webpackJsonp([0],{

/***/ "+++F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_dashboardNotification__ = __webpack_require__("Qoh4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__ = __webpack_require__("a0yF");


/*
  Generic component used to display notifications coming from
  notifications API endpoint. It's also used by notification-items.js
  to display those generic components in top right corner of the app
  if user has notifications turned on.
 */







var NOTIFICATION_CLASS_SETTLED = 'settled';
var NOTIFICATION_CLASS_PRICE_UP = 'price-up';
var NOTIFICATION_CLASS_PRICE_DOWN = 'price-down';
var NOTIFICATION_CLASS_MATCHED = 'matched';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_dashboardNotification__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__["a" /* default */]],
  props: {
    showTimeElapsed: {
      type: Boolean,
      default: false
    }
  },
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  computed: {
    iconTargetClass: function iconTargetClass() {
      switch (this.data.notificationType) {
        case __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["c" /* NOTIFICATION_MATCHED */]:
          return NOTIFICATION_CLASS_MATCHED;
        case __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["d" /* NOTIFICATION_SETTLED */]:
          return NOTIFICATION_CLASS_SETTLED;
        case __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["e" /* NOTIFICATION_PRICE_CHANGE */]:
          return this.data.contentJson.PriceDelta > 0 ? NOTIFICATION_CLASS_PRICE_UP : NOTIFICATION_CLASS_PRICE_DOWN;
        default:
          return NOTIFICATION_CLASS_SETTLED;
      }
    },
    classModifiers: function classModifiers() {
      var _ref;

      var isUnread = this.theme !== 'notifications' && this.data && typeof this.data.isRead !== 'undefined' && !this.data.isRead;
      return _ref = {
        'notification-item-dashboard': true,
        'notification-item-dashboard--unread': isUnread
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'notification-item-dashboard--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'notification-item-dashboard--clickable', this.marketId), _ref;
    },
    marketId: function marketId() {
      return this.data.contentJson ? this.data.contentJson.MarketId : null;
    },
    iconClassModifiers: function iconClassModifiers() {
      return {
        'notification-item-dashboard__icon': true
        // [`notification-item-dashboard__icon--${this.iconTargetClass}`]: this.iconTargetClass,
      };
    },
    iconStyleModifiers: function iconStyleModifiers() {
      return {
        'background-image': 'url(' + this.data.contentJson.ImageUrl + ')'
      };
    },
    showContractName: function showContractName() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["e" /* NOTIFICATION_PRICE_CHANGE */];
    },
    showPayout: function showPayout() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["d" /* NOTIFICATION_SETTLED */];
    },
    showSellInfo: function showSellInfo() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["c" /* NOTIFICATION_MATCHED */];
    },
    showSharesOwned: function showSharesOwned() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["e" /* NOTIFICATION_PRICE_CHANGE */];
    },
    showPriceChange: function showPriceChange() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["e" /* NOTIFICATION_PRICE_CHANGE */];
    },
    showLevelChanged: function showLevelChanged() {
      return this.data.notificationType === __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["f" /* NOTIFICATION_LEVEL */];
    },
    showNextLevelInfo: function showNextLevelInfo() {
      return this.data.contentJson.NewTraderLevel < 7;
    },
    quantity: function quantity() {
      return this.data.contentJson.Quantity;
    },
    sharesOwned: function sharesOwned() {
      return this.data.contentJson.SharesOwned;
    },
    quantityModifiers: function quantityModifiers() {
      var tradeType = this.data.contentJson.TradeType;
      return {
        'notification-item-dashboard__quantity': true,
        'notification-item-dashboard__quantity--negative': tradeType === 0 || tradeType === 2
      };
    },
    pricePerShare: function pricePerShare() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["j" /* toCents */])(this.data.contentJson.PricePerShare);
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["l" /* isMarketSingle */])(this.data.contentJson);
    },
    tradeTypeShare: function tradeTypeShare() {
      return typeof this.data.contentJson.MarketType === 'undefined' || this.isMarketSingle ? '' : this.data.contentJson.ContractName || '';
    },
    tradeTypeOperation: function tradeTypeOperation() {
      return this.data.contentJson.TradeType <= 1 ? 'Bought' : 'Sold';
    },
    lastTradePriceAsCents: function lastTradePriceAsCents() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["j" /* toCents */])(this.data.contentJson.LastTradePrice);
    },
    routeTo: function routeTo() {
      if (this.marketId) {
        return {
          name: 'market-details',
          params: {
            marketId: this.marketId
          }
        };
      }
      return {};
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['closeNotificationsWidget']), {
    onInteract: function onInteract() {
      this.closeNotificationsWidget();
    }
  })
});

/***/ }),

/***/ "+1tr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_research_widget_research_widget_vue__ = __webpack_require__("/yTp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_twitter_twitter_timeline_twitter_timeline_vue__ = __webpack_require__("FM5G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_insight_insight_widget_insight_widget_vue__ = __webpack_require__("w0Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_biggest_gains_market_biggest_gains_vue__ = __webpack_require__("XqpO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_money_widget_market_money_widget_vue__ = __webpack_require__("JVxM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_market_currently_predicting_market_currently_predicting_vue__ = __webpack_require__("Dksu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_key_stats_market_key_stats_vue__ = __webpack_require__("aHny");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_market_market_top_comments_market_top_comments_vue__ = __webpack_require__("KvDS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_insight_insight_news_insight_news_vue__ = __webpack_require__("rjQl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_page_election_map_new_election_map_election_map_vue__ = __webpack_require__("nYw4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_daily_markets_daily_markets_vue__ = __webpack_require__("B/8G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__news_feed_news_feed_vue__ = __webpack_require__("xJ4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__in_the_news_in_the_news_vue__ = __webpack_require__("y1jZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__podcasts_podcasts_vue__ = __webpack_require__("QrTx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__hero_unit_slider_hero_unit_slider_vue__ = __webpack_require__("RQ5D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__quotes_quotes_vue__ = __webpack_require__("PElc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__how_it_works_how_it_works_vue__ = __webpack_require__("Z05w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__most_predicted_most_predicted_vue__ = __webpack_require__("UqqE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__most_predicted_list_most_predicted_list_vue__ = __webpack_require__("4p0o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__home_videos__ = __webpack_require__("CPvM");

























/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_contentLoader__["a" /* default */]],
  components: {
    electionMap: __WEBPACK_IMPORTED_MODULE_13__components_pages_page_election_map_new_election_map_election_map_vue__["f" /* default */],
    heroUnitSlider: __WEBPACK_IMPORTED_MODULE_18__hero_unit_slider_hero_unit_slider_vue__["a" /* default */],
    quotes: __WEBPACK_IMPORTED_MODULE_19__quotes_quotes_vue__["a" /* default */],
    howItWorks: __WEBPACK_IMPORTED_MODULE_20__how_it_works_how_it_works_vue__["a" /* default */],
    mostPredicted: __WEBPACK_IMPORTED_MODULE_21__most_predicted_most_predicted_vue__["a" /* default */],
    podcasts: __WEBPACK_IMPORTED_MODULE_17__podcasts_podcasts_vue__["a" /* default */],
    researchWidget: __WEBPACK_IMPORTED_MODULE_2__components_research_widget_research_widget_vue__["a" /* default */],
    inTheNews: __WEBPACK_IMPORTED_MODULE_16__in_the_news_in_the_news_vue__["a" /* default */],
    twitterTimeline: __WEBPACK_IMPORTED_MODULE_3__components_twitter_twitter_timeline_twitter_timeline_vue__["a" /* default */],
    newsFeed: __WEBPACK_IMPORTED_MODULE_15__news_feed_news_feed_vue__["a" /* default */],
    mostPredictedList: __WEBPACK_IMPORTED_MODULE_22__most_predicted_list_most_predicted_list_vue__["a" /* default */],
    insightWidget: __WEBPACK_IMPORTED_MODULE_4__components_insight_insight_widget_insight_widget_vue__["a" /* default */],
    marketBiggestGains: __WEBPACK_IMPORTED_MODULE_5__components_market_market_biggest_gains_market_biggest_gains_vue__["a" /* default */],
    marketMoneyWidget: __WEBPACK_IMPORTED_MODULE_6__components_market_market_money_widget_market_money_widget_vue__["a" /* default */],
    marketCurrentlyPredicting: __WEBPACK_IMPORTED_MODULE_7__components_market_market_currently_predicting_market_currently_predicting_vue__["a" /* default */],
    marketKeyStats: __WEBPACK_IMPORTED_MODULE_8__components_market_market_key_stats_market_key_stats_vue__["a" /* default */],
    marketTopComments: __WEBPACK_IMPORTED_MODULE_9__components_market_market_top_comments_market_top_comments_vue__["a" /* default */],
    homeVideos: __WEBPACK_IMPORTED_MODULE_23__home_videos__["a" /* default */],
    insightNews: __WEBPACK_IMPORTED_MODULE_10__components_insight_insight_news_insight_news_vue__["a" /* default */],
    dailyMarkets: __WEBPACK_IMPORTED_MODULE_14__components_daily_markets_daily_markets_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: 'PredictIt'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile', 'isShutdownModeOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isUserRestricted', 'isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('popup', ['currentPopup']), {
    classModifiers: function classModifiers() {
      return {
        'home-old': true,
        'home-old--shutdown': this.isShutdownModeOn
      };
    },
    showMap: function showMap() {
      return false;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup'])),
  mounted: function mounted() {
    if (this.isUserRestricted && !this.currentPopup) {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
    }
  }
});

/***/ }),

/***/ "+6ap":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+88x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


function setLargeNumber(el, binding) {
  el.innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["h" /* largeNumberDisplay */])(binding.value || 0);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    setLargeNumber(el, binding);
  },
  update: function update(el, binding) {
    setLargeNumber(el, binding);
  }
});

/***/ }),

/***/ "+8fj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__ = __webpack_require__("vJzj");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["b" /* formMixin */]],
  validations: {
    fields: {
      newPassword: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].password,
      newPasswordConfirmation: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].passwordConfirmation('newPassword')
    }
  },
  data: function data() {
    return {
      fields: {
        newPassword: '',
        newPasswordConfirmation: ''
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotificationWithTimeoutCallback']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['setPassword']), {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formIsValid() && this.formDisable()) {
        var payload = {
          newPassword: this.fields.newPassword
        };
        this.setPassword(payload).then(this.formEnable).then(function () {
          _this.setSuccessSideNotificationWithTimeoutCallback({
            text: 'Password Set.',
            callback: function callback() {
              return _this.$router.go(-1);
            }
          });
        }).catch(this.formHandleErrors);
      }
    }
  })
});

/***/ }),

/***/ "+Bmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-header-title"},[(_vm.backButton)?_c('div',{staticClass:"market-header-title__back"},[_c('back-button',{on:{"back":_vm.back}})],1):_vm._e(),_vm._v(" "),_c('div',{class:_vm.classModifier},[_c('div',{staticClass:"market-header-title__container"},[_c('h1',{staticClass:"market-header-title__text",on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[(_vm.isMarketWithinStory)?[_vm._v("Market: ")]:_vm._e(),_vm._v(_vm._s(_vm.market.marketName)+"\n      ")],2)])]),_vm._v(" "),(_vm.watchIconVisible)?_c('div',{staticClass:"market-header-title__watch"},[_c('market-watch',{attrs:{"marketId":_vm.market.marketId,"isWatched":_vm.market.isMarketWatched}})],1):_vm._e(),_vm._v(" "),(_vm.closeButton)?_c('div',{staticClass:"market-header-title__close",on:{"click":_vm.close}},[_c('close-button')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+CQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_small_js__ = __webpack_require__("S1Yq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16c4b196_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_small_vue__ = __webpack_require__("tLgC");
function injectStyle (ssrContext) {
  __webpack_require__("P40+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_small_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16c4b196_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_small_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+Cz8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_alert_box_js__ = __webpack_require__("qYhg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50ec6a42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_box_vue__ = __webpack_require__("Cg8d");
function injectStyle (ssrContext) {
  __webpack_require__("b1G2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_alert_box_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50ec6a42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+OSe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+PRK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-rows-loader"},[_c('div',{staticClass:"table-rows-loader__header"}),_vm._v(" "),_c('div',{staticClass:"table-rows-loader__content"},_vm._l((_vm.dummyComponents),function(index){return _c('div',{staticClass:"table-rows-loader__content-item"},[_c('div',{staticClass:"table-rows-loader__content-item-text-1"}),_vm._v(" "),_c('div',{staticClass:"table-rows-loader__content-item-text-2"}),_vm._v(" "),_c('div',{staticClass:"table-rows-loader__content-item-text-3"})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+VBi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+W5i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+YUt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_vm._v("\r\n  "+_vm._s(_vm.transformedStatus)+"\r\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+ZRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_loader__ = __webpack_require__("39kf");

/* eslint-disable no-unused-vars */




var searchMixin = {
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_loader__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('search', ['toggleSearchBar', 'getSearch', 'resetSearchResults']), {
    onSearchResults: function onSearchResults(data) {},
    formatQuery: function formatQuery(query) {
      return query.trim();
    },
    doSearch: function doSearch(query) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { reset: true };

      if (this.isLoading) return;
      this.loaderAdd(document.body);
      if (options.reset) {
        this.resetSearchResults(query);
      }

      this.getSearch(this.formatQuery(query)).then(function (data) {
        _this.loaderRemove(document.body);
        _this.$gtm.trackEvent({
          event: 'Search',
          SearchNumTotalMarketsFound: data.totalMarkets
        });
        _this.onSearchResults(data);

        if (_this.$router.currentRoute.query.query !== query) {
          _this.$router.push({
            name: 'market-search',
            query: {
              query: query
            }
          });
        }
      }).catch(function () {
        return _this.loaderRemove(document.body);
      });
    }
  })
};

/* harmony default export */ __webpack_exports__["a"] = (searchMixin);

/***/ }),

/***/ "+a0v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+bJT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_info_js__ = __webpack_require__("kVWy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69788607_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_info_vue__ = __webpack_require__("/axx");
function injectStyle (ssrContext) {
  __webpack_require__("IT5V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_info_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69788607_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+buz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+i2i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purchase-journey"},[(_vm.confirmationData)?_c('purchase-review-and-confirm',{attrs:{"confirmationData":_vm.confirmationData},on:{"cancel":_vm.onClickAmend,"submit":_vm.onClickSubmit}}):(_vm.contract !== null)?[(_vm.kind === 'desktop')?_c('purchase-offer-desktop',{key:"purchase-desktop",attrs:{"market":_vm.market,"contract":_vm.contract},on:{"submit":_vm.onClickNext}}):_vm._e(),_vm._v(" "),(_vm.kind !== 'desktop')?_c('purchase-offer',{key:"purchase-mobile",attrs:{"market":_vm.market,"contract":_vm.contract},on:{"submit":_vm.onClickNext}}):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+k7l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+kDG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_chart_models__ = __webpack_require__("Q+EN");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    chartData: {
      type: Array,
      required: true,
      default: null
    },
    chartDataLoaded: {
      type: Boolean,
      default: false
    },
    chartOptions: {
      type: Object,
      default: null
    },
    market: {
      type: Object,
      required: true
    },
    timeline: {
      type: String,
      required: false
    },
    chartType: {
      type: String,
      required: false
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },

  watch: {
    chartType: function chartType(value) {
      this.createChart(value);
    },
    chartData: function chartData(value) {
      this.createChart(value);
    }
  },
  methods: {
    createChart: function createChart(data) {
      var _this = this;

      if (data && data.length > 0) {
        setTimeout(function () {
          _this.renderChart();
        }, __WEBPACK_IMPORTED_MODULE_0__utils_chart_models__["a" /* ContractChartGroup */].renderTimeout());
      } else if (this.$refs.chart) {
        this.$refs.chart.innerHTML = '';
      }
    },
    renderChart: function renderChart() {
      if (!this.$refs.chart) return;
      if (this.chart !== null) {
        this.chart.destroy();
      }
      var ClassName = this.chartType === 'candle' ? __WEBPACK_IMPORTED_MODULE_0__utils_chart_models__["b" /* ContractChartGroupStock */] : __WEBPACK_IMPORTED_MODULE_0__utils_chart_models__["a" /* ContractChartGroup */];
      var group = new ClassName({
        market: this.market,
        timeline: this.timeline,
        data: this.chartData,
        chartOptions: this.chartOptions || {}
      });
      this.chart = group.draw(this.$refs.chart);
    }
  }
});

/***/ }),

/***/ "+n+m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+poj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_userAgent__ = __webpack_require__("GZXJ");








var CAPTCHA_FIELD = 'g-recaptcha-response';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins_popupPageModeMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_userAgent__["a" /* default */]],
  props: {
    email: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function data() {
    return {
      // login attempt counter used to rerender captcha on failed login
      attempt: 1,
      fieldTypePassword: 'password',
      fields: {
        email: this.email,
        password: '',
        rememberMe: true,
        captcha: ''
      },
      timeout: null
    };
  },

  validations: {
    fields: {
      email: __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["a" /* validators */].emailNoMessage,
      password: __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["a" /* validators */].requiredNoMessage,
      captcha: __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["a" /* validators */].captcha
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isUserRestricted']), {
    loginButtonDisabled: function loginButtonDisabled() {
      return this.invalidOrDisabled || !this.fields.captcha;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['login', 'setUseDisqus', 'loginDisqus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentPopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['setProfileStatus']), {
    showPassword: function showPassword() {
      this.fieldTypePassword = this.fieldTypePassword === 'password' ? 'text' : 'password';
    },
    onForgotten: function onForgotten() {
      if (this.isPage) {
        this.$router.push({ name: 'account-password-forgotten' });
      } else {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_app_modals__["a" /* MODALS */].FORGOTTEN);
      }
    },
    getRedirectPath: function getRedirectPath() {
      if (this.$router.currentRoute.query.redirect) return this.$router.currentRoute.query.redirect;
      if (this.$router.currentRoute.name === 'home' || this.isPage) return { name: 'portfolio' };
      return null;
    },
    triggerRedirect: function triggerRedirect(redirect) {
      this.$router.push(redirect);
      if (this.isIos) {
        this.$nextTick(function () {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 100);
        });
      }
    },
    onLogin: function onLogin() {
      var _this = this;

      this.setProfileStatus({ event: 'login' });
      if (this.$route && this.$route.name === 'disqus-auth') {
        this.loginDisqus().then(function () {
          _this.setUseDisqus(true);
          window.close();
        });
      } else {
        var redirect = this.getRedirectPath();
        this.setCurrentPopup();
        if (redirect) {
          this.triggerRedirect(redirect);
        }
      }
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      if (this.formIsValid() && this.formDisable()) {
        var _payload;

        var payload = (_payload = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_payload, CAPTCHA_FIELD, this.fields.captcha), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_payload, 'email', this.fields.email), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_payload, 'password', this.fields.password), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_payload, 'grant_type', 'password'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_payload, 'rememberMe', this.fields.rememberMe), _payload);
        this.login(payload).then(this.formEnable).then(this.onLogin).catch(function (error) {
          _this2.attempt += 1;
          _this2.fields.captcha = null;
          _this2.formHandleErrors(error);
        });
      }
    },
    hideFooter: function hideFooter() {
      window.clearTimeout(this.timeout);
      this.timeout = null;
      this.setCurrentPopupOptions({ hideFooter: true });
    },
    showFooter: function showFooter() {
      var _this3 = this;

      this.timeout = window.setTimeout(function () {
        _this3.setCurrentPopupOptions({});
      }, 200);
    }
  })
});

/***/ }),

/***/ "/5V2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/BdM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-login-footer"},[_c('h4',{staticClass:"account-login-footer__title"},[_vm._v("\n        "+_vm._s(_vm.$txt('account-login.footer.title'))+"\n      ")]),_vm._v(" "),_c('a',{staticClass:"account-login-footer__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onCreateAccount($event)}}},[_vm._v("\n        "+_vm._s(_vm.$txt('account-login.footer.link'))+"\n      ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/JWN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_getValidationMessage__ = __webpack_require__("U7Hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_promoCode__ = __webpack_require__("nPqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_depositWarningMixin__ = __webpack_require__("Scap");













var AMOUNT_STEP_ONE = 10;
var AMOUNT_STEP_THREE = 50;
var AMOUNT_STEP_FOUR = 100;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_promoCode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_depositWarningMixin__["a" /* default */]],
  data: function data() {
    return {
      error: null,
      canDeposit: false,
      isReady: false,
      disclaimer: '',
      fields: {
        amount: ''
      },
      depositAmounts: [AMOUNT_STEP_ONE, AMOUNT_STEP_THREE, AMOUNT_STEP_FOUR]
    };
  },
  validations: function validations() {
    return {
      fields: {
        amount: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].depositAmountCoinbase(this.minimumDepositAmount, this.maximumDepositAmount)
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('wallet', ['getDepositUSDCoin']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentPopupOptions']), {
    handleAmountBlur: function handleAmountBlur() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'fill',
        label: 'Amount'
      });
    },
    onUpdateAmount: function onUpdateAmount(amount) {
      if (this.fields.amount === '') {
        this.fields.amount = amount;
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["u" /* isNumber */])(this.fields.amount)) {
        this.fields.amount = Number(this.fields.amount) + amount;
      }
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: 'Amount ' + amount + ' Button'
      });
    },
    onSubmit: function onSubmit() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit Confirm',
        action: 'submit',
        label: 'Confirm Deposit'
      });
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].COINBASE);
      this.setCurrentPopupOptions({ depositPayload: this.depositPayload });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('wallet', ['depositMethods']), {
    minimumDepositAmount: function minimumDepositAmount() {
      return this.depositMethods.minimumDepositAmount || 10.0;
    },
    maximumDepositAmount: function maximumDepositAmount() {
      return 99999;
    },
    depositPayload: function depositPayload() {
      return {
        amount: this.fields.amount,
        depositPromoCode: '',
        marketingSource: '',
        marketingProgram: ''
      };
    },
    amountHasError: function amountHasError() {
      return this.$v.fields.amount.$error;
    },
    amountValidationMessage: function amountValidationMessage() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_getValidationMessage__["a" /* default */])(this.$v.fields.amount);
    },
    isConfirmDisabled: function isConfirmDisabled() {
      return this.invalidOrDisabled || !this.canDeposit;
    }
  }),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getDepositUSDCoin().then(function (data) {
      _this.checkDocumentUploadFlags(data);
      _this.loaderRemove(document.body);
      _this.promoCodeDetail = data.promoCodeDetail || {};
      _this.canDeposit = data.canDeposit;
      _this.disclaimer = data.disclaimer;
      _this.isReady = true;
    }).catch(function (error) {
      _this.isReady = true;
      _this.error = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', null);
      _this.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "/KY/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_contracts_history_sold_bought_at_sold_bought_at_vue__ = __webpack_require__("2N1A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__("c/9r");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showMarketName: {
      type: Boolean,
      default: true
    },
    data: Object,
    desktop: {
      type: Boolean,
      default: false
    },
    compactMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    soldBoughtAt: __WEBPACK_IMPORTED_MODULE_0__components_contracts_history_sold_bought_at_sold_bought_at_vue__["a" /* default */]
  },
  computed: {
    classModifiers: function classModifiers() {
      return {
        'contract-tile': true,
        'contract-tile--compact': this.compactMode
      };
    },
    accountHistoryRoute: function accountHistoryRoute() {
      if (this.$route.fullPath === '/account/history') {
        return {
          name: 'account-history',
          params: { marketId: this.data.marketId }
        };
      }
      return {
        name: 'account-history',
        params: { marketId: this.data.marketId },
        query: { contractId: this.data.contractId }
      };
    },
    profit: function profit() {
      switch (this.data.tradeType) {
        case 0: // Buy No
        case 1:
          // Buy Yes
          return ' –';
        default:
          {
            var fee = this.data.tradingFees !== 0 ? this.data.tradingFeesString : '';
            var gainLoss = this.data.tradeGainLossString;
            return this.data.tradeGainLoss ? gainLoss + ' ' + fee : gainLoss;
          }
      }
    },
    profitClass: function profitClass() {
      return {
        'contract-tile__profit-desk': true,
        'contract-tile__profit-desk--plus': this.data.tradeGainLoss > 0
      };
    },
    profitDesk: function profitDesk() {
      return this.data.tradeType > 1 ? this.data.tradeGainLossString : '-';
    },
    fee: function fee() {
      return this.data.tradingFees < 0 ? this.data.tradingFeesString : '';
    },
    date: function date() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["t" /* dateToString */])(this.data.dateExecuted);
    },
    market: function market() {
      return this.data.marketName ? this.data.marketName : 'null';
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["l" /* isMarketSingle */])(this.data);
    },
    contractName: function contractName() {
      if (this.data.marketType !== 0) {
        return this.data.contractName;
      }
      var type = this.data.tradeType;
      return type === 0 || type === 2 ? 'No' : 'Yes';
    },
    shortProfit: function shortProfit() {
      var tradeType = this.data.tradeType;
      return {
        'contract-tile__profit--short': tradeType === 0 || tradeType === 1
      };
    },
    longName: function longName() {
      var tradeType = this.data.tradeType;
      return {
        'contract-tile__name--long': tradeType === 0 || tradeType === 1
      };
    }
  }
});

/***/ }),

/***/ "/Tgi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiperSlide"]
  },
  props: {
    theme: {
      type: String,
      default: 'default'
    }
  },
  data: function data() {
    return {
      isCategoriesLabelVisible: false,
      swiperOption: {
        roundLengths: true, // Fixes blurry text
        slidesPerView: 8,
        breakpoints: {
          320: { // iPhone 5
            slidesPerView: 3.5
          },
          640: {
            slidesPerView: 4.5
          },
          1024: {
            slidesPerView: 6.5
          }
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('browse', ['userBrowseHeaders']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), {
    categoriesIcon: function categoriesIcon() {
      if (this.isLayoutDesktop) {
        return this.iconClassModifiers({ icon: 'globe' });
      }
      return this.iconClassModifiers({ icon: 'categories' });
    },
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {
        'nav-browse-old': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'nav-browse-old--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'nav-browse-old--desktop', !this.isLayoutMobile), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'nav-browse-old--mobile', this.isLayoutMobile), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'nav-browse-old--space-between', this.userBrowseHeaders.length >= 3), _ref;
    }
  }),
  methods: {
    toggleCategoriesLabel: function toggleCategoriesLabel() {
      if (this.isLayoutMobile) {
        this.isCategoriesLabelVisible = !this.isCategoriesLabelVisible;
      }
    },
    iconClassModifiers: function iconClassModifiers(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'nav-browse-old__link-icon': true
      }, 'nav-browse-old__link-icon--' + item.icon, item.icon);
    }
  },
  mounted: function mounted() {
    if (this.isLayoutDesktop) {
      this.isCategoriesLabelVisible = true;
    }
  }
});

/***/ }),

/***/ "/axx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-info"},[_c('div',{staticClass:"page-info__widget-info page-info__widget-info--profile"},[_c('public-profile-widget')],1),_vm._v(" "),(_vm.showInfo)?_c('div',{staticClass:"page-info__widget-info page-info__widget-info--leaderboards"},[_c('div',{staticClass:"page-info__widget-info-title"},[_vm._v("\n      "+_vm._s(_vm.$txt('page-info.title'))+"\n    ")]),_vm._v(" "),_c('leaderboards-info')],1):_vm._e(),_vm._v(" "),(_vm.isUserVerified)?_c('div',{staticClass:"page-info__widget-info page-info__widget-info--share"},[_c('share-invite-widget')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/b9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_externalLinks__ = __webpack_require__("ys9T");


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_externalLinks__["a" /* default */]],
  props: {
    title: {
      type: String,
      required: true
    }
  },
  created: function created() {
    var _this = this;

    this.getExternalLogins({}).then(function (response) {
      _this.links = response.data;
    });
  }
});

/***/ }),

/***/ "/gmg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-section-header"},[_c('div',{staticClass:"market-section-header__title"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-8 market-section-header__text"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"column small-4 market-section-header__counter"},[(_vm.count === 1)?[_vm._v("\n          1 Market\n        ")]:[_vm._v("\n          "+_vm._s(_vm.count)+" Markets\n        ")]],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/gy2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showSwitchButton: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      altModeOn: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlay', ['visible']), {
    isAltViewModifier: function isAltViewModifier() {
      return {
        'modal-switch--isAltView': this.altModeOn
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('overlay', ['show', 'hide']), {
    close: function close() {
      this.hide();
      this.$emit('modalClose');
    },
    toggle: function toggle() {
      this.altModeOn = !this.altModeOn;
      this.$emit('modalToggle');
    }
  }),
  watch: {
    visible: function visible() {
      if (!this.visible) {
        this.close();
      }
    }
  },
  created: function created() {
    this.show();
  }
});

/***/ }),

/***/ "/nxz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-switch"},[_c('div',{staticClass:"modal-switch__wrapper",class:_vm.isAltViewModifier},[_c('div',{staticClass:"modal-switch__header"},[(_vm.showSwitchButton)?_c('button',{staticClass:"modal-switch__info",on:{"click":_vm.toggle}}):_vm._e(),_vm._v(" "),(!_vm.altModeOn)?_vm._t("header"):_vm._e(),_vm._v(" "),(_vm.altModeOn)?_vm._t("altheader"):_vm._e(),_vm._v(" "),_c('button',{staticClass:"modal-switch__close",on:{"click":_vm.close}})],2),_vm._v(" "),_c('div',{staticClass:"modal-switch__content"},[(!_vm.altModeOn)?_vm._t("content"):_vm._e(),_vm._v(" "),(_vm.altModeOn)?_vm._t("altcontent"):_vm._e()],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/v52":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_desktop_header_js__ = __webpack_require__("U91k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54871bc6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_desktop_header_vue__ = __webpack_require__("8No6");
function injectStyle (ssrContext) {
  __webpack_require__("kolS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_desktop_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54871bc6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_desktop_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/yTp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_research_widget_js__ = __webpack_require__("5RCZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2a1dbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_research_widget_vue__ = __webpack_require__("rmwD");
function injectStyle (ssrContext) {
  __webpack_require__("OQ19")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_research_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2a1dbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_research_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/z0E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "09V6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    disabled: Boolean,
    name: {
      type: String,
      required: true
    },
    required: Boolean,
    placeholder: String,
    maxLength: Number,
    value: String,
    validator: String
  },
  data: function data() {
    return {
      focus: false
    };
  },

  computed: {
    textAreaModifiers: function textAreaModifiers() {
      return {
        'textarea--has-value': this.value,
        'textarea--is-focused': this.focus
      };
    }
  },
  methods: {
    handleBlur: function handleBlur(e) {
      this.focus = false;
      this.$emit('blur', e.target.name);
    },
    handleFocus: function handleFocus(e) {
      this.focus = true;
      this.$emit('focus', e.target.name);
    },
    updateValue: function updateValue(e) {
      this.$emit('input', e.target.value);
    }
  }
});

/***/ }),

/***/ "09fK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_special_js__ = __webpack_require__("OprK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_011d0aea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_special_vue__ = __webpack_require__("6Em0");
function injectStyle (ssrContext) {
  __webpack_require__("cDJX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_special_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_011d0aea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_special_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0Gi+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.classModifiers,attrs:{"to":{name: 'market-details', params: {marketId: _vm.market.marketId, marketUrl: _vm.market.marketUrl}}}},[_c('div',{staticClass:"market-list-item-v2__container",on:{"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave}},[_c('div',{staticClass:"market-list-item-v2__container-bg1"}),_vm._v(" "),_c('div',{staticClass:"market-list-item-v2__container-bg2",style:(_vm.styleModifiers)}),_vm._v(" "),_c('div',{staticClass:"row row-100 market-list-item-v2__row"},[_c('div',{staticClass:"column small-7 column-100 market-list-item-v2__mask"},[_c('div',{staticClass:"market-list-item-v2__main-section"},[_c('h3',{staticClass:"market-list-item-v2__title"},[_vm._v("\n            "+_vm._s(_vm.market.marketName)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"market-list-item-v2__contracts"},_vm._l((_vm.contracts),function(item){return _c('market-contract',{key:_vm.contractKey(item),attrs:{"market":_vm.market,"contract":item}})}),1),_vm._v(" "),_c('div',{staticClass:"market-list-item-v2__shares"},[_c('span',{directives:[{name:"large-number",rawName:"v-large-number",value:(_vm.market.totalSharesTraded),expression:"market.totalSharesTraded"}]}),_vm._v(" Share"),(_vm.market.totalSharesTraded !== 1)?_c('span',[_vm._v("s")]):_vm._e(),_vm._v(" Traded\n          ")])])]),_vm._v(" "),(_vm.watchIcon)?_c('div',{staticClass:"column small-5 column-100 market-list-item-v2__right"},[_c('div',{staticClass:"market-list-item-v2__watch",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('watchToggle')}}},[_c('div',{staticClass:"market-list-item-v2__watch-icon"})])]):_vm._e()]),_vm._v(" "),(_vm.showSharesOwnedNotification)?[_c('div',{staticClass:"market-list-item-v2__shares-owned"})]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0HU1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

var STATE_TEXT_MAP = {
  'pending approval': 'pending',
  'not approved': 'rejected'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    state: {
      type: String,
      default: 'pending'
    },
    theme: {
      type: String,
      default: ''
    }
  },
  computed: {
    transformedStatus: function transformedStatus() {
      var statelowerCased = this.state.toLowerCase();
      if (statelowerCased in STATE_TEXT_MAP) {
        return STATE_TEXT_MAP[statelowerCased];
      }
      return statelowerCased;
    },
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {
        'state-icon': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'state-icon--' + this.transformedStatus, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'state-icon--' + this.theme, this.theme), _ref;
    }
  }
});

/***/ }),

/***/ "0IxP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_dashboard_page_main_page_main_vue__ = __webpack_require__("A8Cw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_dashboard_page_portfolio_page_portfolio_vue__ = __webpack_require__("7vVr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_dashboard_page_info_page_info_vue__ = __webpack_require__("+bJT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_dashboard_page_notifications_page_notifications_vue__ = __webpack_require__("nzpA");





/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/dashboard',
  component: __WEBPACK_IMPORTED_MODULE_0__components_pages_dashboard_page_main_page_main_vue__["a" /* default */],
  props: true,
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    name: 'portfolio',
    component: __WEBPACK_IMPORTED_MODULE_1__components_pages_dashboard_page_portfolio_page_portfolio_vue__["a" /* default */]
  }, {
    path: 'info',
    name: 'info',
    component: __WEBPACK_IMPORTED_MODULE_2__components_pages_dashboard_page_info_page_info_vue__["a" /* default */]
  }, {
    path: 'notifications',
    name: 'notifications',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_dashboard_page_notifications_page_notifications_vue__["a" /* default */]
  }]
}]);

/***/ }),

/***/ "0KBQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_throttle__ = __webpack_require__("+X65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_sortBy__ = __webpack_require__("KBYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_without__ = __webpack_require__("yI9a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isString__ = __webpack_require__("JDN0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_intersection__ = __webpack_require__("Aemx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_intersection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_notifications__ = __webpack_require__("tjp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__filters_consts__ = __webpack_require__("OJH0");


















var DEFAULT_FILTERED_MARKETS = {
  data: [],
  page: 0,
  totalCount: 0,
  canLoadMore: true
};

var TWENTY_FOUR_GAINS = 'Biggest 24 hour Gains';
var TWENTY_FOUR_LOSS = 'Biggest 24 hour Losses';
var WEEK_GAINS = 'Biggest 7 day Gains';
var WEEK_LOSS = 'Biggest 7 day Losses';

var prepareBiggestGains = function prepareBiggestGains(items, sectionTitle) {
  var isGain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  items.forEach(function (el) {
    el.sectionTitle = sectionTitle;
    el.isGain = isGain;
  });
  return items;
};

var TITLE_PREDICTED = 'Most Predicted';
var TITLE_TRENDING = 'Top Trending';
var TITLE_MOVERS = 'Biggest Movers';
var TITLE_NEW_ARRIVALS = 'New Arrivals';

var prepareMostPredicted = function prepareMostPredicted(markets, sectionTitle) {
  markets.forEach(function (el) {
    el.sectionTitle = sectionTitle;
  });
  return markets;
};

var THROTTLE_TIME = 1750;

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    headers: [],
    headersReady: false,
    filters: null,
    orders: __WEBPACK_IMPORTED_MODULE_14__filters_consts__["a" /* ORDERS */],
    timespans: __WEBPACK_IMPORTED_MODULE_14__filters_consts__["b" /* TIMESPANS */],
    filteredMarkets: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(DEFAULT_FILTERED_MARKETS),
    selectedFilters: [],
    selectedOrder: __WEBPACK_IMPORTED_MODULE_14__filters_consts__["a" /* ORDERS */][0],
    selectedTimespan: __WEBPACK_IMPORTED_MODULE_14__filters_consts__["c" /* AVAILABLE_TIMESPANS */].TODAY,
    shouldShowTimespanFilter: true,
    twentyFourGains: [],
    twentyFourLoss: [],
    weekGains: [],
    weekLoss: [],
    newArrivalMarkets: [],
    mostPredictedMarkets: [],
    trendingMarkets: [],
    biggestMoverMarkets: [],
    widgets: {},
    latestHeaderId: null,
    storiesNav: [],
    currentStory: null,
    currentStoryDetail: null
  },
  getters: {
    areUserBrowseHeadersEmpty: function areUserBrowseHeadersEmpty(state, getters) {
      return state.headersReady && getters.userBrowseHeaders.length === 0;
    },
    userBrowseHeaders: function userBrowseHeaders(state, getters, rootState, rootGetters) {
      var baseHeaders = [];

      if (false) {
        baseHeaders.push({
          headerId: -2,
          external: true,
          href: process.env.TOURNAMENT_LINK,
          title: 'Tournament',
          icon: 'star'
        });
      }

      if (rootGetters['user/isLoggedIn']) {
        baseHeaders.push({
          headerId: -1,
          external: true,
          name: 'market-watchlist',
          title: 'Watchlist',
          icon: rootState.app.newHeaderEnabled ? '' : 'watch'
        });
      }

      return [].concat(baseHeaders, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(state.headers));
    }
  },
  mutations: {
    clearCurrentStoryDetail: function clearCurrentStoryDetail(state) {
      state.currentStoryDetail = null;
    },
    setCurrentStoryDetail: function setCurrentStoryDetail(state, data) {
      state.currentStoryDetail = data;
    },
    clearCurrentStory: function clearCurrentStory(state) {
      state.currentStory = null;
    },
    setCurrentStory: function setCurrentStory(state, data) {
      state.currentStory = data;
    },
    setStoriesNav: function setStoriesNav(state, data) {
      state.storiesNav = data;
    },
    setLatestHeaderId: function setLatestHeaderId(state, data) {
      state.latestHeaderId = data;
    },
    setHeaders: function setHeaders(state, payload) {
      state.headers = payload;
      state.headersReady = true;
    },
    setFilters: function setFilters(state, payload) {
      state.filters = payload;
      if (payload) {
        // check if we have selected filters available
        var filterIds = payload.reduce(function (c, filters) {
          return c.concat(filters.filters.map(function (f) {
            return f.filterId;
          }));
        }, []);
        var selectedFilters = __WEBPACK_IMPORTED_MODULE_10_lodash_intersection___default()(state.selectedFilters, filterIds);
        if (state.selectedFilters.length !== selectedFilters.length) {
          state.selectedFilters = [];
        }
      } else {
        state.selectedFilters = [];
      }
    },
    updateFilteredMarkets: function updateFilteredMarkets(state, payload) {
      var data = state.filteredMarkets.data.concat(payload.markets || []);
      var page = payload.page;
      var totalCount = payload.totalMarkets;
      var canLoadMore = totalCount > data.length;

      state.filteredMarkets = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.filteredMarkets, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    resetFilteredMarkets: function resetFilteredMarkets(state) {
      state.filteredMarkets = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(DEFAULT_FILTERED_MARKETS);
    },
    updateGainsLossMarketFromNotification: function updateGainsLossMarketFromNotification(state, data) {
      if (state.twentyFourGains.length > 0) {
        var markets = state.twentyFourGains.slice();
        state.twentyFourGains = markets.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.twentyFourLoss.length > 0) {
        var _markets = state.twentyFourLoss.slice();
        state.twentyFourLoss = _markets.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.weekGains.length > 0) {
        var _markets2 = state.weekGains.slice();
        state.weekGains = _markets2.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.weekLoss.length > 0) {
        var _markets3 = state.weekLoss.slice();
        state.weekLoss = _markets3.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
    },
    updateGainsLossContractFromNotification: function updateGainsLossContractFromNotification(state, data) {
      if (state.twentyFourGains.length > 0) {
        var markets = state.twentyFourGains.slice();
        state.twentyFourGains = markets.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }
      if (state.twentyFourLoss.length > 0) {
        var _markets4 = state.twentyFourLoss.slice();
        state.twentyFourLoss = _markets4.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }
      if (state.weekGains.length > 0) {
        var _markets5 = state.weekGains.slice();
        state.weekGains = _markets5.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }
      if (state.weekLoss.length > 0) {
        var _markets6 = state.weekLoss.slice();
        state.weekLoss = _markets6.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }
    },
    updatePredictedTrendingMarketFromNotification: function updatePredictedTrendingMarketFromNotification(state, data) {
      if (state.mostPredictedMarkets.length > 0) {
        var markets = state.mostPredictedMarkets.slice();
        state.mostPredictedMarkets = markets.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.trendingMarkets.length > 0) {
        var _markets7 = state.trendingMarkets.slice();
        state.trendingMarkets = _markets7.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.biggestMoverMarkets.length > 0) {
        var _markets8 = state.biggestMoverMarkets.slice();
        state.biggestMoverMarkets = _markets8.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
      if (state.newArrivalMarkets.length > 0) {
        var _markets9 = state.newArrivalMarkets.slice();
        state.newArrivalMarkets = _markets9.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
    },
    updatePredictedTrendingContractsFromNotification: function updatePredictedTrendingContractsFromNotification(state, data) {
      if (state.mostPredictedMarkets.length > 0) {
        var markets = state.mostPredictedMarkets.slice();
        state.mostPredictedMarkets = markets.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["b" /* updateMarketContracts */])(market, data);
        });
      }
      if (state.trendingMarkets.length > 0) {
        var _markets10 = state.trendingMarkets.slice();
        state.trendingMarkets = _markets10.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["b" /* updateMarketContracts */])(market, data);
        });
      }
      if (state.biggestMoverMarkets.length > 0) {
        var _markets11 = state.biggestMoverMarkets.slice();
        state.biggestMoverMarkets = _markets11.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["b" /* updateMarketContracts */])(market, data);
        });
      }
      if (state.newArrivalMarkets.length > 0) {
        var _markets12 = state.newArrivalMarkets.slice();
        state.newArrivalMarkets = _markets12.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["b" /* updateMarketContracts */])(market, data);
        });
      }
    },
    updateMarketWidgetsContractsFromNotification: function updateMarketWidgetsContractsFromNotification(state, data) {
      if (state.widgets.most) {
        state.widgets = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.widgets, {
          most: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["d" /* updateContract */])(state.widgets.most, data)
        });
      }

      if (state.widgets.smart) {
        state.widgets = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.widgets, {
          smart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["d" /* updateContract */])(state.widgets.smart, data)
        });
      }
    },
    updateMarketFromNotification: function updateMarketFromNotification(state, data) {
      if (state.filteredMarkets.data) {
        state.filteredMarkets = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.filteredMarkets, {
          data: state.filteredMarkets.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["a" /* updateMarket */])(market, data);
          })
        });
      }
    },
    updateContractFromNotification: function updateContractFromNotification(state, data) {
      if (state.filteredMarkets.data) {
        state.filteredMarkets = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.filteredMarkets, {
          data: state.filteredMarkets.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_notifications__["b" /* updateMarketContracts */])(market, data);
          })
        });
      }
    },
    addFilter: function addFilter(state, filterId) {
      if (!state.selectedFilters.includes(filterId)) {
        state.selectedFilters.push(filterId);
      }
    },
    clearFilters: function clearFilters(state) {
      state.selectedFilters = [];
    },
    clearOrder: function clearOrder(state) {
      state.selectedOrder = __WEBPACK_IMPORTED_MODULE_14__filters_consts__["a" /* ORDERS */][0];
    },
    setOrderFromQuery: function setOrderFromQuery(state, order) {
      var found = __WEBPACK_IMPORTED_MODULE_14__filters_consts__["a" /* ORDERS */].find(function (i) {
        return i.sort === order;
      });
      if (found) {
        state.selectedOrder = __WEBPACK_IMPORTED_MODULE_14__filters_consts__["a" /* ORDERS */].find(function (i) {
          return i.sort === order;
        });
        state.shouldShowTimespanFilter = __WEBPACK_IMPORTED_MODULE_14__filters_consts__["e" /* ORDERS_WITH_TIMESPAN_FILTER */].indexOf(order) !== -1;
      }
    },
    clearTimespan: function clearTimespan(state) {
      state.selectedTimespan = __WEBPACK_IMPORTED_MODULE_14__filters_consts__["c" /* AVAILABLE_TIMESPANS */].ALL;
    },
    setTimespanFromQuery: function setTimespanFromQuery(state, timespan) {
      var found = __WEBPACK_IMPORTED_MODULE_14__filters_consts__["c" /* AVAILABLE_TIMESPANS */][timespan];
      if (found) {
        state.selectedTimespan = found;
      }
    },
    removeFilter: function removeFilter(state, filterId) {
      state.selectedFilters = __WEBPACK_IMPORTED_MODULE_8_lodash_without___default()(state.selectedFilters, filterId);
    },

    selectOrder: __WEBPACK_IMPORTED_MODULE_14__filters_consts__["f" /* selectOrder */],
    selectTimespan: __WEBPACK_IMPORTED_MODULE_14__filters_consts__["g" /* selectTimespan */],
    setWidgets: function setWidgets(state, payload) {
      var mapping = {
        currentlyPredictingWidget: 'currently',
        smartMoneyWidget: 'smart',
        todaysMostPredictedWidget: 'most',
        keyStatsWidget: 'key',
        topCommentsWidget: 'comments'
      };
      var widgets = {};
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
        var value = payload[key];
        var name = mapping[key];
        if (name) {
          widgets[name] = value;
        }
      });
      state.widgets = widgets;
    },
    setTwentyFourGains: function setTwentyFourGains(state, data) {
      state.twentyFourGains = prepareBiggestGains(data, TWENTY_FOUR_GAINS, true);
    },
    setTwentyFourLoss: function setTwentyFourLoss(state, data) {
      state.twentyFourLoss = prepareBiggestGains(data, TWENTY_FOUR_LOSS, false);
    },
    setWeekGains: function setWeekGains(state, data) {
      state.weekGains = prepareBiggestGains(data, WEEK_GAINS, true);
    },
    setWeekLoss: function setWeekLoss(state, data) {
      state.weekLoss = prepareBiggestGains(data, WEEK_LOSS, false);
    },
    setNewArrivalMarkets: function setNewArrivalMarkets(state, data) {
      state.newArrivalMarkets = prepareMostPredicted(data.markets, TITLE_NEW_ARRIVALS);
    },
    setMostPredictedMarkets: function setMostPredictedMarkets(state, data) {
      state.mostPredictedMarkets = prepareMostPredicted(data.markets, TITLE_PREDICTED);
    },
    setTrendingMarkets: function setTrendingMarkets(state, data) {
      state.trendingMarkets = prepareMostPredicted(data.markets, TITLE_TRENDING);
    },
    setBiggestMoverMarkets: function setBiggestMoverMarkets(state, data) {
      state.biggestMoverMarkets = prepareMostPredicted(data.markets, TITLE_MOVERS);
    }
  },
  actions: {
    getHeaders: function getHeaders(_ref) {
      var commit = _ref.commit;

      var cached = __WEBPACK_IMPORTED_MODULE_13__helpers_localStorage__["a" /* default */].get('browseHeaders');
      var prom = cached ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({ data: cached }) : __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getHeaders();
      return prom.then(function (response) {
        if (!__WEBPACK_IMPORTED_MODULE_9_lodash_isString___default()(response.data)) {
          var sorted = __WEBPACK_IMPORTED_MODULE_7_lodash_sortBy___default()(response.data, ['sortOrder']);
          __WEBPACK_IMPORTED_MODULE_13__helpers_localStorage__["a" /* default */].set('browseHeaders', response.data, "3600");
          commit('setHeaders', sorted);
        }
        return response;
      });
    },
    getFilters: function getFilters(_ref2, headerId) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getFilters(headerId).then(function (response) {
        var sorted = __WEBPACK_IMPORTED_MODULE_7_lodash_sortBy___default()(response.data, ['sortOrder']);
        sorted.map(function (item) {
          item.filters = __WEBPACK_IMPORTED_MODULE_7_lodash_sortBy___default()(item.filters, ['sortOrder']);
          return item;
        });
        commit('setFilters', sorted);
        return response;
      });
    },

    getFilteredMarkets: __WEBPACK_IMPORTED_MODULE_6_lodash_throttle___default()(function (_ref3, _ref4) {
      var state = _ref3.state,
          commit = _ref3.commit;
      var headerId = _ref4.headerId,
          _ref4$reset = _ref4.reset,
          reset = _ref4$reset === undefined ? false : _ref4$reset;

      var filterIds = state.selectedFilters.join(',');
      var sort = state.selectedOrder.sort;
      var sortParameter = state.selectedTimespan.parameter;
      var page = reset ? 1 : state.filteredMarkets.page + 1;
      var canLoadMore = reset ? true : state.filteredMarkets.canLoadMore;
      if (canLoadMore) {
        return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getFilteredMarkets(headerId, 20, page, filterIds, sort, sortParameter).then(function (response) {
          // resetting takes place here so markets are 'swapped'
          if (reset) commit('resetFilteredMarkets');
          commit('updateFilteredMarkets', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(response.data, { page: page }));
          return response;
        });
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(1);
    }, THROTTLE_TIME),
    resetFilteredMarkets: function resetFilteredMarkets(_ref5) {
      var commit = _ref5.commit;

      commit('resetFilteredMarkets');
    },
    getNewArrivalMarkets: function getNewArrivalMarkets(_ref6, _ref7) {
      var commit = _ref6.commit;
      var limit = _ref7.limit;

      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getNewArrivalMarkets(limit).then(function (response) {
        commit('setNewArrivalMarkets', response.data);
        return response.data;
      });
    },
    getMostPredictedMarkets: function getMostPredictedMarkets(_ref8, _ref9) {
      var commit = _ref8.commit;
      var limit = _ref9.limit;

      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getMostPredictedMarkets(limit).then(function (response) {
        commit('setMostPredictedMarkets', response.data);
        return response.data;
      });
    },
    getTrendingMarkets: function getTrendingMarkets(_ref10, _ref11) {
      var commit = _ref10.commit;
      var limit = _ref11.limit;

      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getTrendingMarkets(limit).then(function (response) {
        commit('setTrendingMarkets', response.data);
        return response.data;
      });
    },
    getBiggestMoverMarkets: function getBiggestMoverMarkets(_ref12, _ref13) {
      var commit = _ref12.commit;
      var limit = _ref13.limit;

      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getBiggestMoverMarkets(limit).then(function (response) {
        commit('setBiggestMoverMarkets', response.data);
        return response.data;
      });
    },
    addFilter: function addFilter(_ref14, filterId) {
      var commit = _ref14.commit;

      commit('addFilter', filterId);
    },
    removeFilter: function removeFilter(_ref15, filterId) {
      var commit = _ref15.commit;

      commit('removeFilter', filterId);
    },
    selectOrder: function selectOrder(_ref16, sort) {
      var commit = _ref16.commit;

      commit('selectOrder', sort);
    },
    selectTimespan: function selectTimespan(_ref17, parameter) {
      var commit = _ref17.commit;

      commit('selectTimespan', parameter);
    },
    getCarousel: function getCarousel() {
      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getCarousel().then(function (response) {
        return response.data;
      });
    },
    getTwentyFourGains: function getTwentyFourGains(_ref18, _ref19) {
      var commit = _ref18.commit;
      var _ref19$isLoss = _ref19.isLoss,
          isLoss = _ref19$isLoss === undefined ? false : _ref19$isLoss,
          _ref19$days = _ref19.days,
          days = _ref19$days === undefined ? 1 : _ref19$days,
          _ref19$contracts = _ref19.contracts,
          contracts = _ref19$contracts === undefined ? 2 : _ref19$contracts;

      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getHomePageGainModule(isLoss, days, contracts).then(function (response) {
        commit('setTwentyFourGains', response.data);
        return response.data;
      });
    },
    getTwentyFourLoss: function getTwentyFourLoss(_ref20, _ref21) {
      var commit = _ref20.commit;
      var _ref21$isLoss = _ref21.isLoss,
          isLoss = _ref21$isLoss === undefined ? true : _ref21$isLoss,
          _ref21$days = _ref21.days,
          days = _ref21$days === undefined ? 1 : _ref21$days,
          _ref21$contracts = _ref21.contracts,
          contracts = _ref21$contracts === undefined ? 2 : _ref21$contracts;

      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getHomePageGainModule(isLoss, days, contracts).then(function (response) {
        commit('setTwentyFourLoss', response.data);
        return response.data;
      });
    },
    getWeekGains: function getWeekGains(_ref22, _ref23) {
      var commit = _ref22.commit;
      var _ref23$isLoss = _ref23.isLoss,
          isLoss = _ref23$isLoss === undefined ? false : _ref23$isLoss,
          _ref23$days = _ref23.days,
          days = _ref23$days === undefined ? 7 : _ref23$days,
          _ref23$contracts = _ref23.contracts,
          contracts = _ref23$contracts === undefined ? 2 : _ref23$contracts;

      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getHomePageGainModule(isLoss, days, contracts).then(function (response) {
        commit('setWeekGains', response.data);
        return response.data;
      });
    },
    getWeekLoss: function getWeekLoss(_ref24, _ref25) {
      var commit = _ref24.commit;
      var _ref25$isLoss = _ref25.isLoss,
          isLoss = _ref25$isLoss === undefined ? true : _ref25$isLoss,
          _ref25$days = _ref25.days,
          days = _ref25$days === undefined ? 7 : _ref25$days,
          _ref25$contracts = _ref25.contracts,
          contracts = _ref25$contracts === undefined ? 2 : _ref25$contracts;

      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getHomePageGainModule(isLoss, days, contracts).then(function (response) {
        commit('setWeekLoss', response.data);
        return response.data;
      });
    },
    clearFilters: function clearFilters(_ref26) {
      var commit = _ref26.commit;

      commit('clearFilters');
    },
    clearTimespan: function clearTimespan(_ref27) {
      var commit = _ref27.commit;

      commit('clearTimespan');
    },
    setTimespanFromQuery: function setTimespanFromQuery(_ref28, payload) {
      var commit = _ref28.commit;

      commit('setTimespanFromQuery', payload);
    },
    clearOrder: function clearOrder(_ref29) {
      var commit = _ref29.commit;

      commit('clearOrder');
    },
    setOrderFromQuery: function setOrderFromQuery(_ref30, payload) {
      var commit = _ref30.commit;

      commit('setOrderFromQuery', payload);
    },
    updateMarketFromNotification: function updateMarketFromNotification(_ref31, payload) {
      var commit = _ref31.commit;

      commit('updateMarketFromNotification', payload);
    },
    updateContractFromNotification: function updateContractFromNotification(_ref32, payload) {
      var commit = _ref32.commit;

      commit('updateContractFromNotification', payload);
    },
    updateGainsLossMarketFromNotification: function updateGainsLossMarketFromNotification(_ref33, payload) {
      var commit = _ref33.commit;

      commit('updateGainsLossMarketFromNotification', payload);
    },
    updateGainsLossContractFromNotification: function updateGainsLossContractFromNotification(_ref34, payload) {
      var commit = _ref34.commit;

      commit('updateGainsLossContractFromNotification', payload);
    },
    updatePredictedTrendingMarketFromNotification: function updatePredictedTrendingMarketFromNotification(_ref35, payload) {
      var commit = _ref35.commit;

      commit('updatePredictedTrendingMarketFromNotification', payload);
    },
    updatePredictedTrendingContractsFromNotification: function updatePredictedTrendingContractsFromNotification(_ref36, payload) {
      var commit = _ref36.commit;

      commit('updatePredictedTrendingContractsFromNotification', payload);
    },
    updateMarketWidgetsContractsFromNotification: function updateMarketWidgetsContractsFromNotification(_ref37, payload) {
      var commit = _ref37.commit;

      commit('updateMarketWidgetsContractsFromNotification', payload);
    },
    getWidgets: function getWidgets(_ref38) {
      var commit = _ref38.commit;

      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getWidgets().then(function (response) {
        commit('setWidgets', response.data);
        return response;
      });
    },
    setLatestHeaderId: function setLatestHeaderId(_ref39, data) {
      var commit = _ref39.commit;

      commit('setLatestHeaderId', data);
    },
    getStoriesNav: function getStoriesNav(_ref40) {
      var commit = _ref40.commit;

      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getStoriesNav().then(function (response) {
        commit('setStoriesNav', response.data);
        return response.data;
      });
    },
    getStory: function getStory(_ref41, index) {
      var commit = _ref41.commit;

      commit('clearCurrentStory');
      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getStory(index).then(function (response) {
        commit('setCurrentStory', response.data);
        return response.data;
      });
    },
    getStoryDetail: function getStoryDetail(_ref42, index) {
      var commit = _ref42.commit;

      commit('clearCurrentStoryDetail');
      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getStoryDetail(index).then(function (response) {
        commit('setCurrentStoryDetail', response.data);
        return response.data;
      });
    },
    getStaticPage: function getStaticPage(_ref43, key) {
      var commit = _ref43.commit;

      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getStaticPageDetail(key).then(function (response) {
        return response.data.renderedHTML || '';
      });
    },
    getStaticPageFull: function getStaticPageFull(_ref44, key) {
      var commit = _ref44.commit;

      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getStaticPageDetail(key).then(function (response) {
        return response.data;
      });
    },
    getStaticPagePreview: function getStaticPagePreview(_ref45, id) {
      var commit = _ref45.commit;

      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getStaticPagePreview(id).then(function (response) {
        return response.data;
      });
    },
    getStoryFullPreview: function getStoryFullPreview(_ref46, id) {
      var commit = _ref46.commit;

      return __WEBPACK_IMPORTED_MODULE_12__services_api__["a" /* default */].browse.getStoryFullPreview(id).then(function (response) {
        return response.data;
      });
    },
    clearCurrentStoryDetail: function clearCurrentStoryDetail(_ref47) {
      var commit = _ref47.commit;

      commit('clearCurrentStoryDetail');
    }
  }
});

/***/ }),

/***/ "0KCx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insight-news"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"insight-news__line"}),_vm._v(" "),_c('insight-panel',{attrs:{"text":"See All","href":_vm.allArticlesLink,"away":_vm.allArticlesAway}},[_c('div',{staticClass:"insight-news__articles"},_vm._l((_vm.analysis),function(link){return _c('insight-link',{key:link.title,attrs:{"title":link.title,"href":_vm.createLink(link.url),"date":_vm.createDate(link.date),"url":link.url}})}),1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insight-news__header"},[_c('div',{staticClass:"insight-news__header-title"},[_vm._v("\n      Insights\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0O9D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onLogin: function onLogin() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'click',
        label: 'Login to My Account'
      });
      if (this.isPage) {
        this.$router.push({ name: 'account-page-login' });
      } else {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
      }
    }
  })
});

/***/ }),

/***/ "0OLA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isDark: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),

/***/ "0RmI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_user_report_js__ = __webpack_require__("CcaY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c7d9c12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_report_vue__ = __webpack_require__("qVoY");
function injectStyle (ssrContext) {
  __webpack_require__("pjhW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_user_report_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c7d9c12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0X7F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getForumUrl: function getForumUrl() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/About/ForumURL');
  },
  getTicketsTypes: function getTicketsTypes() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Support/Tickets/Types');
  },
  postTicket: function postTicket(payload) {
    var options = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Support/Ticket', payload, options);
  },
  getReportUser: function getReportUser() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Support/ReportUser');
  },
  postReportUser: function postReportUser(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Support/ReportUser', payload);
  },
  getAnnouncements: function getAnnouncements() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/About/Announcements');
  }
});

/***/ }),

/***/ "0Xxu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-currently-predicting"},[_c('div',{staticClass:"market-currently-predicting__title"},[_vm._v(_vm._s(_vm.obj.title))]),_vm._v(" "),(!!_vm.widget)?_c('div',{staticClass:"market-currently-predicting__content"},[_c('swiper',{attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.traders),function(pred,index){return _c('swiper-slide',{key:index},[_c('div',{staticClass:"market-currently-predicting__element"},[_c('div',{staticClass:"market-currently-predicting__user-area",on:{"click":function($event){$event.stopPropagation();return _vm.showUserDetails(pred)}}},[_c('div',{staticClass:"market-currently-predicting__avatar"},[_c('account-social-avatar',{attrs:{"avatar":pred.avatarImage,"showProgress":true,"percentage":100,"progressStrokeColor":_vm.getLevelByPredictions(pred.profitablePredictions).currentColor,"showEdit":false,"theme":"markets"}})],1),_vm._v(" "),_c('div',{staticClass:"market-currently-predicting__name"},[_vm._v(_vm._s(pred.userName))]),_vm._v(" "),_c('div',{staticClass:"market-currently-predicting__info"},[_c('div',{staticClass:"market-currently-predicting__active"},[_vm._v("\r\n                 "+_vm._s(_vm.traderLevelDisplay(pred))+"\r\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"market-currently-predicting__market",on:{"click":function($event){$event.stopPropagation();return _vm.onClick(pred)}}},[_vm._v(_vm._s(pred.marketName))]),_vm._v(" "),_c('div',{staticClass:"market-currently-predicting__footer"},[_c('div',{staticClass:"market-currently-predicting__wrap"},[_c('div',{staticClass:"market-currently-predicting__what"},[_vm._v(_vm._s(_vm.boughtSold(pred.tradeType)))]),_vm._v(" "),_c('div',{class:_vm.classModifier(pred.tradeType)},[_vm._v(_vm._s(_vm.yesNo(pred.tradeType)))]),_vm._v(" "),(!_vm.isMarketSingle(pred))?_c('div',{staticClass:"market-currently-predicting__contract"},[_c('span',[_vm._v("in")]),_vm._v(" "+_vm._s(pred.contractName)+"\r\n              ")]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.priceClassModifiers(pred)},[(pred.pricePerShare)?_c('animated-number',{attrs:{"value":Number(pred.pricePerShare)}}):_c('span',[_vm._v(" ")])],1)])])])])}),1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0fv4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_support_js__ = __webpack_require__("tGWZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5ba2c36_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_support_vue__ = __webpack_require__("V6qK");
function injectStyle (ssrContext) {
  __webpack_require__("9Q/H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_support_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5ba2c36_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_support_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0fyw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0iiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-reset-password"},[_c('form',{staticClass:"account-reset-password__form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"name":"username","type":"email","required":true,"validation":_vm.$v.fields.email,"autocomplete":"off","gtm":"Reset Password,Email","placeholder":"Email"},on:{"input":_vm.$v.fields.email.$touch},model:{value:(_vm.fields.email),callback:function ($$v) {_vm.$set(_vm.fields, "email", $$v)},expression:"fields.email"}})],1),_vm._v(" "),_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"name":"newPassword","type":"password","disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.newPassword,"autocomplete":"off","placeholder":"New Password"},on:{"input":_vm.$v.fields.newPassword.$touch},model:{value:(_vm.fields.newPassword),callback:function ($$v) {_vm.$set(_vm.fields, "newPassword", $$v)},expression:"fields.newPassword"}})],1),_vm._v(" "),_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"name":"newPasswordConfirmation","type":"password","disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.newPasswordConfirmation,"autocomplete":"off","placeholder":"Confirm New Password"},on:{"input":_vm.$v.fields.newPasswordConfirmation.$touch},model:{value:(_vm.fields.newPasswordConfirmation),callback:function ($$v) {_vm.$set(_vm.fields, "newPasswordConfirmation", $$v)},expression:"fields.newPasswordConfirmation"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form__section account-reset-password__submit"},[_c('form-submit',{attrs:{"disabled":_vm.invalidOrDisabled,"label":"Reset Password"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0u6x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1/Lc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__ = __webpack_require__("gnYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_contracts_history_contract_tile_contract_tile_vue__ = __webpack_require__("34gu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_plus_minus_sign_plus_minus_sign_vue__ = __webpack_require__("T2le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_staticConf_utils__ = __webpack_require__("RZM5");









var NO_CONTRACTS_MESSAGE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__mixins_staticConf_utils__["a" /* $txt */])('contracts-history.no-items');
var NO_MORE_CONTRACTS_MESSAGE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__mixins_staticConf_utils__["a" /* $txt */])('contracts-history.no-more-items');

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__["a" /* default */]],
  props: {
    lightHeader: {
      type: Boolean,
      default: false
    },
    showMarketNames: {
      type: Boolean,
      default: true
    },
    contracts: {
      type: Array
    },
    canLoadMore: {
      type: Boolean,
      default: true
    },
    compactMode: { // keep mobile size on desktop
      type: Boolean,
      default: false
    },
    marketId: Number // indicates "see more" routing
  },
  components: {
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a,
    contractTile: __WEBPACK_IMPORTED_MODULE_4__components_contracts_history_contract_tile_contract_tile_vue__["a" /* default */],
    plusMinusSign: __WEBPACK_IMPORTED_MODULE_5__components_generics_plus_minus_sign_plus_minus_sign_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loadedInfo: this.getLoadedInfo(),
      infiniteLoader: null
    };
  },

  watch: {
    contracts: {
      handler: 'contractsHandler',
      immediate: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    showLoader: function showLoader() {
      return !this.isComponentReady && !this.compactMode && !this.$route.params.marketId;
    },
    loaderNum: function loaderNum() {
      return this.isLayoutMobile ? 2 : 5;
    },
    showHeader: function showHeader() {
      return this.lightHeader ? this.contracts.length > 0 : true;
    },
    headModifiers: function headModifiers() {
      return {
        'contracts-history__head': true,
        'contracts-history--light': this.lightHeader
      };
    },
    classModifiers: function classModifiers() {
      return {
        'contracts-history--compact': this.compactMode
      };
    },
    stickyOptions: function stickyOptions() {
      if (this.$router.currentRoute.name === 'market-details') {
        return this.isLayoutMobile ? __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__["a" /* default */].mobile : __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__["a" /* default */].desktop;
      }
      return this.isLayoutMobile ? __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__["a" /* default */].mobile : __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__["a" /* default */].desktop;
    },
    desktopColumns: function desktopColumns() {
      return !(this.isLayoutMobile || this.compactMode);
    }
  }),
  methods: {
    contractsHandler: function contractsHandler(newValue, oldValue) {
      if (newValue.length > 0) {
        this.isComponentReady = true;
        if (this.infiniteLoader) {
          this.infiniteLoader.loaded();
          if (!this.canLoadMore) {
            this.infiniteLoader.complete();
          }
        }
        this.loadedInfo = this.getLoadedInfo();
      } else if (typeof oldValue === 'undefined') {
        this.loadedInfo = this.getLoadedInfo();
        this.isComponentReady = true;
      }
    },
    getLoadedInfo: function getLoadedInfo() {
      return this.contracts.length > 0 ? NO_MORE_CONTRACTS_MESSAGE : NO_CONTRACTS_MESSAGE;
    },
    goInfinite: function goInfinite(infi) {
      this.infiniteLoader = infi;
      this.$emit('loading', infi);
    }
  }
});

/***/ }),

/***/ "1/XJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__ = __webpack_require__("vJzj");








var TOTAL_COLUMNS = 12;
var COLUMN_OPTIONS = [{ label: '0%', value: 0 }, { label: '8.3%', value: 1 }, { label: '16.6%', value: 2 }, { label: '25%', value: 3 }, { label: '33.3%', value: 4 }, { label: '41.6%', value: 5 }, { label: '50%', value: 6 }, { label: '58.3%', value: 7 }, { label: '66.6%', value: 8 }, { label: '75%', value: 9 }, { label: '83%', value: 10 }, { label: '91.6%', value: 11 }];
/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  props: {
    previewId: {}
  },
  data: function data() {
    return {
      COLUMN_OPTIONS: COLUMN_OPTIONS,
      columnChoice: {
        left: COLUMN_OPTIONS[0],
        middle: COLUMN_OPTIONS[7],
        right: COLUMN_OPTIONS[0]
      }
    };
  },

  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_5__components_generics_alert_box_alert_box_vue__["a" /* default */]
  },
  computed: {
    isColumnCountExceeding: function isColumnCountExceeding() {
      return this.columnChoice.left.value + this.columnChoice.right.value >= TOTAL_COLUMNS;
    },
    middleOption: function middleOption() {
      var sumColumns = this.columnChoice.left.value + this.columnChoice.right.value;
      return TOTAL_COLUMNS - sumColumns;
    },
    leftColumnClasses: function leftColumnClasses() {
      var option = this.columnChoice.left.value;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        column: true
      }, 'small-' + option, !!option);
    },
    middleColumnClasses: function middleColumnClasses() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        column: true
      }, 'small-' + this.middleOption, !!this.middleOption);
    },
    rightColumnClasses: function rightColumnClasses() {
      var option = this.columnChoice.right.value;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        column: true
      }, option, !!option);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getStaticPagePreview(this.previewId).then(function (data) {
      _this.loaderRemove(document.body);
      _this.installDynamicControls({ data: data });
    }).catch(function () {
      return _this.loaderRemove(document.body);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getStaticPagePreview']))
});

/***/ }),

/***/ "1/qb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_userAgent__ = __webpack_require__("GZXJ");
/* eslint-disable no-bitwise */


var listenAction = void 0;
var stickyTop = void 0;
var zIndex = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    var elStyle = el.style;
    var params = binding.value || {};
    stickyTop = params.stickyTop || 0;
    zIndex = params.zIndex || 1000;
    // uncomment this line and import in case disabling on ios is necessary
    // if (isIos) return;

    if (__WEBPACK_IMPORTED_MODULE_0__mixins_userAgent__["g" /* isWindows */]) return;
    elStyle.position = '-webkit-sticky';
    elStyle.position = 'sticky';

    // if the browser support css sticky（Currently Safari, Firefox and Chrome Canary）
    if (~elStyle.position.indexOf('sticky')) {
      elStyle.top = stickyTop + 'px';
      elStyle.zIndex = zIndex;
      return;
    }

    elStyle.position = 'relative';

    var childStyle = el.firstElementChild.style;
    childStyle.cssText = 'left: 0; right: 0; top: ' + stickyTop + 'px; z-index: ' + zIndex + '; ' + childStyle.cssText;

    var active = false;

    var sticky = function sticky() {
      if (active) {
        return;
      }
      if (!elStyle.height) {
        elStyle.height = el.offsetHeight + 'px';
      }
      childStyle.willChange = 'transform';
      childStyle.position = 'fixed';
      active = true;
    };

    var reset = function reset() {
      if (!active) {
        return;
      }
      childStyle.position = 'absolute';
      active = false;
    };

    var check = function check() {
      var offsetTop = el.getBoundingClientRect().top;
      if (offsetTop <= stickyTop) {
        sticky();
        return;
      }
      reset();
    };

    listenAction = function listenAction() {
      if (!window.requestAnimationFrame) {
        return setTimeout(check, 16);
      }

      window.requestAnimationFrame(check);
      return null;
    };

    window.addEventListener('scroll', listenAction);
  },
  unbind: function unbind() {
    window.removeEventListener('scroll', listenAction);
  },
  update: function update(el, binding) {
    var params = binding.value || {};
    stickyTop = params.stickyTop || 0;
    zIndex = params.zIndex || 1000;

    var childStyle = el.firstElementChild.style;
    el.style.top = stickyTop + 'px';
    el.style.zIndex = zIndex;
    childStyle.top = el.style.top;
    childStyle.zIndex = el.style.zIndex;
  }
});

/***/ }),

/***/ "12Ru":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-withdrawal-loader"},[_c('div',{staticClass:"account-withdrawal-loader__row account-withdrawal-loader__row--first"},[_c('div',{staticClass:"account-withdrawal-loader__row-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row"},[_c('div',{staticClass:"account-withdrawal-loader__row-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row"},[_c('div',{staticClass:"account-withdrawal-loader__row-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row"},[_c('div',{staticClass:"account-withdrawal-loader__row-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-withdrawal-loader__row-col-2"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1F6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__ = __webpack_require__("UKic");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1173e132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("TzxP");
function injectStyle (ssrContext) {
  __webpack_require__("Hidh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1173e132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1FJm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    rules: String,
    dateEnd: String,
    market: {
      type: Object,
      required: true
    },
    emphasize: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('market', ['isRulesOpen']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    wrapperClass: function wrapperClass() {
      return {
        'market-rules__wrapper': true,
        'market-rules__wrapper--single': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["l" /* isMarketSingle */])(this.market)
      };
    },
    marginBoxClass: function marginBoxClass() {
      return {
        'market-rules__box': true,
        'market-rules__box--margin': true
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setGenericSmallPopup']), {
    showRulesPopup: function showRulesPopup() {
      this.setGenericSmallPopup({
        name: __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_MARKET_RULES,
        options: {
          title: 'The Rules',
          content: this.rules
        }
      });
    }
  }),
  mounted: function mounted() {
    if (this.emphasize) this.showRulesPopup();
  }
});

/***/ }),

/***/ "1Lmp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_chart_models__ = __webpack_require__("Q+EN");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contract: {
      type: Object,
      required: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('chart', ['getContractChartData']), {
    createChart: function createChart(data) {
      var _this = this;

      if (data) {
        setTimeout(function () {
          _this.renderChart(data);
        }, __WEBPACK_IMPORTED_MODULE_2__utils_chart_models__["f" /* PriceChangeChart */].renderTimeout());
      }
    },
    renderChart: function renderChart(data) {
      if (!this.$refs.chart) return;
      var chart = new __WEBPACK_IMPORTED_MODULE_2__utils_chart_models__["f" /* PriceChangeChart */](this.contract, data);
      chart.draw(this.$refs.chart);
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    var payload = {
      contractId: this.contract.contractId
    };
    this.getContractChartData(payload).then(function (data) {
      return _this2.createChart(data);
    });
  }
});

/***/ }),

/***/ "1P9U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_detail_charts_js__ = __webpack_require__("1pzP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dbaf584_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_detail_charts_vue__ = __webpack_require__("LTXn");
function injectStyle (ssrContext) {
  __webpack_require__("IQVd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_detail_charts_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dbaf584_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_detail_charts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1PPl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1PxF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1ado":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1lzi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_purchase_purchase_yes_no_switcher_purchase_yes_no_switcher__ = __webpack_require__("mbvb");



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      PURCHASE_DEFAULT_LABEL: __WEBPACK_IMPORTED_MODULE_1__components_purchase_purchase_yes_no_switcher_purchase_yes_no_switcher__["a" /* PURCHASE_DEFAULT_LABEL */]
    };
  },

  props: {
    text: {
      type: String,
      required: true
    },
    price: {
      type: Number,
      required: true
    },
    layout: {
      type: String,
      default: ''
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'button-price': true
      }, 'button-price--' + this.layout, this.layout);
    }
  }
});

/***/ }),

/***/ "1pzP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INITIAL_MAX_CONTRACTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEqual__ = __webpack_require__("hygk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_market_detail_charts_container_container_vue__ = __webpack_require__("M8zO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_detail_charts_header_header_vue__ = __webpack_require__("4pyq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_market_market_detail_charts_table_table_vue__ = __webpack_require__("ZJhQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_market_market_detail_charts_timeline_timeline_vue__ = __webpack_require__("GebD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_market_market_contracts_stats_market_contracts_stats_vue__ = __webpack_require__("Y/q+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__("jPoG");





 /* eslint-disable */











// const YES_CONTRACT_TYPE = 'Yes';
// const NO_CONTRACT_TYPE = 'No';
// const NO_CONTRACT_LINE_COLOR = '#F27130';
var MARKET_SINGLE_CONTRACT_NAME = 'Closing Price';
var INITIAL_SHOW_CONTRACTS = 3;
var INITIAL_MAX_CONTRACTS = 6;

var CHART_TYPES = {
  LINE: 'line',
  CANDLE: 'candle'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_loader__["a" /* default */]],
  props: {
    market: {
      type: Object,
      required: false
    },
    chartOptions: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    var contractIds = __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.chartOptions, 'contractIds', []) || [];
    return {
      hasMarketHiddenContracts: __WEBPACK_IMPORTED_MODULE_13__utils_helpers__["f" /* hasMarketHiddenContracts */],
      chartType: CHART_TYPES.LINE,
      preparedContractIds: null,
      toggled: false,
      disabledContracts: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(),
      chartShowContractsInitial: INITIAL_SHOW_CONTRACTS,
      chartMaxContracts: contractIds.length > 0 ? contractIds.length : INITIAL_MAX_CONTRACTS,
      chartTimeline: null,
      chartDataLoaded: false,
      chartData: [],
      originalChartData: [],
      showStats: false
    };
  },

  components: {
    chartsContainer: __WEBPACK_IMPORTED_MODULE_7__components_market_market_detail_charts_container_container_vue__["a" /* default */],
    chartsHeader: __WEBPACK_IMPORTED_MODULE_8__components_market_market_detail_charts_header_header_vue__["a" /* default */],
    chartsTable: __WEBPACK_IMPORTED_MODULE_9__components_market_market_detail_charts_table_table_vue__["a" /* default */],
    chartsTimeline: __WEBPACK_IMPORTED_MODULE_10__components_market_market_detail_charts_timeline_timeline_vue__["a" /* default */],
    marketContractsStats: __WEBPACK_IMPORTED_MODULE_11__components_market_market_contracts_stats_market_contracts_stats_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('market', ['marketContractsStats']), {
    title: function title() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.chartOptions, 'chartTitle', null);
    },
    caption: function caption() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.chartOptions, 'chartCaption', null);
    },
    chartContracts: function chartContracts() {
      var _this = this;

      var results = [];
      var contractIdDataGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["g" /* groupByKeepOrder */])(this.chartData, 'contractId');

      // show contracts that represent selected point on time on the chart
      contractIdDataGroup.forEach(function (data) {
        results.push(data[data.length - 1]);
      });
      return results.map(function (item) {
        var contract = _this.market.contracts.find(function (i) {
          return i.contractId === item.contractId;
        }) || {};
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
          contractImageUrl: contract.contractImageUrl,
          contractImageSmallUrl: contract.contractImageSmallUrl
        });
      });
    },
    leftToShowContracts: function leftToShowContracts() {
      if (this.market.contracts.length < INITIAL_MAX_CONTRACTS) {
        return 0;
      }
      return this.showChartsTable && this.market.contracts.length - this.chartMaxContracts;
    },
    showChartsTable: function showChartsTable() {
      var noChartOptionOrLegendOn = this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.chartOptions, 'includeLegend', false);
      return this.chartContracts.length > 1 && (this.isLayoutDesktop || this.toggled) && noChartOptionOrLegendOn;
    },
    showChartsKey: function showChartsKey() {
      return this.chartContracts.length > 1 && this.isLayoutMobile && !this.toggled && this.chartOptions === null;
    },
    filteredChartData: function filteredChartData() {
      return this.chartData.filter(function (el) {
        return el.checked;
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('chart', ['getMarketChartData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('market', ['getMarketContractsStats', 'clearMarketContractsStats']), {
    prepareDisabledContracts: function prepareDisabledContracts(data) {
      var _this2 = this;

      var results = [];
      var contractIdDataGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["g" /* groupByKeepOrder */])(data, 'contractId');
      // show contracts that represent selected point on time on the art
      contractIdDataGroup.forEach(function (groupData) {
        results.push(groupData[groupData.length - 1]);
      });
      results.forEach(function (el, index) {
        if (index >= _this2.chartShowContractsInitial) {
          _this2.disabledContracts.add(el.contractId);
        }
      });
    },
    prepareChartData: function prepareChartData(data) {
      var _this3 = this;

      var contracts = __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default()(data, function (el) {
        return el.contractId;
      });
      var contractIds = contracts.map(function (el) {
        return el.contractId;
      });
      var isYesNoMarket = contracts.length === 1;
      if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(contractIds, this.preparedContractIds)) {
        this.prepareDisabledContracts(data);
        this.preparedContractIds = contractIds;
      }

      data.forEach(function (el) {
        el.additional = false;
        el.checked = _this3.checkIsContractEnabled(el);
        el.chartPrice = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils__["a" /* regularContractPrice */])(el);

        if (isYesNoMarket) {
          el.contractName = MARKET_SINGLE_CONTRACT_NAME;
        }
      });

      return data;
    },
    checkIsContractEnabled: function checkIsContractEnabled(el) {
      return !this.disabledContracts.has(el.contractId);
    },
    loadStats: function loadStats() {
      var _this4 = this;

      this.loaderAdd();
      this.getMarketContractsStats(this.market.marketId).then(function () {
        return _this4.loaderRemove();
      }).catch(function () {
        return _this4.loaderRemove();
      });
    },
    loadChartData: function loadChartData(_ref) {
      var _this5 = this;

      var _ref$useOriginalData = _ref.useOriginalData,
          useOriginalData = _ref$useOriginalData === undefined ? false : _ref$useOriginalData;

      if (useOriginalData) {
        var data = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.originalChartData));
        this.chartData = this.prepareChartData(data);
      } else {
        var params = {
          marketId: this.market.marketId,
          maxContracts: this.chartMaxContracts,
          timespan: this.chartTimeline
        };
        var storyId = __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.chartOptions, 'cmsStoryId', null);
        if (storyId) {
          params.storyId = storyId;
          params.chartStoryVersionId = __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.chartOptions, 'cmsVersionId', null);
          params.chartIndex = __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.chartOptions, 'chartIndex', null);
          params.sectionType = __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.chartOptions, 'sectionType', null);
        }

        this.loaderAdd();
        this.getMarketChartData(params).then(function (data) {
          _this5.originalChartData = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
          _this5.chartData = _this5.prepareChartData(data);
          _this5.chartDataLoaded = true;
          _this5.loaderRemove();
        }).catch(function () {
          return _this5.loaderRemove();
        });
      }
    },
    onShowKey: function onShowKey() {
      this.toggled = true;
    },
    onTimelineChange: function onTimelineChange(timeline) {
      if (timeline === 'stats') {
        this.showStats = true;
        this.loadStats();
      } else {
        this.showStats = false;
        this.chartTimeline = timeline;
        this.loadChartData({});
      }
    },
    onTypeChange: function onTypeChange(type) {
      var _this6 = this;

      this.chartType = type;

      if (type === CHART_TYPES.CANDLE && this.chartData) {
        var contracts = __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default()(this.chartData, function (el) {
          return el.contractId;
        });
        var enabled = contracts.find(function (i) {
          return _this6.checkIsContractEnabled(i);
        }) || contracts[0];
        var contractIds = contracts.map(function (i) {
          return i.contractId;
        }).filter(function (i) {
          return i !== enabled.contractId;
        });
        this.disabledContracts = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(contractIds);
        this.loadChartData({ useOriginalData: true });
      }
    },
    onContractToggle: function onContractToggle(item, checked) {
      var contractId = item.contractId;
      // const contractsNum = Math.min(this.market.contracts.length, INITIAL_MAX_CONTRACTS);
      // const disabledContractsMaxSize = contractsNum;

      if (this.chartType === CHART_TYPES.CANDLE) {
        if (!checked) {
          this.disabledContracts.add(contractId);
        } else {
          var contractIds = __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default()(this.chartData, function (el) {
            return el.contractId;
          }).map(function (i) {
            return i.contractId;
          }).filter(function (i) {
            return i !== contractId;
          });
          this.disabledContracts = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(contractIds);
        }
      } else {
        if (!checked) {
          this.disabledContracts.add(contractId);
        } else {
          this.disabledContracts.delete(contractId);
        }
      }

      this.loadChartData({ useOriginalData: true });
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.clearMarketContractsStats();
  }
});

/***/ }),

/***/ "1ri1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_coinbase_withdraw_js__ = __webpack_require__("eWdu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c859b50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_coinbase_withdraw_vue__ = __webpack_require__("yLPo");
function injectStyle (ssrContext) {
  __webpack_require__("k843")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_coinbase_withdraw_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c859b50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_coinbase_withdraw_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1vcp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_contracts_history_contracts_history_vue__ = __webpack_require__("uath");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_export_history_export_history_vue__ = __webpack_require__("cgtd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_history_trades_history_filters_history_filters_vue__ = __webpack_require__("aoNs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_loader__ = __webpack_require__("39kf");










/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_loader__["a" /* default */]],
  props: {
    showExport: Boolean
  },
  components: {
    contractsHistory: __WEBPACK_IMPORTED_MODULE_3__components_contracts_history_contracts_history_vue__["a" /* default */],
    exportHistory: __WEBPACK_IMPORTED_MODULE_4__components_export_history_export_history_vue__["a" /* default */],
    historyFilters: __WEBPACK_IMPORTED_MODULE_5__components_account_history_trades_history_filters_history_filters_vue__["a" /* default */]
  },
  data: function data() {
    return {
      activeFilter: null,
      marketId: undefined,
      recent: true,
      isOpen: false,
      loading: null
    };
  },

  watch: {
    activeFilter: function activeFilter(val) {
      if (val) {
        this.doLoading(val.marketId);
      }
    },

    $route: {
      handler: 'routeHandler',
      immediate: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('market', ['market']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('profile', ['tradeHistory', 'marketHistory', 'tradedMarkets']), {
    showMessage: function showMessage() {
      return !this.isLoading && this.$route.params.marketId && this.$route.params.marketId !== 'all' && this.market.marketId && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["l" /* isMarketSingle */])(this.market);
    },
    filteredContracts: function filteredContracts() {
      if (this.activeFilter) {
        // to not show old data while loading new
        return this.activeFilter.marketId !== this.marketHistory.marketId ? [] : this.marketHistory.data;
      }
      // whole trade history
      return this.tradeHistory.data;
    },
    canLoadMore: function canLoadMore() {
      return this.activeFilter ? this.marketHistory.canLoadMore : this.tradeHistory.canLoadMore;
    },
    showMarketNames: function showMarketNames() {
      return this.activeFilter === null;
    },
    isExportAvailable: function isExportAvailable() {
      return this.showExport;
      // this.tradeHistory &&
      // this.tradeHistory.data &&
      // this.tradeHistory.data.length > 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['getTradeHistory', 'getTradedMarkets']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('market', ['getMarket', 'clearMarket']), {
    routeHandler: function routeHandler(route) {
      var _this = this;

      var marketId = route.params.marketId;
      var isAll = marketId === 'all';
      var isEmpty = !marketId;
      this.loaderAdd(document.body);

      if (marketId && !isAll) {
        this.marketId = Number(marketId);
      } else if (isAll) {
        this.marketId = 'all';
      } else {
        this.marketId = undefined;
      }

      this.getTradedMarkets({ cache: true }).then(function (val) {
        if (_this.marketId) {
          var marketFilter = val.find(function (o) {
            return o.marketId === _this.marketId;
          });
          if (marketFilter) {
            _this.activeFilter = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, marketFilter);
          }
        }
      }).then(function () {
        if (marketId && !isAll) {
          _this.clearMarket();
          return _this.getMarket({ marketId: _this.marketId });
        } else if (isAll) {
          _this.clearMarket();
          return _this.getTradeHistory();
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({});
      }).then(function () {
        _this.loaderRemove(document.body);
        _this.isOpen = isAll;
        _this.recent = isEmpty;
        if (isEmpty || isAll) {
          _this.activeFilter = null;
        }
      });
    },
    loadHistory: function loadHistory() {
      if (this.activeFilter) {
        if (this.loading !== this.activeFilter.marketId) {
          this.doLoading(this.activeFilter.marketId);
        }
      }
      if (this.tradeHistory.canLoadMore) {
        this.getTradeHistory();
      }
    },
    modalExport: function modalExport() {
      this.$emit('export', 'trades');
    },
    doLoading: function doLoading(marketId) {
      var _this2 = this;

      if (this.loading !== marketId) {
        this.loading = marketId;
        var contractId = (this.$route.query || {}).contractId;
        var payload = { marketId: marketId };
        if (contractId) {
          payload.contractId = contractId;
        }
        return this.getTradeHistory(payload).then(function () {
          _this2.loading = null;
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({});
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.clearMarket();
  }
});

/***/ }),

/***/ "1zZw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pending-requests-deposits"},[(!_vm.isComponentReady)?[_c('account-withdrawal-loader'),_vm._v(" "),_c('account-withdrawal-loader'),_vm._v(" "),_c('account-withdrawal-loader')]:[_vm._l((_vm.pendingDepositsRequests),function(request){return (_vm.pendingDepositsRequests.length > 0)?_c('pending-request',{key:request.confirmationNumber,staticClass:"pending-requests-deposits__item",attrs:{"isDeposit":true,"request":request},on:{"success":_vm.onSuccess}}):_vm._e()}),_vm._v(" "),(_vm.pendingDepositsRequests.length === 0)?_c('p',{staticClass:"pending-requests-deposits__info"},[_vm._v("\n      You have no deposits pending.\n    ")]):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2+il":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__market_key_stats_element_market_key_stats_element_vue__ = __webpack_require__("GVWc");





function getOrderMobile(arr) {
  var odd = [];
  var even = arr.reduce(function (prev, curr, idx) {
    if (idx % 2) {
      odd.push(curr);
      return prev;
    }
    prev.push(curr);
    return prev;
  }, []);
  return even.concat(odd);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_loader__["a" /* default */]],
  props: {
    widget: Object
  },
  components: {
    marketKeyStatsElement: __WEBPACK_IMPORTED_MODULE_3__market_key_stats_element_market_key_stats_element_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    obj: function obj() {
      return this.widget ? this.widget : {};
    },
    items: function items() {
      if (!this.widget) {
        return [];
      }
      return this.isLayoutMobile ? getOrderMobile(this.widget.widgetKeyStats) : this.widget.widgetKeyStats;
    }
  }),
  watch: {
    widget: function widget(val) {
      if (val) {
        this.loaderRemove();
      }
    }
  },
  methods: {},
  mounted: function mounted() {
    if (!this.widget) {
      this.loaderAdd();
    }
  }
});

/***/ }),

/***/ "20St":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "21pt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_animated_number_js__ = __webpack_require__("DsFz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_420474cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_animated_number_vue__ = __webpack_require__("3Zmp");
function injectStyle (ssrContext) {
  __webpack_require__("F6mp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_animated_number_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_420474cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_animated_number_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "220P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_story_preview_js__ = __webpack_require__("81Xy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfe50f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_story_preview_vue__ = __webpack_require__("swNj");
function injectStyle (ssrContext) {
  __webpack_require__("QQW0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_story_preview_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfe50f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_story_preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "22Ot":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    email: {
      type: String,
      required: false
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentPopupOptions']), {
    onLogin: function onLogin() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
      this.setCurrentPopupOptions({ email: this.email });
    }
  })
});

/***/ }),

/***/ "25HU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "28H6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "28xE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_shares_bar_market_shares_bar_vue__ = __webpack_require__("HvTw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    marketSharesBar: __WEBPACK_IMPORTED_MODULE_5__components_market_market_shares_bar_market_shares_bar_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imageLoadError: false
    };
  },

  props: {
    market: {
      type: Object,
      required: true
    },
    contract: {
      type: Object,
      required: true
    },
    layout: {
      type: String,
      default: 'grid'
    },
    forceSharesPadding: {
      type: Boolean,
      default: false
    },
    enableImage: {
      type: Boolean,
      default: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_3__models_contract__["a" /* default */](this.contract);
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["l" /* isMarketSingle */])(this.market);
    },
    title: function title() {
      return this.isMarketSingle ? 'Latest Price' : this.contractModel.contractName || this.contractModel.name;
    },
    classModifier: function classModifier() {
      var _ref;

      return _ref = {
        'market-contract': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-contract--' + this.layout, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-contract--with-image', this.shouldShowImage), _ref;
    },
    forcePadding: function forcePadding() {
      return {
        'market-contract__shares-padding': this.forceSharesPadding && this.contract.userQuantity < 1
      };
    },
    showSharesBar: function showSharesBar() {
      return this.contractModel.userQuantity > 0;
    },
    shouldShowImage: function shouldShowImage() {
      return this.enableImage && this.isLayoutDesktop && this.imageUrl && !this.imageLoadError;
    },
    imageAltText: function imageAltText() {
      return this.contractModel.contractName;
    },
    imageUrl: function imageUrl() {
      return this.contractModel.imageSmall || this.contractModel.contractImageUrl;
    },
    isDisabled: function isDisabled() {
      return typeof this.contractModel.isOpen !== 'undefined' && !this.contractModel.isOpen || typeof this.contractModel.contractIsOpen !== 'undefined' && !this.contractModel.contractIsOpen;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('trade', ['setTradeOptions']), {
    openPurchaseJourney: function openPurchaseJourney(contractId, operationType, operationValue) {
      var defaultTab = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      if (this.isDisabled) return;

      this.setTradeOptions({
        contractId: contractId,
        operationType: operationType,
        defaultTab: defaultTab,
        operationValue: operationValue !== null ? operationValue : this.contractModel.mode || 'yes'
      });

      if (this.$router.currentRoute.name === 'market-details' && this.$router.currentRoute.params.marketId === this.market.marketId) {
        return;
      }

      this.$router.push({
        name: 'market-details',
        params: {
          marketId: this.market.marketId
        }
      });
    },
    onImageLoadError: function onImageLoadError() {
      this.imageLoadError = true;
    }
  })
});

/***/ }),

/***/ "2DHc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_main_nav_app_main_nav_vue__ = __webpack_require__("3cKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__ = __webpack_require__("BL43");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_notifications_widget_notifications_widget_vue__ = __webpack_require__("oY3V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_header_notification_app_header_notification_vue__ = __webpack_require__("dMVO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_app_app_secondary_nav_app_secondary_nav_vue__ = __webpack_require__("O8vu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_app_app_header_app_header_external_nav_vue__ = __webpack_require__("Y7WP");












var BALANCE_THRESHOLD = 0;
var DONT_SHOW_LOGIN_AND_SIGN_UP_BUTTONS_ROUTES = ['account-page-login', 'account-page-register', 'account-password-forgotten', 'index1', 'index2'];

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__["a" /* default */]],
  components: {
    appMainNav: __WEBPACK_IMPORTED_MODULE_2__components_app_app_main_nav_app_main_nav_vue__["a" /* default */],
    notificationsWidget: __WEBPACK_IMPORTED_MODULE_7__components_notifications_widget_notifications_widget_vue__["a" /* default */],
    appHeaderNotification: __WEBPACK_IMPORTED_MODULE_8__components_app_app_header_notification_app_header_notification_vue__["a" /* default */],
    appSecondaryNav: __WEBPACK_IMPORTED_MODULE_9__components_app_app_secondary_nav_app_secondary_nav_vue__["a" /* default */],
    appHeaderExternalNav: __WEBPACK_IMPORTED_MODULE_10__components_app_app_header_app_header_external_nav_vue__["a" /* default */]
  },
  data: function data() {
    return {
      MODALS: __WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn', 'isUserRestricted']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('browse', ['areUserBrowseHeadersEmpty']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['balance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop', 'isShutdownModeOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['settings']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('notifications', ['showNotificationsWidget']), {
    showLoginAndSignUpButtons: function showLoginAndSignUpButtons() {
      return !DONT_SHOW_LOGIN_AND_SIGN_UP_BUTTONS_ROUTES.includes(this.$route.name);
    },
    showSocialAvatarDesktop: function showSocialAvatarDesktop() {
      return false;
      // return this.isLoggedIn && this.isLayoutDesktop;
    },
    headerPrimaryMenuModifiers: function headerPrimaryMenuModifiers() {
      return {
        'header-new-primary__menu-nav': true,
        'header-new-primary__menu-nav--with-avatar-and-notifications': this.showSocialAvatarDesktop
      };
    },
    showBalanceHeader: function showBalanceHeader() {
      return this.settings.display ? this.settings.display.ShowBalanceHeader : true;
    },
    notifyOnLowBalance: function notifyOnLowBalance() {
      return this.balance.accountBalanceDecimal <= BALANCE_THRESHOLD;
    },
    valueClassModifiers: function valueClassModifiers() {
      var value = this.balance.accountBalanceDecimal;
      return {
        'header-new-primary__menu-item--plus': !this.notifyOnLowBalance && value > 0,
        'header-new-primary__menu-item--neutral': !this.notifyOnLowBalance && (typeof value === 'undefined' || value === 0),
        'header-new-primary__menu-item--minus': this.notifyOnLowBalance || value < 0
      };
    },
    isNotificationIconActive: function isNotificationIconActive() {
      return this.$route.name === 'notifications' || this.showNotificationsWidget;
    },
    showUnreadNotificationCount: function showUnreadNotificationCount() {
      return !this.isNotificationIconActive && this.userUnreadNotificationsCountHeader > 0;
    },
    notificationsIconModifiers: function notificationsIconModifiers() {
      return {
        'header-new-primary__menu-notifications': true,
        'header-new-primary__menu-notifications--unread': this.showUnreadNotificationCount,
        'header-new-primary__menu-notifications--mobile': this.isLayoutMobile,
        'header-new-primary__menu-notifications--active': this.isNotificationIconActive
      };
    },
    depositIconModifiers: function depositIconModifiers() {
      var disabled = this.$route.name === 'wallet';
      return {
        'header-new-primary__menu-item--deposit': true,
        'header-new-primary__menu-item--deposit-disabled': disabled
      };
    },
    depositTitleModifiers: function depositTitleModifiers() {
      var disabled = this.$route.name === 'wallet';
      return {
        'header-new-primary__menu-item__title': true,
        'header-new-primary__menu-item__title--deposit': true,
        'header-new-primary__menu-item__title--deposit-disabled': disabled
      };
    }
  }),
  watch: {
    showNotificationsWidget: function showNotificationsWidget(value) {
      if (!value) {
        this.clearAllNotifications();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['toggleNotificationsWidget']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('search', ['toggleSearchBar']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['logout']), {
    onCashClick: function onCashClick() {
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
        return;
      } else if (!this.isUserVerified) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_VERIFY);
        return;
      }
      this.$router.push({ name: 'wallet' });
    },
    onSignUp: function onSignUp() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].REGISTER);
    },
    openDepositPopup: function openDepositPopup() {
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
      } else if (this.isUserVerified) {
        if (this.$route.name !== 'wallet') {
          this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS);
        }
      } else {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_VERIFY);
      }
    },
    onAvatarClick: function onAvatarClick() {
      this.$router.push({ name: 'portfolio' });
    },
    onNotificationsClick: function onNotificationsClick() {
      if (this.isLayoutDesktop && this.$route.name !== 'notifications') {
        this.toggleNotificationsWidget();
      } else if (this.isLayoutMobile && this.$route.name === 'notifications') {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: 'notifications' });
      }
    }
  })
});

/***/ }),

/***/ "2I1B":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSIzOSIgdmlld0JveD0iMCAwIDQwIDM5Ij4NCiAgICA8cGF0aCBmaWxsPSJub25lIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iIzA4NDE0QiIgZD0iTTE5Ljk0OSAxLjIyNmMxMC43NDcgMCAxOS40NDkgOC4yOTIgMTkuNDQ5IDE4LjUwOCAwIDEwLjIxNy04LjcwMiAxOC41MDgtMTkuNDQ5IDE4LjUwOEM5LjIwMiAzOC4yNDIuNSAyOS45NTEuNSAxOS43MzQuNSA5LjUxOCA5LjIwMiAxLjIyNiAxOS45NDkgMS4yMjZ6bTUuODgxIDExLjUzMWgtMi4zMjZjLTEuMzQ0IDAtMS42NzYuMzc3LTEuNjc2IDEuNTM4djIuMTcyaDQuMzVsLS4wMDMgNS4xODVoLTQuMzQ3VjMyLjM5aC01LjUzNlYyMS42NTJIMTIuNXYtNS4xODVoMy43OTJ2LTIuNTg2YzAtMy43NTggMi40MTQtNi4wMzIgNi4xNS02LjAzMmwzLjg4OC4wMDZ2NC45MDJoLS41eiIvPg0KPC9zdmc+DQo="

/***/ }),

/***/ "2N1A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sold_bought_at_js__ = __webpack_require__("cbPA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9ab223e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sold_bought_at_vue__ = __webpack_require__("b34v");
function injectStyle (ssrContext) {
  __webpack_require__("7ppQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sold_bought_at_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9ab223e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sold_bought_at_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2O7o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: ''
    },
    showLabels: {
      type: Boolean,
      default: true
    },
    showMarketLink: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    userGainLoss: function userGainLoss() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["z" /* marketUserGainLoss */])(this.market);
    },
    isAllPayoutsAvailable: function isAllPayoutsAvailable() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["l" /* isMarketSingle */])(this.market);
    },
    gainIndicatorClassModifier: function gainIndicatorClassModifier() {
      return {
        'market-payout__gain': true,
        'market-payout__going-down': !this.userGainLoss
      };
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'market-payout': true
      }, 'market-payout--' + this.theme, this.theme);
    },
    gainLossLabel: function gainLossLabel() {
      return this.userGainLoss >= 0 ? 'Gain' : 'Loss';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setGenericPopup']), {
    allPayouts: function allPayouts() {
      // because there is no routing for modals
      this.setGenericPopup({
        name: 'potential-payouts',
        options: {
          market: this.market
        }
      });
    }
  })
});

/***/ }),

/***/ "2Pqz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return connect; });
/* unused harmony export addListener */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addOrderBookListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearOrderBookListeners; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setupMessaging; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cleanupMessaging; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__ = __webpack_require__("GZXJ");

/* eslint-disable */






var MESSAGING_TOKEN_FLAG_NAME = 'firebase-token-sent';
var MESSAGING_TOKEN_EXPIRES_AT = 31536000;
var REF_ORDER_BOOK = 'contractOrderBook';
var REF_MARKETS = 'marketStats';
var REF_CONTRACTS = 'contractStats';

var EVENT_ADDED = 'child_added';
var EVENT_CHANGED = 'child_changed';
var EVENT_INIT = 'value';

var DATA_METHOD = 'update';
var DATA_MARKETS = 'market_data';
var DATA_CONTRACTS = 'contract_data';
// let vapidKey = '';

var setSentTokenFlag = function setSentTokenFlag(flag) {
  return __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].set(MESSAGING_TOKEN_FLAG_NAME, flag, MESSAGING_TOKEN_EXPIRES_AT);
};
var sendTokenToServer = function sendTokenToServer(token) {
  if (!__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['user/isLoggedIn']) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'sendTokenToServer skipped', 'User is not logged in');
    return;
  }

  var isTokenSent = __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get(MESSAGING_TOKEN_FLAG_NAME, false);
  if (isTokenSent) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'sendTokenToServer skipped', 'Token was already sent');
    return;
  }

  __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.putMessagingToken(token).then(function () {
    return setSentTokenFlag(true);
  }).catch(function () {
    return setSentTokenFlag(false);
  });
};

var connect = function connect() {
  var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var listenerOptions = arguments[1];

  var config = {};
  var isAnonymous = token === null;
  if (isAnonymous) {
    config = {
      apiKey: "AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA",
      authDomain: "predictit-f497e.firebaseapp.com",
      databaseURL: "https://predictit-f497e.firebaseio.com",
      projectId: "predictit-f497e",
      messagingSenderId: "76708845910",
      appId: ""
    };
    // vapidKey = process.env.FIREBASE_VAPID_ANONYMOUS;
  } else {
    config = {
      apiKey: "AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA",
      authDomain: "predictit-f497e.firebaseapp.com",
      databaseURL: "https://predictit-f497e.firebaseio.com",
      projectId: "predictit-f497e",
      messagingSenderId: "76708845910",
      appId: "1:76708845910:web:a2746a4abbe584b1911ef7"
    };
    // vapidKey = process.env.FIREBASE_VAPID;
  }
  __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'init', 'anonymous mode: ' + isAnonymous, config);
  if (window.firebase.apps.length > 0) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'reinitializing app');
    window.firebase.app().delete().then(function () {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'reinitialized app succesfully');
      window.firebase.initializeApp(config);
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('app/setFirebaseInitialized', true);
      addListener(listenerOptions);
    });
  } else {
    window.firebase.initializeApp(config);
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('app/setFirebaseInitialized', true);
    addListener(listenerOptions);
  }
};

var triggerUpdate = function triggerUpdate(_ref) {
  var _ref$loaded = _ref.loaded,
      loaded = _ref$loaded === undefined ? false : _ref$loaded,
      callback = _ref.callback,
      _ref$method = _ref.method,
      method = _ref$method === undefined ? DATA_METHOD : _ref$method,
      name = _ref.name,
      data = _ref.data;

  if (loaded) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', method + ' of ' + name + ' with ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
    callback(method, name, data);
  } else {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'skipping ' + method + ' of ' + name);
  }
};

var addOrderBookListener = function addOrderBookListener(contractId, listener) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  /* so initial snapshot is ignored -it should come from API */
  var loaded = false;
  var orderBook = window.firebase.database().ref(REF_ORDER_BOOK + '/' + contractId);
  orderBook.on(EVENT_INIT, function (snapshot) {
    var data = snapshot.val();
    if (true && !loaded) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'skipping initial order book update');
    } else if (data) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'update order book ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      listener(data);
    } else if (defaultValue !== null) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'update order book with default value');
      listener(defaultValue);
    } else {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'order book is empty');
    }
    loaded = true;
  });
};

var clearOrderBookListeners = function clearOrderBookListeners(contractId) {
  window.firebase.database().ref(REF_ORDER_BOOK + '/' + contractId).off();
};

var addListener = function addListener(options) {
  __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'adding listener');
  var _options$onUpdate = options.onUpdate,
      onUpdate = _options$onUpdate === undefined ? function () {
    return null;
  } : _options$onUpdate;

  var marketDataLoaded = false;
  var contractDataLoaded = false;

  var markets = window.firebase.database().ref(REF_MARKETS).orderByChild('TimeStamp').startAt((+new Date() / 1000).toFixed(5).toString());
  markets.on(EVENT_ADDED, function (data) {
    triggerUpdate({
      loaded: marketDataLoaded,
      callback: onUpdate,
      name: DATA_MARKETS,
      data: data.val()
    });
  });
  markets.on(EVENT_CHANGED, function (data) {
    triggerUpdate({
      loaded: marketDataLoaded,
      callback: onUpdate,
      name: DATA_MARKETS,
      data: data.val()
    });
  });
  markets.once(EVENT_INIT, function () {
    marketDataLoaded = true;
  });

  var contracts = window.firebase.database().ref(REF_CONTRACTS).orderByChild('TimeStamp').startAt((+new Date() / 1000).toFixed(5).toString());

  contracts.on(EVENT_ADDED, function (data) {
    triggerUpdate({
      loaded: contractDataLoaded,
      callback: onUpdate,
      name: DATA_CONTRACTS,
      data: data.val()
    });
  });
  contracts.on(EVENT_CHANGED, function (data) {
    triggerUpdate({
      loaded: contractDataLoaded,
      callback: onUpdate,
      name: DATA_CONTRACTS,
      data: data.val()
    });
  });
  contracts.once(EVENT_INIT, function () {
    contractDataLoaded = true;
  });
};

var setupMessaging = function setupMessaging() {
  if (__WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__["b" /* isAndroid */] || __WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__["c" /* isIos */] || __WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__["d" /* isIE */]) return;

  var messaging = window.firebase.messaging();
  // if (vapidKey) {
  //   log.info('firebase::', 'setting up vapidKey', vapidKey);
  //   messaging.usePublicVapidKey(vapidKey);
  // } else {
  //   log.info('firebase::', 'usePublicVapidKey skipped');
  // }
  __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'setting up messaging');
  messaging.requestPermission().then(function (data) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'permission granted', data);
    messaging.getToken().then(function (token) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'messaging token received');
      if (token) {
        sendTokenToServer(token);
      } else {
        setSentTokenFlag(false);
      }
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'error requesting token', error);
      setSentTokenFlag(false);
    });
    messaging.onTokenRefresh(function () {
      messaging.getToken().then(function (token) {
        __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'messaging token refreshed');
        if (token) {
          setSentTokenFlag(false);
          sendTokenToServer(token);
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'error requesting refresh token', error);
        setSentTokenFlag(false);
      });
    });
  }).catch(function (error) {
    __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].info('firebase::', 'error requesting permission', error);
  });
};

var cleanupMessaging = function cleanupMessaging() {
  return __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].del(MESSAGING_TOKEN_FLAG_NAME);
};



/***/ }),

/***/ "2R3v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObject},[_c('div',{staticClass:"check-option__box"},[_c('form-checkbox',{staticClass:"checkbox--settings-option",attrs:{"label":_vm.obj.info,"name":_vm.checkboxName,"disabled":_vm.disabled},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1),_vm._v(" "),(_vm.withValue)?_c('div',{staticClass:"check-option__input"},[_c('currency-input',{attrs:{"initial":_vm.obj.currencyInitial,"disabled":_vm.disabled,"validate":_vm.obj.validate},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2SRW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_search__ = __webpack_require__("+ZRi");




var SEARCH_BAR_VISIBLE_FOCUS_TIMEOUT = 500;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_search__["a" /* default */]],
  data: function data() {
    return {
      searchQuery: '',
      searchFor: '',
      searchTotal: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('search', ['searchBarVisible']), {
    showSummary: function showSummary() {
      return this.searchTotal === 0;
    },
    summaryClassModifiers: function summaryClassModifiers() {
      return {
        'search-bar__summary': true,
        'search-bar__summary--no-results': !this.searchTotal
      };
    }
  }),
  watch: {
    $route: function $route() {
      if (this.searchBarVisible) {
        this.onClose();
      }
    },
    searchBarVisible: function searchBarVisible(value) {
      var _this = this;

      if (value) {
        setTimeout(function () {
          _this.$refs.searchInput.focus();
        }, SEARCH_BAR_VISIBLE_FOCUS_TIMEOUT);
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('search', ['toggleSearchBar']), {
    onSearchResults: function onSearchResults(data) {
      if (data.totalMarkets > 0) {
        // close when there are results
        this.onClose();
      }
      this.searchTotal = data.totalMarkets;
    },
    onClose: function onClose() {
      this.toggleSearchBar();
      this.searchFor = '';
      this.searchQuery = '';
      this.searchTotal = null;
    },
    onSubmit: function onSubmit() {
      this.searchTotal = null;
      if (this.searchQuery === '') return;
      this.searchFor = this.searchQuery;
      this.doSearch(this.searchQuery);
    }
  })
});

/***/ }),

/***/ "2i1L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2l91":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2uhI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeaderboardsInfoLoader_vue__ = __webpack_require__("OIwd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d73ef1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeaderboardsInfoLoader_vue__ = __webpack_require__("sdj+");
function injectStyle (ssrContext) {
  __webpack_require__("LZHh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeaderboardsInfoLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d73ef1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeaderboardsInfoLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2wsJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_keyboard_numeric_js__ = __webpack_require__("URmk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8bf595_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keyboard_numeric_vue__ = __webpack_require__("CMpb");
function injectStyle (ssrContext) {
  __webpack_require__("TtXC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_keyboard_numeric_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8bf595_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keyboard_numeric_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2x63":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2zfn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_side_notification_js__ = __webpack_require__("4RVP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbf3eb78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_side_notification_vue__ = __webpack_require__("kbwM");
function injectStyle (ssrContext) {
  __webpack_require__("ll9a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_side_notification_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbf3eb78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_side_notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "32Fy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    layout: {
      type: String,
      default: ''
    },
    marketId: {
      type: Number
    },
    isWatched: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: true,
      isOn: this.isWatched
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-watch--' + this.layout, this.layout), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-watch--on', this.isOn), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-watch--off', !this.isOn), _ref;
    },
    title: function title() {
      return this.isOn ? 'Remove from Watchlist' : 'Add to Watchlist';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['addMarketToWatchList', 'removeMarketFromWatchList']), {
    onWatchToggle: function onWatchToggle() {
      var _this = this;

      if (!this.isLoggedIn) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
        return;
      }
      this.show = false;
      if (!this.isOn) {
        this.addMarketToWatchList(this.marketId);
      } else {
        this.removeMarketFromWatchList(this.marketId);
      }
      this.isOn = !this.isOn;
      setTimeout(function () {
        _this.show = true;
      }, 0);
    }
  })
});

/***/ }),

/***/ "32OH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "33FX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_support_videos_videos_vue__ = __webpack_require__("HSd1");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    videos: __WEBPACK_IMPORTED_MODULE_2__components_support_videos_videos_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    showVideos: function showVideos() {
      return !this.isLayoutMobile && !this.isLoggedIn;
    },
    mainColumnModifiers: function mainColumnModifiers() {
      return {
        column: true,
        'small-12': true,
        'large-8': this.showVideos
      };
    },
    mainRowModifiers: function mainRowModifiers() {
      return {
        row: !this.showVideos,
        'row-x': this.showVideos
      };
    }
  })
});

/***/ }),

/***/ "33aF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "34gu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_contract_tile_js__ = __webpack_require__("/KY/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e8b15d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contract_tile_vue__ = __webpack_require__("Ld1m");
function injectStyle (ssrContext) {
  __webpack_require__("InKR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_contract_tile_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e8b15d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contract_tile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3982":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-button",class:_vm.isOnModifier,on:{"click":_vm.toggle}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-button__inner"},[_c('div',{staticClass:"switch-button__toggle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "39kf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var CLASS_IS_LOADING = 'is-loading';

var loaderMixin = {
  data: function data() {
    return {
      isLoading: false
    };
  },

  methods: {
    loaderAdd: function loaderAdd() {
      var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var loadingClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CLASS_IS_LOADING;
      var changeFlag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var target = el || this.$el;
      if (target) {
        target.classList.add(loadingClass);
      }
      if (changeFlag) {
        this.isLoading = true;
      }
    },
    loaderRemove: function loaderRemove() {
      var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var loadingClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CLASS_IS_LOADING;
      var changeFlag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var target = el || this.$el;
      if (target) {
        target.classList.remove(loadingClass);
      }
      if (changeFlag) {
        this.isLoading = false;
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (loaderMixin);

/***/ }),

/***/ "3CaU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wallet_pending_requests_pending_request_pending_request_vue__ = __webpack_require__("cUo6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_contentLoader__ = __webpack_require__("P71F");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_contentLoader__["a" /* default */]],
  components: {
    pendingRequest: __WEBPACK_IMPORTED_MODULE_2__components_wallet_pending_requests_pending_request_pending_request_vue__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    this.getPendingWithdrawals().then(function () {
      _this.isComponentReady = true;
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['pendingRequests'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['getPendingWithdrawals']), {
    onSuccess: function onSuccess() {
      this.getPendingWithdrawals();
    }
  })
});

/***/ }),

/***/ "3GDC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_filter_button_js__ = __webpack_require__("JSIy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64382212_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filter_button_vue__ = __webpack_require__("Wxlj");
function injectStyle (ssrContext) {
  __webpack_require__("Mo4z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_filter_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64382212_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filter_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3PvP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_available_balance_js__ = __webpack_require__("AsO2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c53cfea8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_available_balance_vue__ = __webpack_require__("UjwH");
function injectStyle (ssrContext) {
  __webpack_require__("kI67")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_available_balance_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c53cfea8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_available_balance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3TJo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"plus-minus-sign"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3USW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_upload_document_js__ = __webpack_require__("MluJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ceb4e61e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_upload_document_vue__ = __webpack_require__("ROoR");
function injectStyle (ssrContext) {
  __webpack_require__("clCm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_upload_document_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ceb4e61e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_upload_document_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Uxo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_home_old_js__ = __webpack_require__("+1tr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143341e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_old_vue__ = __webpack_require__("wlxR");
function injectStyle (ssrContext) {
  __webpack_require__("fSu0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_home_old_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143341e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_old_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3YBe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer-old"},[_c('div',{staticClass:"footer-old__logos"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"footer-old__logo-item"},[_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":item.href,"title":item.title}},[_c('img',{attrs:{"src":item.icon}})])])}),0),_vm._v(" "),_c('div',[(!_vm.isUserRestricted)?_c('div',{staticClass:"footer-old__links"},[_c('router-link',{staticClass:"footer-old__links--item",attrs:{"to":{ name: 'terms-and-conditions', params: { noPopup: true } }}},[_vm._v("\n        Terms and Conditions\n      ")]),_vm._v(" "),_c('router-link',{staticClass:"footer-old__links--item",attrs:{"to":{ name: 'privacy-policy', params: { noPopup: true } }}},[_vm._v("\n        Privacy Policy\n      ")]),_vm._v(" "),_c('router-link',{staticClass:"footer-old__links--item",attrs:{"to":{ name: 'sitemap' }}},[_vm._v("\n        Site Map\n      ")]),_vm._v(" "),_c('router-link',{staticClass:"footer-old__links--item",attrs:{"to":{ name: 'HelpAndSupport' }}},[_vm._v("\n        Support\n      ")]),_vm._v(" "),_c('router-link',{staticClass:"footer-old__links--item",attrs:{"to":{ name: 'platform-announcements' }}},[_vm._v("\n        Announcements\n      ")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"footer-old__content"},[_vm._v("\n      Predictit.org is an experimental project operated for academic purposes under permission from the CFTC.\n      "),_c('br'),_vm._v(" "),_c('a',{staticClass:"footer-old__links--item",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onLearnMore($event)}}},[_vm._v("Learn More")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n      Copyright © "+_vm._s((new Date()).getFullYear())+" PredictIt. All rights reserved.\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Zmp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"animated-number"},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('span',{key:_vm.value,staticClass:"animated-number__value"},[_vm._v(_vm._s(_vm.value)+"¢")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3cKl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_main_nav_js__ = __webpack_require__("ASm9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a3a1406_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_main_nav_vue__ = __webpack_require__("Eu6z");
function injectStyle (ssrContext) {
  __webpack_require__("922l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_main_nav_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a3a1406_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_main_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3ggI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_textarea_js__ = __webpack_require__("09V6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3875e431_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_textarea_vue__ = __webpack_require__("rmxY");
function injectStyle (ssrContext) {
  __webpack_require__("B1Dv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_textarea_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3875e431_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_textarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3iU4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['clearRefreshToken', 'setUseDisqus', 'loginDisqus', 'logoutDisqus'])),
  created: function created() {
    var _this = this;

    if (this.$route.name === 'disqus-logout') {
      this.logoutDisqus().then(function () {
        _this.setUseDisqus(false);
        _this.$router.push({
          name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["C" /* smartatob */])(_this.$route.params.routeName),
          params: JSON.parse(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["C" /* smartatob */])(_this.$route.params.routeParams))
        });
      });
    } else if (this.isLoggedIn) {
      // remember that from now onwards we should login with disqus
      this.loginDisqus().then(function () {
        _this.setUseDisqus(true);
        setTimeout(function () {
          window.close();
        }, 1000);
      });
    } else {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
    }
  }
});

/***/ }),

/***/ "3mSF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_bank_transfer_js__ = __webpack_require__("NPa3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e18e9e6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bank_transfer_vue__ = __webpack_require__("IExX");
function injectStyle (ssrContext) {
  __webpack_require__("k+5b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_bank_transfer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e18e9e6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bank_transfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3whs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-sitemap"},[_c('div',{staticClass:"page-sitemap__header"},[_vm._v("\n    Site Map\n  ")]),_vm._v(" "),(_vm.sitemap !== null)?_c('div',{staticClass:"page-sitemap__content"},[_c('div',{staticClass:"row row-x"},_vm._l((_vm.filteredGroups),function(group){return _c('div',{staticClass:"column small-12 medium-3 end"},[_c('router-link',{staticClass:"page-sitemap__group-title",attrs:{"to":group.url,"tag":"div"}},[_vm._v("\n          "+_vm._s(group.name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"page-sitemap__group-links"},_vm._l((group.items),function(item){return _c('a',{staticClass:"page-sitemap__group-link",attrs:{"href":item.url}},[_vm._v("\n            "+_vm._s(item.name)+"\n          ")])}),0)],1)}),0)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3wpX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_loader__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('profile', ['userAffiliations', 'isUCAffilSet'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('profile', ['getUserAffiliations']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup', 'setCurrentPopup', 'setCurrentPopupOptions']), {
    showAffiliationsPopup: function showAffiliationsPopup() {
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
        return;
      }
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].AFFILIATIONS);
      this.setCurrentPopupOptions({ allowClose: true });
    },
    onInfoClick: function onInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_PUBLIC_PROFILE_INFO);
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.loaderAdd();
    this.getUserAffiliations().then(function () {
      return _this.loaderRemove();
    }).catch(function () {
      return _this.loaderRemove();
    });
  }
});

/***/ }),

/***/ "3yfD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");






var PROGRESS_LEFT_RIGHT_THRESHOLD = 15;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    avatarTheme: function avatarTheme() {
      return this.isLayoutDesktop ? 'large' : '';
    },
    username: function username() {
      return this.userData && this.userData.userName ? '' + this.userData.userName : '';
    },
    backgroundModifiers: function backgroundModifiers() {
      var num = this.level.num;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'account-social-badge': true
      }, 'account-social-badge--level-' + num, num);
    },
    progressBarStyleModifiers: function progressBarStyleModifiers() {
      return {
        width: this.progressPercentage + '%'
      };
    },
    progressBarClassModifiers: function progressBarClassModifiers() {
      return {
        'account-social-badge__progress-num': true,
        'account-social-badge__progress-num--left': this.progressPercentage > PROGRESS_LEFT_RIGHT_THRESHOLD,
        'account-social-badge__progress-num--right': this.progressPercentage <= PROGRESS_LEFT_RIGHT_THRESHOLD
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    showBadgesPopup: function showBadgesPopup() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_BADGES);
    }
  })
});

/***/ }),

/***/ "4+3v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboards-toolbar"},[(_vm.isLayoutMobile)?_c('div',{staticClass:"leaderboards-toolbar__title"},[(_vm.backButton)?_c('div',{staticClass:"leaderboards-toolbar__back",on:{"click":function($event){return _vm.$emit('back')}}}):_vm._e(),_vm._v(" "),_c('div',[_vm._v("\n      "+_vm._s(_vm._f("pluralize")(_vm.title))+"\n    ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"leaderboards-toolbar__form"},[(false)?_c('form-select',{staticClass:"leaderboards-toolbar__form-item",attrs:{"searchable":false,"placeholder":"Type","options":_vm.typeOptions,"track-by":"value","label":"label"},model:{value:(_vm.filter.type),callback:function ($$v) {_vm.$set(_vm.filter, "type", $$v)},expression:"filter.type"}}):_vm._e(),_vm._v(" "),_c('form-select',{staticClass:"leaderboards-toolbar__form-item",attrs:{"small":_vm.isLayoutMobile,"searchable":false,"options":_vm.timeOptions,"track-by":"value","label":"label"},model:{value:(_vm.filter.time),callback:function ($$v) {_vm.$set(_vm.filter, "time", $$v)},expression:"filter.time"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4/Ye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    text: {
      type: String
    },
    reversed: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('showPopup');
    }
  }
});

/***/ }),

/***/ "4/yT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('h2',{staticClass:"purchase-quantity-value__header"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"purchase-quantity-value__wrap"},[_c('button',{staticClass:"purchase-quantity-value__button purchase-quantity-value__button--left",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.subtract($event)}}},[_vm._v("-"+_vm._s(_vm.threshold))]),_vm._v(" "),_c('div',{staticClass:"purchase-quantity-value__box"},[(_vm.kind === 'modal')?_c('keyboard-numeric-input',{attrs:{"value":_vm.val,"selected":_vm.selected},on:{"click":_vm.click},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],staticClass:"purchase-quantity-value__input",attrs:{"tabindex":_vm.tabindex,"maxlength":"4","placeholder":""},domProps:{"value":(_vm.val)},on:{"blur":function($event){return _vm.$emit('blur')},"focus":function($event){return _vm.$emit('focus')},"input":function($event){if($event.target.composing){ return; }_vm.val=$event.target.value}}})],1),_vm._v(" "),_c('button',{staticClass:"purchase-quantity-value__button purchase-quantity-value__button--right",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.add($event)}}},[_vm._v("+"+_vm._s(_vm.threshold))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4EoQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_disqus_js__ = __webpack_require__("cz2j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57199795_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_disqus_vue__ = __webpack_require__("CSqp");
function injectStyle (ssrContext) {
  __webpack_require__("Jt46")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_disqus_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57199795_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_disqus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4OEB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_cash_js__ = __webpack_require__("9rUd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a028d7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_cash_vue__ = __webpack_require__("U9bD");
function injectStyle (ssrContext) {
  __webpack_require__("+OSe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_cash_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a028d7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_cash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4RI/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_collapsible_panel_collapsible_panel_vue__ = __webpack_require__("NMl0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_collapsible_panel_components_collapsible_panel_simple_collapsible_panel_simple_vue__ = __webpack_require__("gYkw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_support_faq_search_input_faq_search_input_vue__ = __webpack_require__("ZvSa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_support__ = __webpack_require__("33FX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_loader__ = __webpack_require__("39kf");












/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_support__["a" /* default */]],
  props: {
    title: {
      type: String,
      default: 'FAQs'
    },
    minLength: {
      type: Number,
      default: 2
    },
    triggerNavigateToHelpAndSupport: {
      type: Boolean,
      default: true
    }
  },
  components: {
    collapsiblePanel: __WEBPACK_IMPORTED_MODULE_3__components_collapsible_panel_collapsible_panel_vue__["a" /* default */],
    collapsiblePanelSimple: __WEBPACK_IMPORTED_MODULE_4__components_collapsible_panel_components_collapsible_panel_simple_collapsible_panel_simple_vue__["a" /* default */],
    faqSearchInput: __WEBPACK_IMPORTED_MODULE_5__components_support_faq_search_input_faq_search_input_vue__["a" /* default */],
    contentHeader: __WEBPACK_IMPORTED_MODULE_6__components_generics_content_header_content_header_vue__["a" /* default */]
  },
  data: function data() {
    return {
      searchTerm: '',
      noResultFound: false,
      reg: [],
      expanded: false,
      accordion: null,
      accordionQA: null
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Support'
    };
  },

  // watch: {
  //   isLayoutMobile(value) {
  //     if (!value && this.triggerNavigateToHelpAndSupport) {
  //       this.$router.push({ name: 'HelpAndSupport' });
  //     }
  //   },
  // },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('about', ['faqs']), {
    filteredFAQs: function filteredFAQs() {
      this.expanded = false;
      if (this.$route.params.faqid === 666) {
        this.expanded = true;
        this.searchTerm = 'how do you calculate risk in multi';
      }
      var formatTitle = function formatTitle(title, count) {
        return title + ' [' + count + ']';
      };
      if (this.faqs === null) {
        return [];
      }
      if (this.searchTerm === '') {
        this.noResultFound = this.faqs.length === 0;
        // just mapping category names to add [items.count] to name
        return this.faqs.map(function (category) {
          return {
            name: formatTitle(category.name, category.faqs.length),
            faqs: category.faqs,
            id: category.id
          };
        });
      }
      var reg = this.getRegexp(this.searchTerm);
      // reducing categories depending on filtered QA in them
      var newCategories = this.faqs.reduce(function (previouse, category) {
        var filteredQA = category.faqs.filter(function (qa) {
          return reg.test(qa.title) || reg.test(qa.description_text);
        });
        if (filteredQA.length > 0) {
          previouse.push({
            name: formatTitle(category.name, filteredQA.length),
            faqs: filteredQA,
            id: category.id
          });
        }
        return previouse;
      }, []);
      this.noResultFound = newCategories.length === 0;
      return newCategories;
    },
    isEmpty: function isEmpty() {
      return this.noResultFound;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('about', ['getFaqs']), {
    updateSearch: function updateSearch(term) {
      this.searchTerm = term.length >= this.minLength ? term.toLowerCase() : '';
    },
    initializeComponentWithSearchTerm: function initializeComponentWithSearchTerm(term) {
      var _this = this;

      this.updateSearch(term);
      this.$nextTick(function () {
        _this.expanded = true;
        _this.accordion = 'faq-0';
        _this.accordionQA = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(_this.filteredFAQs, '[0].faqs[0].id');
      });
    },
    getRegexp: function getRegexp(term) {
      if (!this.reg[term]) {
        this.reg[term] = new RegExp(term, 'im');
      }
      return this.reg[term];
    },
    accordionOpen: function accordionOpen(e) {
      this.accordion = e;

      if (e !== null) {
        setTimeout(function () {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_scrollTo__["a" /* default */])(document.getElementById(e), 0);
        }, 50);
      }
    },
    accordionOpenQA: function accordionOpenQA(e) {
      this.accordionQA = e;
    }
  }),
  created: function created() {
    var _this2 = this;

    // if (store.state.app.layout === 'desktop' && this.triggerNavigateToHelpAndSupport) {
    //   this.$router.push({ name: 'HelpAndSupport' });
    // }
    this.loaderAdd(document.body);
    this.getFaqs().then(function () {
      return _this2.loaderRemove(document.body);
    }).catch(function () {
      return _this2.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "4RVP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logger__ = __webpack_require__("G/BR");






var levels = ['success', 'danger', 'warning', 'info'];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    level: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        return levels.indexOf(value) !== -1;
      }
    },
    autoClose: {
      type: Boolean,
      required: false,
      default: true
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
    },
    onCloseCallback: {
      default: null
    },
    text: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      interacted: false
    };
  },

  computed: {
    showIcon: function showIcon() {
      return ['danger', 'success'].includes(this.level);
    },
    contentModifiers: function contentModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'side-notification__content': true
      }, 'side-notification__content--' + this.level, this.level);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['clearSideNotification']), {
    onClose: function onClose() {
      this.clearSideNotification();
      if (typeof this.onCloseCalback !== 'undefined' && this.oncloseCallback !== null) {
        this.onCloseCalback.apply(this);
      }
    },
    onInteract: function onInteract() {
      this.interacted = true;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.$el.addEventListener('click', function () {
      return _this.onInteract();
    });
    if (this.autoClose && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__logger__["b" /* isDebugOn */])()) {
      this.timeout = setTimeout(function () {
        _this.onClose();
      }, this.closeTimeout);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
});

/***/ }),

/***/ "4blE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_catchHtmlClickMixin__ = __webpack_require__("xO2F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_support_faq_faq_vue__ = __webpack_require__("ZIhC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_support__ = __webpack_require__("33FX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__("oiih");










var DEFAULT_TITLE = 'What is PredictIt?';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__helpers_catchHtmlClickMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_support__["a" /* default */]],
  props: {
    title: {
      type: String,
      default: DEFAULT_TITLE
    }
  },
  components: {
    contentHeader: __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__["a" /* default */],
    faq: __WEBPACK_IMPORTED_MODULE_4__components_support_faq_faq_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Support'
    };
  },
  data: function data() {
    return {
      topBasics: [{
        name: DEFAULT_TITLE,
        text: ''
      }]
    };
  },

  computed: {
    topics: function topics() {
      return this.isLayoutMobile ? [] : [this.topBasics[0]];
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    openResearch: function openResearch() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_app_modals__["a" /* MODALS */].RESEARCH);
    }
  }),
  created: function created() {
    var _this = this;

    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_8__constants__["b" /* STATIC_PAGES */].WHAT_IS).then(function (data) {
      _this.installDynamicControls({ data: data });
    });
  }
});

/***/ }),

/***/ "4km3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-panel",class:_vm.wrapperModifier},[_c('div',{staticClass:"collapsible-panel__header",class:_vm.darkHeaderModifier,on:{"click":_vm.toggle}},[(_vm.hasSlotTitle)?_c('div',{staticClass:"collapsible-panel__header-text"},[_vm._t("title")],2):_vm._e(),_vm._v(" "),(!_vm.hasSlotTitle)?_c('div',{staticClass:"collapsible-panel__header-text",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e()]),_vm._v(" "),(_vm.isOpenState)?_c('div',{staticClass:"collapsible-panel__content",class:_vm.noPaddingModifier},[(_vm.hasSlotContent)?[_vm._t("default")]:[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4kpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_not_found_js__ = __webpack_require__("urbP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e962b44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_not_found_vue__ = __webpack_require__("vTdY");
function injectStyle (ssrContext) {
  __webpack_require__("I6xq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_not_found_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e962b44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_not_found_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4n2q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('div',{class:_vm.menuClassModifier},[_c('div',{staticClass:"market-filters-desktop-grid__menu-filters"},[_c('menu-button',{attrs:{"theme":"light","type":"filters","name":_vm.filterMenuName,"active":_vm.filtersOpen,"arrow":true},on:{"click":_vm.toggleFilters}})],1),_vm._v(" "),(_vm.shouldShowTimespanFilter)?_c('div',{staticClass:"market-filters-desktop-grid__menu-timespan"},[_c('menu-button',{attrs:{"theme":"light","type":"timespan","name":_vm.selectedTimespan.name,"active":_vm.timespansOpen,"arrow":true},on:{"click":_vm.toggleTimespans}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-filters-desktop-grid__menu-order"},[_c('span',[_vm._v("Sort By:")]),_vm._v(" "),_c('menu-button',{attrs:{"theme":"light","type":_vm.selectedOrder.sort,"name":_vm.orderMenuName,"active":_vm.ordersOpen,"arrow":true},on:{"click":_vm.toggleOrder}})],1)]),_vm._v(" "),(_vm.ordersOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-desktop-grid__order"},_vm._l((_vm.orderList('markets')),function(order){return _c('menu-button',{key:order.sort,attrs:{"type":order.sort,"name":order.fullName,"selected":_vm.orderSelected(order.sort),"typeThemeEnabled":true},on:{"click":_vm.selectOrderAndClose}})}),1):_vm._e(),_vm._v(" "),(_vm.filtersOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-desktop-grid__filters"},[_c('a',{staticClass:"market-filters-desktop-grid__clear-all",on:{"click":function($event){$event.preventDefault();return _vm.onClearFilters($event)}}},[_vm._v("Clear Selections")]),_vm._v(" "),_vm._l((_vm.filters),function(category){return _c('div',{staticClass:"market-filters-desktop-grid__filters-group"},[_c('h3',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_vm._l((category.filters),function(filter){return _c('filter-button',{key:_vm.filterKey(filter),attrs:{"id":filter.filterId,"name":filter.name,"selected":_vm.filterSelected(filter.filterId)},on:{"addFilter":_vm.onAddFilter,"removeFilter":_vm.onRemoveFilter}})})],2)})],2):_vm._e(),_vm._v(" "),(_vm.timespansOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-desktop-grid__timespans"},_vm._l((_vm.availableTimespanOptions),function(timespan){return _c('menu-button',{key:timespan.parameter,attrs:{"type":timespan.parameter,"name":timespan.name},on:{"click":_vm.selectTimespanAndClose}})}),1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4ntM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4opG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-social-auth"},[_c('div',{staticClass:"account-social-auth__spinner"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4p0o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_most_predicted_list_js__ = __webpack_require__("Zi8f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ec04238_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_most_predicted_list_vue__ = __webpack_require__("CPMw");
function injectStyle (ssrContext) {
  __webpack_require__("d1Ib")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_most_predicted_list_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ec04238_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_most_predicted_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4pyq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_header_js__ = __webpack_require__("Ufge");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db730be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("93E7");
function injectStyle (ssrContext) {
  __webpack_require__("eNZS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db730be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4vD6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_biggest_gains_element_js__ = __webpack_require__("OLUT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_761997e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_biggest_gains_element_vue__ = __webpack_require__("eaFd");
function injectStyle (ssrContext) {
  __webpack_require__("qniv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_biggest_gains_element_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_761997e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_biggest_gains_element_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5/dB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tabs",class:("tabs--" + _vm.theme)},_vm._l((_vm.items),function(item){return _c('li',{class:_vm.tabItemModifiers(item),on:{"click":function($event){$event.preventDefault();return _vm.onChange(item.name)}}},[_c('a',{class:_vm.tabLinkModifiers(item),attrs:{"href":"#"}},[(item.icon)?[_c('span',{class:_vm.tabIconModifiers(item)})]:[_vm._v("\n        "+_vm._s(item.title)+"\n      ")]],2)])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "526r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_marketHeader__ = __webpack_require__("rbjD");


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_marketHeader__["a" /* default */]],
  computed: {
    classModifier: function classModifier() {
      return {
        'market-header-title-large__header': true,
        'market-header-title-large__header--right-padding': this.watchIconVisible
      };
    }
  },
  methods: {
    onClick: function onClick() {}
  }
});

/***/ }),

/***/ "54E+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    theme: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isOn: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('dashboard', ['mySharesCount']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'dashboard-markets-toggle': true
      }, 'dashboard-markets-toggle--' + this.theme, this.theme);
    },
    buttonText: function buttonText() {
      return this.isOn ? 'Close All' : 'Open All';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('dashboard', ['setMarketsToggle']), {
    onClick: function onClick() {
      this.isOn = !this.isOn;
      this.setMarketsToggle(this.isOn);
    }
  })
});

/***/ }),

/***/ "5MMF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__ = __webpack_require__("gnYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_balance_history_balance_history_item_balance_history_item_vue__ = __webpack_require__("FSWW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_staticConf_utils__ = __webpack_require__("RZM5");









var NO_ITEMS_MESSAGE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__mixins_staticConf_utils__["a" /* $txt */])('balance-history.no-items');
var NO_MORE_ITEMS_MESSAGE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__mixins_staticConf_utils__["a" /* $txt */])('balance-history.no-more-items');

var BASIC_COLUMN_SET = ['DEPOSITS', 'PROMOTIONS'];

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_contentLoader__["a" /* default */]],
  props: {
    type: {
      type: String
    },
    items: {
      type: Array
    },
    canLoadMore: {
      type: Boolean,
      default: true
    }
  },
  components: {
    balanceHistoryItem: __WEBPACK_IMPORTED_MODULE_4__components_balance_history_balance_history_item_balance_history_item_vue__["a" /* default */],
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a
  },
  data: function data() {
    return {
      loadedInfo: NO_ITEMS_MESSAGE,
      infiniteLoader: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    loaderNum: function loaderNum() {
      return this.isLayoutMobile ? 2 : 5;
    },
    stickyOptions: function stickyOptions() {
      return this.isLayoutMobile ? __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__["a" /* default */].mobile : __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__["a" /* default */].desktop;
    },
    showAdditionalColumns: function showAdditionalColumns() {
      return !BASIC_COLUMN_SET.includes(this.type) && this.isLayoutDesktop;
    },
    amountColumnModifiers: function amountColumnModifiers() {
      return {
        column: true,
        'text-center': true,
        'small-4': !this.showAdditionalColumns,
        'small-2': this.showAdditionalColumns
      };
    },
    typeColumnModifiers: function typeColumnModifiers() {
      return {
        column: true,
        'text-left': true,
        'small-4': !this.showAdditionalColumns,
        'small-3': this.showAdditionalColumns
      };
    },
    statusColumnModifiers: function statusColumnModifiers() {
      return {
        column: true,
        'text-right': true,
        'small-4': !this.showAdditionalColumns,
        'small-3': this.showAdditionalColumns
      };
    }
  }),
  watch: {
    items: function items() {
      this.isComponentReady = true;
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        if (!this.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }
      this.loadedInfo = this.items.length > 0 ? NO_MORE_ITEMS_MESSAGE : NO_ITEMS_MESSAGE;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    onFeeInfoClick: function onFeeInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_FEE_INFO);
    },
    goInfinite: function goInfinite(infi) {
      this.infiniteLoader = infi;
      this.$emit('loading', infi);
    }
  })
});

/***/ }),

/***/ "5RCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    shutdown: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClick: function onClick() {
      if (this.shutdown) {
        window.location.href = 'https://twitter.com/PredictIt';
      } else {
        this.$router.push({ name: 'research' });
      }
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'research-widget': true
      }, 'research-widget--' + this.theme, this.theme);
    }
  }
});

/***/ }),

/***/ "5V1p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_prices_js__ = __webpack_require__("d4Dm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1761ebb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_prices_vue__ = __webpack_require__("rGOk");
function injectStyle (ssrContext) {
  __webpack_require__("rixl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_prices_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1761ebb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_prices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5aqh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationLoader_vue__ = __webpack_require__("U7LV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a70aaa8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationLoader_vue__ = __webpack_require__("rEh3");
function injectStyle (ssrContext) {
  __webpack_require__("PiJZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a70aaa8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5f2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_getValidationMessage__ = __webpack_require__("U7Hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_catchHtmlClickMixin__ = __webpack_require__("xO2F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_instant_credit__ = __webpack_require__("zAJv");











/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_7__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__helpers_catchHtmlClickMixin__["a" /* default */]],
  validations: {
    fields: {
      firstName: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].onlyCharacters,
      lastName: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].onlyCharacters,
      dateOfBirthDay: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required,
      dateOfBirthMonth: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required,
      dateOfBirthYear: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].validateIsAdult('dateOfBirthMonth', 'dateOfBirthDay'),
      street: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required,
      city: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].onlyCharacters,
      zipCode: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].validateUSZipCode('country'),
      country: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required,
      nscbStatus: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].validatenNscbStatus('country')
    }
  },
  data: function data() {
    return {
      ready: false,
      years: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].birthYears,
      months: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].months,
      days: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].days,
      countryID: null,
      disclaimer: '',
      countries: [],
      showNscbStatusExplanation: false,
      fields: {
        nscbStatus: false,
        firstName: '',
        lastName: '',
        dateOfBirthDay: '',
        dateOfBirthMonth: '',
        dateOfBirthYear: '',
        street: '',
        city: '',
        zipCode: '',
        country: ''
      }
    };
  },
  created: function created() {
    var _this = this;

    this.getVerifyID().then(function (response) {
      var data = response.data;
      _this.disclaimer = data.disclaimer;
      _this.countryID = data.countryID;
      _this.countries = data.countryList.map(function (el) {
        return {
          required: el.validatePostalCode,
          label: el.countryName,
          value: el.countryCode
        };
      });
      if (_this.countryID) {
        _this.fields.country = _this.countries.find(function (i) {
          return i.value === _this.countryID;
        }) || '';
      } else if (_this.countries.length === 1) {
        _this.fields.country = _this.countries[0];
      }
      if (_this.formDataCache !== null) {
        _this.fields = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.fields, _this.formDataCache);
      }
      _this.ready = true;
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('popup', ['formDataCache']), {
    showNoSolicitingNotice: function showNoSolicitingNotice() {
      return this.isNotUnitedStates;
    },
    isNotUnitedStates: function isNotUnitedStates() {
      return this.fields.country && this.fields.country.value && this.fields.country.value !== 'US';
    },
    isSubmitButtonDisabled: function isSubmitButtonDisabled() {
      return this.invalidOrDisabled;
    },
    errorNotAdult: function errorNotAdult() {
      var field = this.$v.fields.dateOfBirthYear;
      return field.$error ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_getValidationMessage__["a" /* default */])(field) : '';
    },
    zipCodeModifier: function zipCodeModifier() {
      return {
        column: true,
        'small-6': this.countries.length > 0,
        'small-12': this.countries.length === 0
      };
    },
    countriesModifier: function countriesModifier() {
      return {
        column: true,
        'small-6': this.countries.length > 0
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getVerifyID', 'verifyID', 'getAccountDetail', 'logout']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopupWithDelay', 'cacheFormData', 'setCurrentPopup', 'setCurrentPopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('wallet', ['getBalance']), {
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'ID Verification',
        action: 'submit',
        label: 'ID Verify Next'
      });
      if (this.formIsValid() && this.formDisable()) {
        var payload = {
          firstName: this.fields.firstName,
          lastName: this.fields.lastName,
          birthDay: this.fields.dateOfBirthDay.value,
          birthMonth: this.fields.dateOfBirthMonth.value,
          birthYear: this.fields.dateOfBirthYear.value,
          address1: this.fields.street,
          city: this.fields.city,
          postalCode: this.fields.zipCode,
          countryID: this.fields.country.value
        };
        if (this.showNoSolicitingNotice) {
          payload.nscbStatus = this.fields.nscbStatus ? 1 : 0;
        } else {
          payload.nscbStatus = -1;
        }
        this.verifyID(payload).then(function (data) {
          if (_this2.isNotUnitedStates) {
            window.location.href = data;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('');
          }
          return _this2.formEnable();
        }).then(this.getAccountDetail).then(function () {
          _this2.$gtm.trackEvent({ event: 'PassIDV' });
          _this2.cacheFormData({});
          _this2.setCurrentPopupWithDelay({
            name: __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS,
            options: {
              checkInstantCredit: __WEBPACK_IMPORTED_MODULE_9__services_instant_credit__["a" /* default */].checkIfCanRunAfterVerification()
            }
          });
          _this2.getBalance();
        }).catch(function (error) {
          _this2.$gtm.trackEvent({ event: 'FailIDV' });
          _this2.formHandleErrors(error);
        });
      }
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.cacheFormData(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.fields));
  }
});

/***/ }),

/***/ "5g2X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wallet_withdraw_confirm_withdraw_confirm_vue__ = __webpack_require__("waMS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wallet_available_balance_available_balance_vue__ = __webpack_require__("3PvP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_notification_icon_notification_icon_vue__ = __webpack_require__("qIn7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");















var DEFAULT_ACCOUNT_TYPE = '1';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["b" /* formMixin */]],
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_5__components_generics_alert_box_alert_box_vue__["a" /* default */],
    availableBalance: __WEBPACK_IMPORTED_MODULE_6__components_wallet_available_balance_available_balance_vue__["a" /* default */],
    notificationIcon: __WEBPACK_IMPORTED_MODULE_7__components_notification_icon_notification_icon_vue__["a" /* default */],
    withdrawConfirm: __WEBPACK_IMPORTED_MODULE_4__components_wallet_withdraw_confirm_withdraw_confirm_vue__["a" /* default */]
  },
  data: function data() {
    return {
      newAccountMode: true,
      showConfirmation: false,
      error: '',
      fields: {
        amount: '',
        routingNumber: '',
        accountNumber: '',
        accountType: DEFAULT_ACCOUNT_TYPE
      }
    };
  },
  validations: function validations() {
    if (this.newAccountMode) {
      return {
        fields: {
          accountNumber: __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["a" /* validators */].accountNumber,
          routingNumber: __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["a" /* validators */].routingNumber,
          amount: __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["a" /* validators */].withdrawalAmount(this.minWithdrawal, this.maxWithdrawal)
        }
      };
    }
    return {
      fields: {
        amount: __WEBPACK_IMPORTED_MODULE_8__components_forms_mixin__["a" /* validators */].withdrawalAmount(this.minWithdrawal, this.maxWithdrawal)
      }
    };
  },
  created: function created() {
    this.checkWithdrawAch();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('wallet', ['ach']), {
    accountTypes: function accountTypes() {
      var _this = this;

      var results = [];
      if (!this.ach || !this.ach.bankAccountTypes) return results;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.ach.bankAccountTypes).forEach(function (index) {
        var label = _this.ach.bankAccountTypes[index];
        if (label !== 'Unknown') {
          results.push({ index: index, label: label });
        }
      });
      return results;
    },
    accountDetails: function accountDetails() {
      var data = {
        routingNumber: this.fields.routingNumber,
        accountNumber: this.fields.accountNumber,
        accountType: this.fields.accountType,
        accountTypeLabel: this.accountTypeLabel
      };
      if (!this.newAccountMode) {
        data.accountId = this.ach.accountAchDetailId;
        data.accountLastFourDigits = this.ach.achAccountNumberLastFour;
      }

      return data;
    },
    accountTypeLabel: function accountTypeLabel() {
      var _this2 = this;

      if (this.accountTypes.length === 0) return '';
      return this.accountTypes.filter(function (item) {
        return item.index === _this2.fields.accountType;
      })[0].label;
    },
    availableBalance: function availableBalance() {
      return this.ach && this.ach.availableFundsString ? this.ach.availableFundsString : '$0.00';
    },
    restrictedFunds: function restrictedFunds() {
      return this.ach && this.ach.restrictedFundsString ? this.ach.restrictedFundsString : '';
    },
    minWithdrawal: function minWithdrawal() {
      return this.maxWithdrawal > 0 ? 1 : 0;
    },
    maxWithdrawal: function maxWithdrawal() {
      return this.ach ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["v" /* roundDown */])(this.ach.availableFunds) : 0;
    },
    isAmountFieldDisabled: function isAmountFieldDisabled() {
      return this.minWithdrawal < 1 || this.maxWithdrawal < 1;
    },
    errorMessage: function errorMessage() {
      return this.error || this.ach.errorMessage;
    },
    hasErrorMessage: function hasErrorMessage() {
      return this.error || !!this.ach.errorMessage;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('wallet', ['getWithdrawAch']), {
    onSubmit: function onSubmit() {
      this.showConfirmation = true;
    },
    onSuccess: function onSuccess() {
      this.fields.amount = '';
      this.fields.routingNumber = '';
      this.fields.accountNumber = '';
      this.fields.accountType = DEFAULT_ACCOUNT_TYPE;
      this.showConfirmation = false;
      // this.$nextTick(() => { this.$v.$reset(); });
      this.checkWithdrawAch();
      this.$emit('success');
    },
    onEdit: function onEdit() {
      this.showConfirmation = false;
    },
    onChangeAccount: function onChangeAccount() {
      this.newAccountMode = true;
    },
    showRoutingNumberModal: function showRoutingNumberModal() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_ROUTING_NUMBER);
    },
    checkWithdrawAch: function checkWithdrawAch() {
      var _this3 = this;

      this.getWithdrawAch().then(function (data) {
        _this3.checkDocumentUploadFlags(data);
        _this3.newAccountMode = !data.hasSavedAccount;
        _this3.isComponentReady = true;
      }).catch(function (error) {
        _this3.isComponentReady = true;
        _this3.error = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(error, 'response.data.message', '');
      });
    }
  })
});

/***/ }),

/***/ "5inO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"notification-item-simple__container"},[_c('div',{staticClass:"row row-100"},[_c('div',{staticClass:"column small-2 column-100 column-valign"},[_c('div',{staticClass:"notification-item-simple__icon"},[(_vm.icon === 'pending')?_c('img',{attrs:{"src":__webpack_require__("U+El")}}):_vm._e(),_vm._v(" "),(_vm.icon === 'cancel')?_c('img',{attrs:{"src":__webpack_require__("VM/5")}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"column small-9 medium-8 column-100 column-valign"},[_vm._v("\n        "+_vm._s(_vm.text)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"column small-1 medium-2 text-center column-100"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.closeButton),expression:"closeButton"}],staticClass:"notification-item-simple__close",on:{"click":_vm.onClose}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5oDx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5r1F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_bank_account_js__ = __webpack_require__("h/F2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11629c56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bank_account_vue__ = __webpack_require__("w4tW");
function injectStyle (ssrContext) {
  __webpack_require__("tSuy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_bank_account_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11629c56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bank_account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5wJI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5y3J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    colorDisabled: {
      type: String,
      default: '#263b1e'
    },
    color: {
      type: String,
      default: '#000000'
    },
    name: {
      type: String,
      required: true
    },
    checked: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: true
    };
  },

  computed: {
    classModifiers: function classModifiers() {
      return {
        'charts-checkbox': true,
        'charts-checkbox--checked': this.checked
      };
    },
    tickClassModifiers: function tickClassModifiers() {
      return {
        'charts-checkbox__tick': true,
        'charts-checkbox__tick--checked': this.checked
      };
    },
    styleModifiers: function styleModifiers() {
      var color = this.checked ? this.color : this.colorDisabled;
      return {
        border: 'solid 2px ' + color
      };
    }
  },
  methods: {
    onChange: function onChange(e) {
      var _this = this;

      this.show = false;
      this.$emit('change', e.target.checked);
      setTimeout(function () {
        _this.show = true;
      }, 0);
    }
  }
});

/***/ }),

/***/ "5yVZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_v2_market_contract_horizontal_v2_market_contract_horizontal_v2_vue__ = __webpack_require__("p+B/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    market: {
      type: Object,
      required: true
    }
  },
  components: {
    marketContract: __WEBPACK_IMPORTED_MODULE_2__components_market_v2_market_contract_horizontal_v2_market_contract_horizontal_v2_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onContractClick: function onContractClick(data) {
      if (!this.isLoggedIn) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
      } else {
        var contractId = data.contractId;

        this.$router.push({
          name: 'market-details',
          params: {
            marketId: this.market.marketId,
            marketUrl: this.market.marketUrl
          },
          query: {
            contractId: contractId
          }
        });
      }
    }
  })
});

/***/ }),

/***/ "5yZz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "61DT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_register_js__ = __webpack_require__("NSIw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1239ef37_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_register_vue__ = __webpack_require__("QnsU");
function injectStyle (ssrContext) {
  __webpack_require__("jh2l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_register_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1239ef37_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "61rA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('div',{class:_vm.menuClassModifier},[_c('div',{staticClass:"market-filters-mobile-watchlist__menu-order"},[_c('menu-button',{attrs:{"theme":_vm.orderButtonTheme,"type":_vm.selectedOrder.sort,"name":_vm.orderMenuName,"active":_vm.ordersOpen,"arrow":true},on:{"click":_vm.toggleOrder}})],1),_vm._v(" "),(_vm.shouldShowTimespanFilter)?_c('div',{staticClass:"market-filters-mobile-watchlist__menu-timespans"},[_c('menu-button',{attrs:{"type":"timespan","name":_vm.selectedTimespan.name,"theme":_vm.timespansButtonTheme,"active":_vm.timespansOpen,"arrow":true},on:{"click":_vm.toggleTimespans}})],1):_vm._e()]),_vm._v(" "),(_vm.ordersOpen)?_c('div',{staticClass:"market-filters-mobile-watchlist__order"},_vm._l((_vm.orderList('markets')),function(order){return _c('menu-button',{key:order.sort,attrs:{"type":order.sort,"name":order.fullName,"selected":_vm.orderSelected(order.sort),"typeThemeEnabled":true},on:{"click":_vm.selectOrderAndClose}})}),1):_vm._e(),_vm._v(" "),(_vm.filtersOpen)?_c('div',{staticClass:"market-filters-mobile-watchlist__filters"},[_c('a',{staticClass:"market-filters-mobile-watchlist__clear-all",on:{"click":function($event){$event.preventDefault();return _vm.onClearFilters($event)}}},[_vm._v("Clear Selections")]),_vm._v(" "),_vm._l((_vm.filters),function(category){return _c('div',{staticClass:"market-filters-mobile-watchlist__filters-group"},[_c('h3',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_vm._l((category.filters),function(filter){return _c('filter-button',{key:_vm.filterKey(filter),attrs:{"id":filter.filterId,"name":filter.name,"selected":_vm.filterSelected(filter.filterId)},on:{"addFilter":_vm.onAddFilter,"removeFilter":_vm.onRemoveFilter}})})],2)})],2):_vm._e(),_vm._v(" "),(_vm.timespansOpen)?_c('div',{staticClass:"market-filters-mobile-watchlist__order"},_vm._l((_vm.availableTimespanOptions),function(timespan){return _c('menu-button',{key:timespan.parameter,attrs:{"type":timespan.parameter,"name":timespan.name},on:{"click":_vm.selectTimespanAndClose}})}),1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "63Fj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

function set(key, value) {
  var data = {
    value: value
  };
  sessionStorage.setItem(key.toString(), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
}

function get(key, defaultValue) {
  try {
    var data = JSON.parse(sessionStorage.getItem(key.toString()));
    if (data !== null) {
      return data.value;
    }
  } catch (e) {
    sessionStorage.removeItem(key.toString());
  }
  return defaultValue || null;
}

function del(key) {
  sessionStorage.removeItem(key.toString());
}

/* harmony default export */ __webpack_exports__["a"] = ({
  set: set,
  get: get,
  del: del
});

/***/ }),

/***/ "65iJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"podcasts__header"},[_c('div',{staticClass:"podcasts__header-title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),(_vm.showArrows)?_c('div',{staticClass:"podcasts__header-arrows"},[_c('span',{class:_vm.prevArrowModifiers,on:{"click":_vm.prevSlide}}),_vm._v(" "),_c('span',{class:_vm.nextArrowModifiers,on:{"click":_vm.nextSlide}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"podcasts__line"}),_vm._v(" "),_c('div',{staticClass:"podcasts__content",on:{"mouseenter":_vm.stopSwiper,"mouseleave":_vm.startSwiper}},[_c('swiper',{ref:"swiper",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.tracks),function(track,index){return _c('swiper-slide',{key:index,staticClass:"podcasts__slide"},[(track.type === _vm.PODCAST.POLITICAN_TRADER)?_c('iframe',{attrs:{"width":"100%","height":_vm.height,"scrolling":"no","frameborder":"no","allowfullscreen":"","webkitallowfullscreen":"","mozallowfullscreen":"","oallowfullscreen":"","msallowfullscreen":"","src":_vm.getPoliticanTraderUrl()}}):_vm._e(),_vm._v(" "),(track.type === _vm.PODCAST.SOUNDCLOUD)?_c('iframe',{attrs:{"width":"100%","height":_vm.height,"scrolling":"no","frameborder":"no","src":_vm.getSoundCloudUrl(track.id)}}):_vm._e(),_vm._v(" "),(track.type === _vm.PODCAST.APPLE)?_c('iframe',{attrs:{"width":"100%","height":_vm.height,"scrolling":"no","frameborder":"no","src":_vm.getAppleUrl(track.id)}}):_vm._e(),_vm._v(" "),(track.type === _vm.PODCAST.STITCHER)?_c('iframe',{attrs:{"width":"100%","height":_vm.height,"scrolling":"no","frameborder":"no","src":_vm.getStitcherUrl(track.id)}}):_vm._e(),_vm._v(" "),(track.type === _vm.PODCAST.ITUNES)?_c('div',{staticClass:"podcasts__iframe podcasts__iframe--itunes"},[_c('iframe',{style:(_vm.styleItunesIframe),attrs:{"scrolling":"no","frameborder":"no","src":_vm.getItunesUrl(track.id)}})]):_vm._e(),_vm._v(" "),(track.type === _vm.PODCAST.BACKTRACKS)?_c('div',{staticClass:"podcasts__backtrack",attrs:{"data-bt-embed":_vm.getBacktracksUrl(track.id),"data-bt-theme":"dark","data-bt-show-description":"false","data-bt-show-comments":"false","data-bt-show-art-cover":"false"}}):_vm._e()])}),1),_vm._v(" "),(false)?_c('div',{staticClass:"podcasts__link-wrapper"},[_c('strong',[_vm._v("Special Offer:")]),_vm._v(" "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],staticClass:"podcasts__link",attrs:{"href":"https://lp.stratfor.com/predictitoffer"}},[_vm._v("\n      Access Stratfor Worldview - Geopolitical Insights on What Moves Political Markets")])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Bn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


function setSrc(el, binding) {
  el.setAttribute('src', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["s" /* getAssetPath */])(binding.value));
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    setSrc(el, binding);
  }
});

/***/ }),

/***/ "6Elq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"most-predicted"},[_c('div',{staticClass:"most-predicted__header"},[_c('div',[_vm._v("\r\n      "+_vm._s(_vm.title)+"\r\n    ")]),_vm._v(" "),(_vm.isLayoutMobile)?_c('div',{staticClass:"most-predicted__header-arrows"},[_c('span',{class:_vm.prevArrowModifiers,on:{"click":_vm.prevSlide}}),_vm._v(" "),_c('span',{class:_vm.nextArrowModifiers,on:{"click":_vm.nextSlide}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row most-predicted__content"},[(_vm.isLayoutMobile)?_c('swiper',{ref:"swiper",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.items),function(item){return _c('swiper-slide',{key:item.marketId},[_c('market-list-item',{staticClass:"most-predicted__swiper-slide",attrs:{"market":item,"theme":"home"}})],1)}),1):_c('div',{staticClass:"row"},_vm._l((_vm.items),function(market){return _c('div',{key:market.marketId,staticClass:"large-4 column most-predicted__swiper-column"},[_c('market-list-item',{key:market.marketId,attrs:{"market":market,"theme":"home"}})],1)}),0)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Em0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"election-map-special__label"},[_vm._v("\n    GA Special:\n  ")]),_vm._v(" "),_c('transition',{attrs:{"name":"election-map-special"}},[(_vm.showTooltip && _vm.isLayoutDesktop)?_c('div',{staticClass:"election-map-special__tooltip"},[_c('market-state-tooltip',{attrs:{"stateCode":"GA2","stateName":"Georgia","marketData":_vm.mapStateDataSenate.GA2,"type":"senate"}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"election-map-special__legend",style:(_vm.legendStyleModifiers),on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave,"click":_vm.onClick}},[_c('animated-number',{attrs:{"value":_vm.targetContractInstance.lastTradePriceAsCents}})],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Fjk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_table_js__ = __webpack_require__("AZoq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39419996_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_table_vue__ = __webpack_require__("KBWT");
function injectStyle (ssrContext) {
  __webpack_require__("W0Ww")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_table_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39419996_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6L/K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-header-external-nav"},[_c('div',{staticClass:"app-header-external-nav__menu"},[_c('a',{staticClass:"app-header-external-nav__menu-item app-header-external-nav__menu-item--active",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return (function () {})($event)}}},[_vm._v("Classic")]),_vm._v(" "),_c('a',{staticClass:"app-header-external-nav__menu-item",attrs:{"href":_vm.exchangeNavigateUrl,"target":"_blank"}},[_vm._v("Exchange")])]),_vm._v(" "),_c('div',{staticClass:"app-header-external-nav__line"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6M/o":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "6Ngg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    content: String,
    isOpen: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    darkHeader: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'default'
    },
    accordion: {
      default: null
    },
    id: {
      default: null
    },
    canClose: {
      type: Boolean,
      default: true
    },
    showChevron: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isOpenState: this.isOpen
    };
  },

  computed: {
    hasSlotTitle: function hasSlotTitle() {
      return !!this.$slots.title;
    },
    hasSlotContent: function hasSlotContent() {
      return !!this.$slots.default;
    },
    wrapperModifier: function wrapperModifier() {
      if (this.id !== null) {
        this.isOpenState = this.accordion === this.id;
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'collapsible-panel--no-chevron': !this.showChevron,
        'collapsible-panel--is-open': this.isOpenState
      }, 'collapsible-panel--theme-' + this.theme, true);
    },
    noPaddingModifier: function noPaddingModifier() {
      return {
        'collapsible-panel--no-padding': this.noPadding
      };
    },
    darkHeaderModifier: function darkHeaderModifier() {
      return {
        'collapsible-panel--dark-header': this.darkHeader
      };
    }
  },
  methods: {
    toggle: function toggle() {
      if (this.isOpenState === true && !this.canClose) return;

      this.isOpenState = !this.isOpenState;
      if (this.id !== null) {
        this.$emit('open', this.isOpenState ? this.id : null);
      } else {
        this.$emit('toggle', this.isOpenState);
      }
    }
  }
});

/***/ }),

/***/ "6SU6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6V5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_privacy_policy_js__ = __webpack_require__("umUo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c0777b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_privacy_policy_vue__ = __webpack_require__("nIvA");
function injectStyle (ssrContext) {
  __webpack_require__("kb5U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_privacy_policy_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c0777b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_privacy_policy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6b0c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_logos_old_bloomberg_png__ = __webpack_require__("MuFU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_logos_old_bloomberg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_logos_old_bloomberg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logos_old_cnn_png__ = __webpack_require__("HpV6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_logos_old_cnn_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_logos_old_cnn_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_logos_old_economist_png__ = __webpack_require__("Q+Dx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_logos_old_economist_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_logos_old_economist_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_logos_old_hbr_png__ = __webpack_require__("e/7H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_logos_old_hbr_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_logos_old_hbr_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_logos_old_nbc_png__ = __webpack_require__("r7L0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_logos_old_nbc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_logos_old_nbc_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_logos_old_newyorktimes_png__ = __webpack_require__("n8WA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_logos_old_newyorktimes_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_logos_old_newyorktimes_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_logos_old_politico_png__ = __webpack_require__("AYS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_logos_old_politico_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_logos_old_politico_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_logos_old_thejournal_png__ = __webpack_require__("FlLb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_logos_old_thejournal_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_logos_old_thejournal_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_logos_old_theringer_png__ = __webpack_require__("xyij");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_logos_old_theringer_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_logos_old_theringer_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_logos_old_vox_png__ = __webpack_require__("ttZ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_logos_old_vox_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_logos_old_vox_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_logos_old_yahoo_png__ = __webpack_require__("fpwF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_logos_old_yahoo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_logos_old_yahoo_png__);
















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      items: [{
        href: 'https://www.cnn.com/videos/tv/2019/10/05/do-gambling-odds-forecase-elections-better-than-polls.cnn',
        src: __WEBPACK_IMPORTED_MODULE_5__assets_images_logos_old_cnn_png___default.a,
        class: ''
      }, {
        href: 'https://www.cnbc.com/2018/01/30/these-online-traders-bet-on-the-chaos-of-the-trump-administration.html',
        src: __WEBPACK_IMPORTED_MODULE_8__assets_images_logos_old_nbc_png___default.a,
        class: ''
      }, {
        href: 'https://www.nytimes.com/2019/03/20/technology/andrew-yang-internet-democratic-primary.html?searchResultPosition=1',
        src: __WEBPACK_IMPORTED_MODULE_9__assets_images_logos_old_newyorktimes_png___default.a,
        class: ''
      }, {
        href: 'https://finance.yahoo.com/news/politics-not-trade-will-drive-markets-in-2020-goldman-sachs-152608855.html',
        src: __WEBPACK_IMPORTED_MODULE_14__assets_images_logos_old_yahoo_png___default.a,
        class: ''
      }, {
        href: 'https://www.theringer.com/2018/3/21/17130490/predictit-politics-elections-gambling',
        src: __WEBPACK_IMPORTED_MODULE_12__assets_images_logos_old_theringer_png___default.a,
        class: ''
      }, {
        href: 'https://www.politico.com/story/2018/07/05/supreme-court-justice-contenders-gambling-odds-694906',
        src: __WEBPACK_IMPORTED_MODULE_10__assets_images_logos_old_politico_png___default.a,
        class: ''
      }, {
        href: 'https://hbr.org/2018/07/if-you-say-something-is-likely-how-likely-do-people-think-it-is',
        src: __WEBPACK_IMPORTED_MODULE_7__assets_images_logos_old_hbr_png___default.a,
        class: ''
      }, {
        href: 'https://www.wsj.com/articles/wanna-bet-the-market-has-a-view-on-the-2020-election-11578679896',
        src: __WEBPACK_IMPORTED_MODULE_11__assets_images_logos_old_thejournal_png___default.a,
        class: ''
      }, {
        href: 'https://www.vox.com/future-perfect/2019/4/5/18290870/forecasting-tetlock-prediction-markets-betting',
        src: __WEBPACK_IMPORTED_MODULE_13__assets_images_logos_old_vox_png___default.a,
        class: ''
      }, {
        href: 'https://www.bloomberg.com/news/articles/2019-08-01/predictit-owns-the-market-for-2020-presidential-election-betting',
        src: __WEBPACK_IMPORTED_MODULE_4__assets_images_logos_old_bloomberg_png___default.a,
        class: ''
      }, {
        href: 'https://www.economist.com/graphic-detail/2020/01/04/what-markets-and-models-expect-in-2020',
        src: __WEBPACK_IMPORTED_MODULE_6__assets_images_logos_old_economist_png___default.a,
        class: ''
      }],
      swiperOptions: {
        autoplay: 3000,
        loop: true,
        direction: 'horizontal',
        pagination: '.in-the-news__pagination'
      },
      chunkSize: 4
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    itemsPaged: function itemsPaged() {
      var items = this.items;
      var chunk = this.chunkSize;
      var pages = [];
      for (var a = 0, end = items.length; a < end; a += chunk) {
        pages.push({
          key: a,
          items: items.slice(a, a + chunk)
        });
      }
      return pages;
    }
  }),
  methods: {
    getImgModifiers: function getImgModifiers(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'in-the-news-old__img': true
      }, 'in-the-news-old__img--' + item.class, item.class);
    }
  }
});

/***/ }),

/***/ "6b6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-container"},[_vm._t("parallax-bg"),_vm._v(" "),_c('div',{class:_vm.defaultSwiperClasses.wrapperClass},[_vm._t("default")],2),_vm._v(" "),_vm._t("pagination"),_vm._v(" "),_vm._t("button-prev"),_vm._v(" "),_vm._t("button-next"),_vm._v(" "),_vm._t("scrollbar")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6bRq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6iuM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "6mGA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6pEg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6sKT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_review_and_confirm_js__ = __webpack_require__("JeCN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_954fbe14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_review_and_confirm_vue__ = __webpack_require__("FJBP");
function injectStyle (ssrContext) {
  __webpack_require__("i6WZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_review_and_confirm_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_954fbe14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_review_and_confirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6uXL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"market-contract-v2__title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"market-contract-v2__current-price"},[_c('animated-number',{attrs:{"value":_vm.price}})],1),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.changePrice,"lastClosePrice":_vm.contractModel.lastClosePrice,"theme":"browse"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "72gB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "73Zp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-leaderboards"},[(_vm.isLayoutDesktop)?[_c('div',{staticClass:"page-leaderboards__no-scroll"}),_vm._v(" "),_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12 large-4 page-leaderboards__sticky"},[_c('leaderboards-levels',[_c('leaderboards-toolbar')],1),_vm._v(" "),_c('div',{staticClass:"page-leaderboards__note"},[_vm._v("\n          "+_vm._s(_vm.$txt('page-leaderboards.note'))+"\n        ")]),_vm._v(" "),(_vm.isLoggedIn && _vm.isUserVerified)?_c('share-invite-widget',{staticClass:"page-leaderboards__share"}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"column small-12 large-8"},[_c('leaderboards-table')],1)])]:[(!_vm.selectedLeaderboard)?_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12"},[_c('leaderboards-levels'),_vm._v(" "),_c('div',{staticClass:"page-leaderboards__note"},[_vm._v("\n          "+_vm._s(_vm.$txt('page-leaderboards.note'))+"\n        ")]),_vm._v(" "),(_vm.isLoggedIn && _vm.isUserVerified)?_c('share-invite-widget',{staticClass:"page-leaderboards__share"}):_vm._e()],1)]):[_c('div',{staticClass:"page-leaderboards__toolbar"},[_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12"},[_c('leaderboards-toolbar',{attrs:{"backButton":true},on:{"back":_vm.onBackClick}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('leaderboards-table')],1)])])]]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "78tC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7A0p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7DQ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_settings_option_js__ = __webpack_require__("mThu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6208d08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_option_vue__ = __webpack_require__("UxJK");
function injectStyle (ssrContext) {
  __webpack_require__("yaVC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_settings_option_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6208d08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_option_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Ez+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "7GI3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_combined_login_js__ = __webpack_require__("nlkt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_005e894d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_combined_login_vue__ = __webpack_require__("RIDg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_combined_login_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_005e894d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_combined_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Wq7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__top_comment_top_comment_vue__ = __webpack_require__("bFAx");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    widget: Object
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_loader__["a" /* default */]],
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"],
    topComment: __WEBPACK_IMPORTED_MODULE_2__top_comment_top_comment_vue__["a" /* default */]
  },
  data: function data() {
    var _this = this;

    return {
      rightDis: false,
      leftDis: true,
      swiperOptions: {
        spaceBetween: 0,
        autoplay: 10 * 1000,
        slidesPerColumn: 1,
        loop: true,
        direction: 'horizontal',
        onTransitionStart: function onTransitionStart(swp) {
          var ax = swp.activeIndex % _this.lastIndex;
          _this.leftDis = ax === 1;
          _this.rightDis = ax === 0;
        }
      }
    };
  },

  computed: {
    obj: function obj() {
      return !this.widget ? {} : this.widget;
    },
    items: function items() {
      return this.widget.widgetTopComments || [];
    },
    lastIndex: function lastIndex() {
      return this.items.length;
    },
    prevArrowModifiers: function prevArrowModifiers() {
      return {
        'market-top-comments__arrow': true,
        'market-top-comments__arrow--left': true
      };
    },
    nextArrowModifiers: function nextArrowModifiers() {
      return {
        'market-top-comments__arrow': true,
        'market-top-comments__arrow--right': true
      };
    }
  },
  methods: {
    prevSlide: function prevSlide() {
      this.$refs.swiper.swiper.slidePrev();
    },
    nextSlide: function nextSlide() {
      this.$refs.swiper.swiper.slideNext();
    }
  },
  watch: {
    widget: function widget(val) {
      if (val) {
        this.loaderRemove();
      }
    }
  },
  mounted: function mounted() {
    if (!this.widget) {
      this.loaderAdd();
    }
  }
});

/***/ }),

/***/ "7Ymm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    theme: {
      type: String,
      default: ''
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'market-widget-loader': true
      }, 'market-widget-loader--' + this.theme, this.theme);
    }
  })
});

/***/ }),

/***/ "7ea0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"market-money-widget__title"},[_vm._v(_vm._s(_vm.obj.title))]),_vm._v(" "),(!!_vm.widget)?_c('div',{staticClass:"market-money-widget__content",on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_c('div',{staticClass:"market-money-widget__percent-container"},[_c('div',{staticClass:"market-money-widget__percent"},[_vm._v(_vm._s(_vm.percent))]),_vm._v(" "),_c('div',{staticClass:"market-money-widget__percent-title"},[_c('div',{staticClass:"market-money-widget__percent-vertical"},[_vm._v(_vm._s(_vm.obj.percentTitle))])])]),_vm._v(" "),_c('div',{staticClass:"market-money-widget__market"},[_vm._v(_vm._s(_vm.obj.marketName))]),_vm._v(" "),_c('div',{staticClass:"market-money-widget__contract"},[_c('div',{staticClass:"market-money-widget__contract-title"},[_vm._v(_vm._s(_vm.contractName))]),_vm._v(" "),_c('div',{staticClass:"market-money-widget__contract-section"},[_c('span',{staticClass:"market-money-widget__contract-price"},[_c('animated-number',{attrs:{"value":_vm.price}})],1),_vm._v(" "),_c('market-change-price',{staticClass:"market-money-widget__contract-delta",attrs:{"price":_vm.delta}}),_vm._v(" "),_c('span',{class:_vm.iconModifiers})],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7jIy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7okt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_generic_js__ = __webpack_require__("DFsO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aec59b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_vue__ = __webpack_require__("aEut");
function injectStyle (ssrContext) {
  __webpack_require__("8M3L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_generic_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aec59b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7ppQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7vVr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_portfolio_js__ = __webpack_require__("CtVF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ea38ac9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_portfolio_vue__ = __webpack_require__("u+c/");
function injectStyle (ssrContext) {
  __webpack_require__("9+zh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_portfolio_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ea38ac9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_portfolio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7wmZ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8cGF0aCBkPSJNMS4xNiA4Ljg2M2gzLjEzOXY2LjYwMUgxLjE2ek0xNC42OTEgMTIuMjc0aDMuMTM5djMuMTkxaC0zLjEzOXoiLz4NCiAgICAgICAgPHRleHQgZmlsbD0iIzY3OTk5RiIgZm9udC1mYW1pbHk9IlJvYm90by1Cb2xkLCBSb2JvdG8iIGZvbnQtc2l6ZT0iMTIiIGZvbnQtd2VpZ2h0PSJib2xkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDEpIj4NCiAgICAgICAgICAgIDx0c3BhbiB4PSIxNC4wOCIgeT0iMTQiPsKiPC90c3Bhbj4NCiAgICAgICAgPC90ZXh0Pg0KICAgICAgICA8cGF0aCBmaWxsPSIjNjc5OTlGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xOC40MSAxOEguNThjLS4zMiAwLS41OC4yNjQtLjU4LjU5IDAgLjMyNS4yNi41OS41OC41OWgxNy44M2MuMzIgMCAuNTgtLjI2NS41OC0uNTkgMC0uMzI2LS4yNi0uNTktLjU4LS41OXoiLz4NCiAgICAgICAgPHBhdGggc3Ryb2tlPSIjNjc5OTlGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41IiBkPSJNMSAxNGw1LTcgNSA0IDYuNTEzLTkuNTEzIi8+DQogICAgPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "7wxw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_youtube_embed__ = __webpack_require__("5/be");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_collapsible_panel_collapsible_panel_vue__ = __webpack_require__("NMl0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_scrollTo__ = __webpack_require__("rrO7");







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    asWidget: {
      type: Boolean,
      default: false
    }
  },
  components: {
    contentHeader: __WEBPACK_IMPORTED_MODULE_4__components_generics_content_header_content_header_vue__["a" /* default */],
    collapsiblePanel: __WEBPACK_IMPORTED_MODULE_3__components_collapsible_panel_collapsible_panel_vue__["a" /* default */]
  },
  data: function data() {
    return {
      expanded: false,
      accordion: 'video-0',
      videos: [{ title: 'Buying and Selling Shares', video: 'https://www.youtube.com/watch?v=h57BM4abHJ4', id: 'video-0' }, { title: 'Navigating the Site', video: 'https://www.youtube.com/watch?v=muJmhHeVJ_w', id: 'video-1' }, { title: 'Opening an Account', video: 'https://www.youtube.com/watch?v=NfWU0Wiixuo', id: 'video-2' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile'])),
  methods: {
    getYoutubeIdFromUrl: function getYoutubeIdFromUrl(url) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vue_youtube_embed__["b" /* getIdFromURL */])(url);
    },
    accordionOpen: function accordionOpen(e) {
      this.accordion = e;

      if (e !== null) {
        setTimeout(function () {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_scrollTo__["a" /* default */])(document.getElementById(e), 0);
        }, 50);
      }
    }
  }
});

/***/ }),

/***/ "7yL+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8/3H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = checkResponseForMaintenance;
/* harmony export (immutable) */ __webpack_exports__["c"] = checkResponseForTaxInfo;
/* harmony export (immutable) */ __webpack_exports__["d"] = checkResponseForDocumentUpload;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkResponseForApiGoingOffline;
/* harmony export (immutable) */ __webpack_exports__["e"] = checkResponseVersion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some__ = __webpack_require__("mGzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__("JDN0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");






var TAX_INFO_STATUS_CODE = 403;
var TAX_INFO_MESSAGE_CODE = 'requireTax1099Redirect';

var DOCUMENT_UPLOAD_SKIP_POPUP_URLS = ['Wallet/DepositCard', 'Wallet/ConfirmDepositCard', 'Wallet/SubmitDepositCard', 'Wallet/WithdrawAch', 'Wallet/WithdrawCheck', 'Wallet/DepositUSDCoin', 'Wallet/WithdrawWire', 'Wallet/WithdrawUSDC', 'Wallet/DepositPWMB'];

function checkResponseForMaintenance(response) {
  var maintenanceMessage = response.headers['pi-maintenancemessage'];
  var suspendedMessage = response.headers['pi-tradingsuspendedmessage'];
  var systemMessage = response.headers['pi-systemmessages'];

  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('app/setMaintenance', {
    isMaintenanceEnabled: typeof maintenanceMessage !== 'undefined',
    isTradingEnabled: typeof maintenanceMessage === 'undefined',
    maintenanceMessage: maintenanceMessage || '',
    suspendedMessage: suspendedMessage || '',
    systemMessage: systemMessage || ''
  });
}

function checkResponseForTaxInfo(response) {
  if (!(response.status === TAX_INFO_STATUS_CODE && response.data.code && response.data.code === TAX_INFO_MESSAGE_CODE)) return;
  setTimeout(function () {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__["a" /* MODALS */].TAX_INFO);
  }, 1000);
}

function checkResponseForDocumentUpload(response) {
  var dontAct = response.config.method.toLowerCase() === 'get' && __WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(DOCUMENT_UPLOAD_SKIP_POPUP_URLS, function (x) {
    return response.config.url.includes(x);
  });

  if (!(response.data.duRequired || response.data.duPending) || dontAct) return;

  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__["a" /* MODALS */].UPLOAD_DOCUMENT);
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('popup/setCurrentPopupOptions', {
    isPending: !!response.data.duPending,
    source: response.data.duSource
  });
}

function checkResponseForApiGoingOffline(response) {
  if (!(response.data && __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(response.data) && response.data.includes('MaintenanceMessage'))) return;
  // When error response includes MaintenanceMessage redirect to home
  // This situation means API is offline
  window.location.href = "/";
}

function checkResponseVersion(response) {
  var version = response.headers['x-version'];
  if (!version) return;
  if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.app.initialVersion === null) {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('app/setInitialVersion', version);
  }
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('app/setServerVersion', version);
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  checkResponseForMaintenance: checkResponseForMaintenance,
  checkResponseForTaxInfo: checkResponseForTaxInfo,
  checkResponseForApiGoingOffline: checkResponseForApiGoingOffline,
  checkResponseVersion: checkResponseVersion
});

/***/ }),

/***/ "81Xy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__ = __webpack_require__("vJzj");








var TOTAL_COLUMNS = 12;
var COLUMN_OPTIONS = [{ label: '0%', value: 0 }, { label: '8.3%', value: 1 }, { label: '16.6%', value: 2 }, { label: '25%', value: 3 }, { label: '33.3%', value: 4 }, { label: '41.6%', value: 5 }, { label: '50%', value: 6 }, { label: '58.3%', value: 7 }, { label: '66.6%', value: 8 }, { label: '75%', value: 9 }, { label: '83%', value: 10 }, { label: '91.6%', value: 11 }];
var TYPE_OPTIONS = [{ label: 'Desktop', value: 'desktop' }, { label: 'Mobile', value: 'mobile' }, { label: 'Detail', value: 'detail' }];
/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  props: {
    previewId: {}
  },
  data: function data() {
    return {
      COLUMN_OPTIONS: COLUMN_OPTIONS,
      TYPE_OPTIONS: TYPE_OPTIONS,
      typeChoice: TYPE_OPTIONS[0],
      columnChoice: {
        left: COLUMN_OPTIONS[0],
        middle: COLUMN_OPTIONS[7],
        right: COLUMN_OPTIONS[0]
      }
    };
  },

  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_5__components_generics_alert_box_alert_box_vue__["a" /* default */]
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'page-story-preview': true
      }, 'page-story-preview--' + this.typeChoice.value, true);
    },
    isColumnCountExceeding: function isColumnCountExceeding() {
      return this.columnChoice.left.value + this.columnChoice.right.value >= TOTAL_COLUMNS;
    },
    middleOption: function middleOption() {
      var sumColumns = this.columnChoice.left.value + this.columnChoice.right.value;
      return TOTAL_COLUMNS - sumColumns;
    },
    leftColumnClasses: function leftColumnClasses() {
      var option = this.columnChoice.left.value;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        column: true
      }, 'small-' + option, !!option);
    },
    middleColumnClasses: function middleColumnClasses() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        column: true
      }, 'small-' + this.middleOption, !!this.middleOption);
    },
    rightColumnClasses: function rightColumnClasses() {
      var option = this.columnChoice.right.value;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        column: true
      }, option, !!option);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getStoryFullPreview']), {
    typeChoiceHandler: function typeChoiceHandler(option) {
      var _this = this;

      switch (option.value) {
        case 'mobile':
          this.columnChoice.left = COLUMN_OPTIONS[4];
          this.columnChoice.right = COLUMN_OPTIONS[4];
          break;
        case 'desktop':
          this.columnChoice.left = COLUMN_OPTIONS[1];
          this.columnChoice.right = COLUMN_OPTIONS[1];
          break;
        case 'detail':
          this.columnChoice.left = COLUMN_OPTIONS[0];
          this.columnChoice.right = COLUMN_OPTIONS[0];
          break;
        default:
          break;
      }
      this.loaderAdd(document.body);
      this.getStoryFullPreview(this.previewId).then(function (responseData) {
        var data = {};
        switch (option.value) {
          case 'mobile':
            data = {
              renderedHTML: responseData.homePagePreviewViewModel.mobileContent.html,
              cmsContentObject: responseData.homePagePreviewViewModel.mobileContent.cmsContent
            };
            break;
          case 'desktop':
            data = {
              renderedHTML: responseData.homePagePreviewViewModel.desktopContent.html,
              cmsContentObject: responseData.homePagePreviewViewModel.desktopContent.cmsContent
            };
            break;
          case 'detail':
            data = {
              renderedHTML: responseData.detailPageViewModel.bodyHTML,
              cmsContentObject: responseData.detailPageViewModel.cmsContentObject
            };
            break;
          default:
            break;
        }
        _this.loaderRemove(document.body);
        _this.installDynamicControls({ data: data });
      }).catch(function () {
        return _this.loaderRemove(document.body);
      });
    }
  }),
  watch: {
    typeChoice: {
      handler: 'typeChoiceHandler',
      immediate: true
    }
  }
});

/***/ }),

/***/ "8Crr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(!_vm.isComponentReady)?_c('div',{staticClass:"hero-unit-slider__loader"}):_c('swiper',{attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.items),function(banner){return _c('swiper-slide',{key:banner.carouselId,staticClass:"hero-unit-slider__slide"},[_c('div',{staticClass:"hero-unit-slider__image",style:(_vm.bannerImageStyleModifiers(banner.carouselData.image))}),_vm._v(" "),_c('div',{staticClass:"hero-unit-slider__content"},[(banner.carouselData.carouselItemHeader.secondLine)?_c('p',{staticClass:"hero-unit-slider__para",domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemHeader.secondLine)}}):_vm._e(),_vm._v(" "),(banner.carouselData.carouselItemHeader.firstLine)?_c('h2',{staticClass:"hero-unit-slider__headline",domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemHeader.firstLine)}}):_vm._e(),_vm._v(" "),(banner.carouselData.carouselItemButton)?[(_vm.isUrlExternal(banner))?_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],staticClass:"button button--medium button--submit hero-unit-slider__button",style:(_vm.buttonStyleModifiers(banner.carouselData.carouselItemButton)),attrs:{"href":_vm.getBannerUrl(banner)},domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemButton.text)}}):_c('router-link',{staticClass:"button button--medium button--submit hero-unit-slider__button",style:(_vm.buttonStyleModifiers(banner.carouselData.carouselItemButton)),attrs:{"to":_vm.getBannerUrl(banner)},domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemButton.text)}})]:_vm._e()],2)])}),_vm._v(" "),_c('div',{staticClass:"hero-unit-slider__pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8G+U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_login_js__ = __webpack_require__("lFoL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f160bed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_login_vue__ = __webpack_require__("hene");
function injectStyle (ssrContext) {
  __webpack_require__("pIbi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_login_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f160bed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8I/4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wallet_amount_info_amount_info_vue__ = __webpack_require__("Jm7U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");






var RECEIVED_MESSAGE = 'Your withdrawal request has been received.';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */]],
  components: {
    amountInfo: __WEBPACK_IMPORTED_MODULE_2__components_wallet_amount_info_amount_info_vue__["a" /* default */]
  },
  props: {
    amendAvailable: {
      type: Boolean,
      required: false,
      default: false
    },
    kind: {
      type: String,
      required: false
    },
    amount: {
      type: Number,
      required: false
    },
    bankWithdrawAmounts: {
      type: Object
    },
    fee: {
      type: Number,
      required: false,
      default: 5.0
    },
    beneficiaryInfo: {
      type: Object,
      required: false
    },
    accountDetails: {
      type: Object,
      required: false
    },
    addressLine1: {
      type: String,
      required: false
    },
    addressLine2: {
      type: String,
      required: false
    },
    addressLine3: {
      type: String,
      required: false
    },
    country: {
      required: false
    },
    recipient: {
      required: false
    }
  },
  data: function data() {
    return {
      hasFailed: false
    };
  },

  computed: {
    isAch: function isAch() {
      return this.kind === 'ach';
    },
    isCheck: function isCheck() {
      return this.kind === 'check';
    },
    isCoinbase: function isCoinbase() {
      return this.kind === 'coinbase-withdraw';
    },
    isBankTransfer: function isBankTransfer() {
      return this.kind === 'bank-transfer';
    },
    netTotal: function netTotal() {
      return this.amount - this.fee;
    },
    backText: function backText() {
      return this.hasFailed ? 'Back' : 'Cancel';
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['postWithdrawCheck', 'postWithdrawAch', 'postWithdrawCoinbase', 'postWithdrawWireSubmit']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotification']), {
    inspectWithrawConfirmResponse: function inspectWithrawConfirmResponse(data) {
      if (data.isTLEvent) {
        this.$gtm.trackEvent({
          event: 'FullWithdraw'
        });
      }
    },
    onEdit: function onEdit() {
      this.$emit('edit');
    },
    onSubmit: function onSubmit() {
      var _this = this;

      this.formReset();
      this.loaderAdd(document.body);
      if (this.isCheck) {
        var payload = {
          amount: this.amount
        };
        this.postWithdrawCheck(payload).then(function (data) {
          _this.loaderRemove(document.body);
          _this.inspectWithrawConfirmResponse(data);
          _this.setSuccessSideNotification(RECEIVED_MESSAGE);
          _this.$gtm.trackEvent({ event: 'Withdraw' });
          _this.$emit('success');
        }).catch(function (error) {
          _this.hasFailed = true;
          _this.loaderRemove(document.body);
          _this.formHandleErrors(error);
          _this.$gtm.trackEvent({ event: 'FailWithdraw' });
        });
      } else if (this.isAch) {
        var _payload = {
          amount: this.amount,
          savedAchAccountId: this.accountDetails.accountId,
          achRoutingNumber: this.accountDetails.routingNumber,
          achAccountNumber: this.accountDetails.accountNumber,
          achAccountType: this.accountDetails.accountType
        };
        this.postWithdrawAch(_payload).then(function (data) {
          _this.loaderRemove(document.body);
          _this.inspectWithrawConfirmResponse(data);
          _this.setSuccessSideNotification(RECEIVED_MESSAGE);
          _this.$gtm.trackEvent({ event: 'Withdraw' });
          _this.$emit('success');
        }).catch(function (error) {
          _this.hasFailed = true;
          _this.loaderRemove(document.body);
          _this.formHandleErrors(error);
          _this.$gtm.trackEvent({ event: 'FailWithdraw' });
        });
      } else if (this.isCoinbase) {
        var _payload2 = {
          amount: this.amount
        };
        this.postWithdrawCoinbase(_payload2).then(function (data) {
          _this.loaderRemove(document.body);
          _this.inspectWithrawConfirmResponse(data);
          _this.setSuccessSideNotification(RECEIVED_MESSAGE);
          _this.$gtm.trackEvent({ event: 'Withdraw' });
          _this.$emit('success');
        }).catch(function (error) {
          _this.hasFailed = true;
          _this.loaderRemove(document.body);
          _this.formHandleErrors(error);
          _this.$gtm.trackEvent({ event: 'FailWithdraw' });
        });
      } else if (this.isBankTransfer) {
        var _payload3 = {
          amount: this.amount,
          accountWireBeneficiaryId: this.beneficiaryInfo.accountWireBeneficiaryId
        };
        this.postWithdrawWireSubmit(_payload3).then(function (data) {
          _this.loaderRemove(document.body);
          _this.inspectWithrawConfirmResponse(data);
          _this.setSuccessSideNotification(RECEIVED_MESSAGE);
          _this.$gtm.trackEvent({ event: 'Withdraw' });
          _this.$emit('success');
        }).catch(function (error) {
          _this.hasFailed = true;
          _this.loaderRemove(document.body);
          _this.formHandleErrors(error);
          _this.$gtm.trackEvent({ event: 'FailWithdraw' });
        });
      }
    }
  })
});

/***/ }),

/***/ "8IYq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8KbT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_how_it_works_old_market_svg__ = __webpack_require__("K0uo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_how_it_works_old_market_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_icons_how_it_works_old_market_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_how_it_works_old_prediction_svg__ = __webpack_require__("LmU5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_how_it_works_old_prediction_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_icons_how_it_works_old_prediction_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_how_it_works_old_shares_svg__ = __webpack_require__("htEh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_how_it_works_old_shares_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_icons_how_it_works_old_shares_svg__);






/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isShutdownModeOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isUserRestricted']), {
    items: function items() {
      if (this.isShutdownModeOn) {
        return [{
          title: 'Browsing Questions',
          description: 'Markets offer a range of questions for traders to test their skills.',
          icon: __WEBPACK_IMPORTED_MODULE_2__assets_icons_how_it_works_old_market_svg___default.a
        }, {
          title: 'Making Predictions',
          description: 'Traders make predictions by buying and selling shares in potential outcomes.',
          icon: __WEBPACK_IMPORTED_MODULE_3__assets_icons_how_it_works_old_prediction_svg___default.a
        }, {
          title: 'Trading Shares',
          description: 'Prices will rise and fall with political events, giving traders the opportunity to cash in shares for a profit.',
          icon: __WEBPACK_IMPORTED_MODULE_4__assets_icons_how_it_works_old_shares_svg___default.a
        }];
      }
      return [{
        title: 'Browse Markets',
        description: 'Check out the range of available markets on which you can try and predict the outcome.',
        icon: __WEBPACK_IMPORTED_MODULE_2__assets_icons_how_it_works_old_market_svg___default.a
      }, {
        title: 'Make A Prediction',
        description: 'Think everyone’s got it wrong? Put your money where your mouth is and buy shares for or against an event taking place.',
        icon: __WEBPACK_IMPORTED_MODULE_3__assets_icons_how_it_works_old_prediction_svg___default.a
      }, {
        title: 'Trade Your Shares',
        description: 'Buy your shares low and sell them high once the crowd figures out you were right.',
        icon: __WEBPACK_IMPORTED_MODULE_4__assets_icons_how_it_works_old_shares_svg___default.a
      }];
    }
  })
});

/***/ }),

/***/ "8M3L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8No6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-list-desktop-header"},[_c('div',{staticClass:"market-list-desktop-header__title"},[_c('div',{staticClass:"market-list-desktop-header__text"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),_c('span',{staticClass:"market-list-desktop-header__text--small"},[_vm._v("\n        "+_vm._s(_vm.count)+" Market"),(_vm.count !== 1)?[_vm._v("s")]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"market-list-desktop-header__filters"},[(_vm.layout == 'grid')?_c('market-filters-desktop-grid'):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8TeC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_forgotten_js__ = __webpack_require__("QM9i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72426725_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_forgotten_vue__ = __webpack_require__("A0/P");
function injectStyle (ssrContext) {
  __webpack_require__("qV4T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_forgotten_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72426725_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_forgotten_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8X7E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8YBB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userBrowseHeaders.length > 0)?_c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"nav-browse-old__container"},[(_vm.theme === 'new')?_c('div',{staticClass:"nav-browse-old__slide"},[_c('div',{staticClass:"nav-browse-old__item"},[_c('span',{staticClass:"nav-browse-old__link",on:{"click":_vm.toggleCategoriesLabel}},[_c('span',{class:_vm.categoriesIcon}),_vm._v(" "),_c('transition',{attrs:{"name":"nav-browse-old"}},[(_vm.isCategoriesLabelVisible)?_c('span',{staticClass:"nav-browse-old__link-text nav-browse-old__link-text--categories"},[_vm._v("Categories:")]):_vm._e()])],1)])]):_vm._e(),_vm._v(" "),_vm._l((_vm.userBrowseHeaders),function(item){return _c('div',{key:item.headerId,staticClass:"nav-browse-old__slide"},[_c('div',{staticClass:"nav-browse-old__item"},[(item.external)?[(item.name)?_c('router-link',{staticClass:"nav-browse-old__link",attrs:{"to":{name: item.name}}},[(item.icon)?_c('span',{class:_vm.iconClassModifiers(item)}):_vm._e(),_vm._v(" "+_vm._s(item.title)+"\r\n          ")]):(item.href)?_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],staticClass:"nav-browse-old__link",attrs:{"href":item.href}},[(item.icon)?_c('span',{class:_vm.iconClassModifiers(item)}):_vm._e(),_vm._v(" "+_vm._s(item.title)+"\r\n          ")]):_vm._e()]:_c('router-link',{staticClass:"nav-browse-old__link",attrs:{"to":{name: 'market-list', params: {headerId: item.headerId, headerUrl: item.headerUrl}}}},[_vm._v("\r\n          "+_vm._s(item.name)+"\r\n        ")])],2)])})],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8YSH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountFormLoader_vue__ = __webpack_require__("h1Ye");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f06a416a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountFormLoader_vue__ = __webpack_require__("whbd");
function injectStyle (ssrContext) {
  __webpack_require__("Lzij")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountFormLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f06a416a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountFormLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8hek":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_js__ = __webpack_require__("bYWr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32ef4915_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__("AUn5");
function injectStyle (ssrContext) {
  __webpack_require__("SYp6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32ef4915_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8jtT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_offers_js__ = __webpack_require__("fvt5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74b2ffed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_offers_vue__ = __webpack_require__("JThl");
function injectStyle (ssrContext) {
  __webpack_require__("+buz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_offers_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74b2ffed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_offers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8m5v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8mne":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"small-11 column"},[_c('h3',{staticClass:"content-header__title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.subTitle)?_c('span',{staticClass:"content-header__sub-title"},[_vm._v(_vm._s(_vm.subTitle))]):_vm._e()])]),_vm._v(" "),(_vm.showCloseButton)?_c('div',{staticClass:"small-1 column content-header__close"},[_c('close-button',{attrs:{"isDark":true},on:{"close":_vm.close}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8mrx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TIME_OPTIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api__ = __webpack_require__("H/Zg");






var DEFAULT_LOAD_LEADERBOARD = {
  data: [],
  trader: null,
  page: 0,
  totalCount: 0,
  canLoadMore: true
};

var TIME_OPTIONS = {
  PAST_WEEK: { label: 'Past Week', value: 7 },
  PAST_MONTH: { label: 'Past Month', value: 30 },
  PAST_YEAR: { label: 'Past Year', value: 365 }
};

/* harmony default export */ __webpack_exports__["b"] = ({
  namespaced: true,
  state: {
    selectedLeaderboardId: null,
    playerLeaderboards: [],
    leaderboards: [],
    leaderboardsResults: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_LOAD_LEADERBOARD),
    leaderboardsDateRange: TIME_OPTIONS.PAST_WEEK.value
  },
  getters: {
    selectedLeaderboard: function selectedLeaderboard(state) {
      return state.leaderboards.find(function (i) {
        return i.leaderBoardId === state.selectedLeaderboardId;
      });
    }
  },
  mutations: {
    setSelectedLeaderboardId: function setSelectedLeaderboardId(state, data) {
      state.selectedLeaderboardId = data;
    },
    setPlayerLeaderboards: function setPlayerLeaderboards(state, data) {
      state.playerLeaderboards = data;
    },
    setLeaderboards: function setLeaderboards(state, data) {
      state.leaderboards = data;
    },
    clearSelectedLeaderboardId: function clearSelectedLeaderboardId(state) {
      state.selectedLeaderboardId = null;
    },
    resetLeaderboardsResults: function resetLeaderboardsResults(state) {
      state.leaderboardsResults = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(DEFAULT_LOAD_LEADERBOARD);
    },
    setLeaderboardsResults: function setLeaderboardsResults(state, payload) {
      var sourceData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.leaderboardsResults.data));
      var data = sourceData.concat(payload.data.traders || []);
      var page = payload.data.page;
      var totalCount = payload.data.totalTraders;
      var canLoadMore = totalCount > data.length;

      state.leaderboardsResults = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.leaderboardsResults, {
        trader: payload.data.trader,
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    setLeaderboardsDateRange: function setLeaderboardsDateRange(state, data) {
      state.leaderboardsDateRange = data;
    },
    resetLeaderboardsDateRange: function resetLeaderboardsDateRange(state) {
      state.leaderboardsDateRange = TIME_OPTIONS.PAST_WEEK.value;
    }
  },
  actions: {
    getLeaderboardsResults: function getLeaderboardsResults(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      if (state.selectedLeaderboardId !== null && state.leaderboardsResults.canLoadMore) {
        var page = state.leaderboardsResults.page + 1;
        return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].leaderboards.getLeaderboard({
          dateRange: state.leaderboardsDateRange,
          id: state.selectedLeaderboardId,
          page: page
        }).then(function (response) {
          commit('setLeaderboardsResults', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return null;
    },
    getLeaderboards: function getLeaderboards(_ref2) {
      var state = _ref2.state,
          commit = _ref2.commit;

      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref3$cache = _ref3.cache,
          cache = _ref3$cache === undefined ? true : _ref3$cache;

      if (cache && state.leaderboards.length > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.leaderboards);
      }
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].leaderboards.getLeaderboards().then(function (response) {
        commit('setLeaderboards', response.data);
        return response.data;
      });
    },
    getPlayerLeaderboards: function getPlayerLeaderboards(_ref4) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].leaderboards.getPlayerLeaderboards().then(function (response) {
        commit('setPlayerLeaderboards', response.data);
        return response.data;
      });
    },
    setSelectedLeaderboardId: function setSelectedLeaderboardId(_ref5, data) {
      var commit = _ref5.commit;

      commit('setSelectedLeaderboardId', data);
    },
    clearSelectedLeaderboardId: function clearSelectedLeaderboardId(_ref6) {
      var commit = _ref6.commit;

      commit('clearSelectedLeaderboardId');
    },
    resetLeaderboardsResults: function resetLeaderboardsResults(_ref7) {
      var commit = _ref7.commit;

      commit('resetLeaderboardsResults');
    },
    setLeaderboardsDateRange: function setLeaderboardsDateRange(_ref8, data) {
      var commit = _ref8.commit;

      commit('setLeaderboardsDateRange', data);
    },
    resetLeaderboardsDateRange: function resetLeaderboardsDateRange(_ref9) {
      var commit = _ref9.commit;

      commit('resetLeaderboardsDateRange');
    }
  }
});

/***/ }),

/***/ "8nLW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_profile_page_js__ = __webpack_require__("M5iw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b822490_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_page_vue__ = __webpack_require__("qikT");
function injectStyle (ssrContext) {
  __webpack_require__("pBjg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_profile_page_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b822490_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8rZo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8sRt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__("H/Zg");



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    ticketTypes: null,
    reportReasons: []
  },
  mutations: {
    updateTicketTypes: function updateTicketTypes(state, payload) {
      state.ticketTypes = payload;
    },
    setReportReasons: function setReportReasons(state, data) {
      state.reportReasons = data.reasons || [];
    }
  },
  actions: {
    getForumUrl: function getForumUrl() {
      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.getForumUrl().then(function (response) {
        return response.data;
      });
    },
    getTicketsTypes: function getTicketsTypes(_ref) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.getTicketsTypes().then(function (response) {
        return commit('updateTicketTypes', response.data.map(function (o) {
          return { label: o, value: o };
        }));
      });
    },
    postTicket: function postTicket(_ref2, payload) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.postTicket(payload);
    },
    getReportUserReasons: function getReportUserReasons(_ref3) {
      var state = _ref3.state,
          commit = _ref3.commit;

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$cache = _ref4.cache,
          cache = _ref4$cache === undefined ? true : _ref4$cache;

      if (cache && state.reportReasons.length > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.reportReasons);
      }
      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.getReportUser().then(function (response) {
        commit('setReportReasons', response.data);
        return response.data;
      });
    },
    reportUser: function reportUser(_ref5, payload) {
      var commit = _ref5.commit;

      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.postReportUser(payload).then(function (response) {
        return response.data;
      });
    },
    getAnnouncements: function getAnnouncements() {
      return __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].support.getAnnouncements().then(function (response) {
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "8sqq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.classModifiers,attrs:{"href":_vm.marketDetailUrl}},[(_vm.isLayoutMobile)?[_c('div',{staticClass:"overview-map-contract__image-wrapper"},[_c('div',{staticClass:"overview-map-contract__image",style:(_vm.imageStyleModifiers)}),_vm._v(" "),(false)?_c('div',{staticClass:"overview-map-contract__indicator",style:(_vm.bgColorStyleModifiers)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"overview-map-contract__info"},[_c('span',{staticClass:"overview-map-contract__current-price"},[_c('animated-number',{attrs:{"value":_vm.contractModel.lastTradePriceAsCents}})],1),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice}})],1)]),_vm._v(" "),_c('span',{staticClass:"overview-map-contract__title",style:(_vm.bgColorStyleModifiers)},[_vm._v("\n      "+_vm._s(_vm.item.shortName)+"\n    ")])]:[_c('div',{staticClass:"overview-map-contract__image-wrapper"},[_c('div',{staticClass:"overview-map-contract__image",style:(_vm.imageStyleModifiers)}),_vm._v(" "),(false)?_c('div',{staticClass:"overview-map-contract__indicator",style:(_vm.bgColorStyleModifiers)}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"overview-map-contract__info-wrapper"},[_c('span',{staticClass:"overview-map-contract__title",style:(_vm.bgColorStyleModifiers)},[_vm._v("\n        "+_vm._s(_vm.item.shortName)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"overview-map-contract__info"},[_c('span',{staticClass:"overview-map-contract__current-price"},[_c('animated-number',{attrs:{"value":_vm.contractModel.lastTradePriceAsCents}})],1),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice}})],1)])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8zAU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverviewMapLoader_vue__ = __webpack_require__("sCGU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_638e558c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverviewMapLoader_vue__ = __webpack_require__("Lxtc");
function injectStyle (ssrContext) {
  __webpack_require__("5wJI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverviewMapLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_638e558c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverviewMapLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9+zh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "922l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "93E7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-header"},[(_vm.isLayoutDesktop)?_c('div',{staticClass:"charts-header--clear"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"charts-header--right"},[(_vm.showDownload)?_c('div',{staticClass:"charts-header__download",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onDownload($event)}}},[_c('div',{staticClass:"charts-header__download-icon"})]):_vm._e()])]):_vm._e(),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-header--left"},[_c('div',{staticClass:"charts-header__logo"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-header--clear"},[_c('div',{staticClass:"charts-header--left"},[_vm._v("\n      Volume "),_c('img',{attrs:{"src":__webpack_require__("Z4oj")}})]),_vm._v(" "),_c('div',{staticClass:"charts-header--right"},[_c('img',{attrs:{"src":__webpack_require__("7wmZ")}}),_vm._v(" Price\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "95mA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    announcement: {
      type: Object,
      required: true
    }
  }
});

/***/ }),

/***/ "95qB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_insight_insight_panel_insight_panel_vue__ = __webpack_require__("QgOX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_insight_insight_link_insight_link_vue__ = __webpack_require__("DXdo");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    insightPanel: __WEBPACK_IMPORTED_MODULE_2__components_insight_insight_panel_insight_panel_vue__["a" /* default */],
    insightLink: __WEBPACK_IMPORTED_MODULE_3__components_insight_insight_link_insight_link_vue__["a" /* default */]
  },
  props: {
    numArticles: {
      type: Number,
      default: 4
    }
  },
  data: function data() {
    return {
      linkBack: {
        name: 'insight'
      },
      createLink: function createLink(url) {
        return {
          path: '/insight/' + btoa(encodeURI(url))
        };
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('insight', ['analysis']), {
    allArticlesAway: function allArticlesAway() {
      return !this.isLayoutMobile;
    },
    allArticlesLink: function allArticlesLink() {
      if (!this.isLayoutMobile) {
        return 'https://analysis.predictit.org/';
      }
      return {
        path: '/insight/' + btoa(encodeURI('//analysis.predictit.org/'))
      };
    },
    tumblr: function tumblr() {
      return this.analysis === null ? [] : this.analysis;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('insight', ['getMostPopular', 'getAnalysis'])),
  mounted: function mounted() {
    this.getAnalysis({
      limit: this.numArticles
    });
  }
});

/***/ }),

/***/ "9MVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button button--large button--submit button--full-width",attrs:{"type":_vm.type,"disabled":_vm.disabled}},[_c('span',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Q/H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9W9C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Wdi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-videos"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"home-videos__line"}),_vm._v(" "),_c('div',{staticClass:"home-videos__content"},[_c('youtube',{staticClass:"home-videos__player",attrs:{"player-width":"100%","player-height":240,"video-id":_vm.getYoutubeUrl}}),_vm._v(" "),_c('div',{staticClass:"home-videos__note"},[_vm._v("\n      For more information on how to trade on PredictIt, visit our "),_c('router-link',{staticClass:"home-videos__note-link",attrs:{"to":{name: 'HelpAndSupport'}}},[_vm._v("Support")]),_vm._v(" page.\n    ")],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-videos__header"},[_c('div',{staticClass:"home-videos__header-title"},[_vm._v("\n      How to Open an Account\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9aIe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"refine-history"},[_c('div',{staticClass:"refine-history__header"},[_vm._v("Market")]),_vm._v(" "),(_vm.list.length === 0)?_c('div',{staticClass:"refine-history__loaded-info"},[_vm._v("\r\n    No trades in the past 30 days\r\n  ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item){return (_vm.list.length > 0)?_c('refine-link',{key:item.marketId,staticClass:"refine-history__item",attrs:{"name":item.marketTitle,"data":item},on:{"click":_vm.onClick}}):_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9aRS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9cGE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onLogin: function onLogin() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'click',
        label: 'Login to My Account'
      });
      if (this.isPage) {
        this.$router.push({ name: 'account-page-login' });
      } else {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
      }
    }
  })
});

/***/ }),

/***/ "9eDo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_register_account_register_vue__ = __webpack_require__("61DT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_account_account_register_footer_footer_vue__ = __webpack_require__("cVuz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_landing_pages_hero_unit_slider_hero_unit_slider_vue__ = __webpack_require__("eLuk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_home_old_quotes_quotes_vue__ = __webpack_require__("PElc");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    accountRegister: __WEBPACK_IMPORTED_MODULE_0__components_account_account_register_account_register_vue__["a" /* default */],
    accountRegisterFooter: __WEBPACK_IMPORTED_MODULE_1__components_account_account_register_footer_footer_vue__["a" /* default */],
    heroUnitSlider: __WEBPACK_IMPORTED_MODULE_2__components_landing_pages_hero_unit_slider_hero_unit_slider_vue__["a" /* default */],
    quotes: __WEBPACK_IMPORTED_MODULE_3__components_home_home_old_quotes_quotes_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "9g4G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videos"},[_c('div',{staticClass:"row"},[(!_vm.asWidget)?_c('div',{staticClass:"column small-12"},[(_vm.isLayoutMobile)?_c('content-header',{attrs:{"title":"Videos"}}):_c('div',{staticClass:"videos__desktop-header"},[_c('router-link',{staticClass:"videos__back",attrs:{"to":{name: 'HelpAndSupport'},"tag":"span"}},[_vm._v("\r\n          Help and Support\r\n        ")])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column small-12"},[(!_vm.isLayoutMobile)?_c('div',{staticClass:"videos__header"},[_vm._v("Videos")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"videos__content"},_vm._l((_vm.videos),function(item){return _c('div',{attrs:{"id":item.id}},[_c('collapsible-panel',{key:item.title,attrs:{"isOpen":_vm.expanded,"title":item.title,"accordion":_vm.accordion,"id":item.id},on:{"open":_vm.accordionOpen}},[_c('youtube',{staticClass:"videos__player",attrs:{"player-width":"100%","player-height":220,"video-id":_vm.getYoutubeIdFromUrl(item.video)}})],1)],1)}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9hG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__ = __webpack_require__("DECz");



/* harmony default export */ __webpack_exports__["a"] = ({
  getBalance: function getBalance() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/Balance');
  },
  getDepositCard: function getDepositCard() {
    var utmCodeParam = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].get('utm_code');
    if (utmCodeParam) {
      return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/DepositCard?' + utmCodeParam.name + '=' + encodeURIComponent(utmCodeParam.value));
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/DepositCard');
  },
  postConfirmDepositCard: function postConfirmDepositCard(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/ConfirmDepositCard', marketingPayload);
  },
  postSubmitDepositCard: function postSubmitDepositCard(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/SubmitDepositCard', marketingPayload);
  },
  getPayNearMe: function getPayNearMe(page) {
    var utmCodeParam = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].get('utm_code');
    if (utmCodeParam) {
      return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/PayNearMe?page=' + page + '&' + utmCodeParam.name + '=' + encodeURIComponent(utmCodeParam.value));
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/PayNearMe?page=' + page);
  },
  getDepositUSDCoin: function getDepositUSDCoin() {
    var utmCodeParam = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].get('utm_code');
    if (utmCodeParam) {
      return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/DepositUSDCoin?' + utmCodeParam.name + '=' + encodeURIComponent(utmCodeParam.value));
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/DepositUSDCoin');
  },
  postSubmitDepositUSDCoin: function postSubmitDepositUSDCoin(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/DepositUSDCoin', marketingPayload);
  },
  getWithdrawAch: function getWithdrawAch() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawAch');
  },
  getWithdrawCheck: function getWithdrawCheck() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawCheck');
  },
  getWithdrawUSDC: function getWithdrawUSDC() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawUSDC');
  },
  postWithdrawAch: function postWithdrawAch(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawAch', payload);
  },
  postWithdrawCheck: function postWithdrawCheck(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawCheck', payload);
  },
  postWithdrawUSDC: function postWithdrawUSDC(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawUSDC', payload);
  },
  getPendingWithdrawals: function getPendingWithdrawals() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/PendingWithdrawals');
  },
  getPendingDeposits: function getPendingDeposits() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/PendingDeposits');
  },
  postCancelWithdrawal: function postCancelWithdrawal(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/CancelWithdrawal', payload);
  },
  getDepositMethods: function getDepositMethods() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/DepositMethods');
  },
  getWithdrawalMethods: function getWithdrawalMethods() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawalMethods');
  },
  getWithdrawWire: function getWithdrawWire() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawWire');
  },
  getWithdrawWireBankSearch: function getWithdrawWireBankSearch(page, query) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/WithdrawWireBankSearch?page=' + page + '&query=' + encodeURIComponent(query));
  },
  postWithdrawWireBankInfo: function postWithdrawWireBankInfo(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawWireBankInfo', payload);
  },
  postWithdrawWireConfirm: function postWithdrawWireConfirm(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawWireConfirm', payload);
  },
  postWithdrawWireSubmit: function postWithdrawWireSubmit(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/WithdrawWireSubmit', payload);
  },
  getDepositPWMB: function getDepositPWMB(_ref) {
    var authorizationId = _ref.authorizationId,
        returnUrl = _ref.returnUrl,
        cancelUrl = _ref.cancelUrl;

    var utmCodeParam = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].get('utm_code');
    if (utmCodeParam) {
      return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/DepositPWMB?AuthorizationIdToRefresh=' + authorizationId + '&requestedReturnUrl=' + returnUrl + '&requestedCancelUrl=' + cancelUrl + '&' + utmCodeParam.name + '=' + encodeURIComponent(utmCodeParam.value));
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/DepositPWMB?AuthorizationIdToRefresh=' + authorizationId + '&requestedReturnUrl=' + returnUrl + '&requestedCancelUrl=' + cancelUrl);
  },
  deletePWMBAuthorization: function deletePWMBAuthorization(authorizationId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].delete('api/User/Wallet/PWMBAuthorization/' + authorizationId);
  },
  postConfirmDepositPWMB: function postConfirmDepositPWMB(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/ConfirmDepositPWMB', marketingPayload);
  },
  postSubmitDepositPWMB: function postSubmitDepositPWMB(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_1__helpers_sessionVars__["a" /* default */].payload(payload, 'utm_code', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/DepositPWMB', marketingPayload);
  },
  getPWMBAuthorization: function getPWMBAuthorization() {
    var queryPart = decodeURIComponent(window.location.search.replace('?pwmbDeposit=success&', '').replace('?pwmbDeposit=cancel&', ''));
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/User/Wallet/PWMBAuthorization?redirectQueryStringPWMBPart=' + queryPart);
  },
  postInstantCredit: function postInstantCredit(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/User/Wallet/InstantCredit', payload);
  }
});

/***/ }),

/***/ "9k2S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('div',{class:_vm.menuClassModifier},[(_vm.shouldShowTimespanFilter)?_c('div',{staticClass:"market-filters-desktop-grid-watchlist__menu-timespan"},[_c('menu-button',{attrs:{"theme":"light","type":"timespan","name":_vm.selectedTimespan.name,"active":_vm.timespansOpen,"arrow":true},on:{"click":_vm.toggleTimespans}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-filters-desktop-grid-watchlist__menu-order"},[_c('span',[_vm._v("Sort By:")]),_vm._v(" "),_c('menu-button',{attrs:{"theme":"light","type":_vm.selectedOrder.sort,"name":_vm.orderMenuName,"active":_vm.ordersOpen,"arrow":true},on:{"click":_vm.toggleOrder}})],1)]),_vm._v(" "),(_vm.ordersOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-desktop-grid-watchlist__order"},_vm._l((_vm.orderList('markets')),function(order){return _c('menu-button',{key:order.sort,attrs:{"type":order.sort,"name":order.fullName,"selected":_vm.orderSelected(order.sort),"typeThemeEnabled":true},on:{"click":_vm.selectOrderAndClose}})}),1):_vm._e(),_vm._v(" "),(_vm.filtersOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-desktop-grid-watchlist__filters"},[_c('a',{staticClass:"market-filters-desktop-grid-watchlist__clear-all",on:{"click":function($event){$event.preventDefault();return _vm.onClearFilters($event)}}},[_vm._v("Clear Selections")]),_vm._v(" "),_vm._l((_vm.filters),function(category){return _c('div',{staticClass:"market-filters-desktop-grid-watchlist__filters-group"},[_c('h3',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_vm._l((category.filters),function(filter){return _c('filter-button',{key:_vm.filterKey(filter),attrs:{"id":filter.filterId,"name":filter.name,"selected":_vm.filterSelected(filter.filterId)},on:{"addFilter":_vm.onAddFilter,"removeFilter":_vm.onRemoveFilter}})})],2)})],2):_vm._e(),_vm._v(" "),(_vm.timespansOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-desktop-grid-watchlist__timespans"},_vm._l((_vm.availableTimespanOptions),function(timespan){return _c('menu-button',{key:timespan.parameter,attrs:{"type":timespan.parameter,"name":timespan.name},on:{"click":_vm.selectTimespanAndClose}})}),1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9kKf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_keyboard_numeric_input_keyboard_numeric_input_vue__ = __webpack_require__("HCce");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    keyboardNumericInput: __WEBPACK_IMPORTED_MODULE_3__components_keyboard_numeric_input_keyboard_numeric_input_vue__["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: 'Minimum Sell Price'
    },
    value: {
      type: Number,
      default: 50
    },
    kind: {
      type: String,
      default: 'modal'
    },
    selected: Boolean,
    tabindex: Number,
    minValue: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      cents: this.value !== null ? parseInt(this.value, 10) : 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    classModifier: function classModifier() {
      var _ref;

      return _ref = {
        'purchase-offer-value': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'purchase-offer-value--' + this.kind, this.kind), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'purchase-offer-value--selected', this.selected), _ref;
    }
  }),
  watch: {
    cents: 'updateOffer',
    value: function value(_value) {
      this.cents = _value !== null ? parseInt(_value, 10) : 0;
    }
  },
  methods: {
    add: function add() {
      if (isNaN(this.cents) || this.cents === null) this.cents = 0;
      this.cents += 1;
    },
    subtract: function subtract() {
      if (isNaN(this.cents) || this.cents === null) this.cents = 0;
      var newValue = this.cents - 1;
      this.cents = Math.max(newValue, this.minValue);
    },
    updateOffer: function updateOffer() {
      this.cents = parseInt(this.cents, 10);
      if (isNaN(this.cents) || this.cents < 1) this.cents = null;else if (this.cents > 99) this.cents = 99;

      if (this.cents !== null) {
        this.$emit('input', Number(this.cents));
      } else {
        this.$emit('input', this.cents);
      }
    },
    click: function click() {
      this.$emit('click');
    },
    onBoxClick: function onBoxClick() {
      if (this.isLayoutDesktop) {
        this.$refs.input.focus();
      }
    }
  }
});

/***/ }),

/***/ "9kST":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9pxA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");
/* eslint-disable max-len */


var DEFAULT_TIMELINE = '30d';

/* harmony default export */ __webpack_exports__["a"] = ({
  getMarketChartData: function getMarketChartData(_ref) {
    var marketId = _ref.marketId,
        _ref$timespan = _ref.timespan,
        timespan = _ref$timespan === undefined ? DEFAULT_TIMELINE : _ref$timespan,
        _ref$maxContracts = _ref.maxContracts,
        maxContracts = _ref$maxContracts === undefined ? 4 : _ref$maxContracts,
        _ref$storyId = _ref.storyId,
        storyId = _ref$storyId === undefined ? null : _ref$storyId,
        _ref$chartIndex = _ref.chartIndex,
        chartIndex = _ref$chartIndex === undefined ? null : _ref$chartIndex,
        _ref$sectionType = _ref.sectionType,
        sectionType = _ref$sectionType === undefined ? null : _ref$sectionType,
        _ref$chartStoryVersio = _ref.chartStoryVersionId,
        chartStoryVersionId = _ref$chartStoryVersio === undefined ? null : _ref$chartStoryVersio;

    var isTimespanInHours = timespan.includes('h');
    var finalTimespan = timespan.replace('h', '').replace('d', '');
    if (finalTimespan === '0') {
      finalTimespan = '';
    }
    if (storyId) {
      return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Public/GetMarketChartData/' + marketId + '?timespan=' + finalTimespan + '&maxContracts=' + maxContracts + '&isTimespanInHours=' + isTimespanInHours + '&chartIndex=' + chartIndex + '&chartStoryId=' + storyId + '&sectionType=' + (sectionType || '') + '&chartStoryVersionId=' + (chartStoryVersionId || ''));
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Public/GetMarketChartData/' + marketId + '?timespan=' + finalTimespan + '&maxContracts=' + maxContracts + '&isTimespanInHours=' + isTimespanInHours);
  },
  getContractChartData: function getContractChartData(contractId) {
    var timespan = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_TIMELINE;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Public/GetContractChartData/' + contractId + '?timespan=' + timespan);
  }
});

/***/ }),

/***/ "9qAd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9rUd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_promoCode__ = __webpack_require__("nPqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_depositWarningMixin__ = __webpack_require__("Scap");









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_promoCode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_depositWarningMixin__["a" /* default */]],
  data: function data() {
    return {
      disclaimer: '',
      buttonDisabled: false,
      url: null,
      error: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.loaderAdd();
    this.getPayNearMe('').then(function (data) {
      _this.loaderRemove();
      _this.url = data.url;
      _this.promoCodeDetail = data.promoCodeDetail || {};
      _this.disclaimer = data.disclaimer;
    }).catch(function (error) {
      _this.loaderRemove();
      _this.error = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', 'Your authorization to deposit by cash has been disabled.');
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('wallet', ['getPayNearMe']), {
    onDeposit: function onDeposit() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit Confirm',
        action: 'submit',
        label: 'Confirm Cash Deposit'
      });
      this.buttonDisabled = true;
      window.location.href = this.url;
    }
  })
});

/***/ }),

/***/ "9t11":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.maintenance.isMaintenanceEnabled)?_c('div',{staticClass:"maintenance-notification"},[_c('img',{staticClass:"maintenance-notification__logo",attrs:{"src":__webpack_require__("zxL1")}}),_vm._v(" "),_c('p',{staticClass:"maintenance-notification__info"},[(_vm.maintenance.maintenanceMessage)?[_vm._v("\n      "+_vm._s(_vm.maintenance.maintenanceMessage)+"\n    ")]:[_vm._v("\n      We are currently undergoing scheduled maintenance.\n    ")]],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9xGB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_back_button_js__ = __webpack_require__("NCFh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35087c4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_back_button_vue__ = __webpack_require__("P+qc");
function injectStyle (ssrContext) {
  __webpack_require__("blla")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_back_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35087c4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_back_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9xQS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_upload_document_account_upload_document_vue__ = __webpack_require__("3USW");


var documentUploadMixin = {
  data: function data() {
    return {
      documentUploadSource: 4,
      documentUploadInfoVisible: false,
      documentUploadInfoPending: false
    };
  },

  components: {
    accountUploadDocument: __WEBPACK_IMPORTED_MODULE_0__components_account_account_upload_document_account_upload_document_vue__["a" /* default */]
  },
  methods: {
    checkDocumentUploadFlags: function checkDocumentUploadFlags(data) {
      this.documentUploadInfoVisible = data.duRequired || data.duPending;
      this.documentUploadInfoPending = data.duPending;
      this.documentUploadSource = data.duSource || this.documentUploadSource;
      return data.duRequired || data.duPending;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (documentUploadMixin);

/***/ }),

/***/ "9zdy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_check_option_js__ = __webpack_require__("BEGL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f1c718_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_check_option_vue__ = __webpack_require__("2R3v");
function injectStyle (ssrContext) {
  __webpack_require__("Q1xv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_check_option_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f1c718_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_check_option_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A0/P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-forgotten"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('p',{staticClass:"account-forgotten__notification"},[_vm._v("\n      "+_vm._s(_vm.$txt('account-forgotten.disclaimer'))+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"account-forgotten__notification"},[_vm._v("\n      "+_vm._s(_vm.$txt('account-forgotten.notification'))+" "),_c('a',{attrs:{"href":("mailto:" + (_vm.systemEmails.support))}},[_vm._v(_vm._s(_vm.systemEmails.support))]),_vm._v(".\n    ")]),_vm._v(" "),_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('div',{staticClass:"row-y"},[_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.email,"name":"username","type":"email","placeholder":"Email","autocomplete":"off"},on:{"input":_vm.$v.fields.email.$touch},model:{value:(_vm.fields.email),callback:function ($$v) {_vm.$set(_vm.fields, "email", $$v)},expression:"fields.email"}})],1),_vm._v(" "),_c('div',{staticClass:"small-12 column"},[_c('form-captcha',{key:_vm.attempt,model:{value:(_vm.fields.captcha),callback:function ($$v) {_vm.$set(_vm.fields, "captcha", $$v)},expression:"fields.captcha"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form__section account-forgotten__submit"},[_c('form-submit',{attrs:{"disabled":_vm.resetButtonDisabled,"label":_vm.$txt('account-forgotten.button')}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A07q":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAAEEfUpiAAAAAXNSR0IArs4c6QAAA85JREFUWAntV81LVFEUv/fN6JsZ+1ADzYJCkDaKuyRoIerMLogWSZrOSAT+A62jgqBNu2hRi5xR+lAII1rkjEZFVBhBhpEgWS5Eiqw0Z96bnLmd82bu8747940zuGnRhfGc8zuf9+vcJyEw9KE4wx/y1uACp5YFV2qccVA09UUTdwtAB2ALO2Iv6vDHAcqZfEqTEJoihFUjbg6EqJcb5AEf0pwxXRN1jlpFhaPu+ti7KlGJvFWDL5Y4z7LsYl75qymwr262uzmNci4CI9ZCYVGA7Z5PLkGxuWGnoLq3ESFNrzyA1Bebardk/AOJKDM3FpDNmulFpEa48ynS3DTzKRDIp0HWGnYKDsiUG1jTqx15tcvFAJeXkJW+I6uyAU7LHtJ6EErpD8ZYjW0AjEa03tRA1x2O8RJysjQZIxKslSeVJdnbVaNP9qoDwHJxRTG63t2xzPXOCjjqTj/KFTmOG2z45t0QgshOgip/VkSkTN6ec2D4WUMmYy6J/sUyi3YO3heNL/mjkyccYBHBrgBt7FYgOVBK5gnVLhnhrmFJVdoaMEaaWDYb06OJPyUH8HhpG79jthNjXuhAQ7YMjPIcQMm3kn3BaaOn4zNcxquiAxztiCgXBIBFWTEioTPcyBwInoM78Z3LMi0IACepVh9KWA0FjfVo3ISse7gjJuA80oIAolLJV9DDIu48yqJGwVOitRunuz6Jqi0DmJGQLjrIfPlTkCL8IwFOjjKP+GhhlbIsVW6L1hTGumlmgyXf2yhhFRli9G7K7pzLbaQf4AQ2u7ttahyLWKEF6lFVqjPaOipAgA/5jeB4qRQu5ALT6KDZH4wX83HMoJihqIPgix7dvx9ekWkRF3noQY0kwyagya3vjCYOiTqR3/ImiMbIQ9JBePBu5PG2QDR+PMPIuGwnyIE0I69BdrywXF/GCtC3DQe9fmPATm7FSEZCD1paaiqhZb3kQQspq4ZG2lGIl9qNKJ2BwzKz/CVzTRVkdvbndXhR5+BjYkalR8xL/bMqnfsWiI80Y63QZ1thA/BNOSsHAtMwYJXqZx28KLn5O3z0q+yHsnsB+J2i/E5QhXHBKElr1NOTCnfed7EoUoCbhwpnNAlbtAIr8Q1m+4Zq5NExPTiOHUplLmLuKyBugeih4KHxFJzwMYWdCirjFqjct4/9L8DxFuC7+DCVmIQ22l50cSndgIPWafQHnxe1K0HpKIDb+0amuthGZgLkgi2CjncPWvEpbrtdqiwAg15gTLsSm3wMH3VBKwklq5Wap22tv3Nuu0nL8sd/OqGPXy7LqQzjv1PcMmiyG8e0AAAAAElFTkSuQmCC"

/***/ }),

/***/ "A7J2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A8Cw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_main_js__ = __webpack_require__("WLVe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e140e1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_main_vue__ = __webpack_require__("Of+R");
function injectStyle (ssrContext) {
  __webpack_require__("A7J2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_main_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e140e1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AM9x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getPlayerLeaderboards: function getPlayerLeaderboards() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/leaderboards');
  },
  getLeaderboards: function getLeaderboards() {
    var url = __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","FIREBASE_API_KEY_ANONYMOUS":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID_ANONYMOUS":"","FIREBASE_AUTH_DOMAIN_ANONYMOUS":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL_ANONYMOUS":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID_ANONYMOUS":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID_ANONYMOUS":"76708845910","FIREBASE_STORAGE_BUCKET_ANONYMOUS":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_FIREBASE":false,"ANONYMOUS_SIGNALR":false,"ORDER_BOOK_API_CALL_ENABLED":true,"ORDER_BOOK_FIREBASE_ENABLED":true,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","OPTIMOVE_ENABLED":true,"OPTIMOVE_SDK_TOKEN":"3b0d03cb1a8091dcf9b3f84bb2466b968ebf27e1b4d8a50c123316c0d129a99b","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","NEW_HEADER_ENABLED":false,"NEW_HEADER_EXCHANGE_URL":"https://exchange.predictit.com"}).USE_API_WRAPPER ? 'api/Public/GetLiveData?url=/api/Leaderboards' : 'api/Leaderboards';
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url);
  },
  getLeaderboard: function getLeaderboard(_ref) {
    var id = _ref.id,
        _ref$dateRange = _ref.dateRange,
        dateRange = _ref$dateRange === undefined ? 7 : _ref$dateRange,
        _ref$page = _ref.page,
        page = _ref$page === undefined ? 1 : _ref$page,
        _ref$itemsPerPage = _ref.itemsPerPage,
        itemsPerPage = _ref$itemsPerPage === undefined ? 30 : _ref$itemsPerPage;

    var encoded = encodeURIComponent('?daterange=' + dateRange + '&page=' + page + '&itemsPerPage=' + itemsPerPage);
    var url = __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","FIREBASE_API_KEY_ANONYMOUS":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID_ANONYMOUS":"","FIREBASE_AUTH_DOMAIN_ANONYMOUS":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL_ANONYMOUS":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID_ANONYMOUS":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID_ANONYMOUS":"76708845910","FIREBASE_STORAGE_BUCKET_ANONYMOUS":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_FIREBASE":false,"ANONYMOUS_SIGNALR":false,"ORDER_BOOK_API_CALL_ENABLED":true,"ORDER_BOOK_FIREBASE_ENABLED":true,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","OPTIMOVE_ENABLED":true,"OPTIMOVE_SDK_TOKEN":"3b0d03cb1a8091dcf9b3f84bb2466b968ebf27e1b4d8a50c123316c0d129a99b","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","NEW_HEADER_ENABLED":false,"NEW_HEADER_EXCHANGE_URL":"https://exchange.predictit.com"}).USE_API_WRAPPER ? 'api/Public/GetLiveData?url=/api/Leaderboards/' + id + encoded : 'api/Leaderboards/' + id + '?daterange=' + dateRange + '&page=' + page + '&itemsPerPage=' + itemsPerPage;
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url);
  }
});

/***/ }),

/***/ "ASm9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__ = __webpack_require__("BL43");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__["a" /* default */]],
  props: {
    showIcons: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isShutdownModeOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    classModifiers: function classModifiers() {
      return {
        'main-nav-old': true,
        'main-nav-old--shutdown': this.isShutdownModeOn
      };
    },
    filteredUrls: function filteredUrls() {
      return this.urls.filter(function (i) {
        return !i.disabled;
      });
    },
    urls: function urls() {
      if (this.isShutdownModeOn && !this.isLoggedIn) {
        return [
        // {
        //   title: 'Insights',
        //   name: 'insight',
        //   href: '/insight',
        // },
        {
          title: 'Support',
          name: 'help',
          href: '/support'
        }];
      }

      if (this.isShutdownModeOn && this.isLoggedIn && this.isLayoutMobile) {
        return [{
          title: 'Account',
          name: 'account',
          href: this.accountLink
        }, {
          title: 'Dashboard',
          name: 'dashboard',
          href: '/dashboard'
        }, {
          title: 'Support',
          name: 'help',
          href: '/support'
        }];
      }

      if (this.isShutdownModeOn && this.isLoggedIn && !this.isLayoutMobile) {
        return [{
          title: 'Account',
          name: 'account',
          href: this.accountLink
        }, {
          title: 'Dashboard',
          name: 'dashboard',
          href: '/dashboard'
        }, {
          title: 'Support',
          name: 'help',
          href: '/support'
        }];
      }

      if (this.isLoggedIn && this.isLayoutMobile) {
        return [{
          title: 'Markets',
          name: 'markets',
          href: '/markets'
        }, {
          title: 'Trends',
          name: 'trends',
          href: '/trends'
        }, {
          title: 'Dashboard',
          name: 'dashboard',
          href: '/dashboard'
        }, {
          title: 'Leaderboards',
          name: 'leaderboards',
          href: '/leaderboards',
          disabled: !false
        }, {
          title: 'Account',
          name: 'account',
          href: this.accountLink
        }, {
          title: 'Support',
          name: 'help',
          href: '/support',
          disabled: false
        }];
      }

      if (this.isLoggedIn && !this.isLayoutMobile) {
        return [{
          title: 'Markets',
          name: 'markets',
          href: '/markets'
        }, {
          title: 'Trends',
          name: 'trends',
          href: '/trends'
        }, {
          title: 'Leaderboards',
          name: 'leaderboards',
          href: '/leaderboards',
          disabled: !false
        }, {
          title: 'Account',
          name: 'account',
          href: this.accountLink
        }, {
          title: 'Dashboard',
          name: 'dashboard',
          href: '/dashboard'
        }];
      }

      return [{
        title: 'Markets',
        name: 'markets',
        href: '/markets'
      },
      // {
      //   title: 'Insights',
      //   name: 'insight',
      //   href: '/insight',
      // },
      {
        title: 'Leaderboards',
        name: 'leaderboards',
        href: '/leaderboards',
        disabled: !false
      }, {
        title: 'Support',
        name: 'help',
        href: '/support'
      }];
    }
  }),
  methods: {
    classModifier: function classModifier(name) {
      var _ref;

      var routes = ['market-details'];
      var dontHighlight = routes.includes(this.$route.name);
      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'main-nav-old__link-with-icon main-nav-old__link-with-icon--' + name, this.showIcons), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'main-nav-old__link--no-highlight', dontHighlight), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'main-nav-old__link', true), _ref;
    },
    showSocialAvatarOnMobile: function showSocialAvatarOnMobile(item) {
      return this.isLayoutMobile && item.name === 'dashboard' && this.isLoggedIn;
    },
    showRegularItem: function showRegularItem(item) {
      return this.isLayoutMobile ? item.name !== 'dashboard' : true;
    },
    onAvatarClick: function onAvatarClick() {
      this.$router.push({ name: 'portfolio' });
    },
    onLinkClick: function onLinkClick(href) {
      // scroll page to top if link is clicked again
      if (this.$route && this.$route.path === href) {
        window.scrollTo(0, 0);
      }
    }
  }
});

/***/ }),

/***/ "AUn5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-old__wrap"},[_c('app-header-notification'),_vm._v(" "),_c('header',{staticClass:"header-old"},[_c('div',{staticClass:"header-old-primary"},[_c('div',{staticClass:"header-old-primary__menu"},[_c('div',{staticClass:"header-old-primary__menu-logo"},[_c('router-link',{attrs:{"to":{name: 'home'},"id":"pl-logo"}},[_c('img',{staticClass:"header-old-primary__logo",attrs:{"src":__webpack_require__("zxL1")}})])],1),_vm._v(" "),(_vm.isLoggedIn)?_c('div',{class:_vm.headerPrimaryMenuModifiers},[_c('div',{staticClass:"header-old-primary__menu-nav-left"},[_c('app-main-nav',{staticClass:"header-old-primary__menu-main-nav"}),_vm._v(" "),(_vm.showSocialAvatarDesktop)?_c('div',{staticClass:"header-old-primary__menu-avatar",on:{"click":function($event){$event.preventDefault();return _vm.onAvatarClick($event)}}},[_vm._v("\n               \n               "),_c('account-social-avatar',{key:_vm.userAvatar,attrs:{"theme":"nav-top","avatar":_vm.userAvatar,"showProgress":true,"percentage":100,"progressStrokeColor":_vm.levelColorWithRespectToNav,"showEdit":false}},[_c('span',{attrs:{"slot":"label","id":"nav-dashboard"},on:{"click":function($event){$event.stopPropagation();return _vm.onAvatarClick($event)}},slot:"label"},[_vm._v("Dashboard")])])],1):_vm._e(),_vm._v(" "),(!_vm.isShutdownModeOn)?_c('div',{class:_vm.notificationsIconModifiers,on:{"click":function($event){$event.stopPropagation();return _vm.onNotificationsClick($event)}}},[(_vm.showUnreadNotificationCount)?_c('div',{staticClass:"header-old-primary__menu-notifications-count"},[_vm._v("\n                "+_vm._s(_vm.userUnreadNotificationsCountHeader)+"\n              ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"header-old-primary__menu-notifications-widget"}},[(_vm.showNotificationsWidget)?_c('div',{staticClass:"header-old-primary__menu-notifications-widget"},[_c('notifications-widget')],1):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"header-old-primary__menu-nav-right"},[(_vm.showBalanceHeader)?[(_vm.isLayoutDesktop)?_c('router-link',{staticClass:"header-old-primary__menu-item",attrs:{"id":"investment","tag":"div","to":{ name: 'portfolio' }}},[_c('div',{directives:[{name:"price-display",rawName:"v-price-display.floor.fixed",value:(_vm.balance.portfolioBalanceDecimal),expression:"balance.portfolioBalanceDecimal",modifiers:{"floor":true,"fixed":true}}],staticClass:"header-old-primary__menu-item--total-investment"}),_vm._v(" "),_c('div',{staticClass:"header-old-primary__menu-item__title"},[_vm._v("Investment")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"header-old-primary__menu-item",attrs:{"id":"cash"},on:{"click":_vm.onCashClick}},[_c('div',{directives:[{name:"price-display",rawName:"v-price-display.floor.fixed",value:(_vm.balance.accountBalanceDecimal),expression:"balance.accountBalanceDecimal",modifiers:{"floor":true,"fixed":true}}],class:_vm.valueClassModifiers}),_vm._v(" "),_c('div',{staticClass:"header-old-primary__menu-item__title"},[_vm._v("Cash")])])]:_vm._e(),_vm._v(" "),(!_vm.isShutdownModeOn)?[_c('div',{staticClass:"header-old-primary__menu-item",attrs:{"id":"nav-deposit"},on:{"click":function($event){$event.preventDefault();return _vm.openDepositPopup($event)}}},[_c('span',{class:_vm.depositIconModifiers}),_vm._v(" "),_c('div',{class:_vm.depositTitleModifiers},[_vm._v("Deposit")])]),_vm._v(" "),(_vm.isLayoutMobile)?_c('div',{staticClass:"header-old-primary__menu-item"},[_c('div',{class:_vm.notificationsIconModifiers,on:{"click":function($event){$event.stopPropagation();return _vm.onNotificationsClick($event)}}},[(_vm.showUnreadNotificationCount)?_c('div',{staticClass:"header-old-primary__menu-notifications-count"},[_vm._v("\n                    "+_vm._s(_vm.userUnreadNotificationsCountHeader)+"\n                  ")]):_vm._e()])]):_vm._e()]:_vm._e()],2)]):_c('div',{staticClass:"header-old-primary__menu-nav"},[(!_vm.isUserRestricted)?_c('div',{staticClass:"header-old-primary__menu-nav-left"},[_c('app-main-nav')],1):_vm._e(),_vm._v(" "),(_vm.showLoginAndSignUpButtons)?_c('div',{staticClass:"header-old-primary__menu-nav-right"},[_c('button',{staticClass:"button button--white",attrs:{"id":"login"},on:{"click":function($event){return _vm.setCurrentPopup(_vm.MODALS.LOGIN)}}},[_vm._v("Login")]),_vm._v(" "),(!_vm.isUserRestricted && !_vm.isShutdownModeOn)?_c('button',{staticClass:"button button--darken",attrs:{"id":"signup"},on:{"click":_vm.onSignUp}},[_vm._v("Sign Up")]):_vm._e()]):_vm._e()]),_vm._v(" "),(!_vm.isUserRestricted && !_vm.isShutdownModeOn)?_c('div',{staticClass:"header-old-primary__menu-search"},[_c('button',{staticClass:"button header-old-primary__search-button",attrs:{"id":"search"},on:{"click":_vm.toggleSearchBar}},[_vm._v("Search")])]):_vm._e()])])]),_vm._v(" "),(!_vm.isUserRestricted && !_vm.isShutdownModeOn && !_vm.areUserBrowseHeadersEmpty)?_c('app-secondary-nav'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AYJx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AYS5":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "AZoq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_maxBy__ = __webpack_require__("K1hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__("lHK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__ = __webpack_require__("nYw4");







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ready: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('market', ['mapStateData']), {
    meStyleModifiers: function meStyleModifiers() {
      return this.getContractInfo('ME');
    },
    me1StyleModifiers: function me1StyleModifiers() {
      return this.getContractInfo('ME-01');
    },
    me2StyleModifiers: function me2StyleModifiers() {
      return this.getContractInfo('ME-02');
    },
    me3StyleModifiers: function me3StyleModifiers() {
      return this.getContractInfo('ME-03');
    },
    neStyleModifiers: function neStyleModifiers() {
      return this.getContractInfo('NE');
    },
    ne1StyleModifiers: function ne1StyleModifiers() {
      return this.getContractInfo('NE-01');
    },
    ne2StyleModifiers: function ne2StyleModifiers() {
      return this.getContractInfo('NE-02');
    },
    ne3StyleModifiers: function ne3StyleModifiers() {
      return this.getContractInfo('NE-03');
    }
  }),
  watch: {
    mapStateData: {
      handler: 'mapStateDataHandler',
      immediate: true
    }
  },
  methods: {
    getContractInfo: function getContractInfo(key) {
      var data = this.mapStateData[key] || null;
      if (data === null) {
        return {
          background: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].GRAY[__WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].MEDIUM].color
        };
      }
      var targetContract = __WEBPACK_IMPORTED_MODULE_1_lodash_maxBy___default()(data.contracts, function (j) {
        return j.lastTradePrice;
      });
      var colorMap = targetContract.contractName === __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["d" /* CONTRACTS */].DEMOCRATIC ? __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE : __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED;
      var index = null;
      if (targetContract.lastTradePrice <= __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["e" /* PRICE_FACTORS */].LOW) {
        index = __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].LOW;
      } else if (targetContract.lastTradePrice <= __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["e" /* PRICE_FACTORS */].MEDIUM) {
        index = __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].MEDIUM;
      } else if (targetContract.lastTradePrice <= __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["e" /* PRICE_FACTORS */].HIGH) {
        index = __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH;
      }
      return {
        color: '#fff',
        background: colorMap[index].color
      };
    },
    mapStateDataHandler: function mapStateDataHandler(value) {
      if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(value)) {
        this.ready = true;
      }
    }
  }
});

/***/ }),

/***/ "Aq5e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_trades_js__ = __webpack_require__("1vcp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2984aaf1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trades_vue__ = __webpack_require__("t4XB");
function injectStyle (ssrContext) {
  __webpack_require__("BPxL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_trades_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2984aaf1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trades_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Aqlg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_update_image_js__ = __webpack_require__("Ug2n");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58455a24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_update_image_vue__ = __webpack_require__("GnOr");
function injectStyle (ssrContext) {
  __webpack_require__("rpQZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_update_image_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58455a24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_update_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AsKc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-price-change-chart"},[_c('div',{ref:"chart",staticClass:"market-price-change-chart__chart"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AsO2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    balance: {
      type: String
    },
    restricted: {
      type: String,
      default: ''
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    onInfoClick: function onInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_RESTRICTED_FUNDS_INFO);
    }
  })
});

/***/ }),

/***/ "Atob":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-desktop"},[_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column large-4 dashboard-desktop__sticky"},[_c('div',{staticClass:"dashboard-desktop__badge"},[_c('account-social-badge')],1),_vm._v(" "),_c('public-profile-widget'),_vm._v(" "),(_vm.showInfo)?[_c('div',{staticClass:"dashboard-desktop__header-widget-info"},[_vm._v("\r\n          Leaderboard Rank (Past Week)\r\n        ")]),_vm._v(" "),_c('leaderboards-info')]:_vm._e(),_vm._v(" "),(_vm.isUserVerified)?_c('div',{staticClass:"dashboard-desktop__share-invite"},[_c('share-invite-widget')],1):_vm._e()],2),_vm._v(" "),(_vm.showMyMarkets)?_c('div',{staticClass:"column large-8"},[_c('div',{staticClass:"dashboard-desktop__markets"},[_c('div',{staticClass:"dashboard-desktop__header"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"dashboard-desktop__header-right"},[_c('div',{staticClass:"dashboard-desktop__header-subtitle"},[_vm._v("\r\n              Portfolio Value\r\n            ")]),_vm._v(" "),(_vm.portfolioValueReady)?_c('div',{directives:[{name:"price-display",rawName:"v-price-display.fixed",value:(_vm.portfolioValueDecimal),expression:"portfolioValueDecimal",modifiers:{"fixed":true}}],staticClass:"dashboard-desktop__header-title"}):_vm._e()]),_vm._v(" "),_c('div',[_c('div',{staticClass:"dashboard-desktop__header-subtitle"},[_vm._v("\r\n              Gain/Loss\r\n            ")]),_vm._v(" "),(_vm.portfolioValueReady)?_c('div',{directives:[{name:"price-display",rawName:"v-price-display.fixed",value:(Math.abs(_vm.mySharesTotalGainLoss)),expression:"Math.abs(mySharesTotalGainLoss)",modifiers:{"fixed":true}}],staticClass:"dashboard-desktop__header-title",class:_vm.gainLossClassModifiers}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-9"},[_c('dashboard-market-filters')],1),_vm._v(" "),_c('div',{staticClass:"column small-3"},[_c('dashboard-markets-toggle')],1)]),_vm._v(" "),_c('portfolio-my-markets')],1)]):_vm._e(),_vm._v(" "),(_vm.showNotifications)?_c('div',{staticClass:"column large-8"},[_c('div',{staticClass:"dashboard-desktop__notifications-title"},[_vm._v("\r\n        Notifications\r\n      ")]),_vm._v(" "),_c('notifications-list',{attrs:{"theme":"dashboard-full"}})],1):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-desktop__header-left"},[_c('div',{staticClass:"dashboard-desktop__header-title"},[_vm._v("My Markets")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AxKI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_account_social_avatar_account_social_avatar_vue__ = __webpack_require__("ROsZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_userDetails__ = __webpack_require__("jtWA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");











/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_userDetails__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_socialLevel__["a" /* default */]],
  components: {
    accountSocialAvatar: __WEBPACK_IMPORTED_MODULE_5__components_account_account_social_avatar_account_social_avatar_vue__["a" /* default */],
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a
  },
  data: function data() {
    return {
      infiniteLoader: null,
      isLoading: false
    };
  },

  watch: {
    isLoggedIn: {
      handler: 'leaderboardsParamChangeHandler'
    },
    leaderboardsDateRange: {
      handler: 'leaderboardsParamChangeHandler'
    },
    selectedLeaderboard: {
      handler: 'leaderboardsParamChangeHandler',
      immediate: true
    },
    rows: function rows() {
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        if (!this.leaderboardsResults.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('leaderboards', ['selectedLeaderboard']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('leaderboards', ['leaderboardsDateRange', 'leaderboardsResults']), {
    rows: function rows() {
      var _this = this;

      var items = this.leaderboardsResults.data === null ? [] : this.leaderboardsResults.data;
      if (this.leaderboardsResults.trader) {
        return [this.leaderboardsResults.trader].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(items.filter(function (i) {
          return i.userName !== _this.leaderboardsResults.trader.userName;
        })));
      }
      return items;
    },
    infiniteLoadingKey: function infiniteLoadingKey() {
      return this.selectedLeaderboard.leaderBoardId + '-' + this.leaderboardsDateRange + '-' + this.isLoggedIn.toString();
    },
    showNoDataMessage: function showNoDataMessage() {
      return !this.isLoading && this.rows.length === 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('leaderboards', ['resetLeaderboardsResults', 'getLeaderboardsResults']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    range: function range(limit) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash_range___default()(0, limit);
    },
    goInfinite: function goInfinite(infi) {
      this.infiniteLoader = infi;

      if (this.leaderboardsResults.canLoadMore) {
        this.loadLeaderboardRows();
      }
    },
    loadLeaderboardRows: function loadLeaderboardRows() {
      var _this2 = this;

      this.isLoading = true;
      this.getLeaderboardsResults().then(function () {
        _this2.isLoading = false;
      }).catch(function () {
        _this2.isLoading = false;
        _this2.infiniteLoader.complete();
        _this2.infiniteLoader = null;
      });
    },
    leaderboardsParamChangeHandler: function leaderboardsParamChangeHandler(newValue) {
      if (newValue) {
        this.resetLeaderboardsResults();
        this.infiniteLoader = null;
      }
    },
    traderLevelColor: function traderLevelColor(item) {
      return this.getLevelByNumber(item.traderLevel).currentColor;
    },
    traderLevelDisplay: function traderLevelDisplay(item) {
      var level = this.getLevelByNumber(item.traderLevel);
      return 'Level ' + level.num + ' (' + level.text + ')';
    },
    traderRoiDisplay: function traderRoiDisplay(item) {
      var value = Math.abs(item.roi * 100);
      var fractionDigits = value >= 1000 ? 0 : 1;
      var roi = value.toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      });
      return roi + '%';
    },
    isItemCurrentUser: function isItemCurrentUser(item) {
      return this.leaderboardsResults.trader && this.leaderboardsResults.trader.userName === item.userName;
    },
    rowClassModifiers: function rowClassModifiers(item) {
      return {
        'leaderboards-table__row': true,
        'leaderboards-table__row--me': this.isItemCurrentUser(item)
      };
    },
    roiModifiers: function roiModifiers(item) {
      return {
        'leaderboards-table__row-roi': true,
        'leaderboards-table__row-roi--gain': item.roi > 0,
        'leaderboards-table__row-roi--loss': item.roi < 0
      };
    },
    arrowChangeClassModifiers: function arrowChangeClassModifiers(item) {
      return {
        'leaderboards-table__row-change-arrow': true,
        'leaderboards-table__row-change-arrow--up': item.rankChange > 0,
        'leaderboards-table__row-change-arrow--down': item.rankChange < 0
      };
    },
    showRankChange: function showRankChange(item) {
      return item.rankChange !== null && item.rankChange !== 0;
    },
    onAvatarClick: function onAvatarClick(item) {
      if (this.isItemCurrentUser(item)) return;
      this.showUserDetails(item);
    },
    onRoiInfoClick: function onRoiInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_ROI_INFO);
    },
    onWinsInfoClick: function onWinsInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_WINS_INFO);
    }
  })
});

/***/ }),

/***/ "AyUZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_platform_announcements_js__ = __webpack_require__("dLt5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69a405ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_platform_announcements_vue__ = __webpack_require__("lfj9");
function injectStyle (ssrContext) {
  __webpack_require__("MO++")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_platform_announcements_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69a405ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_platform_announcements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B/8G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_daily_markets_js__ = __webpack_require__("nGgz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44f2dd85_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_markets_vue__ = __webpack_require__("shsd");
function injectStyle (ssrContext) {
  __webpack_require__("8IYq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_daily_markets_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44f2dd85_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_markets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B1Dv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B1kG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.showProgress)?_c('div',{staticClass:"account-social-avatar__progress-container",on:{"click":_vm.onShowEditPopup}},[_c('svg',{staticClass:"account-social-avatar__progress",attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 120 120"}},[(_vm.percentage < 100)?_c('circle',{staticClass:"account-social-avatar__progress-meter",attrs:{"cx":"60","cy":"60","r":_vm.radius,"stroke-width":_vm.strokeWidth,"stroke":_vm.backgroundStrokeColor}}):_vm._e(),_vm._v(" "),_c('circle',{staticClass:"account-social-avatar__progress-value",style:(_vm.styleModifiers),attrs:{"cx":"60","cy":"60","r":_vm.radius,"stroke-width":_vm.strokeWidth}})])]):_vm._e(),_vm._v(" "),(_vm.avatar)?_c('div',{class:_vm.imageClassModifiers,style:(_vm.imageStyleModifiers),on:{"click":_vm.onShowEditPopup}}):_vm._e(),_vm._v(" "),(_vm.showNotificationsCount)?_c('div',{staticClass:"account-social-avatar__notifications-count"},[_vm._v("\n    "+_vm._s(_vm.notificationsCount)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.hasLabel)?_c('div',{class:_vm.labelClassModifiers},[_vm._t("label"),_vm._v(" "),_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.isEditEnabled)?_c('div',{staticClass:"account-social-avatar__edit-photo",on:{"click":_vm.onShowEditPopup}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B7kp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-login"},[_c('div',{staticClass:"account-login__socials"},[_c('form-socials',{attrs:{"title":"Login through"}})],1),_vm._v(" "),_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--new"},[_vm._v("\r\n          "+_vm._s(_vm.$txt('account-login.title'))+"\r\n        ")])]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.email,"disabled":_vm.isFormDisabled,"name":"username","type":"email","required":true,"autocomplete":"off","placeholder":"Email"},on:{"input":_vm.$v.fields.email.$touch,"focus":_vm.hideFooter,"blur":_vm.showFooter},model:{value:(_vm.fields.email),callback:function ($$v) {_vm.$set(_vm.fields, "email", $$v)},expression:"fields.email"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"hideIconOnValue":false,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.password,"name":"password","type":_vm.fieldTypePassword,"required":true,"autocomplete":"off","placeholder":"Password"},on:{"input":_vm.$v.fields.password.$touch,"focus":_vm.hideFooter,"blur":_vm.showFooter},model:{value:(_vm.fields.password),callback:function ($$v) {_vm.$set(_vm.fields, "password", $$v)},expression:"fields.password"}},[(!_vm.isIE)?_c('show-password-icon',{attrs:{"slot":"icon"},on:{"showPassword":_vm.showPassword},slot:"icon"}):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('form-checkbox',{attrs:{"name":"rememberMe","label":"Keep Me Logged In"},model:{value:(_vm.fields.rememberMe),callback:function ($$v) {_vm.$set(_vm.fields, "rememberMe", $$v)},expression:"fields.rememberMe"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('div',{staticClass:"account-login__forgotten-password"},[_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.onForgotten($event)}}},[_vm._v(_vm._s(_vm.$txt('account-login.forgot')))])])]),_vm._v(" "),_c('div',{staticClass:"small-12 column"},[_c('form-captcha',{key:_vm.attempt,model:{value:(_vm.fields.captcha),callback:function ($$v) {_vm.$set(_vm.fields, "captcha", $$v)},expression:"fields.captcha"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-submit',{attrs:{"disabled":_vm.loginButtonDisabled,"label":_vm.$txt('account-login.button')}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B8JL":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "BEGL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_checkbox_checkbox_vue__ = __webpack_require__("vXhB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_currency_input_currency_input_vue__ = __webpack_require__("xMYI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_loader__ = __webpack_require__("39kf");










var DEBOUNCE_TIME = 1000;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_loader__["a" /* default */]],
  components: {
    formCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_forms_checkbox_checkbox_vue__["a" /* default */],
    currencyInput: __WEBPACK_IMPORTED_MODULE_6__components_forms_currency_input_currency_input_vue__["a" /* default */]
  },
  props: {
    category: {
      type: String,
      required: true
    },
    obj: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      checked: false,
      errorChecked: null,
      value: this.initialValue,
      errorValue: null,
      debounceUpdate: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('profile', ['settings']), {
    name: function name() {
      return this.obj.key;
    },
    checkboxName: function checkboxName() {
      return '' + this.category + this.name;
    },
    withValue: function withValue() {
      return this.obj.withValue;
    },
    getSettingsChecked: function getSettingsChecked() {
      return this.settings[this.category][this.name];
    },
    getSettingsValue: function getSettingsValue() {
      return this.withValue ? this.settings[this.category][this.withValue] : 0;
    },
    classObject: function classObject() {
      return {
        'check-option': true,
        'check-option--with-value': this.withValue,
        'check-option--disabled': this.disabled
      };
    },
    initialValue: function initialValue() {
      return 10;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('profile', ['updateSettings'])),
  created: function created() {
    var _this = this;

    this.checked = this.getSettingsChecked;
    var parsed = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(this.getSettingsValue, 10);
    this.value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(parsed) ? this.initialValue : parsed;

    this.$watch('checked', function (val, old) {
      if (_this.errorChecked !== val) {
        _this.loaderAdd();
        _this.updateSettings({
          category: _this.category,
          key: _this.name,
          value: val
        }).then(function () {
          return _this.loaderRemove();
        }).catch(function () {
          _this.loaderRemove();
          _this.errorChecked = old;
          _this.checked = _this.errorChecked;
          _this.$emit('error', 'Could not set "' + _this.obj.info + '"');
        });
      } else {
        _this.errorChecked = null;
      }
    });

    this.debounceUpdate = __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function (val) {
      _this.updateSettings({
        category: _this.category,
        key: _this.withValue,
        value: val
      }).catch(function () {
        _this.errorValue = _this.getSettingsValue;
        _this.value = _this.errorValue;
        _this.$emit('error', 'Could not set "' + _this.obj.info + '"');
      });
    }, DEBOUNCE_TIME, { trailing: true });

    if (this.withValue) {
      this.$watch('value', function (val) {
        // prevents watch endless loop
        if (_this.errorValue !== val) {
          _this.debounceUpdate(val);
        } else {
          _this.errorValue = null;
        }
      });
    }
  }
});

/***/ }),

/***/ "BL43":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



// const ROUTES_TO_HIDE_COUNT = [
//   'portfolio',
// ];

var unreadNotificationMixin = {
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['userUnreadNotificationsCount']), {
    userUnreadNotificationsCountHeader: function userUnreadNotificationsCountHeader() {
      // if (this.$route && ROUTES_TO_HIDE_COUNT.includes(this.$route.name)) return 0;
      return this.userUnreadNotificationsCount;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('dashboard', ['markNotificationsAsRead']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['setUserUnreadNotificationsCount']), {
    clearAllNotifications: function clearAllNotifications() {
      this.markNotificationsAsRead();
      this.setUserUnreadNotificationsCount(0);
    }
  })
};

/* harmony default export */ __webpack_exports__["a"] = (unreadNotificationMixin);

/***/ }),

/***/ "BPxL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BQl6":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "BUtN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BXSV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-watchlist"},[(_vm.isLayoutMobile)?[_c('market-filters-mobile'),_vm._v(" "),_c('div',{staticClass:"page-watchlist__title"},[_vm._v("\n      Watchlist\n    ")])]:[_c('div',{staticClass:"page-watchlist__title"},[_c('div',{staticClass:"page-watchlist__title-text"},[_vm._v("\n        Watchlist\n      ")]),_vm._v(" "),_c('div',{staticClass:"page-watchlist__title-filters"},[_c('market-filters-desktop-grid')],1)])],_vm._v(" "),(_vm.items)?_c('div',{staticClass:"page-watchlist__grid"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"page-watchlist__grid-item"},[_c('market-list-item',{key:item.marketId,attrs:{"watchIcon":true,"market":item},on:{"watchToggle":function($event){return _vm.onRemoveMarketFromWatchList(item)}}})],1)}),0):_vm._e(),_vm._v(" "),(_vm.watchlist.canLoadMore)?_c('infinite-loading',{key:_vm.infiniteLoadingKey,on:{"infinite":_vm.goInfinite}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('div',{staticClass:"page-watchlist__spinner"})]),_vm._v(" "),_c('span',{attrs:{"slot":"no-results"},slot:"no-results"}),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})]):_vm._e(),_vm._v(" "),(_vm.showNoMarketsMessage)?_c('div',{staticClass:"page-watchlist__no-markets-found"},[_vm._v("\n    There are no markets in your Watchlist.\n  ")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bkaa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BmES":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_appNotification__ = __webpack_require__("qtti");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_plus_minus_sign_plus_minus_sign_vue__ = __webpack_require__("T2le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_modules_notifications__ = __webpack_require__("t45u");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_appNotification__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["b" /* formMixin */]],
  components: {
    plusMinusSign: __WEBPACK_IMPORTED_MODULE_2__components_generics_plus_minus_sign_plus_minus_sign_vue__["a" /* default */]
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      dontShowAgain: false,
      advanced: false
    };
  },

  computed: {
    showFooter: function showFooter() {
      return !false;
    },
    minPrice: function minPrice() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* toCents */])(this.data.Offer.PricePerShare);
    },
    minPriceDisplay: function minPriceDisplay() {
      var suffix = this.minPrice === 1 ? 'cent' : 'cents';
      return this.minPrice + ' ' + suffix;
    },
    profit: function profit() {
      return this.data.TotalProfit;
    },
    fee: function fee() {
      return this.data.TotalFees;
    },
    cost: function cost() {
      return this.data.TotalCost;
    },
    risk: function risk() {
      return this.data.TotalRiskChange;
    },
    showRisk: function showRisk() {
      return this.data.ShowRisk;
    },
    contractName: function contractName() {
      return this.data.Name || this.data.LongName;
    },
    marketName: function marketName() {
      return this.data.MarketName;
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["l" /* isMarketSingle */])(this.data);
    },
    history: function history() {
      var source = this.data.History ? this.data.History.map(function (i) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, i);
      }) : [];
      return source.map(function (h) {
        h.PricePerShare = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* toCents */])(h.PricePerShare);
        return h;
      }) || [];
    },
    defaultTradeType: function defaultTradeType() {
      return parseInt(this.data.Offer.TradeType, 10) || 0;
    },
    offerType: function offerType() {
      return this.data.Offer.TradeType;
    },
    remainingQuantity: function remainingQuantity() {
      return this.data.Offer.RemainingQuantity;
    },
    isOfferProcessed: function isOfferProcessed() {
      return this.data.History !== null && this.data.History.length > 0 && this.data.Offer.RemainingQuantity !== 0;
    },
    isOfferMatched: function isOfferMatched() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__store_modules_notifications__["a" /* isOfferMatched */])(this.data);
    },
    isOpenOfferRecorded: function isOpenOfferRecorded() {
      return this.data.Offer.RemainingQuantity !== 0;
    },
    isProcessedOrMatched: function isProcessedOrMatched() {
      return this.isOfferProcessed || this.isOfferMatched;
    },
    offerStatusLongText: function offerStatusLongText() {
      if (this.isOfferProcessed) return 'Shares Traded!';
      if (this.isOfferMatched) return 'Shares Traded!';
      if (this.isOpenOfferRecorded) return 'Offer Recorded';
      return null;
    },
    showHistory: function showHistory() {
      return this.isProcessedOrMatched && this.history && this.history.length > 0;
    },
    showCashFooter: function showCashFooter() {
      return this.isProcessedOrMatched && this.advanced;
    },
    showToggle: function showToggle() {
      return this.isProcessedOrMatched;
    },
    showProfitLoss: function showProfitLoss() {
      return this.defaultTradeType > 1;
    },
    showFees: function showFees() {
      return this.defaultTradeType > 1 && this.fee !== 0;
    },
    shareText: function shareText() {
      if (this.history.length > 0) {
        if (this.defaultTradeType <= 1) {
          // show max price when user buy shares
          var _h = this.history.reduce(function (prev, current) {
            return prev.PricePerShare > current.PricePerShare ? prev : current;
          });
          return this.getShareText('buy', _h.Quantity, _h.PricePerShare);
        }
        // show min price when user sell shares
        var h = this.history.reduce(function (prev, current) {
          return prev.PricePerShare < current.PricePerShare ? prev : current;
        });
        return this.getShareText('sell', h.Quantity, h.PricePerShare);
      }
      if (this.defaultTradeType <= 1) {
        return this.getShareText('buy-offer', this.remainingQuantity, this.minPrice);
      }
      return this.getShareText('sell-offer', this.remainingQuantity, this.minPrice);
    },
    shareUrl: function shareUrl() {
      var resolved = this.$router.resolve({
        name: 'market-details',
        params: {
          marketId: this.data.MarketId,
          marketUrl: this.data.MarketUrl
        }
      });
      return '' + window.location.origin + resolved.href;
    },
    facebookShareUrl: function facebookShareUrl() {
      var pictureUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["s" /* getAssetPath */])('/images/Contracts/' + this.data.ImageName);
      return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.shareUrl) + '&picture=' + encodeURIComponent(pictureUrl) + '&quote=' + encodeURIComponent(this.shareText);
    },
    twitterShareUrl: function twitterShareUrl() {
      return 'http://twitter.com/share?text=' + encodeURIComponent(this.shareText) + '&url=' + encodeURIComponent(this.shareUrl);
    },
    toggleButtonModifiers: function toggleButtonModifiers() {
      return {
        'notification-item-trade-confirmed__toggle': true,
        'notification-item-trade-confirmed__toggle--on': this.advanced
      };
    },
    profitOrLossText: function profitOrLossText() {
      return this.data.TotalProfit > 0 ? 'Profit' : 'Loss';
    },
    bottomContainerClassModifiers: function bottomContainerClassModifiers() {
      return {
        'notification-item-trade-confirmed__container': true,
        'notification-item-trade-confirmed__container--simple': !this.isProcessedOrMatched,
        'notification-item-trade-confirmed__container--border': this.isProcessedOrMatched
      };
    },
    mailto: function mailto() {
      var text = this.shareText;
      var newShareText = text.replace(' @PredictIt', '');
      return 'mailto:?body=' + newShareText + escape('\r\n') + escape('\r\n') + escape('\r\n') + this.shareUrl + '&subject=I just traded on PredictIt.org!';
    }
  },
  methods: {
    soldOrBoughtTextOffer: function soldOrBoughtTextOffer() {
      return this.defaultTradeType <= 1 ? 'Buy Offer' : 'Sell Offer';
    },
    soldOrBoughtText: function soldOrBoughtText() {
      var tradeType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var isHistoryPresent = !!this.data.History;
      if (tradeType === null) return this.soldOrBoughtText(this.defaultTradeType);
      if (tradeType <= 1) return isHistoryPresent ? 'Bought' : 'Buy';
      return isHistoryPresent ? 'Sold' : 'Sell';
    },
    tradeTypeClassModifier: function tradeTypeClassModifier(tradeType) {
      return {
        'notification-item-trade-confirmed__num-shares': true,
        'notification-item-trade-confirmed__num-shares--yes': tradeType === 1 || tradeType === 3,
        'notification-item-trade-confirmed__num-shares--no': tradeType === 0 || tradeType === 2
      };
    },
    onToggle: function onToggle() {
      this.advanced = !this.advanced;
    },
    openShareDialog: function openShareDialog(url) {
      window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
    },
    onEmailShare: function onEmailShare() {
      this.$gtm.trackEvent({ event: 'Share-Email' });
    },
    onFacebookShare: function onFacebookShare() {
      this.$gtm.trackEvent({ event: 'Share-Facebook' });
      this.openShareDialog(this.facebookShareUrl);
    },
    onTwitterShare: function onTwitterShare() {
      this.$gtm.trackEvent({ event: 'Share-Twitter' });
      this.openShareDialog(this.twitterShareUrl);
    },
    getShareText: function getShareText(type, quantity, pricePerShare) {
      var soldOrBoughtShareText = 'I just bought';
      switch (type) {
        default:
        case 'buy':
          break;
        case 'sell':
          soldOrBoughtShareText = 'I just sold';
          break;
        case 'buy-offer':
          soldOrBoughtShareText = "I'm offering to buy";
          break;
        case 'sell-offer':
          soldOrBoughtShareText = "I'm offering to sell";
          break;
      }

      var suffix = quantity > 1 ? 'shares' : 'share';
      var tradeTypeText = this.defaultTradeType === 0 || this.defaultTradeType === 2 ? 'No' : 'Yes';
      var contractSuffix = this.isMarketSingle ? '' : ' in \'' + this.contractName + '\'';
      var shares = quantity + ' ' + tradeTypeText + ' ' + suffix + contractSuffix;

      return soldOrBoughtShareText + ' ' + shares + ' for ' + pricePerShare + '\xA2 in this market. @PredictIt';
    }
  }
});

/***/ }),

/***/ "BpQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"},on:{"after-enter":_vm.afterEnter}},[_c('div',{staticClass:"modal__overlay"},[_c('div',{staticClass:"modal__wrapper"},[_c('div',{staticClass:"modal__body",class:_vm.bodyClass},[(_vm.hasHeader)?_c('div',{staticClass:"modal__header",class:_vm.headerClass},[_vm._t("header"),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.closeButton),expression:"closeButton"}],staticClass:"modal__close",class:_vm.closeButtonClass,on:{"click":function($event){$event.preventDefault();return _vm.close($event)}}})],2):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticClass:"modal__content",class:_vm.classModifier},[_vm._t("content")],2),_vm._v(" "),(_vm.hasFooter)?_c('div',{staticClass:"modal__footer"},[_vm._t("footer")],2):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C5mt":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4NCiAgICA8cGF0aCBmaWxsPSIjMDdBMEJCIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi4zNCAxMC43MzJsLTcuNjA4IDQuMzRWNi4zNGw3LjYwOCA0LjM5MnptNS40NjQgNi41MzZWNC4xOTZIMi4xOTZ2MTMuMDcyaDE5LjYwOHptMC0xNS4yNjhjLjU3OSAwIDEuMDkuMjEzIDEuNTMyLjYzOC40NDMuNDI2LjY2NC45NDUuNjY0IDEuNTU4bC0uMDUxIDEzLjA3MmMwIC41NzktLjIxMyAxLjA4LS42MzggMS41MDYtLjQyNi40MjYtLjkyOC42MzktMS41MDcuNjM5SDE2LjM0djIuMTk2SDcuNjZ2LTIuMTk2SDIuMTk2YTIuMTIgMi4xMiAwIDAgMS0xLjU1OC0uNjM5Qy4yMTMgMTguMzUgMCAxNy44NDcgMCAxNy4yNjhWNC4xOTZjMC0uNjEzLjIxMy0xLjEzMi42MzgtMS41NThBMi4xMTkgMi4xMTkgMCAwIDEgMi4xOTYgMmgxOS42MDh6Ii8+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "CAq+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_maxBy__ = __webpack_require__("K1hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__ = __webpack_require__("nYw4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");


/* eslint-disable no-restricted-syntax,consistent-return */







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    stateCode: {
      type: String
    },
    stateName: {
      type: String
    },
    marketData: {
      type: Object
    },
    type: {}
  },
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  data: function data() {
    return {
      capitalizeFirstLetter: __WEBPACK_IMPORTED_MODULE_6__utils_helpers__["n" /* capitalizeFirstLetter */],
      toCents: __WEBPACK_IMPORTED_MODULE_6__utils_helpers__["j" /* toCents */]
    };
  },

  computed: {
    isSenate: function isSenate() {
      return this.type === 'senate';
    },
    color: function color() {
      return this.pallette.color;
    },
    showNote: function showNote() {
      var statesForNote = ['ME', 'NE'];
      return statesForNote.includes(this.stateCode) && !this.isSenate;
    },
    winnerMode: function winnerMode() {
      return true;
      // return get(this.marketData, 'status', 'Open') === constants.MARKET_CLOSED;
    },
    winnerBgColorStyleModifiers: function winnerBgColorStyleModifiers() {
      return {
        'background-color': this.color
      };
    },
    targetContract: function targetContract() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_maxBy___default()(this.marketData.contracts || [], function (i) {
        return i.lastTradePrice;
      });
    },
    targetContractInstance: function targetContractInstance() {
      return new __WEBPACK_IMPORTED_MODULE_4__models_contract__["a" /* default */](this.targetContract);
    },
    classModifiers: function classModifiers() {
      return {
        'market-state-tooltip': true
      };
    },
    styleModifiers: function styleModifiers() {
      return {
        border: '4px solid ' + this.color
      };
    },
    titleClassModifiers: function titleClassModifiers() {
      // const lightPallettes = [
      //   COLOR_MAP.GRAY[0],
      //   COLOR_MAP.BLUE[0],
      //   COLOR_MAP.RED[0],
      // ];
      return {
        'market-state-tooltip__state-name': true
        // 'market-state-tooltip__state-name--light': lightPallettes.includes(this.pallette),
      };
    },
    titleStyleModifiers: function titleStyleModifiers() {
      return {
        background: this.color
      };
    },
    pallette: function pallette() {
      var pallette = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["a" /* getColorForPalletteCandidate */])(this.targetContract.contractName);
      var factor = pallette[0].from + this.targetContract.lastTradePrice;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(pallette), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (factor <= item.to) {
            return item;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    contracts: function contracts() {
      return this.marketData.contracts.map(function (i) {
        return new __WEBPACK_IMPORTED_MODULE_4__models_contract__["a" /* default */](i);
      });
    }
  },
  methods: {
    getNameDisplay: function getNameDisplay(contract) {
      return contract.contractName.split(' ')[1];
    },
    contractClassModifiers: function contractClassModifiers(contract, index) {
      return {
        'market-state-tooltip__contract': true,
        'market-state-tooltip__contract--with-border': index === 0
      };
    },
    imageStyleModifiers: function imageStyleModifiers(contract) {
      return {
        'background-image': 'url(' + contract.contractImageUrl + ')'
      };
    },
    onTooltipClick: function onTooltipClick() {
      if (this.marketData.marketId) {
        window.location.href = 'https://www.predictit.org/markets/detail/' + this.marketData.marketId;
      }
    }
  },
  created: function created() {
    if (this.stateCode !== 'GA2') {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('market/setMarketMapTooltipVisible', true);
    }
  }
});

/***/ }),

/***/ "CAth":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CONTRACTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COLOR_INDEXES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PRICE_FACTORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COLOR_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getColorForPalletteCandidate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_page_election_map_new_election_map_toolbar_election_map_toolbar_vue__ = __webpack_require__("yhSh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_table_election_map_table_vue__ = __webpack_require__("6Fjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_special_election_map_special_vue__ = __webpack_require__("09fK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_chart_models__ = __webpack_require__("Q+EN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_page_election_map_new_overview_map_overview_map_vue__ = __webpack_require__("Shp1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__("c/9r");










var CONTRACTS = {
  REPUBLICAN: 'Republican',
  DEMOCRATIC: 'Democratic',
  TRUMP: 'Trump'
};

var COLOR_INDEXES = {
  LOW: 0,
  MEDIUM: 1,
  HIGH: 2
};

var PRICE_FACTORS = {
  DELTA: 0.01,
  LOW: 0.64,
  MEDIUM: 0.79,
  HIGH: 1
};

var COLOR_MAP = {
  GRAY: [{ from: 0, to: PRICE_FACTORS.LOW, color: '#dddddd' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["i" /* roundToTwo */])(PRICE_FACTORS.LOW + PRICE_FACTORS.DELTA), to: PRICE_FACTORS.MEDIUM, color: '#bbbbbb' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["i" /* roundToTwo */])(PRICE_FACTORS.MEDIUM + PRICE_FACTORS.DELTA), to: PRICE_FACTORS.HIGH, color: '#888888' }],
  BLUE: [{ from: 30, to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["i" /* roundToTwo */])(30 + PRICE_FACTORS.LOW), color: '#8aafff' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["i" /* roundToTwo */])(30 + PRICE_FACTORS.LOW + PRICE_FACTORS.DELTA), to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["i" /* roundToTwo */])(30 + PRICE_FACTORS.MEDIUM), color: '#5c80dc' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["i" /* roundToTwo */])(30 + PRICE_FACTORS.MEDIUM + PRICE_FACTORS.DELTA), to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["i" /* roundToTwo */])(30 + PRICE_FACTORS.HIGH), color: '#244999' }],
  RED: [{ from: 40, to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["i" /* roundToTwo */])(40 + PRICE_FACTORS.LOW), color: '#ff8b98' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["i" /* roundToTwo */])(40 + PRICE_FACTORS.LOW + PRICE_FACTORS.DELTA), to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["i" /* roundToTwo */])(40 + PRICE_FACTORS.MEDIUM), color: '#ff5865' }, { from: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["i" /* roundToTwo */])(40 + PRICE_FACTORS.MEDIUM + PRICE_FACTORS.DELTA), to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["i" /* roundToTwo */])(40 + PRICE_FACTORS.HIGH), color: '#d22532' }]
};

var getColorForPalletteCandidate = function getColorForPalletteCandidate(contractName) {
  var name = (contractName || '').toLowerCase();
  var isRepublican = name.includes(CONTRACTS.REPUBLICAN.toLowerCase()) || name.includes(CONTRACTS.TRUMP.toLowerCase());

  if (isRepublican) {
    return COLOR_MAP.RED;
  }
  return COLOR_MAP.BLUE;
};

/* harmony default export */ __webpack_exports__["c"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_loader__["a" /* default */]],
  components: {
    electionMapToolbar: __WEBPACK_IMPORTED_MODULE_2__components_pages_page_election_map_new_election_map_toolbar_election_map_toolbar_vue__["a" /* default */],
    electionMapTable: __WEBPACK_IMPORTED_MODULE_3__components_pages_page_election_map_new_election_map_table_election_map_table_vue__["a" /* default */],
    electionMapSpecial: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_election_map_new_election_map_special_election_map_special_vue__["a" /* default */],
    overviewMap: __WEBPACK_IMPORTED_MODULE_6__components_pages_page_election_map_new_overview_map_overview_map_vue__["a" /* default */]
  },
  data: function data() {
    return {
      type: 'senate'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('market', ['mapStateData', 'mapOverviewData', 'mapStateDataSenate', 'mapOverviewDataSenate']), {
    ChartClass: function ChartClass() {
      if (this.type === 'electoral') {
        return __WEBPACK_IMPORTED_MODULE_5__utils_chart_models__["c" /* ElectionMapChartParty */];
      }
      if (this.type === 'senate') {
        return __WEBPACK_IMPORTED_MODULE_5__utils_chart_models__["d" /* ElectionMapChartSenate */];
      }
      return __WEBPACK_IMPORTED_MODULE_5__utils_chart_models__["e" /* ElectionMapChartOverall */];
    }
  }),
  watch: {
    type: {
      handler: 'typeHandler',
      immediate: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('market', ['getMapStateData', 'getMapOverviewData', 'getMapOverviewDataSenate', 'getMapStateDataSenate']), {
    typeHandler: function typeHandler() {
      var _this = this;

      this.loaderAdd();
      if (this.type === 'electoral') {
        this.getMapOverviewData().then(function () {
          return _this.getMapStateData();
        }).then(function (data) {
          return _this.createChart(data);
        }).then(function () {
          return _this.loaderRemove();
        }).catch(function () {
          return _this.loaderRemove();
        });
      } else if (this.type === 'senate') {
        this.getMapOverviewDataSenate().then(function () {
          return _this.getMapStateDataSenate();
        }).then(function (data) {
          return _this.createChart(data);
        }).then(function () {
          return _this.loaderRemove();
        }).catch(function () {
          return _this.loaderRemove();
        });
      }
    },
    createChart: function createChart(data) {
      var _this2 = this;

      setTimeout(function () {
        _this2.renderChart(data);
      }, this.ChartClass.renderTimeout());
    },
    renderChart: function renderChart(data) {
      if (!this.$refs.chart) return;
      var group = new this.ChartClass(data);
      group.draw(this.$refs.chart);
    },
    onToggle: function onToggle() {
      this.type = this.type === 'electoral' ? 'senate' : 'electoral';
    }
  }),
  created: function created() {
    if (this.$route.query.map) {
      this.type = this.$route.query.map;
    }
  }
});

/***/ }),

/***/ "CAzF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_modal_js__ = __webpack_require__("Y+KT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b26fa6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__ = __webpack_require__("BpQ6");
function injectStyle (ssrContext) {
  __webpack_require__("smEl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_modal_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b26fa6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CBfy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CCA8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_what_is_predictit_js__ = __webpack_require__("4blE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68231b17_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_what_is_predictit_vue__ = __webpack_require__("ssm7");
function injectStyle (ssrContext) {
  __webpack_require__("XRns")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_what_is_predictit_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68231b17_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_what_is_predictit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CG+G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      requited: true
    }
  },
  computed: {
    selectedModifier: function selectedModifier() {
      return {
        'state-button--selected': this.selected
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click', this);
    }
  }
});

/***/ }),

/***/ "CGiI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mySharesCount > 0 )?_c('div',{class:_vm.classModifier},[_c('div',{class:_vm.menuClassModifier},[_c('div',{staticClass:"market-filters-dashboard__menu-order"},[_c('span',[_vm._v("Sort By:")]),_vm._v(" "),_c('menu-button',{attrs:{"theme":"blue","type":_vm.selectedOrder.sort,"name":_vm.orderMenuName,"active":_vm.ordersOpen,"arrow":true},on:{"click":_vm.toggleOrder}})],1),_vm._v(" "),(_vm.shouldShowTimespanFilter)?_c('div',{staticClass:"market-filters-dashboard__menu-timespan"},[_c('menu-button',{attrs:{"theme":"blue","type":"timespan","name":_vm.selectedTimespan.name,"active":_vm.timespansOpen,"arrow":true},on:{"click":_vm.toggleTimespans}})],1):_vm._e()]),_vm._v(" "),(_vm.ordersOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-dashboard__order"},_vm._l((_vm.orderList('dashboard')),function(order){return _c('menu-button',{key:order.sort,attrs:{"type":order.sort,"name":order.fullName,"selected":_vm.dashOrderSelected(order.sort),"typeThemeEnabled":true},on:{"click":_vm.selectOrderAndClose}})}),1):_vm._e(),_vm._v(" "),(_vm.timespansOpen)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeFilters),expression:"closeFilters"}],staticClass:"market-filters-dashboard__timespans"},_vm._l((_vm.availableTimespanOptions),function(timespan){return _c('menu-button',{key:timespan.parameter,attrs:{"type":timespan.parameter,"name":timespan.name},on:{"click":_vm.selectTimespanAndClose}})}),1):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CIck":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_markets_js__ = __webpack_require__("i3z8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3070f8fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_markets_vue__ = __webpack_require__("FIqf");
function injectStyle (ssrContext) {
  __webpack_require__("AYJx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_markets_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3070f8fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_markets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CMpb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyboard-numeric",on:{"click":function($event){$event.stopPropagation();return _vm.outsideClick($event)}}},[_c('div',{staticClass:"keyboard-numeric__content"},[_c('div',{staticClass:"keyboard-numeric__numbers"},[_c('div',{staticClass:"keyboard-numeric__row"},[_c('button',{staticClass:"keyboard-numeric__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('1')}}},[_vm._v("1")]),_vm._v(" "),_c('button',{staticClass:"keyboard-numeric__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('2')}}},[_vm._v("2")]),_vm._v(" "),_c('button',{staticClass:"keyboard-numeric__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('3')}}},[_vm._v("3")]),_vm._v(" "),_c('button',{staticClass:"keyboard-numeric__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('4')}}},[_vm._v("4")]),_vm._v(" "),_c('button',{staticClass:"keyboard-numeric__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('5')}}},[_vm._v("5")])]),_vm._v(" "),_c('div',{staticClass:"keyboard-numeric__row"},[_c('button',{staticClass:"keyboard-numeric__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('6')}}},[_vm._v("6")]),_vm._v(" "),_c('button',{staticClass:"keyboard-numeric__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('7')}}},[_vm._v("7")]),_vm._v(" "),_c('button',{staticClass:"keyboard-numeric__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('8')}}},[_vm._v("8")]),_vm._v(" "),_c('button',{staticClass:"keyboard-numeric__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('9')}}},[_vm._v("9")]),_vm._v(" "),_c('button',{staticClass:"keyboard-numeric__key",on:{"click":function($event){$event.stopPropagation();return _vm.buttonClick('0')}}},[_vm._v("0")])])]),_vm._v(" "),_c('div',{staticClass:"keyboard-numeric__options"},[_c('button',{staticClass:"keyboard-numeric__key keyboard-numeric__key--backspace",on:{"click":function($event){$event.stopPropagation();return _vm.backspaceClick($event)}}},[_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyboard-numeric__key--backspace-image"},[_c('span',{staticClass:"keyboard-numeric__key--backspace-text"},[_vm._v("x")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CPMw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"most-predicted-list"},[_c('div',{staticClass:"most-predicted-list__header"},[_c('div',[_vm._v("\r\n      "+_vm._s(_vm.title)+"\r\n    ")]),_vm._v(" "),(_vm.isLayoutMobile)?_c('div',{staticClass:"most-predicted-list__header-arrows"},[_c('span',{class:_vm.prevArrowModifiers,on:{"click":_vm.prevSlide}}),_vm._v(" "),_c('span',{class:_vm.nextArrowModifiers,on:{"click":_vm.nextSlide}})]):_vm._e()]),_vm._v(" "),(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader"},_vm._l((_vm.dummyComponents),function(index){return _c('div',{staticClass:"content-loader-item"},[_c('market-loader')],1)}),0):_c('div',{staticClass:"most-predicted-list__content"},[(_vm.isLayoutDesktop)?_vm._l((_vm.items),function(market){return _c('market-list-item',{key:market.marketId,staticClass:"most-predicted-list__item",attrs:{"market":market,"theme":"home"}})}):_vm._e(),_vm._v(" "),(_vm.isLayoutMobile)?[_c('swiper',{ref:"swiper",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.items),function(item){return _c('swiper-slide',{key:item.marketId},[_c('market-list-item',{staticClass:"most-predicted-list__item",attrs:{"market":item,"theme":"home"}})],1)}),1)]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CPTB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__ = __webpack_require__("wU6a");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_526c5450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__ = __webpack_require__("GH+k");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_526c5450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CPcE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__("H/Zg");
/* eslint-disable max-len */


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getMarketChartData: function getMarketChartData(_ref, params) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].chart.getMarketChartData(params).then(function (response) {
        return response.data;
      });
    },
    getContractChartData: function getContractChartData(_ref2, _ref3) {
      var commit = _ref2.commit;
      var contractId = _ref3.contractId,
          timeline = _ref3.timeline;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].chart.getContractChartData(contractId, timeline).then(function (response) {
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "CPvM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_videos_vue__ = __webpack_require__("w1pb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27312ed8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_videos_vue__ = __webpack_require__("9Wdi");
function injectStyle (ssrContext) {
  __webpack_require__("Ox9w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_videos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27312ed8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_videos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CSqp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disqus-panel"},[(_vm.showTitle)?_c('div',{staticClass:"disqus-panel__title"},[_vm._v("\n    Comments "),(_vm.total)?_c('span',[_vm._v("("+_vm._s(_vm.total.toLocaleString())+" Archived)")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"disqus-panel__content"},[(_vm.currentTitle)?_c('div',{staticClass:"disqus-panel__subtitle"},[_vm._v("\n      "+_vm._s(_vm.currentTitle)+"\n    ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"disqus-panel__note"},[_c('strong',[_vm._v("DISCLAIMER:")]),_vm._v("\n      The Disqus comment section below is for informational purposes only. PredictIt does not monitor or assess the accuracy of comments. Traders should seek out independent information before making any investment decision. PredictIt removes comments and may ban users that violate the terms of service (such as those containing inappropriate or offensive language or content) if we become aware of them. See also the "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":"https://help.disqus.com/en/articles/1717116-basic-rules-for-disqus"}},[_vm._v("Basic Rules for Disqus")]),_vm._v(" and "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":"https://help.disqus.com/en/articles/1717227-how-to-report-abuse"}},[_vm._v("How to Report Abuse on Disqus")]),_vm._v(".\n    ")]),_vm._v(" "),_c('div',{staticClass:"disqus",attrs:{"id":"disqus_thread"}}),_vm._v(" "),((_vm.previousThread !== null) || (_vm.nextThread !== null))?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"disqus-panel__navigation"},[(_vm.previousThread !== null)?_c('div',{staticClass:"disqus-panel__navigation-link disqus-panel__navigation-link--left",on:{"click":_vm.onPrevious}},[_vm._v("\n          < OLDER COMMENTS\n        ")]):_vm._e(),_vm._v(" "),(_vm.nextThread !== null)?_c('div',{staticClass:"disqus-panel__navigation-link disqus-panel__navigation-link--right",on:{"click":_vm.onNext}},[_vm._v("\n          NEWER COMMENTS >\n        ")]):_vm._e()])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"disqus-panel__note"},[_c('strong',[_vm._v("ARCHIVED COMMENTS:")]),_vm._v("\n        Every so often we need to archive the comments on a page. If that happens we still make the archived comments accessible by clicking the Older Comments link.\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CcaY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");



/* eslint-disable arrow-body-style */




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */]],
  data: function data() {
    return {
      fields: {
        reason: null,
        message: ''
      },
      files: []
    };
  },

  validations: {
    fields: {
      reason: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required,
      message: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].message
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('support', ['reportReasons']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['watchedUserDetails']), {
    isUploadEnabled: function isUploadEnabled() {
      // return !(this.isIos && this.isStandalone);
      return false;
    },
    messagePlaceholder: function messagePlaceholder() {
      return this.fields.message ? '' : 'Message';
    },
    messageRequired: function messageRequired() {
      return !this.fields.message;
    },
    reasonOptions: function reasonOptions() {
      return this.reportReasons.map(function (item) {
        return {
          label: item.reason,
          value: item.reasonId
        };
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('support', ['getReportUserReasons', 'reportUser']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotification']), {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formIsValid() && this.formDisable()) {
        this.loaderAdd(document.body);
        // const formData = new FormData();
        // formData.append('subject', this.fields.subject.value);
        // formData.append('description', this.fields.message);
        //
        //
        // this.files.forEach((file) => {
        //   formData.append('uploadedFile', file);
        // });
        var payload = {
          userName: this.watchedUserDetails.userName,
          description: this.fields.message,
          reasonId: this.fields.reason.value,
          pageUrl: window.location.href
        };
        this.reportUser(payload).then(function () {
          _this.loaderRemove(document.body);
          _this.setSuccessSideNotification('Report received.<br> Thank you.');
          _this.setCurrentSmallPopup();
        }).catch(function (error) {
          _this.loaderRemove(document.body);
          _this.formHandleErrors(error);
        });
      }
    },
    onUpload: function onUpload() {
      this.$refs.fileinput.click();
    },
    fileToBase64: function fileToBase64(file) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          return resolve({
            name: file.name,
            file: reader.result
          });
        };
        reader.onerror = function (error) {
          return reject(error);
        };
      });
    },
    onChange: function onChange() {
      var files = this.$refs.fileinput.files;
      if (files.length) {
        this.files = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.files), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files));
      }
    },
    fileRemove: function fileRemove(index) {
      this.files = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.files.slice(0, index)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.files.slice(index + 1)));
    }
  }),
  created: function created() {
    this.getReportUserReasons();
  }
});

/***/ }),

/***/ "CdV1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"community-forums"},[(_vm.isLayoutMobile)?_c('content-header',{attrs:{"title":"Forum","silent":true},on:{"close":_vm.onClose}}):_c('div',{staticClass:"community-forums__desktop-header"},[_c('router-link',{staticClass:"community-forums__back",attrs:{"to":{name: 'HelpAndSupport'},"tag":"span"}},[_vm._v("\r\n      Help and Support\r\n    ")])],1),_vm._v(" "),(_vm.url)?_c('div',{staticClass:"community-forums__content"},[_c('iframe',{staticClass:"community-forums__iframe",attrs:{"src":_vm.url,"frameborder":"0"}})]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cg8d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-box",class:_vm.levelModifier},[_c('p',{staticClass:"alert-box__text"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cn7X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-table"},[_c('div',{staticClass:"row row-y"},[_vm._l((_vm.contracts),function(item){return _c('div',{staticClass:"column small-6 medium-4 end"},[_c('form-checkbox',{attrs:{"color":_vm.checkboxColor(item),"name":_vm.contractName(item)},on:{"change":function($event){return _vm.onChange(item, $event)}},model:{value:(item.checked),callback:function ($$v) {_vm.$set(item, "checked", $$v)},expression:"item.checked"}},[_c('div',{staticClass:"charts-table__item"},[(_vm.showImage)?_c('div',{staticClass:"charts-table__item-image",style:(_vm.imageStyleModifiers(item))}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"charts-table__item-label"},[_vm._v("\n            "+_vm._s(item.contractName)+"\n          ")])])])],1)}),_vm._v(" "),_vm._l((_vm.blankColumns),function(item){return (_vm.fillWithBlankColumns)?_c('div',{staticClass:"column small-6 medium-4 end"},[_vm._v("\n       \n    ")]):_vm._e()})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CrmB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state-button",class:_vm.selectedModifier,on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CtVF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dashboard_dashboard_portfolio_dashboard_portfolio_vue__ = __webpack_require__("PqvG");


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    dashboardPortfolio: __WEBPACK_IMPORTED_MODULE_0__components_dashboard_dashboard_portfolio_dashboard_portfolio_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "CuUC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-funds-combined"},[(_vm.showTabs && !_vm.hideTabs)?_c('div',{staticClass:"add-funds-combined__tabs"},[_c('tabs',{attrs:{"items":_vm.tabs},on:{"tabChange":_vm.tabChange}})],1):_vm._e(),_vm._v(" "),(!_vm.showTabs)?_c('div',{staticClass:"add-funds-combined__content add-funds-combined__content--loading"}):_c('div',{staticClass:"add-funds-combined__content"},[(_vm.showBankingTab)?_c('add-funds-bank-transfer',{attrs:{"instantCreditData":_vm.instantCreditData,"isPopup":true},on:{"step":_vm.onBankTransferStep}}):_vm._e(),_vm._v(" "),(_vm.showCardTab)?_c('add-funds-card',{attrs:{"instantCreditData":_vm.instantCreditData}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cv46":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D+Yn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_market_market_filters_market_filters_mixin_market_filters_mixin__ = __webpack_require__("kGlu");


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_market_market_filters_market_filters_mixin_market_filters_mixin__["a" /* default */]],
  computed: {
    mainClassName: function mainClassName() {
      return 'market-filters-desktop-grid';
    },
    menuClassModifier: function menuClassModifier() {
      return {
        'market-filters-desktop-grid__menu': true,
        'market-filters-desktop-grid__menu--with-timespan-filter': this.shouldShowTimespanFilter
      };
    },
    orderMenuName: function orderMenuName() {
      return this.selectedOrder.fullName;
    }
  }
});

/***/ }),

/***/ "D5rx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_v2_js__ = __webpack_require__("iYpn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_108d84d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_v2_vue__ = __webpack_require__("6uXL");
function injectStyle (ssrContext) {
  __webpack_require__("25HU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_v2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_108d84d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D7aM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-forgotten-password"},[_c('div',{staticClass:"page-forgotten-password__content"},[_c('div',{staticClass:"page-forgotten-password__title"},[_vm._v("\n      "+_vm._s(_vm.$txt('page-forgotten-password.title'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"page-forgotten-password__content-wrap"},[_c('account-forgotten')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DCmb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"input",class:_vm.inputModifiers,attrs:{"title":_vm.errorMessage}},[_c('label',{staticClass:"input__label",attrs:{"for":_vm.name}},[(_vm.placeholder)?_c('div',{staticClass:"input__placeholder"},[_vm._v(_vm._s(_vm.placeholder)),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.hasIcon)?_c('div',{staticClass:"input__icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_c('input',{staticClass:"input__value",attrs:{"tabindex":_vm.tabindex,"type":_vm.type,"autocomplete":_vm.autocomplete,"disabled":_vm.disabled,"name":_vm.name,"id":_vm.name,"required":_vm.required,"maxlength":_vm.maxLength,"max":_vm.max,"min":_vm.min},domProps:{"value":_vm.value},on:{"input":_vm.updateValue,"blur":_vm.handleBlur,"focus":_vm.handleFocus}})]),_vm._v(" "),(_vm.showValidationWithin)?[(_vm.error)?_c('div',{staticClass:"input__validation-message"},[_vm._v("\n        "+_vm._s(_vm.errorMessage)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.successTick)?_c('div',{staticClass:"input__success-tick"}):_vm._e()]:_vm._e()],2),_vm._v(" "),(!_vm.showValidationWithin)?[(_vm.error)?_c('div',{staticClass:"input__validation-message input__validation-message--outer"},[_vm._v("\n      "+_vm._s(_vm.errorMessage)+"\n    ")]):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DE6t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_value_js__ = __webpack_require__("9kKf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff5eb026_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_value_vue__ = __webpack_require__("j9oC");
function injectStyle (ssrContext) {
  __webpack_require__("YpG9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_value_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff5eb026_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_value_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DECz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__ = __webpack_require__("63Fj");




// maps url parameters to endpoint parameter names
var VARIABLES = {
  PIReferral: 'piReferral',
  utm_campaign: 'marketingProgram',
  utm_source: 'marketingSource',
  utm_code: 'depositPromoCode',
  instant_credit: ''
};

function check(route) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(VARIABLES).forEach(function (key) {
    var value = route.query[key];
    if (value) {
      __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].set(key, value);
    }
  });
}

function get(name) {
  var value = __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].get(name, null);
  if (value !== null) {
    return {
      name: VARIABLES[name],
      value: value
    };
  }
  return null;
}

function payload(oldPayload) {
  var data = {};

  for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    names[_key - 1] = arguments[_key];
  }

  names.forEach(function (name) {
    var value = __WEBPACK_IMPORTED_MODULE_2__helpers_sessionStorage__["a" /* default */].get(name, null);
    if (value !== null) {
      data[VARIABLES[name]] = value;
    }
  });
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, oldPayload, data);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  check: check,
  get: get,
  payload: payload
});

/***/ }),

/***/ "DFsO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('popup', ['currentPopupOptions']))
});

/***/ }),

/***/ "DRzK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DUXn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DXdo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_link_js__ = __webpack_require__("w70/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f21a71e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_link_vue__ = __webpack_require__("rFhE");
function injectStyle (ssrContext) {
  __webpack_require__("psIE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_link_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f21a71e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DZrC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-panel-simple",class:_vm.isOpenModifier},[_c('h3',{staticClass:"collapsible-panel-simple__header",on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.isOpenState)?_c('div',{staticClass:"collapsible-panel-simple__content"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DZwU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_search__ = __webpack_require__("+ZRi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_list_item_v2_market_list_item_v2_vue__ = __webpack_require__("tPuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_search__["a" /* default */]],
  components: {
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a,
    marketListItem: __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_list_item_v2_market_list_item_v2_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: 'PredictIt: Search Results'
    };
  },
  data: function data() {
    return {
      infiniteLoader: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('search', ['hasSearched', 'searchResults', 'searchQuery']), {
    items: function items() {
      return this.searchResults.data === null ? [] : this.searchResults.data;
    }
  }),
  watch: {
    items: function items() {
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        if (!this.searchResults.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }
    }
  },
  methods: {
    goInfinite: function goInfinite(infi) {
      this.infiniteLoader = infi;

      if (this.searchResults.canLoadMore) {
        var query = this.$router.currentRoute.query.query;
        this.doSearch(query, { reset: false });
      }
    }
  },
  created: function created() {
    var query = this.$router.currentRoute.query.query;
    // no search results in store and query provided
    // so user must have navigated here manually, trying searching
    if (!this.hasSearched && query) {
      this.doSearch(query);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.resetSearchResults('');
  }
});

/***/ }),

/***/ "DbLG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_details_js__ = __webpack_require__("Zdym");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcd357ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_details_vue__ = __webpack_require__("L6SS");
function injectStyle (ssrContext) {
  __webpack_require__("UFoq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_details_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcd357ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DiJc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DjnW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-shares-item-loader"},[_c('div',{staticClass:"market-shares-item-loader__image"}),_vm._v(" "),_c('div',{staticClass:"market-shares-item-loader__content"},[_c('div',{staticClass:"market-shares-item-loader__text"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dksu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_currently_predicting_js__ = __webpack_require__("u9HT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c90e63a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_currently_predicting_vue__ = __webpack_require__("0Xxu");
function injectStyle (ssrContext) {
  __webpack_require__("Qy6g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_currently_predicting_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c90e63a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_currently_predicting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DsFz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      type: Number
    }
  },
  data: function data() {
    return {
      isNewValueGreater: false
    };
  },

  watch: {
    value: {
      handler: function handler(newValue, oldValue) {
        this.isNewValueGreater = newValue > oldValue;
      },

      deep: false
    }
  },
  computed: {
    transitionName: function transitionName() {
      return this.isNewValueGreater ? 'animated-number--high' : 'animated-number--low';
    }
  }
});

/***/ }),

/***/ "Dwlj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_notifications__ = __webpack_require__("tjp7");


/* eslint-disable */



var DEFAULT_TOP_POSITION = 0;
var DEFAULT_RESET_POSITION_TIMEOUT = 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    lastTopPosition: DEFAULT_TOP_POSITION,
    currentPopup: null,
    currentSmallPopup: null,
    tradePopupOptions: {},
    currentPopupOptions: {},
    formDataCache: null,
    remember: {}
  },
  mutations: {
    setCurrentPopup: function setCurrentPopup(state, popupName) {
      if (popupName) {
        state.lastTopPosition = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
      }
      state.currentPopup = popupName;
      state.currentPopupOptions = {};
    },
    setCurrentSmallPopup: function setCurrentSmallPopup(state, popupName) {
      if (popupName) {
        state.lastTopPosition = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
      }
      state.currentSmallPopup = popupName;
    },
    setTradePopupOptions: function setTradePopupOptions(state, options) {
      state.tradePopupOptions = options;
    },
    setCurrentPopupOptions: function setCurrentPopupOptions(state, options) {
      state.currentPopupOptions = options;
    },
    cacheFormData: function cacheFormData(state, payload) {
      state.formDataCache = payload;
    },
    rememberPopup: function rememberPopup(state, _ref) {
      var route = _ref.route,
          popup = _ref.popup;

      state.remember = {
        route: route,
        popup: popup
      };
    },
    restorePopup: function restorePopup(state, payload) {
      if (state.remember.route === payload) {
        state.currentPopup = state.remember.popup;
      }
      state.remember = {};
    },
    resetLastTopPosition: function resetLastTopPosition(state) {
      state.lastTopPosition = DEFAULT_TOP_POSITION;
    },
    updateTradePopupOptionsMarketFromNotification: function updateTradePopupOptionsMarketFromNotification(state, data) {
      if (state.tradePopupOptions && state.tradePopupOptions.market) {
        state.tradePopupOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.tradePopupOptions, {
          market: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_notifications__["a" /* updateMarket */])(state.tradePopupOptions.market, data)
        });
      }
    },
    updateTradePopupOptionsContractsFromNotification: function updateTradePopupOptionsContractsFromNotification(state, data) {
      if (state.tradePopupOptions && state.tradePopupOptions.market) {
        state.tradePopupOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.tradePopupOptions, {
          market: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_notifications__["b" /* updateMarketContracts */])(state.tradePopupOptions.market, data)
        });
      }
    }
  },
  actions: {
    setCurrentPopupWithDelay: function setCurrentPopupWithDelay(_ref2, _ref3) {
      var commit = _ref2.commit;
      var name = _ref3.name,
          _ref3$options = _ref3.options,
          options = _ref3$options === undefined ? {} : _ref3$options;

      commit('setCurrentPopup', null);
      setTimeout(function () {
        commit('setCurrentPopup', name);
        commit('setCurrentPopupOptions', options);
      }, 1000);
    },
    setTradePopup: function setTradePopup(_ref4, _ref5) {
      var commit = _ref4.commit;
      var name = _ref5.name,
          options = _ref5.options;

      commit('setCurrentPopup', name);
      commit('setTradePopupOptions', options);
    },
    setCurrentPopup: function setCurrentPopup(_ref6) {
      var commit = _ref6.commit,
          state = _ref6.state;
      var popupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        commit('setCurrentPopup', popupName);
        if (!popupName && state.lastTopPosition !== DEFAULT_TOP_POSITION) {
          if (__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].POPUP_OVERFLOW_MODE) {
            setTimeout(function () {
              window.scrollTo(0, state.lastTopPosition);
              commit('resetLastTopPosition');
            }, DEFAULT_RESET_POSITION_TIMEOUT);
          }
          resolve();
        } else {
          resolve();
        }
      });
    },
    setCurrentSmallPopup: function setCurrentSmallPopup(_ref7) {
      var commit = _ref7.commit,
          state = _ref7.state;
      var popupName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      commit('setCurrentSmallPopup', popupName);
      if (!popupName && state.lastTopPosition !== DEFAULT_TOP_POSITION) {
        if (__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].POPUP_OVERFLOW_MODE) {
          setTimeout(function () {
            window.scrollTo(0, state.lastTopPosition);
            commit('resetLastTopPosition');
          }, DEFAULT_RESET_POSITION_TIMEOUT);
        }
      }
    },
    setTradePopupOptions: function setTradePopupOptions(_ref8, options) {
      var commit = _ref8.commit;

      commit('setTradePopupOptions', options);
    },
    setCurrentPopupOptions: function setCurrentPopupOptions(_ref9, options) {
      var commit = _ref9.commit;

      commit('setCurrentPopupOptions', options);
    },
    setGenericPopup: function setGenericPopup(_ref10, popup) {
      var commit = _ref10.commit;

      commit('setCurrentPopup', popup.name);
      commit('setCurrentPopupOptions', popup.options);
    },
    setGenericSmallPopup: function setGenericSmallPopup(_ref11, popup) {
      var commit = _ref11.commit;

      commit('setCurrentSmallPopup', popup.name);
      commit('setCurrentPopupOptions', popup.options);
    },
    setErrorPopup: function setErrorPopup(_ref12) {
      var commit = _ref12.commit;
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      commit('setCurrentSmallPopup', 'generic-small');
      commit('setCurrentPopupOptions', {
        title: 'Error',
        icon: 'error',
        iconTitle: 'Error!',
        content: content
      });
    },
    setSuccessPopup: function setSuccessPopup(_ref13) {
      var commit = _ref13.commit;
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Operation successful.';

      commit('setCurrentSmallPopup', 'generic-small');
      commit('setCurrentPopupOptions', {
        title: 'Success',
        icon: 'success',
        iconTitle: 'Success!',
        content: content
      });
    },
    setSuccessPopupWithTimeoutCallback: function setSuccessPopupWithTimeoutCallback(_ref14, _ref15) {
      var _this = this;

      var commit = _ref14.commit;
      var _ref15$content = _ref15.content,
          content = _ref15$content === undefined ? 'Operation successful.' : _ref15$content,
          _ref15$callback = _ref15.callback,
          callback = _ref15$callback === undefined ? function () {} : _ref15$callback;

      var callBackApplied = false;
      var timeout = setTimeout(function () {
        callBackApplied = true;
        callback.apply(_this);
      }, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DEFAULT_SMALL_POPUP_TIMEOUT);
      commit('setCurrentSmallPopup', 'generic-small');
      commit('setCurrentPopupOptions', {
        title: 'Success',
        icon: 'success',
        iconTitle: 'Success!',
        onClose: function onClose() {
          if (!callBackApplied) {
            clearTimeout(timeout);
            callback.apply(_this);
          }
        },
        content: content
      });
    },
    cacheFormData: function cacheFormData(_ref16, payload) {
      var commit = _ref16.commit;

      commit('cacheFormData', payload);
    },
    rememberPopup: function rememberPopup(_ref17, route) {
      var commit = _ref17.commit,
          state = _ref17.state;

      commit('rememberPopup', route);
    },
    restorePopup: function restorePopup(_ref18, route) {
      var commit = _ref18.commit;

      commit('restorePopup', route);
    },
    updateTradePopupOptionsMarketFromNotification: function updateTradePopupOptionsMarketFromNotification(_ref19, data) {
      var commit = _ref19.commit;

      commit('updateTradePopupOptionsMarketFromNotification', data);
    },
    updateTradePopupOptionsContractsFromNotification: function updateTradePopupOptionsContractsFromNotification(_ref20, data) {
      var commit = _ref20.commit;

      commit('updateTradePopupOptionsContractsFromNotification', data);
    }
  }
});

/***/ }),

/***/ "E/7D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getActiveButtonAfterSwitch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_shares_bar_market_shares_bar_vue__ = __webpack_require__("HvTw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_v2_button_price_button_price_vue__ = __webpack_require__("al65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_mutex__ = __webpack_require__("EOu+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_accountVerify__ = __webpack_require__("yZQa");



/* eslint-disable max-len, arrow-body-style, no-mixed-operators */











var thousandDisplay = function thousandDisplay(value) {
  if (value >= 1.0e+4) {
    return Math.round(value / 1.0e+3) + 'K';
  }
  return value >= 1.0e+3 ? Math.floor(10 * value / 1.0e+3) / 10 + 'K' : value;
};

var TITLE_LATEST_PRICE = 'Latest Price';
var OPERATIONS = {
  BUY: 'buy',
  SELL: 'sell'
};
var VALUES = {
  YES: 'yes',
  NO: 'no'
};
var BUTTONS = {
  BUY_NO: {
    id: 'buy-no',
    type: OPERATIONS.BUY,
    value: VALUES.NO
  },
  BUY_NO_ALT: {
    id: 'buy-no-alt',
    type: OPERATIONS.BUY,
    value: VALUES.NO
  },
  BUY_YES: {
    id: 'buy-yes',
    type: OPERATIONS.BUY,
    value: VALUES.YES
  },
  SELL_NO: {
    id: 'sell-no',
    type: OPERATIONS.SELL,
    value: VALUES.NO
  },
  SELL_YES: {
    id: 'sell-yes',
    type: OPERATIONS.SELL,
    value: VALUES.YES
  }
};

function getActiveButtonAfterSwitch(contractModel, switchTo) {
  var button = BUTTONS.BUY_NO_ALT;

  if (switchTo === 'right') {
    if (contractModel.mode === VALUES.NO) {
      button = BUTTONS.SELL_NO;
    } else if (contractModel.mode === VALUES.YES) {
      button = BUTTONS.SELL_YES;
    }
  } else if (switchTo === 'left') {
    if (contractModel.mode === VALUES.NO) {
      button = BUTTONS.BUY_NO;
    } else {
      button = BUTTONS.BUY_YES;
    }
  }

  return button;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_accountVerify__["a" /* default */]],
  components: {
    buttonPrice: __WEBPACK_IMPORTED_MODULE_7__components_market_v2_button_price_button_price_vue__["a" /* default */],
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    marketSharesBar: __WEBPACK_IMPORTED_MODULE_6__components_market_market_shares_bar_market_shares_bar_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    contract: {
      type: Object,
      required: true
    },
    layout: {
      type: String,
      default: 'default'
    },
    showPurchaseOnInit: {
      type: Boolean,
      default: false
    },
    forCmsWidget: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      BUTTONS: BUTTONS,
      OPERATIONS: OPERATIONS,
      VALUES: VALUES,
      isWaiting: false,
      activeButton: null
    };
  },
  created: function created() {
    this.activatePurchaseJourneyForMarket();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'tradeOperationToggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['status']), {
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_4__models_contract__["a" /* default */](this.contract);
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["l" /* isMarketSingle */])(this.market);
    },
    singleMarketTitle: function singleMarketTitle() {
      return this.isMarketSingle ? TITLE_LATEST_PRICE : this.contractModel.contractName || this.contractModel.name;
    },
    title: function title() {
      return this.isMarketSingle ? this.singleMarketTitle : this.contractModel.contractName || this.contractModel.name;
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'market-contract-horizontal-v2': true,
        'market-contract-horizontal-v2--no-shares-or-offers': !this.showOffersOrShares
      }, 'market-contract-horizontal-v2--' + this.layout, this.layout);
    },
    rowModifiers: function rowModifiers() {
      return {
        row: true,
        'row-y': this.isLayoutDesktop,
        'row-large-100': true
      };
    },
    titleModifiers: function titleModifiers() {
      return {
        'market-contract-horizontal-v2__title': true,
        'market-contract-horizontal-v2__title--no-shares': !this.showSharesBar,
        'market-contract-horizontal-v2__title--no-offers': !this.showOpenOffers
      };
    },
    classModifiersMobileHeaderTitle: function classModifiersMobileHeaderTitle() {
      return {
        'market-contract-horizontal-v2__mobile-header-title': true,
        'market-contract-horizontal-v2__mobile-header-title--single': this.isMarketSingle
      };
    },
    isLayoutDashboard: function isLayoutDashboard() {
      return this.layout === 'dashboard';
    },
    infoPartModifiers: function infoPartModifiers() {
      return {
        column: true,
        'small-12': true,
        'column-large-100': true,
        'column-valign': true,
        'market-contract--dashboard': this.isLayoutDashboard,
        'market-contract--infopart': true
      };
    },
    pricePartModifiers: function pricePartModifiers() {
      return {
        column: true,
        'small-12': true,
        'column-large-100': true,
        'column-valign': true,
        'medium-5': !this.isLayoutDashboard,
        'medium-3': this.isLayoutDashboard
      };
    },
    imageAltText: function imageAltText() {
      return this.contractModel.contractName;
    },
    imageUrl: function imageUrl() {
      return this.contractModel.contractImageSmallUrl || this.contractModel.contractImageUrl;
    },
    contractImageStyleModifiers: function contractImageStyleModifiers() {
      return {
        'background-image': 'url(' + this.imageUrl + ')'
      };
    },
    isMarketDisabled: function isMarketDisabled() {
      var statuses = [__WEBPACK_IMPORTED_MODULE_9__constants__["a" /* default */].MARKET_EXPIRED, __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* default */].MARKET_SUSPENDED, __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* default */].MARKET_SETTLED, __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* default */].MARKET_MAINTENANCE];
      return this.market && statuses.includes(this.market.status);
    },
    isMarketSettled: function isMarketSettled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["e" /* isMarketSettled */])(this.market);
    },
    openOffersText: function openOffersText() {
      var buyOffers = thousandDisplay(this.contractModel.userOpenOrdersBuyQuantity, false);
      var sellOffers = thousandDisplay(this.contractModel.userOpenOrdersSellQuantity, false);
      // const prefix = (this.isLayoutDesktop && !this.isLayoutDashboard) ? 'Offers: ' : '';
      return buyOffers + '/' + sellOffers;
    },
    showOpenOffers: function showOpenOffers() {
      return !this.isMarketSettled && this.contractModel.userOpenOrders > 0;
    },
    showSharesBar: function showSharesBar() {
      return !this.isMarketSettled && this.contractModel.userQuantity > 0;
    },
    showOffersOrShares: function showOffersOrShares() {
      return this.showSharesBar || this.showOpenOffers;
    },
    showOuterPriceButton: function showOuterPriceButton() {
      return !this.isLayoutDashboard && this.isLayoutDesktop;
    },
    showInnerPriceButton: function showInnerPriceButton() {
      return this.isLayoutDashboard || this.isLayoutMobile;
    },
    disabledMarketButtonText: function disabledMarketButtonText() {
      return this.market.status;
    },
    shouldClosePurchaseJourney: function shouldClosePurchaseJourney() {
      return this.isLayoutDesktop && this.tradeOptions && this.tradeOptions.contractId === this.contract.contractId;
    },
    currentPrice: function currentPrice() {
      return this.contractModel.lastTradePriceAsCents;
    }
  }),
  watch: {
    // opposite side of order book was clicked -- switching sides
    tradeOperationToggle: function tradeOperationToggle(switchTo) {
      if (this.contract.contractId !== this.tradeOptions.contractId || !switchTo) return;
      var button = getActiveButtonAfterSwitch(this.contractModel, switchTo);
      this.toggleTradeOperation(null);
      this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, null, button.id);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'toggleTradeOperation']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    findActiveButton: function findActiveButton() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(BUTTONS).find(function (i) {
        return i.id === _this.activeButton;
      });
    },
    getTypeAndValueIfButtonActiveOrDefaults: function getTypeAndValueIfButtonActiveOrDefaults() {
      var type = this.tradeOptions.operationType;
      var value = this.tradeOptions.operationValue;
      if (this.activeButton) {
        var button = this.findActiveButton();
        type = button.type;
        value = button.value;
      }
      return { type: type, value: value };
    },
    onClickSharesBar: function onClickSharesBar() {
      var _getTypeAndValueIfBut = this.getTypeAndValueIfButtonActiveOrDefaults(),
          type = _getTypeAndValueIfBut.type,
          value = _getTypeAndValueIfBut.value;

      this.openPurchaseJourney(this.contractModel.contractId, type, value, 'my-shares');
    },
    onClickOpenOffers: function onClickOpenOffers() {
      var tab = 'sell-offers';
      var operationType = this.tradeOptions.operationType || '';
      if (operationType === '' && this.contractModel.userOpenOrdersBuyQuantity || operationType === OPERATIONS.BUY && this.contractModel.userOpenOrdersBuyQuantity) {
        tab = 'buy-offers';
      }

      var _getTypeAndValueIfBut2 = this.getTypeAndValueIfButtonActiveOrDefaults(),
          type = _getTypeAndValueIfBut2.type,
          value = _getTypeAndValueIfBut2.value;

      this.openPurchaseJourney(this.contractModel.contractId, type, value, tab);
    },
    activatePurchaseJourneyForMarket: function activatePurchaseJourneyForMarket() {
      var button = this.contractModel.mode === VALUES.NO ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
      this.activeButton = button.id;
      if (this.showPurchaseOnInit) {
        this.$emit('purchaseShown');
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, null, null);
      } else if ((!this.isMarketSingle || this.isLayoutMobile) && this.tradeOptions && this.contract.contractId === this.tradeOptions.contractId && (button.type !== this.tradeOptions.operationType || button.value !== this.tradeOptions.operationValue)) {
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, null, null);
      }
    },
    onContractClick: function onContractClick() {
      if (this.shouldClosePurchaseJourney) {
        this.setTradeOptions(null);
        return;
      }
      if (!this.isMarketDisabled && this.activeButton) {
        var $el = this.$refs[this.activeButton];
        if (!$el) return;
        var ev = new MouseEvent('click');
        $el.dispatchEvent(ev);
      } else {
        var button = this.contractModel.mode === VALUES.NO ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, null, null);
      }
    },
    isButtonActive: function isButtonActive(index) {
      var isOn = this.activeButton === index;
      return {
        'market-contract-horizontal-v2__button-single--on': isOn,
        'market-contract-horizontal-v2__button-single--off': !isOn
      };
    },
    openPurchaseJourney: function openPurchaseJourney(contractId, operationType, operationValue) {
      var _this2 = this;

      var defaultTab = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var activateButton = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      if (this.isWaiting) {
        return;
      }

      this.isWaiting = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_mutex__["a" /* waitForFirebaseInitialized */])().then(function () {
        _this2.isWaiting = false;
        // contract does not modify tradeOptions, is simply used as a widget somewhere
        if (_this2.forCmsWidget) {
          _this2.$emit('contractClicked', { contractId: contractId });
          return;
        }
        if (_this2.isLoggedIn && _this2.status.isClassicEnabled === false) {
          _this2.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
          return;
        }
        if (_this2.isLoggedIn && !_this2.isUserVerified) {
          _this2.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_VERIFY);
          return;
        }
        if (_this2.isLoggedIn && !_this2.status.hasBeenFunded) {
          _this2.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS);
          return;
        }
        if (_this2.isMarketSettled) return;
        if (_this2.isMarketDisabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["m" /* contractOwnershipNum */])(_this2.contractModel) === 0) return;
        if (activateButton) {
          _this2.activeButton = activateButton;
        }

        _this2.setTradeOptions({
          contractId: contractId,
          operationType: operationType,
          defaultTab: defaultTab,
          operationValue: operationValue !== null ? operationValue : _this2.contractModel.mode || VALUES.YES
        });
      });
    }
  })
});

/***/ }),

/***/ "E2Y7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__ = __webpack_require__("tQfv");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  created: function created() {
    var _this = this;

    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* STATIC_PAGES */].RESEARCH).then(function (data) {
      _this.installDynamicControls({ data: data });
    });
  }
});

/***/ }),

/***/ "E3zi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MODALS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_modal_modal_vue__ = __webpack_require__("CAzF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_modal_layouts_generic_vue__ = __webpack_require__("7okt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_modal_layouts_generic_small_vue__ = __webpack_require__("WRh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_account_login_account_login_vue__ = __webpack_require__("V3zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_account_account_login_footer_footer_vue__ = __webpack_require__("ULMz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_account_account_forgotten_account_forgotten_vue__ = __webpack_require__("8TeC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_account_account_forgotten_footer_footer_vue__ = __webpack_require__("koWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_account_account_register_account_register_vue__ = __webpack_require__("61DT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_account_account_register_footer_footer_vue__ = __webpack_require__("cVuz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_account_account_register_external_account_register_external_vue__ = __webpack_require__("E9c5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_account_account_details_modal_account_details_verify_vue__ = __webpack_require__("EKqI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_account_account_upload_id_account_upload_id_vue__ = __webpack_require__("flEW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_account_account_upload_document_account_upload_document_vue__ = __webpack_require__("3USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_account_account_details_modal_account_details_update_modal_vue__ = __webpack_require__("IUvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_account_account_update_image_account_update_image_vue__ = __webpack_require__("Aqlg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_wallet_add_funds_combined_add_funds_combined_vue__ = __webpack_require__("l9wN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_wallet_add_funds_combined_footer_footer_vue__ = __webpack_require__("1F6f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_wallet_deposited_deposited_vue__ = __webpack_require__("WXHk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_potential_payouts_potential_payouts_vue__ = __webpack_require__("gTQM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_generics_modal_small_small_vue__ = __webpack_require__("+CQ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_export_history_export_history_vue__ = __webpack_require__("cgtd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_purchase_purchase_modal_purchase_modal_vue__ = __webpack_require__("Ktaw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_insight_insight_modal_insight_modal_vue__ = __webpack_require__("TJ+c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_research_research_vue__ = __webpack_require__("eNmc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_tax_info_notification_tax_info_notification_vue__ = __webpack_require__("wQDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_twitter_twitter_timeline_twitter_timeline_vue__ = __webpack_require__("FM5G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_home_home_old_news_feed_news_feed_vue__ = __webpack_require__("xJ4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_attach_to_home_attach_to_home_vue__ = __webpack_require__("r6f4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_offers_indicator_popup_offers_indicator_popup_vue__ = __webpack_require__("zyut");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_market_market_contracts_stats_popup_market_contracts_stats_popup_vue__ = __webpack_require__("ETXZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_account_account_reset_password_account_reset_password_vue__ = __webpack_require__("TMp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_orientation_info_orientation_info_vue__ = __webpack_require__("v0Cj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_account_account_badges_list_account_badges_list_vue__ = __webpack_require__("yeq6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_social_user_profile_overview_user_profile_overview_vue__ = __webpack_require__("M6xY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_social_user_profile_overview_header_user_profile_overview_header_vue__ = __webpack_require__("nNeU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_social_user_report_user_report_vue__ = __webpack_require__("0RmI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_leaderboards_leaderboards_trophy_pyramid_leaderboards_trophy_pyramid_vue__ = __webpack_require__("mgKt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_messaging_journey_info_messaging_journey_info_vue__ = __webpack_require__("sIse");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_wallet_coinbase_process_overview_coinbase_process_overview_vue__ = __webpack_require__("MbhW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_profile_affiliations_popup_affiliations_popup_vue__ = __webpack_require__("jI1b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_announcement_announcement_vue__ = __webpack_require__("Mz4K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_account_account_already_exists_account_already_exists_vue__ = __webpack_require__("QSM8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_account_account_already_exists_footer_footer_vue__ = __webpack_require__("Z/tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_account_account_enable_classic_predictit_account_enable_classic_predictit_vue__ = __webpack_require__("Y6Bb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_account_account_enable_classic_predictit_footer_footer_vue__ = __webpack_require__("nBxi");
















































var MODALS = {
  LOGIN: 'login',
  FORGOTTEN: 'forgotten',
  RESET_PASSWORD: 'reset-password',
  REGISTER: 'register',
  REGISTER_EXTERNAL: 'register-external',
  ACCOUNT_VERIFY: 'account-verify',
  UPLOAD_ID: 'upload-id',
  TAX_INFO: 'tax-info',
  ATTACH_TO_HOME: 'attach-to-home',
  ACCOUNT_DETAIL_UPDATE: 'account-detail-update',
  ACCOUNT_DETAIL_PASSWORD: 'account-detail-password',
  ACCOUNT_DETAIL_PASSWORD_SET: 'account-detail-password-set',
  ACCOUNT_ADDRESS_UPDATE: 'account-address-update',
  ADD_FUNDS: 'add-funds',
  PAYMENT_SUCCESS: 'payment-success',
  PAYMENT_ERROR: 'payment-error',
  POTENTIAL_PAYOUTS: 'potential-payouts',
  MARKET_CONTRACT_STATS: 'market-contracts-stats',
  RESEARCH: 'research',
  TWITTER: 'twitter',
  NEWS_FEED: 'news-feed',
  PURCHASE: 'purchase-modal',
  INSIGHT: 'insight-modal',
  GENERIC: 'generic',
  EXPORT_TRADE_HISTORY: 'export-trade-history',
  EXPORT_TRANSACTION_HISTORY: 'export-transaction-history',
  COINBASE: 'coinbase',
  SMALL_CVV: 'cvv',
  SMALL_SWIFT: 'swift',
  SMALL_ROUTING_NUMBER: 'routing-number',
  SMALL_EDIT_IMAGE: 'edit-image',
  SMALL_MARKET_RULES: 'market-rules',
  SMALL_GENERIC: 'generic-small',
  SMALL_USERNAME: 'username',
  SMALL_TRADE_INFO: 'account-trade-info',
  SMALL_OFFERS_INDICATOR: 'offers-indicator',
  SMALL_VERIFICATION_INFO: 'verfication-info',
  SMALL_OWNERSHIP_INFO: 'ownership-info',
  SMALL_BADGES: 'badges',
  SMALL_USER_PROFILE: 'user-profile',
  SMALL_REPORT_USER: 'report-user',
  SMALL_ROI_INFO: 'roi-info',
  SMALL_FEE_INFO: 'fee-info',
  SMALL_WINS_INFO: 'wins-info',
  SMALL_LEADERBOARDS_UPDATE_INFO: 'leaderboards-update-info',
  SMALL_SHARE_INVITE_INFO: 'share-invite-info',
  SMALL_PUBLIC_PROFILE_INFO: 'public-profile-info',
  SMALL_RESTRICTED_FUNDS_INFO: 'restricted-funds-info',
  SMALL_ANNOUNCEMENT: 'announcement',
  UPLOAD_DOCUMENT: 'upload-document',
  ORIENTATION: 'orientation',
  SMALL_MESSAGING_JOURNEY: 'messaging-journey',
  SMALL_PWMB_ACCOUNT_CONFIRM_DELETE: 'pwmb-account-confirm-delete',
  AFFILIATIONS: 'affiliations',
  VIDEO: 'video',
  ACCOUNT_ALREADY_EXISTS: 'account-already-exists',
  ACCOUNT_ENABLE_CLASSIC: 'account-enable-classic'
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  components: {
    modal: __WEBPACK_IMPORTED_MODULE_2__components_generics_modal_modal_vue__["a" /* default */],
    announcement: __WEBPACK_IMPORTED_MODULE_42__components_announcement_announcement_vue__["a" /* default */],
    affiliationsPopup: __WEBPACK_IMPORTED_MODULE_41__components_profile_affiliations_popup_affiliations_popup_vue__["a" /* default */],
    addFundsCombined: __WEBPACK_IMPORTED_MODULE_17__components_wallet_add_funds_combined_add_funds_combined_vue__["a" /* default */],
    addFundsCombinedFooter: __WEBPACK_IMPORTED_MODULE_18__components_wallet_add_funds_combined_footer_footer_vue__["a" /* default */],
    accountDetailsVerify: __WEBPACK_IMPORTED_MODULE_12__components_account_account_details_modal_account_details_verify_vue__["a" /* default */],
    accountUploadId: __WEBPACK_IMPORTED_MODULE_13__components_account_account_upload_id_account_upload_id_vue__["a" /* default */],
    accountUploadDocument: __WEBPACK_IMPORTED_MODULE_14__components_account_account_upload_document_account_upload_document_vue__["a" /* default */],
    accountDetailsUpdateModal: __WEBPACK_IMPORTED_MODULE_15__components_account_account_details_modal_account_details_update_modal_vue__["a" /* default */],
    accountLogin: __WEBPACK_IMPORTED_MODULE_5__components_account_account_login_account_login_vue__["a" /* default */],
    accountLoginFooter: __WEBPACK_IMPORTED_MODULE_6__components_account_account_login_footer_footer_vue__["a" /* default */],
    accountForgotten: __WEBPACK_IMPORTED_MODULE_7__components_account_account_forgotten_account_forgotten_vue__["a" /* default */],
    accountForgottenFooter: __WEBPACK_IMPORTED_MODULE_8__components_account_account_forgotten_footer_footer_vue__["a" /* default */],
    accountRegister: __WEBPACK_IMPORTED_MODULE_9__components_account_account_register_account_register_vue__["a" /* default */],
    accountRegisterFooter: __WEBPACK_IMPORTED_MODULE_10__components_account_account_register_footer_footer_vue__["a" /* default */],
    accountRegisterExternal: __WEBPACK_IMPORTED_MODULE_11__components_account_account_register_external_account_register_external_vue__["a" /* default */],
    accountUpdateImage: __WEBPACK_IMPORTED_MODULE_16__components_account_account_update_image_account_update_image_vue__["a" /* default */],
    attachToHome: __WEBPACK_IMPORTED_MODULE_29__components_attach_to_home_attach_to_home_vue__["a" /* default */],
    deposited: __WEBPACK_IMPORTED_MODULE_19__components_wallet_deposited_deposited_vue__["a" /* default */],
    genericPopup: __WEBPACK_IMPORTED_MODULE_3__components_generics_modal_layouts_generic_vue__["a" /* default */],
    genericSmallPopup: __WEBPACK_IMPORTED_MODULE_4__components_generics_modal_layouts_generic_small_vue__["a" /* default */],
    offersIndicatorPopup: __WEBPACK_IMPORTED_MODULE_30__components_offers_indicator_popup_offers_indicator_popup_vue__["a" /* default */],
    potentialPayouts: __WEBPACK_IMPORTED_MODULE_20__components_potential_payouts_potential_payouts_vue__["a" /* default */],
    smallModal: __WEBPACK_IMPORTED_MODULE_21__components_generics_modal_small_small_vue__["a" /* default */],
    exportHistory: __WEBPACK_IMPORTED_MODULE_22__components_export_history_export_history_vue__["a" /* default */],
    purchaseModal: __WEBPACK_IMPORTED_MODULE_23__components_purchase_purchase_modal_purchase_modal_vue__["a" /* default */],
    insightModal: __WEBPACK_IMPORTED_MODULE_24__components_insight_insight_modal_insight_modal_vue__["a" /* default */],
    research: __WEBPACK_IMPORTED_MODULE_25__components_research_research_vue__["a" /* default */],
    taxInfoNotification: __WEBPACK_IMPORTED_MODULE_26__components_tax_info_notification_tax_info_notification_vue__["a" /* default */],
    twitterTimeline: __WEBPACK_IMPORTED_MODULE_27__components_twitter_twitter_timeline_twitter_timeline_vue__["a" /* default */],
    newsFeed: __WEBPACK_IMPORTED_MODULE_28__components_home_home_old_news_feed_news_feed_vue__["a" /* default */],
    marketContractsStatsPopup: __WEBPACK_IMPORTED_MODULE_31__components_market_market_contracts_stats_popup_market_contracts_stats_popup_vue__["a" /* default */],
    accountResetPassword: __WEBPACK_IMPORTED_MODULE_32__components_account_account_reset_password_account_reset_password_vue__["a" /* default */],
    orientationInfo: __WEBPACK_IMPORTED_MODULE_33__components_orientation_info_orientation_info_vue__["a" /* default */],
    accountBadgesList: __WEBPACK_IMPORTED_MODULE_34__components_account_account_badges_list_account_badges_list_vue__["a" /* default */],
    userProfileOverview: __WEBPACK_IMPORTED_MODULE_35__components_social_user_profile_overview_user_profile_overview_vue__["a" /* default */],
    userProfileOverviewHeader: __WEBPACK_IMPORTED_MODULE_36__components_social_user_profile_overview_header_user_profile_overview_header_vue__["a" /* default */],
    userReport: __WEBPACK_IMPORTED_MODULE_37__components_social_user_report_user_report_vue__["a" /* default */],
    leaderboardsTrophyPyramid: __WEBPACK_IMPORTED_MODULE_38__components_leaderboards_leaderboards_trophy_pyramid_leaderboards_trophy_pyramid_vue__["a" /* default */],
    messagingJourneyInfo: __WEBPACK_IMPORTED_MODULE_39__components_messaging_journey_info_messaging_journey_info_vue__["a" /* default */],
    coinbaseProcessOverview: __WEBPACK_IMPORTED_MODULE_40__components_wallet_coinbase_process_overview_coinbase_process_overview_vue__["a" /* default */],
    accountAlreadyExists: __WEBPACK_IMPORTED_MODULE_43__components_account_account_already_exists_account_already_exists_vue__["a" /* default */],
    accountAlreadyExistsFooter: __WEBPACK_IMPORTED_MODULE_44__components_account_account_already_exists_footer_footer_vue__["a" /* default */],
    accountEnableClassicPredictit: __WEBPACK_IMPORTED_MODULE_45__components_account_account_enable_classic_predictit_account_enable_classic_predictit_vue__["a" /* default */],
    accountEnableClassicPredictitFooter: __WEBPACK_IMPORTED_MODULE_46__components_account_account_enable_classic_predictit_footer_footer_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['isTaxNotificationMandatory']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('popup', ['currentPopup', 'currentSmallPopup', 'currentPopupOptions', 'lastTopPosition', 'tradePopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isShutdownModeOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isUserRestricted']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['status']), {
    footerHideBodyClass: function footerHideBodyClass() {
      return this.currentPopupOptions.hideFooter ? 'modal__body--medium modal__footer--hide' : 'modal__body--medium';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentSmallPopup', 'setCurrentPopupWithDelay']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['setCurrentDeposit', 'markFirstDepositDone']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['logout']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('overlay', { hideOverlay: 'hide' }), {
    isCurrentModal: function isCurrentModal(name) {
      return this.currentPopup === name;
    },
    isCurrentSmallModal: function isCurrentSmallModal(name) {
      return this.currentSmallPopup === name;
    },
    closeModal: function closeModal() {
      this.setCurrentPopup();
      this.onClose();
    },
    closeSmallModal: function closeSmallModal() {
      this.setCurrentSmallPopup();
      this.onClose();
    },
    closeModalWithLogout: function closeModalWithLogout() {
      this.logout();
      this.setCurrentPopup();
      this.onClose();
    },
    closePaymentSuccessModal: function closePaymentSuccessModal() {
      this.markFirstDepositDone();
      this.setCurrentPopup();
      this.setCurrentDeposit(null);
      this.onClose();
    },
    closeModalHideOverlay: function closeModalHideOverlay() {
      this.setCurrentPopup();
      this.hideOverlay();
      this.onClose();
    },
    closeUserReportModal: function closeUserReportModal() {
      this.setCurrentSmallPopup(MODALS.SMALL_USER_PROFILE);
    },
    onClose: function onClose() {
      if (this.currentPopupOptions && typeof this.currentPopupOptions.onClose !== 'undefined') {
        this.currentPopupOptions.onClose.apply(this);
      }
    },
    addFundsClose: function addFundsClose() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: 'Closing/Cancel Deposit Modal'
      });
      this.closeModal();
    },
    paymentSuccessDone: function paymentSuccessDone() {
      if (this.status.isUCAffilSet === null) {
        this.setCurrentPopupWithDelay({ name: MODALS.AFFILIATIONS });
      } else {
        this.closeModal();
      }
    }
  }),
  data: function data() {
    return {
      MODALS: MODALS,
      gtmAddFunds: {
        virtualPage: '/Account/_DptFrmUsSgnUp',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Deposit',
          action: 'click',
          label: 'Closing Deposit Modal'
        }
      },
      gtmAccountVerify: {
        virtualPage: '_SgnUpDptIDV',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'ID Verification',
          action: 'click',
          label: 'Closing ID Verification Modal'
        }
      },
      gtmLogin: {
        name: 'login',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Login',
          action: 'click',
          label: 'Closing Login Modal'
        }
      },
      gtmSignUp: {
        virtualPage: '/Account/SignUp',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Registration',
          action: 'click',
          label: 'Closing Registration Modal'
        }
      }
    };
  }
});

/***/ }),

/***/ "E5wa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_page_election_map_new_election_map_election_map_vue__ = __webpack_require__("nYw4");








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    item: {
      type: Object,
      required: true
    },
    type: {
      type: String
    }
  },
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_3__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'overview-map-contract': true
      }, 'overview-map-contract--' + this.type, this.type);
    },
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_4__models_contract__["a" /* default */](this.item);
    },
    color: function color() {
      var pallette = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__components_pages_page_election_map_new_election_map_election_map_vue__["a" /* getColorForPalletteCandidate */])(this.item.shortName);
      return pallette[__WEBPACK_IMPORTED_MODULE_6__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH].color;
    },
    bgColorStyleModifiers: function bgColorStyleModifiers() {
      return {
        'background-color': this.color
      };
    },
    imageStyleModifiers: function imageStyleModifiers() {
      return {
        'background-image': 'url(\'' + this.item.contractImageUrl + '\')'
      };
    },
    marketDetailUrl: function marketDetailUrl() {
      if (!__WEBPACK_IMPORTED_MODULE_5__mixins_userAgent__["f" /* isStandalone */]) {
        return this.type === 'senate' ? 'https://www.predictit.org/markets/detail/6874' : 'https://www.predictit.org/markets/detail/3698';
      }
      return '#';
    }
  })
});

/***/ }),

/***/ "E9c5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_register_external_js__ = __webpack_require__("RSTw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2137cbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_register_external_vue__ = __webpack_require__("yG7b");
function injectStyle (ssrContext) {
  __webpack_require__("ns37")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_register_external_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2137cbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_register_external_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ECXD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-terms-and-conditions",domProps:{"innerHTML":_vm._s(_vm.content)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ED1x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{staticClass:"account-update-password form content-header__section-group",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('p',{staticClass:"account-update-password__disclaimer"},[_vm._v("\r\n      "+_vm._s(_vm.$txt('account-update-password.disclaimer'))+"\r\n    ")]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.currentPassword,"name":"currentPassword","type":"password","validator":"password","required":true,"autocomplete":"off","placeholder":"Current Password"},on:{"input":_vm.$v.fields.currentPassword.$touch},model:{value:(_vm.fields.currentPassword),callback:function ($$v) {_vm.$set(_vm.fields, "currentPassword", $$v)},expression:"fields.currentPassword"}})],1),_vm._v(" "),_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.newPassword,"name":"newPassword","type":"password","validator":"password","required":true,"autocomplete":"off","placeholder":"New Password"},on:{"input":_vm.$v.fields.newPassword.$touch},model:{value:(_vm.fields.newPassword),callback:function ($$v) {_vm.$set(_vm.fields, "newPassword", $$v)},expression:"fields.newPassword"}})],1),_vm._v(" "),_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.newPasswordConfirmation,"name":"newPasswordConfirmation","type":"password","validator":"password","required":true,"autocomplete":"off","placeholder":"Confirm New Password"},on:{"input":_vm.$v.fields.newPasswordConfirmation.$touch},model:{value:(_vm.fields.newPasswordConfirmation),callback:function ($$v) {_vm.$set(_vm.fields, "newPasswordConfirmation", $$v)},expression:"fields.newPasswordConfirmation"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('password-requirements',{attrs:{"validation":_vm.$v.fields.newPassword}})],1)]),_vm._v(" "),_c('div',{staticClass:"account-update-password__buttons"},[_c('form-submit',{attrs:{"disabled":_vm.invalidOrDisabled,"label":_vm.$txt('account-update-password.button')}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EGLE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");




/*
  Use this component as <captcha :key="parentVar"></captcha>
  and update var on error, so it rerenders properly.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      key: ''
    };
  },

  computed: {
    styleModifiers: function styleModifiers() {
      return {
        transform: 'scale(0.95)'
      };
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getCaptchaSiteKey']), {
    onSuccess: function onSuccess(value) {
      this.$emit('input', value);
    },
    onExpired: function onExpired() {
      this.$emit('input', null);
    }
  }),
  mounted: function mounted() {
    var _this = this;

    var url = 'https://www.google.com/recaptcha/api.js';
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["a" /* loadScript */])(url, 'grecaptcha').then(function (grecaptcha) {
      _this.getCaptchaSiteKey().then(function (data) {
        _this.key = data;
        grecaptcha.ready(function () {
          grecaptcha.render(_this.$refs.captcha, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
            sitekey: _this.key,
            callback: _this.onSuccess
          }, 'expired-callback', _this.onExpired));
        });
      });
    });
  }
});

/***/ }),

/***/ "EI6j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"how-it-works-old"},[_c('h2',{staticClass:"how-it-works-old__title"},[(_vm.isUserRestricted)?[_vm._v("\n      Coming Soon\n    ")]:(_vm.isShutdownModeOn)?[_vm._v("\n      How Prediction Markets Work\n    ")]:[_vm._v("\n      How It Works\n    ")]],2),_vm._v(" "),_c('div',{staticClass:"how-it-works-old__items row"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"how-it-works-old__item column small-12 large-4"},[_c('div',{staticClass:"how-it-works-old__item-image-container"},[_c('img',{staticClass:"how-it-works-old__item-image",attrs:{"src":item.icon}})]),_vm._v(" "),_c('h4',{staticClass:"how-it-works-old__item-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"how-it-works-old__item-description"},[_vm._v("\n        "+_vm._s(item.description)+"\n      ")])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EKqI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_details_verify_js__ = __webpack_require__("5f2b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2c20888_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_details_verify_vue__ = __webpack_require__("nuYZ");
function injectStyle (ssrContext) {
  __webpack_require__("peeU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_details_verify_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2c20888_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_details_verify_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ENdH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return connect; });
/* unused harmony export forceReconnect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createConnection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isConnected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return forceDisconnect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__("G/BR");
/* global $ */
/* eslint-disable */


var STATES = ['connecting', 'connected', 'reconnecting', '', 'disconnected'];
var reconnectTimeout = 5 * 1000;
var channelMarketHub = null;
var connection = null;
var reconnectDisabled = false;

function createConnection() {
  if (typeof $ !== 'undefined' && typeof $.hubConnection !== 'undefined') {
    connection = $.hubConnection("https://hub.predictit.org/signalr", {
      useDefaultPath: false
    });
    channelMarketHub = connection.createHubProxy('marketHub');
  }
  return null;
}

var isConnected = function isConnected() {
  return connection !== null;
};

var connect = function connect() {
  if (!isConnected()) return;
  channelMarketHub.on('update', function (objectType, object) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'marketHub::', 'update::', objectType, object);
  });
  connection.start().done(function (state) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'connection::', 'connected::', state.id, state);
  }).fail(function (error) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'connection::', 'errored::', error);
    if (reconnectDisabled) {
      __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnect-disabled::');
    } else {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnect::');
        connection.start();
      }, reconnectTimeout);
    }
  });
  connection.starting(function () {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: starting::');
  });
  connection.received(function (data) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'received::', data);
  });
  connection.connectionSlow(function () {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: connectionSlow::');
  });
  connection.reconnecting(function () {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnecting::');
  });
  connection.reconnected(function () {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnected::');
  });
  connection.stateChanged(function (change) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: stateChanged::', STATES[change.oldState], ' => ', STATES[change.newState]);
  });
  connection.disconnected(function () {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: disconnected::', connection.lastError);
    if (reconnectDisabled) {
      __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnect-disabled::');
    } else {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: reconnect::');
        connection.start();
      }, reconnectTimeout);
    }
  });
  window.onbeforeunload = function () {
    connection.stop();
  };
};

var addListener = function addListener(options) {
  __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket::', 'adding listener');
  var _options$onUpdate = options.onUpdate,
      onUpdate = _options$onUpdate === undefined ? function () {
    return null;
  } : _options$onUpdate;

  channelMarketHub.on('update', function (objectType, object) {
    onUpdate('update', objectType, object);
  });
};

var setToken = function setToken(options) {
  var _options$token = options.token,
      token = _options$token === undefined ? null : _options$token;

  if (token !== null && connection !== null) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: token present, add bearer');
    connection.qs = { bearer: token };
  }
};

var forceReconnect = function forceReconnect() {
  if (document.readyState !== 'complete') return;
  if (!isConnected()) return;
  connection.stop();
  setTimeout(function () {
    connection.start();
  }, 1000);
};

var forceDisconnect = function forceDisconnect() {
  if (!isConnected()) return;
  __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('socket:: forceDisconnect::');
  reconnectDisabled = true;
  connection.stop();
};



/***/ }),

/***/ "ENjL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EOu+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return waitForFirebaseInitialized; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return waitForStatusReady; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");

/* eslint-disable */


var waitForFirebaseInitialized = function waitForFirebaseInitialized() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    var check = function check() {
      if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.app.firebaseInitialized || !__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters['user/isLoggedIn']) {
        resolve();
      } else {
        setTimeout(check, 200);
      }
    };
    check();
  });
};

var waitForStatusReady = function waitForStatusReady() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    var check = function check() {
      if (typeof __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.user.status.hasBeenFunded !== 'undefined') {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
};

/***/ }),

/***/ "ETXZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_stats_popup_js__ = __webpack_require__("eFE/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c8c69d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_stats_popup_vue__ = __webpack_require__("v0+/");
function injectStyle (ssrContext) {
  __webpack_require__("/5V2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_stats_popup_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c8c69d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_stats_popup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EZP0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_simple_js__ = __webpack_require__("OHuv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b885b25_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_simple_vue__ = __webpack_require__("5inO");
function injectStyle (ssrContext) {
  __webpack_require__("z5zI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_simple_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b885b25_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_simple_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EcaT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_notification_items_notification_item_simple_notification_item_simple_vue__ = __webpack_require__("EZP0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_notification_items_notification_item_trade_confirmed_notification_item_trade_confirmed_vue__ = __webpack_require__("uVqX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_notification_items_notifcation_item_dashboard_notification_item_dashboard_vue__ = __webpack_require__("MJqx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__ = __webpack_require__("a0yF");

/* eslint-disable no-unused-vars */
/*
  Display List of notifications in top right side of the page, reuses many components.
  One of used components is dashboard notification which for now is used to display:
  - NOTIFICATION_SHARES_TRADES
 */






var ROUTE_PORTFOLIO = 'portfolio';
var ROUTE_MARKET_DETAILS = 'market-details';

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    notificationItemDashboard: __WEBPACK_IMPORTED_MODULE_4__components_notification_items_notifcation_item_dashboard_notification_item_dashboard_vue__["a" /* default */],
    notificationItemSimple: __WEBPACK_IMPORTED_MODULE_2__components_notification_items_notification_item_simple_notification_item_simple_vue__["a" /* default */],
    notificationItemTradeConfirmed: __WEBPACK_IMPORTED_MODULE_3__components_notification_items_notification_item_trade_confirmed_notification_item_trade_confirmed_vue__["a" /* default */]
  },
  data: function data() {
    return {
      NOTIFICATION_SHARES_TRADES_CLOSE_DELAY: __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["g" /* NOTIFICATION_SHARES_TRADES_CLOSE_DELAY */],
      NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY: __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["h" /* NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY */],
      activeNotification: null,
      currentRoute: this.$router.currentRoute
    };
  },

  watch: {
    notificationList: function notificationList(value) {
      this.activeNotification = value[value.length - 1];
    },
    $route: function $route(to, from) {
      this.currentRoute = to;
      if (from.name !== to.name) {
        this.clear();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('notifications', ['notificationList']), {
    notificationsToDisplay: function notificationsToDisplay() {
      return this.notificationList.filter(this.isNotificationDisplayable);
    },
    shouldDisplayNotifications: function shouldDisplayNotifications() {
      return this.notificationsToDisplay.length > 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['clear']), {
    onClose: function onClose() {
      this.clear();
    },
    isNotificationDisplayable: function isNotificationDisplayable(notification) {
      return this.shouldDisplayNotificationSimple(notification) || this.shouldDisplayNotificationTradeConfirmed(notification) || this.shouldDisplayDashboardNotification(notification);
    },
    shouldDisplayNotificationSimple: function shouldDisplayNotificationSimple(notification) {
      return notification.type === __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["i" /* NOTIFICATION_SIMPLE */];
    },
    shouldDisplayNotificationTradeConfirmed: function shouldDisplayNotificationTradeConfirmed(notification) {
      if (this.currentRoute.name === ROUTE_MARKET_DETAILS) {
        return notification.type === __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["j" /* NOTIFICATION_TRADE_CONFIRMED */] && notification.data.MarketId.toString() === this.currentRoute.params.marketId.toString();
      } else if (this.currentRoute.name === ROUTE_PORTFOLIO) {
        return notification.type === __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["j" /* NOTIFICATION_TRADE_CONFIRMED */];
      }
      return false;
    },
    shouldDisplayDashboardNotification: function shouldDisplayDashboardNotification(notification) {
      var types = [__WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["k" /* NOTIFICATION_SHARES_TRADES */], __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["l" /* NOTIFICATION_TRADER_LEVEL_CHANGED */]];
      return types.includes(notification.type);
    }
  })
});

/***/ }),

/***/ "Ed8h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Efhk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_insights__ = __webpack_require__("95qB");



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_insights__["a" /* default */]],
  props: {
    theme: {
      type: String,
      default: ''
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'insight-widget': true
      }, 'insight-widget--' + this.theme, this.theme);
    }
  }
});

/***/ }),

/***/ "EhGh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_pending_requests_js__ = __webpack_require__("3CaU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65ae6da4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_requests_vue__ = __webpack_require__("PUQq");
function injectStyle (ssrContext) {
  __webpack_require__("vgpr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_pending_requests_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65ae6da4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_requests_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EjHU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_password_requirements_js__ = __webpack_require__("LHdv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15bec6e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_password_requirements_vue__ = __webpack_require__("X1oX");
function injectStyle (ssrContext) {
  __webpack_require__("zxhS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_password_requirements_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15bec6e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_password_requirements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EoBZ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDIxIDIxIj4NCiAgICA8ZyBmaWxsPSIjNjc5OTlGIiBmaWxsLXJ1bGU9Im5vbnplcm8iPg0KICAgICAgICA8cGF0aCBkPSJNMTAuNSAwQzQuNzEgMCAwIDQuNzEgMCAxMC41UzQuNzEgMjEgMTAuNSAyMSAyMSAxNi4yOSAyMSAxMC41IDE2LjI5IDAgMTAuNSAwem0wIDE5LjJjLTQuNzk3IDAtOC43LTMuOTAzLTguNy04LjcgMC00Ljc5NyAzLjkwMy04LjcgOC43LTguNyA0Ljc5NyAwIDguNyAzLjkwMyA4LjcgOC43IDAgNC43OTctMy45MDMgOC43LTguNyA4Ljd6Ii8+DQogICAgICAgIDxwYXRoIGQ9Ik0xMC42NyA4LjQ5NWMuNjgyLjAwNiAxLjI0My0uNTcgMS4yNS0xLjI3NGExLjI2NiAxLjI2NiAwIDAgMC0xLjI0My0xLjI5M2MtLjY5NSAwLTEuMjY0LjU2Mi0xLjI3IDEuMjczIDAgLjcwNC41NjEgMS4yODcgMS4yNjMgMS4yOTR6TTEyLjE3NCAxNC4yNzJjLS4xMi4wNDctLjIzNC4xMzUtLjM1NC4xODJhMS45NDIgMS45NDIgMCAwIDEtLjQ2OC4xMzZjLS4xOTQuMDItLjMzNC0uMDgxLS4zODEtLjI3MWExLjQwNiAxLjQwNiAwIDAgMS0uMDQtLjQ0Yy4wMzMtLjMwNS4wOTMtLjYwMy4xNDctLjkwOC4xNi0uOTA3LjMzNC0xLjgxNS40ODgtMi43MjkuMDQtLjI0NC4wODctLjQ5NC4wOC0uNzQ1LS4wMDctLjI5OC0uMTgtLjQ0LS40NzUtLjQ0SDguNzkyYTIuMDUgMi4wNSAwIDAgMC0uMjg4LjAyYy0uMTguMDM0LS4yNjcuMTIyLS4yOC4yNjQtLjAxNC4xMjkuMDUzLjI1OC4yMi4zMTkuMTM0LjA0Ny4yNzQuMDYuNDE1LjA4LjMyLjA0OC40MjguMTYzLjQyOC40OTUgMCAuMDU0LS4wMDcuMTAyLS4wMTQuMTU2LS4xMzQuOC0uMjggMS41OTEtLjQxNCAyLjM5LS4wNzQuNDYxLS4xNDcuOTE1LS4yMDcgMS4zNzUtLjA5NC42Ny41NDggMS4zMDggMS4wNDkgMS4zNzUuMy4wNC42MDguMDU0LjkxNi4wNDguNjU1LS4wMDcgMS4yMDMtLjI5MiAxLjY2NC0uNzU5YS42OTYuNjk2IDAgMCAwIC4xNzQtLjMwNWMuMDUzLS4xOS0uMDk0LS4zMTgtLjI4MS0uMjQzeiIvPg0KICAgIDwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "Eu6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:_vm.classModifiers},[_c('div',{staticClass:"main-nav-old__menu"},_vm._l((_vm.filteredUrls),function(item){return _c('div',{staticClass:"main-nav-old__item",on:{"click":function($event){return _vm.onLinkClick(item.href)}}},[(_vm.showRegularItem(item))?_c('router-link',{class:_vm.classModifier(item.name),attrs:{"id":("nav-" + (item.name)),"to":item.href}},[_vm._v("\n          "+_vm._s(item.title.toString())+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.showSocialAvatarOnMobile(item))?_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.onAvatarClick($event)}}},[_vm._v("\n         \n        "),_c('account-social-avatar',{attrs:{"theme":"nav-bottom-old","avatar":_vm.userAvatar,"showProgress":true,"percentage":100,"progressStrokeColor":_vm.levelColorWithRespectToNav,"showEdit":false}},[_c('span',{attrs:{"slot":"label"},on:{"click":function($event){$event.stopPropagation();return _vm.onAvatarClick($event)}},slot:"label"},[_vm._v("Dashboard")])])],1):_vm._e()],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EvDZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-upload-id"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"account-upload-id__note"},[_vm._v("\n    "+_vm._s(_vm.$txt('account-upload-id.info'))+"\n  ")]),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width",on:{"click":function($event){$event.preventDefault();return _vm.onButtonClick($event)}}},[_vm._v("\n    "+_vm._s(_vm.$txt('account-upload-id.button'))+"\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-upload-id__icon"},[_c('img',{attrs:{"src":__webpack_require__("z6fO")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EvOh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_mobile_js__ = __webpack_require__("tE+S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aa76541_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_mobile_vue__ = __webpack_require__("y5Vv");
function injectStyle (ssrContext) {
  __webpack_require__("SygH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_mobile_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aa76541_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_mobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EyLR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_header_app_header_vue__ = __webpack_require__("8hek");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_header_app_header_new_vue__ = __webpack_require__("siP5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_main_nav_app_main_nav_vue__ = __webpack_require__("3cKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app_app_footer_app_footer_vue__ = __webpack_require__("bkfp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_notification_items_notification_items_vue__ = __webpack_require__("rEDR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_maintenance_notification_maintenance_notification_vue__ = __webpack_require__("T7ic");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_header_search_bar_search_bar_vue__ = __webpack_require__("OL8g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_generics_side_notification_side_notification_vue__ = __webpack_require__("2zfn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__("oiih");












var SIMPLE_LAYOUT_ROUTES = ['disqus-auth', 'disqus-logout'];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    appHeader: __WEBPACK_IMPORTED_MODULE_2__components_app_app_header_app_header_vue__["a" /* default */],
    appMainNav: __WEBPACK_IMPORTED_MODULE_4__components_app_app_main_nav_app_main_nav_vue__["a" /* default */],
    appFooter: __WEBPACK_IMPORTED_MODULE_5__components_app_app_footer_app_footer_vue__["a" /* default */],
    maintenanceNotification: __WEBPACK_IMPORTED_MODULE_7__components_maintenance_notification_maintenance_notification_vue__["a" /* default */],
    notificationItems: __WEBPACK_IMPORTED_MODULE_6__components_notification_items_notification_items_vue__["a" /* default */],
    searchBar: __WEBPACK_IMPORTED_MODULE_8__components_app_app_header_search_bar_search_bar_vue__["a" /* default */],
    sideNotification: __WEBPACK_IMPORTED_MODULE_9__components_generics_side_notification_side_notification_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('browse', ['areUserBrowseHeadersEmpty']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['hasBanner', 'hasMaintenanceMessage', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['hasServerErrorOccurred', 'liveUpdatesDisabled', 'newHeaderEnabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('popup', ['currentPopup', 'currentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('notifications', ['sideNotificationLevel', 'sideNotificationText', 'sideNotificationOnCloseCallback', 'showNotificationsWidget']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isShutdownModeOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isUserRestricted']), {
    headerComponent: function headerComponent() {
      return this.newHeaderEnabled ? __WEBPACK_IMPORTED_MODULE_3__components_app_app_header_app_header_new_vue__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_2__components_app_app_header_app_header_vue__["a" /* default */];
    },
    isSimpleLayout: function isSimpleLayout() {
      return SIMPLE_LAYOUT_ROUTES.includes(this.$route.name);
    },
    appModifiers: function appModifiers() {
      return {
        'app-layout-old': true,
        'app-layout-old--with-overflow': (this.currentPopup !== null || this.currentSmallPopup !== null) && __WEBPACK_IMPORTED_MODULE_10__constants__["a" /* default */].POPUP_OVERFLOW_MODE
      };
    },
    headerModifiers: function headerModifiers() {
      return {
        'app-layout-old__header': true,
        'app-layout-old__header--shutdown': this.isShutdownModeOn || this.areUserBrowseHeadersEmpty,
        'app-layout-old__header--secondary': !this.isShutdownModeOn && !this.areUserBrowseHeadersEmpty,
        'app-layout-old__header--error': this.hasServerErrorOccurred || this.hasMaintenanceMessage || this.hasBanner || this.liveUpdatesDisabled,
        'app-layout-old__header--notifications-widget-open': this.showNotificationsWidget
      };
    },
    contentModifiers: function contentModifiers() {
      return {
        'app-layout-old__content': true,
        'app-layout-old__content--secondary': !this.isSimpleLayout && !this.isShutdownModeOn && !this.areUserBrowseHeadersEmpty,
        'app-layout-old__content--shutdown': this.isShutdownModeOn || this.areUserBrowseHeadersEmpty,
        'app-layout-old__content--simple': this.isSimpleLayout,
        'app-layout-old__content--error': this.hasServerErrorOccurred || this.hasMaintenanceMessage || this.hasBanner || this.liveUpdatesDisabled,
        'app-layout-old__content--with-overflow': this.$route.meta.appContentOverflowed || this.$route.meta.appContentOverflowedDesktop && this.isLayoutDesktop
      };
    },
    sideNotificationShouldDisplay: function sideNotificationShouldDisplay() {
      return this.sideNotificationLevel && this.sideNotificationText;
    }
  })
});

/***/ }),

/***/ "EyqK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_notifications__ = __webpack_require__("tjp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filters_consts__ = __webpack_require__("OJH0");




 /* eslint-disable arrow-body-style, max-len */








var KEY_SHOULD_SHOW_TIMESPAN = 'should-show-timespan';
var KEY_SELECTED_ORDER = 'selected-order';
var KEY_SELECTED_TIMESPAN = 'selected-timespan';

var DEFAULT_NOTIFICATIONS = {
  data: [],
  page: 0,
  totalCount: -1,
  canLoadMore: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    markReadIsBeingCalled: false,
    marketsToggle: null,
    myShares: null,
    mySharesReady: false,
    notifications: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(DEFAULT_NOTIFICATIONS),
    notificationsToggle: false,
    orders: __WEBPACK_IMPORTED_MODULE_9__filters_consts__["a" /* ORDERS */],
    timespans: __WEBPACK_IMPORTED_MODULE_9__filters_consts__["b" /* TIMESPANS */],
    selectedOrder: __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].get(KEY_SELECTED_ORDER, __WEBPACK_IMPORTED_MODULE_9__filters_consts__["a" /* ORDERS */][0]),
    selectedTimespan: __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].get(KEY_SELECTED_TIMESPAN, __WEBPACK_IMPORTED_MODULE_9__filters_consts__["c" /* AVAILABLE_TIMESPANS */].ALL),
    shouldShowTimespanFilter: __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].get(KEY_SHOULD_SHOW_TIMESPAN, true)
  },
  getters: {
    mySharesCount: function mySharesCount(state) {
      return state.myShares ? state.myShares.markets.length : 0;
    },
    mySharesTotalGainLoss: function mySharesTotalGainLoss(state) {
      if (state.myShares && state.myShares.markets) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy___default()(state.myShares.markets, __WEBPACK_IMPORTED_MODULE_7__utils_helpers__["z" /* marketUserGainLoss */]);
      }
      return 0;
    }
  },
  mutations: {
    setMarketsToggle: function setMarketsToggle(state, flag) {
      state.marketsToggle = flag;
    },
    setMyShares: function setMyShares(state, payload) {
      state.myShares = payload;
      state.mySharesReady = true;
    },
    setSummaryChartData: function setSummaryChartData(state, payload) {
      state.summaryChart = payload;
    },
    updateNotifications: function updateNotifications(state, payload) {
      var sourceNotifications = payload.data.notificationItems || [];
      sourceNotifications.forEach(function (el) {
        el.contentJson = typeof el.contentJson === 'string' ? JSON.parse(el.contentJson) : el.contentJson;
      });
      var data = state.notifications.data.concat(sourceNotifications);
      var page = payload.data.page;
      var totalCount = payload.data.totalItems;
      var canLoadMore = totalCount > data.length;

      state.notifications = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.notifications, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    resetNotifications: function resetNotifications(state) {
      state.notifications = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(DEFAULT_NOTIFICATIONS);
    },
    updateMySharesFromNotification: function updateMySharesFromNotification(state, data) {
      if (state.myShares && state.myShares.markets) {
        state.myShares = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.myShares, {
          markets: state.myShares.markets.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_notifications__["c" /* updateMySharesMarket */])(market, data);
          })
        });
      }
    },
    updateMySharesContractFromNotification: function updateMySharesContractFromNotification(state, data) {
      if (state.myShares && state.myShares.markets) {
        state.myShares = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.myShares, {
          markets: state.myShares.markets.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_notifications__["b" /* updateMarketContracts */])(market, data);
          })
        });
      }
    },
    toggleNotifications: function toggleNotifications(state) {
      state.notificationsToggle = !state.notificationsToggle;
    },
    selectOrder: function selectOrder(state, sort) {
      var selectedOrder = __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(state.orders, { sort: sort });
      var selectedTimespan = __WEBPACK_IMPORTED_MODULE_9__filters_consts__["d" /* DEFAULT_TIMESPANS */][sort] || __WEBPACK_IMPORTED_MODULE_9__filters_consts__["c" /* AVAILABLE_TIMESPANS */].EMPTY;
      var shouldShowTimespan = __WEBPACK_IMPORTED_MODULE_9__filters_consts__["e" /* ORDERS_WITH_TIMESPAN_FILTER */].indexOf(selectedOrder.sort) !== -1;
      state.selectedOrder = selectedOrder;
      state.selectedTimespan = selectedTimespan;
      state.shouldShowTimespanFilter = shouldShowTimespan;
      __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_TIMESPAN, selectedTimespan);
      __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].set(KEY_SHOULD_SHOW_TIMESPAN, shouldShowTimespan);
      __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_ORDER, selectedOrder);
    },
    selectTimespan: function selectTimespan(state, parameter) {
      var selectedTimespan = __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(state.timespans, { parameter: parameter });
      state.selectedTimespan = selectedTimespan;
      __WEBPACK_IMPORTED_MODULE_8__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_TIMESPAN, selectedTimespan);
    },
    setMarkReadBeingCalled: function setMarkReadBeingCalled(state, value) {
      state.markReadIsBeingCalled = value;
    }
  },
  actions: {
    getMyShares: function getMyShares(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].profile.getMyShares(state.selectedOrder.sort, state.selectedTimespan.parameter).then(function (response) {
        commit('setMyShares', response.data);
        return response.data;
      });
    },
    resetNotifications: function resetNotifications(_ref2) {
      var commit = _ref2.commit;

      commit('resetNotifications');
    },
    getNotifications: function getNotifications(_ref3) {
      var state = _ref3.state,
          commit = _ref3.commit;

      if (state.notifications.canLoadMore) {
        var page = state.notifications.page + 1;
        return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].profile.getNotifications(page).then(function (response) {
          commit('updateNotifications', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(null);
    },
    markNotificationsAsRead: function markNotificationsAsRead(_ref4) {
      var commit = _ref4.commit,
          state = _ref4.state;

      if (state.markReadIsBeingCalled) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({});

      commit('setMarkReadBeingCalled', true);
      return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].profile.putNotifications().then(function (response) {
        commit('setMarkReadBeingCalled', false);
        return response.data;
      }).catch(function (error) {
        commit('setMarkReadBeingCalled', false);
        throw error;
      });
    },
    updateMySharesFromNotification: function updateMySharesFromNotification(_ref5, payload) {
      var commit = _ref5.commit;

      commit('updateMySharesFromNotification', payload);
    },
    updateMySharesContractFromNotification: function updateMySharesContractFromNotification(_ref6, payload) {
      var commit = _ref6.commit;

      commit('updateMySharesContractFromNotification', payload);
    },
    selectOrder: function selectOrder(_ref7, sort) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      commit('selectOrder', sort);
      return dispatch('getMyShares');
    },
    selectTimespan: function selectTimespan(_ref8, timespan) {
      var state = _ref8.state,
          dispatch = _ref8.dispatch,
          commit = _ref8.commit;

      commit('selectTimespan', timespan);
      return dispatch('getMyShares');
    },
    toggleNotifications: function toggleNotifications(_ref9) {
      var commit = _ref9.commit;

      commit('toggleNotifications');
    },
    setMarketsToggle: function setMarketsToggle(_ref10, flag) {
      var commit = _ref10.commit;

      commit('setMarketsToggle', flag);
    }
  }
});

/***/ }),

/***/ "F2lC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"friends-search"},[_c('form-input',{attrs:{"name":"searchFriend","autocomplete":"searchFriend","placeholder":"Friend’s email address or username"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F6mp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FGdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  multipleEmails: 'Invalid email',
  email: 'Enter a valid email',
  sameAs: 'Doesn’t Match',
  minLength: 'At least %v characters',
  maxLength: '%v characters maximum',
  exactLength: 'Exactly %v digits required',
  required: 'Is required',
  alphaNum: 'Only letters and numbers are allowed',
  hasOneLower: 'At least one lowercase letter',
  hasOneUpper: 'At least one uppercase letter',
  hasOneDigit: 'At least one number',
  validateIsAdult: 'You must be at least 18 years old',
  alpha: 'Only letters are allowed',
  onlyCharacters: 'Only letters are allowed',
  validateUSZipCode: 'Enter a valid code',
  validateCardNumber: '',
  numeric: 'Numbers only',
  price: 'Invalid amount',
  between: 'Amount must be between $%v1 and $%v2',
  minValue: 'Minimum amount is $%v',
  minLengthDigit: 'Min. %v digits',
  maxLengthDigit: 'Max. %v digits',
  minValueDeposit: 'Minimum amount is $%v',
  maxValueDeposit: 'Invalid amount',
  usernameIsValid: 'Enter a valid username',
  greaterThan: 'Value must be greater than %v',
  noSpaces: 'No spaces'
});

/***/ }),

/***/ "FITW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{
        id: 1,
        text: 'The most exciting engine in terms of political opinion',
        author: 'James Carville, Political Pundit'
      }],
      swiperOptions: {
        autoplay: 3000,
        direction: 'horizontal'
      }
    };
  },

  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
  }
});

/***/ }),

/***/ "FIqf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-markets"},[(_vm.isLayoutDesktop)?[_c('market-list-desktop-header',{ref:"desktopHeader",staticClass:"page-markets__section-header",attrs:{"title":_vm.currentHeaderName,"count":_vm.filteredMarkets.totalCount,"layout":_vm.marketDisplay},on:{"toggle":_vm.onLayoutToggle}})]:[_c('market-filters-mobile',{on:{"used":_vm.onFiltersUsed}}),_vm._v(" "),_c('market-section-header',{ref:"mobileHeader",class:_vm.sectionHeaderClass,attrs:{"title":_vm.currentHeaderName,"count":_vm.filteredMarkets.totalCount}})],_vm._v(" "),(_vm.items)?_c('div',{staticClass:"page-markets__grid"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"page-markets__grid-item"},[_c('market-list-item',{key:item.marketId,attrs:{"layout":_vm.marketDisplay,"market":item}})],1)}),0):_vm._e(),_vm._v(" "),(_vm.filteredMarkets.canLoadMore)?_c('infinite-loading',{on:{"infinite":_vm.goInfinite}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('div',{staticClass:"page-markets__spinner"})]),_vm._v(" "),_c('span',{attrs:{"slot":"no-results"},slot:"no-results"}),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})]):_vm._e(),_vm._v(" "),(_vm.showNoMarketsMessage)?_c('div',{staticClass:"page-markets__no-markets-found"},[_vm._v("\n  "+_vm._s(_vm.$txt('page-markets.no-markets.first-line'))+" "),_c('br'),_vm._v("\n  "+_vm._s(_vm.$txt('page-markets.no-markets.second-line'))+"\n")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FJBP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purchase-review-and-confirm"},[(_vm.isLayoutMobile)?[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm__contracts"},[_c('a',{staticClass:"purchase-review-and-confirm__amend-link",on:{"click":_vm.cancel}},[_vm._v("< Amend Offer")]),_vm._v(" "),(_vm.confirmationData.isTradeWarningMessage)?_c('alert-box',{staticClass:"purchase-review-and-confirm__alert-box",attrs:{"level":_vm.confirmationData.isTradeWarningMessageLevel}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.confirmationData.isTradeWarningMessage)}})]):_vm._e(),_vm._v(" "),(_vm.confirmationData.showTradeData)?_c('div',{staticClass:"purchase-review-and-confirm__contract-single"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-8"},[_c('div',{staticClass:"purchase-review-and-confirm__contract-single-name"},[_vm._v(_vm._s(_vm.confirmationData.contractName))])]),_vm._v(" "),_c('div',{staticClass:"column small-4"},[_c('div',{staticClass:"purchase-review-and-confirm__contract-single-price"},[_vm._v(_vm._s(_vm.pricePerShare))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-8"},[_c('div',{staticClass:"purchase-review-and-confirm__contract-single-shares"},[_vm._v(_vm._s(_vm.tradeTypeText)+"\n              "),_c('span',{class:_vm.tradeTypeClass},[_vm._v(_vm._s(_vm.confirmationData.quantity))]),_vm._v(" share"),(_vm.confirmationData.quantity > 1)?[_vm._v("s")]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"column small-4"},[_c('div',{staticClass:"purchase-review-and-confirm__contract-single-price-label"},[_vm._v(_vm._s(_vm.priceText))])])])]):_vm._e()],1),_vm._v(" "),(_vm.confirmationData.showTradeData)?_c('div',{staticClass:"purchase-review-and-confirm__information"},[_c('p',[_vm._v("\n        Calculations offered for profit or loss, fees, risk adjustment and changes to your cash balance assume that all offers above are matched at the price shown.\n        Actual figures will differ in the event that some offers cannot be matched or are matched at more favorable prices.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Open offers in any contract that you are unable to cover as a result of this transaction will be cancelled.\n      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm__footer"},[(_vm.confirmationData.showTradeData)?_c('div',{staticClass:"row purchase-review-and-confirm__footer__info-row"},[_c('div',{staticClass:"column small-7"},[(_vm.showProfitOrLoss)?_c('div',{staticClass:"purchase-review-and-confirm__footer-profits"},[_vm._v(_vm._s(_vm.profitOrLoss)+": "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.profits),expression:"profits",modifiers:{"fixed3":true}}]})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column small-5"},[(_vm.fees)?_c('div',{staticClass:"purchase-review-and-confirm__footer-fees"},[_vm._v("Fees: "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.fees),expression:"fees",modifiers:{"fixed3":true}}]})]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.confirmationData.showTradeData)?_c('div',{staticClass:"row purchase-review-and-confirm__footer__info-row"},[_c('div',{staticClass:"column small-7"},[(_vm.riskAdjustment)?_c('div',{staticClass:"purchase-review-and-confirm__footer-risk"},[_vm._v("Risk Adj.: "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.riskAdjustment),expression:"riskAdjustment",modifiers:{"fixed3":true}}]})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column small-5"},[_c('div',{staticClass:"purchase-review-and-confirm__footer-cash"},[_c('plus-minus-sign'),_vm._v(" Cash "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.orderTotal),expression:"orderTotal",modifiers:{"fixed3":true}}]})],1)])]):_vm._e(),_vm._v(" "),(_vm.confirmationData.showSubmitTradeButton)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12"},[_c('button',{staticClass:"button button--primary button--full-width purchase-review-and-confirm__footer-next-button",on:{"click":_vm.submit}},[_vm._v("Submit Offer")])])]):_vm._e()])]:_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm__footer"},[_c('div',{staticClass:"purchase-review-and-confirm__footer-content",class:_vm.dashboardClass},[(_vm.confirmationData.isTradeWarningMessage)?_c('alert-box',{staticClass:"purchase-review-and-confirm__alert-box",attrs:{"level":_vm.confirmationData.isTradeWarningMessageLevel}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.confirmationData.isTradeWarningMessage)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row purchase-review-and-confirm__upper"},[(_vm.confirmationData.showTradeData)?_c('div',{staticClass:"column small-8 text-left"},[_c('div',{staticClass:"purchase-review-and-confirm__contract-single-flex"},[_c('div',{staticClass:"purchase-review-and-confirm__contract-single-name"},[_vm._v("\n                "+_vm._s(_vm.confirmationData.contractName)+"\n               ")]),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm__contract-single-shares"},[_vm._v("\n                "+_vm._s(_vm.tradeTypeText)+"\n                "),_c('span',{class:_vm.tradeTypeClass},[_vm._v(_vm._s(_vm.confirmationData.quantity))]),_vm._v(" Share"),(_vm.confirmationData.quantity > 1)?[_vm._v("s")]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"purchase-review-and-confirm__contract-single-price"},[_c('div',{staticClass:"purchase-review-and-confirm__contract-single-price-label-desktop"},[_vm._v(_vm._s(_vm.priceText))]),_vm._v(" "+_vm._s(_vm.pricePerShare)+"\n              ")])])]):_c('div',{staticClass:"column small-8 text-left"},[_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"column small-4 text-right"},[_c('a',{staticClass:"purchase-review-and-confirm__amend-link",on:{"click":_vm.cancel}},[_vm._v("< Amend Offer")])])]),_vm._v(" "),_c('div',{staticClass:"row purchase-review-and-confirm__lower"},[_c('div',{staticClass:"column small-6"},[(_vm.confirmationData.showTradeData)?[_c('div',{staticClass:"purchase-review-and-confirm__footer-summary-left"},[_c('div',{staticClass:"column small-6"},[(_vm.showProfitOrLoss)?_c('div',{staticClass:"purchase-review-and-confirm__footer-profits"},[_vm._v(_vm._s(_vm.profitOrLoss)+": "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.profits),expression:"profits",modifiers:{"fixed3":true}}]})]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"column small-6"},[(_vm.fees)?_c('div',{staticClass:"purchase-review-and-confirm__footer-fees"},[_vm._v("Fees: "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.fees),expression:"fees",modifiers:{"fixed3":true}}]})]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"column small-6"},[(_vm.riskAdjustment)?_c('div',{staticClass:"purchase-review-and-confirm__footer-risk"},[_vm._v("Risk Adj.: "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.riskAdjustment),expression:"riskAdjustment",modifiers:{"fixed3":true}}]})]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('div',{staticClass:"purchase-review-and-confirm__footer-cash"},[_c('plus-minus-sign'),_vm._v(" Cash "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.orderTotal),expression:"orderTotal",modifiers:{"fixed3":true}}]})],1)])])]:[_vm._v("\n               \n            ")]],2),_vm._v(" "),_c('div',{staticClass:"column small-6"},[(_vm.confirmationData.showSubmitTradeButton)?_c('div',{staticClass:"purchase-review-and-confirm__footer-summary-right"},[_c('button',{staticClass:"button button--primary button--full-width purchase-review-and-confirm__footer-next-button",on:{"click":_vm.submit}},[_vm._v("\n                Submit Offer\n              ")])]):[_vm._v("\n               \n            ")]],2)])],1)]),_vm._v(" "),_vm._m(2)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row purchase-review-and-confirm__title"},[_c('div',{staticClass:"column small-12"},[_vm._v("\n        Review and Confirm Your Order\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row purchase-review-and-confirm__title"},[_c('div',{staticClass:"column small-12"},[_vm._v("\n        Review and Confirm Your Order\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purchase-review-and-confirm__information"},[_c('p',[_vm._v("\n        Calculations offered for profit or loss, fees, risk adjustment and changes to your cash balance assume that all offers above are matched at the price shown.\n        Actual figures will differ in the event that some offers cannot be matched or are matched at more favorable prices. Open offers in any contract that you are unable to cover as a result of this transaction will be cancelled.\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FM5G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_twitter_timeline_js__ = __webpack_require__("tumW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_227c6b1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_twitter_timeline_vue__ = __webpack_require__("Ldd3");
function injectStyle (ssrContext) {
  __webpack_require__("Ohsr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_twitter_timeline_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_227c6b1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_twitter_timeline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FP0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getOrderBook: function getOrderBook(contractId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Trade/' + contractId + '/OrderBook');
  },
  postConfirmTrade: function postConfirmTrade(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Trade/ConfirmTrade', payload); // Confirm trade create order for confirmation
  },
  postSubmitTrade: function postSubmitTrade(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Trade/SubmitTrade', payload); // Submit trade create order without confirmation
  },
  postCancelAllOffers: function postCancelAllOffers(contractId, payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Trade/CancelAllOffers/' + contractId, payload);
  },
  postCancelOffer: function postCancelOffer(offerId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Trade/CancelOffer/' + offerId);
  },
  getOrderBookTradeInfo: function getOrderBookTradeInfo(contractId, tradeType, price) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Trade/' + contractId + '/OrderBook/' + tradeType + '/' + price);
  }
});

/***/ }),

/***/ "FPPs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.chartData.length > 0)?_c('div',{ref:"chart",staticClass:"charts-container"}):(_vm.chartDataLoaded)?_c('div',{staticClass:"charts-container__no-data"},[_vm._v("\n    No data to display\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FSWW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_balance_history_item_js__ = __webpack_require__("TNLE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d288e05e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_balance_history_item_vue__ = __webpack_require__("qHZ2");
function injectStyle (ssrContext) {
  __webpack_require__("GxcF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_balance_history_item_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d288e05e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_balance_history_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FcIm":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "FdH1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FezS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_forgotten_password_js__ = __webpack_require__("wfyV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e0d6768_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_forgotten_password_vue__ = __webpack_require__("D7aM");
function injectStyle (ssrContext) {
  __webpack_require__("ICSm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_forgotten_password_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e0d6768_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_forgotten_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ffa9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['maintenance']))
});

/***/ }),

/***/ "FlLb":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Fn63":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'submit'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "Fq0I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index1"},[_c('section',{staticClass:"index__banner"},[_c('div',{staticClass:"row row-x "},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-12 large-4"},[_c('div',{staticClass:"index1__sign-up"},[_c('div',{staticClass:"index1__modal__header"},[_vm._v("Create an Account")]),_vm._v(" "),_c('account-register',{attrs:{"mode":"page"}}),_vm._v(" "),_c('account-register-footer')],1)])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('section',{staticClass:"index__quote"},[_c('div',{staticClass:"index__quote--quote-container"},[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"index__quote--quote-logo-img"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/60739962-605f-4bac-912f-6d9353a9c1b5.png"),expression:"`/images/60739962-605f-4bac-912f-6d9353a9c1b5.png`"}],staticClass:"img-responsive"})])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('section',{staticClass:"index__properties"},[_c('div',{staticClass:" "},[_c('div',{staticClass:"index__properties-container"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/4300778c-1f81-48dd-bc0f-34c7b1390ac8.png"),expression:"`/images/4300778c-1f81-48dd-bc0f-34c7b1390ac8.png`"}]})]),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/010db909-3592-4dd7-8fe9-53d40fba2b8f.png"),expression:"`/images/010db909-3592-4dd7-8fe9-53d40fba2b8f.png`"}]})]),_vm._v(" "),_vm._m(7)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/33cc985e-910b-41a6-93b8-bdad5cd60908.png"),expression:"`/images/33cc985e-910b-41a6-93b8-bdad5cd60908.png`"}]})]),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/262950df-75d5-4d67-ae63-eb12878c3a0a.png"),expression:"`/images/262950df-75d5-4d67-ae63-eb12878c3a0a.png`"}]})]),_vm._v(" "),_vm._m(9)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/ce63ef48-3790-471d-88cd-dec2880845c1.png"),expression:"`/images/ce63ef48-3790-471d-88cd-dec2880845c1.png`"}]})]),_vm._v(" "),_vm._m(10)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"})])])]),_vm._v(" "),_vm._m(11)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12 large-8 index__hero-container"},[_c('h1',[_vm._v("Think You Know Politics?")]),_vm._v(" "),_c('h2',[_vm._v("Put your money "),_c('br'),_vm._v(" where your "),_c('br'),_vm._v(" mouth is")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"index__prediction"},[_c('div',{staticClass:"row row-x "},[_c('div',{staticClass:"column small-12 medium-4"},[_c('a',{attrs:{"href":"https://www.predictit.org/markets/detail/8100/Will-Congress-confirm-a-Supreme-Court-justice-in-2025","target":"_blank"}},[_c('div',{staticClass:"index__prediction-img index__prediction-img--left"},[_c('p',{staticClass:"index__prediction--prediction-text"},[_vm._v("New justice "),_c('br'),_vm._v(" confirmed?")])])])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4"},[_c('a',{attrs:{"href":"https://www.predictit.org/markets/detail/8142/How-many-vetoes-will-Trump-issue-in-2025","target":"_blank"}},[_c('div',{staticClass:"index__prediction-img index__prediction-img--middle"},[_c('p',{staticClass:"index__prediction--prediction-text"},[_vm._v("Number of "),_c('br'),_vm._v(" vetoes?")])])])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4"},[_c('a',{attrs:{"href":"https://www.predictit.org/markets/detail/8099/Which-party-will-win-the-2025-gubernatorial-election-in-Virginia","target":"_blank"}},[_c('div',{staticClass:"index__prediction-img index__prediction-img--right"},[_c('p',{staticClass:"index__prediction--prediction-text"},[_vm._v("Next Virginia "),_c('br'),_vm._v(" Governor?")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"index__quote--quote-text"},[_c('p',[_vm._v("\"This is probably one of the most exciting engines I've come across in terms of political opinion.\"")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"index__quote--quote-author"},[_c('p',{staticClass:"index__quote--author-name"}),_c('hr',{staticClass:"index__quote--hyphen"}),_vm._v(" James Carville"),_c('p'),_vm._v(" "),_c('p',{staticClass:"index__quote--author-position"},[_vm._v("Political Pundit")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"index__video"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"index__video--video-container"},[_c('div',{staticClass:"column small-12 index__video--videowrapper"},[_c('iframe',{attrs:{"height":"608","width":"100%","src":"https://www.youtube.com/embed/XxHBRkqT5YQ?rel=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12 large-12"},[_c('div',{staticClass:"index__process-heading"},[_c('h2',[_vm._v("Start Now")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index__process-text"},[_c('p',[_vm._v("Shares priced 1¢ - 99¢. Winning shares pay $1.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index__process-text"},[_c('p',[_vm._v("Think your shares hit the roof? Sell them to other buyers.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index__process-text"},[_c('p',[_vm._v("Safe and Secure: Operated by the Prediction Market Research Consortium.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index__process-text"},[_c('p',[_vm._v("Trade on over 300 political futures markets.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index__process-text"},[_c('p',[_vm._v("Join the prediction market for politics.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"index__work"},[_c('div',{staticClass:"row row-x index__work-container "},[_c('div',{staticClass:"col-sm-12 index__process-heading"},[_c('h2',[_vm._v("How Does It Work")])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4 index__work--work-info"},[_c('div',{staticClass:"index__work--work-icon"},[_vm._v("\n\t\t\t\t\t1\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"index__process-text"},[_c('h3',[_vm._v("Browse Markets")]),_vm._v(" "),_c('p',[_vm._v("Look for opportunities on market prices.")])])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4 index__work--work-info"},[_c('div',{staticClass:"index__work--work-icon"},[_vm._v("\n\t\t\t\t\t2\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"index__process-text"},[_c('h3',[_vm._v("Make a Prediction")]),_vm._v(" "),_c('p',[_vm._v("Think everyone's got it wrong? Buy shares for or against an event taking place. ")])])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4 index__work--work-info"},[_c('div',{staticClass:"index__work--work-icon"},[_vm._v("\n\t\t\t\t\t3\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"index__process-text"},[_c('h3',[_vm._v("Trade your shares")]),_vm._v(" "),_c('p',[_vm._v("Buy your shares low and sell them high once the crowd figures out you were right.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G/BR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isDebugOn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_hasIn__ = __webpack_require__("RfZv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_hasIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_hasIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__("YaEn");




function isDebugOn() {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_hasIn___default()(__WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */], ['currentRoute', 'query', 'console']) || "production" === 'development';
}

function info() {
  if (isDebugOn()) {
    var _console;

    (_console = console).info.apply(_console, arguments); // eslint-disable-line no-console
  }
}

function warn() {
  if (isDebugOn()) {
    var _console2;

    (_console2 = console).warn.apply(_console2, arguments); // eslint-disable-line no-console
  }
}

function error() {
  if (isDebugOn()) {
    var _console3;

    (_console3 = console).error.apply(_console3, arguments); // eslint-disable-line no-console
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  info: info,
  warn: warn,
  error: error
});

/***/ }),

/***/ "G1Rm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insight-panel",class:_vm.openModifier},[_c('div',{staticClass:"insight-panel__wrap"},[_vm._t("default")],2),_vm._v(" "),(_vm.showBottom)?_c('div',{staticClass:"insight-panel__bottom"},[_c('span',{staticClass:"insight-panel__link",class:_vm.moreModifier,on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.text))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G4zp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G6+2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orientation-info"},[_c('img',{staticClass:"orientation-info__image",attrs:{"src":__webpack_require__("RuPo")}}),_vm._v(" "),_c('div',[_c('span',{staticClass:"orientation-info__emphasize"},[_vm._v("You're making me dizzy!")]),_vm._v(" "),_c('br'),_vm._v("\n    Rotate your device back to portrait mode\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GBcl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_js__ = __webpack_require__("pt4Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_559d3cc6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_vue__ = __webpack_require__("q/KQ");
function injectStyle (ssrContext) {
  __webpack_require__("kO8i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_559d3cc6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GC/j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GH+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.slideClass},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GH8/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GMue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    text: {
      type: String,
      required: true
    },
    more: {
      type: Boolean,
      default: false
    },
    href: {
      type: [Object, String]
    },
    showBottom: {
      type: Boolean,
      default: true
    },
    away: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      open: false
    };
  },

  computed: {
    moreModifier: function moreModifier() {
      return { 'insight-panel__link--more': this.more };
    },
    openModifier: function openModifier() {
      return { 'insight-panel--open': this.open };
    }
  },
  methods: {
    onClick: function onClick() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.href) === 'object') {
        this.$router.push(this.href);
      } else if (this.away) {
        window.open(this.href, '_blank');
      }
    }
  }
});

/***/ }),

/***/ "GOBe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_account_account_social_avatar_account_social_avatar_vue__ = __webpack_require__("ROsZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_default_avatar_png__ = __webpack_require__("FcIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_default_avatar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_default_avatar_png__);

/* eslint-disable no-unused-vars */






var LEVEL_BRONZE_THRESHOLD = 10;
var LEVEL_SILVER_THRESHOLD = 135;
var LEVEL_GOLD_THRESHOLD = 915;
var LEVEL_PLATINUM_THRESHOLD = 4950;
var LEVEL_DIAMOND_THRESHOLD = 30000;
var LEVEL_BLACK_THRESHOLD = 375000;

var LEVEL_MAP = {
  LEVEL_LOADING: { num: 100, text: '', progressColor: 'transparent', currentColor: 'transparent' },
  LEVEL_BLUE_THRESHOLD: { num: 1, text: 'Novice', next: LEVEL_BRONZE_THRESHOLD, progressColor: '#e2a779', currentColor: '#0c96ae' },
  LEVEL_BRONZE_THRESHOLD: { num: 2, text: 'Prognosticator', next: LEVEL_SILVER_THRESHOLD, progressColor: '#cdcdcd', currentColor: '#e2a779' },
  LEVEL_SILVER_THRESHOLD: { num: 3, text: 'Diviner', next: LEVEL_GOLD_THRESHOLD, progressColor: '#fadf7c', currentColor: '#cdcdcd' },
  LEVEL_GOLD_THRESHOLD: { num: 4, text: 'Soothsayer', next: LEVEL_PLATINUM_THRESHOLD, progressColor: '#4f4e4e', currentColor: '#fadf7c' },
  LEVEL_PLATINUM_THRESHOLD: { num: 5, text: 'Fortune Teller', next: LEVEL_DIAMOND_THRESHOLD, progressColor: '#88b9ce', currentColor: '#4f4e4e' },
  LEVEL_DIAMOND_THRESHOLD: { num: 6, text: 'Prophet', next: LEVEL_BLACK_THRESHOLD, progressColor: '#000000', currentColor: '#88b9ce' },
  LEVEL_BLACK_THRESHOLD: { num: 7, text: 'Oracle', next: null, currentColor: '#000000' }
};

var ACTIVE_COLOR = '#07a0bb';
var ACTIVE_ROUTES = ['portfolio'];

var socialLevelMixin = {
  components: {
    accountSocialAvatar: __WEBPACK_IMPORTED_MODULE_3__components_account_account_social_avatar_account_social_avatar_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['profileDetail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['userData']), {
    // computed properties are in user context
    level: function level() {
      if (this.isSocialReady) {
        return this.getLevelByPredictions(this.profileDetail.profitablePredictions);
      }
      return LEVEL_MAP.LEVEL_LOADING;
    },
    activeFor: function activeFor() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(this.userData.dateRegistered).fromNow(true);
    },
    toNextLevel: function toNextLevel() {
      var next = this.level.next;
      if (next !== null) return (next - this.profileDetail.profitablePredictions).toLocaleString();
      return null;
    },
    progressPercentage: function progressPercentage() {
      var next = this.level.next;
      var predictionsNormalized = 100 * this.profileDetail.profitablePredictions;
      if (next !== null) return Math.floor(predictionsNormalized / next);
      return 0;
    },
    progressColor: function progressColor() {
      return this.level.progressColor ? this.level.progressColor : null;
    },
    progressInfoText: function progressInfoText() {
      return 'You are ' + this.progressPercentage + '% of the way to Level ' + (this.level.num + 1);
    },
    levelColor: function levelColor() {
      return this.level.currentColor;
    },
    levelColorWithRespectToNav: function levelColorWithRespectToNav() {
      if (this.$route && ACTIVE_ROUTES.includes(this.$route.name)) {
        return ACTIVE_COLOR;
      }
      return this.levelColor;
    },
    isTopLevelTrader: function isTopLevelTrader() {
      return this.toNextLevel === null;
    },
    userAvatar: function userAvatar() {
      if (this.isSocialReady && this.userData.avatarImage) {
        return this.userData.avatarImage;
      }
      return __WEBPACK_IMPORTED_MODULE_4__assets_images_default_avatar_png___default.a;
    },
    isSocialReady: function isSocialReady() {
      return this.userData && this.userData.userName !== undefined && this.profileDetail && this.profileDetail.userGuid !== undefined;
    }
  }),
  methods: {
    getProgressInfoTextForLevel: function getProgressInfoTextForLevel(num, profitablePredictions) {
      var nextLevel = this.getLevelByNumber(num);
      var predictionsNormalized = 100 * profitablePredictions;
      if (num === LEVEL_MAP.LEVEL_BLACK_THRESHOLD.num) {
        return "You've reached Top Level.";
      }

      var progressPercentage = Math.floor(predictionsNormalized / nextLevel.next);
      return 'You are ' + progressPercentage + '% of the way to Level ' + (num + 1);
    },
    getThresholdByNumber: function getThresholdByNumber(num) {
      if (num === LEVEL_MAP.LEVEL_BLACK_THRESHOLD) return '-';
      var previousLevel = this.getLevelByNumber(num - 1);
      var currentLevel = this.getLevelByNumber(num);

      return currentLevel.next - previousLevel.next;
    },
    getLevelByNumber: function getLevelByNumber(num) {
      if (num === LEVEL_MAP.LEVEL_BLUE_THRESHOLD.num) return LEVEL_MAP.LEVEL_BLUE_THRESHOLD;
      if (num === LEVEL_MAP.LEVEL_BRONZE_THRESHOLD.num) return LEVEL_MAP.LEVEL_BRONZE_THRESHOLD;
      if (num === LEVEL_MAP.LEVEL_SILVER_THRESHOLD.num) return LEVEL_MAP.LEVEL_SILVER_THRESHOLD;
      if (num === LEVEL_MAP.LEVEL_GOLD_THRESHOLD.num) return LEVEL_MAP.LEVEL_GOLD_THRESHOLD;
      if (num === LEVEL_MAP.LEVEL_PLATINUM_THRESHOLD.num) return LEVEL_MAP.LEVEL_PLATINUM_THRESHOLD;
      if (num === LEVEL_MAP.LEVEL_DIAMOND_THRESHOLD.num) return LEVEL_MAP.LEVEL_DIAMOND_THRESHOLD;
      return LEVEL_MAP.LEVEL_BLACK_THRESHOLD;
    },
    getLevelByPredictions: function getLevelByPredictions(threshold) {
      if (!threshold) return LEVEL_MAP.LEVEL_BLUE_THRESHOLD;
      if (threshold < LEVEL_BRONZE_THRESHOLD) return LEVEL_MAP.LEVEL_BLUE_THRESHOLD;
      if (threshold < LEVEL_SILVER_THRESHOLD) return LEVEL_MAP.LEVEL_BRONZE_THRESHOLD;
      if (threshold < LEVEL_GOLD_THRESHOLD) return LEVEL_MAP.LEVEL_SILVER_THRESHOLD;
      if (threshold < LEVEL_PLATINUM_THRESHOLD) return LEVEL_MAP.LEVEL_GOLD_THRESHOLD;
      if (threshold < LEVEL_DIAMOND_THRESHOLD) return LEVEL_MAP.LEVEL_PLATINUM_THRESHOLD;
      if (threshold < LEVEL_BLACK_THRESHOLD) return LEVEL_MAP.LEVEL_DIAMOND_THRESHOLD;
      return LEVEL_MAP.LEVEL_BLACK_THRESHOLD;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (socialLevelMixin);

/***/ }),

/***/ "GOHg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_close_button_close_button_vue__ = __webpack_require__("mjGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_purchase_purchase_journey_purchase_journey_vue__ = __webpack_require__("sKk/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    market: {},
    showCloseButton: {
      type: Boolean,
      default: true
    },
    closeJourneyAfterSuccess: {
      type: Boolean,
      default: true
    }
  },
  components: {
    closeButton: __WEBPACK_IMPORTED_MODULE_2__components_generics_close_button_close_button_vue__["a" /* default */],
    purchaseJourney: __WEBPACK_IMPORTED_MODULE_3__components_purchase_purchase_journey_purchase_journey_vue__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'clearOrderBook']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    close: function close() {
      this.setTradeOptions(null);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('trade', ['tradeOptions'])),
  created: function created() {
    if (!this.isLoggedIn) {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clearOrderBook();
  }
});

/***/ }),

/***/ "GQPr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_shares_js__ = __webpack_require__("rWm4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c83e3f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_shares_vue__ = __webpack_require__("K1KK");
function injectStyle (ssrContext) {
  __webpack_require__("IRTZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_shares_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c83e3f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_shares_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GQqe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"charts-checkbox"}},[(_vm.show)?_c('div',{class:_vm.classModifiers},[_c('label',{staticClass:"charts-checkbox__label-container",attrs:{"for":_vm.name}},[_c('input',{attrs:{"type":"checkbox","name":_vm.name,"id":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_vm._v(" "),_c('div',{class:_vm.tickClassModifiers,style:(_vm.styleModifiers)}),_vm._v(" "),_c('div',{staticClass:"charts-checkbox__label"},[_vm._t("default")],2)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GUdh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GVWc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_key_stats_element_js__ = __webpack_require__("wWzM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b58dc10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_key_stats_element_vue__ = __webpack_require__("XCpQ");
function injectStyle (ssrContext) {
  __webpack_require__("Cv46")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_key_stats_element_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b58dc10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_key_stats_element_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GZXJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _isStandalone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _isIos; });
/* unused harmony export isMacOs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _isWindows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _isAndroid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _isIE; });
/* unused harmony export isEdge */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _iOSWrapper; });
/* unused harmony export isTablet */
/* unused harmony export getOrientation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ua_parser_js__ = __webpack_require__("GCDA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ua_parser_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ua_parser_js__);


var uaParsed = __WEBPACK_IMPORTED_MODULE_0_ua_parser_js___default()(window.navigator.userAgent);
var _isStandalone = !!window.navigator.standalone;

var _isIos = uaParsed && uaParsed.os && uaParsed.os.name === 'iOS';

var _isMacOs = uaParsed && uaParsed.os && uaParsed.os.name === 'Mac OS';

var _isWindows = uaParsed && uaParsed.os && uaParsed.os.name.includes('Windows');

var _isAndroid = uaParsed && uaParsed.os && uaParsed.os.name === 'Android';

var _isIE = uaParsed && uaParsed.browser && (uaParsed.browser.name === 'IE' || uaParsed.browser.name === 'IEMobile');

var _isEdge = uaParsed && uaParsed.browser && uaParsed.browser.name === 'Edge';

var _iOSWrapper = window.navigator.userAgent && window.navigator.userAgent.includes('iOSWrapper');

var _isTablet = uaParsed && uaParsed.device && uaParsed.device.type === 'tablet';


var _getOrientation = function _getOrientation() {
  if (window.screen.orientation) {
    if (window.screen.orientation.type.includes('portrait')) return 'portrait';
    return 'landscape';
  }
  if (Math.abs(window.orientation) === 90) return 'landscape';
  return 'portrait';
};


var userAgentMixin = {
  computed: {
    isTablet: function isTablet() {
      return _isTablet;
    },
    isWindows: function isWindows() {
      return _isWindows;
    },
    isIos: function isIos() {
      return _isIos;
    },
    isMacOs: function isMacOs() {
      return _isMacOs;
    },
    isStandalone: function isStandalone() {
      return _isStandalone;
    },
    isAndroid: function isAndroid() {
      return _isAndroid;
    },
    isIE: function isIE() {
      return _isIE;
    },
    iOSWrapper: function iOSWrapper() {
      return _iOSWrapper;
    },
    isEdge: function isEdge() {
      return _isEdge;
    }
  },
  methods: {
    getWindowSize: function getWindowSize() {
      return [Math.min(document.documentElement.clientWidth, window.innerWidth || 0), Math.min(document.documentElement.clientHeight, window.innerHeight || 0)];
    },
    getOrientation: function getOrientation() {
      return _getOrientation();
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (userAgentMixin);

/***/ }),

/***/ "GebD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_timeline_js__ = __webpack_require__("ucfx");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_timeline_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d93f9d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timeline_vue__ = __webpack_require__("r4gD");
function injectStyle (ssrContext) {
  __webpack_require__("20St")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_timeline_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d93f9d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_timeline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GgQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_submit_js__ = __webpack_require__("Fn63");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0d5b6b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_submit_vue__ = __webpack_require__("9MVb");
function injectStyle (ssrContext) {
  __webpack_require__("ao05")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_submit_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0d5b6b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_submit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ggix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gh0K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gik0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select",class:_vm.selectModifiers},[(_vm.disabled)?_c('div',{staticClass:"select__disabled"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"select__placeholder"},[_vm._v(_vm._s(_vm.placeholder)),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('multiselect',{attrs:{"adjust":_vm.adjust,"value":_vm.value,"show-no-results":_vm.showNoResults,"options":_vm.options,"track-by":_vm.trackBy,"label":_vm.label,"placeholder":"","show-labels":false,"searchable":_vm.searchable,"allow-empty":false,"max-height":_vm.maxHeight,"custom-label":_vm.customLabel,"tabindex":_vm.tabindex},on:{"close":function (e) { return _vm.$emit('close', e); },"select":function (e) { return _vm.$emit('select', e); },"input":_vm.updateValue}},[_c('div',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v("No elements found.")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GnOr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-update-image"},[_c('div',{staticClass:"account-update-image__note"},[_vm._v("\n    "+_vm._s(_vm.$txt('account-update-image.disclaimer'))+"\n  ")]),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width account-update-image__button",on:{"click":_vm.onUpload}},[_vm._v("\n    "+_vm._s(_vm.$txt('account-update-image.add'))+"\n  ")]),_vm._v(" "),_c('input',{ref:"fileinput",staticClass:"account-update-image__input",attrs:{"type":"file"},on:{"change":_vm.onChange}}),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width account-update-image__button",attrs:{"disabled":!_vm.showRemoveOption},on:{"click":_vm.onRemove}},[_vm._v("\n    "+_vm._s(_vm.$txt('account-update-image.remove'))+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GnhT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tax-info-notification"},[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[(_vm.statement)?_c('p',{staticClass:"tax-info-notification__disclaimer"},[_vm._v("\n          "+_vm._s(_vm.statement)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.mandatoryStatement)?_c('p',{staticClass:"tax-info-notification__disclaimer tax-info-notification__disclaimer--statement"},[_vm._v("\n          "+_vm._s(_vm.mandatoryStatement)+"\n        ")]):_vm._e(),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.name,"disabled":_vm.isFormDisabled,"name":"name","type":"text","required":true,"autocomplete":"name","placeholder":"Name"},on:{"input":_vm.$v.fields.name.$touch},model:{value:(_vm.fields.name),callback:function ($$v) {_vm.$set(_vm.fields, "name", $$v)},expression:"fields.name"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.address,"disabled":_vm.isFormDisabled,"name":"address","type":"text","required":true,"autocomplete":"address","placeholder":"Address"},on:{"input":_vm.$v.fields.address.$touch},model:{value:(_vm.fields.address),callback:function ($$v) {_vm.$set(_vm.fields, "address", $$v)},expression:"fields.address"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.city,"disabled":_vm.isFormDisabled,"name":"city","type":"text","required":true,"autocomplete":"city","placeholder":"City"},on:{"input":_vm.$v.fields.city.$touch},model:{value:(_vm.fields.city),callback:function ($$v) {_vm.$set(_vm.fields, "city", $$v)},expression:"fields.city"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.stateCode,"disabled":_vm.isFormDisabled,"name":"stateCode","type":"text","required":true,"autocomplete":"state-code","placeholder":"State Code"},on:{"input":_vm.$v.fields.stateCode.$touch},model:{value:(_vm.fields.stateCode),callback:function ($$v) {_vm.$set(_vm.fields, "stateCode", $$v)},expression:"fields.stateCode"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.zipCode,"disabled":_vm.isFormDisabled,"name":"zipCode","type":"text","required":true,"autocomplete":"zip-code","placeholder":"Zip/Postal Code"},on:{"input":_vm.$v.fields.zipCode.$touch},model:{value:(_vm.fields.zipCode),callback:function ($$v) {_vm.$set(_vm.fields, "zipCode", $$v)},expression:"fields.zipCode"}})],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.taxId,"disabled":_vm.isFormDisabled,"name":"taxId","type":"text","required":true,"autocomplete":"taxId","placeholder":"Social Security number or ITIN"},on:{"input":_vm.$v.fields.taxId.$touch},model:{value:(_vm.fields.taxId),callback:function ($$v) {_vm.$set(_vm.fields, "taxId", $$v)},expression:"fields.taxId"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('br'),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',{staticClass:"tax-info-notification__disclaimer"},[_vm._v("\n          If you cannot complete this form for any reason, please contact "),_c('a',{attrs:{"href":("mailto:" + (_vm.systemEmails.support))}},[_vm._v(_vm._s(_vm.systemEmails.support))])])]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-submit',{attrs:{"disabled":_vm.invalidOrDisabled,"label":"Submit"}})],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tax-info-notification__disclaimer"},[_c('span',{staticClass:"tax-info-notification__title"},[_vm._v("Please provide or confirm the following information")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('p',{staticClass:"tax-info-notification__disclaimer"},[_c('span',{staticClass:"tax-info-notification__title"},[_vm._v("Please provide your Social Security number or ITIN")]),_vm._v(" "),_c('br'),_vm._v("\n          Note that this number is only used for tax reporting purposes and will be encrypted to ensure proper security.\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tax-info-notification__disclaimer"},[_c('span',{staticClass:"tax-info-notification__title"},[_vm._v("By submitting this form, I certify that:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"tax-info-notification__list"},[_c('li',[_vm._v("The number shown on this form is my correct Social Security number or individual taxpayer identification number, and")]),_vm._v(" "),_c('li',[_vm._v("I am not subject to backup withholding because: (a) I am exempt from backup withholding, or (b) I have not been notified by the Internal Revenue Service (IRS) that I am subject to backup withholding as a result of a failure to report all interest or dividends, or (c) the IRS has notified me that I am no longer subject to backup withholding and")]),_vm._v(" "),_c('li',[_vm._v("I am a U.S Person (a US Citizen living anywhere in the world or a Resident Alien)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GxcF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H/Zg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_about__ = __webpack_require__("L3N8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_account__ = __webpack_require__("cW54");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_browse__ = __webpack_require__("R6p5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_chart__ = __webpack_require__("9pxA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api_insight__ = __webpack_require__("gatU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api_market__ = __webpack_require__("d3y4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_api_profile__ = __webpack_require__("aeoD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_api_support__ = __webpack_require__("0X7F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_api_trade__ = __webpack_require__("FP0m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_api_wallet__ = __webpack_require__("9hG0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_api_dashboard__ = __webpack_require__("OfZf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_api_leaderboards__ = __webpack_require__("AM9x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_api_map__ = __webpack_require__("JoM+");














/* harmony default export */ __webpack_exports__["a"] = ({
  about: __WEBPACK_IMPORTED_MODULE_0__services_api_about__["a" /* default */],
  account: __WEBPACK_IMPORTED_MODULE_1__services_api_account__["a" /* default */],
  browse: __WEBPACK_IMPORTED_MODULE_2__services_api_browse__["a" /* default */],
  chart: __WEBPACK_IMPORTED_MODULE_3__services_api_chart__["a" /* default */],
  insight: __WEBPACK_IMPORTED_MODULE_4__services_api_insight__["a" /* default */],
  market: __WEBPACK_IMPORTED_MODULE_5__services_api_market__["a" /* default */],
  profile: __WEBPACK_IMPORTED_MODULE_6__services_api_profile__["a" /* default */],
  support: __WEBPACK_IMPORTED_MODULE_7__services_api_support__["a" /* default */],
  trade: __WEBPACK_IMPORTED_MODULE_8__services_api_trade__["a" /* default */],
  wallet: __WEBPACK_IMPORTED_MODULE_9__services_api_wallet__["a" /* default */],
  dashboard: __WEBPACK_IMPORTED_MODULE_10__services_api_dashboard__["a" /* default */],
  leaderboards: __WEBPACK_IMPORTED_MODULE_11__services_api_leaderboards__["a" /* default */],
  map: __WEBPACK_IMPORTED_MODULE_12__services_api_map__["a" /* default */]
});

/***/ }),

/***/ "H2eu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");

/* eslint-disable object-shorthand */






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["b" /* formMixin */]],
  components: {
    contentHeader: __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__["a" /* default */]
  },
  validations: {
    fields: {
      newUserName: __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["a" /* validators */].username
    }
  },
  data: function data() {
    return {
      initialised: false,
      fields: {
        username: '',
        newUserName: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['userData', 'usernameTries']), {
    isSubmitButtonDisabled: function isSubmitButtonDisabled() {
      return this.invalidOrDisabled || this.usernameTries === 0;
    },
    isUsernameInputDisabled: function isUsernameInputDisabled() {
      return this.isFormDisabled || this.usernameTries === 0;
    }
  }),
  watch: {
    isLoading: function isLoading(value) {
      var el = document.querySelector('.modal__body--show-ready');
      if (!el) return;
      if (value) {
        el.style.display = 'none';
      } else {
        el.style.display = 'block';
      }
    },

    userData: {
      handler: 'userDataChanged',
      immediate: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotificationWithTimeoutCallback']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['changeUserName', 'getAccountDetail', 'getUserNameTries']), {
    userDataChanged: function userDataChanged(value) {
      if (value) {
        this.fields.username = value.userName;
      }
    },
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formIsValid() && this.formDisable()) {
        this.changeUserName(this.fields.newUserName).then(function () {
          _this.setSuccessSideNotificationWithTimeoutCallback({
            text: 'Username Updated.',
            callback: function callback() {
              return _this.$router.go(-1);
            }
          });
        }).then(this.formEnable).then(this.getAccountDetail).catch(function (e) {
          _this.formHandleErrors(e);
        });
      }
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.loaderAdd(document.body);
    this.getUserNameTries().then(function (data) {
      _this2.loaderRemove(document.body);
      _this2.initialised = true;
      _this2.$nextTick(function () {
        if (data > 0) {
          var newUsernameInput = _this2.$refs.newUsername.$el.querySelector('.input__value');
          newUsernameInput.focus();
        }
      });
    });
  }
});

/***/ }),

/***/ "HBSA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showNewsFeed)?_c('div',{class:_vm.classModifiers},[(!_vm.collapsible)?[(_vm.showTitle)?_c('div',{staticClass:"news-feed__header"},[_c('div',{staticClass:"news-feed__header-title"},[_vm._v("\r\n        News Feed\r\n      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"news-feed__line"}),_vm._v(" "),_c('div',{class:_vm.contentClassModifiers},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"news-feed__item"},[_c('news-feed-item',{attrs:{"data":item}})],1)}),0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMoreButton),expression:"showMoreButton"}],staticClass:"news-feed__more-button",on:{"click":_vm.loadMore}},[_vm._v("\r\n      More News\r\n    ")])]:[_c('collapsible-panel',{key:_vm.isOpen,attrs:{"noPadding":true,"darkHeader":true,"canClose":false,"isOpen":_vm.isOpen,"theme":"small-header"},on:{"toggle":function($event){return _vm.$emit('toggle-news')}}},[_c('div',{staticClass:"news-feed__collapsible-title",attrs:{"slot":"title"},slot:"title"},[_c('span',{staticClass:"news-feed__collapsible-title-text"},[_vm._v("News Feed")])]),_vm._v(" "),_c('div',{staticClass:"news-feed__collapsible-content"},[_c('div',{class:_vm.contentClassModifiers},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"news-feed__item"},[_c('news-feed-item',{attrs:{"data":item}})],1)}),0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMoreButton),expression:"showMoreButton"}],staticClass:"news-feed__more-button",on:{"click":_vm.loadMore}},[_vm._v("\r\n          More News\r\n        ")])])])]],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HCbx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HCce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_keyboard_numeric_input_js__ = __webpack_require__("ae3x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20460a9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keyboard_numeric_input_vue__ = __webpack_require__("t5ec");
function injectStyle (ssrContext) {
  __webpack_require__("Ggix")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_keyboard_numeric_input_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20460a9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keyboard_numeric_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HJEq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_js__ = __webpack_require__("28xE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d36a687c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_vue__ = __webpack_require__("lJBn");
function injectStyle (ssrContext) {
  __webpack_require__("TWnl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d36a687c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HK72":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_search_js__ = __webpack_require__("DZwU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_867bd784_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_search_vue__ = __webpack_require__("xxJB");
function injectStyle (ssrContext) {
  __webpack_require__("7yL+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_search_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_867bd784_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HKaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors.length > 0)?_c('div',{staticClass:"form-errors"},_vm._l((_vm.errors),function(error,index){return _c('p',{key:index,staticClass:"form-errors__entry",domProps:{"innerHTML":_vm._s(error)}})}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HLCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_research_js__ = __webpack_require__("iHjQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4409f3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_research_vue__ = __webpack_require__("a25Q");
function injectStyle (ssrContext) {
  __webpack_require__("pEUD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_research_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4409f3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_research_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HOak":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_account_desktop_header_account_desktop_header_vue__ = __webpack_require__("Tp6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_account_profile_profile_vue__ = __webpack_require__("lmGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_account_history_trades_trades_vue__ = __webpack_require__("Aq5e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_account_history_transactions_transactions_vue__ = __webpack_require__("eMds");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");










var TAB_TRADES = 'trades';
var TAB_DEPOSIT_WITHDRAWALS = 'deposit-withdrawals';

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    marketId: {}
  },
  components: {
    accountDesktopHeader: __WEBPACK_IMPORTED_MODULE_2__components_account_account_desktop_header_account_desktop_header_vue__["a" /* default */],
    contentHeader: __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_4__components_account_profile_profile_vue__["a" /* default */],
    tabs: __WEBPACK_IMPORTED_MODULE_5__components_generics_tabs_tabs_vue__["a" /* default */],
    trades: __WEBPACK_IMPORTED_MODULE_6__components_account_history_trades_trades_vue__["a" /* default */],
    transactions: __WEBPACK_IMPORTED_MODULE_7__components_account_history_transactions_transactions_vue__["a" /* default */]
  },
  data: function data() {
    return {
      ready: false,
      activeTab: '',
      tabs: [{ name: TAB_TRADES, title: 'Trades' }, { name: TAB_DEPOSIT_WITHDRAWALS, title: 'Deposits/Withdrawals' }]
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'History'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    tradesKey: function tradesKey() {
      return 'trades-' + this.isLayoutMobile.toString();
    },
    transactionsKey: function transactionsKey() {
      return 'transactions-' + this.isLayoutMobile.toString();
    },
    showTradesTab: function showTradesTab() {
      return this.activeTab === TAB_TRADES;
    },
    showTransactionsTab: function showTransactionsTab() {
      return this.activeTab === TAB_DEPOSIT_WITHDRAWALS;
    },
    gridRowModifier: function gridRowModifier() {
      return {
        row: this.isLayoutMobile,
        'row-x': !this.isLayoutMobile
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('overlay', {
    showOverlay: 'show'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('profile', ['resetTradeHistory', 'resetTransactionHistory']), {
    onExport: function onExport(what) {
      this.showOverlay();
      if (what === TAB_TRADES) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].EXPORT_TRADE_HISTORY);
      } else {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].EXPORT_TRANSACTION_HISTORY);
      }
    },
    tabChange: function tabChange(name) {
      var _this = this;

      if (name === TAB_DEPOSIT_WITHDRAWALS) {
        this.resetTransactionHistory();
      } else if (name === TAB_TRADES) {
        this.resetTradeHistory();
      }

      setTimeout(function () {
        if (_this.activeTab && _this.$route && _this.$route.path) {
          _this.$gtm.trackEvent({
            event: 'pageviewTrackerEvent',
            virtualPage: _this.$route.path + '/' + name,
            virtualPageTitle: _this.$route.name + ' - ' + name
          });
        }

        _this.activeTab = name;
        if (_this.isLayoutDesktop && name) {
          _this.$router.push({
            name: 'account-history',
            query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.$route.query, {
              tabId: _this.activeTab
            })
          });
        }
      }, 0);
    }
  }),
  created: function created() {
    if (this.$route.query.tabId && this.isLayoutDesktop) {
      this.activeTab = this.$route.query.tabId;
    }
    this.ready = true;
  }
});

/***/ }),

/***/ "HP6i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MODALS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_modal_modal_vue__ = __webpack_require__("CAzF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_modal_layouts_generic_vue__ = __webpack_require__("7okt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_modal_layouts_generic_small_vue__ = __webpack_require__("WRh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_account_login_account_login_vue__ = __webpack_require__("V3zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_account_account_login_footer_footer_vue__ = __webpack_require__("ULMz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_account_account_forgotten_account_forgotten_vue__ = __webpack_require__("8TeC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_account_account_forgotten_footer_footer_vue__ = __webpack_require__("koWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_account_account_register_account_register_vue__ = __webpack_require__("61DT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_account_account_register_footer_footer_vue__ = __webpack_require__("cVuz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_account_account_register_external_account_register_external_vue__ = __webpack_require__("E9c5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_account_account_details_modal_account_details_verify_vue__ = __webpack_require__("EKqI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_account_account_upload_id_account_upload_id_vue__ = __webpack_require__("flEW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_account_account_upload_document_account_upload_document_vue__ = __webpack_require__("3USW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_account_account_details_modal_account_details_update_modal_vue__ = __webpack_require__("IUvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_account_account_update_image_account_update_image_vue__ = __webpack_require__("Aqlg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_wallet_add_funds_combined_add_funds_combined_vue__ = __webpack_require__("l9wN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_wallet_add_funds_combined_footer_footer_vue__ = __webpack_require__("1F6f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_wallet_deposited_deposited_vue__ = __webpack_require__("WXHk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_potential_payouts_potential_payouts_vue__ = __webpack_require__("gTQM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_generics_modal_small_small_vue__ = __webpack_require__("+CQ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_export_history_export_history_vue__ = __webpack_require__("cgtd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_purchase_purchase_modal_purchase_modal_vue__ = __webpack_require__("Ktaw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_insight_insight_modal_insight_modal_vue__ = __webpack_require__("TJ+c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_research_research_vue__ = __webpack_require__("eNmc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_tax_info_notification_tax_info_notification_vue__ = __webpack_require__("wQDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_twitter_twitter_timeline_twitter_timeline_vue__ = __webpack_require__("FM5G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_home_home_old_news_feed_news_feed_vue__ = __webpack_require__("xJ4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_attach_to_home_attach_to_home_vue__ = __webpack_require__("r6f4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_offers_indicator_popup_offers_indicator_popup_vue__ = __webpack_require__("zyut");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_market_market_contracts_stats_popup_market_contracts_stats_popup_vue__ = __webpack_require__("ETXZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_account_account_reset_password_account_reset_password_vue__ = __webpack_require__("TMp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_orientation_info_orientation_info_vue__ = __webpack_require__("v0Cj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_account_account_badges_list_account_badges_list_vue__ = __webpack_require__("yeq6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_social_user_profile_overview_user_profile_overview_vue__ = __webpack_require__("M6xY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_social_user_profile_overview_header_user_profile_overview_header_vue__ = __webpack_require__("nNeU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_social_user_report_user_report_vue__ = __webpack_require__("0RmI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_leaderboards_leaderboards_trophy_pyramid_leaderboards_trophy_pyramid_vue__ = __webpack_require__("mgKt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_messaging_journey_info_messaging_journey_info_vue__ = __webpack_require__("sIse");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_wallet_coinbase_process_overview_coinbase_process_overview_vue__ = __webpack_require__("MbhW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_profile_affiliations_popup_affiliations_popup_vue__ = __webpack_require__("jI1b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_announcement_announcement_vue__ = __webpack_require__("Mz4K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_account_account_already_exists_account_already_exists_vue__ = __webpack_require__("QSM8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_account_account_already_exists_footer_footer_vue__ = __webpack_require__("Z/tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_account_account_enable_classic_predictit_account_enable_classic_predictit_vue__ = __webpack_require__("Y6Bb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_account_account_enable_classic_predictit_footer_footer_vue__ = __webpack_require__("nBxi");
















































var MODALS = {
  LOGIN: 'login',
  FORGOTTEN: 'forgotten',
  RESET_PASSWORD: 'reset-password',
  REGISTER: 'register',
  REGISTER_EXTERNAL: 'register-external',
  ACCOUNT_VERIFY: 'account-verify',
  UPLOAD_ID: 'upload-id',
  TAX_INFO: 'tax-info',
  ATTACH_TO_HOME: 'attach-to-home',
  ACCOUNT_DETAIL_UPDATE: 'account-detail-update',
  ACCOUNT_DETAIL_PASSWORD: 'account-detail-password',
  ACCOUNT_DETAIL_PASSWORD_SET: 'account-detail-password-set',
  ACCOUNT_ADDRESS_UPDATE: 'account-address-update',
  ADD_FUNDS: 'add-funds',
  PAYMENT_SUCCESS: 'payment-success',
  PAYMENT_ERROR: 'payment-error',
  POTENTIAL_PAYOUTS: 'potential-payouts',
  MARKET_CONTRACT_STATS: 'market-contracts-stats',
  RESEARCH: 'research',
  TWITTER: 'twitter',
  NEWS_FEED: 'news-feed',
  PURCHASE: 'purchase-modal',
  INSIGHT: 'insight-modal',
  GENERIC: 'generic',
  EXPORT_TRADE_HISTORY: 'export-trade-history',
  EXPORT_TRANSACTION_HISTORY: 'export-transaction-history',
  COINBASE: 'coinbase',
  SMALL_CVV: 'cvv',
  SMALL_SWIFT: 'swift',
  SMALL_ROUTING_NUMBER: 'routing-number',
  SMALL_EDIT_IMAGE: 'edit-image',
  SMALL_MARKET_RULES: 'market-rules',
  SMALL_GENERIC: 'generic-small',
  SMALL_USERNAME: 'username',
  SMALL_TRADE_INFO: 'account-trade-info',
  SMALL_OFFERS_INDICATOR: 'offers-indicator',
  SMALL_VERIFICATION_INFO: 'verfication-info',
  SMALL_OWNERSHIP_INFO: 'ownership-info',
  SMALL_BADGES: 'badges',
  SMALL_USER_PROFILE: 'user-profile',
  SMALL_REPORT_USER: 'report-user',
  SMALL_ROI_INFO: 'roi-info',
  SMALL_FEE_INFO: 'fee-info',
  SMALL_WINS_INFO: 'wins-info',
  SMALL_LEADERBOARDS_UPDATE_INFO: 'leaderboards-update-info',
  SMALL_SHARE_INVITE_INFO: 'share-invite-info',
  SMALL_PUBLIC_PROFILE_INFO: 'public-profile-info',
  SMALL_RESTRICTED_FUNDS_INFO: 'restricted-funds-info',
  SMALL_ANNOUNCEMENT: 'announcement',
  UPLOAD_DOCUMENT: 'upload-document',
  ORIENTATION: 'orientation',
  SMALL_MESSAGING_JOURNEY: 'messaging-journey',
  SMALL_PWMB_ACCOUNT_CONFIRM_DELETE: 'pwmb-account-confirm-delete',
  AFFILIATIONS: 'affiliations',
  VIDEO: 'video',
  ACCOUNT_ALREADY_EXISTS: 'account-already-exists',
  ACCOUNT_ENABLE_CLASSIC: 'account-enable-classic'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    modal: __WEBPACK_IMPORTED_MODULE_2__components_generics_modal_modal_vue__["a" /* default */],
    announcement: __WEBPACK_IMPORTED_MODULE_42__components_announcement_announcement_vue__["a" /* default */],
    affiliationsPopup: __WEBPACK_IMPORTED_MODULE_41__components_profile_affiliations_popup_affiliations_popup_vue__["a" /* default */],
    addFundsCombined: __WEBPACK_IMPORTED_MODULE_17__components_wallet_add_funds_combined_add_funds_combined_vue__["a" /* default */],
    addFundsCombinedFooter: __WEBPACK_IMPORTED_MODULE_18__components_wallet_add_funds_combined_footer_footer_vue__["a" /* default */],
    accountDetailsVerify: __WEBPACK_IMPORTED_MODULE_12__components_account_account_details_modal_account_details_verify_vue__["a" /* default */],
    accountUploadId: __WEBPACK_IMPORTED_MODULE_13__components_account_account_upload_id_account_upload_id_vue__["a" /* default */],
    accountUploadDocument: __WEBPACK_IMPORTED_MODULE_14__components_account_account_upload_document_account_upload_document_vue__["a" /* default */],
    accountDetailsUpdateModal: __WEBPACK_IMPORTED_MODULE_15__components_account_account_details_modal_account_details_update_modal_vue__["a" /* default */],
    accountLogin: __WEBPACK_IMPORTED_MODULE_5__components_account_account_login_account_login_vue__["a" /* default */],
    accountLoginFooter: __WEBPACK_IMPORTED_MODULE_6__components_account_account_login_footer_footer_vue__["a" /* default */],
    accountForgotten: __WEBPACK_IMPORTED_MODULE_7__components_account_account_forgotten_account_forgotten_vue__["a" /* default */],
    accountForgottenFooter: __WEBPACK_IMPORTED_MODULE_8__components_account_account_forgotten_footer_footer_vue__["a" /* default */],
    accountRegister: __WEBPACK_IMPORTED_MODULE_9__components_account_account_register_account_register_vue__["a" /* default */],
    accountRegisterFooter: __WEBPACK_IMPORTED_MODULE_10__components_account_account_register_footer_footer_vue__["a" /* default */],
    accountRegisterExternal: __WEBPACK_IMPORTED_MODULE_11__components_account_account_register_external_account_register_external_vue__["a" /* default */],
    accountUpdateImage: __WEBPACK_IMPORTED_MODULE_16__components_account_account_update_image_account_update_image_vue__["a" /* default */],
    attachToHome: __WEBPACK_IMPORTED_MODULE_29__components_attach_to_home_attach_to_home_vue__["a" /* default */],
    deposited: __WEBPACK_IMPORTED_MODULE_19__components_wallet_deposited_deposited_vue__["a" /* default */],
    genericPopup: __WEBPACK_IMPORTED_MODULE_3__components_generics_modal_layouts_generic_vue__["a" /* default */],
    genericSmallPopup: __WEBPACK_IMPORTED_MODULE_4__components_generics_modal_layouts_generic_small_vue__["a" /* default */],
    offersIndicatorPopup: __WEBPACK_IMPORTED_MODULE_30__components_offers_indicator_popup_offers_indicator_popup_vue__["a" /* default */],
    potentialPayouts: __WEBPACK_IMPORTED_MODULE_20__components_potential_payouts_potential_payouts_vue__["a" /* default */],
    smallModal: __WEBPACK_IMPORTED_MODULE_21__components_generics_modal_small_small_vue__["a" /* default */],
    exportHistory: __WEBPACK_IMPORTED_MODULE_22__components_export_history_export_history_vue__["a" /* default */],
    purchaseModal: __WEBPACK_IMPORTED_MODULE_23__components_purchase_purchase_modal_purchase_modal_vue__["a" /* default */],
    insightModal: __WEBPACK_IMPORTED_MODULE_24__components_insight_insight_modal_insight_modal_vue__["a" /* default */],
    research: __WEBPACK_IMPORTED_MODULE_25__components_research_research_vue__["a" /* default */],
    taxInfoNotification: __WEBPACK_IMPORTED_MODULE_26__components_tax_info_notification_tax_info_notification_vue__["a" /* default */],
    twitterTimeline: __WEBPACK_IMPORTED_MODULE_27__components_twitter_twitter_timeline_twitter_timeline_vue__["a" /* default */],
    newsFeed: __WEBPACK_IMPORTED_MODULE_28__components_home_home_old_news_feed_news_feed_vue__["a" /* default */],
    marketContractsStatsPopup: __WEBPACK_IMPORTED_MODULE_31__components_market_market_contracts_stats_popup_market_contracts_stats_popup_vue__["a" /* default */],
    accountResetPassword: __WEBPACK_IMPORTED_MODULE_32__components_account_account_reset_password_account_reset_password_vue__["a" /* default */],
    orientationInfo: __WEBPACK_IMPORTED_MODULE_33__components_orientation_info_orientation_info_vue__["a" /* default */],
    accountBadgesList: __WEBPACK_IMPORTED_MODULE_34__components_account_account_badges_list_account_badges_list_vue__["a" /* default */],
    userProfileOverview: __WEBPACK_IMPORTED_MODULE_35__components_social_user_profile_overview_user_profile_overview_vue__["a" /* default */],
    userProfileOverviewHeader: __WEBPACK_IMPORTED_MODULE_36__components_social_user_profile_overview_header_user_profile_overview_header_vue__["a" /* default */],
    userReport: __WEBPACK_IMPORTED_MODULE_37__components_social_user_report_user_report_vue__["a" /* default */],
    leaderboardsTrophyPyramid: __WEBPACK_IMPORTED_MODULE_38__components_leaderboards_leaderboards_trophy_pyramid_leaderboards_trophy_pyramid_vue__["a" /* default */],
    messagingJourneyInfo: __WEBPACK_IMPORTED_MODULE_39__components_messaging_journey_info_messaging_journey_info_vue__["a" /* default */],
    coinbaseProcessOverview: __WEBPACK_IMPORTED_MODULE_40__components_wallet_coinbase_process_overview_coinbase_process_overview_vue__["a" /* default */],
    accountAlreadyExists: __WEBPACK_IMPORTED_MODULE_43__components_account_account_already_exists_account_already_exists_vue__["a" /* default */],
    accountAlreadyExistsFooter: __WEBPACK_IMPORTED_MODULE_44__components_account_account_already_exists_footer_footer_vue__["a" /* default */],
    accountEnableClassicPredictit: __WEBPACK_IMPORTED_MODULE_45__components_account_account_enable_classic_predictit_account_enable_classic_predictit_vue__["a" /* default */],
    accountEnableClassicPredictitFooter: __WEBPACK_IMPORTED_MODULE_46__components_account_account_enable_classic_predictit_footer_footer_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['isTaxNotificationMandatory']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('popup', ['currentPopup', 'currentSmallPopup', 'currentPopupOptions', 'lastTopPosition', 'tradePopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isShutdownModeOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isUserRestricted']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['status']), {
    footerHideBodyClass: function footerHideBodyClass() {
      return this.currentPopupOptions.hideFooter ? 'modal__body--medium modal__footer--hide' : 'modal__body--medium';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentSmallPopup', 'setCurrentPopupWithDelay']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['setCurrentDeposit', 'markFirstDepositDone']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['logout']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('overlay', { hideOverlay: 'hide' }), {
    isCurrentModal: function isCurrentModal(name) {
      return this.currentPopup === name;
    },
    isCurrentSmallModal: function isCurrentSmallModal(name) {
      return this.currentSmallPopup === name;
    },
    closeModal: function closeModal() {
      this.setCurrentPopup();
      this.onClose();
    },
    closeSmallModal: function closeSmallModal() {
      this.setCurrentSmallPopup();
      this.onClose();
    },
    closeModalWithLogout: function closeModalWithLogout() {
      this.logout();
      this.setCurrentPopup();
      this.onClose();
    },
    closePaymentSuccessModal: function closePaymentSuccessModal() {
      this.markFirstDepositDone();
      this.setCurrentPopup();
      this.setCurrentDeposit(null);
      this.onClose();
    },
    closeModalHideOverlay: function closeModalHideOverlay() {
      this.setCurrentPopup();
      this.hideOverlay();
      this.onClose();
    },
    closeUserReportModal: function closeUserReportModal() {
      this.setCurrentSmallPopup(MODALS.SMALL_USER_PROFILE);
    },
    onClose: function onClose() {
      if (this.currentPopupOptions && typeof this.currentPopupOptions.onClose !== 'undefined') {
        this.currentPopupOptions.onClose.apply(this);
      }
    },
    addFundsClose: function addFundsClose() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: 'Closing/Cancel Deposit Modal'
      });
      this.closeModal();
    },
    paymentSuccessDone: function paymentSuccessDone() {
      if (this.status.isUCAffilSet === null) {
        this.setCurrentPopupWithDelay({ name: MODALS.AFFILIATIONS });
      } else {
        this.closeModal();
      }
    }
  }),
  data: function data() {
    return {
      MODALS: MODALS,
      gtmAddFunds: {
        virtualPage: '/Account/_DptFrmUsSgnUp',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Deposit',
          action: 'click',
          label: 'Closing Deposit Modal'
        }
      },
      gtmAccountVerify: {
        virtualPage: '_SgnUpDptIDV',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'ID Verification',
          action: 'click',
          label: 'Closing ID Verification Modal'
        }
      },
      gtmLogin: {
        name: 'login',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Login',
          action: 'click',
          label: 'Closing Login Modal'
        }
      },
      gtmSignUp: {
        virtualPage: '/Account/SignUp',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Registration',
          action: 'click',
          label: 'Closing Registration Modal'
        }
      }
    };
  }
});

/***/ }),

/***/ "HPJt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "HSd1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_videos_js__ = __webpack_require__("7wxw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b40f6ef2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_videos_vue__ = __webpack_require__("9g4G");
function injectStyle (ssrContext) {
  __webpack_require__("hBWk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_videos_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b40f6ef2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_videos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HX7c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hd0W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hidh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HjfT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticClass:"notifications-widget"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"notifications-widget__content"},[_c('notifications-list',{attrs:{"limit":5,"theme":"widget"}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications-widget__title"},[_c('div',{staticClass:"notifications-widget__title-text"},[_vm._v("\n      Notifications\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HkCn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_info_js__ = __webpack_require__("TONy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a1fa423_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_info_vue__ = __webpack_require__("xKzW");
function injectStyle (ssrContext) {
  __webpack_require__("Hd0W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_info_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a1fa423_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HpV6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "HvTw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_shares_bar_js__ = __webpack_require__("Paoj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e7749c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_shares_bar_vue__ = __webpack_require__("oB/D");
function injectStyle (ssrContext) {
  __webpack_require__("qcXe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_shares_bar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e7749c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_shares_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HzXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_market_biggest_gains_element_market_biggest_gains_element_vue__ = __webpack_require__("4vD6");










var REFRSEH_ENABLED = true;
var REFRESH_INTERVAL = 10 * 60 * 1000;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */]],
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__["swiperSlide"],
    marketBiggestGainsElement: __WEBPACK_IMPORTED_MODULE_7__components_market_market_biggest_gains_element_market_biggest_gains_element_vue__["a" /* default */]
  },
  props: {
    headerId: {
      type: Number,
      default: 0
    },
    extended: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;

    return {
      activeIndex: 0,
      interval: null,
      swiperOptions: {
        spaceBetween: 0,
        autoplay: 10 * 1000,
        slidesPerColumn: 1,
        loop: true,
        direction: 'horizontal',
        onTransitionStart: function onTransitionStart(swp) {
          _this.activeIndex = swp.activeIndex;
        }
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('browse', ['getTwentyFourGains', 'getTwentyFourLoss', 'getWeekGains', 'getWeekLoss']), {
    prevSlide: function prevSlide() {
      this.$refs['market-biggest-gains-slider'].swiper.slidePrev();
    },
    nextSlide: function nextSlide() {
      this.$refs['market-biggest-gains-slider'].swiper.slideNext();
    },
    fetchData: function fetchData() {
      var _this2 = this;

      var promises = [this.getTwentyFourGains({}), this.getTwentyFourLoss({}), this.getWeekGains({}), this.getWeekLoss({})];

      this.loaderAdd();
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        _this2.isComponentReady = true;
        _this2.loaderRemove();
      }).catch(function () {
        return _this2.loaderRemove();
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('browse', ['twentyFourGains', 'twentyFourLoss', 'weekGains', 'weekLoss']), {
    classModifiers: function classModifiers() {
      return {
        'market-biggest-gains': true,
        'market-biggest-gains--extended': this.extended
      };
    },
    dummyComponents: function dummyComponents() {
      if (this.isLayoutMobile) return __WEBPACK_IMPORTED_MODULE_2_lodash_range___default()(0, 1);
      var num = this.extended ? 4 : 2;
      return __WEBPACK_IMPORTED_MODULE_2_lodash_range___default()(0, num);
    },
    items: function items() {
      var results = [];
      if (this.isLayoutDesktop) {
        if (this.twentyFourGains.length) results.push(this.twentyFourGains[0]);
        if (this.twentyFourLoss.length) results.push(this.twentyFourLoss[0]);
        if (this.extended) {
          if (this.weekGains.length) results.push(this.weekGains[0]);
          if (this.weekLoss.length) results.push(this.weekLoss[0]);
        }
      } else {
        if (this.twentyFourGains.length) results.push(this.twentyFourGains);
        if (this.twentyFourLoss.length) results.push(this.twentyFourLoss);
        if (this.extended) {
          if (this.weekGains.length) results.push(this.weekGains);
          if (this.weekLoss.length) results.push(this.weekLoss);
        }
      }
      return results;
    },
    isPrevArrowDisabled: function isPrevArrowDisabled() {
      return this.activeIndex === 0;
    },
    isNextArrowDisabled: function isNextArrowDisabled() {
      return this.items.length === 0 || this.activeIndex === 3;
    },
    prevArrowModifiers: function prevArrowModifiers() {
      return {
        'market-biggest-gains__swiper-arrows__arrow': true,
        'market-biggest-gains__swiper-arrows__arrow--left': true
        // 'market-biggest-gains__swiper-arrows__arrow--disabled': this.isPrevArrowDisabled,
      };
    },
    nextArrowModifiers: function nextArrowModifiers() {
      return {
        'market-biggest-gains__swiper-arrows__arrow': true,
        'market-biggest-gains__swiper-arrows__arrow--right': true
        // 'market-biggest-gains__swiper-arrows__arrow--disabled': this.isNextArrowDisabled,
      };
    },
    shouldShowMobileSlider: function shouldShowMobileSlider() {
      return this.items.length > 0 && !this.isLayoutDesktop;
    },
    shouldShowDesktopList: function shouldShowDesktopList() {
      return this.items.length > 0 && this.isLayoutDesktop;
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.fetchData();
    if (REFRSEH_ENABLED) {
      this.interval = setInterval(function () {
        _this3.fetchData();
      }, REFRESH_INTERVAL);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
});

/***/ }),

/***/ "I0OX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I0mR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.documentUploadInfoVisible)?_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending,"theme":_vm.accountUploadDocumentTheme}}):(_vm.isStep(_vm.STEPS.INITIAL))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[(_vm.showPromoNotification)?_c('alert-box',{class:_vm.alertBoxPromoModifiers,attrs:{"level":"success"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.promoCodeDetail.friendlyDescription)}})]):_vm._e(),_vm._v(" "),(_vm.depositWarning)?_c('div',{staticClass:"predictit-embedded-alert",domProps:{"innerHTML":_vm._s(_vm.depositWarning)}}):_vm._e(),_vm._v(" "),(_vm.showInstantCreditNotification)?_c('alert-box',{class:_vm.alertBoxPromoModifiers,attrs:{"level":_vm.instantCreditBoxLevel}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.instantCreditBoxMessage)}})]):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('alert-box',{staticClass:"add-funds-bank-transfer__alert-box add-funds-bank-transfer__alert-box--error",attrs:{"level":"warning"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]):[(_vm.existingAccounts.length > 0)?_c('div',{staticClass:"add-funds-bank-transfer__accounts"},[_c('div',{staticClass:"add-funds-bank-transfer__title"},[_vm._v("\n          Use an Existing Account\n        ")]),_vm._v(" "),_vm._l((_vm.existingAccounts),function(account){return _c('bank-account',{key:account.authorizationId,staticClass:"add-funds-bank-transfer__account",attrs:{"account":account},on:{"select":function($event){return _vm.onSelect(account)},"remove":function($event){return _vm.onRemove(account)}}})})],2):_vm._e(),_vm._v(" "),_c('div',[_c('div',{ref:"paywithmybank",staticClass:"add-funds-bank-transfer__paywithmybank",attrs:{"id":_vm.payWithMyBankId}})]),_vm._v(" "),(_vm.disclaimer)?_c('p',{staticClass:"add-funds-bank-transfer__note"},[_c('strong',[_vm._v("Note")]),_vm._v(": "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.disclaimer)}})]):_vm._e()]],2):(_vm.isStep(_vm.STEPS.AMOUNT_CONFIRM))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[(_vm.showPromoNotification)?_c('alert-box',{class:_vm.alertBoxPromoModifiers,attrs:{"level":"success"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.promoCodeDetail.friendlyDescription)}})]):_vm._e(),_vm._v(" "),(_vm.showInstantCreditNotification)?_c('alert-box',{class:_vm.alertBoxPromoModifiers,attrs:{"level":_vm.instantCreditBoxLevel}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.instantCreditBoxMessage)}})]):_vm._e(),_vm._v(" "),_c('h4',{staticClass:"add-funds-bank-transfer__cancel-title"},[_c('span',{staticClass:"add-funds-bank-transfer__cancel",on:{"click":function($event){$event.preventDefault();return _vm.onLoadInitial($event)}}},[_vm._v("\n        Cancel\n      ")])]),_vm._v(" "),(_vm.account !== null)?_c('bank-account',{staticClass:"add-funds-bank-transfer__account",attrs:{"removable":false,"showMessage":false,"account":_vm.account},on:{"select":_vm.onLoadInitial}}):_vm._e(),_vm._v(" "),_c('h5',{staticClass:"form__title form__title--left form__title--margin"},[_vm._v("Deposit Amount ($"+_vm._s(_vm.minimumDepositAmount.toFixed(2))+" Minimum)")]),_vm._v(" "),_c('div',{staticClass:"row-x"},[(_vm.amountHasError)?_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"add-funds-bank-transfer__error"},[_vm._v("\n          "+_vm._s(_vm.amountValidationMessage)+"\n        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"small-12 medium-4 column"},[_c('div',{staticClass:"input-group input-group--large"},[_c('span',{staticClass:"input-group__addon"},[_vm._v("$")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],staticClass:"input-group__input",attrs:{"tabindex":"1","validation":_vm.$v.amount},domProps:{"value":(_vm.amount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value},_vm.$v.amount.$touch],"blur":_vm.handleAmountBlur}})])]),_vm._v(" "),_c('div',{staticClass:"small-12 medium-8 column"},[_c('div',{staticClass:"row-x"},_vm._l((_vm.depositAmounts),function(value){return _c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"button button--primary add-funds-bank-transfer__button",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onUpdateAmount(value)}}},[_c('span',{staticClass:"add-funds-bank-transfer__button-plus"},[_vm._v("+")]),_vm._v(" $"+_vm._s(value)+"\n              ")])])}),0)])]),_vm._v(" "),_c('button',{staticClass:"button button--large button--submit button--full-width add-funds-bank-transfer__confirm",attrs:{"disabled":_vm.isConfirmDisabled},on:{"click":_vm.onReviewAndConfirm}},[_c('span',[_vm._v("\n        Review And Confirm\n      ")])]),_vm._v(" "),(_vm.disclaimer)?_c('p',{staticClass:"add-funds-bank-transfer__note add-funds-bank-transfer__note--large-padding"},[_c('strong',[_vm._v("Note")]),_vm._v(": "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.disclaimer)}})]):_vm._e()],1):(_vm.isStep(_vm.STEPS.CONFIRM))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[_c('h4',{staticClass:"add-funds-bank-transfer__cancel-title"},[_c('span',{staticClass:"add-funds-bank-transfer__cancel",on:{"click":function($event){$event.preventDefault();return _vm.onCancelConfirm($event)}}},[_vm._v("\n        Cancel\n      ")])]),_vm._v(" "),_c('div',{staticClass:"add-funds-bank-transfer__info"},[_c('p',{staticClass:"add-funds-bank-transfer__info-large-para"},[_vm._v("\n        Are you sure you want to deposit\n      ")]),_vm._v(" "),_c('p',{staticClass:"add-funds-bank-transfer__info-amount"},[_vm._v("\n        "+_vm._s(_vm.infoAmount)+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"add-funds-bank-transfer__info-large-para"},[_vm._v("\n        using Online Banking?\n      ")]),_vm._v(" "),_c('bank-account',{staticClass:"add-funds-bank-transfer__account",attrs:{"account":_vm.account,"preview":true}}),_vm._v(" "),_c('button',{staticClass:"button button--large button--submit button--full-width add-funds-bank-transfer__submit",attrs:{"disabled":_vm.isConfirmDisabled},on:{"click":_vm.onSubmit}},[_c('span',[_vm._v("\n          Confirm And Deposit\n        ")])]),_vm._v(" "),(_vm.disclaimer)?_c('p',{staticClass:"add-funds-bank-transfer__note"},[_c('strong',[_vm._v("Note")]),_vm._v(": "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.disclaimer)}})]):_vm._e()],1)]):(_vm.isStep(_vm.STEPS.PROCESSING))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[_c('processing-transaction')],1):(_vm.isStep(_vm.STEPS.FINISHED_SUCCESS))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[_c('div',{staticClass:"add-funds-bank-transfer__headline"},[_c('div',{staticClass:"add-funds-bank-transfer__icon"},[_c('img',{attrs:{"src":__webpack_require__("ihRI"),"alt":""}})]),_vm._v(" "),_c('h5',{staticClass:"add-funds-bank-transfer__icon-title add-funds-bank-transfer__icon-title--success"},[_vm._v("\n        Success!\n      ")]),_vm._v(" "),_c('deposited'),_vm._v(" "),_c('button',{staticClass:"button button--large button--submit button--full-width add-funds-bank-transfer__submit",on:{"click":_vm.onSuccess}},[_c('span',[_vm._v("\n          Done\n        ")])])],1)]):(_vm.isStep(_vm.STEPS.FINISHED_FAILED))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[_c('div',{staticClass:"add-funds-bank-transfer__headline"},[_c('div',{staticClass:"add-funds-bank-transfer__icon"},[_c('img',{attrs:{"src":__webpack_require__("z6fO"),"alt":""}})]),_vm._v(" "),_c('div',[(_vm.currentStepData && _vm.currentStepData.error)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentStepData.error)}}):_c('span',[_vm._v("Unfortunately, we could not process your payment.")])])]),_vm._v(" "),_c('button',{staticClass:"button button--large button--submit button--full-width add-funds-bank-transfer__submit",on:{"click":_vm.onLoadInitial}},[_c('span',[_vm._v("\n        Done\n      ")])])]):(_vm.isStep(_vm.STEPS.FINISHED_EXPIRED))?_c('div',{staticClass:"add-funds-bank-transfer__content"},[_c('div',{staticClass:"add-funds-bank-transfer__headline"},[_c('h5',{staticClass:"add-funds-bank-transfer__title add-funds-bank-transfer__title--warn"},[_vm._v("\n        Bank Reauthorization Required\n      ")]),_vm._v(" "),_c('div',{staticClass:"add-funds-bank-transfer__expired-account"},[_c('bank-account',{staticClass:"add-funds-bank-transfer__account",attrs:{"account":_vm.account,"preview":true}})],1),_vm._v(" "),_c('div',[(_vm.currentStepData && _vm.currentStepData.error)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.currentStepData.error)}}):_c('p',[_vm._v("Unfortunately, we could not process your payment.")])]),_vm._v(" "),_c('div',{staticClass:"add-funds-bank-transfer__loader"}),_vm._v(" "),_c('div',[_c('div',{ref:"paywithmybank",staticClass:"add-funds-bank-transfer__paywithmybank add-funds-bank-transfer__paywithmybank--no-min-height",attrs:{"id":_vm.payWithMyBankId}})])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I4ul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fields: {
        newPassword: null,
        newPasswordConfirmation: null
      },
      error: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['userInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['hasMaintenance']), {
    searchQuery: function searchQuery() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["A" /* parseQuery */])(window.location.search);
    },
    hashQuery: function hashQuery() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["A" /* parseQuery */])(window.location.hash);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setErrorSideNotification']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['addExternal', 'setToken', 'setRefreshToken', 'getUserInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('profile', ['setProfileStatus']), {
    handleAdd: function handleAdd() {
      var _this = this;

      var payload = {
        externalAccessToken: this.hashQuery.access_token
      };
      this.addExternal(payload).then(function () {
        return _this.goToTarget();
      }).catch(function () {
        return _this.handleError();
      });
    },
    handleRegister: function handleRegister() {
      this.$router.push({ name: 'home' });
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].REGISTER_EXTERNAL);
    },
    handleLogin: function handleLogin() {
      this.setProfileStatus({ event: 'login' });
      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].del('externalToken');
      if (this.hashQuery.refresh_token) {
        this.setRefreshToken(this.hashQuery.refresh_token);
      }
      this.setToken(this.hashQuery.access_token);
      this.goToTarget();
    },
    handleError: function handleError() {
      var _this2 = this;

      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Login Cancelled or Failed.';

      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].del('externalToken');
      this.setErrorSideNotification(message);
      setTimeout(function () {
        return _this2.$router.push({ name: 'home' });
      }, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DEFAULT_SMALL_POPUP_TIMEOUT);
    },
    goToTarget: function goToTarget() {
      if (this.searchQuery.redirect) {
        this.$router.push(this.searchQuery.redirect);
      } else {
        this.$router.push({ name: 'home' });
      }
    }
  }),
  watch: {
    userInfo: function userInfo(data) {
      if (this.searchQuery.type === __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].SOCIAL_LOGIN_ADD) {
        this.handleAdd();
      } else if (!this.hasMaintenance && data && data.hasRegistered === false) {
        this.handleRegister();
      } else if (data && data.hasRegistered === true) {
        this.handleLogin();
      } else {
        this.handleError();
      }
    }
  },
  created: function created() {
    var _this3 = this;

    if (this.hashQuery.access_token) {
      if (this.searchQuery.type === __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].SOCIAL_LOGIN_OR_REGISTER) {
        __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].set('externalToken', this.hashQuery.access_token);
      }
      this.getUserInfo().catch(function () {
        return _this3.handleError();
      });
    } else if (this.hashQuery.error) {
      this.handleError();
    }
  }
});

/***/ }),

/***/ "I6xq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IBR7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"myshares",staticClass:"portfolio-my-markets"},[_c('div',{staticClass:"portfolio-my-markets__wrapper"},[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader"},_vm._l((_vm.loaderItems(5)),function(item){return _c('div',{staticClass:"content-loader-item"},[_c('market-shares-item-loader')],1)}),0):[(_vm.showMarketsList)?_vm._l((_vm.filteredMarkets),function(market){return _c('div',{key:market.marketId,staticClass:"portfolio-my-markets__item"},[_c('market-list-item-expandable',{attrs:{"expandingAll":_vm.isExpandingAllTriggered(market.marketId),"expanded":_vm.isItemExpanded(market.marketId),"market":market},on:{"toggle":_vm.onMarketListItemToggle}})],1)}):_vm._e(),_vm._v(" "),(_vm.showNoSharesPlaceholder)?[_c('div',{staticClass:"portfolio-my-markets__info"},[_vm._v("\r\n            You do not own any shares.\r\n          ")])]:_vm._e()]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ICSm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IEE4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IExX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bank-transfer"},[(!_vm.isComponentReady)?_c('account-form-loader',{attrs:{"theme":"withdraw"}}):[(!_vm.showConfirmation)?_c('div',[(_vm.documentUploadInfoVisible)?_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending}}):[(!_vm.hasErrorMessage)?[_c('alert-box',{attrs:{"level":"warning"}},[_vm._v("\n            Withdrawing funds may cause some or all of your open offers to be cancelled.\n          ")]),_vm._v(" "),_c('div',{staticClass:"form bank-transfer__form"},[_c('available-balance',{attrs:{"restricted":_vm.restrictedFunds,"balance":_vm.availableBalance}}),_vm._v(" "),(_vm.showBankInfoForm)?[(_vm.hasSavedAccount)?_c('h4',{staticClass:"bank-transfer__cancel-title"},[_c('span',{staticClass:"bank-transfer__cancel",on:{"click":function($event){$event.preventDefault();return _vm.onCancel($event)}}},[_vm._v("\n                  Cancel\n                ")])]):_vm._e(),_vm._v(" "),_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('h4',{staticClass:"bank-transfer__section-title"},[_vm._v("\n                Account\n              ")]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[(_vm.showIbanValidationInfo)?_c('div',{staticClass:"column small-12"},[_c('alert-box',{attrs:{"level":"success"}},[_vm._v("\n                    Your IBAN has been validated. Please identify additional details to locate your specific bank branch.\n                  ")])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.beneficiaryFieldsJustFirst),function(field){return _c('div',{key:field.id,staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fieldsBankInfoForm[field.id],"showValidationWithin":false,"name":field.id,"type":"text","required":field.isRequired,"disabled":_vm.hasErrorMessage,"autocomplete":"","placeholder":field.name},on:{"input":function($event){return _vm.onFieldInput(field.id, $event)}},model:{value:(_vm.fieldsBankInfoForm[field.id]),callback:function ($$v) {_vm.$set(_vm.fieldsBankInfoForm, field.id, $$v)},expression:"fieldsBankInfoForm[field.id]"}},[(field.id === 'swiftBicCode')?_c('notification-icon',{attrs:{"slot":"icon","reversed":true},on:{"showPopup":_vm.showSwiftModal},slot:"icon"}):_vm._e()],1)],1)}),_vm._v(" "),_vm._l((_vm.beneficiaryFieldsWithoutFirst),function(field){return _c('div',{key:field.id,class:_vm.customFieldsClassModifiers(field)},[(field.hasValueList)?_c('form-select',{attrs:{"options":Object.values(field.valueList),"label":"","required":field.isRequired,"placeholder":field.name,"trackBy":""},model:{value:(_vm.fieldsBankInfoForm[field.id]),callback:function ($$v) {_vm.$set(_vm.fieldsBankInfoForm, field.id, $$v)},expression:"fieldsBankInfoForm[field.id]"}}):_c('form-input',{attrs:{"validation":_vm.$v.fieldsBankInfoForm[field.id],"showValidationWithin":false,"name":field.id,"type":"text","required":field.isRequired,"disabled":_vm.hasErrorMessage,"autocomplete":"","placeholder":field.name},on:{"input":function($event){return _vm.onFieldInput(field.id, $event)}},model:{value:(_vm.fieldsBankInfoForm[field.id]),callback:function ($$v) {_vm.$set(_vm.fieldsBankInfoForm, field.id, $$v)},expression:"fieldsBankInfoForm[field.id]"}},[(field.id === 'swiftBicCode')?_c('notification-icon',{attrs:{"slot":"icon","reversed":true},on:{"showPopup":_vm.showSwiftModal},slot:"icon"}):_vm._e()],1)],1)})],2),_vm._v(" "),(_vm.showIbanValidationForm)?[_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"type":"submit","disabled":_vm.hasErrorMessage || _vm.invalidOrDisabled},on:{"click":_vm.confirmAccountInfo}},[_vm._v("\n                  Confirm Account Information\n                ")])]:[_c('h4',{staticClass:"bank-transfer__section-title"},[_vm._v("\n                  Bank Branch Lookup\n                ")]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-6"},[_c('form-input',{attrs:{"type":"text","required":false,"disabled":_vm.hasErrorMessage,"autocomplete":"","name":"search-bank","placeholder":"Bank Name"},model:{value:(_vm.fieldsBankInfoForm.searchBankName),callback:function ($$v) {_vm.$set(_vm.fieldsBankInfoForm, "searchBankName", $$v)},expression:"fieldsBankInfoForm.searchBankName"}}),_vm._v(" "),(false)?_c('div',{staticClass:"bank-transfer__explanation"},[_vm._v("\n                      You may enter one or more values, separated by spaces, to locate your specific bank.\n                      Example values to search: Swift/BIC number, bank routing number, bank city\n                    ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('form-input',{attrs:{"type":"text","required":false,"disabled":_vm.hasErrorMessage,"autocomplete":"","name":"search-city","placeholder":"City"},model:{value:(_vm.fieldsBankInfoForm.searchCity),callback:function ($$v) {_vm.$set(_vm.fieldsBankInfoForm, "searchCity", $$v)},expression:"fieldsBankInfoForm.searchCity"}})],1),_vm._v(" "),(_vm.showAddressSearch)?_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"type":"text","required":false,"disabled":_vm.hasErrorMessage,"autocomplete":"","name":"search-address","placeholder":"Address"},model:{value:(_vm.fieldsBankInfoForm.searchAddress),callback:function ($$v) {_vm.$set(_vm.fieldsBankInfoForm, "searchAddress", $$v)},expression:"fieldsBankInfoForm.searchAddress"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"type":"submit"},on:{"click":_vm.onSearch}},[_vm._v("\n                      Search For Matching Banks\n                    ")])]),_vm._v(" "),(_vm.isSearching)?_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"bank-transfer__spinner"})]):_vm._e(),_vm._v(" "),(_vm.hasSearched)?[(_vm.suggestionsTotal === 0)?_c('div',{staticClass:"column small-12"},[_c('alert-box',{attrs:{"level":"warning"}},[_vm._v("\n                         A matching bank could not be located in "+_vm._s(_vm.userData.countryName)+". Please try again.\n                      ")])],1):(_vm.suggestionsTotal > _vm.TOO_MANY_RESULTS)?_c('div',{staticClass:"column small-12"},[_c('alert-box',{attrs:{"level":"warning"}},[_vm._v("\n                        Your search returned too many results. Please provide additional details such as bank address or city.\n                      ")])],1):_vm._e(),_vm._v(" "),(_vm.suggestionsTotal <= 50)?_c('div',{staticClass:"column small-12"},[_vm._l((_vm.suggestions),function(suggestion){return _c('div',{key:suggestion.id,class:_vm.suggestionClassModifiers(suggestion),on:{"click":function($event){return _vm.onSuggestionPick(suggestion)}}},[_vm._v("\n                        "+_vm._s(suggestion.name)+"\n                        "),_c('div',{staticClass:"bank-transfer__suggestion-description"},[_c('strong',[_vm._v("City")]),_vm._v(": "+_vm._s(suggestion.city)+" | "),_c('strong',[_vm._v("Swift")]),_vm._v(": "+_vm._s(suggestion.swiftCode)+" "),(suggestion.routingCode)?[_vm._v("| "),_c('strong',[_vm._v("Routing")]),_vm._v(": "+_vm._s(suggestion.routingCode))]:_vm._e()],2),_vm._v(" "),(suggestion.address1)?_c('div',[_c('strong',[_vm._v("Address")]),_vm._v(": "+_vm._s(suggestion.address1)+"\n                        ")]):_vm._e(),_vm._v(" "),(!suggestion.isValid)?_c('div',{staticClass:"bank-transfer__suggestion-message"},[_vm._v("\n                          This branch can't be selected\n                        ")]):_vm._e()])}),_vm._v(" "),(_vm.wireSearchResults.canLoadMore)?_c('infinite-loading',{on:{"infinite":_vm.goInfinite}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('div',{staticClass:"bank-transfer__spinner"})]),_vm._v(" "),_c('span',{attrs:{"slot":"no-results"},slot:"no-results"}),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})]):_vm._e()],2):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.pickedSuggestion !== null)?[_c('div',{staticClass:"column small-12"},[_c('h4',{staticClass:"bank-transfer__section-title bank-transfer__section-title--no-margin-bottom"},[_vm._v("\n                        Your Banking Information\n                      ")]),_vm._v(" "),_c('div',{staticClass:"bank-transfer__section-group content-header__section-group"},[_vm._l((_vm.beneficiaryFieldsJustFirst),function(field){return _c('div',{key:((field.id) + "-edit"),staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                            "+_vm._s(field.name)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\n                            "+_vm._s(_vm.fieldsBankInfoForm[field.id])+"\n                          ")])])}),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                            Bank Name\n                          ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\n                            "+_vm._s(_vm.fieldsBankInfoForm.bankName)+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                            Street Address\n                          ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\n                            "+_vm._s(_vm.fieldsBankInfoForm.streetAddress)+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                            City\n                          ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\n                            "+_vm._s(_vm.fieldsBankInfoForm.city)+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\n                            Postal Code\n                          ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\n                            "+_vm._s(_vm.fieldsBankInfoForm.zipCode)+"\n                          ")])])],2)]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"type":"submit","disabled":_vm.hasErrorMessage || _vm.invalidOrDisabled},on:{"click":_vm.confirmBankInfo}},[_vm._v("\n                        Confirm Banking Information\n                      ")])])]:_vm._e()],2)],_vm._v(" "),_c('p',{staticClass:"bank-transfer__disclaimer",domProps:{"innerHTML":_vm._s(_vm.disclaimer)}},[_vm._v("\n                Your banking information will be saved in a secure environment.\n                PredictIt can store information on only one bank account at a time.\n              ")]),_vm._v(" "),_c('p',{staticClass:"bank-transfer__disclaimer"},[_vm._v("\n                If you wish to change your address before proceeding with this withdrawal, you can do so on the "),_c('router-link',{attrs:{"to":{ name: 'address-update' }}},[_vm._v("Account Details")]),_vm._v(" page.\n              ")],1)]:(_vm.showWithdrawalAmountForm)?[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"theme":"amount","name":"amount","validation":_vm.$v.fieldsWithdrawalAmountForm.amount,"disabled":_vm.isAmountFieldDisabled,"showValidationWithin":false,"autocomplete":"","placeholder":_vm.amountPlaceholder},on:{"input":_vm.$v.fieldsWithdrawalAmountForm.amount.$touch},model:{value:(_vm.fieldsWithdrawalAmountForm.amount),callback:function ($$v) {_vm.$set(_vm.fieldsWithdrawalAmountForm, "amount", $$v)},expression:"fieldsWithdrawalAmountForm.amount"}})],1)]),_vm._v(" "),_c('h4',{staticClass:"bank-transfer__section-title"},[_vm._v("\n                Your Name & Address\n              ")]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"name":"name","type":"text","disabled":true,"autocomplete":"","placeholder":"Name"},model:{value:(_vm.beneficiaryInfo.accountName),callback:function ($$v) {_vm.$set(_vm.beneficiaryInfo, "accountName", $$v)},expression:"beneficiaryInfo.accountName"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"name":"street","type":"text","disabled":true,"autocomplete":"","placeholder":"Street Address"},model:{value:(_vm.beneficiaryInfo.accountAddress),callback:function ($$v) {_vm.$set(_vm.beneficiaryInfo, "accountAddress", $$v)},expression:"beneficiaryInfo.accountAddress"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('form-input',{attrs:{"name":"city","type":"text","disabled":true,"autocomplete":"","placeholder":"City"},model:{value:(_vm.beneficiaryInfo.accountCity),callback:function ($$v) {_vm.$set(_vm.beneficiaryInfo, "accountCity", $$v)},expression:"beneficiaryInfo.accountCity"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('form-input',{attrs:{"name":"zipCode","type":"text","disabled":true,"autocomplete":"","placeholder":"Postal Code"},model:{value:(_vm.beneficiaryInfo.accountPostal),callback:function ($$v) {_vm.$set(_vm.beneficiaryInfo, "accountPostal", $$v)},expression:"beneficiaryInfo.accountPostal"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('h4',{staticClass:"bank-transfer__section-title bank-transfer__section-title--no-margin-bottom"},[_vm._v("\n                    Your bank transfer will be sent to\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"column small-7"},[_c('div',{staticClass:"bank-transfer__info"},[_vm._v("\n                    "+_vm._s(_vm.beneficiaryInfo.bankName)+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"bank-transfer__info"},[_vm._v("\n                    Account ending in: "+_vm._s(_vm.beneficiaryInfo.accountNumberLastFour)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"column small-5"},[_c('h4',{staticClass:"bank-transfer__cancel-title"},[_c('span',{staticClass:"bank-transfer__cancel",on:{"click":function($event){$event.preventDefault();return _vm.changeBankInformation($event)}}},[_vm._v("\n                      Change\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"disabled":_vm.hasErrorMessage || _vm.invalidOrDisabled},on:{"click":_vm.reviewRequest}},[_vm._v("\n                    Review Request\n                  ")])])]),_vm._v(" "),_c('p',{staticClass:"bank-transfer__disclaimer"},[_vm._v("\n                Your banking information will be saved in a secure environment. PredictIt can store information on only one bank account at a time.\n              ")]),_vm._v(" "),_c('p',{staticClass:"bank-transfer__disclaimer",domProps:{"innerHTML":_vm._s(_vm.disclaimer)}},[_vm._v("\n                Your banking information will be saved in a secure environment.\n                PredictIt can store information on only one bank account at a time.\n              ")])]:_vm._e()],2)]:_vm._e(),_vm._v(" "),(_vm.hasErrorMessage)?_c('alert-box',{attrs:{"level":"warning"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]):_vm._e()]],2):_vm._e(),_vm._v(" "),(_vm.showConfirmation)?_c('withdraw-confirm',{staticClass:"withdraw-confirm--with-margin",attrs:{"kind":"bank-transfer","amendAvailable":true,"beneficiaryInfo":_vm.beneficiaryInfo,"bankWithdrawAmounts":_vm.bankWithdrawAmounts,"amount":Number(_vm.fieldsWithdrawalAmountForm.amount)},on:{"edit":_vm.onEdit,"success":_vm.onSuccess}}):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "II89":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_button_with_info_js__ = __webpack_require__("pgVC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd35a038_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_with_info_vue__ = __webpack_require__("k6pL");
function injectStyle (ssrContext) {
  __webpack_require__("kYNi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_button_with_info_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd35a038_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_with_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IQVd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IRTZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ISj0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IT5V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IUvR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_details_update_modal_js__ = __webpack_require__("g1ej");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d4409b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_details_update_modal_vue__ = __webpack_require__("Mc9E");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_details_update_modal_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d4409b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_details_update_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IYz5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__ = __webpack_require__("b4Ty");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d336702_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__("q+n/");
function injectStyle (ssrContext) {
  __webpack_require__("TAlE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d336702_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_about__ = __webpack_require__("Ke/w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_browse__ = __webpack_require__("0KBQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_chart__ = __webpack_require__("CPcE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_market__ = __webpack_require__("L09H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_overlay__ = __webpack_require__("X/Fy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_popup__ = __webpack_require__("Dwlj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_search__ = __webpack_require__("dI8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_support__ = __webpack_require__("8sRt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_trade__ = __webpack_require__("fmhl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_user__ = __webpack_require__("bREw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_wallet__ = __webpack_require__("XWIj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_profile__ = __webpack_require__("PMOm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_notifications__ = __webpack_require__("t45u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_insight__ = __webpack_require__("bwq/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_dashboard__ = __webpack_require__("EyqK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_leaderboards__ = __webpack_require__("8mrx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_watchlist__ = __webpack_require__("UtW7");





















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  modules: {
    about: __WEBPACK_IMPORTED_MODULE_2__modules_about__["a" /* default */],
    app: __WEBPACK_IMPORTED_MODULE_3__modules_app__["a" /* default */],
    browse: __WEBPACK_IMPORTED_MODULE_4__modules_browse__["a" /* default */],
    chart: __WEBPACK_IMPORTED_MODULE_5__modules_chart__["a" /* default */],
    market: __WEBPACK_IMPORTED_MODULE_6__modules_market__["a" /* default */],
    overlay: __WEBPACK_IMPORTED_MODULE_7__modules_overlay__["a" /* default */],
    popup: __WEBPACK_IMPORTED_MODULE_8__modules_popup__["a" /* default */],
    search: __WEBPACK_IMPORTED_MODULE_9__modules_search__["a" /* default */],
    support: __WEBPACK_IMPORTED_MODULE_10__modules_support__["a" /* default */],
    trade: __WEBPACK_IMPORTED_MODULE_11__modules_trade__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_12__modules_user__["a" /* default */],
    wallet: __WEBPACK_IMPORTED_MODULE_13__modules_wallet__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_14__modules_profile__["c" /* default */],
    notifications: __WEBPACK_IMPORTED_MODULE_15__modules_notifications__["b" /* default */],
    insight: __WEBPACK_IMPORTED_MODULE_16__modules_insight__["a" /* default */],
    dashboard: __WEBPACK_IMPORTED_MODULE_17__modules_dashboard__["a" /* default */],
    leaderboards: __WEBPACK_IMPORTED_MODULE_18__modules_leaderboards__["b" /* default */],
    watchlist: __WEBPACK_IMPORTED_MODULE_19__modules_watchlist__["a" /* default */]
  },
  strict: "production" !== 'production'
}));

/***/ }),

/***/ "Igwv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__ = __webpack_require__("vJzj");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["b" /* formMixin */]],
  props: {
    token: {
      type: String
    }
  },
  validations: {
    fields: {
      email: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].email,
      newPassword: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].password,
      newPasswordConfirmation: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].passwordConfirmation('newPassword')
    }
  },
  data: function data() {
    return {
      fields: {
        email: '',
        newPassword: null,
        newPasswordConfirmation: null
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['resetPassword']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']), {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formIsValid() && this.formDisable()) {
        this.resetPassword({
          email: this.fields.email,
          password: this.fields.newPassword,
          token: this.token
        }).then(function () {
          _this.setCurrentPopup();
          _this.$router.push({ name: 'home' });
          _this.setSuccessSideNotification('Your password has been changed');
        }).catch(function (errors) {
          _this.formEnable();
          _this.setErrorSideNotification(errors.response.data.message);
        });
      }
    }
  })
});

/***/ }),

/***/ "InKR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IwtE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_disqus_js__ = __webpack_require__("3iU4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_517aa21c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_disqus_vue__ = __webpack_require__("NVwc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_disqus_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_517aa21c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_disqus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J+13":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contract: {
      type: Object,
      required: true
    },
    color: {}
  },
  computed: {
    imageStyleModifiers: function imageStyleModifiers() {
      return {
        'border-color': this.color,
        'background-image': 'url(' + this.contract.contractImageSmallUrl + ')'
      };
    }
  }
});

/***/ }),

/***/ "J1ma":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J3xD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JDJa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JOj2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_state_button_js__ = __webpack_require__("CG+G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cdbc433_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_state_button_vue__ = __webpack_require__("CrmB");
function injectStyle (ssrContext) {
  __webpack_require__("sBFK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_state_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cdbc433_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_state_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JSIy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isSelected: this.selected
    };
  },

  computed: {
    buttonModifier: function buttonModifier() {
      return {
        'filter-button--selected': this.isSelected
      };
    }
  },
  methods: {
    toggleFilter: function toggleFilter(e) {
      e.stopPropagation();
      this.isSelected = !this.isSelected;
      if (this.isSelected) {
        this.$emit('addFilter', this.id);
      } else {
        this.$emit('removeFilter', this.id);
      }
    }
  }
});

/***/ }),

/***/ "JSpR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_item_v2_embed_js__ = __webpack_require__("WhZX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3525e29a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_item_v2_embed_vue__ = __webpack_require__("Wy5T");
function injectStyle (ssrContext) {
  __webpack_require__("jeW4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_item_v2_embed_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3525e29a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_item_v2_embed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JThl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{class:_vm.tableModifiers},[_c('div',{staticClass:"order-book__header row"},[_c('div',{staticClass:"column small-3 order-book__header-cell order-book__header-cell--highlight-strong"},[_vm._v("Price")]),_vm._v(" "),_c('div',{staticClass:"column small-3 order-book__header-cell order-book__header-cell--highlight-strong"},[_vm._v("Quantity")]),_vm._v(" "),_c('div',{staticClass:"column small-6 order-book__header-cell order-book__header-cell--highlight-strong"},[(!_vm.deleteAllMode)?_c('button',{staticClass:"order-book-offers__button order-book-offers__button--delete-all",on:{"click":function($event){return _vm.deleteAllClicked()}}},[_vm._v("Remove All >")]):_vm._e(),_vm._v(" "),(_vm.deleteAllMode)?_c('button',{staticClass:"order-book-offers__button order-book-offers__button--cancel",on:{"click":function($event){return _vm.cancelClicked()}}},[_vm._v("Cancel")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"order-book__body order-book-offers__body"},[_vm._l((_vm.offers),function(item){return _c('div',{staticClass:"row"},[(item.offerId == _vm.deleteOfferId)?[_c('div',{staticClass:"column small-3 order-book__body-cell"},[(!item.isProcessed)?[_vm._v("*")]:_vm._e(),_vm._v(_vm._s(item.pricePerShare)+"¢\n          ")],2),_vm._v(" "),_c('div',{staticClass:"column small-3 order-book__body-cell order-book__body-cell--highlight"},[_vm._v("\n            "+_vm._s(item.remainingQuantity.toLocaleString())+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"column small-6 order-book__body-cell"},[_c('button',{staticClass:"order-book-offers__button order-book-offers__button--confirm-delete",on:{"click":function($event){$event.stopPropagation();return _vm.confirmDeleteClicked(item.offerId)}}},[_vm._v("Confirm Removal")]),_vm._v(" "),_c('button',{staticClass:"order-book-offers__button order-book-offers__button--cancel",on:{"click":function($event){$event.stopPropagation();return _vm.cancelClicked()}}},[_vm._v("Cancel")])])]:[_c('div',{staticClass:"column small-3 order-book__body-cell"},[(!item.isProcessed)?[_vm._v("*")]:_vm._e(),_vm._v(_vm._s(item.pricePerShare)+"¢\n          ")],2),_vm._v(" "),_c('div',{staticClass:"column small-3 order-book__body-cell order-book__body-cell--highlight"},[_vm._v("\n            "+_vm._s(item.remainingQuantity.toLocaleString())+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"column small-6 order-book__body-cell"},[_c('button',{staticClass:"order-book-offers__button order-book-offers__button--delete",on:{"click":function($event){$event.stopPropagation();return _vm.deleteClicked(item.offerId)}}},[_c('span',[_vm._v("Remove")]),_vm._v(" "),_c('span',{staticClass:"order-book-offers__delete-icon"})])])]],2)}),_vm._v(" "),(_vm.deleteAllMode)?_c('div',{staticClass:"order-book-offers__delete-all-confirmation"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-3"},[_vm._v("\n             \n          ")]),_vm._v(" "),_c('div',{staticClass:"column small-3"},[_vm._v("\n             \n          ")]),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('button',{staticClass:"order-book-offers__button order-book-offers__button--confirm-delete-all",on:{"click":function($event){$event.stopPropagation();return _vm.confirmDeleteAllClicked()}}},[_vm._v("\n              Remove All Offers\n            ")])])])]):_vm._e()],2)]),_vm._v(" "),(_vm.showProcessedNotice)?_c('div',{staticClass:"order-book__footer"},[_c('div',{staticClass:"order-book__footer-cell"},[_vm._v("\n      * Offer is currently in process.\n    ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JVxM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_money_widget_js__ = __webpack_require__("qXT1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_770254b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_money_widget_vue__ = __webpack_require__("7ea0");
function injectStyle (ssrContext) {
  __webpack_require__("p82I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_money_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_770254b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_money_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JcZ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_header_title_js__ = __webpack_require__("zREO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc037202_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_header_title_vue__ = __webpack_require__("+Bmr");
function injectStyle (ssrContext) {
  __webpack_require__("imWh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_header_title_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc037202_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_header_title_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JeCN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_plus_minus_sign_plus_minus_sign_vue__ = __webpack_require__("T2le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    confirmationData: {
      type: Object,
      required: true
    }
  },
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_2__components_generics_alert_box_alert_box_vue__["a" /* default */],
    plusMinusSign: __WEBPACK_IMPORTED_MODULE_3__components_generics_plus_minus_sign_plus_minus_sign_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    pricePerShare: function pricePerShare() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["j" /* toCents */])(this.confirmationData.pricePerShare) + '\xA2';
    },
    tradeTypeText: function tradeTypeText() {
      return this.confirmationData.tradeType <= 1 ? 'Buy' : 'Sell';
    },
    priceText: function priceText() {
      var prefix = this.confirmationData.tradeType <= 1 ? 'Max' : 'Min';
      return prefix + ' Price';
    },
    tradeTypeClass: function tradeTypeClass() {
      return {
        'purchase-review-and-confirm__contract-single-share': true,
        'purchase-review-and-confirm__contract-single-share--yes': this.confirmationData.tradeType === 1 || this.confirmationData.tradeType === 3,
        'purchase-review-and-confirm__contract-single-share--no': this.confirmationData.tradeType === 0 || this.confirmationData.tradeType === 2
      };
    },
    profits: function profits() {
      return this.confirmationData.tradeProfit || 0;
    },
    fees: function fees() {
      return this.confirmationData.fee || null;
    },
    riskAdjustment: function riskAdjustment() {
      return this.confirmationData.estimatedRisk || null;
    },
    orderTotal: function orderTotal() {
      return this.confirmationData.orderTotal;
    },
    showProfitOrLoss: function showProfitOrLoss() {
      var types = [2, 3];
      var tradeType = this.confirmationData.tradeType;
      return this.profits !== 0 || types.includes(tradeType);
    },
    profitOrLoss: function profitOrLoss() {
      var profit = this.profits || 0;
      return profit > 0 ? 'Profit' : 'Loss';
    },
    dashboardClass: function dashboardClass() {
      return {
        'purchase-review-and-confirm--dashboard': this.$route.name === 'portfolio'
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('trade', ['setConfirmationToggle']), {
    cancel: function cancel() {
      this.setConfirmationToggle(true);
      this.$emit('cancel');
    },
    submit: function submit() {
      this.$emit('submit');
    }
  })
});

/***/ }),

/***/ "Jjcr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_notification_icon_notification_icon_vue__ = __webpack_require__("qIn7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_cards_americanexpress_jpg__ = __webpack_require__("ZFw9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_cards_americanexpress_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_cards_americanexpress_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_cards_discover_jpg__ = __webpack_require__("OGIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_cards_discover_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_cards_discover_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_cards_mastercard_jpg__ = __webpack_require__("MzT2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_cards_mastercard_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_cards_mastercard_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_cards_visa_jpg__ = __webpack_require__("XiJB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_cards_visa_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_cards_visa_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_cards_blank_png__ = __webpack_require__("owqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_cards_blank_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_cards_blank_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_getValidationMessage__ = __webpack_require__("U7Hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_promoCode__ = __webpack_require__("nPqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_depositWarningMixin__ = __webpack_require__("Scap");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");























var AMOUNT_STEP_ONE = 10;
var AMOUNT_STEP_THREE = 50;
var AMOUNT_STEP_FOUR = 100;
var DEPOSIT_INITIAL = 20;
var DEPOSIT_NON_ZERO_BALANCE = 50;

var STEP_INITIAL = 1;
var STEP_CONFIRM = 2;
var STEP_TRY_AGAIN = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_13__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_12__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__mixins_popupPageModeMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__mixins_promoCode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__mixins_depositWarningMixin__["a" /* default */]],
  validations: function validations() {
    var rules = {
      fields: {
        name: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].required,
        number: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].cardNumber,
        expiryDateMonth: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].required,
        expiryDateYear: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].required,
        cvv: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].cvv,
        amount: __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].depositAmountCoinbase(this.minimumDepositAmount, this.maximumDepositAmount)
      }
    };

    if (this.avsFlag) {
      rules.fields.address = __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].required;
      rules.fields.city = __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].required;
      rules.fields.zipCode = __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["a" /* validators */].validateUSZipCode('country');
    }
    return rules;
  },

  components: {
    notificationIcon: __WEBPACK_IMPORTED_MODULE_3__components_notification_icon_notification_icon_vue__["a" /* default */]
  },
  props: {
    instantCreditData: {}
  },
  data: function data() {
    return {
      ready: false,
      canDeposit: false,
      balanceChecked: false,
      step: STEP_INITIAL,
      years: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].expiryYears,
      months: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].months,
      days: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].days,
      depositAmounts: [AMOUNT_STEP_ONE, AMOUNT_STEP_THREE, AMOUNT_STEP_FOUR],
      disclaimer: '',
      errorMessage: '',
      errorMessageDepositFail: '',
      avsMessage: false,
      avsFlag: false,
      fields: {
        country: '',
        name: '',
        amount: '',
        number: '',
        expiryDateMonth: '',
        expiryDateYear: '',
        cvv: '',
        address: '',
        city: '',
        zipCode: ''
      },
      instantCreditDetail: this.instantCreditData
    };
  },
  created: function created() {
    var _this = this;

    this.loaderAdd();
    this.getBalance().then(this.getDepositCard).then(function (data) {
      _this.loaderRemove();
      _this.isComponentReady = true;
      _this.checkDocumentUploadFlags(data);
      _this.canDeposit = data.canDeposit;
      _this.errorMessage = data.errorMessage;
      _this.promoCodeDetail = data.promoCodeDetail || {};
      _this.disclaimer = data.disclaimer;
      _this.fields.name = data.cardHoldersName;
      _this.avsFlag = data.avsFlag;
      _this.fields.city = data.city || '';
      _this.fields.address = data.address1 || '';
      _this.fields.zipCode = data.postalCode || '';
      _this.fields.country = {
        value: _this.userData.countryCode
      };
    }).catch(function (error) {
      _this.isComponentReady = true;
      _this.errorMessage = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', null);
      _this.loaderRemove();
    });

    if (!this.isPopup) {
      this.getDepositMethods();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('wallet', ['balance', 'firstDepositDone', 'depositMethods']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['status', 'userData']), {
    classModifiers: function classModifiers() {
      return {
        'add-funds': true,
        'add-funds--popup': this.isPopup,
        'add-funds--regular': !this.isPopup
      };
    },
    availableCardTypes: function availableCardTypes() {
      return (this.depositMethods.creditCardTypes || []).map(function (i) {
        return i.toLowerCase();
      });
    },
    minimumDepositAmount: function minimumDepositAmount() {
      return this.depositMethods.minimumDepositAmount || 10.0;
    },
    maximumDepositAmount: function maximumDepositAmount() {
      return 99999;
    },
    accountUploadDocumentTheme: function accountUploadDocumentTheme() {
      return this.isPage ? 'page-padded' : '';
    },
    minDeposit: function minDeposit() {
      return AMOUNT_STEP_ONE;
    },
    amountHasError: function amountHasError() {
      return this.$v.fields.amount.$error;
    },
    amountValidationMessage: function amountValidationMessage() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers_getValidationMessage__["a" /* default */])(this.$v.fields.amount);
    },
    isConfirmDisabled: function isConfirmDisabled() {
      return this.invalidOrDisabled || !this.canDeposit || this.cardTypeHasError;
    },
    isStepInitial: function isStepInitial() {
      return this.step === STEP_INITIAL;
    },
    isStepConfirm: function isStepConfirm() {
      return this.step === STEP_CONFIRM;
    },
    isStepTryAgain: function isStepTryAgain() {
      return this.step === STEP_TRY_AGAIN;
    },
    cardNumber: function cardNumber() {
      return (this.fields.number || '').replace(/ /g, '');
    },
    cardTypeHasError: function cardTypeHasError() {
      return this.cardType !== __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].CARDS.BLANK && !this.availableCardTypes.includes(this.cardType);
    },
    cardTypeValidationMessage: function cardTypeValidationMessage() {
      return 'This card is not supported';
    },
    cardType: function cardType() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["c" /* getCardTypeForNumber */])(this.cardNumber);
    },
    cardTypeImage: function cardTypeImage() {
      var img = __WEBPACK_IMPORTED_MODULE_10__assets_images_cards_blank_png___default.a;
      switch (this.cardType) {
        case __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].CARDS.AMERICAN_EXPRESS:
          img = __WEBPACK_IMPORTED_MODULE_6__assets_images_cards_americanexpress_jpg___default.a;
          break;
        case __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].CARDS.DISCOVER:
          img = __WEBPACK_IMPORTED_MODULE_7__assets_images_cards_discover_jpg___default.a;
          break;
        case __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].CARDS.MASTERCARD:
          img = __WEBPACK_IMPORTED_MODULE_8__assets_images_cards_mastercard_jpg___default.a;
          break;
        case __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].CARDS.VISA:
          img = __WEBPACK_IMPORTED_MODULE_9__assets_images_cards_visa_jpg___default.a;
          break;
        default:
          break;
      }
      return img;
    },
    depositPayload: function depositPayload() {
      var payload = {
        cardHoldersName: this.fields.name,
        amount: this.fields.amount,
        cardNumber: this.cardNumber,
        securityCode: this.fields.cvv,
        expirationMonth: this.fields.expiryDateMonth.value,
        expirationYear: this.fields.expiryDateYear.value,
        depositPromoCode: '',
        marketingSource: '',
        marketingProgram: '',
        cardType: this.cardType
      };
      if (this.avsFlag) {
        payload.address1 = this.fields.address;
        payload.city = this.fields.city;
        payload.postalCode = this.fields.zipCode;
      }
      return payload;
    },
    infoAmount: function infoAmount() {
      var number = Number(this.depositPayload.amount).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return '$' + number;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('wallet', ['getDepositCard', 'confirmDepositCard', 'submitDepositCard', 'setCurrentDeposit', 'getBalance', 'getDepositMethods']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setGenericPopup', 'setCurrentPopup', 'setCurrentSmallPopup']), {
    tabChange: function tabChange(name) {
      this.activeTab = name;
    },
    scrollToTopIfPage: function scrollToTopIfPage() {
      if (this.isLayoutMobile && this.isPage) {
        setTimeout(function () {
          window.scrollTo(0, 0);
        }, 100);
      }
    },
    getInitialAmount: function getInitialAmount() {
      return this.balance && this.balance.accountBalanceDecimal > 0 ? DEPOSIT_NON_ZERO_BALANCE : DEPOSIT_INITIAL;
    },
    handleDepositFail: function handleDepositFail(error) {
      this.errorMessageDepositFail = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', '');
      if (this.isPage) {
        this.step = STEP_INITIAL;
        this.setGenericPopup({
          name: __WEBPACK_IMPORTED_MODULE_20__components_app_app_modals_app_modals__["a" /* MODALS */].PAYMENT_ERROR,
          options: {
            title: 'Payment Failed',
            icon: 'error',
            error: this.errorMessageDepositFail
          }
        });
      } else {
        this.step = STEP_TRY_AGAIN;
      }
    },
    onUpdateAmount: function onUpdateAmount(amount) {
      if (this.fields.amount === '') {
        this.fields.amount = amount;
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["u" /* isNumber */])(this.fields.amount)) {
        this.fields.amount = Number(this.fields.amount) + amount;
      }
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: 'Amount ' + amount + ' Button'
      });
    },
    onConfirmDeposit: function onConfirmDeposit() {
      var _this2 = this;

      this.avsMessage = false;
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'submit',
        label: 'Submit Deposit'
      });
      if (this.formIsValid() && this.formDisable()) {
        this.loaderAdd();
        this.confirmDepositCard(this.depositPayload).then(function (data) {
          _this2.loaderRemove();
          _this2.formEnable();
          if (_this2.checkDocumentUploadFlags(data)) return;
          if (data.dapFlag) {
            _this2.step = STEP_INITIAL;
            _this2.canDeposit = false;
            _this2.errorMessage = data.dapMessage;
          } else if (data.avsFlag) {
            _this2.step = STEP_INITIAL;
            _this2.avsFlag = true;
            _this2.avsMessage = true;
            _this2.getDepositCard().then(function (depositData) {
              _this2.checkDocumentUploadFlags(depositData);
              _this2.fields.city = depositData.city || '';
              _this2.fields.address = depositData.address1 || '';
              _this2.fields.zipCode = depositData.postalCode || '';
              _this2.fields.country = {
                value: _this2.userData.countryCode
              };
            }).catch(function (error) {
              _this2.errorMessage = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', null);
            });
          } else {
            _this2.step = STEP_CONFIRM;
            _this2.scrollToTopIfPage();
          }
        }).catch(function (error) {
          _this2.loaderRemove();
          if (_this2.checkDocumentUploadFlags(error.response.data)) return;
          _this2.formEnable();
          _this2.handleDepositFail(error);
        });
      }
    },
    onSubmitDeposit: function onSubmitDeposit() {
      var _this3 = this;

      this.formDisable();
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit Confirm',
        action: 'submit',
        label: 'Confirm Deposit'
      });
      this.loaderAdd();
      this.submitDepositCard(this.depositPayload).then(function (data) {
        _this3.loaderRemove();
        if (_this3.checkDocumentUploadFlags(data)) return;
        _this3.setCurrentDeposit(data);
        _this3.balanceChecked = false;
        _this3.$gtm.trackEvent({ event: _this3.status.hasBeenFunded ? 'MultiDeposit' : 'Deposit' });
        var popupOptions = {
          name: __WEBPACK_IMPORTED_MODULE_20__components_app_app_modals_app_modals__["a" /* MODALS */].PAYMENT_SUCCESS,
          options: {
            title: 'Payment Confirmed',
            icon: 'success',
            iconTitle: 'Success!'
          }
        };
        if (!_this3.status.hasBeenFunded) {
          popupOptions.options.noClose = true;
        }
        _this3.setGenericPopup(popupOptions);
        _this3.formEnable();
        _this3.$emit('success');
      }).then(this.getBalance).catch(function (error) {
        _this3.loaderRemove();
        if (_this3.checkDocumentUploadFlags(error.response.data)) return;
        _this3.formEnable();
        _this3.handleDepositFail(error);
      });
    },
    onTryAgain: function onTryAgain() {
      this.step = STEP_INITIAL;
    },
    showCVVModal: function showCVVModal() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_20__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_CVV);
    },
    fieldName: function fieldName(name) {
      return this.mode + '-' + name;
    },
    handleAmountBlur: function handleAmountBlur() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'fill',
        label: 'Amount'
      });
    }
  })
});

/***/ }),

/***/ "Jm7U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_amount_info_js__ = __webpack_require__("gCuu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_551afe4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_amount_info_vue__ = __webpack_require__("XxaH");
function injectStyle (ssrContext) {
  __webpack_require__("QAFl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_amount_info_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_551afe4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_amount_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JnuS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JoM+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getContracts: function getContracts() {
    var url = __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","FIREBASE_API_KEY_ANONYMOUS":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID_ANONYMOUS":"","FIREBASE_AUTH_DOMAIN_ANONYMOUS":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL_ANONYMOUS":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID_ANONYMOUS":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID_ANONYMOUS":"76708845910","FIREBASE_STORAGE_BUCKET_ANONYMOUS":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_FIREBASE":false,"ANONYMOUS_SIGNALR":false,"ORDER_BOOK_API_CALL_ENABLED":true,"ORDER_BOOK_FIREBASE_ENABLED":true,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","OPTIMOVE_ENABLED":true,"OPTIMOVE_SDK_TOKEN":"3b0d03cb1a8091dcf9b3f84bb2466b968ebf27e1b4d8a50c123316c0d129a99b","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","NEW_HEADER_ENABLED":false,"NEW_HEADER_EXCHANGE_URL":"https://exchange.predictit.com"}).USE_API_WRAPPER ? 'api/Public/GetLiveData?url=/api/Public/MapDataLegend/EC' : 'api/Public/MapDataLegend/EC';

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url);
  },
  getStateData: function getStateData() {
    var url = __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","FIREBASE_API_KEY_ANONYMOUS":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID_ANONYMOUS":"","FIREBASE_AUTH_DOMAIN_ANONYMOUS":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL_ANONYMOUS":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID_ANONYMOUS":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID_ANONYMOUS":"76708845910","FIREBASE_STORAGE_BUCKET_ANONYMOUS":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_FIREBASE":false,"ANONYMOUS_SIGNALR":false,"ORDER_BOOK_API_CALL_ENABLED":true,"ORDER_BOOK_FIREBASE_ENABLED":true,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","OPTIMOVE_ENABLED":true,"OPTIMOVE_SDK_TOKEN":"3b0d03cb1a8091dcf9b3f84bb2466b968ebf27e1b4d8a50c123316c0d129a99b","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","NEW_HEADER_ENABLED":false,"NEW_HEADER_EXCHANGE_URL":"https://exchange.predictit.com"}).USE_API_WRAPPER ? 'api/Public/GetLiveData?url=/api/Public/MapData/EC' : 'api/Public/MapData/EC';

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url);
  },
  getContractsSenate: function getContractsSenate() {
    var url = __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","FIREBASE_API_KEY_ANONYMOUS":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID_ANONYMOUS":"","FIREBASE_AUTH_DOMAIN_ANONYMOUS":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL_ANONYMOUS":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID_ANONYMOUS":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID_ANONYMOUS":"76708845910","FIREBASE_STORAGE_BUCKET_ANONYMOUS":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_FIREBASE":false,"ANONYMOUS_SIGNALR":false,"ORDER_BOOK_API_CALL_ENABLED":true,"ORDER_BOOK_FIREBASE_ENABLED":true,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","OPTIMOVE_ENABLED":true,"OPTIMOVE_SDK_TOKEN":"3b0d03cb1a8091dcf9b3f84bb2466b968ebf27e1b4d8a50c123316c0d129a99b","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","NEW_HEADER_ENABLED":false,"NEW_HEADER_EXCHANGE_URL":"https://exchange.predictit.com"}).USE_API_WRAPPER ? 'api/Public/GetLiveData?url=/api/Public/MapDataLegend/SEN' : 'api/Public/MapDataLegend/SEN';

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url);
  },
  getStateDataSenate: function getStateDataSenate() {
    var url = __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","FIREBASE_API_KEY_ANONYMOUS":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID_ANONYMOUS":"","FIREBASE_AUTH_DOMAIN_ANONYMOUS":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL_ANONYMOUS":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID_ANONYMOUS":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID_ANONYMOUS":"76708845910","FIREBASE_STORAGE_BUCKET_ANONYMOUS":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_FIREBASE":false,"ANONYMOUS_SIGNALR":false,"ORDER_BOOK_API_CALL_ENABLED":true,"ORDER_BOOK_FIREBASE_ENABLED":true,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","OPTIMOVE_ENABLED":true,"OPTIMOVE_SDK_TOKEN":"3b0d03cb1a8091dcf9b3f84bb2466b968ebf27e1b4d8a50c123316c0d129a99b","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","NEW_HEADER_ENABLED":false,"NEW_HEADER_EXCHANGE_URL":"https://exchange.predictit.com"}).USE_API_WRAPPER ? 'api/Public/GetLiveData?url=/api/Public/MapData/SEN' : 'api/Public/MapData/SEN';

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url);
  }
});

/***/ }),

/***/ "JrD7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_order_book_order_book_vue__ = __webpack_require__("M4KV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_keyboard_numeric_keyboard_numeric_vue__ = __webpack_require__("2wsJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_keyboard_numeric_input_keyboard_numeric_input_vue__ = __webpack_require__("HCce");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_purchase_purchase_yes_no_switcher_purchase_yes_no_switcher_vue__ = __webpack_require__("TdoF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_purchase_purchase_offer_value_purchase_offer_value_vue__ = __webpack_require__("DE6t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_purchase_purchase_quantity_value_purchase_quantity_value_vue__ = __webpack_require__("TQoy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");


 /* eslint-disable */
















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_13__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_14__mixins_loader__["a" /* default */]],
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    keyboardNumeric: __WEBPACK_IMPORTED_MODULE_7__components_keyboard_numeric_keyboard_numeric_vue__["a" /* default */],
    keyboardNumericInput: __WEBPACK_IMPORTED_MODULE_8__components_keyboard_numeric_input_keyboard_numeric_input_vue__["a" /* default */],
    orderBook: __WEBPACK_IMPORTED_MODULE_6__components_order_book_order_book_vue__["a" /* default */],
    purchaseYesNoSwitcher: __WEBPACK_IMPORTED_MODULE_9__components_purchase_purchase_yes_no_switcher_purchase_yes_no_switcher_vue__["a" /* default */],
    purchaseOfferValue: __WEBPACK_IMPORTED_MODULE_10__components_purchase_purchase_offer_value_purchase_offer_value_vue__["a" /* default */],
    purchaseQuantityValue: __WEBPACK_IMPORTED_MODULE_11__components_purchase_purchase_quantity_value_purchase_quantity_value_vue__["a" /* default */]
  },
  props: {
    market: {},
    contract: {
      type: Object,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'cancelToggle', 'confirmationToggle']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'purchase-offer': true
      }, 'purchase-offer--' + this.$router.currentRoute.name, true);
    },
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_4__models_contract__["a" /* default */](this.contract);
    },
    contractName: function contractName() {
      if (!this.market || !this.contract) return '';
      var name = this.market.marketType === 0 ? this.tradeOptions.operationValue : this.contractModel.contractName;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["n" /* capitalizeFirstLetter */])(name);
    },
    minQuantityValue: function minQuantityValue() {
      if (this.tradeOptions.operationType === 'buy') {
        return this.contractModel.userQuantity >= this.minimumOwnership ? 1 : Math.min(this.minimumOwnership, this.minimumOwnership - this.contractModel.userQuantity);
      } else {
        return this.contractModel.userQuantity === 0 ? 1 : this.contractModel.userQuantity > this.minimumOwnership ? 1 : this.contractModel.userQuantity;
      }
    },
    maxQuantityValue: function maxQuantityValue() {
      if (this.tradeOptions.operationType === 'buy') {
        return 9999;
      } else {
        return this.contractModel.userQuantity === 0 ? 1 : this.contractModel.userQuantity;
        // CR
        // : (this.contractModel.userQuantity > this.minimumOwnership)
        //   ? this.contractModel.userQuantity - this.minimumOwnership
        //   : this.contractModel.userQuantity;
      }
    },
    minimumOwnership: function minimumOwnership() {
      return Math.max(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(this.contract, 'minimumClipSize', 1), 1);
    },
    showThresholdInfo: function showThresholdInfo() {
      return this.minimumOwnership > 1;
    },
    initialPricePerShare: function initialPricePerShare() {
      var initialPrice = 0;
      // buy
      if (this.tradeOptions.operationType === 'buy') {
        if (this.tradeOptions.operationValue === 'yes') {
          initialPrice = this.contractModel.buyYesCostAsCents;
        } else {
          initialPrice = this.contractModel.buyNoCostAsCents;
        }
      } else if (this.tradeOptions.operationValue === 'yes') {
        // sell
        initialPrice = this.contractModel.sellYesCostAsCents;
      } else {
        initialPrice = this.contractModel.sellNoCostAsCents;
      }

      if (initialPrice === 0) {
        initialPrice = this.contractModel.lastTradePriceAsCents;
        if (initialPrice > 0 && this.tradeOptions.operationValue === 'no') {
          initialPrice = 100 - initialPrice;
        }
      }

      if (initialPrice === 0) {
        initialPrice = 50;
      }

      return initialPrice;
    },
    mainClassName: function mainClassName() {
      return 'purchase-offer';
    },
    classSharesOwnedLabel: function classSharesOwnedLabel() {
      var _ref2;

      return _ref2 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, this.mainClassName + '__offer-table-contract-shares-owned--no', this.contractModel.mode === 'no'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, this.mainClassName + '__offer-table-contract-shares-owned--yes', this.contractModel.mode === 'yes'), _ref2;
    },
    quantityInputClass: function quantityInputClass() {
      var _ref3;

      return _ref3 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, this.mainClassName + '__offer-quantity-input', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, this.mainClassName + '__offer-quantity-input--empty', !this.tradeOptions.quantity), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, this.mainClassName + '__offer-quantity-input--error', this.quantityError), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, this.mainClassName + '__offer-quantity-input--focus', this.quantityFocused), _ref3;
    },
    quantitySelectedClass: function quantitySelectedClass() {
      return {
        'offer-quantity--selected': this.keyboardNumericType === 'quantity'
      };
    },
    quantityErrorText: function quantityErrorText() {
      var _getReducedQuantity = this.getReducedQuantity(),
          reduced = _getReducedQuantity.reduced,
          min = _getReducedQuantity.min,
          max = _getReducedQuantity.max;
      // console.log(`DEBUG reduced=${reduced}, minimumOwnership=${this.minimumOwnership}, quantity=${this.quantity}, max=${max}`)

      if (this.tradeOptions.operationType === 'buy' && this.quantity && this.quantity < reduced) {
        return 'You must own at least ' + min + ' shares in this contract';
      }
      if (this.tradeOptions.operationType === 'sell' && this.quantity > this.contractModel.userQuantity) {
        if (this.contractModel.userQuantity === 1) {
          return 'You have only 1 share to sell';
        }
        if (this.contractModel.userQuantity === 0) {
          return "You don't have any shares to sell";
        }
        return 'You have only ' + this.contractModel.userQuantity + ' shares to sell';
      }
      if (this.tradeOptions.operationType === 'sell' && this.quantity && this.quantity < reduced) {
        return 'You must maintain ownership of at least ' + min + ' shares';
      }
      // CR
      if (this.tradeOptions.operationType === 'sell' && this.quantity && max && this.quantity > max && this.quantity !== this.contractModel.userQuantity) {
        return 'You must maintain ownership of at least ' + min + ' shares';
      }
      return null;
    },
    isPriceValid: function isPriceValid() {
      if (this.pricePerShare === null || isNaN(this.pricePerShare) || this.pricePerShare === 0) {
        return false;
      }
      return true;
    },
    isQuantityValid: function isQuantityValid() {
      if (this.quantity === null) return false;
      if (this.tradeOptions.operationType === 'sell') {
        if (this.quantity > this.contractModel.userQuantity) return false;
      }
      return !this.quantityErrorText;
    },
    purchaseOfferTitle: function purchaseOfferTitle() {
      var prefix = this.tradeOptions.operationType === 'buy' ? 'Maximum' : 'Minimum';
      return prefix + ' ' + this.tradeOptions.operationType + ' Price';
    },
    nextButtonTitle: function nextButtonTitle() {
      return this.tradeOptions && this.tradeOptions.skipConfirmation ? 'Submit Offer' : 'Next';
    },
    nextButtonDisabled: function nextButtonDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["p" /* isMarketClosed */])(this.market) || !this.isQuantityValid || !this.isPriceValid || this.isLoading;
    },
    purchaseOfferKey: function purchaseOfferKey() {
      var timestamp = this.contractModel.timestamp || '-';
      return this.contractModel.contractId + '-' + timestamp + '-' + this.contractModel.mode + '-' + this.contractModel.userOpenOrders + '-' + this.tradeOptions.operationType + '-' + this.tradeOptions.operationValue;
    },
    orderBookKey: function orderBookKey() {
      return this.purchaseOfferKey;
    },
    isContractOpen: function isContractOpen() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["o" /* isContractOpen */])(this.contract);
    }
  }),
  data: function data() {
    return {
      isMarketClosed: __WEBPACK_IMPORTED_MODULE_12__utils_helpers__["p" /* isMarketClosed */],
      pricePerShareUpdateCount: 0,
      pricePerShare: 0,
      quantity: __WEBPACK_IMPORTED_MODULE_15__constants__["a" /* default */].DEFAULT_QUANTITY,
      skipConfirmation: false,
      keyboardNumericType: null,
      quantityError: null,
      quantityFocused: false,
      priceFocused: false
    };
  },

  watch: {
    'tradeOptions.operationType': function watchOperationType() {
      this.pricePerShareUpdateCount += 1;
      this.pricePerShare = this.getDefaultPricePerShare();
      this.setDefaultQuantity();
    },
    'tradeOptions.operationValue': function watchOperationValue() {
      this.pricePerShareUpdateCount += 1;
      this.pricePerShare = this.getDefaultPricePerShare();
      this.setDefaultQuantity();
    },
    contractModel: function contractModel() {
      // reinit contract after offer cancelation
      if (this.cancelToggle) {
        this.setCancelToggle(false);
        // this.pricePerShare = this.getDefaultPricePerShare();
        // this.quantity = this.getDefaultQuantity();
        // if (!(this.keyboardNumericType || this.quantityFocused || this.priceFocused)) {
        //   this.pricePerShare = this.initialPricePerShare;
        //   this.quantity = constants.DEFAULT_QUANTITY;
        // }
      }
    },
    pricePerShare: function pricePerShare(value) {
      this.setTradePrice(value);
      this.pricePerShare = this.tradeOptions.pricePerShare;
    },
    quantity: function quantity(value) {
      this.setTradeQuantity(value);
      this.quantity = this.tradeOptions.quantity;
    },
    skipConfirmation: function skipConfirmation(value) {
      this.setTradeSkipConfirmation(value);
      this.skipConfirmation = this.tradeOptions.skipConfirmation;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('market', ['getMarketRules']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('trade', ['setTradeQuantity', 'setTradePrice', 'setTradeSkipConfirmation', 'setCancelToggle', 'setConfirmationToggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setGenericSmallPopup', 'setCurrentSmallPopup', 'setCurrentPopupOptions']), {
    openThresholdInfoPopup: function openThresholdInfoPopup() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_OWNERSHIP_INFO);
      this.setCurrentPopupOptions({ shares: this.minimumOwnership });
    },
    getDefaultPricePerShare: function getDefaultPricePerShare() {
      return this.initialPricePerShare;
    },
    getReducedQuantity: function getReducedQuantity() {
      if (this.tradeOptions.operationType === 'sell') {
        return this.contractModel.userQuantity === 0 ? {
          reduced: 1,
          min: this.minimumOwnership,
          max: null
        } : this.contractModel.userQuantity > this.minimumOwnership ? {
          reduced: 1,
          min: this.minimumOwnership,
          max: this.contractModel.userQuantity - this.minimumOwnership
        } : {
          reduced: this.contractModel.userQuantity,
          min: this.minimumOwnership,
          max: null
        };
      } else if (this.tradeOptions.operationType === 'buy') {
        return this.contractModel.userQuantity >= this.minimumOwnership ? {
          reduced: 1,
          min: this.minimumOwnership,
          max: null
        } : {
          reduced: Math.min(this.minimumOwnership, this.minimumOwnership - this.contractModel.userQuantity),
          min: this.minimumOwnership,
          max: null
        };
      }
    },
    setDefaultQuantity: function setDefaultQuantity() {
      var _getReducedQuantity2 = this.getReducedQuantity(),
          reduced = _getReducedQuantity2.reduced,
          min = _getReducedQuantity2.min;
      // console.log(`DEBUG set default: ${reduced}`)


      this.quantity = reduced;
      this.setTradeQuantity(this.quantity);
    },
    onUpdatePriceAndQuantity: function onUpdatePriceAndQuantity(data) {
      this.setTradeQuantity(Math.min(data.quantity, 9999));
      this.quantity = this.tradeOptions.quantity;
      this.setTradePrice(data.price);
      this.pricePerShare = this.tradeOptions.pricePerShare;
    },
    onClickQuantityInput: function onClickQuantityInput() {
      this.keyboardNumericType = 'quantity';
    },
    onClickPricePerShareInput: function onClickPricePerShareInput() {
      this.keyboardNumericType = 'pricePerShare';
    },
    onOutsideClick: function onOutsideClick() {
      this.keyboardNumericType = null;
    },
    onClickNext: function onClickNext() {
      if (this.isQuantityValid && !this.isLoading) {
        this.$emit('submit');
      } else {
        this.quantityError = true;
      }
    },
    onReadRules: function onReadRules() {
      var _this = this;

      if (this.$router.currentRoute.name === 'portfolio') {
        this.loaderAdd(document.body);
        this.getMarketRules(this.market.marketId).then(function (data) {
          _this.loaderRemove(document.body);
          _this.setGenericSmallPopup({
            name: __WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_MARKET_RULES,
            options: {
              title: 'The Rules',
              content: data.rule
            }
          });
        }).catch(function () {
          return _this.loaderRemove(document.body);
        });
      } else {
        this.setGenericSmallPopup({
          name: __WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_MARKET_RULES,
          options: {
            title: 'The Rules',
            content: this.market.rule
          }
        });
      }
    },
    onQuantityInputFocus: function onQuantityInputFocus() {
      this.quantityFocused = true;
    },
    onQuantityInputBlur: function onQuantityInputBlur() {
      this.quantityFocused = false;
      // console.log(`DEBUG minQuantityValue=${this.minQuantityValue} maxQuantityValue=${this.maxQuantityValue}`)

      // if (this.quantity === null || this.quantity < this.minQuantityValue) {
      //   this.quantity = this.minQuantityValue;
      // } else if (this.quantity > this.maxQuantityValue) {
      //   this.quantity = this.maxQuantityValue
      // }
    },
    onPriceFocus: function onPriceFocus() {
      this.priceFocused = true;
    },
    onPriceBlur: function onPriceBlur() {
      this.priceFocused = false;
    },
    onClickQuantityBox: function onClickQuantityBox() {
      this.$refs.sharesNumberInput.click();
    }
  }),
  created: function created() {
    // do not reinit contract if user comes back from confirm page
    if (this.confirmationToggle && this.tradeOptions.pricePerShare !== null) {
      this.quantity = this.tradeOptions.quantity;
      this.setConfirmationToggle(false);
    } else {
      this.setTradePrice(this.getDefaultPricePerShare());
      this.setDefaultQuantity();
    }

    this.pricePerShare = this.tradeOptions.pricePerShare;
    // this.quantity = (defaultQuantity === null) ? defaultQuantity : this.tradeOptions.quantity;
    this.skipConfirmation = this.tradeOptions.skipConfirmation;
  }
});

/***/ }),

/***/ "Jt46":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K/Lh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OFFSET_CHECK_TIMEOUT */
/* unused harmony export MARKET_CONTRACTS_SHOW_MORE_NUM */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_contract_horizontal_v2_market_contract_horizontal_v2_vue__ = __webpack_require__("p+B/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_purchase_purchase_desktop_purchase_desktop_vue__ = __webpack_require__("nGzq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_payout_market_payout_vue__ = __webpack_require__("SdEv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");













// transition time + buffer
var OFFSET_CHECK_TIMEOUT = 300 + 150;
var MARKET_CONTRACTS_SHOW_MORE_NUM = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    market: {
      type: Object,
      required: true
    },
    expandingAll: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showAllContracts: false,
      isExpandingAll: this.expandingAll,
      togglePositionTop: null,
      reinitializeAttempt: 1
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_loader__["a" /* default */]],
  components: {
    marketContract: __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_contract_horizontal_v2_market_contract_horizontal_v2_vue__["a" /* default */],
    marketPayout: __WEBPACK_IMPORTED_MODULE_5__components_market_market_payout_market_payout_vue__["a" /* default */],
    purchaseDesktop: __WEBPACK_IMPORTED_MODULE_4__components_purchase_purchase_desktop_purchase_desktop_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('trade', ['tradeOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('popup', ['currentPopup']), {
    showContractsHeader: function showContractsHeader() {
      return this.isLayoutDesktop;
    },
    contractsToShow: function contractsToShow() {
      return !this.showAllContracts && this.shouldShowToggleMoreButton ? this.filteredContracts.slice(0, MARKET_CONTRACTS_SHOW_MORE_NUM) : this.filteredContracts;
    },
    leftContractsToShow: function leftContractsToShow() {
      return this.showAllContracts ? [] : this.filteredContracts.slice(MARKET_CONTRACTS_SHOW_MORE_NUM, this.filteredContracts.length);
    },
    shouldShowToggleMoreButton: function shouldShowToggleMoreButton() {
      return this.expandingAll && this.filteredContracts.length > MARKET_CONTRACTS_SHOW_MORE_NUM;
    },
    toggleMoreModifiers: function toggleMoreModifiers() {
      return {
        'market-list-item-expandable__contracts-toggle-more': true,
        'market-list-item-expandable__contracts-toggle-more--active': this.showAllContracts
      };
    },
    contractLayout: function contractLayout() {
      return this.isLayoutDesktop ? 'dashboard' : 'default';
    },
    titleMobileClassModifiers: function titleMobileClassModifiers() {
      return {
        'market-list-item-expandable__mobile-title': true,
        'market-list-item-expandable__mobile-title--has-open-offers': this.showOpenOffersIndicator
      };
    },
    toggleMobileClassModifiers: function toggleMobileClassModifiers() {
      return {
        'market-list-item-expandable__mobile-toggle': true,
        'market-list-item-expandable__mobile-toggle--expanded': this.expanded
      };
    },
    titleDesktopClassModifiers: function titleDesktopClassModifiers() {
      return {
        'market-list-item-expandable__desktop-title': true,
        'market-list-item-expandable__desktop-title--has-open-offers': this.showOpenOffersIndicator
      };
    },
    toggleDesktopClassModifiers: function toggleDesktopClassModifiers() {
      return {
        'market-list-item-expandable__desktop-toggle': true,
        'market-list-item-expandable__desktop-toggle--expanded': this.expanded
      };
    },
    marketImageStyleModifiers: function marketImageStyleModifiers() {
      var baseGradient = 'linear-gradient(to right, rgba(78, 109, 115, 0.12), rgba(78, 109, 115, 0.16))';
      return {
        'background-image': baseGradient + ', url(' + this.market.marketImageUrl + ')'
      };
    },
    filteredContracts: function filteredContracts() {
      return this.market && this.market.marketContracts ? this.market.marketContracts.filter(function (i) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["m" /* contractOwnershipNum */])(i) > 0;
      }) : [];
    },
    isPayoutAvailable: function isPayoutAvailable() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["y" /* hasMarketPayout */])(this.market);
    },
    openOffers: function openOffers() {
      if (!this.market.isOpen) return 0;
      return __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(this.filteredContracts, function (i) {
        return i.userOpenOrdersBuyQuantity + i.userOpenOrdersSellQuantity;
      });
    },
    showOpenOffersIndicator: function showOpenOffersIndicator() {
      return this.isLayoutDesktop && this.openOffers > 0;
    },
    marketKey: function marketKey() {
      var loggedIn = this.isLoggedIn ? 'logged-in' : 'logged-out';
      return this.market ? 'dashboard-' + this.market.marketId + '-' + loggedIn : null;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('market', ['getMarket']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setTradePopup']), {
    onToggleMore: function onToggleMore() {
      this.showAllContracts = !this.showAllContracts;
      if (!this.showAllContracts) {
        window.scrollTo(0, this.$el.offsetTop);
      }
    },
    onViewMarket: function onViewMarket(market) {
      this.$router.push({
        name: 'market-details',
        params: { marketId: market.marketId, marketUrl: market.marketUrl }
      });
    },
    onReinitializePurchase: function onReinitializePurchase() {
      // this.reinitializeAttempt += 1;
    },
    toggleItem: function toggleItem() {
      this.togglePositionTop = this.$el.offsetTop;
      this.$emit('toggle', {
        expanded: !this.expanded,
        market: this.market
      });
    },
    contractKey: function contractKey(prefix, data) {
      var contract = new __WEBPACK_IMPORTED_MODULE_7__models_contract__["a" /* default */](data);
      return prefix + '-' + this.marketKey + '-' + contract.contractId + '-' + contract.mode + '-' + this.reinitializeAttempt.toString();
    },
    isPurchaseDesktopMode: function isPurchaseDesktopMode(contractId) {
      return this.isLayoutDesktop && this.tradeOptions && this.tradeOptions.contractId === contractId;
    },
    initializePurchase: function initializePurchase() {
      var contracts = this.market.contracts || this.market.marketContracts;
      var contractIds = contracts.map(function (i) {
        return i.contractId;
      });
      if (this.isLayoutMobile && this.tradeOptions !== null && this.tradeOptions.contractId !== null && contractIds.includes(this.tradeOptions.contractId) && this.currentPopup !== __WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].PURCHASE) {
        this.setTradePopup({
          name: __WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].PURCHASE,
          options: {
            market: this.market
          }
        });
      }
    }
  }),
  watch: {
    expanded: function expanded(value) {
      var _this = this;

      if (value && !this.expandingAll) {
        setTimeout(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_scrollTo__["a" /* default */])(_this.$el.offsetTop, 500);
        }, OFFSET_CHECK_TIMEOUT);
      }
    },
    tradeOptions: function tradeOptions() {
      this.initializePurchase();
    }
  }
});

/***/ }),

/***/ "K0uo":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDQiIGhlaWdodD0iNTIiIHZpZXdCb3g9IjAgMCAxMDQgNTIiPg0KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxwYXRoIGZpbGw9IiMyNjNCM0YiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTk1LjAxIDQwLjEzMmEyLjMzIDIuMzMgMCAwIDAtMS45MTQtLjY2NGwtMS4xMDYtMS4xYzMuNjk1LTQuMTc2IDUuNzM0LTkuNDYxIDUuNzM0LTE1LjA3MyAwLTYuMTAxLTIuMzg2LTExLjg0LTYuNzIxLTE2LjE1NkM4Ni42NiAyLjgxNCA4MC44OTQuNDQyIDc0Ljc1My40NDJjLTYuMTMgMC0xMS44OTYgMi4zNzUtMTYuMjM2IDYuNjk3LTQuMzQ1IDQuMzE2LTYuNzM0IDEwLjA1NS02LjczNCAxNi4xNTYgMCA2LjEwMiAyLjM5NCAxMS44NDMgNi43MzQgMTYuMTU5IDQuMzQgNC4zMiAxMC4xMDYgNi42OTIgMTYuMjM3IDYuNjkyYTIyLjgxOSAyMi44MTkgMCAwIDAgMTUuMTUtNS43MDdsMS4xMTEgMS4wOTdhMi4zMSAyLjMxIDAgMCAwIC42NjggMS45MWw3LjkxMyA3Ljg3M2MuNDYxLjQ1OCAxLjA2Mi42OCAxLjY2OC42OC41OTggMCAxLjIwNC0uMjI1IDEuNjY3LS42OGEyLjMzNyAyLjMzNyAwIDAgMCAwLTMuMzFsLTcuOTItNy44Nzd6bS03LjM0LTMuOTk5YTE4LjE5NSAxOC4xOTUgMCAwIDEtMTIuOTE2IDUuMzMgMTguMTggMTguMTggMCAwIDEtMTIuOTA3LTUuMzI1Yy0zLjQ0Ni0zLjQyOC01LjM1LTcuOTkzLTUuMzUtMTIuODQ1IDAtNC44NSAxLjktOS40MTIgNS4zNS0xMi44NDNhMTguMTg5IDE4LjE4OSAwIDAgMSAxMi45MDctNS4zMjVjNC44OCAwIDkuNDY4IDEuODkgMTIuOTE2IDUuMzI1IDMuNDQ0IDMuNDMgNS4zNDUgNy45OTMgNS4zNDUgMTIuODQzIDAgNC44NTItMS45MDEgOS40MS01LjM0NSAxMi44NHoiLz4NCiAgICAgICAgPGcgc3Ryb2tlPSIjMjYzQjNGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iNCI+DQogICAgICAgICAgICA8cGF0aCBkPSJNMTEgNDhhMSAxIDAgMCAxLTEgMUgzYTEgMSAwIDAgMS0xLTFWMjNhMSAxIDAgMCAxIDEtMWg3YTEgMSAwIDAgMSAxIDF2MjV6TTQ1IDQ4YTEgMSAwIDAgMS0xIDFoLTdhMSAxIDAgMCAxLTEtMVYzM2ExIDEgMCAwIDEgMS0xaDdhMSAxIDAgMCAxIDEgMXYxNXpNMjggNDhhMSAxIDAgMCAxLTEgMWgtN2ExIDEgMCAwIDEtMS0xVjhhMSAxIDAgMCAxIDEtMWg3YTEgMSAwIDAgMSAxIDF2NDB6Ii8+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "K1KK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-book-shares"},[_c('div',{class:_vm.tableModifiers},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"order-book__body"},_vm._l((_vm.shares),function(item){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6 order-book__body-cell"},[_vm._v(_vm._s(item.dateExecuted))]),_vm._v(" "),_c('div',{staticClass:"column small-3 order-book__body-cell order-book__body-cell--highlight"},[_vm._v(_vm._s(item.pricePerShare)+"¢")]),_vm._v(" "),_c('div',{staticClass:"column small-3 order-book__body-cell"},[_vm._v("\n          "+_vm._s(item.sharesOwned.toLocaleString())+"\n        ")])])}),0)]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row order-book__header"},[_c('div',{staticClass:"column small-6 order-book__header-cell order-book__header-cell--highlight-strong"},[_vm._v("Date")]),_vm._v(" "),_c('div',{staticClass:"column small-3 order-book__header-cell order-book__header-cell--highlight-strong"},[_vm._v("Price")]),_vm._v(" "),_c('div',{staticClass:"column small-3 order-book__header-cell order-book__header-cell--highlight-strong"},[_vm._v("Quantity")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-book__footer"},[_c('div',{staticClass:"order-book__footer-cell"},[_vm._v("\n      Shares are sold in order of purchase\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K2ud":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_radio_js__ = __webpack_require__("joAC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22dcbdbf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radio_vue__ = __webpack_require__("SER/");
function injectStyle (ssrContext) {
  __webpack_require__("Xc0v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_radio_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22dcbdbf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K9BP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KBWT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{staticClass:"election-map-table"},[_c('div',{staticClass:"election-map-table__title"},[_vm._v("\r\n    Split Electoral Votes\r\n  ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"election-map-table__row"},[_c('div',{staticClass:"election-map-table__row-legend"},[_vm._v("\r\n      NE\r\n    ")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-state",style:(_vm.neStyleModifiers)},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-district"},[_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.ne1StyleModifiers)},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.ne2StyleModifiers)},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.ne3StyleModifiers)},[_vm._v("1")])])]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row"},[_c('div',{staticClass:"election-map-table__row-legend"},[_vm._v("\r\n      ME\r\n    ")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-state",style:(_vm.meStyleModifiers)},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-district"},[_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.me1StyleModifiers)},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.me2StyleModifiers)},[_vm._v("1")]),_vm._v(" "),(false)?_c('div',{staticClass:"election-map-table__row-district-entry",style:(_vm.me3StyleModifiers)},[_vm._v("x")]):_vm._e()])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"election-map-table__header"},[_c('div',{staticClass:"election-map-table__header-state"},[_c('div',[_vm._v("\r\n        State\r\n      ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-table__header-district"},[_c('div',{staticClass:"election-map-table__header-district-header"},[_vm._v("\r\n        District\r\n      ")]),_vm._v(" "),_c('div',{staticClass:"election-map-table__header-district-num"},[_c('div',[_vm._v("1")]),_vm._v(" "),_c('div',[_vm._v("2")]),_vm._v(" "),_c('div',[_vm._v("3")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KCsQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KG2i":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSIzOSIgdmlld0JveD0iMCAwIDQwIDM5Ij4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLjcyNikiPg0KICAgICAgICA8ZWxsaXBzZSBjeD0iMTkuOTY2IiBjeT0iMTguOTcxIiBmaWxsPSIjMDc0MTRCIiByeD0iMy42MiIgcnk9IjMuMzQyIi8+DQogICAgICAgIDxwYXRoIGZpbGw9IiMwNzQxNEIiIGQ9Ik0yNS41NyAxOS4xNTdjMCAyLjg1Ny0yLjUxIDUuMTczLTUuNjA0IDUuMTczLTMuMDk0IDAtNS42MDMtMi4zMTYtNS42MDMtNS4xNzMgMC0uNTEyLjA4Mi0xLjAwNi4yMzItMS40NzNoLTEuNjU2djcuMjU1YzAgLjM3Ni4zMjIuNjgzLjcxNi42ODNoMTIuNTUzYy4zOTQgMCAuNzE3LS4zMDcuNzE3LS42ODN2LTcuMjU1aC0xLjU4N2MuMTUuNDY3LjIzMS45NjEuMjMxIDEuNDczek0yNC4wNjcgMTUuNzI2aDIuMDM4Yy40NDYgMCAuODExLS4zNDguODExLS43NzN2LTEuODUxYzAtLjQyNi0uMzY1LS43NzMtLjgxMS0uNzczaC0yLjAzOGMtLjQ0NiAwLS44MTEuMzQ3LS44MTEuNzczdjEuODVjMCAuNDI2LjM2NS43NzQuODExLjc3NHoiLz4NCiAgICAgICAgPHBhdGggc3Ryb2tlPSIjMDc0MTRCIiBkPSJNMTkuOTQ5LjVjMTAuNzQ3IDAgMTkuNDQ5IDguMjkyIDE5LjQ0OSAxOC41MDhzLTguNzAyIDE4LjUwOC0xOS40NDkgMTguNTA4QzkuMjAyIDM3LjUxNi41IDI5LjIyNC41IDE5LjAwOFM5LjIwMi41IDE5Ljk0OS41em02LjcgMjcuNTk2SDEzLjI1Yy0xLjU3NiAwLTIuODE0LTEuMTQ1LTIuODE0LTIuNzA0VjEyLjYyNWMwLTEuNTYgMS4yMzgtMi43MDUgMi44MTQtMi43MDVoMTMuMzk4YzEuNTc2IDAgMi44MTQgMS4xNDUgMi44MTQgMi43MDV2MTIuNzY3YzAgMS41Ni0xLjIzOCAyLjcwNC0yLjgxNCAyLjcwNHoiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "KGr/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dashboard_portfolio_my_markets_portfolio_my_markets_vue__ = __webpack_require__("UIPs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_account_social_badge_account_social_badge_vue__ = __webpack_require__("gdGR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dashboard_friends_search_friends_search_vue__ = __webpack_require__("h9LM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_market_filters_market_filters_dashboard_market_filters_dashboard_vue__ = __webpack_require__("of0E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_dashboard_dashboard_markets_toggle_dashboard_markets_toggle_vue__ = __webpack_require__("zkja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_social_share_invite_widget_share_invite_widget_vue__ = __webpack_require__("dDcj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_leaderboards_leaderboards_info_leaderboards_info_vue__ = __webpack_require__("HkCn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_notifications_list_notifications_list_vue__ = __webpack_require__("R/N+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_profile_public_profile_widget_public_profile_widget_vue__ = __webpack_require__("dlHv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_accountVerify__ = __webpack_require__("yZQa");

















var TAB_WEEK = 'week';
var TAB_MONTH = 'month';
// const TAB_YEAR = 'year';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_15__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__mixins_loader__["a" /* default */]],
  components: {
    publicProfileWidget: __WEBPACK_IMPORTED_MODULE_13__components_profile_public_profile_widget_public_profile_widget_vue__["a" /* default */],
    leaderboardsInfo: __WEBPACK_IMPORTED_MODULE_11__components_leaderboards_leaderboards_info_leaderboards_info_vue__["a" /* default */],
    shareInviteWidget: __WEBPACK_IMPORTED_MODULE_10__components_social_share_invite_widget_share_invite_widget_vue__["a" /* default */],
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a,
    tabs: __WEBPACK_IMPORTED_MODULE_3__components_generics_tabs_tabs_vue__["a" /* default */],
    portfolioMyMarkets: __WEBPACK_IMPORTED_MODULE_4__components_dashboard_portfolio_my_markets_portfolio_my_markets_vue__["a" /* default */],
    accountSocialBadge: __WEBPACK_IMPORTED_MODULE_5__components_account_account_social_badge_account_social_badge_vue__["a" /* default */],
    friendsSearch: __WEBPACK_IMPORTED_MODULE_6__components_dashboard_friends_search_friends_search_vue__["a" /* default */],
    dashboardMarketFilters: __WEBPACK_IMPORTED_MODULE_7__components_market_market_filters_market_filters_dashboard_market_filters_dashboard_vue__["a" /* default */],
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_9__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    dashboardMarketsToggle: __WEBPACK_IMPORTED_MODULE_8__components_dashboard_dashboard_markets_toggle_dashboard_markets_toggle_vue__["a" /* default */],
    notificationsList: __WEBPACK_IMPORTED_MODULE_12__components_notifications_list_notifications_list_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showTabs: true,
      activeTab: null,
      infiniteLoader: null,
      tabs: [{
        name: TAB_WEEK,
        title: '1 Week',
        timespan: '1w'
      }, {
        name: TAB_MONTH,
        title: '1 Month',
        timespan: '1m'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('dashboard', ['mySharesTotalGainLoss']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('wallet', ['portfolioValueDecimal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('dashboard', ['mySharesReady']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['balance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isShutdownModeOn']), {
    portfolioValueReady: function portfolioValueReady() {
      return !this.balance.isDefault && this.mySharesReady;
    },
    activeTabTimespan: function activeTabTimespan() {
      return this.getActiveTabTimespan(this.activeTab);
    },
    moreRecentTradesModifiers: function moreRecentTradesModifiers() {
      return {
        'dashboard-desktop__trades-footer-button': true
      };
    },
    gainLossClassModifiers: function gainLossClassModifiers() {
      var value = this.mySharesTotalGainLoss;
      return {
        'dashboard-desktop__header--plus': value > 0,
        'dashboard-desktop__header--minus': value < 0
      };
    },
    showMyMarkets: function showMyMarkets() {
      return this.$route.name === 'portfolio';
    },
    showNotifications: function showNotifications() {
      return this.$route.name === 'notifications';
    },
    showInfo: function showInfo() {
      return false && !this.isShutdownModeOn;
    }
  })
});

/***/ }),

/***/ "KKwX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KKxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay",class:_vm.classObject,on:{"click":_vm.hide}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KRkG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__ = __webpack_require__("jLJc");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_001c5ad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__ = __webpack_require__("6b6f");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_001c5ad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KUSN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_notification_items_notifcation_item_dashboard_notification_item_dashboard_vue__ = __webpack_require__("MJqx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__ = __webpack_require__("BL43");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__ = __webpack_require__("P71F");

 /*
                                       Display List of notifications in dashboard/account pages.
                                      */







var NOTIFICATION_COUNT_LIMIT = 99;
var NO_ITEMS_MESSAGE = 'There are no notifications';
var NO_MORE_ITEMS_MESSAGE = 'No more notifications to display';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__["a" /* default */]],
  props: {
    limit: {
      type: Number,
      default: null
    },
    theme: {
      type: String,
      default: ''
    }
  },
  components: {
    notificationItemDashboard: __WEBPACK_IMPORTED_MODULE_4__components_notification_items_notifcation_item_dashboard_notification_item_dashboard_vue__["a" /* default */],
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default.a
  },
  data: function data() {
    return {
      loadedInfo: NO_ITEMS_MESSAGE,
      infiniteLoader: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('dashboard', ['notifications', 'notificationsToggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['userData']), {
    items: function items() {
      var data = this.notifications.data;

      if (this.limit) {
        data = this.notifications.data.slice(0, this.limit);
      }
      return __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy___default()(data, function (el) {
        return el.notificationId;
      });
    },
    moreNotificationsModifiers: function moreNotificationsModifiers() {
      return {
        'notifications-list__footer-button': true,
        'notifications-list__footer-button--expanded': true
      };
    },
    notificationsCount: function notificationsCount() {
      var total = this.notifications.totalCount;
      return total > NOTIFICATION_COUNT_LIMIT ? NOTIFICATION_COUNT_LIMIT : total;
    },
    showInfiniteLoading: function showInfiniteLoading() {
      return this.notifications.canLoadMore && !this.limit;
    },
    isScrollMore: function isScrollMore() {
      return this.infiniteLoader && this.notifications.canLoadMore && this.items.length > 0;
    }
  }),
  watch: {
    notificationsToggle: function notificationsToggle() {
      this.infiniteLoader = null;
      this.resetNotifications();
      this.loadNotifications();
    },
    items: function items() {
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        if (!this.notifications.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }
      this.loadedInfo = this.items.length > 0 ? NO_MORE_ITEMS_MESSAGE : NO_ITEMS_MESSAGE;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('dashboard', ['resetNotifications', 'getNotifications']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['toggleNotificationsWidget']), {
    onSeeAllClick: function onSeeAllClick() {
      this.toggleNotificationsWidget();
      this.$router.push({ name: 'notifications' });
    },
    goInfinite: function goInfinite(infi) {
      this.infiniteLoader = infi;

      if (this.notifications.canLoadMore) {
        this.loadNotifications();
      }
    },
    loadNotifications: function loadNotifications() {
      var _this = this;

      if (this.loading) return;

      this.loading = true;
      this.getNotifications().then(function () {
        _this.loading = false;
        _this.isComponentReady = true;
      });
    }
  }),
  created: function created() {
    this.resetNotifications();
    this.loadNotifications();
  }
});

/***/ }),

/***/ "KV4/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KWv7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_home_old_home_old_vue__ = __webpack_require__("3Uxo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_trends_trends_vue__ = __webpack_require__("dywA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_page_markets_page_markets_vue__ = __webpack_require__("CIck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_page_market_detail_page_market_detail_vue__ = __webpack_require__("aGuV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_page_story_detail_page_story_detail_vue__ = __webpack_require__("p+/I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_page_search_page_search_vue__ = __webpack_require__("HK72");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_page_watchlist_page_watchlist_vue__ = __webpack_require__("UwQr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_page_privacy_policy_page_privacy_policy_vue__ = __webpack_require__("6V5V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_page_terms_and_conditions_page_terms_and_conditions_vue__ = __webpack_require__("v+Mv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_page_platform_announcements_page_platform_announcements_vue__ = __webpack_require__("AyUZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_debug_debug_vue__ = __webpack_require__("V/Y1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_page_sitemap_page_sitemap_vue__ = __webpack_require__("PVzo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_page_research_page_research_vue__ = __webpack_require__("HLCK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pages_page_leaderboards_page_leaderboards_vue__ = __webpack_require__("LnYJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_page_not_found_page_not_found_vue__ = __webpack_require__("4kpQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_pages_page_static_preview_page_static_preview_vue__ = __webpack_require__("n58p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_pages_page_story_preview_page_story_preview_vue__ = __webpack_require__("220P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_pages_page_daily_markets_details_page_daily_markets_details_vue__ = __webpack_require__("Ykf8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__account__ = __webpack_require__("Rlrl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__support__ = __webpack_require__("u0d3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__dashboard__ = __webpack_require__("0IxP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__static__ = __webpack_require__("gQ0Z");

// import homeNew from '@/components/home/home-new/home-new.vue';


















// import insight from '@/components/insight/insight.vue';







var routes = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_21__account__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__support__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_23__dashboard__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_24__static__["a" /* default */]), [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_1__components_home_home_old_home_old_vue__["a" /* default */],
  name: 'home'
  // meta: {
  //   appContentFullWidth: true,
  // },
},
// TODO change back
// {
//   path: '/',
//   component: homeNew,
//   name: 'home',
//   meta: {
//     appContentFullWidth: true,
//   },
// },
{
  path: '/trends',
  component: __WEBPACK_IMPORTED_MODULE_2__components_home_trends_trends_vue__["a" /* default */],
  name: 'trends',
  meta: {
    requiresAuth: true
  }
}, {
  path: '/research',
  component: __WEBPACK_IMPORTED_MODULE_13__components_pages_page_research_page_research_vue__["a" /* default */],
  name: 'research'
}, {
  path: '/privacy-policy',
  component: __WEBPACK_IMPORTED_MODULE_8__components_pages_page_privacy_policy_page_privacy_policy_vue__["a" /* default */],
  name: 'privacy-policy'
}, {
  path: '/terms-and-conditions',
  component: __WEBPACK_IMPORTED_MODULE_9__components_pages_page_terms_and_conditions_page_terms_and_conditions_vue__["a" /* default */],
  name: 'terms-and-conditions'
}, {
  path: '/platform-announcements',
  component: __WEBPACK_IMPORTED_MODULE_10__components_pages_page_platform_announcements_page_platform_announcements_vue__["a" /* default */],
  name: 'platform-announcements'
}, {
  path: '/markets/search',
  name: 'market-search',
  component: __WEBPACK_IMPORTED_MODULE_6__components_pages_page_search_page_search_vue__["a" /* default */]
}, {
  path: '/markets/watchlist',
  name: 'market-watchlist',
  component: __WEBPACK_IMPORTED_MODULE_7__components_pages_page_watchlist_page_watchlist_vue__["a" /* default */],
  beforeEnter: function beforeEnter(to, from, next) {
    // browse.selectedOrder etc i shared by watchlist and markets page
    __WEBPACK_IMPORTED_MODULE_20__logger__["a" /* default */].info('[WATCHLIST] Before enter setup');
    if (to.query.sortParameter) {
      __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].dispatch('browse/setTimespanFromQuery', to.query.sortParameter);
    } else {
      __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].dispatch('browse/setTimespanFromQuery', 'ALL');
    }
    if (to.query.sort) {
      __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].dispatch('browse/setOrderFromQuery', to.query.sort);
    } else {
      __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].dispatch('browse/setOrderFromQuery', 'traded');
    }
    next();
  }
}, {
  path: '/markets/detail/:marketId/:marketUrl?',
  name: 'market-details',
  component: __WEBPACK_IMPORTED_MODULE_4__components_pages_page_market_detail_page_market_detail_vue__["a" /* default */],
  props: function props(route) {
    return {
      marketId: parseInt(route.params.marketId, 10),
      showRules: !!route.params.showRules,
      prerendered: route.query.prerendered
    };
  }
}, {
  path: '/markets/:headerId?/:headerUrl?',
  name: 'market-list',
  component: __WEBPACK_IMPORTED_MODULE_3__components_pages_page_markets_page_markets_vue__["a" /* default */],
  beforeEnter: function beforeEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_20__logger__["a" /* default */].info('[MARKETS] Before enter setup');
    if (to.query.filterIds) {
      to.query.filterIds.split(',').forEach(function (i) {
        var filterId = parseInt(i, 10);
        __WEBPACK_IMPORTED_MODULE_20__logger__["a" /* default */].info('[MARKETS] filterId passed: ' + filterId);
        if (filterId) __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].dispatch('browse/addFilter', filterId);
      });
    }
    if (to.query.sortParameter) {
      __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].dispatch('browse/setTimespanFromQuery', to.query.sortParameter);
    }
    if (to.query.sort) {
      __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].dispatch('browse/setOrderFromQuery', to.query.sort);
    }
    next();
  },
  props: function props(route) {
    return {
      headerId: parseInt(route.params.headerId, 10) || 0,
      headerUrl: route.params.headerUrl
    };
  }
}, {
  path: '/stories/detail/:storyId/:storyUrl?',
  name: 'story-details',
  component: __WEBPACK_IMPORTED_MODULE_5__components_pages_page_story_detail_page_story_detail_vue__["a" /* default */],
  props: function props(route) {
    return {
      storyId: parseInt(route.params.storyId, 10)
    };
  }
},
// {
//   path: '/insight',
//   name: 'insight',
//   component: insight,
// },
// {
//   path: '/insight/:slug',
//   name: 'insight-detail',
//   component: insight,
//   props: true,
// },
{
  path: '/payment/success',
  component: __WEBPACK_IMPORTED_MODULE_3__components_pages_page_markets_page_markets_vue__["a" /* default */],
  name: 'payment-success',
  props: function props(route) {
    return {
      headerId: parseInt(route.params.headerId, 10) || 0,
      headerUrl: route.params.headerUrl,
      notificationText: 'Bitcoin Deposit Received',
      notificationLevel: 'success'
    };
  }
}, {
  path: '/payment/fail',
  component: __WEBPACK_IMPORTED_MODULE_3__components_pages_page_markets_page_markets_vue__["a" /* default */],
  name: 'payment-fail',
  props: function props(route) {
    return {
      headerId: parseInt(route.params.headerId, 10) || 0,
      headerUrl: route.params.headerUrl
    };
  }
}, {
  path: '/static-page-preview',
  component: __WEBPACK_IMPORTED_MODULE_16__components_pages_page_static_preview_page_static_preview_vue__["a" /* default */],
  name: 'static-page-preview',
  beforeEnter: function beforeEnter(to, from, next) {
    if (!to.query.previewId) {
      next({
        name: 'home'
      });
    } else {
      next();
    }
  },
  props: function props(route) {
    return {
      previewId: route.query.previewId
    };
  }
}, {
  path: '/story-full-preview',
  component: __WEBPACK_IMPORTED_MODULE_17__components_pages_page_story_preview_page_story_preview_vue__["a" /* default */],
  name: 'story-full-preview',
  beforeEnter: function beforeEnter(to, from, next) {
    if (!to.query.previewId) {
      next({
        name: 'home'
      });
    } else {
      next();
    }
  },
  props: function props(route) {
    return {
      previewId: route.query.previewId
    };
  }
}, {
  path: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].MONDAY.path,
  component: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["b" /* default */],
  name: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].MONDAY.id,
  props: function props() {
    return {
      pageId: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].MONDAY.pageId
    };
  }
}, {
  path: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].TUESDAY.path,
  component: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["b" /* default */],
  name: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].TUESDAY.id,
  props: function props() {
    return {
      pageId: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].TUESDAY.pageId
    };
  }
}, {
  path: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].WEDNESDAY.path,
  component: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["b" /* default */],
  name: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].WEDNESDAY.id,
  props: function props() {
    return {
      pageId: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].WEDNESDAY.pageId
    };
  }
}, {
  path: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].THURSDAY.path,
  component: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["b" /* default */],
  name: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].THURSDAY.id,
  props: function props() {
    return {
      pageId: __WEBPACK_IMPORTED_MODULE_18__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].THURSDAY.pageId
    };
  }
}, {
  path: '/sitemap',
  component: __WEBPACK_IMPORTED_MODULE_12__components_pages_page_sitemap_page_sitemap_vue__["a" /* default */],
  name: 'sitemap'
}, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_15__components_pages_page_not_found_page_not_found_vue__["a" /* default */],
  name: 'not-found'
}]);

if (false) {
  routes.push({
    path: '/debug',
    component: pageDebug,
    name: 'debug'
  });
}

if (false) {
  routes.push({
    path: '/leaderboards',
    component: pageLeaderboards,
    name: 'leaderboards',
    beforeEnter: function beforeEnter(to, from, next) {
      log.info('[LEADERBOARDS] Before enter setup');
      if (typeof to.query.leaderboardId !== 'undefined') {
        log.info('[LEADERBOARDS] settings leaderboardId: ' + to.query.leaderboardId);
        store.dispatch('leaderboards/setSelectedLeaderboardId', parseInt(to.query.leaderboardId, 10));
      }
      if (to.query.dateRange) {
        log.info('[LEADERBOARDS] settings dateRange: ' + to.query.dateRange);
        store.dispatch('leaderboards/setLeaderboardsDateRange', parseInt(to.query.dateRange, 10));
      }
      next();
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "Ke/w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__("H/Zg");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    faqs: null,
    sitemap: null
  },
  mutations: {
    setFaqs: function setFaqs(state, payload) {
      state.faqs = payload;
    },
    setSitemap: function setSitemap(state, payload) {
      state.sitemap = payload;
    }
  },
  actions: {
    getFaqs: function getFaqs(_ref) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].about.getFaqs().then(function (response) {
        commit('setFaqs', response.data);
        return response.data;
      });
    },
    getSitemap: function getSitemap(_ref2) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].about.getSitemap().then(function (response) {
        commit('setSitemap', response.data);
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "KfAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DAILY_PAGES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__ = __webpack_require__("tQfv");





var DAILY_PAGES = {
  MONDAY: {
    id: 'market-focus',
    path: '/market-focus',
    pageId: 'DailyMarketsMonday',
    title: 'Market Focus'
  },
  TUESDAY: {
    id: 'daily-market-updates',
    path: '/daily-market-updates',
    pageId: 'DailyMarketsTuesday',
    title: 'Daily Market Updates'
  },
  WEDNESDAY: {
    id: 'daily-markets-wednesday',
    path: '/daily-markets-wednesday',
    pageId: 'DailyMarketsWednesday',
    title: 'Daily Markets Wednesday'
  },
  THURSDAY: {
    id: 'daily-markets-thursday',
    path: '/daily-markets-thursday',
    pageId: 'DailyMarketsThursday',
    title: 'Daily Markets Thursday'
  }
};

/* harmony default export */ __webpack_exports__["b"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__["a" /* default */]],
  props: {
    pageId: {
      type: String,
      required: true
    }
  },
  metaInfo: function metaInfo() {
    var _this = this;

    var info = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(DAILY_PAGES);
    var pageData = info.find(function (i) {
      return i.pageId === _this.pageId;
    });

    return {
      title: (pageData || {}).title || 'Daily Markets'
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  created: function created() {
    var _this2 = this;

    this.getStaticPageFull(this.pageId).then(function (data) {
      _this2.installDynamicControls({ data: data });
    });
  }
});

/***/ }),

/***/ "KmKt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KsCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_list_v2_embed_js__ = __webpack_require__("5yVZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_014b46e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_list_v2_embed_vue__ = __webpack_require__("icPb");
function injectStyle (ssrContext) {
  __webpack_require__("+k7l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_list_v2_embed_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_014b46e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_list_v2_embed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ktaw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_modal_js__ = __webpack_require__("Sxoj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b44d910a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_modal_vue__ = __webpack_require__("q6iB");
function injectStyle (ssrContext) {
  __webpack_require__("co1A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_modal_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b44d910a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KvDS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_top_comments_js__ = __webpack_require__("7Wq7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64cdb822_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_top_comments_vue__ = __webpack_require__("jl5J");
function injectStyle (ssrContext) {
  __webpack_require__("x8VV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_top_comments_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64cdb822_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_top_comments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L/Rx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L09H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep__ = __webpack_require__("kvU2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_notifications_proxy__ = __webpack_require__("a0yF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_notifications__ = __webpack_require__("tjp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__("oiih");





 /* eslint-disable max-len,no-unused-vars,arrow-body-style,no-restricted-syntax */






var MAX_RELATED_MARKETS = 3;
var MARKET_DEBOUNCE_INTERVAL = 750;
var debounceGetMarket = __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(function (dispatch, marketId) {
  dispatch('getMarket', { marketId: marketId, skipCache: true });
}, MARKET_DEBOUNCE_INTERVAL);

var ITEMS_PER_HISTORY_PAGE = 10;
var DEFAULT_HISTORY = {
  data: null,
  marketId: -1,
  totalCount: -1,
  canLoadMore: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    marketIsEngineBusy: false,
    marketIsEngineBusyMessage: null,
    marketLoadError: false,
    market: null,
    contracts: [],
    contract: null,
    history: DEFAULT_HISTORY,
    isRulesOpen: false,
    related: [],
    chartTimeline: null,
    chartType: null,
    marketContractsStats: [],
    mapStateData: {},
    mapStateDataSenate: {},
    mapOverviewData: [],
    mapOverviewDataSenate: [],
    marketMapTooltipVisible: false
  },
  getters: {
    getMarketHistoryData: function getMarketHistoryData(state) {
      var historyData = state.history.data;
      return historyData === null ? [] : historyData;
    }
  },
  mutations: {
    setMarket: function setMarket(state, payload) {
      state.market = payload;
    },
    setContract: function setContract(state, payload) {
      state.contract = payload;
    },
    setContracts: function setContracts(state, payload) {
      state.contracts = payload;
    },
    setMarketLoadError: function setMarketLoadError(state, payload) {
      state.marketLoadError = payload;
    },
    setMarketEngineBusyMessage: function setMarketEngineBusyMessage(state, _ref) {
      var isEngineBusy = _ref.isEngineBusy,
          isEngineBusyMessage = _ref.isEngineBusyMessage;

      state.marketIsEngineBusy = isEngineBusy;
      state.marketIsEngineBusyMessage = isEngineBusyMessage;
    },
    updateMarketFromNotification: function updateMarketFromNotification(state, data) {
      state.market = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_notifications__["a" /* updateMarket */])(state.market, data);
    },
    updateContractFromNotification: function updateContractFromNotification(state, data) {
      if (state.market !== null && typeof state.market.contracts !== 'undefined') {
        // CONTRACTS SORT
        // contracts.sort((prev, next) => {
        //   if (prev.lastTradePrice < next.lastTradePrice) {
        //     return 1;
        //   } else if (prev.lastTradePrice > next.lastTradePrice) {
        //     return -1;
        //   }
        //   return 0;
        // });
        state.market = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_notifications__["b" /* updateMarketContracts */])(state.market, data);
      }
      if (state.contracts !== null) {
        // CONTRACTS SORT
        // state.contracts.sort((prev, next) => {
        //   if (prev.lastTradePrice < next.lastTradePrice) {
        //     return 1;
        //   } else if (prev.lastTradePrice > next.lastTradePrice) {
        //     return -1;
        //   }
        //   return 0;
        // });
        var contracts = state.contracts.slice();
        state.contracts = contracts.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }
      if (state.contract !== null) {
        state.contract = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_notifications__["d" /* updateContract */])(state.contract, data);
      }
    },
    updateMapOverviewDataFromNotification: function updateMapOverviewDataFromNotification(state, data) {
      if (state.mapOverviewData.length > 0) {
        var mapOverviewData = state.mapOverviewData.slice();
        state.mapOverviewData = mapOverviewData.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }

      var mapStateData = __WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep___default()(state.mapStateData);

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(mapStateData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var stateCode = _step.value;

          mapStateData[stateCode] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_notifications__["b" /* updateMarketContracts */])(mapStateData[stateCode], data);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      state.mapStateData = mapStateData;
    },
    updateMapOverviewDataSenateFromNotification: function updateMapOverviewDataSenateFromNotification(state, data) {
      if (state.mapOverviewDataSenate.length > 0) {
        var mapOverviewData = state.mapOverviewDataSenate.slice();
        state.mapOverviewDataSenate = mapOverviewData.map(function (contract) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_notifications__["d" /* updateContract */])(contract, data);
        });
      }

      var mapStateData = __WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep___default()(state.mapStateDataSenate);

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(mapStateData)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var stateCode = _step2.value;

          mapStateData[stateCode] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_notifications__["b" /* updateMarketContracts */])(mapStateData[stateCode], data);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      state.mapStateDataSenate = mapStateData;
    },
    resetHistory: function resetHistory(state) {
      state.history = DEFAULT_HISTORY;
    },
    updateHistory: function updateHistory(state, payload) {
      state.history = {
        data: payload.data.historyList,
        marketId: payload.marketId,
        totalCount: payload.data.totalCount,
        canLoadMore: payload.data.totalCount > payload.data.historyList.length
      };
    },
    setOpenRules: function setOpenRules(state, payload) {
      state.isRulesOpen = payload;
    },
    setRelatedMarkets: function setRelatedMarkets(state, payload) {
      state.related = payload;
    },
    clearRelatedMarkets: function clearRelatedMarkets(state) {
      state.related = [];
    },
    updateRelatedMarketFromNotification: function updateRelatedMarketFromNotification(state, data) {
      if (state.related.length > 0) {
        state.related = state.related.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_notifications__["a" /* updateMarket */])(market, data);
        });
      }
    },
    updateRelatedContractFromNotification: function updateRelatedContractFromNotification(state, data) {
      if (state.related.length > 0) {
        state.related = state.related.map(function (market) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_notifications__["b" /* updateMarketContracts */])(market, data);
        });
      }
    },
    setChartTimeline: function setChartTimeline(state, data) {
      state.chartTimeline = data;
    },
    setChartType: function setChartType(state, data) {
      state.chartType = data;
    },
    setMarketContractsStats: function setMarketContractsStats(state, data) {
      state.marketContractsStats = data;
    },
    clearMarketContractsStats: function clearMarketContractsStats(state) {
      state.marketContractsStats = [];
    },
    setMapOverviewData: function setMapOverviewData(state, data) {
      state.mapOverviewData = data;
    },
    setMapOverviewDataSenate: function setMapOverviewDataSenate(state, data) {
      state.mapOverviewDataSenate = data;
    },
    setMapStateData: function setMapStateData(state, data) {
      state.mapStateData = data;
    },
    setMapStateDataSenate: function setMapStateDataSenate(state, data) {
      state.mapStateDataSenate = data;
    },
    setMarketMapTooltipVisible: function setMarketMapTooltipVisible(state, flag) {
      state.marketMapTooltipVisible = flag;
    }
  },
  actions: {
    clearMarket: function clearMarket(_ref2) {
      var commit = _ref2.commit;

      commit('setMarket', {});
      commit('setContracts', []);
    },
    clearMarketEngineBusyMessage: function clearMarketEngineBusyMessage(_ref3) {
      var commit = _ref3.commit;

      commit('setMarketEngineBusyMessage', {
        isEngineBusy: false,
        isEngineBusyMessage: null
      });
    },
    getMarket: function getMarket(_ref4, _ref5) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch,
          state = _ref4.state;
      var marketId = _ref5.marketId,
          _ref5$commentThreadId = _ref5.commentThreadId,
          commentThreadId = _ref5$commentThreadId === undefined ? '' : _ref5$commentThreadId,
          _ref5$skipCache = _ref5.skipCache,
          skipCache = _ref5$skipCache === undefined ? false : _ref5$skipCache,
          _ref5$modifyState = _ref5.modifyState,
          modifyState = _ref5$modifyState === undefined ? true : _ref5$modifyState;

      commit('setMarketLoadError', false);
      if (!skipCache && state.market !== null && state.market.marketId === marketId) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(state.market);
      }
      var marketData = {};
      return __WEBPACK_IMPORTED_MODULE_8__services_api__["a" /* default */].market.getMarket(marketId, commentThreadId).then(function (response) {
        marketData = response.data;
      }).then(function () {
        return __WEBPACK_IMPORTED_MODULE_8__services_api__["a" /* default */].market.getMarketContracts(marketId);
      }).then(function (response) {
        marketData.contracts = response.data;
        if (modifyState) {
          commit('setContracts', marketData.contracts);
          commit('setMarket', marketData);
        }
        return marketData;
      }).catch(function () {
        if (modifyState) {
          commit('setMarketLoadError', true);
          dispatch('clearMarket');
        }
      });
    },
    getMarketRules: function getMarketRules(_ref6, marketId) {
      var commit = _ref6.commit;

      return __WEBPACK_IMPORTED_MODULE_8__services_api__["a" /* default */].market.getMarketRules(marketId).then(function (response) {
        return response.data;
      });
    },
    getContract: function getContract(_ref7, contractId) {
      var commit = _ref7.commit,
          state = _ref7.state;

      if (state.contract !== null && state.contract.contractId === contractId) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(state.contract);
      }
      if (state.contracts !== null) {
        var contract = state.contracts.find(function (c) {
          return c.contractId === contractId;
        });
        if (typeof contract !== 'undefined') {
          commit('setContract', contract);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(contract);
        }
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
    },
    getMarketContractsStats: function getMarketContractsStats(_ref8, marketId) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;

      return __WEBPACK_IMPORTED_MODULE_8__services_api__["a" /* default */].market.getMarketContractsStats(marketId).then(function (response) {
        commit('setMarketContractsStats', response.data);
        return response.data;
      }).catch(function () {
        dispatch('clearMarketContractsStats');
      });
    },
    clearMarketContractsStats: function clearMarketContractsStats(_ref9) {
      var commit = _ref9.commit;

      commit('clearMarketContractsStats');
    },
    resetHistory: function resetHistory(_ref10) {
      var commit = _ref10.commit;

      commit('resetHistory');
    },
    getMarketHistory: function getMarketHistory(_ref11, marketId) {
      var state = _ref11.state,
          commit = _ref11.commit;

      var history = state.history;
      if (history !== null && history.marketId === marketId) {
        return history.data;
      }
      // on new market but in history old data
      commit('resetHistory');
      return __WEBPACK_IMPORTED_MODULE_8__services_api__["a" /* default */].profile.getTradeHistory(ITEMS_PER_HISTORY_PAGE, 1, marketId).then(function (response) {
        commit('updateHistory', {
          data: response.data,
          marketId: marketId
        });
        return response.data;
      });
    },
    getRelatedMarkets: function getRelatedMarkets(_ref12, marketId) {
      var commit = _ref12.commit;

      return __WEBPACK_IMPORTED_MODULE_8__services_api__["a" /* default */].market.getMarketRelated(marketId).then(function (response) {
        var data = response.data.slice(0, MAX_RELATED_MARKETS);
        commit('setRelatedMarkets', data);
        return data;
      });
    },
    clearRelatedMarkets: function clearRelatedMarkets(_ref13) {
      var commit = _ref13.commit;

      commit('clearRelatedMarkets');
    },
    updateMarketFromNotification: function updateMarketFromNotification(_ref14, payload) {
      var commit = _ref14.commit,
          dispatch = _ref14.dispatch,
          state = _ref14.state;

      var marketId = payload.MarketId;
      if (state.market !== null && state.market.marketId === marketId) {
        commit('updateMarketFromNotification', payload);
        // debounceGetMarket(dispatch, marketId);
      }
    },
    setMarketEngineBusyMessage: function setMarketEngineBusyMessage(_ref15, payload) {
      var commit = _ref15.commit;

      commit('setMarketEngineBusyMessage', payload);
    },
    updateRelatedMarketFromNotification: function updateRelatedMarketFromNotification(_ref16, payload) {
      var commit = _ref16.commit;

      commit('updateRelatedMarketFromNotification', payload);
    },
    updateRelatedContractFromNotification: function updateRelatedContractFromNotification(_ref17, payload) {
      var commit = _ref17.commit;

      commit('updateRelatedContractFromNotification', payload);
    },
    updateContractFromNotification: function updateContractFromNotification(_ref18, payload) {
      var commit = _ref18.commit;

      commit('updateContractFromNotification', payload);
    },
    updateMapOverviewDataFromNotification: function updateMapOverviewDataFromNotification(_ref19, payload) {
      var commit = _ref19.commit;

      commit('updateMapOverviewDataFromNotification', payload);
    },
    updateMapOverviewDataSenateFromNotification: function updateMapOverviewDataSenateFromNotification(_ref20, payload) {
      var commit = _ref20.commit;

      commit('updateMapOverviewDataSenateFromNotification', payload);
    },
    openRules: function openRules(_ref21) {
      var commit = _ref21.commit;
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      commit('setOpenRules', payload);
    },
    setMarket: function setMarket(_ref22, market) {
      var commit = _ref22.commit;

      commit('setMarket', market);
    },
    setContracts: function setContracts(_ref23, contracts) {
      var commit = _ref23.commit;

      commit('setContracts', contracts);
    },
    setMarketLoadError: function setMarketLoadError(_ref24, flag) {
      var commit = _ref24.commit;

      commit('setMarketLoadError', flag);
    },
    setChartTimeline: function setChartTimeline(_ref25, payload) {
      var commit = _ref25.commit;

      commit('setChartTimeline', payload);
    },
    setChartType: function setChartType(_ref26, payload) {
      var commit = _ref26.commit;

      commit('setChartType', payload);
    },
    getMapOverviewData: function getMapOverviewData(_ref27) {
      var commit = _ref27.commit;

      return __WEBPACK_IMPORTED_MODULE_8__services_api__["a" /* default */].map.getContracts().then(function (response) {
        commit('setMapOverviewData', response.data);
        return response.data;
      });
    },
    getMapStateData: function getMapStateData(_ref28) {
      var commit = _ref28.commit;

      return __WEBPACK_IMPORTED_MODULE_8__services_api__["a" /* default */].map.getStateData().then(function (response) {
        var data = (response.data || []).reduce(function (obj, item) {
          var stateCode = item.marketName.split(' ')[4];
          var stateName = __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* default */].statesCodeToNameMap[stateCode];
          var stateVotes = __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* default */].statesCodeToElectoralVotesMap[stateCode];
          obj[stateCode] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
            stateVotes: stateVotes,
            stateCode: stateCode,
            stateName: stateName
          });
          return obj;
        }, {});
        commit('setMapStateData', data);
        return data;
      });
    },
    getMapOverviewDataSenate: function getMapOverviewDataSenate(_ref29) {
      var commit = _ref29.commit;

      return __WEBPACK_IMPORTED_MODULE_8__services_api__["a" /* default */].map.getContractsSenate().then(function (response) {
        commit('setMapOverviewDataSenate', response.data);
        return response.data;
      });
    },
    getMapStateDataSenate: function getMapStateDataSenate(_ref30) {
      var commit = _ref30.commit;

      return __WEBPACK_IMPORTED_MODULE_8__services_api__["a" /* default */].map.getStateDataSenate().then(function (response) {
        var data = (response.data || []).reduce(function (obj, item) {
          var stateCode = item.marketName.match(/\b[A-Z]{2}\b/)[0];
          var stateName = __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* default */].statesCodeToNameMap[stateCode];
          var stateVotes = __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* default */].statesCodeToElectoralVotesMap[stateCode];
          var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
            stateVotes: stateVotes,
            stateCode: stateCode,
            stateName: stateName
          });
          // if (stateCode === 'GA') {
          //   if (item.marketId === 6651) {
          //     obj[stateCode] = result;
          //   } else {
          //     obj.GA2 = result;
          //   }
          // }
          obj[stateCode] = result;
          return obj;
        }, {});
        commit('setMapStateDataSenate', data);
        return data;
      });
    },
    setMarketMapTooltipVisible: function setMarketMapTooltipVisible(_ref31, flag) {
      var commit = _ref31.commit;

      commit('setMarketMapTooltipVisible', flag);
    },
    getCommentThread: function getCommentThread(_ref32, _ref33) {
      var commit = _ref32.commit;
      var marketId = _ref33.marketId,
          threadId = _ref33.threadId;

      return __WEBPACK_IMPORTED_MODULE_8__services_api__["a" /* default */].market.getCommentThread({ marketId: marketId, threadId: threadId }).then(function (response) {
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "L2dZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-key-stats"},[_c('div',{staticClass:"market-key-stats__title"},[_vm._v(_vm._s(_vm.obj.title))]),_vm._v(" "),_c('div',{staticClass:"market-key-stats__content"},_vm._l((_vm.items),function(elem,index){return _c('market-key-stats-element',{key:index,attrs:{"widget":elem}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L3N8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getFaqs: function getFaqs() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/about/faqs');
  },
  getSitemap: function getSitemap() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/About/sitemap');
  }
});

/***/ }),

/***/ "L6SS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-details"},[(_vm.isLayoutMobile)?_c('content-header',{attrs:{"title":_vm.title}}):_vm._e(),_vm._v(" "),_c('div',{class:_vm.gridRowModifier},[(!_vm.isLayoutMobile)?_c('div',{staticClass:"column large-4 account-details__sticky"},[_c('profile')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column large-8 small-12"},[(!_vm.isLayoutMobile)?_c('div',{staticClass:"account-details__header"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.isMobileAddressUpdate)?_c('account-address-update'):_vm._e(),_vm._v(" "),(_vm.isMobileDetailsUpdate)?_c('account-details-update'):_vm._e(),_vm._v(" "),(_vm.isMobilePasswordChange)?_c('account-update-password'):_vm._e(),_vm._v(" "),(_vm.isMobilePasswordSet)?_c('account-set-password'):_vm._e(),_vm._v(" "),(_vm.isDetailsShown)?_c('div',{staticClass:"account-details__content"},[(!_vm.isComponentReady)?_c('account-form-loader',{attrs:{"theme":"details"}}):[_c('h4',{staticClass:"content-header__section-title content-header__section-title--margin-top"},[_vm._v("Personal Details")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-group"},[_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\r\n                First Name\r\n              ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\r\n                "+_vm._s(_vm.userData.firstName)+"\r\n              ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\r\n                Last Name\r\n              ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\r\n                "+_vm._s(_vm.userData.lastName)+"\r\n              ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\r\n                Username\r\n              ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_c('div',[_vm._v(_vm._s(_vm.userData.userName))]),_vm._v(" "),_c('router-link',{staticClass:"content-header__section-alt-link",attrs:{"to":{name: 'details-update'}}},[_vm._v("\r\n                  Edit\r\n                 ")])],1)]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\r\n                Email\r\n              ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\r\n                "+_vm._s(_vm.userData.email)+"\r\n              ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\r\n                Password\r\n              ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_c('div',[_vm._v("*********")]),_vm._v(" "),(_vm.hasLocalPassword)?_c('router-link',{staticClass:"content-header__section-alt-link content-header__section-alt-link--small-margin",attrs:{"to":{name: 'password-update'}}},[_vm._v("\r\n                  Edit\r\n                 ")]):_vm._e(),_vm._v(" "),(!_vm.hasLocalPassword)?_c('router-link',{staticClass:"content-header__section-alt-link content-header__section-alt-link--small-margin",attrs:{"to":{name: 'password-set'}}},[_vm._v("\r\n                  Set\r\n                ")]):_vm._e()],1)])]),_vm._v(" "),_c('h4',{staticClass:"content-header__section-title content-header__section-title--margin-top"},[_vm._v("Identity Verification")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-group"},[_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_c('div',{staticClass:"content-header__section-text"},[_vm._v("Verification Status")]),_vm._v(" "),(_vm.showVerificationStatusInfo)?_c('notification-icon',{staticClass:"content-header__section-icon",on:{"showPopup":_vm.onShowVerificationInfo}}):_vm._e()],1),_vm._v(" "),_c('div',{class:_vm.contentHeaderButtonSectionModifiers},[_c('div',[_vm._v(_vm._s(_vm.verificationStatusDisplay))]),_vm._v(" "),(!_vm.verificationStatusIs(_vm.STATUS_ENHANCED))?[(_vm.verificationStatusIs(_vm.STATUS_NOT_VERIFIED))?_c('button',{staticClass:"content-header__section-alt-button",on:{"click":_vm.onVerifyIdentity}},[_c('div',[_vm._v("Verify")])]):_vm._e(),_vm._v(" "),(_vm.verificationStatusIs(_vm.STATUS_BASIC))?_c('button',{staticClass:"content-header__section-alt-button",on:{"click":_vm.onUploadDocuments}},[_c('div',[_vm._v("Upgrade")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt-button-icon"})]):_vm._e()]:_vm._e()],2)])]),_vm._v(" "),_c('h4',{staticClass:"content-header__section-title content-header__section-title--margin-top"},[_vm._v("Contact Details")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-group"},[_c('div',{staticClass:"content-header__section-alt content-header__section-alt--full-height"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\r\n                Address\r\n              ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right text-right"},[_c('div',[_vm._v("\r\n                  "+_vm._s(_vm.userData.address)),_c('br'),_vm._v("\r\n                  "+_vm._s(_vm.userData.city)),_c('br'),_vm._v("\r\n                  "+_vm._s(_vm.userData.postalCode)+"\r\n                ")]),_vm._v(" "),(!_vm.isUpdateAddressDisabled)?_c('router-link',{staticClass:"content-header__section-alt-link",attrs:{"to":{name: 'address-update'}}},[_vm._v("\r\n                  Edit\r\n                 ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt"},[_c('div',{staticClass:"content-header__section-alt--left"},[_vm._v("\r\n                Country\r\n              ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right"},[_vm._v("\r\n                "+_vm._s(_vm.userData.countryName)+"\r\n              ")])])]),_vm._v(" "),_c('h4',{staticClass:"account-details__profile-title"},[_c('span',{staticClass:"account-details__profile-title-text"},[_vm._v("Profile")]),_vm._v(" "),_c('div',{staticClass:"account-details__profile-title-icon",on:{"click":function($event){$event.stopPropagation();return _vm.onInfoClick($event)}}})]),_vm._v(" "),_c('div',{staticClass:"content-header__section-group"},[_c('div',{staticClass:"content-header__section-alt content-header__section-alt--full-height content-header__section-alt--no-border"},[_c('div',{staticClass:"content-header__section-alt--left-short"},[_c('div',[_vm._v("\r\n                  College Affiliation\r\n                ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section-alt--right text-right"},[(_vm.isUCAffilSet === false)?_c('div',[_vm._v("\r\n                  Not Affiliated\r\n                ")]):(_vm.userAffiliations.length === 0)?_c('div',[_vm._v("\r\n                  No Affiliations Specified\r\n                ")]):(_vm.userAffiliations.length > 0)?_c('div',_vm._l((_vm.userAffiliations),function(item){return _c('div',[_vm._v("\r\n                    "+_vm._s(item.name)),(item.isPendingApproval)?_c('span',[_vm._v(" (Pending)")]):_vm._e(),(!item.isPublic)?_c('span',[_vm._v(" *")]):_vm._e()])}),0):_vm._e(),_vm._v(" "),_c('a',{staticClass:"content-header__section-alt-link",on:{"click":_vm.showAffiliationsPopup}},[_vm._v("\r\n                  Edit\r\n                 ")])])])])]],2):_vm._e()],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"large-6 column"},[_vm._v("Account Details")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L6pp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "L8Dv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_contentLoader__ = __webpack_require__("P71F");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_contentLoader__["a" /* default */]],
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      items: [],
      swiperOptions: {
        loop: false,
        autoplay: 5000,
        direction: 'horizontal',
        pagination: '.hero-unit-slider__pagination',
        paginationClickable: true
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isShutdownModeOn']), {
    classModifiers: function classModifiers() {
      return {
        'hero-unit-slider': true,
        'hero-unit-slider--shutdown': this.isShutdownModeOn
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getCarousel']), {
    getBannerUrl: function getBannerUrl(banner) {
      if (banner.carouselData.carouselItemButton.url) {
        return banner.carouselData.carouselItemButton.url;
      } else if (banner.carouselData.marketId) {
        return { name: 'market-details', params: { marketId: banner.carouselData.marketId } };
      }
      return {};
    },
    isUrlExternal: function isUrlExternal(banner) {
      var url = banner.carouselData.carouselItemButton.url || '';
      return url.startsWith('http');
    },
    bannerImageStyleModifiers: function bannerImageStyleModifiers(url) {
      if (!url) return {};
      return {
        'background-image': 'url(\'' + url + '\')'
      };
    },
    buttonStyleModifiers: function buttonStyleModifiers(button) {
      var styles = {};
      if (button.backgroundColor) {
        styles.backgroundColor = button.backgroundColor;
        styles.borderColor = button.backgroundColor;
      }
      return styles;
    }
  }),
  created: function created() {
    var _this = this;

    this.getCarousel().then(function (data) {
      _this.items = data;
      _this.isComponentReady = _this.items.length > 0;
    });
  }
});

/***/ }),

/***/ "LBfO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-item-trade-confirmed"},[_c('div',{staticClass:"notification-item-trade-confirmed__content"},[_c('div',{staticClass:"notification-item-trade-confirmed__container"},[_c('div',{staticClass:"notification-item-trade-confirmed__icon"},[_c('div',{staticClass:"notification-item-trade-confirmed__tick"},[(_vm.isProcessedOrMatched)?_c('img',{attrs:{"src":__webpack_require__("uDSN")}}):_c('img',{attrs:{"src":__webpack_require__("U+El")}})])]),_vm._v(" "),_c('h4',{staticClass:"notification-item-trade-confirmed__title"},[_vm._v(_vm._s(_vm.offerStatusLongText))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.closeButton),expression:"closeButton"}],staticClass:"notification-item-trade-confirmed__close",on:{"click":_vm.onClose}})]),_vm._v(" "),_c('div',{staticClass:"notification-item-trade-confirmed__container notification-item-trade-confirmed__container--simple"},[_c('div',{staticClass:"notification-item-trade-confirmed__market"},[_vm._v("\n        "+_vm._s(_vm.marketName)+"\n      ")])]),_vm._v(" "),(_vm.showHistory)?_c('div',_vm._l((_vm.history),function(stock){return _c('div',{staticClass:"row notification-item-trade-confirmed__container notification-item-trade-confirmed__container--simple"},[_c('div',{staticClass:"notification-item-trade-confirmed__info"},[_c('div',[_vm._v("\n            "+_vm._s(_vm.soldOrBoughtText(stock.TradeType))+"\n            "),_c('span',{class:_vm.tradeTypeClassModifier(stock.TradeType)},[_vm._v(_vm._s(stock.Quantity))]),_vm._v(" "),(!_vm.isMarketSingle)?_c('span',{staticClass:"notification-item-trade-confirmed__contract"},[_vm._v("\n              in "+_vm._s(_vm.contractName)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"notification-item-trade-confirmed__price"},[_c('div',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(stock.PricePerShare),expression:"stock.PricePerShare",modifiers:{"cents":true}}],staticClass:"notification-item-trade-confirmed__min-price"})])])])}),0):_vm._e(),_vm._v(" "),(_vm.showToggle)?_c('div',{staticClass:"notification-item-trade-confirmed__container notification-item-trade-confirmed__container--simple"},[_c('div',{staticClass:"notification-item-trade-confirmed__toggle",on:{"click":_vm.onToggle}},[(_vm.advanced)?[_vm._v("Hide details")]:[_vm._v("Show details")]],2)]):_vm._e(),_vm._v(" "),(_vm.showCashFooter)?_c('div',{staticClass:"notification-item-trade-confirmed__container notification-item-trade-confirmed__container--footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6 text-left"},[(_vm.showProfitLoss)?_c('div',[_vm._v("\n            "+_vm._s(_vm.profitOrLossText)+": "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.profit),expression:"profit",modifiers:{"fixed3":true}}]})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column small-6 text-right"},[(_vm.showFees)?_c('div',[_vm._v("\n            Fees: "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.fee),expression:"fee",modifiers:{"fixed3":true}}]})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6 text-left"},[(_vm.showRisk)?_c('div',[_vm._v("\n            Risk Adj.: "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.risk),expression:"risk",modifiers:{"fixed3":true}}]})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column small-6 text-right"},[_c('div',[_c('strong',[_c('plus-minus-sign'),_vm._v(" Cash: "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.fixed3",value:(_vm.cost),expression:"cost",modifiers:{"fixed3":true}}]})],1)])])])]):_vm._e(),_vm._v(" "),(_vm.remainingQuantity > 0)?_c('div',{class:_vm.bottomContainerClassModifiers},[(_vm.isProcessedOrMatched)?_c('div',{staticClass:"notification-item-trade-confirmed__icon"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"notification-item-trade-confirmed__info"},[_c('div',[_vm._v("\n          "+_vm._s(_vm.soldOrBoughtTextOffer())+"\n          "),_c('span',{class:_vm.tradeTypeClassModifier(_vm.offerType)},[_vm._v(_vm._s(_vm.remainingQuantity))]),_vm._v(" "),(!_vm.isMarketSingle)?_c('span',{staticClass:"notification-item-trade-confirmed__contract"},[_vm._v("\n            in "+_vm._s(_vm.contractName)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"notification-item-trade-confirmed__price"},[_c('div',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.minPrice),expression:"minPrice",modifiers:{"cents":true}}],staticClass:"notification-item-trade-confirmed__min-price"})])])]):_vm._e()]),_vm._v(" "),(_vm.showFooter)?_c('div',{staticClass:"notification-item-trade-confirmed__footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12 text-right notification-item-trade-confirmed__share"},[_c('span',{staticClass:"notification-item-trade-confirmed__share-text"},[_vm._v("\n          Share this trade with your friends\n        ")]),_vm._v(" "),_c('div',{staticClass:"notification-item-trade-confirmed__share-buttons"},[_c('a',{staticClass:"notification-item-trade-confirmed__share-link",attrs:{"href":_vm.mailto},on:{"click":_vm.onEmailShare}},[_c('img',{attrs:{"src":__webpack_require__("BQl6")}})]),_vm._v(" "),_c('a',{staticClass:"notification-item-trade-confirmed__share-link",on:{"click":function($event){$event.preventDefault();return _vm.onFacebookShare($event)}}},[_c('img',{attrs:{"src":__webpack_require__("QPgH")}})]),_vm._v(" "),_c('a',{staticClass:"notification-item-trade-confirmed__share-link",on:{"click":function($event){$event.preventDefault();return _vm.onTwitterShare($event)}}},[_c('img',{attrs:{"src":__webpack_require__("OtFn")}})])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-item-trade-confirmed__tick"},[_c('img',{attrs:{"src":__webpack_require__("U+El")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LHdv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_forms_checkbox_checkbox_vue__ = __webpack_require__("vXhB");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    validation: {
      type: Object,
      required: true
    }
  },
  components: {
    formCheckbox: __WEBPACK_IMPORTED_MODULE_0__components_forms_checkbox_checkbox_vue__["a" /* default */]
  },
  computed: {
    hasOneUpperLower: function hasOneUpperLower() {
      return this.validation.hasOneLower && this.validation.hasOneUpper;
    }
  }
});

/***/ }),

/***/ "LKuo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboards-levels"},[_c('div',{staticClass:"leaderboards-levels__header"},[_vm._v("\n    Leaderboards\n  ")]),_vm._v(" "),_vm._t("default"),_vm._v(" "),(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader"},_vm._l((_vm.loaderItems(7)),function(item){return _c('div',{staticClass:"content-loader-item"},[_c('leaderboards-info-loader')],1)}),0):[(_vm.leaderboards.length > 0)?_c('div',{staticClass:"leaderboards-levels__items"},_vm._l((_vm.leaderboards),function(item){return _c('div',{key:item.leaderBoardId,class:_vm.itemClassModifiers(item),on:{"click":function($event){return _vm.onItemClick(item)}}},[_vm._v("\n        "+_vm._s(_vm._f("pluralize")(item.leaderBoardName))+"\n      ")])}),0):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LTXn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-detail-charts"},[_c('charts-timeline',{attrs:{"market":_vm.market,"chartOptions":_vm.chartOptions},on:{"timelineChange":_vm.onTimelineChange,"typeChange":_vm.onTypeChange}}),_vm._v(" "),(!_vm.showStats)?[(_vm.title)?_c('div',{staticClass:"market-detail-charts__title",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_c('charts-header',{attrs:{"chartOptions":_vm.chartOptions}}),_vm._v(" "),_c('charts-container',{attrs:{"market":_vm.market,"timeline":_vm.chartTimeline,"chartOptions":_vm.chartOptions,"chartType":_vm.chartType,"chartData":_vm.filteredChartData,"chartDataLoaded":_vm.chartDataLoaded}}),_vm._v(" "),(_vm.caption)?_c('div',{staticClass:"market-detail-charts__caption",domProps:{"innerHTML":_vm._s(_vm.caption)}}):_vm._e(),_vm._v(" "),(_vm.showChartsTable)?_c('charts-table',{attrs:{"chartOptions":_vm.chartOptions,"contracts":_vm.chartContracts},on:{"toggleItem":_vm.onContractToggle}}):_vm._e(),_vm._v(" "),(_vm.showChartsKey)?_c('div',{staticClass:"market-detail-charts__key",on:{"click":_vm.onShowKey}},[_vm._v("\n      Show key\n    ")]):_vm._e()]:[_c('div',{staticClass:"market-detail-charts__stats-container"},[(_vm.marketContractsStats.length > 0)?_c('market-contracts-stats',{attrs:{"isFixed":_vm.hasMarketHiddenContracts(_vm.market),"stats":_vm.marketContractsStats}}):(!_vm.isLoading)?_c('div',{staticClass:"market-detail-charts__stats-no-data"},[_vm._v("\n        No data to display\n      ")]):_vm._e()],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LWRS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    earned: function earned() {
      return [{ title: 'Badge 1' }, { title: 'Badge 2' }];
    },
    current: function current() {
      return [{ title: 'Badge 3' }, { title: 'Badge 4' }];
    },
    toDiscover: function toDiscover() {
      return [{ title: 'Badge 5' }, { title: 'Badge 6' }];
    }
  }
});

/***/ }),

/***/ "LZHh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ld1m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.showMarketName)?_c('router-link',{staticClass:"contract-tile__market",attrs:{"to":{ name: 'market-details', params: { marketId: _vm.data.marketId } }}},[_vm._v(_vm._s(_vm.market))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contract-tile__wrap"},[(_vm.isMarketSingle)?[_c('span',{staticClass:"contract-tile__name contract-tile__name--long"},[_vm._v(_vm._s(_vm.contractName))])]:[_c('router-link',{staticClass:"contract-tile__name contract-tile__name--long contract-tile__name--clickable",attrs:{"to":_vm.accountHistoryRoute}},[_vm._v(_vm._s(_vm.contractName))])],_vm._v(" "),_c('div',{staticClass:"contract-tile__profit contract-tile__profit--short"},[(_vm.desktop)?[_c('div',{class:_vm.profitClass},[_vm._v("\r\n          "+_vm._s(_vm.profitDesk)+"\r\n        ")]),_vm._v(" "),_c('div',{staticClass:"contract-tile__fees"},[_vm._v("\r\n          "+_vm._s(_vm.fee)+"\r\n        ")])]:[_vm._v(_vm._s(_vm.data.netProfitLossString))]],2),_vm._v(" "),_c('div',{staticClass:"contract-tile__risk"},[_vm._v("\r\n      "+_vm._s(_vm.data.riskChangeString)+"\r\n    ")]),_vm._v(" "),_c('div',{staticClass:"contract-tile__cash"},[_vm._v("\r\n      "+_vm._s(_vm.data.tradeValueString)+"\r\n    ")])],2),_vm._v(" "),_c('div',{staticClass:"contract-tile__bottom"},[_c('div',{staticClass:"contract-tile__per-share"},[_c('sold-bought-at',{attrs:{"tradeType":_vm.data.tradeType,"predictionType":_vm.data.predictionType,"quantity":_vm.data.quantity,"price":_vm.data.pricePerShare}})],1),_vm._v(" "),_c('div',{staticClass:"contract-tile__date"},[_vm._v("\r\n      "+_vm._s(_vm.date)+"\r\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ldd3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.loading)?_c('div',{staticClass:"twittertimeline__spinner"}):_vm._e(),_vm._v(" "),_c('div',{class:_vm.contentClassModifiers},[_c('div',{ref:"init",class:_vm.initClassModifiers})]),_vm._v(" "),(_vm.showFooter)?_c('div',{staticClass:"twittertimeline__footer"},[_c('div',{staticClass:"twittertimeline__more-button",on:{"click":_vm.onFooterMoreButtonClick}},[_vm._v("\n      "+_vm._s(_vm.getMoreTweetsLabel)+"\n    ")])]):_vm._e(),_vm._v(" "),_c('div',{ref:"more",staticClass:"twittertimeline__content"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LmU5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI3OCIgdmlld0JveD0iMCAwIDgwIDc4Ij4NCiAgICA8ZyBmaWxsPSIjMjYzQjNGIiBmaWxsLXJ1bGU9Im5vbnplcm8iPg0KICAgICAgICA8cGF0aCBkPSJNNDAuODQyIDBBMS44MzkgMS44MzkgMCAwIDAgMzkgMS44NXYzNi42NDVjMCAxLjAyOC44MTkgMS44NSAxLjg0MiAxLjg1aDM2LjQ5NmExLjgzOSAxLjgzOSAwIDAgMCAxLjg0My0xLjg1YzAtOS40LTMuNDA2LTE4LjQ0NC05LjYwMy0yNS40ODlDNjIuMyA0Ljc0NiA1MS44MjMgMCA0MC44NDIgMHptMS44NDMgMzYuNjQ1VjMuNzU2YTM0LjcyIDM0LjcyIDAgMCAxIDI0LjEzOCAxMS43MTdjNS4xOTMgNS44ODYgOC4yMDggMTMuMzYgOC42MzYgMjEuMTcySDQyLjY4NXoiLz4NCiAgICAgICAgPHBhdGggZD0iTTY0LjAwNiA0NS43ODZjMC0uNzk2LS42MzQtMS40MzMtMS40MjctMS40MzNIMzMuNDUzdi0yOS4yNmMwLS43OTYtLjYzNS0xLjQzMy0xLjQyOC0xLjQzM0MxNC4zNzYgMTMuNjYuMDI5IDI4LjA2Ni4wMjkgNDUuNzg2YzAgMTcuNzA3IDE0LjM0NyAzMi4xMjcgMzEuOTk2IDMyLjEyN3MzMS45ODEtMTQuNDIgMzEuOTgxLTMyLjEyN3ptLTMxLjk4MSAyOS4yNmMtMTYuMDYzIDAtMjkuMTQtMTMuMTMxLTI5LjE0LTI5LjI2IDAtMTUuNjUgMTIuMjk5LTI4LjQ3NyAyNy43MTMtMjkuMjN2MjkuMjE2YzAgLjc5Ni42MzQgMS40MzMgMS40MjcgMS40MzNoMjkuMDk4Yy0uNzUgMTUuNDc3LTEzLjUxMSAyNy44NDEtMjkuMDk4IDI3Ljg0MXoiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "LnYJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_leaderboards_js__ = __webpack_require__("RaQB");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2dcfd6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_leaderboards_vue__ = __webpack_require__("73Zp");
function injectStyle (ssrContext) {
  __webpack_require__("ovgP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_leaderboards_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2dcfd6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_leaderboards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "Lxtc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overview-map-loader"},[_c('div',{staticClass:"overview-map-loader__avatar"},[_c('div',{staticClass:"overview-map-loader__avatar-circle"})]),_vm._v(" "),_c('div',{staticClass:"overview-map-loader__content"},[_c('div',{staticClass:"overview-map-loader__text-1"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LyDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      url: null
    };
  },
  created: function created() {
    var _this = this;

    this.getIdUploadUrl().then(function (data) {
      _this.url = data;
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['getIdUploadUrl']), {
    onButtonClick: function onButtonClick() {
      window.location.href = this.url;
    }
  })
});

/***/ }),

/***/ "LygJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lzij":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M0+2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    isOpen: {
      type: Boolean,
      default: false
    },
    accordion: null,
    id: null
  },
  data: function data() {
    return {
      isOpenState: this.isOpen
    };
  },

  computed: {
    isOpenModifier: function isOpenModifier() {
      if (this.id) {
        this.isOpenState = this.accordion === this.id;
      }
      return {
        'collapsible-panel--is-open': this.isOpenState
      };
    }
  },
  methods: {
    toggle: function toggle() {
      this.isOpenState = !this.isOpenState;
      if (this.id) {
        this.$emit('open', this.isOpenState ? this.id : null);
      }
    }
  }
});

/***/ }),

/***/ "M1ko":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-notifications"},[(_vm.isLayoutMobile)?_c('content-header',{attrs:{"showCloseButton":false,"theme":"notifications","title":"Notifications"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12"},[_c('notifications-list')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M32j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__ = __webpack_require__("GZXJ");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'multiselect',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__["multiselectMixin"], __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__["pointerMixin"], __WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__["a" /* default */]],
  props: {
    name: {
      type: String,
      default: ''
    },
    selectLabel: {
      type: String,
      default: 'Press enter to select'
    },
    selectedLabel: {
      type: String,
      default: 'Selected'
    },
    deselectLabel: {
      type: String,
      default: 'Press enter to remove'
    },
    showLabels: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 99999
    },
    maxHeight: {
      type: Number,
      default: 300
    },
    limitText: {
      type: Function,
      default: function _default(count) {
        return 'and ' + count + ' more';
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    openDirection: {
      type: String,
      default: ''
    },
    showNoResults: {
      type: Boolean,
      default: true
    },
    tabindex: {
      type: Number,
      default: 0
    },
    adjust: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    activate: function activate() {
      var _this = this;

      if (this.isOpen || this.disabled) return;
      if (this.adjust) {
        this.adjustPosition();
      }
      if (this.groupValues && this.pointer === 0 && this.filteredOptions.length) {
        this.pointer = 1;
      }

      this.isOpen = true;
      if (this.searchable) {
        if (!this.preserveSearch) this.search = '';
        this.$nextTick(function () {
          return _this.$refs.search.focus();
        });
      } else {
        this.$el.focus();
      }
      this.$emit('open', this.id);
    },
    addPointerElement: function addPointerElement() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Enter',
          key = _ref.key;

      if (this.filteredOptions.length > 0) {
        this.select(this.filteredOptions[this.pointer], key);
      }
      this.pointerReset();
    },
    pointerSet: function pointerSet(index, option) {
      this.pointer = index;
      this.pointerDirty = true;
      if (this.isIos) {
        this.select(option);
      }
    }
  },
  computed: {
    visibleValue: function visibleValue() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : [];
    },
    deselectLabelText: function deselectLabelText() {
      return this.showLabels ? this.deselectLabel : '';
    },
    selectLabelText: function selectLabelText() {
      return this.showLabels ? this.selectLabel : '';
    },
    selectedLabelText: function selectedLabelText() {
      return this.showLabels ? this.selectedLabel : '';
    },
    inputStyle: function inputStyle() {
      if (this.multiple && this.value && this.value.length) {
        // Hide input by setting the width to 0 allowing it to receive focus
        return this.isOpen ? { width: 'auto' } : { width: '0', position: 'absolute' };
      }
      return {};
    },
    contentStyle: function contentStyle() {
      return this.options.length ? { display: 'inline-block' } : { display: 'block' };
    },
    isAbove: function isAbove() {
      if (this.openDirection === 'above' || this.openDirection === 'top') {
        return true;
      } else if (this.openDirection === 'below' || this.openDirection === 'bottom') {
        return false;
      }
      return this.prefferedOpenDirection === 'above';
    }
  }
});

/***/ }),

/***/ "M4KV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_js__ = __webpack_require__("T5jF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3772652_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_vue__ = __webpack_require__("mo3u");
function injectStyle (ssrContext) {
  __webpack_require__("KV4/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_order_book_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3772652_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_book_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M5iw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_profile_profile_vue__ = __webpack_require__("lmGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_accountVerify__ = __webpack_require__("yZQa");






function getDefaultRedirectRouteName(isWalletAvailable) {
  return isWalletAvailable ? 'wallet' : 'account-history';
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_accountVerify__["a" /* default */]],
  components: {
    profile: __WEBPACK_IMPORTED_MODULE_2__components_account_profile_profile_vue__["a" /* default */]
  },
  watch: {
    isLayoutMobile: function isLayoutMobile(value) {
      if (!value) {
        // const isWalletAvailable = this.isUserVerified && !this.hasMaintenanceMessage;
        this.$router.push({ name: getDefaultRedirectRouteName(this.isWalletEnabled) });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['hasMaintenanceMessage'])),
  beforeCreate: function beforeCreate() {
    // because router.beforeEnter() fires before app.resizeHandler() can check client width
    // also this.isLayoutMobile === undefined here
    if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.app.layout === 'desktop') {
      var idVerified = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.user.status.idVerified;
      var isUserVerified = typeof idVerified !== 'undefined' ? idVerified : true;
      // const isMaintenanceEnabled = store.getters['app/hasMaintenanceMessage'];
      // const isWalletAvailable = isUserVerified && !isMaintenanceEnabled;
      this.$router.push({ name: getDefaultRedirectRouteName(isUserVerified) });
    }
  }
});

/***/ }),

/***/ "M6xY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_user_profile_overview_js__ = __webpack_require__("p8bb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b6f68e3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_profile_overview_vue__ = __webpack_require__("aQYE");
function injectStyle (ssrContext) {
  __webpack_require__("J1ma")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_user_profile_overview_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b6f68e3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_profile_overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M8Zh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M8zO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_container_js__ = __webpack_require__("+kDG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_233d1a01_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_container_vue__ = __webpack_require__("FPPs");
function injectStyle (ssrContext) {
  __webpack_require__("33aF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_container_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_233d1a01_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_container_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MBIL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initialised)?_c('div',[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{staticClass:"account-details-update form content-header__section-group",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[(_vm.usernameTries === 3)?_c('p',{staticClass:"account-details-update__disclaimer"},[_vm._v("You can change your username up to three times only.")]):(_vm.usernameTries === 2)?_c('p',{staticClass:"account-details-update__disclaimer"},[_vm._v("You have changed your username once already. You can change it twice more only.")]):(_vm.usernameTries === 1)?_c('p',{staticClass:"account-details-update__disclaimer"},[_vm._v("You have changed your username twice already. You can change it once more only.")]):_c('p',{staticClass:"account-details-update__disclaimer"},[_vm._v("You have changed your username three times already. You cannot change it further.")]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('form-input',{staticClass:"account-details-update__current-username",attrs:{"disabled":true,"name":"nickname","type":"text","autocomplete":"off","placeholder":"Current Username"},model:{value:(_vm.fields.username),callback:function ($$v) {_vm.$set(_vm.fields, "username", $$v)},expression:"fields.username"}})],1),_vm._v(" "),(_vm.usernameTries > 0)?_c('div',{staticClass:"small-12 column"},[_c('form-input',{ref:"newUsername",attrs:{"validation":_vm.$v.fields.newUserName,"disabled":_vm.isUsernameInputDisabled,"name":"nickname","type":"text","autocomplete":"off","gtm":"Registration,User Name","placeholder":"New Username"},on:{"input":_vm.$v.fields.newUserName.$touch},model:{value:(_vm.fields.newUserName),callback:function ($$v) {_vm.$set(_vm.fields, "newUserName", $$v)},expression:"fields.newUserName"}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"account-details-update__buttons"},[(_vm.usernameTries > 0)?_c('form-submit',{attrs:{"disabled":_vm.isSubmitButtonDisabled,"label":"Confirm"}}):_vm._e()],1)])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MGrt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      type: Number,
      default: 0
    },
    validate: Function,
    initial: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      lastCorrect: this.value,
      min: 5,
      max: 94, // coz 99 - 5
      invalid: false,
      val: 0,
      focused: false
    };
  },

  computed: {
    valueWithCent: function valueWithCent() {
      return this.focused ? this.val : this.val + '\xA2';
    }
  },
  created: function created() {
    this.val = this.value;
  },

  methods: {
    updateValue: function updateValue(value) {
      if (value === '') {
        return;
      }

      var parsed = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(value, 10);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(parsed)) {
        this.$refs.input.value = this.lastCorrect;
        return;
      }

      if ('' + parsed !== value) {
        this.$refs.input.value = this.lastCorrect;
        return;
      }

      if (value > this.max) {
        this.lastCorrect = this.max;
        this.$refs.input.value = this.max;
        return;
      }

      this.lastCorrect = parsed;
    },
    onFocus: function onFocus() {
      this.focused = true;
    },
    onBlur: function onBlur() {
      this.focused = false;
      this.val = this.lastCorrect;

      if (this.$refs.input.value === '') {
        this.val = this.min;
      }
      if (this.lastCorrect < this.min) {
        this.val = this.min;
      }

      if (this.lastCorrect > this.max) {
        this.val = this.max;
      }

      this.$refs.input.value = this.val + '\xA2';
      this.$emit('input', this.val);
    }
  }
});

/***/ }),

/***/ "MH7L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_filters_market_filters_mixin_market_filters_mixin__ = __webpack_require__("kGlu");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_market_market_filters_market_filters_mixin_market_filters_mixin__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('watchlist', ['selectedOrder', 'selectedTimespan', 'shouldShowTimespanFilter']), {
    mainClassName: function mainClassName() {
      return 'market-filters-desktop-grid-watchlist';
    },
    menuClassModifier: function menuClassModifier() {
      return {
        'market-filters-desktop-grid-watchlist__menu': true,
        'market-filters-desktop-grid-watchlist__menu--with-timespan-filter': this.shouldShowTimespanFilter
      };
    },
    orderMenuName: function orderMenuName() {
      return this.selectedOrder.fullName;
    }
  }),
  created: function created() {
    this.isWatchlistOpen = true;
  }
});

/***/ }),

/***/ "MJqx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_dashboard_js__ = __webpack_require__("+++F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f26f83a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_dashboard_vue__ = __webpack_require__("voqc");
function injectStyle (ssrContext) {
  __webpack_require__("YyHL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_dashboard_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f26f83a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MO++":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MUii":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"debug"},[_c('br'),_vm._v(" "),_c('app-header-new')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MXhm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MbhW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_coinbase_process_overview_js__ = __webpack_require__("b47U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acda855e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_coinbase_process_overview_vue__ = __webpack_require__("SlPv");
function injectStyle (ssrContext) {
  __webpack_require__("q1v3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_coinbase_process_overview_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acda855e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_coinbase_process_overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mc9E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"noPadding":_vm.noPadding,"bodyClass":"modal__body--slim modal__body--show-ready"},on:{"modalClose":_vm.closeModal}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),(_vm.what === 'account-address-update')?_c('account-address-update',{attrs:{"slot":"content"},slot:"content"}):_vm._e(),_vm._v(" "),(_vm.what === 'account-detail-update')?_c('account-details-update',{attrs:{"slot":"content"},slot:"content"}):_vm._e(),_vm._v(" "),(_vm.what === 'account-detail-password')?_c('account-update-password',{attrs:{"slot":"content"},slot:"content"}):_vm._e(),_vm._v(" "),(_vm.what === 'account-detail-password-set')?_c('account-set-password',{attrs:{"slot":"content"},slot:"content"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MluJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    source: {
      type: Number,
      default: 4
    },
    isPending: {
      type: Boolean,
      default: false
    },
    isModal: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    isCard: function isCard() {
      return this.type === 'card';
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'account-upload-document': true,
        'account-upload-document--modal': this.isModal,
        'account-upload-document--embedded': !this.isModal
      }, 'account-upload-document--' + this.theme, this.theme);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getDocumentUploadLink']), {
    onButtonClick: function onButtonClick() {
      this.getDocumentUploadLink(this.source).then(function (link) {
        window.location.href = link;
      });
    }
  })
});

/***/ }),

/***/ "Mo4z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Moaq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* eslint-disable no-console */

function set(key, value) {
  var ttl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var data = {
    value: value,
    expires_at: ttl !== null ? (new Date().getTime() + ttl * 1000) / 1 : null
  };

  try {
    localStorage.setItem(key.toString(), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
  } catch (e) {
    console.error(e);
  }
}

function del(key) {
  try {
    localStorage.removeItem(key.toString());
  } catch (e) {
    console.error(e);
  }
}

function get(key, defaultValue) {
  try {
    var data = JSON.parse(localStorage.getItem(key.toString()));
    if (data !== null) {
      if (data.expires_at !== null && data.expires_at < new Date().getTime()) {
        localStorage.removeItem(key.toString());
      } else {
        return data.value;
      }
    }
  } catch (e) {
    console.error(e);
    del(key);
  }
  return defaultValue || null;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  set: set,
  get: get,
  del: del
});

/***/ }),

/***/ "Mq7P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wallet_add_funds_bank_transfer_components_bank_account_bank_account_vue__ = __webpack_require__("5r1F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    bankAccount: __WEBPACK_IMPORTED_MODULE_2__components_wallet_add_funds_bank_transfer_components_bank_account_bank_account_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['currentDeposit', 'balance']), {
    amountFormatted: function amountFormatted() {
      return '&#36;' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["d" /* priceDisplay */])(this.currentDeposit.amount || 0);
    },
    matchedFormatted: function matchedFormatted() {
      return '&#36;' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["d" /* priceDisplay */])(this.currentDeposit.matched || 0);
    },
    promoAmountFormatted: function promoAmountFormatted() {
      var value = this.currentDeposit.promoAmount || 0;
      return '&#36;' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["d" /* priceDisplay */])(value);
    },
    hasPromotionalCredit: function hasPromotionalCredit() {
      var value = this.currentDeposit.matched || this.currentDeposit.promoAmount || 0;
      return value !== 0;
    },
    leftColClassModifiers: function leftColClassModifiers() {
      return {
        column: true,
        'small-4': this.hasPromotionalCredit,
        'small-6': !this.hasPromotionalCredit,
        deposited__divider: true
      };
    },
    rightColClassModifiers: function rightColClassModifiers() {
      return {
        column: true,
        'small-4': this.hasPromotionalCredit,
        'small-6': !this.hasPromotionalCredit
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['getStatus'])),
  created: function created() {
    this.getStatus(); // reload hasBeenFunded flag when showing Summary
  }
});

/***/ }),

/***/ "Msc9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"withdraw"},[(_vm.showTabs)?_c('div',{staticClass:"withdraw__tabs"},[_c('tabs',{attrs:{"activeTab":_vm.activeTab,"items":_vm.tabs,"theme":"alt"},on:{"tabChange":_vm.tabChange}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"withdraw__content"},[(_vm.showAchTab)?_c('ach',{on:{"success":_vm.onSuccessWithdraw}}):_vm._e(),_vm._v(" "),(_vm.showCheckTab)?_c('check',{on:{"success":_vm.onSuccessWithdraw}}):_vm._e(),_vm._v(" "),(_vm.showCryptoTab)?_c('coinbase-withdraw',{on:{"success":_vm.onSuccessWithdraw}}):_vm._e(),_vm._v(" "),(_vm.showBankTransferTab)?_c('bank-transfer',{on:{"success":_vm.onSuccessWithdraw}}):_vm._e(),_vm._v(" "),(_vm.showPendingTab)?_c('pending-requests'):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MuFU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bloomberg.a7ba880.png";

/***/ }),

/***/ "Mz4K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_announcement_js__ = __webpack_require__("95mA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae4e016_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_announcement_vue__ = __webpack_require__("xLZ0");
function injectStyle (ssrContext) {
  __webpack_require__("78tC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_announcement_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae4e016_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_announcement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MzT2":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "N1CV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-quotes"},[_c('swiper',{attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.items),function(quote){return _c('swiper-slide',{key:quote.id,staticClass:"main-quotes__slide"},[_c('div',{staticClass:"main-quotes__image"}),_vm._v(" "),_c('div',{staticClass:"main-quotes__content"},[_c('p',{staticClass:"main-quotes__item--text"},[_vm._v(_vm._s(quote.text))]),_vm._v(" "),_c('p',{staticClass:"main-quotes__item--author"},[_vm._v(_vm._s(quote.author))])])])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N2S3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboards-table"},[_c('div',{staticClass:"leaderboards-table__row leaderboards-table__row--header"},[_c('div',{staticClass:"leaderboards-table__row-position"},[_vm._v("\n      Rank\n    ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__row-change"},[_vm._v("\n      Change\n    ")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__row-profitable-predictions"},[_c('div',[_vm._v("Wins")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__info-icon",on:{"click":_vm.onWinsInfoClick}})]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__row-roi"},[_c('div',[_vm._v("ROI")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__info-icon",on:{"click":_vm.onRoiInfoClick}})])]),_vm._v(" "),(_vm.showNoDataMessage)?_c('div',{staticClass:"leaderboards-table__no-data"},[_vm._v("\n    No data is available for this selection.\n  ")]):_vm._l((_vm.rows),function(item){return _c('div',{key:item.id,class:_vm.rowClassModifiers(item)},[_c('div',{staticClass:"leaderboards-table__row-position"},[_vm._v("\n        "+_vm._s(item.rank)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__row-trader",on:{"click":function($event){return _vm.onAvatarClick(item)}}},[_c('div',{staticClass:"leaderboards-table__row-trader-avatar"},[_c('account-social-avatar',{attrs:{"avatar":item.avatarImage,"showProgress":true,"percentage":100,"progressStrokeColor":_vm.traderLevelColor(item),"showEdit":false,"theme":"leaderboards"}})],1),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__row-trader-info"},[_c('div',{staticClass:"leaderboards-table__row-trader-username"},[(_vm.isLayoutDesktop)?_c('span',[_vm._v(_vm._s(_vm._f("usernameDisplayLong")(item.userName)))]):_c('span',[_vm._v(_vm._s(_vm._f("usernameDisplay")(item.userName)))])]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__row-trader-level"},[_vm._v("\n            "+_vm._s(_vm.traderLevelDisplay(item))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__row-change"},[(_vm.showRankChange(item))?_c('div',{staticClass:"leaderboards-table__row-change-wrap"},[_c('div',{staticClass:"leaderboards-table__row-change-number"},[_vm._v(_vm._s(Math.abs(item.rankChange)))]),_vm._v(" "),_c('div',{class:_vm.arrowChangeClassModifiers(item)})]):(item.rankChange === 0)?_c('div',{staticClass:"leaderboards-table__row-change-empty-value"},[_vm._v("\n          NC\n        ")]):_c('div',{staticClass:"leaderboards-table__row-change-empty-value"},[_vm._v("\n          New!\n        ")])]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__row-profitable-predictions"},[(item.wins)?[(_vm.isLayoutDesktop)?_vm._l((_vm.range(item.wins)),function(i){return _c('div',{key:i,staticClass:"leaderboards-table__trophy"})}):[_c('strong',[_vm._v(_vm._s(item.wins))]),_vm._v(" "),_c('div',{staticClass:"leaderboards-table__trophy"})]]:_c('hr',{staticClass:"leaderboards-table__dash"})],2),_vm._v(" "),_c('div',{class:_vm.roiModifiers(item)},[(item.roi >0)?[_vm._v("+")]:(item.roi <0)?[_vm._v("-")]:_vm._e(),_vm._v(_vm._s(_vm.traderRoiDisplay(item))+"\n      ")],2)])}),_vm._v(" "),(_vm.selectedLeaderboard)?[(_vm.leaderboardsResults.canLoadMore)?_c('infinite-loading',{key:_vm.infiniteLoadingKey,on:{"infinite":_vm.goInfinite}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('div',{staticClass:"leaderboards-table__spinner"})]),_vm._v(" "),_c('span',{attrs:{"slot":"no-results"},slot:"no-results"}),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})]):_vm._e()]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboards-table__row-trader"},[_c('div',{staticClass:"leaderboards-table__row-trader-menu"},[_vm._v("Trader")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N5+X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NCFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    kind: {
      type: String,
      default: ''
    },
    routeName: {
      type: String,
      default: ''
    }
  },
  computed: {
    classModifier: function classModifier() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'back-button': true
      }, 'back-button--' + this.kind, this.kind);
    }
  },
  methods: {
    onButtonClick: function onButtonClick() {
      if (this.routeName) {
        this.$router.push({ name: this.routeName });
      } else {
        this.$router.go(-1);
      }
    }
  }
});

/***/ }),

/***/ "NGPj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-list-item-expandable"},[(_vm.isLayoutMobile)?[_c('div',{class:_vm.titleMobileClassModifiers,on:{"click":_vm.toggleItem}},[_c('div',{class:_vm.toggleMobileClassModifiers}),_vm._v(" "),_c('div',{staticClass:"market-list-item-expandable__mobile-title-image",style:(_vm.marketImageStyleModifiers)}),_vm._v(" "),_c('div',{staticClass:"market-list-item-expandable__mobile-title-text"},[_vm._v("\n        "+_vm._s(_vm.market.marketShortName)+"\n      ")]),_vm._v(" "),(!_vm.isPayoutAvailable)?_c('div',{staticClass:"market-list-item-expandable__view-market-container"},[_c('router-link',{staticClass:"market-list-item-expandable__view-market-link",attrs:{"to":{ name: 'market-details', params: { marketId: _vm.market.marketId, marketUrl: _vm.market.marketUrl } }},nativeOn:{"click":function($event){return $event.stopPropagation()}}},[_vm._v("\n          View"),_c('br'),_vm._v("Market\n        ")])],1):_vm._e()]),_vm._v(" "),(_vm.isPayoutAvailable)?_c('market-payout',{attrs:{"theme":"dashboard","showMarketLink":true,"market":_vm.market}}):_vm._e()]:[_c('div',{class:_vm.titleDesktopClassModifiers,on:{"click":_vm.toggleItem}},[_c('div',{class:_vm.toggleDesktopClassModifiers}),_vm._v(" "),_c('div',{staticClass:"market-list-item-expandable__desktop-title-image",style:(_vm.marketImageStyleModifiers)}),_vm._v(" "),_c('div',{staticClass:"market-list-item-expandable__desktop-title-content"},[_c('div',{staticClass:"market-list-item-expandable__desktop-title-text"},[_vm._v("\n          "+_vm._s(_vm.market.marketShortName)+"\n        ")]),_vm._v(" "),(_vm.isPayoutAvailable)?_c('market-payout',{attrs:{"theme":"dashboard","showMarketLink":true,"market":_vm.market}}):_vm._e(),_vm._v(" "),(!_vm.isPayoutAvailable)?_c('div',{staticClass:"market-list-item-expandable__view-market-container"},[_c('router-link',{staticClass:"market-list-item-expandable__view-market-link",attrs:{"to":{ name: 'market-details', params: { marketId: _vm.market.marketId, marketUrl: _vm.market.marketUrl } }},nativeOn:{"click":function($event){return $event.stopPropagation()}}},[_vm._v("\n            View"),_c('br'),_vm._v("Market\n          ")])],1):_vm._e()],1)])],_vm._v(" "),_c('transition',{attrs:{"name":"market-list-item-expandable"}},[(_vm.expanded)?_c('div',{staticClass:"market-list-item-expandable__content"},[(_vm.showContractsHeader)?_c('div',{staticClass:"market-list-item-expandable__contracts-header"},[_c('div',{staticClass:"market-list-item-expandable__contracts-header-item-1"},[_vm._v("\n          Contract\n        ")]),_vm._v(" "),_c('div',{staticClass:"market-list-item-expandable__contracts-header-item-2"},[_vm._v("\n          Latest\n        ")]),_vm._v(" "),_c('div',{staticClass:"market-list-item-expandable__contracts-header-item-3"},[_vm._v("\n          Shares\n        ")]),_vm._v(" "),_c('div',{staticClass:"market-list-item-expandable__contracts-header-item-4"},[_vm._v("\n          Avg. Paid\n        ")]),_vm._v(" "),_c('div',{staticClass:"market-list-item-expandable__contracts-header-item-5"},[_vm._v("\n          Offers\n        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-list-item-expandable__contracts"},[_vm._l((_vm.contractsToShow),function(item){return [_c('market-contract',{key:_vm.contractKey('market-contract', item),attrs:{"layout":_vm.contractLayout,"market":_vm.market,"contract":item}}),_vm._v(" "),(_vm.isPurchaseDesktopMode(item.contractId))?_c('purchase-desktop',{key:_vm.contractKey('purchase-desktop', item),attrs:{"market":_vm.market,"showCloseButton":false,"closeJourneyAfterSuccess":true},on:{"reinitialize":_vm.onReinitializePurchase}}):_vm._e()]}),_vm._v(" "),(_vm.shouldShowToggleMoreButton)?_c('div',{class:_vm.toggleMoreModifiers,on:{"click":_vm.onToggleMore}},[(!_vm.showAllContracts)?[_vm._v("\n            "+_vm._s(_vm.leftContractsToShow.length)+" More Contract"),(_vm.leftContractsToShow.length > 1)?[_vm._v("s")]:_vm._e()]:[_vm._v("\n            Show Fewer\n          ")]],2):_vm._e()],2)]):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NGyh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_footer_old_facebook_svg__ = __webpack_require__("2I1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_footer_old_facebook_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_icons_footer_old_facebook_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_footer_old_instagram_svg__ = __webpack_require__("KG2i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_footer_old_instagram_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_icons_footer_old_instagram_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_footer_old_twitter_svg__ = __webpack_require__("V8GJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_footer_old_twitter_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_icons_footer_old_twitter_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ title: 'Facebook', href: "https://www.facebook.com/PredictIt/", icon: __WEBPACK_IMPORTED_MODULE_2__assets_icons_footer_old_facebook_svg___default.a }, { title: 'Instagram', href: "https://www.instagram.com/PredictIt/", icon: __WEBPACK_IMPORTED_MODULE_3__assets_icons_footer_old_instagram_svg___default.a }, { title: 'Twitter', href: "https://twitter.com/PredictIt", icon: __WEBPACK_IMPORTED_MODULE_4__assets_icons_footer_old_twitter_svg___default.a }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isUserRestricted'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onLearnMore: function onLearnMore() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_app_modals__["a" /* MODALS */].RESEARCH);
    }
  })
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_custom_polyfill__ = __webpack_require__("SRJW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_custom_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_custom_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_meta__ = __webpack_require__("p3jY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gtm__ = __webpack_require__("Sl4y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gtm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_gtm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_youtube_embed__ = __webpack_require__("5/be");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_app_app_vue__ = __webpack_require__("IYz5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_animated_number_animated_number_vue__ = __webpack_require__("21pt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_market_market_state_tooltip_market_state_tooltip_vue__ = __webpack_require__("Vnj/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__directives_click_outside__ = __webpack_require__("oKYE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__directives_outer_link__ = __webpack_require__("dK2d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directives_price_display__ = __webpack_require__("P3fZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__directives_large_number__ = __webpack_require__("+88x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__directives_sticky__ = __webpack_require__("1/qb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__directives_asset_cdn_src__ = __webpack_require__("6Bn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_staticConf_utils__ = __webpack_require__("RZM5");
/* global Sentry */
/* eslint-disable no-confusing-arrow */





















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_meta___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_youtube_embed__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('click-outside', __WEBPACK_IMPORTED_MODULE_13__directives_click_outside__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('outer-link', __WEBPACK_IMPORTED_MODULE_14__directives_outer_link__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('price-display', __WEBPACK_IMPORTED_MODULE_15__directives_price_display__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('large-number', __WEBPACK_IMPORTED_MODULE_16__directives_large_number__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('sticky', __WEBPACK_IMPORTED_MODULE_17__directives_sticky__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('asset-cdn-src', __WEBPACK_IMPORTED_MODULE_18__directives_asset_cdn_src__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('pluralize', function (value) {
  return value.charAt(value.length - 1) === 's' ? value : value + 's';
});
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('usernameDisplay', function (value) {
  var limit = 14;
  var username = value || '';
  if (username.length >= limit) {
    return username.substr(0, limit) + '...';
  }
  return username;
});
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('usernameDisplayLong', function (value) {
  var limit = 20;
  var username = value || '';
  if (username.length >= limit) {
    return username.substr(0, limit) + '...';
  }
  return username;
});
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('ordinal', function (value) {
  var symbols = ['th', 'st', 'nd', 'rd'];
  var v = value % 100;
  var suffix = symbols[(v - 20) % 10] || symbols[v] || symbols[0];
  return '' + value + suffix;
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('animated-number', __WEBPACK_IMPORTED_MODULE_11__components_animated_number_animated_number_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('market-state-tooltip', __WEBPACK_IMPORTED_MODULE_12__components_market_market_state_tooltip_market_state_tooltip_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_gtm___default.a, {
  debug: "production" === 'development'
});
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$txt = __WEBPACK_IMPORTED_MODULE_19__mixins_staticConf_utils__["a" /* $txt */];

if (typeof Sentry !== 'undefined' && "production" !== 'development' && __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","FIREBASE_API_KEY_ANONYMOUS":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID_ANONYMOUS":"","FIREBASE_AUTH_DOMAIN_ANONYMOUS":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL_ANONYMOUS":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID_ANONYMOUS":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID_ANONYMOUS":"76708845910","FIREBASE_STORAGE_BUCKET_ANONYMOUS":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_FIREBASE":false,"ANONYMOUS_SIGNALR":false,"ORDER_BOOK_API_CALL_ENABLED":true,"ORDER_BOOK_FIREBASE_ENABLED":true,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","OPTIMOVE_ENABLED":true,"OPTIMOVE_SDK_TOKEN":"3b0d03cb1a8091dcf9b3f84bb2466b968ebf27e1b4d8a50c123316c0d129a99b","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","NEW_HEADER_ENABLED":false,"NEW_HEADER_EXCHANGE_URL":"https://exchange.predictit.com"}).SENTRY_DSN) {
  Sentry.init({
    dsn: __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","FIREBASE_API_KEY_ANONYMOUS":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID_ANONYMOUS":"","FIREBASE_AUTH_DOMAIN_ANONYMOUS":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL_ANONYMOUS":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID_ANONYMOUS":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID_ANONYMOUS":"76708845910","FIREBASE_STORAGE_BUCKET_ANONYMOUS":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_FIREBASE":false,"ANONYMOUS_SIGNALR":false,"ORDER_BOOK_API_CALL_ENABLED":true,"ORDER_BOOK_FIREBASE_ENABLED":true,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","OPTIMOVE_ENABLED":true,"OPTIMOVE_SDK_TOKEN":"3b0d03cb1a8091dcf9b3f84bb2466b968ebf27e1b4d8a50c123316c0d129a99b","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","NEW_HEADER_ENABLED":false,"NEW_HEADER_EXCHANGE_URL":"https://exchange.predictit.com"}).SENTRY_DSN,
    environment: "production"
  });
}

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_10__components_app_app_vue__["a" /* default */]);
  }
});

/***/ }),

/***/ "NLYo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_notifications_list_notifications_list_vue__ = __webpack_require__("R/N+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__ = __webpack_require__("BL43");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__["a" /* default */]],
  components: {
    contentHeader: __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__["a" /* default */],
    notificationsList: __WEBPACK_IMPORTED_MODULE_4__components_notifications_list_notifications_list_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Notifications'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile'])),
  beforeDestroy: function beforeDestroy() {
    this.clearAllNotifications();
  }
});

/***/ }),

/***/ "NMl0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_collapsible_panel_js__ = __webpack_require__("6Ngg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc5fb05c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapsible_panel_vue__ = __webpack_require__("4km3");
function injectStyle (ssrContext) {
  __webpack_require__("b8IF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_collapsible_panel_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc5fb05c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapsible_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NPa3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wallet_withdraw_confirm_withdraw_confirm_vue__ = __webpack_require__("waMS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wallet_available_balance_available_balance_vue__ = __webpack_require__("3PvP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_notification_icon_notification_icon_vue__ = __webpack_require__("qIn7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_infinite_loading__);


 /* eslint-disable arrow-body-style */














var TOO_MANY_RESULTS = 50;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_13__mixins_loader__["a" /* default */]],
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_5__components_generics_alert_box_alert_box_vue__["a" /* default */],
    availableBalance: __WEBPACK_IMPORTED_MODULE_6__components_wallet_available_balance_available_balance_vue__["a" /* default */],
    notificationIcon: __WEBPACK_IMPORTED_MODULE_11__components_notification_icon_notification_icon_vue__["a" /* default */],
    withdrawConfirm: __WEBPACK_IMPORTED_MODULE_4__components_wallet_withdraw_confirm_withdraw_confirm_vue__["a" /* default */],
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_14_vue_infinite_loading___default.a
  },
  data: function data() {
    return {
      TOO_MANY_RESULTS: TOO_MANY_RESULTS,
      showConfirmation: false,
      showBankInfoForm: false,
      showWithdrawalAmountForm: false,
      showAddressSearch: false,
      isSearching: false,
      hasSearched: false,
      hasSavedAccount: false,
      showIbanValidationInfo: false,
      showIbanValidationForm: false,
      infiniteLoader: null,
      pickedSuggestion: null,
      accountId: null,
      beneficiaryInfo: {},
      error: '',
      query: '',
      disclaimer: '',
      beneficiaryFields: [],
      bankWithdrawAmounts: {
        grossWithdrawalAmount: 0,
        flatFeeAmount: 0,
        percentageFeeAmount: 0,
        totalFees: 0,
        netWithdrawalAmount: 0
      },
      fieldsBankInfoForm: {
        searchBankName: '',
        searchCity: '',
        searchAddress: '',
        bankName: '',
        streetAddress: '',
        city: '',
        zipCode: '',
        region: ''
      },
      fieldsWithdrawalAmountForm: {
        amount: ''
      }
    };
  },
  validations: function validations() {
    if (this.showBankInfoForm) {
      var rules = {};
      this.beneficiaryFields.forEach(function (field) {
        rules = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rules, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, field.id, __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__["a" /* validators */].customPattern(field.regEx, field.errorMessage)));
      });
      return {
        fieldsBankInfoForm: rules
      };
    }
    return {
      fieldsWithdrawalAmountForm: {
        amount: __WEBPACK_IMPORTED_MODULE_7__components_forms_mixin__["a" /* validators */].withdrawalAmount(this.minWithdrawal, this.maxWithdrawal)
      }
    };
  },

  watch: {
    suggestions: function suggestions() {
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        if (!this.wireSearchResults.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('wallet', ['wire', 'wireSearchResults']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['userData']), {
    beneficiaryFieldsJustFirst: function beneficiaryFieldsJustFirst() {
      return this.beneficiaryFields.slice(0, 1);
    },
    beneficiaryFieldsWithoutFirst: function beneficiaryFieldsWithoutFirst() {
      return this.beneficiaryFields.slice(1, this.beneficiaryFields.length);
    },
    suggestions: function suggestions() {
      return this.wireSearchResults.data === null ? [] : this.wireSearchResults.data;
    },
    suggestionsTotal: function suggestionsTotal() {
      return this.wireSearchResults.data === null ? 0 : this.wireSearchResults.totalCount;
    },
    amountPlaceholder: function amountPlaceholder() {
      return 'Withdrawal Amount (Minimum $' + this.minWithdrawal + ' USD)';
    },
    minWithdrawal: function minWithdrawal() {
      return this.wire ? this.wire.minimumWithdrawalAmount : 0;
    },
    maxWithdrawal: function maxWithdrawal() {
      return this.wire ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_helpers__["v" /* roundDown */])(this.wire.availableFunds) : 0;
    },
    isAmountFieldDisabled: function isAmountFieldDisabled() {
      return this.minWithdrawal < 1 || this.maxWithdrawal < 1;
    },
    availableBalance: function availableBalance() {
      return this.wire && this.wire.availableFundsString ? this.wire.availableFundsString : '$0.00';
    },
    restrictedFunds: function restrictedFunds() {
      return this.wire && this.wire.restrictedFundsString ? this.wire.restrictedFundsString : '';
    },
    errorMessage: function errorMessage() {
      return this.error;
    },
    hasErrorMessage: function hasErrorMessage() {
      return this.error;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('wallet', ['getWithdrawWire', 'getWithdrawWireBankSearch', 'postWithdrawWireBankInfo', 'postWithdrawWireConfirm', 'resetWireSearchResults']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    goInfinite: function goInfinite(infi) {
      this.infiniteLoader = infi;

      if (this.wireSearchResults.canLoadMore) {
        this.loadWireSearch();
      }
    },
    loadWireSearch: function loadWireSearch() {
      var _this = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$reset = _ref.reset,
          reset = _ref$reset === undefined ? false : _ref$reset;

      this.isSearching = true;
      if (reset) {
        this.hasSearched = false;
      }
      this.getWithdrawWireBankSearch({ query: this.query }).then(function (data) {
        if (data.totalResults > TOO_MANY_RESULTS) {
          _this.showAddressSearch = true;
        }
        _this.hasSearched = true;
        _this.isSearching = false;
      }).catch(function () {
        _this.isSearching = false;
        _this.infiniteLoader.complete();
        _this.infiniteLoader = null;
      });
    },
    reviewRequest: function reviewRequest() {
      var _this2 = this;

      if (this.formIsValid() && this.formDisable()) {
        var payload = {
          amount: this.fieldsWithdrawalAmountForm.amount,
          accountWireBeneficiaryId: this.beneficiaryInfo.accountWireBeneficiaryId
        };
        this.postWithdrawWireConfirm(payload).then(function (data) {
          _this2.bankWithdrawAmounts = data;
          _this2.showConfirmation = true;
          _this2.loaderRemove(document.body);
          _this2.formEnable();
        }).catch(function (error) {
          _this2.loaderRemove(document.body);
          _this2.formHandleErrors(error);
          _this2.formEnable();
        });
      }
    },
    confirmAccountInfo: function confirmAccountInfo() {
      var _this3 = this;

      if (this.formIsValid() && this.formDisable()) {
        var payload = {};
        this.beneficiaryFields.forEach(function (field) {
          payload[field.id] = _this3.fieldsBankInfoForm[field.id];
        });
        this.postWithdrawWireBankInfo(payload).then(function (data) {
          _this3.beneficiaryInfo = data.beneficiaryInfo;
          if (data.canWithdraw) {
            _this3.showWithdrawalAmountForm = true;
            _this3.showBankInfoForm = false;
          } else {
            _this3.showIbanValidationInfo = true;
            _this3.showIbanValidationForm = false;
            _this3.showAddressSearch = true;
          }
          _this3.loaderRemove(document.body);
          _this3.formEnable();
        }).catch(function (error) {
          _this3.loaderRemove(document.body);
          _this3.formHandleErrors(error);
          _this3.formEnable();
        });
      }
    },
    confirmBankInfo: function confirmBankInfo() {
      var _this4 = this;

      if (this.formIsValid() && this.formDisable()) {
        var payload = {
          bankId: this.pickedSuggestion.id
        };
        this.beneficiaryFields.forEach(function (field) {
          payload[field.id] = _this4.fieldsBankInfoForm[field.id];
        });
        this.postWithdrawWireBankInfo(payload).then(function (data) {
          _this4.beneficiaryInfo = data.beneficiaryInfo;
          _this4.showWithdrawalAmountForm = true;
          _this4.showBankInfoForm = false;
          _this4.loaderRemove(document.body);
          _this4.formEnable();
        }).catch(function (error) {
          _this4.loaderRemove(document.body);
          _this4.formHandleErrors(error);
          _this4.formEnable();
        });
      }
    },
    showSwiftModal: function showSwiftModal() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_12__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_SWIFT);
    },
    customFieldsClassModifiers: function customFieldsClassModifiers(field) {
      return {
        column: true,
        'small-6': true,
        'bank-transfer--hidden-column': field.hidden
      };
    },
    suggestionClassModifiers: function suggestionClassModifiers(suggestion) {
      return {
        'bank-transfer__suggestion': true,
        'bank-transfer__suggestion--not-valid': !suggestion.isValid
      };
    },
    onSuggestionPick: function onSuggestionPick(suggestion) {
      if (!suggestion.isValid) return;

      this.hasSearched = false;
      this.fieldsBankInfoForm.bankName = suggestion.name;
      this.fieldsBankInfoForm.streetAddress = suggestion.address1 + ' ' + suggestion.address2;
      this.fieldsBankInfoForm.city = suggestion.city;
      this.fieldsBankInfoForm.region = suggestion.region;
      this.fieldsBankInfoForm.zipCode = suggestion.postalCode;
      this.fieldsBankInfoForm.swiftBicCode = suggestion.swiftCode;
      this.pickedSuggestion = suggestion;
      this.resetWireSearchResults();
    },
    onFieldInput: function onFieldInput(fieldId) {
      var f = this.beneficiaryFields.find(function (i) {
        return i.id === fieldId;
      });
      var vField = this.$v.fieldsBankInfoForm[fieldId];
      vField.errorMessage = (f || {}).errorMessage || '';
      vField.$touch();
    },
    onSearch: function onSearch() {
      var query = this.fieldsBankInfoForm.searchCity + ' ' + this.fieldsBankInfoForm.searchBankName;
      if (this.showAddressSearch) {
        query += ' ' + this.fieldsBankInfoForm.searchAddress;
      }
      if (query && !this.isSearching) {
        this.resetWireSearchResults();
        this.query = query;
        this.loadWireSearch({ reset: true });
      }
    },
    onSuccess: function onSuccess() {
      this.showConfirmation = false;
      this.checkWithdrawBankTransfer();
      this.$emit('success');
    },
    onEdit: function onEdit() {
      this.showConfirmation = false;
    },
    changeBankInformation: function changeBankInformation() {
      this.resetWireSearchResults();
      this.showWithdrawalAmountForm = false;
      this.showBankInfoForm = true;
    },
    onCancel: function onCancel() {
      this.showWithdrawalAmountForm = true;
      this.showBankInfoForm = false;
    },
    checkWithdrawBankTransfer: function checkWithdrawBankTransfer() {
      var _this5 = this;

      this.getWithdrawWire().then(function (data) {
        _this5.checkDocumentUploadFlags(data);
        _this5.disclaimer = data.disclaimer;
        _this5.beneficiaryInfo = data.beneficiaryInfo;
        _this5.beneficiaryFields = (data.beneficiaryFields || []).map(function (field) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, field, {
            value: ''
          });
        });
        _this5.beneficiaryFields.forEach(function (field) {
          _this5.fieldsBankInfoForm = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this5.fieldsBankInfoForm, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, field.id, field.defaultValue || ''));
        });

        _this5.error = data.errorMessage;
        _this5.isComponentReady = true;
        _this5.hasSavedAccount = data.hasSavedAccount;
        _this5.showIbanValidationForm = data.isIbanEnabled && !data.hasSavedAccount;
        _this5.$nextTick(function () {
          if (data.hasSavedAccount) {
            _this5.showWithdrawalAmountForm = true;
          } else {
            _this5.showBankInfoForm = true;
          }
        });
      }).catch(function (error) {
        _this5.isComponentReady = true;
        _this5.error = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(error, 'response.data.message', '') || __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(error, 'response.data.errorMessage', '');
      });
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.resetWireSearchResults();
  },
  mounted: function mounted() {
    this.checkWithdrawBankTransfer();
  }
});

/***/ }),

/***/ "NQP2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NSIw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_snakeCase__ = __webpack_require__("OAqO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_snakeCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_snakeCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_findIndex__ = __webpack_require__("KgVm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");




 /* eslint-disable no-mixed-operators,object-shorthand,max-len */







var CAPTCHA_FIELD = 'g-recaptcha-response';
var CACHE_NAME = 'register';
var MAX_CHARACTERS_USERNAME_PART = 5;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_7__mixins_popupPageModeMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_userAgent__["a" /* default */]],
  data: function data() {
    return {
      // login attempt counter used to rerender captcha on failed login
      attempt: 1,
      usernameShowed: false,
      usernameSource: '',
      fieldTypePassword: 'password',
      latestEmail: '',
      fields: {
        email: '',
        emailConfirmation: '',
        password: '',
        username: '',
        captcha: ''
      },
      timeout: null
    };
  },

  validations: {
    fields: {
      email: __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["a" /* validators */].email,
      emailConfirmation: __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["a" /* validators */].emailConfirmation('email'),
      password: __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["a" /* validators */].password,
      username: __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["a" /* validators */].username,
      captcha: __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["a" /* validators */].captcha
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('popup', ['formDataCache']), {
    showUsername: function showUsername() {
      if (this.usernameShowed) return true;
      var show = !this.$v.fields.email.$invalid && !this.$v.fields.emailConfirmation.$invalid;
      if (show) {
        if (this.fields.username === '') {
          var email = this.fields.email;
          this.usernameSource = __WEBPACK_IMPORTED_MODULE_2_lodash_snakeCase___default()(email.substr(0, email.indexOf('@')));
          this.fields.username = this.suggestUserName();
          this.$v.fields.username.$touch();
          this.tabTo('_', 'password');
          this.usernameShowed = true;
        }
      } else {
        this.fields.username = '';
      }
      return show;
    },
    registerButtonDisabled: function registerButtonDisabled() {
      return this.invalidOrDisabled || !this.fields.captcha;
    }
  }),
  watch: {
    'fields.email': function fieldsEmail(value) {
      if (this.latestEmail && value && value !== this.latestEmail && this.formIsValid() && this.errors.length > 0) {
        this.formReset();
      }
    },
    'fields.emailConfirmation': function fieldsEmailConfirmation(value) {
      if (this.latestEmail && value && value !== this.latestEmail && this.formIsValid() && this.errors.length > 0) {
        this.formReset();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('user', ['login', 'register']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentSmallPopup', 'cacheFormData', 'setCurrentPopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('profile', ['setProfileStatus']), {
    showPassword: function showPassword() {
      this.fieldTypePassword = this.fieldTypePassword === 'password' ? 'text' : 'password';
    },
    onLoginFail: function onLoginFail() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
    },
    loginAfterRegistration: function loginAfterRegistration() {
      var _payload,
          _this = this;

      var payload = (_payload = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_payload, CAPTCHA_FIELD, this.fields.captcha), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_payload, 'email', this.fields.email), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_payload, 'password', this.fields.password), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_payload, 'grant_type', 'password'), _payload);
      if (this.isPage) {
        return this.login(payload).then(function () {
          return _this.$router.push({ name: 'home' });
        }).catch(this.onLoginFail);
      }

      return this.login(payload).then(function () {
        return _this.setCurrentPopup();
      }).catch(this.onLoginFail);
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      var payload = {
        onErrorRecaptchaToken: this.fields.captcha,
        email: this.fields.email,
        password: this.fields.password,
        username: this.fields.username
      };

      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'submit',
        label: 'Create Account'
      });
      if (this.formIsValid() && this.formDisable()) {
        this.register(payload).then(this.formEnable).then(function () {
          return _this2.setProfileStatus({ event: 'registered' });
        }).then(this.loginAfterRegistration).catch(function (e) {
          var data = __WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(e, 'response.data', []);
          var errorCodesEmailExist = ['emailAlreadyInUse'];
          var emailExistsIndex = __WEBPACK_IMPORTED_MODULE_3_lodash_findIndex___default()(data, function (i) {
            return i.code && errorCodesEmailExist.includes(i.code);
          });

          if (emailExistsIndex !== -1) {
            _this2.latestEmail = _this2.fields.email;
            _this2.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ALREADY_EXISTS);
            _this2.setCurrentPopupOptions({ email: _this2.fields.email });
          } else {
            _this2.latestEmail = '';
          }
          _this2.attempt += 1;
          _this2.fields.captcha = null;
          var errorCodesToSuggestUsername = ['restrictedTextInUsername', 'usernameAlreadyInUse'];
          var isUsernameTakenIndex = __WEBPACK_IMPORTED_MODULE_3_lodash_findIndex___default()(data, function (i) {
            return i.code && errorCodesToSuggestUsername.includes(i.code);
          });

          if (isUsernameTakenIndex !== -1) {
            _this2.fields.username = _this2.suggestUserName();
          }

          _this2.formHandleErrors(e);
        });
      }
    },
    showUsernameInfo: function showUsernameInfo() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_USERNAME);
    },
    suggestUserName: function suggestUserName() {
      return '' + this.usernameSource.slice(0, MAX_CHARACTERS_USERNAME_PART) + this.randomNumber();
    },
    randomNumber: function randomNumber() {
      var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10000;
      var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 99999;

      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    onTermsAndConditions: function onTermsAndConditions() {
      var termsAndConditionsRoute = 'terms-and-conditions';
      if (this.$router.currentRoute.name === termsAndConditionsRoute) {
        this.setCurrentPopup();
      } else {
        this.$router.push({ name: termsAndConditionsRoute });
      }
    },
    hideFooter: function hideFooter() {
      window.clearTimeout(this.timeout);
      this.timeout = null;
      this.setCurrentPopupOptions({ hideFooter: true });
    },
    showFooter: function showFooter() {
      var _this3 = this;

      this.timeout = window.setTimeout(function () {
        _this3.setCurrentPopupOptions({});
      }, 200);
    }
  }),
  created: function created() {
    if (this.formDataCache !== null && CACHE_NAME === this.formDataCache.route) {
      this.fields = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.fields, this.formDataCache);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cacheFormData(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.fields, { route: CACHE_NAME }));
  }
});

/***/ }),

/***/ "NVO6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_js__ = __webpack_require__("Wspo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e734f87_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_vue__ = __webpack_require__("foFW");
function injectStyle (ssrContext) {
  __webpack_require__("LygJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposit_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e734f87_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NVwc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-disqus"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Nb1x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Njid":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contracts-history",class:_vm.classModifiers},[(_vm.showLoader)?_c('table-rows-loader',{attrs:{"num":_vm.loaderNum}}):_vm._e(),_vm._v(" "),(_vm.showHeader && _vm.isComponentReady)?_c('div',{class:_vm.headModifiers},[_c('div',{staticClass:"contracts-history__contract"},[_vm._v("\r\n      "+_vm._s(_vm.$txt('contracts-history.contract'))+"\r\n    ")]),_vm._v(" "),_c('div',{staticClass:"contracts-history__profit"},[(_vm.desktopColumns)?[_c('div',{staticClass:"contracts-history__profit-desk"},[_vm._v("\r\n          "+_vm._s(_vm.$txt('contracts-history.profit-loss'))+"\r\n        ")]),_vm._v(" "),_c('div',{staticClass:"contracts-history__profit-fees"},[_vm._v("\r\n          "+_vm._s(_vm.$txt('contracts-history.fee'))+"\r\n        ")])]:[_vm._v("\r\n        "+_vm._s(_vm.$txt('contracts-history.net'))+"\r\n      ")]],2),_vm._v(" "),_c('div',{staticClass:"contracts-history__risk"},[_vm._v("\r\n      "+_vm._s(_vm.$txt('contracts-history.risk'))+"\r\n    ")]),_vm._v(" "),_c('div',{staticClass:"contracts-history__cash"},[_c('plus-minus-sign',{staticClass:"contracts-history__plus-minus"}),_vm._v(" "+_vm._s(_vm.$txt('contracts-history.cash'))+"\r\n    ")],1)]):_vm._e(),_vm._v(" "),(!_vm.showHeader)?_c('div',{staticClass:"contracts-history__line"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contracts-history__list"},[(_vm.compactMode && _vm.contracts.length === 0)?_c('div',{staticClass:"contracts-history__list-message"},[_vm._v("\r\n      "+_vm._s(_vm.$txt('contracts-history.no-trades'))+"\r\n    ")]):_vm._l((_vm.contracts),function(item,index){return _c('contract-tile',{key:index,staticClass:"contracts-history__item",attrs:{"showMarketName":_vm.showMarketNames,"data":item,"compactMode":_vm.compactMode,"desktop":_vm.desktopColumns}})}),_vm._v(" "),(_vm.marketId)?_c('div',{staticClass:"contracts-history__more"},[_c('div',{staticClass:"contracts-history__see"},[_vm._v("\r\n        "+_vm._s(_vm.$txt('contracts-history.detailed'))+" "),(_vm.contracts.length > 0)?_c('router-link',{staticClass:"contracts-history__account-link",attrs:{"to":{ name: 'account-history', params: { marketId: _vm.marketId } }}},[_vm._v(_vm._s(_vm.$txt('contracts-history.history-link')))]):[_vm._v(_vm._s(_vm.$txt('contracts-history.history-link')))]],2)]):_vm._e(),_vm._v(" "),(_vm.canLoadMore)?_c('infinite-loading',{on:{"infinite":_vm.goInfinite}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('div',{staticClass:"contracts-history__spinner"})]),_vm._v(" "),_c('span',{attrs:{"slot":"no-results"},slot:"no-results"}),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})]):_vm._e(),_vm._v(" "),(!_vm.canLoadMore && !_vm.marketId)?_c('div',{staticClass:"contracts-history__loaded-info",domProps:{"innerHTML":_vm._s(_vm.loadedInfo)}}):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Nm85":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NoTp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socials"},[_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--new"},[_vm._v(_vm._s(_vm.title)+" Facebook or Twitter")])]),_vm._v(" "),(_vm.facebookLink)?_c('div',{staticClass:"column small-6"},[_c('a',{staticClass:"socials__button socials__button--facebook",attrs:{"href":_vm.facebookLink},on:{"click":function($event){return _vm.registrationTrack('Facebook')}}})]):_vm._e(),_vm._v(" "),(_vm.twitterLink)?_c('div',{staticClass:"column small-6"},[_c('a',{staticClass:"socials__button socials__button--twitter",attrs:{"href":_vm.twitterLink},on:{"click":function($event){return _vm.registrationTrack('Twitter')}}})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NqVK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_socials_js__ = __webpack_require__("/b9a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f79008ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_socials_vue__ = __webpack_require__("NoTp");
function injectStyle (ssrContext) {
  __webpack_require__("rLrd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_socials_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f79008ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_socials_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nu5K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_content_header_js__ = __webpack_require__("n2FT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09e0e130_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_content_header_vue__ = __webpack_require__("8mne");
function injectStyle (ssrContext) {
  __webpack_require__("uCSF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_content_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09e0e130_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_content_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NvUv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"election-map"},[(_vm.type === 'electoral')?_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12 large-9"},[_c('div',{staticClass:"election-map__content"},[_c('div',{staticClass:"election-map__title"},[_vm._v("\n          Which party will win the Electoral College?\n        ")]),_vm._v(" "),_c('div',{staticClass:"election-map__toolbar"},[_c('election-map-toolbar',{attrs:{"mapStateData":_vm.mapStateData,"type":"electoral"}})],1),_vm._v(" "),_c('div',{ref:"chart",staticClass:"election-map__chart"})])]),_vm._v(" "),_c('div',{staticClass:"column small-12 large-3"},[_c('overview-map',{attrs:{"mapOverviewData":_vm.mapOverviewData,"type":"electoral"}})],1)]):_vm._e(),_vm._v(" "),(_vm.type === 'senate')?_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12 large-9"},[_c('div',{staticClass:"election-map__content"},[_c('div',{staticClass:"election-map__title"},[_vm._v("\n          Which party will win the Senate?\n        ")]),_vm._v(" "),_c('div',{staticClass:"election-map__toolbar"},[_c('election-map-toolbar',{attrs:{"mapStateData":_vm.mapStateDataSenate,"type":"senate"}})],1),_vm._v(" "),_c('div',{ref:"chart",staticClass:"election-map__chart"}),_vm._v(" "),(false)?_c('div',{staticClass:"election-map__special"},[_c('election-map-special')],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"column small-12 large-3"},[_c('overview-map',{attrs:{"mapOverviewData":_vm.mapOverviewDataSenate,"type":"senate"}})],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O1+7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O43h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_js__ = __webpack_require__("QxUi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b535422_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_vue__ = __webpack_require__("8m5v");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b535422_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O7RW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O8vu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_secondary_nav_js__ = __webpack_require__("zV2+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cee6894_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_secondary_nav_vue__ = __webpack_require__("eX9O");
function injectStyle (ssrContext) {
  __webpack_require__("WUho")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_secondary_nav_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cee6894_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_secondary_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O8wz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-header-title-large"},[_c('div',{class:_vm.classModifier},[_c('div',{staticClass:"market-header-title-large__container"},[_c('h1',{staticClass:"market-header-title-large__text",on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[(_vm.isMarketWithinStory)?[_vm._v("Market: ")]:_vm._e(),_vm._v(" "+_vm._s(_vm.market.marketName)+"\n      ")],2)])]),_vm._v(" "),(_vm.watchIconVisible)?_c('div',{staticClass:"market-header-title-large__watch"},[(_vm.watchIconVisible)?_c('market-watch',{attrs:{"layout":"bright","marketId":_vm.market.marketId,"isWatched":_vm.market.isMarketWatched}}):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OGIm":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "OHuv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_appNotification__ = __webpack_require__("qtti");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_appNotification__["a" /* default */]],
  props: {
    icon: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    classModifiers: function classModifiers() {
      return {
        'notification-item-simple': true,
        'notification-item-simple--long': this.text.length > 120
      };
    }
  })
});

/***/ }),

/***/ "OIiS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_show_password_icon_js__ = __webpack_require__("UKGl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d655050_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_show_password_icon_vue__ = __webpack_require__("ZiDD");
function injectStyle (ssrContext) {
  __webpack_require__("eHhE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_show_password_icon_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d655050_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_show_password_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OIwd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "OJH0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AVAILABLE_TIMESPANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DEFAULT_TIMESPANS; });
/* unused harmony export DEFAULT_TIMESPANS_MARKETS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ORDERS_WITH_TIMESPAN_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TIMESPANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectTimespan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectOrder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);




var AVAILABLE_TIMESPANS = {
  TODAY: {
    parameter: 'TODAY',
    name: 'Today'
  },
  '3DAY': {
    parameter: '3DAY',
    name: '3 Days'
  },
  WEEK: {
    parameter: 'WEEK',
    name: 'Week'
  },
  MONTH: {
    parameter: 'MONTH',
    name: 'Month'
  },
  ALL: {
    parameter: 'ALL',
    name: 'All Time'
  },
  EMPTY: {
    parameter: '',
    name: ''
  }
};

var DEFAULT_TIMESPANS = {
  movers: AVAILABLE_TIMESPANS.TODAY,
  traded: AVAILABLE_TIMESPANS.ALL
};

var DEFAULT_TIMESPANS_MARKETS = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DEFAULT_TIMESPANS, {
  traded: AVAILABLE_TIMESPANS.TODAY
});

var ORDERS = [{
  name: 'Volume',
  fullName: 'Trade Volume',
  sort: 'traded'
}, {
  name: 'Price',
  fullName: 'Price Change',
  sort: 'movers'
}, {
  name: 'New Arrivals',
  fullName: 'New Arrivals',
  sort: 'newest'
}, {
  name: 'Expiring',
  fullName: 'Expiring',
  sort: 'closing'
}, {
  name: 'Investment',
  fullName: 'Investment',
  sort: 'investment'
}, {
  name: 'Gain',
  fullName: 'Gain',
  sort: 'gain'
}, {
  name: 'Loss',
  fullName: 'Loss',
  sort: 'loss'
}];

var ORDERS_WITH_TIMESPAN_FILTER = ['movers', 'traded'];

var TIMESPANS = [AVAILABLE_TIMESPANS.TODAY, AVAILABLE_TIMESPANS['3DAY'], AVAILABLE_TIMESPANS.WEEK, AVAILABLE_TIMESPANS.MONTH, AVAILABLE_TIMESPANS.ALL];

var selectTimespan = function selectTimespan(state, parameter) {
  state.selectedTimespan = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(state.timespans, { parameter: parameter });
};

var selectOrder = function selectOrder(state, sort) {
  state.selectedOrder = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(state.orders, { sort: sort });
  state.selectedTimespan = DEFAULT_TIMESPANS_MARKETS[sort] || AVAILABLE_TIMESPANS.EMPTY;
  state.shouldShowTimespanFilter = ORDERS_WITH_TIMESPAN_FILTER.indexOf(state.selectedOrder.sort) !== -1;
};

/***/ }),

/***/ "OL8g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_search_bar_js__ = __webpack_require__("2SRW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_619ac3cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_bar_vue__ = __webpack_require__("pIon");
function injectStyle (ssrContext) {
  __webpack_require__("OLLJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_search_bar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_619ac3cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OLLJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OLUT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_price_change_chart_market_price_change_chart_vue__ = __webpack_require__("ptZl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_contract__ = __webpack_require__("YZ+m");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_1__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    marketPriceChangeChart: __WEBPACK_IMPORTED_MODULE_2__components_market_market_price_change_chart_market_price_change_chart_vue__["a" /* default */]
  },
  props: {
    promo: {
      type: Object
    },
    header: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    contract: function contract() {
      return new __WEBPACK_IMPORTED_MODULE_3__models_contract__["a" /* default */](this.promo);
    },
    iconModifiers: function iconModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'market-biggest-gains-element__icon': true
      }, 'market-biggest-gains-element__icon--' + this.iconTargetClass, this.iconTargetClass);
    },
    iconTargetClass: function iconTargetClass() {
      return this.promo.isGain ? 'price-up' : 'price-down';
    }
  }
});

/***/ }),

/***/ "OQ19":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ORlq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_notifications_list_notifications_list_vue__ = __webpack_require__("R/N+");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    notificationsList: __WEBPACK_IMPORTED_MODULE_2__components_notifications_list_notifications_list_vue__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['closeNotificationsWidget']), {
    onClickOutside: function onClickOutside() {
      this.closeNotificationsWidget();
    }
  })
});

/***/ }),

/***/ "OU80":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"potential-payouts"},[_c('switch-modal',{staticClass:"modal-switch--payouts",on:{"modalClose":_vm.close,"modalToggle":_vm.toggle}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Potential Payouts")]),_vm._v(" "),_c('div',{key:_vm.toggleIndex,staticClass:"potential-payouts__content",class:_vm.classModifier,attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"potential-payouts__market-name"},[_vm._v(_vm._s(_vm.market.marketName))]),_vm._v(" "),_c('table',{staticClass:"potential-payouts__table"},[_c('thead',{staticClass:"potential-payouts__thead"},[_c('th',[_vm._v("Market Outcome")]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('th',{staticClass:"potential-payouts--middle"},[_vm._v("\r\n            You Own\r\n          ")]):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('th',{staticClass:"potential-payouts--middle"},[_vm._v("\r\n            Shares\r\n          ")]):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('th',{staticClass:"potential-payouts--middle"},[_vm._v("\r\n            Average Price\r\n          ")]):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('th',{staticClass:"potential-payouts--middle"},[_vm._v("\r\n            Value\r\n          ")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"potential-payouts--middle"},[_vm._v("Risk")]),_vm._v(" "),_c('th',{staticClass:"potential-payouts--last"},[_vm._v("Payout")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.payouts),function(item,index){return _c('tr',{key:index},[_c('td',{staticClass:"potential-payouts--highlight"},[_vm._v(_vm._s(item.contractName))]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('td',{staticClass:"potential-payouts--middle"},[(item.sharesOwned > 0)?_c('span',[(_vm.isNo(item))?[_vm._v("No")]:[_vm._v("Yes")]],2):_c('span',[_vm._v("\r\n                --\r\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('td',{staticClass:"potential-payouts--middle"},[(item.sharesOwned > 0)?_c('span',{class:_vm.yourOwnModifiers(item)},[_vm._v("\r\n                "+_vm._s(item.sharesOwned)+"\r\n              ")]):_c('span',[_vm._v("\r\n                --\r\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('td',{staticClass:"potential-payouts--middle"},[(item.averagePrice !== 0)?_c('span',[_vm._v("\r\n                "+_vm._s(item.averagePriceString)+"\r\n              ")]):_c('span',[_vm._v("\r\n                --\r\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('td',{staticClass:"potential-payouts--middle"},[(item.investment !== 0)?_c('span',[_vm._v("\r\n                "+_vm._s(item.investmentString)+"\r\n              ")]):_c('span',[_vm._v("\r\n                --\r\n              ")])]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"potential-payouts--middle",class:_vm.isWithGreatestRisk(item) ? 'potential-payouts--greatest' : ''},[_vm._v(_vm._s(item.riskAmountString))]),_vm._v(" "),_c('td',{staticClass:"potential-payouts--last"},[_vm._v(_vm._s(item.payoutAmountString))])])}),0)]),_vm._v(" "),(_vm.showSpinner)?_c('div',{staticClass:"potential-payouts__spinner"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"potential-payouts__description"},[_c('p',{staticClass:"potential-payouts__risk-calculated"},[_vm._v("Risk is calculated to the tenth of a cent, but rounded for display purposes.")]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('a',{ref:"export",on:{"click":_vm.onExport}},[_c('span',{staticClass:"potential-payouts__button"},[_vm._v("Export Full Calculations")])]):_vm._e()])]),_vm._v(" "),_c('div',{attrs:{"slot":"altheader"},slot:"altheader"},[_vm._v("How are Risk and Potential Payouts calculated?")]),_vm._v(" "),_c('div',{key:_vm.toggleIndex,staticClass:"potential-payouts__content",attrs:{"slot":"altcontent"},slot:"altcontent"},[_c('div',{staticClass:"potential-payouts__altcontent"},[_c('p',[_vm._v("Your Risk in any contract is the sum of your profits and losses, across all contracts, should that contract resolve to \"Yes\".")]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('p',[_vm._v("Your Investment in the market as a whole is equal to your greatest Risk in any one contract. This is the amount PredcitIt debits from your account to cover your position.")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Your Potential Payout is the amount you would be credited if the contract resolved to \"Yes\". It is the difference between your total Investment (greatest Risk in any contract) and the Risk in the winning contract.\r\n        ")]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('p',[_vm._v("Share Value corresponds to the face value of your position in each contract (shares multiplied by average purchase price).")]):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('p',[_vm._v("For a full table of these calculations, export the data by clicking the button at the bottom of the table.")]):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('div',{staticClass:"potential-payouts__description potential-payouts__description--alt"},[_c('a',{ref:"export",on:{"click":_vm.onExport}},[_c('span',{staticClass:"potential-payouts__button"},[_vm._v("Export Full Calculations")])])]):_vm._e()])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OUji":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_checkbox_js__ = __webpack_require__("5y3J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e886c8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__ = __webpack_require__("GQqe");
function injectStyle (ssrContext) {
  __webpack_require__("TKqG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_checkbox_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e886c8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OWA8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_dashboard_desktop_js__ = __webpack_require__("KGr/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea5f7454_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_desktop_vue__ = __webpack_require__("Atob");
function injectStyle (ssrContext) {
  __webpack_require__("2i1L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_dashboard_desktop_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea5f7454_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_desktop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Of+R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[(_vm.isLayoutDesktop)?_c('dashboard-desktop'):[(_vm.showSocialBadge)?_c('account-social-badge'):_vm._e(),_vm._v(" "),(_vm.showTabs)?_c('div',{staticClass:"dashboard__tabs"},[_c('tabs',{attrs:{"theme":"dashboard","activeTab":_vm.activeTab,"items":_vm.tabs},on:{"tabChange":_vm.tabChange}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dashboard__content"},[_c('router-view')],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OfZf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getMarkets: function getMarkets() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/0?itemsPerPage=' + limit + '&page=' + page + '&filterIds=&sort=newest');
  }
});

/***/ }),

/***/ "Ohsr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Oi4w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_collapsible_panel_collapsible_panel_vue__ = __webpack_require__("NMl0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_contracts_history_contracts_history_vue__ = __webpack_require__("uath");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_loader__["a" /* default */]],
  components: {
    collapsiblePanel: __WEBPACK_IMPORTED_MODULE_3__components_collapsible_panel_collapsible_panel_vue__["a" /* default */],
    contractsHistory: __WEBPACK_IMPORTED_MODULE_4__components_contracts_history_contracts_history_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isLoaded: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('market', ['contracts', 'history']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('market', ['getMarketHistoryData']), {
    historyContracts: function historyContracts() {
      var data = this.getMarketHistoryData;
      return data.slice(0, 4);
    }
  }),
  watch: {
    isOpen: {
      handler: 'openWatcher',
      immediate: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('market', ['getMarketHistory', 'resetHistory']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup', 'setCurrentPopupOptions']), {
    loadHistory: function loadHistory() {
      var _this = this;

      this.loaderAdd();
      this.getMarketHistory(this.market.marketId).then(function () {
        return _this.loaderRemove();
      }).catch(function () {
        _this.loaderRemove();
        _this.isLoaded = false;
      });
    },
    onInfoClick: function onInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_TRADE_INFO);
      this.setCurrentPopupOptions({ completeInfo: true });
    },
    openWatcher: function openWatcher(open) {
      if (open && !this.isLoaded) {
        this.resetHistory();
        this.isLoaded = true;
        this.loadHistory();
      }
    }
  })
});

/***/ }),

/***/ "OnEi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Oota":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('overlay', ['visible']), {
    classObject: function classObject() {
      return { 'overlay--visible': this.visible };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('overlay', ['hide']))
});

/***/ }),

/***/ "OprK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_maxBy__ = __webpack_require__("K1hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEmpty__ = __webpack_require__("lHK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__ = __webpack_require__("nYw4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_contract__ = __webpack_require__("YZ+m");



 /* eslint-disable no-restricted-syntax,consistent-return */





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ready: false,
      showTooltip: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('market', ['mapStateDataSenate', 'marketMapTooltipVisible']), {
    classModifiers: function classModifiers() {
      return {
        'election-map-special': true,
        'election-map-special--tooltip-visible': this.marketMapTooltipVisible
      };
    },
    legendStyleModifiers: function legendStyleModifiers() {
      return {
        background: this.color
      };
    },
    color: function color() {
      return this.pallette.color;
    },
    targetContract: function targetContract() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash_maxBy___default()(this.mapStateDataSenate.GA2.contracts || [], function (i) {
        return i.lastTradePrice;
      });
    },
    targetContractInstance: function targetContractInstance() {
      return new __WEBPACK_IMPORTED_MODULE_6__models_contract__["a" /* default */](this.targetContract);
    },
    pallette: function pallette() {
      var pallette = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["a" /* getColorForPalletteCandidate */])(this.targetContract.contractName);
      var factor = pallette[0].from + this.targetContract.lastTradePrice;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(pallette), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (factor <= item.to) {
            return item;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }),
  watch: {
    mapStateDataSenate: {
      handler: 'mapStateDataHandler',
      immediate: true
    }
  },
  methods: {
    onClick: function onClick() {
      if (this.isLayoutMobile) {
        var marketId = this.mapStateDataSenate.GA2.marketId;
        if (marketId) {
          window.location.href = 'https://www.predictit.org/markets/detail/' + marketId;
        }
      }
    },
    onMouseEnter: function onMouseEnter() {
      this.showTooltip = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.showTooltip = false;
    },
    mapStateDataHandler: function mapStateDataHandler(value) {
      if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isEmpty___default()(value)) {
        this.ready = true;
      }
    }
  }
});

/***/ }),

/***/ "OtFn":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IiM1NUFDRUUiIHJ4PSIyIi8+DQogICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTE1LjkxMiA2LjE0NmMtLjQzOC4xOTQtLjkxLjMyNi0xLjQwNC4zODRhMi40NSAyLjQ1IDAgMCAwIDEuMDc1LTEuMzUxYy0uNDcyLjI4LS45OTUuNDgzLTEuNTUyLjU5M2EyLjQ0NCAyLjQ0NCAwIDAgMC00LjE2NSAyLjIzQTYuOTM3IDYuOTM3IDAgMCAxIDQuODMgNS40NDZhMi40NDQgMi40NDQgMCAwIDAgLjc1NiAzLjI2MyAyLjQyNyAyLjQyNyAwIDAgMS0xLjEwNy0uMzA2di4wMzFjMCAxLjE4NC44NDMgMi4xNzIgMS45NiAyLjM5NmEyLjQzNSAyLjQzNSAwIDAgMS0xLjEwMy4wNDIgMi40NDcgMi40NDcgMCAwIDAgMi4yODMgMS42OThBNC45MDMgNC45MDMgMCAwIDEgNCAxMy41ODNhNi45MTMgNi45MTMgMCAwIDAgMy43NDYgMS4wOThjNC40OTUgMCA2Ljk1NC0zLjcyNCA2Ljk1NC02Ljk1NGE2Ljk5IDYuOTkgMCAwIDAtLjAwOC0uMzE2IDQuOTU2IDQuOTU2IDAgMCAwIDEuMjItMS4yNjV6Ii8+DQogICAgPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "Ox9w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Oz+7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_detail_charts_checkbox_checkbox_vue__ = __webpack_require__("OUji");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_detail_charts_market_detail_charts__ = __webpack_require__("XSP/");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    formCheckbox: __WEBPACK_IMPORTED_MODULE_4__components_market_market_detail_charts_checkbox_checkbox_vue__["a" /* default */]
  },
  props: {
    contracts: {
      type: Array,
      required: true
    },
    fillWithBlankColumns: { // so it's always fixed height
      type: Boolean,
      default: false
    },
    chartOptions: {
      type: Object,
      default: null
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('market', ['chartType']), {
    showImage: function showImage() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(this.chartOptions, 'showContractImagesOnLegend', false);
    },
    blankColumns: function blankColumns() {
      return this.contracts.length < __WEBPACK_IMPORTED_MODULE_5__components_market_market_detail_charts_market_detail_charts__["a" /* INITIAL_MAX_CONTRACTS */] ? __WEBPACK_IMPORTED_MODULE_1_lodash_range___default()(0, __WEBPACK_IMPORTED_MODULE_5__components_market_market_detail_charts_market_detail_charts__["a" /* INITIAL_MAX_CONTRACTS */] - this.contracts.length) : [];
    }
  }),
  methods: {
    contractName: function contractName(item) {
      var chartIndex = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(this.chartOptions, 'chartIndex', null);
      if (chartIndex !== null) {
        return 'checkbox-' + chartIndex + '-' + item.contractName + '-' + item.marketId;
      }
      return 'checkbox-' + item.contractName + '-' + item.marketId;
    },
    imageStyleModifiers: function imageStyleModifiers(item) {
      return {
        'border-color': item.lineColor,
        'background-image': 'url(' + item.contractImageSmallUrl + ')'
      };
    },
    onChange: function onChange(item, checked) {
      this.$emit('toggleItem', item, checked);
    },
    checkboxColor: function checkboxColor(item) {
      if (this.chartType === 'candle') return '#204b52';
      return item.additional ? item.additionalLineColor : item.lineColor;
    },
    tradeVolumeDisplay: function tradeVolumeDisplay(item) {
      if (item.tradeVolume !== null) {
        return '' + item.tradeVolume;
      }
      return '-';
    },
    chartPriceDisplay: function chartPriceDisplay(item) {
      if (item.chartPrice !== null) {
        return item.chartPrice + '\xA2';
      }
      return '-';
    }
  }
});

/***/ }),

/***/ "P+qc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"back-button",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onButtonClick($event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P3fZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


var CURRENCY_CENTS = '&cent;';
var CURRENCY_DOLLARS = '$';

function setPrice(el, binding) {
  var sourcePrice = binding.value || 0;
  var absolutePrice = Math.abs(sourcePrice);
  if (binding.modifiers.round2) {
    absolutePrice = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(absolutePrice);
  }
  var currency = binding.modifiers.cents ? CURRENCY_CENTS : CURRENCY_DOLLARS;
  // Display 100cents as $1
  if (absolutePrice === 100 && currency === CURRENCY_CENTS) {
    currency = CURRENCY_DOLLARS;
    absolutePrice = 1;
  }
  var formattedPrice = absolutePrice;
  if (binding.modifiers.floor) {
    absolutePrice = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["v" /* roundDown */])(absolutePrice);
  }
  if (binding.modifiers.fixed) {
    formattedPrice = absolutePrice.toFixed(2);
  }
  if (binding.modifiers.fixed3) {
    formattedPrice = absolutePrice.toFixed(3);
  }
  var p = formattedPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  var text = currency === CURRENCY_CENTS ? '' + p + currency : '' + currency + p;
  el.innerHTML = sourcePrice >= 0 ? text : '(' + text + ')';
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    setPrice(el, binding);
  },
  update: function update(el, binding) {
    setPrice(el, binding);
  }
});

/***/ }),

/***/ "P3oX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("8/3H");

/* eslint-disable no-console */







var ERROR_STATUS_CODES = [500, 501, 502, 503, 504];
var UNAUTHORIZED_STATUS_CODE = 401;

var refreshSubscribers = [];
var isRefreshing = false;

function tokenRefreshSubscribe(cb) {
  refreshSubscribers.push(cb);
}

function tokenRefreshComplete(token) {
  refreshSubscribers.map(function (cb) {
    return cb(token);
  });
  refreshSubscribers = [];
}

/* harmony default export */ __webpack_exports__["a"] = (function (error) {
  if (!error.response) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  }
  var config = error.config,
      status = error.response.status;

  var originalRequest = config;

  if (status === UNAUTHORIZED_STATUS_CODE) {
    __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].info('[TOKEN] Unauthorized');
    if (!isRefreshing) {
      isRefreshing = true;
      var payload = {
        grant_type: 'refresh_token',
        refresh_token: __WEBPACK_IMPORTED_MODULE_4__helpers_localStorage__["a" /* default */].get('refreshToken')
      };
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('user/login', payload).then(function () {
        isRefreshing = false;
        __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].info('[TOKEN] REFRESHED');
        tokenRefreshComplete(__WEBPACK_IMPORTED_MODULE_4__helpers_localStorage__["a" /* default */].get('token'));
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].info('[TOKEN] CANNOT REFRESH');
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('user/setToken', null);
      });
    }

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      tokenRefreshSubscribe(function (token) {
        originalRequest.headers.Authorization = 'Bearer ' + token;
        __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].info('[TOKEN] Retry');
        resolve(__WEBPACK_IMPORTED_MODULE_1_axios___default()(originalRequest));
      });
    });
  }

  if (error.response) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* checkResponseForApiGoingOffline */])(error.response);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* checkResponseForMaintenance */])(error.response);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* checkResponseForTaxInfo */])(error.response);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["d" /* checkResponseForDocumentUpload */])(error.response);
    __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].error('API - ERROR', error.response.status, error.response.config.url);
    if (ERROR_STATUS_CODES.indexOf(error.response.status) !== -1) {
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('app/setServerError', true);
    }
  } else if (error.request) {
    __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].error('The request was made but no response was received');
  } else {
    __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].error('Something happened in setting up the request that triggered an error');
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/***/ }),

/***/ "P40+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P5pR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P71F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_content_loader__ = __webpack_require__("SHAV");




var contentLoaderMixin = {
  components: {
    AccountFormLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["a" /* AccountFormLoader */],
    AccountWithdrawalLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["b" /* AccountWithdrawalLoader */],
    LeaderboardsInfoLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["c" /* LeaderboardsInfoLoader */],
    MarketLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["d" /* MarketLoader */],
    MarketSharesItemLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["e" /* MarketSharesItemLoader */],
    MarketWidgetLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["f" /* MarketWidgetLoader */],
    NotificationLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["g" /* NotificationLoader */],
    BiggestGainsLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["h" /* BiggestGainsLoader */],
    TableRowsLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["i" /* TableRowsLoader */],
    OverviewMapLoader: __WEBPACK_IMPORTED_MODULE_1__components_content_loader__["j" /* OverviewMapLoader */]
  },
  data: function data() {
    return {
      isComponentReady: false
    };
  },

  methods: {
    loaderItems: function loaderItems(number) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(0, number);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (contentLoaderMixin);

/***/ }),

/***/ "P9X2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile"},[_c('account-social-badge'),_vm._v(" "),_c('div',{staticClass:"profile__menu"},[_vm._l((_vm.links),function(link){return (_vm.isLinkAvailable(link))?_c('router-link',{key:link.name,class:_vm.profileButtonClass(link),attrs:{"to":{name: link.pathName},"tag":"div"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-10"},[_c('div',{staticClass:"profile__button-link-name"},[_vm._v("\n            "+_vm._s(link.name)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"column small-2"},[_c('div',{staticClass:"profile__button-nav-icon  profile__button-arrow-right"})])])]):_vm._e()}),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width profile__button-logout",on:{"click":_vm.logoutButton}},[_vm._v("\n      LOGOUT\n    ")])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PElc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_quotes_js__ = __webpack_require__("FITW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4396287a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quotes_vue__ = __webpack_require__("N1CV");
function injectStyle (ssrContext) {
  __webpack_require__("V4/F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_quotes_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4396287a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quotes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PMOm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_TYPES_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALL_YEARS_OPTION; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_notifications_proxy__ = __webpack_require__("a0yF");















var ITEMS_PER_HISTORY_PAGE = 10;
var DEFAULT_HISTORY = {
  data: [],
  page: 0,
  totalCount: -1,
  canLoadMore: true,
  marketId: -1
};
var DEFAULT_PRICE_CHANGE = 10;

var ALL_TYPES_OPTION = { label: 'All Transactions', value: 'ALL' };
var ALL_YEARS_OPTION = { label: 'All', value: '' };

var TYPE_OPTIONS = [ALL_TYPES_OPTION, { label: 'Deposits', value: 'DEPOSITS' }, { label: 'Withdrawals', value: 'WITHDRAWALS' }, { label: 'Promotions', value: 'PROMOTIONS' }];

function makeYearsOptions(obj) {
  var years = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(obj.keys())).sort().reduceRight(function (filter, year) {
    filter.push({ label: year, value: year.toString() });
    return filter;
  }, []);
  years.unshift(ALL_YEARS_OPTION);
  return years;
}

/* harmony default export */ __webpack_exports__["c"] = ({
  namespaced: true,
  state: {
    portfolioChart: {
      history: []
    },
    userAffiliations: [],
    profileStatus: {},
    profileDetail: {},
    tradeHistory: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY),
    transactionHistory: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY),
    marketHistory: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY),
    pendingHistory: [],
    marketPayouts: null,
    tradedMarkets: [],
    tradedMarketsLoaded: false,
    watchToggle: false,
    isUCAffilSet: false,
    settings: {
      display: {},
      privacy: {},
      InAppNotifications: {},
      PushNotifications: {}
    }
  },
  mutations: {
    resetTransactionHistory: function resetTransactionHistory(state) {
      state.transactionHistory = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY);
    },
    resetTradeHistory: function resetTradeHistory(state) {
      state.tradeHistory = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY);
    },
    resetMarketHistory: function resetMarketHistory(state) {
      state.marketHistory = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY);
    },
    updateTransactionHistory: function updateTransactionHistory(state, payload) {
      var data = state.transactionHistory.data.concat(payload.data.fundsHistoryViewModel);
      state.pendingHistory = payload.data.fundsPendingViewModel;
      var page = payload.page;
      var totalCount = payload.data.totalItems;
      var canLoadMore = totalCount > data.length;

      state.transactionHistory = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, state.transactionHistory, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    updateTradeHistory: function updateTradeHistory(state, payload) {
      var current = state[payload.what];
      var history = void 0;

      if (current.marketId !== payload.marketId || payload.contractId !== current.contractId) {
        history = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(DEFAULT_HISTORY);
      } else {
        history = current;
      }
      var data = history.data.concat(payload.data.historyList);
      var page = payload.page;
      var marketId = payload.marketId;
      var contractId = payload.contractId;
      var totalCount = payload.data.totalCount;
      var canLoadMore = totalCount > data.length;

      state[payload.what] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, state[payload.what], {
        data: data,
        page: page,
        marketId: marketId,
        contractId: contractId,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    updateMarketPayouts: function updateMarketPayouts(state, payload) {
      state.marketPayouts = payload;
    },
    setProfileDetail: function setProfileDetail(state, data) {
      state.profileDetail = data;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        gtmUserID: data.userGuid,
        otmUserID: data.otmUserId
      });
    },
    setProfileStatus: function setProfileStatus(state, data) {
      state.profileStatus = data;
    },
    updateTradedMarkets: function updateTradedMarkets(state, payload) {
      state.tradedMarkets = payload;
      state.tradedMarketsLoaded = true;
    },
    clearTradedMarkets: function clearTradedMarkets(state) {
      state.tradedMarkets = [];
      state.tradedMarketsLoaded = false;
    },
    updateTransactionFilters: function updateTransactionFilters(state, payload) {
      state.transactionFilters = payload;
    },
    setPortfolioChart: function setPortfolioChart(state, data) {
      state.portfolioChart = data;
    },
    updateSettingsCategory: function updateSettingsCategory(state, payload) {
      var categories = payload.reduce(function (acc, _ref) {
        var category = _ref.category,
            keyName = _ref.keyName,
            value = _ref.value;

        if (acc[category] === undefined) {
          acc[category] = {};
        }
        // converting to boolean if true/false
        var boolValue = null;
        if (value === 'true') {
          boolValue = true;
        }
        if (value === 'false') {
          boolValue = false;
        }
        var parsed = value;
        if (keyName === 'ContractPriceChangeAmount') {
          parsed = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int___default()(value, 10);
          if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default()(parsed)) {
            parsed = DEFAULT_PRICE_CHANGE;
          }
        }
        acc[category][keyName] = boolValue !== null ? boolValue : parsed;
        return acc;
      }, {});
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(categories).forEach(function (k) {
        state.settings[k] = categories[k];
      });
    },
    updateSettings: function updateSettings(state, _ref2) {
      var category = _ref2.category,
          key = _ref2.key,
          value = _ref2.value;

      state.settings[category][key] = value;
    },
    toggleWatch: function toggleWatch(state) {
      state.watchToggle = !state.watchToggle;
    },
    updateProfileFromNotification: function updateProfileFromNotification(state, data) {
      state.profileDetail = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["D" /* updateObjectValues */])(state.profileDetail, data, __WEBPACK_IMPORTED_MODULE_12__services_notifications_proxy__["o" /* ACCOUNT_FUNDS_MAP */]);
    },
    setUserAffiliations: function setUserAffiliations(state, data) {
      state.userAffiliations = data;
    },
    setIsUCAffilSet: function setIsUCAffilSet(state, data) {
      state.isUCAffilSet = data;
    }
  },
  getters: {
    transactionFilters: function transactionFilters(state) {
      if (state.transactionHistory.data) {
        var registrationYear = __WEBPACK_IMPORTED_MODULE_9_moment___default.a.utc(state.profileDetail.dateRegistered).year();
        var currentYear = new Date().getFullYear();
        var yearPairs = __WEBPACK_IMPORTED_MODULE_8_lodash_range___default()(registrationYear, currentYear + 1).map(function (i) {
          return [i, i];
        });
        var yearsMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a(yearPairs);
        var yearOptions = makeYearsOptions(yearsMap);
        return { yearOptions: yearOptions, typeOptions: TYPE_OPTIONS };
      }
      return { yearOptions: [], typeOptions: TYPE_OPTIONS };
    },
    showBidAsk: function showBidAsk(state) {
      return state.settings.display.ShowBidAsk;
    },
    settingsReady: function settingsReady(state) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.settings.privacy).length > 0 && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.settings.InAppNotifications).length > 0 && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.settings.PushNotifications).length > 0;
    }
  },
  actions: {
    getTradeHistory: function getTradeHistory(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$marketId = _ref4.marketId,
          marketId = _ref4$marketId === undefined ? '' : _ref4$marketId,
          _ref4$contractId = _ref4.contractId,
          contractId = _ref4$contractId === undefined ? '' : _ref4$contractId;

      var what = marketId === '' ? 'tradeHistory' : 'marketHistory';
      var history = state[what];
      var force = history.marketId !== marketId || contractId !== history.contractId;

      if (force || history.canLoadMore) {
        var page = force ? 1 : history.page + 1;
        return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getTradeHistory(ITEMS_PER_HISTORY_PAGE, page, marketId, contractId).then(function (response) {
          commit('updateTradeHistory', {
            page: page,
            data: response.data,
            marketId: marketId,
            contractId: contractId,
            what: what
          });
        });
      }
      return null;
    },
    getTransactionHistory: function getTransactionHistory(_ref5, _ref6) {
      var state = _ref5.state,
          commit = _ref5.commit;
      var _ref6$type = _ref6.type,
          type = _ref6$type === undefined ? 'ALL' : _ref6$type,
          _ref6$year = _ref6.year,
          year = _ref6$year === undefined ? '' : _ref6$year;

      if (state.transactionHistory.canLoadMore) {
        var page = state.transactionHistory.page + 1;
        return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getTransactionHistory(ITEMS_PER_HISTORY_PAGE, page, type, year).then(function (response) {
          commit('updateTransactionHistory', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return null;
    },
    clearMarketPayouts: function clearMarketPayouts(_ref7) {
      var commit = _ref7.commit;

      commit('updateMarketPayouts', null);
    },
    getMarketPayouts: function getMarketPayouts(_ref8, marketId) {
      var commit = _ref8.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getMarketPayouts(marketId).then(function (response) {
        commit('updateMarketPayouts', response.data);
      });
    },
    getProfileDetail: function getProfileDetail(_ref9) {
      var commit = _ref9.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getProfileDetail().then(function (response) {
        commit('setProfileDetail', response.data);
        return response.data;
      });
    },
    getTradedMarkets: function getTradedMarkets(_ref10, _ref11) {
      var commit = _ref10.commit,
          state = _ref10.state;
      var _ref11$cache = _ref11.cache,
          cache = _ref11$cache === undefined ? false : _ref11$cache;

      if (cache && state.tradedMarketsLoaded) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.tradedMarkets);
      }
      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getTradeHistoryMarkets().then(function (response) {
        commit('updateTradedMarkets', response.data);
        return response.data;
      });
    },
    resetTransactionHistory: function resetTransactionHistory(_ref12) {
      var commit = _ref12.commit;

      commit('resetTransactionHistory');
    },
    resetTradeHistory: function resetTradeHistory(_ref13) {
      var commit = _ref13.commit;

      commit('resetTradeHistory');
    },
    resetMarketHistory: function resetMarketHistory(_ref14) {
      var commit = _ref14.commit;

      commit('resetMarketHistory');
    },
    addMarketToWatchList: function addMarketToWatchList(_ref15, marketId) {
      var commit = _ref15.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.putMarketWatch(marketId).then(function (response) {
        commit('toggleWatch');
        return response.data;
      });
    },
    removeMarketFromWatchList: function removeMarketFromWatchList(_ref16, marketId) {
      var commit = _ref16.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.deleteMarketWatch(marketId).then(function (response) {
        commit('toggleWatch');
        return response.data;
      });
    },
    getPortfolioChart: function getPortfolioChart(_ref17, _ref18) {
      var commit = _ref17.commit;
      var timespan = _ref18.timespan;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getPortfolioChart(timespan).then(function (response) {
        commit('setPortfolioChart', response.data);
        return response.data;
      });
    },
    updateSettings: function updateSettings(_ref19, payload) {
      var commit = _ref19.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.putSettings(payload.category, payload.key, payload.value).then(function (response) {
        commit('updateSettings', payload);
        return response.data;
      });
    },
    getAllSettings: function getAllSettings(_ref20) {
      var commit = _ref20.commit;

      var categories = ['Display', 'InAppNotifications', 'PushNotifications', 'Privacy'].map(function (i) {
        return i.toLowerCase();
      }).join();
      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getAllSettings(categories).then(function (response) {
        commit('updateSettingsCategory', response.data);
        return response.data;
      });
    },
    updateProfileFromNotification: function updateProfileFromNotification(_ref21, payload) {
      var commit = _ref21.commit;

      commit('updateProfileFromNotification', payload);
    },
    clearTradedMarkets: function clearTradedMarkets(_ref22) {
      var commit = _ref22.commit;

      commit('clearTradedMarkets');
    },
    setProfileStatus: function setProfileStatus(_ref23, data) {
      var commit = _ref23.commit;

      commit('setProfileStatus', data);
    },
    sendInviteEmail: function sendInviteEmail(_ref24, email) {
      var commit = _ref24.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.postSendInviteEmail(email).then(function (response) {
        return response.data;
      });
    },
    getUserAffiliations: function getUserAffiliations(_ref25) {
      var commit = _ref25.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getUserAffiliations().then(function (response) {
        var data = response.data;
        commit('setIsUCAffilSet', data.isUCAffilSet);
        commit('setUserAffiliations', data.affiliateEntities || []);
        return response.data;
      });
    },
    setUserAffiliations: function setUserAffiliations(_ref26, payload) {
      var commit = _ref26.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.setUserAffiliations(payload).then(function (response) {
        return response.data;
      });
    },
    removeUserAffiliations: function removeUserAffiliations(_ref27, payload) {
      var commit = _ref27.commit;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.removeUserAffiliations(payload).then(function (response) {
        return response.data;
      });
    },
    getAffiliations: function getAffiliations(_ref28, search) {
      var _ = _ref28._;

      return __WEBPACK_IMPORTED_MODULE_10__services_api__["a" /* default */].profile.getAffiliations(search).then(function (response) {
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "PMnD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_related_js__ = __webpack_require__("RqeL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f2ec200_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_related_vue__ = __webpack_require__("bWQR");
function injectStyle (ssrContext) {
  __webpack_require__("1ado")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_related_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f2ec200_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_related_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PMqM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PTlq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PUQq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pending-requests"},[(!_vm.isComponentReady)?[_c('account-withdrawal-loader'),_vm._v(" "),_c('account-withdrawal-loader'),_vm._v(" "),_c('account-withdrawal-loader')]:[_vm._l((_vm.pendingRequests),function(request){return (_vm.pendingRequests.length > 0)?_c('pending-request',{key:request.confirmationNumber,staticClass:"pending-requests__item",attrs:{"request":request},on:{"success":_vm.onSuccess}}):_vm._e()}),_vm._v(" "),(_vm.pendingRequests.length === 0)?_c('p',{staticClass:"pending-requests__info"},[_vm._v("\n      You have no withdrawals pending.\n    ")]):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PUuo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_modals_js__ = __webpack_require__("HP6i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ac910c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_modals_vue__ = __webpack_require__("eNoA");
function injectStyle (ssrContext) {
  __webpack_require__("2x63")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_modals_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ac910c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_modals_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PVzo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_sitemap_js__ = __webpack_require__("sof5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce93b8ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_sitemap_vue__ = __webpack_require__("3whs");
function injectStyle (ssrContext) {
  __webpack_require__("Yz9l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_sitemap_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce93b8ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_sitemap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PadP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Paoj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_1__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  props: {
    mode: {
      type: String,
      required: true
    },
    number: {
      type: Number,
      required: true
    },
    average: {
      type: Number,
      required: true
    },
    difference: {
      type: Number,
      required: true
    },
    lastClosePrice: {},
    numberOnly: {
      type: Boolean,
      default: false
    },
    avgPriceOnly: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    },
    changePriceTheme: {
      type: String,
      default: ''
    }
  },
  computed: {
    text: function text() {
      return this.theme === 'mobile' ? '&nbsp;&nbsp;Avg. Paid' : 'avg. paid';
    },
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {
        'market-shares-bar': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-shares-bar--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-shares-bar--yes', this.mode === 'yes'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-shares-bar--no', this.mode === 'no'), _ref;
    }
  },
  methods: {
    onClickNumber: function onClickNumber() {
      this.$emit('click');
    }
  }
});

/***/ }),

/***/ "PiJZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PlD9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"biggest-gains-loader"},[_c('div',{staticClass:"biggest-gains-loader__header"},[_c('div',{staticClass:"biggest-gains-loader__header-text"})]),_vm._v(" "),_c('div',{staticClass:"biggest-gains-loader__content"},[_c('div',{staticClass:"biggest-gains-loader-text-1"}),_vm._v(" "),_c('div',{staticClass:"biggest-gains-loader-text-2"}),_vm._v(" "),_c('div',{staticClass:"biggest-gains-loader-text-3"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PqvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_dashboard_portfolio_js__ = __webpack_require__("v8MK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b48e1510_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_portfolio_vue__ = __webpack_require__("fp8t");
function injectStyle (ssrContext) {
  __webpack_require__("GH8/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_dashboard_portfolio_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b48e1510_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_portfolio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q+Dx":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Q+EN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ContractChartGroupStock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContractChartGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PriceChangeChart; });
/* unused harmony export DashboardPortfolioSummaryChart */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ElectionMapChartOverall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ElectionMapChartParty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ElectionMapChartSenate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_maxBy__ = __webpack_require__("K1hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_market_market_state_tooltip_market_state_tooltip_vue__ = __webpack_require__("Vnj/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_market_market_contract_image_market_contract_image_vue__ = __webpack_require__("nygi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__ = __webpack_require__("nYw4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_market_market_detail_charts_timeline_timeline_vue__ = __webpack_require__("GebD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__models_contract__ = __webpack_require__("YZ+m");















 /* global Highcharts:false */
/* eslint-disable */












var DATE_MONTHLY_FORMAT = 'DD MMM';
var DATE_YEARLY_FORMAT = 'DD MMM YYYY';
var CONTRACT_BAR_CHART_GRADIENT = '#c6ebf2';
var CONTRACT_BAR_CHART_GRADIENT_STOCK = '#7ed2e2';
var CONTRACT_LINE_CHART_MARKER_FILL_COLOR = '#fff';
var CONTRACT_SELECTION_COLOR = '#c97575';
var CONTRACT_SELECTION_COLOR_ALT = '#fff';

var MarketStateTooltipComponent = __WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_20__components_market_market_state_tooltip_market_state_tooltip_vue__["a" /* default */]);
var MarketContractImageComponent = __WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_21__components_market_market_contract_image_market_contract_image_vue__["a" /* default */]);

function splitArray(arr, size) {
  var result = [];
  var noOfChunks = Math.ceil(arr.length / size);
  for (var i = 0; i < noOfChunks; i += 1) {
    result.push(arr.slice(i * size, (i + 1) * size));
  }
  return result;
}

function volumeRoundUp(num, base) {
  return num % base !== 0 ? num - num % base + base : num;
}

function volumeGetBase(num) {
  if (num >= 10000) return 10000;
  if (num >= 5000) return 5000;
  if (num >= 2500) return 2500;
  if (num >= 1000) return 1000;
  if (num >= 500) return 500;
  if (num >= 250) return 250;
  if (num >= 100) return 100;
  if (num >= 10) return 10;
  return 1;
}

function volumeNormalize(num, base, parts) {
  var result = num;
  if (result % parts === 0) return result;
  do {
    result = result + base;
  } while (result % parts !== 0);
  return result;
}

function volumeGetRange(num) {
  var parts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

  var base = volumeGetBase(num);
  var max = volumeRoundUp(num, base);
  var normalizedMax = volumeNormalize(max, base, parts);
  var diff = normalizedMax / parts;
  return __WEBPACK_IMPORTED_MODULE_13_lodash_range___default()(0, normalizedMax + diff, diff);
}

function getTradeVolumeTickPositions(data, parts) {
  var max = Math.max.apply(null, data);
  if (max >= parts) {
    return volumeGetRange(max, parts);
  }
  return undefined;
}

Highcharts.SVGRenderer.prototype.symbols.download = function (x, y, w, h) {
  return [
  // Arrow stem
  'M', x + w * 0.5, y, 'L', x + w * 0.5, y + h * 0.7,
  // Arrow head
  'M', x + w * 0.3, y + h * 0.5, 'L', x + w * 0.5, y + h * 0.7, 'L', x + w * 0.7, y + h * 0.5,
  // Box
  'M', x, y + h * 0.9, 'L', x, y + h, 'L', x + w, y + h, 'L', x + w, y + h * 0.9];
};

function getExporting() {
  if (__WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].getters['app/isLayoutMobile']) {
    return {
      enabled: false
    };
  }
  return {
    enabled: false
  };
}

var ContractChartGroupStock = function () {
  function ContractChartGroupStock(_ref) {
    var market = _ref.market,
        timeline = _ref.timeline,
        data = _ref.data,
        _ref$chartOptions = _ref.chartOptions,
        chartOptions = _ref$chartOptions === undefined ? {} : _ref$chartOptions,
        _ref$prepare = _ref.prepare,
        prepare = _ref$prepare === undefined ? true : _ref$prepare;

    __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_classCallCheck___default()(this, ContractChartGroupStock);

    this.market = market;
    this.contracts = market.contracts;
    this.timeline = timeline;
    this.data = data;
    this.contractXaxis = [];
    this.volume = [];
    this.stock = [];
    this.lastXaxisLabelIndex = 0;
    this.contractXaxis = [];
    this.chartOptions = chartOptions;
    if (prepare) this.prepareChartGroupData();
  }

  __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_createClass___default()(ContractChartGroupStock, [{
    key: 'isTimelineDaily',
    value: function isTimelineDaily() {
      return this.timeline.includes('h');
    }
  }, {
    key: 'prepareDateString',
    value: function prepareDateString(contractData, index, total) {
      var label = void 0;
      if (this.isTimelineDaily()) {
        var value = -(total - index);
        label = value + 'h';
      } else {
        label = __WEBPACK_IMPORTED_MODULE_16_moment___default()(contractData.date).format(DATE_MONTHLY_FORMAT);
      }
      this.contractXaxis[index] = label;
    }
  }, {
    key: 'prepareChartGroupData',
    value: function prepareChartGroupData() {
      var _this = this;

      this.data.forEach(function (item, index) {
        _this.prepareDateString(item, index, _this.data.length);
        _this.prepareSeries(index, item);
      });
    }
  }, {
    key: 'getCandleStickChartData',
    value: function getCandleStickChartData() {
      var name = this.data.length > 1 ? this.data[0].contractName : '';
      var that = this;
      return {
        id: 'candle',
        type: 'candlestick',
        showInLegend: false,
        data: this.stock,
        name: name,
        tooltip: {
          valueSuffix: '¢',
          pointFormatter: function volumeTooltipFormatter(i) {
            var point = {
              open: this.open,
              low: this.low,
              high: this.high,
              close: this.close,
              date: that.contractXaxis[this.index]
            };
            return '<small>' + point.date + '</small><br><b>Open</b>: ' + point.open + '\xA2<br/><b>High</b>: ' + point.high + '\xA2<br/><b>Low</b>: ' + point.low + '\xA2<br/><b>Close</b>: ' + point.close + '\xA2';
          }
        }
      };
    }
  }, {
    key: 'getVolumeChartData',
    value: function getVolumeChartData() {
      var that = this;
      return {
        id: 'volume',
        yAxis: 1,
        color: {
          linearGradient: [0, 0, 0, 92],
          stops: [[0, CONTRACT_BAR_CHART_GRADIENT_STOCK], [1, CONTRACT_BAR_CHART_GRADIENT_STOCK]]
        },
        data: this.volume,
        showInLegend: false,
        name: 'Total Volume',
        borderRadius: 2,
        type: 'column',
        tooltip: {
          pointFormatter: function volumeTooltipFormatter() {
            return '<small>' + that.contractXaxis[this.index] + '</small><br>Total Volume: <strong>' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["h" /* largeNumberDisplay */])(this.y, false) + '</strong>';
          }
        }
      };
    }
  }, {
    key: 'prepareSeries',
    value: function prepareSeries(index, item) {
      var timestamp = +__WEBPACK_IMPORTED_MODULE_16_moment___default()(item.date);
      this.volume[index] = [timestamp, Number((item.tradeVolume || 0).toFixed(1))];
      this.stock[index] = [timestamp, Number((100 * (item.openSharePrice || 0)).toFixed(2)), Number((100 * (item.highSharePrice || 0)).toFixed(2)), Number((100 * (item.lowSharePrice || 0)).toFixed(2)), Number((100 * (item.closeSharePrice || 0)).toFixed(2))];
    }
  }, {
    key: 'getXaxisLabel',
    value: function getXaxisLabel() {
      var label = this.contractXaxis[this.lastXaxisLabelIndex];
      this.lastXaxisLabelIndex += 1;
      return label;
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var series = [this.getCandleStickChartData(), this.getVolumeChartData()];
      var max = undefined;
      var tickPositions = undefined;
      var values = [];

      series[1].data.forEach(function (i) {
        values.push(i[1]);
      });
      if (values.every(function (v) {
        return v === values[0];
      })) {
        max = 100;
        tickPositions = [0, 20, 40, 60, 80, 100, 120];
      }

      return {
        navigator: {
          enabled: false
        },
        scrollbar: {
          enabled: false
        },
        rangeSelector: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        title: {
          text: ''
        },
        credits: {
          enabled: false
        },
        xAxis: [{
          tickLength: 0,
          lineWidth: 0,
          labels: {
            formatter: function xAxisLabelFormatter() {
              return '';
            }
          }
        }],
        yAxis: [{
          max: max,
          tickPositions: tickPositions,
          allowDecimals: false,
          labels: {
            align: 'right',
            x: -3,
            formatter: function yAxisLabelFormatter() {
              if (this.value >= 0) {
                return this.value + '\xA2';
              }
            }
          },
          title: {
            text: ''
          },
          top: '0px',
          height: '205px',
          offset: 25,
          resize: {
            enabled: true
          }
        }, {
          allowDecimals: false,
          labels: {
            align: 'right',
            x: -3,
            formatter: function yAxisOppositeLabelFormatter() {
              if (this.value >= 0) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["h" /* largeNumberDisplay */])(this.value, false);
              }
            }
          },
          title: {
            text: ''
          },
          top: '225px',
          height: '140px',
          offset: 25
        }],
        plotOptions: {
          candlestick: {
            color: '#07a0bb',
            upColor: '#ffffff'
          }
        },
        tooltip: {
          split: true,
          shared: false,
          headerFormat: ''
        },
        series: series,
        exporting: {
          enabled: false
        }
      };
    }
  }, {
    key: 'draw',
    value: function draw(container) {
      var options = this.getOptions();
      return Highcharts.stockChart(container, options);
    }
  }], [{
    key: 'renderTimeout',
    value: function renderTimeout() {
      return 300;
    }
  }]);

  return ContractChartGroupStock;
}();

var ContractChartGroup = function () {
  function ContractChartGroup(_ref2) {
    var market = _ref2.market,
        timeline = _ref2.timeline,
        data = _ref2.data,
        _ref2$chartOptions = _ref2.chartOptions,
        chartOptions = _ref2$chartOptions === undefined ? {} : _ref2$chartOptions,
        _ref2$prepare = _ref2.prepare,
        prepare = _ref2$prepare === undefined ? true : _ref2$prepare;

    __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_classCallCheck___default()(this, ContractChartGroup);

    this.market = market;
    this.contracts = market.contracts;
    this.timeline = timeline;
    this.data = data;
    this.contractSeries = {};
    this.contractSeriesNameId = {};
    this.volume = {};
    this.contractXaxis = [];
    this.priceLineType = 'line';
    this.volumeLineType = 'column';
    this.chartOptions = chartOptions;
    if (prepare) this.prepareChartGroupData();
  }

  __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_createClass___default()(ContractChartGroup, [{
    key: 'getVolumeChartData',
    value: function getVolumeChartData() {
      return {
        yAxis: 1,
        color: {
          linearGradient: [0, 0, 0, 92],
          stops: [[0, CONTRACT_BAR_CHART_GRADIENT], [1, CONTRACT_BAR_CHART_GRADIENT]]
        },
        data: __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_values___default()(this.volume).map(function (el) {
          return Number(el.toFixed(1));
        }),
        showInLegend: false,
        name: 'Total Volume',
        borderRadius: 2,
        type: this.volumeLineType,
        tooltip: {
          pointFormatter: function volumeTooltipFormatter() {
            return 'Total Volume: <strong>' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["h" /* largeNumberDisplay */])(this.y, false) + '</strong>';
          }
        }
      };
    }
  }, {
    key: 'isTimelineDaily',
    value: function isTimelineDaily() {
      return this.timeline.includes('h');
    }
  }, {
    key: 'isMarkerEnabledForTimeline',
    value: function isMarkerEnabledForTimeline(seriesSize) {
      if (__WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].getters['app/isLayoutMobile']) {
        return this.timeline === __WEBPACK_IMPORTED_MODULE_23__components_market_market_detail_charts_timeline_timeline_vue__["b" /* TAB_SEVEN_DAYS */];
      }
      return seriesSize <= 30;
    }
  }, {
    key: 'prepareLabels',
    value: function prepareLabels(item) {
      if (!(item.contractId in this.contractSeries)) {
        var color = item.additional ? item.additionalLineColor : item.lineColor;
        this.contractSeriesNameId[item.contractName] = item.contractId;
        this.contractSeries[item.contractId] = {
          color: color,
          lineWidth: 2,
          marker: {
            enabled: false,
            symbol: 'circle',
            fillColor: CONTRACT_LINE_CHART_MARKER_FILL_COLOR,
            lineWidth: 1,
            lineColor: null,
            radius: 5
          },
          data: [],
          yAxis: 0,
          showInLegend: false,
          name: item.contractName,
          contractId: item.contractId,
          type: this.priceLineType,
          tooltip: {
            valueSuffix: '¢'
          }
        };
      }
    }
  }, {
    key: 'prepareSeries',
    value: function prepareSeries(index, item) {
      this.contractSeries[item.contractId].data.push(item.chartPrice);
      // volume is build as sum of contracts
      // on particular points in time
      if (!(index in this.volume)) {
        this.volume[index] = 0;
      }
      if (item.tradeVolume) {
        this.volume[index] += item.tradeVolume;
      }
    }
  }, {
    key: 'prepareDateString',
    value: function prepareDateString(contractData, index) {
      if (this.isTimelineDaily()) {
        var value = -(index + 1);
        return value + 'h';
      }
      var dt = __WEBPACK_IMPORTED_MODULE_16_moment___default()(contractData.date);
      var dateYear = dt.year();
      var currentYear = __WEBPACK_IMPORTED_MODULE_16_moment___default()().year();
      var format = dateYear === currentYear ? DATE_MONTHLY_FORMAT : DATE_YEARLY_FORMAT;
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(contractData.date).format(format);
    }
  }, {
    key: 'prepareChartGroupData',
    value: function prepareChartGroupData() {
      var _this2 = this;

      var lastContractId = null;
      var lastContractIndex = 0;
      var dateStrings = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a();

      this.data.forEach(function (item, index) {
        if (index === 0 || item.contractId !== lastContractId) {
          lastContractIndex = 0;
        }
        dateStrings.add(_this2.prepareDateString(item, lastContractIndex));
        _this2.prepareLabels(item);
        _this2.prepareSeries(lastContractIndex, item);
        lastContractIndex += 1;
        lastContractId = item.contractId;
      });
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(this.contractSeries)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref3 = _step.value;

          var _ref4 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

          var key = _ref4[0];
          var value = _ref4[1];

          this.contractSeries[key].marker.enabled = this.isMarkerEnabledForTimeline(this.contractSeries[key].data.length);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.contractXaxis = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()(dateStrings);
      // we relate to 24h hour format so respacting prepareDateString method
      // we have to reverse
      if (this.isTimelineDaily()) {
        this.contractXaxis = this.contractXaxis.reverse();
      }
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var series = [];
      var volume = this.getVolumeChartData();
      series.push(volume);

      __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_values___default()(this.contractSeries).forEach(function (contractSeries) {
        series.push(contractSeries);
      });

      var max = undefined;
      var tickPositions = undefined;
      var endOnTick = false;
      var maxes = [];

      series.slice(1).forEach(function (i) {
        maxes.push(Math.max.apply(null, i.data));
      });
      var totalMax = Math.max.apply(null, maxes);

      if (totalMax < 80) {
        endOnTick = true;
      }
      if (series.length === 2 && series[1].data.every(function (v) {
        return v === series[1].data[0];
      })) {
        max = 100;
        tickPositions = [0, 20, 40, 60, 80, 100];
      }
      return {
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        tooltip: {
          shared: false
        },
        credits: {
          enabled: false
        },
        yAxis: [{
          tickPositions: tickPositions,
          max: max,
          endOnTick: endOnTick,
          allowDecimals: false,
          title: { text: '' },
          gridLineWidth: 0,
          labels: {
            formatter: function yAxisLabelFormatter() {
              if (this.value >= 0) {
                return this.value + '\xA2';
              }
            }
          },
          opposite: true
        }, {
          allowDecimals: false,
          tickPositions: getTradeVolumeTickPositions(volume.data, 5),
          title: {
            text: ''
          },
          gridLineWidth: 0,
          tickInterval: 5,
          labels: {
            formatter: function yAxisOppositeLabelFormatter() {
              if (this.value >= 0) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["h" /* largeNumberDisplay */])(this.value, false);
              }
            }
          }
        }],
        xAxis: [{
          categories: this.contractXaxis,
          crosshair: true,
          tickLength: 0,
          lineWidth: 0
        }],
        series: series,
        plotOptions: {
          series: {
            cursor: 'pointer'
          },
          line: {
            allowPointSelect: true
          },
          column: {
            allowPointSelect: true,
            pointPadding: 0,
            groupPadding: 0
          }
        },
        exporting: getExporting.bind(this)()
      };
    }
  }, {
    key: 'draw',
    value: function draw(container) {
      var _this3 = this;

      var options = this.getOptions();
      return Highcharts.chart(container, options, function (chart) {
        var xAxis = chart.xAxis[0];
        var yAxis = chart.yAxis[0];

        if (__WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(_this3.chartOptions, 'showContractImagesOnChart', false)) {
          chart.series.forEach(function (s) {
            if (s.type === 'line') {
              var lastPoint = s.data[s.data.length - 1];
              var lastX = xAxis.toPixels(lastPoint.x);
              var lastY = yAxis.toPixels(lastPoint.y);
              var contractId = _this3.contractSeriesNameId[lastPoint.series.name];
              var contract = _this3.market.contracts.find(function (i) {
                return i.contractId === contractId;
              });
              if (contract) {
                var instance = new MarketContractImageComponent({
                  propsData: {
                    contract: contract,
                    color: lastPoint.series.color
                  }
                });
                instance.$mount();
                chart.renderer.text(instance.$el.outerHTML, lastX + 7, lastY - 5, true).add();
              }
            }
          });
        }
      });
    }
  }], [{
    key: 'renderTimeout',
    value: function renderTimeout() {
      return 300;
    }
  }]);

  return ContractChartGroup;
}();

var PriceChangeChart = function () {
  function PriceChangeChart(contract, data) {
    __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_classCallCheck___default()(this, PriceChangeChart);

    this.contract = contract;
    this.data = data;
    this.colorPositive = '#7dc671';
    this.colorNegative = '#c63540';
    this.colorGrid = '#fff';
    this.lineWidth = 1;
    this.lineType = 'line';
  }

  __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_createClass___default()(PriceChangeChart, [{
    key: 'getSeries',
    value: function getSeries() {
      var seriesData = this.data.map(function (el) {
        return 50 - (el.closeSharePrice || 0.5) * 100;
      });
      return [{
        data: seriesData,
        lineWidth: this.lineWidth,
        type: this.lineType,
        color: this.colorPositive,
        negativeColor: this.colorNegative,
        marker: { enabled: false, states: { hover: { enabled: false } } },
        states: { hover: { enabled: false } }
      }];
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      return {
        chart: {
          margin: [0, 0, 0, 0],
          spacingTop: 0,
          spacingBottom: 0,
          spacingLeft: 0,
          spacingRight: 0
        },
        plotOptions: {},
        legend: { enabled: false },
        credits: { enabled: false },
        tooltip: { enabled: false },
        series: this.getSeries(),
        title: { text: '', style: { display: 'none' }, margin: 0 },
        yAxis: { labels: { enabled: false }, gridLineColor: this.colorGrid },
        xAxis: { labels: { enabled: false }, gridLineColor: this.colorGrid },
        exporting: {
          enabled: false
        }
      };
    }
  }, {
    key: 'draw',
    value: function draw(container) {
      var options = this.getOptions();
      Highcharts.chart(container, options);
    }
  }], [{
    key: 'renderTimeout',
    value: function renderTimeout() {
      return 300;
    }
  }]);

  return PriceChangeChart;
}();

var DashboardPortfolioSummaryChart = function () {
  function DashboardPortfolioSummaryChart(data) {
    __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_classCallCheck___default()(this, DashboardPortfolioSummaryChart);

    this.data = data;
    this.lineWidth = 1;
    this.lineType = 'area';
    this.colorGrid = '#263b3f'; // $black
    this.colorSeries = '#07a0bb'; // $blue
    this.colorYLabels = '#67999f'; // was $green, now green is blue2
    this.colorXLabels = '#263b3f'; // $black
    this.colorTooltipBg = '#ffffff'; // $white
  }

  __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_createClass___default()(DashboardPortfolioSummaryChart, [{
    key: 'prepareSeries',
    value: function prepareSeries() {
      var seriesData = this.data.map(function (el) {
        var portfolioValue = el.investment + el.gainLossUnrealized + el.accountBalance;
        return [__WEBPACK_IMPORTED_MODULE_16_moment___default()(el.historyDate).valueOf(), portfolioValue];
      });
      return [{
        type: this.lineType,
        data: seriesData,
        lineWidth: this.lineWidth,
        lineColor: this.colorSeries,
        fillColor: {
          linearGradient: [0, 0, 0, 220],
          stops: [[0, Highcharts.Color(this.colorSeries).setOpacity(0.5).get('rgba')], [1, Highcharts.Color(this.colorSeries).setOpacity(0).get('rgba')]]
        },
        marker: {
          fillColor: this.colorSeries,
          enabled: false
        }
      }];
    }
  }, {
    key: 'formatTooltip',
    value: function formatTooltip() {
      var index = this.point.index;
      var data = this.point.series.userOptions.data[index];

      var _data = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray___default()(data, 2),
          timestamp = _data[0],
          portfolioValue = _data[1];

      var cssMainClassName = 'portfolio-summary-chart__tooltip';
      var template = '';
      template += '<div class="' + cssMainClassName + '">';
      template += '<h3 class="' + cssMainClassName + '__title">Portfolio Value</h3>';
      template += '<div class="' + cssMainClassName + '__value">$' + Math.abs(portfolioValue).toFixed(2) + '</div>';
      template += '<div class="' + cssMainClassName + '__date">';
      template += __WEBPACK_IMPORTED_MODULE_16_moment___default()(timestamp).format('MM/DD/YYYY h:mma') + ' ET'; // TODO check timezone!
      template += '</div></div></div>';

      return template;
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var series = this.prepareSeries();
      var data = series[0].data;
      var yValues = data.map(function (i) {
        return i[1];
      });
      var maxThreshold = 50;
      var minValuesLength = 3;
      var min = undefined;
      var max = undefined;

      if (yValues.length > minValuesLength) {
        var minValue = parseInt(Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(yValues)), 10);
        var maxValue = parseInt(Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(yValues)), 10);
        var threshold = Math.max(maxValue - minValue, maxThreshold);
        min = Math.max(0, minValue - threshold);
        max = maxValue + threshold;
      }

      return {
        chart: {
          height: 220,
          marginRight: 20,
          spacingRight: 0
          // events: {
          //     load: function() {
          //       const imageHeight = 57;
          //       const imageWidth = 200;
          //       const x = (this.chartWidth - imageWidth) / 2;
          //       const y = (this.chartHeight / 2) - imageHeight;
          //         this.renderer.image(chartWatermarkImage, x, y, imageWidth, imageHeight).add();
          //     }
          // }
        },
        plotOptions: {},
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        tooltip: {
          formatter: this.formatTooltip,
          useHTML: true,
          backgroundColor: this.colorTooltipBg,
          borderColor: this.colorSeries,
          borderRadius: 4
        },
        series: series,
        title: {
          text: '',
          style: {
            display: 'none',
            margin: 0
          }
        },
        yAxis: {
          min: min,
          max: max,
          labels: {
            formatter: function yAxisLabelFormatter() {
              if (this.value > 0) {
                return '$' + this.value;
              }
            },
            style: {
              color: this.colorYLabels,
              fontWeight: 'bold',
              fontFamily: 'Roboto',
              fontSize: 12
            }
          },
          title: {
            text: null
          },
          gridLineColor: this.colorGrid
        },
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
            millisecond: '%H:%M',
            day: '%e %b',
            week: '%e %b',
            second: '%H:%M',
            minute: '%H:%M',
            hour: '%H:%M'
          },
          labels: {
            style: {
              color: this.colorXLabels,
              fontFamily: 'Roboto',
              fontSize: 12
            }
          },
          tickAmount: 0,
          tickLength: 0
        },
        exporting: {
          enabled: false
        }
      };
    }
  }, {
    key: 'draw',
    value: function draw(container) {
      var options = this.getOptions();
      Highcharts.chart(container, options);
    }
  }], [{
    key: 'renderTimeout',
    value: function renderTimeout() {
      return 300;
    }
  }]);

  return DashboardPortfolioSummaryChart;
}();

var ElectionMapChartOverall = function () {
  function ElectionMapChartOverall(data) {
    __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_classCallCheck___default()(this, ElectionMapChartOverall);

    this.data = data;
  }

  __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_createClass___default()(ElectionMapChartOverall, [{
    key: 'draw',
    value: function draw(container) {
      var options = this.getOptions();
      Highcharts.mapChart(container, options);
    }
  }, {
    key: 'getColorValue',
    value: function getColorValue(_ref5) {
      var marketData = _ref5.marketData,
          stateCode = _ref5.stateCode,
          stateName = _ref5.stateName,
          stateVotes = _ref5.stateVotes;

      if (!marketData.contracts) return 0;
      var targetContract = __WEBPACK_IMPORTED_MODULE_14_lodash_maxBy___default()(marketData.contracts, function (i) {
        return i.lastTradePrice;
      });
      if (targetContract.lastTradePrice === 0.5) return 0;
      return targetContract.name === 'Democratic' ? 1 : 2;
    }
  }, {
    key: 'formatTooltip',
    value: function formatTooltip() {
      var index = this.point.index;
      var data = this.point.series.userOptions.data[index];
      var marketData = data.marketData;

      if (!marketData.contracts) return false;
      var instance = new MarketStateTooltipComponent({
        propsData: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data)
      });
      instance.$mount();
      return instance.$el.outerHTML;
    }
  }, {
    key: 'formatDataLabel',
    value: function formatDataLabel() {
      if (this.point.stateCode === 'HI') return '';
      var targetContract = __WEBPACK_IMPORTED_MODULE_14_lodash_maxBy___default()(this.point.marketData.contracts, function (i) {
        return i.lastTradePrice;
      });
      var stateCode = this.point.properties['hc-a2'];
      var showStates = ['VT', 'NH', 'MA', 'RI', 'CT', 'NJ', 'DE', 'MD', 'DC'];
      if (!targetContract) {
        return showStates.includes(stateCode) ? stateCode : '';
      }
      var contract = new __WEBPACK_IMPORTED_MODULE_25__models_contract__["a" /* default */](targetContract);
      return contract.lastTradePriceAsCents + '\xA2';
    }
  }, {
    key: 'prepareSeries',
    value: function prepareSeries() {
      var _this4 = this;

      var mapData = Highcharts.geojson(Highcharts.maps['countries/us/custom/us-small']);
      var statesData = [];

      mapData.forEach(function (value, index) {
        var path = value.geometry.coordinates;
        var copy = {
          path: path
        };

        if (path[0][1] === 9727) {
          Highcharts.seriesTypes.map.prototype.getBox.call({}, [copy]);
          value.middleX = ((path[0][1] + path[1][1]) / 2 - copy._minX) / (copy._maxX - copy._minX);
          value.middleY = ((path[0][2] + path[2][2]) / 2 - copy._minY) / (copy._maxY - copy._minY);
        }

        var stateCode = value.properties['hc-a2'];
        var stateName = value.name.toUpperCase();
        var marketData = _this4.data[stateCode] || {};
        value.stateName = stateName;
        var stateVotes = __WEBPACK_IMPORTED_MODULE_24__constants__["a" /* default */].statesCodeToElectoralVotesMap[stateCode];

        statesData[index] = {
          stateCode: stateCode,
          stateName: stateName,
          stateVotes: stateVotes,
          marketData: marketData,
          value: _this4.getColorValue({ marketData: marketData, stateCode: stateCode, stateName: stateName, stateVotes: stateVotes })
        };
      });

      return { mapData: mapData, statesData: statesData };
    }
  }, {
    key: 'getBaseOptions',
    value: function getBaseOptions(_ref6) {
      var mapData = _ref6.mapData,
          statesData = _ref6.statesData;

      return {
        plotOptions: {
          series: {
            cursor: 'pointer',
            dataLabels: {
              style: {
                textOutline: 0
              }
            }
          }
        },
        exporting: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        mapNavigation: {
          enabled: false,
          enableButtons: false
        },
        xAxis: {
          labels: {
            enabled: false
          }
        },
        title: {
          text: ''
        },
        chart: {
          margin: [0, 0, 0, 0],
          spacing: [0, 0, 0, 0]
        },
        colorAxis: {
          dataClasses: [, {
            from: 0,
            to: 0,
            color: '#c8c8c8',
            name: 'N/A'
          }, {
            from: 1,
            to: 1,
            color: '#2f88dc',
            name: 'Clinton'
          }, {
            from: 2,
            to: 2,
            color: '#bc1500',
            name: 'Trump'
          }]
        },
        tooltip: {
          enabled: __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].getters['app/isLayoutDesktop'],
          formatter: this.formatTooltip,
          hideDelay: 200,
          useHTML: true,
          borderRadius: 0,
          borderWidth: 0,
          backgroundColor: 'white',
          padding: 0,
          shadow: false,
          followPointer: true
        },
        series: [{
          mapData: mapData,
          data: statesData,
          joinBy: 'stateName',
          name: 'States',
          events: {
            mouseOut: function mouseOut(e) {
              __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].dispatch('market/setMarketMapTooltipVisible', false);
            },
            click: function click(e) {
              var marketId = __WEBPACK_IMPORTED_MODULE_15_lodash_get___default()(e, 'point.marketData.marketId', null);
              if (marketId) {
                window.location.href = 'https://www.predictit.org/markets/detail/' + marketId;
                // router.push({
                //   name: 'market-details',
                //   params: {
                //     marketId,
                //   }
                // });
              }
            }
          },
          dataLabels: {
            enabled: true,
            formatter: this.formatDataLabel,
            style: {
              fontSize: __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].getters['app/isLayoutMobile'] ? '10px' : '12px',
              color: 'white'
            }
          }
        }, {
          name: 'Separators',
          type: 'mapline',
          data: Highcharts.geojson(Highcharts.maps['countries/us/custom/us-small'], 'mapline'),
          color: 'silver',
          showInLegend: false,
          enableMouseTracking: false
        }]
      };
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var _prepareSeries = this.prepareSeries(),
          mapData = _prepareSeries.mapData,
          statesData = _prepareSeries.statesData;

      return this.getBaseOptions({ mapData: mapData, statesData: statesData });
    }
  }], [{
    key: 'renderTimeout',
    value: function renderTimeout() {
      return 300;
    }
  }]);

  return ElectionMapChartOverall;
}();

var ElectionMapChartParty = function (_ElectionMapChartOver) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ElectionMapChartParty, _ElectionMapChartOver);

  function ElectionMapChartParty() {
    __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_classCallCheck___default()(this, ElectionMapChartParty);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ElectionMapChartParty.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ElectionMapChartParty)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_createClass___default()(ElectionMapChartParty, [{
    key: 'getColorValue',
    value: function getColorValue(_ref7) {
      var marketData = _ref7.marketData,
          stateCode = _ref7.stateCode,
          stateName = _ref7.stateName,
          stateVotes = _ref7.stateVotes;

      if (!marketData.contracts) return 0;
      var targetContract = __WEBPACK_IMPORTED_MODULE_14_lodash_maxBy___default()(marketData.contracts, function (i) {
        return i.lastTradePrice;
      });
      var pallette = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["a" /* getColorForPalletteCandidate */])(targetContract.contractName);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["i" /* roundToTwo */])(targetContract.lastTradePrice + pallette[0].from);
    }
  }, {
    key: 'getColorAxisStops',
    value: function getColorAxisStops() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].GRAY), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED));
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var _prepareSeries2 = this.prepareSeries(),
          mapData = _prepareSeries2.mapData,
          statesData = _prepareSeries2.statesData;

      var options = this.getBaseOptions({ mapData: mapData, statesData: statesData });
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, options, {
        title: {
          text: ''
        },
        colorAxis: {
          min: 0,
          dataClasses: this.getColorAxisStops()
        }
      });
    }
  }]);

  return ElectionMapChartParty;
}(ElectionMapChartOverall);

var ElectionMapChartSenate = function (_ElectionMapChartOver2) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ElectionMapChartSenate, _ElectionMapChartOver2);

  function ElectionMapChartSenate() {
    __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_classCallCheck___default()(this, ElectionMapChartSenate);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ElectionMapChartSenate.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ElectionMapChartSenate)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_createClass___default()(ElectionMapChartSenate, [{
    key: 'getColorValue',
    value: function getColorValue(_ref8) {
      var marketData = _ref8.marketData,
          stateCode = _ref8.stateCode,
          stateName = _ref8.stateName,
          stateVotes = _ref8.stateVotes;

      var hardcodedDemocrats = ['CA', 'CT', 'HI', 'IL', 'MD', 'NY', 'OR', 'VT', 'WA'];
      var hardcodedRepublicans = ['AK', 'AL', 'AR', 'IA', 'ID', 'IN', 'KS', 'KY', 'LA', 'MO', 'ND', 'OK', 'SC', 'SD', 'UT'];
      if (hardcodedDemocrats.includes(stateCode)) {
        return __WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE[2].to;
      }
      if (hardcodedRepublicans.includes(stateCode)) {
        return __WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED[2].to;
      }
      if (!marketData.contracts) return 0;
      var targetContract = __WEBPACK_IMPORTED_MODULE_14_lodash_maxBy___default()(marketData.contracts, function (i) {
        return i.lastTradePrice;
      });
      var pallette = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["a" /* getColorForPalletteCandidate */])(targetContract.contractName);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_helpers__["i" /* roundToTwo */])(targetContract.lastTradePrice + pallette[0].from);
    }
  }, {
    key: 'formatDataLabel',
    value: function formatDataLabel() {
      // if (this.point.stateCode === 'HI') return '';
      var targetContract = __WEBPACK_IMPORTED_MODULE_14_lodash_maxBy___default()(this.point.marketData.contracts, function (i) {
        return i.lastTradePrice;
      });
      var stateCode = this.point.properties['hc-a2'];
      var showStates = ['VT', 'NH', 'MA', 'RI', 'CT', 'NJ', 'DE', 'MD', 'DC'];
      var markWhenRepublicansAhead = ['DE', 'IL', 'MA', 'NH', 'NJ', 'OR', 'RI', 'VA', 'MN', 'NM', 'MI', 'AL'];
      var markWhenDemocratsAhead = ['AZ', 'CO', 'ME', 'MT', 'NC', 'GA', 'IA', 'KS', 'AK', 'KY', 'SC', 'TX', 'AR', 'ID', 'LA', 'MS', 'NE', 'OK', 'SD', 'TN', 'WV', 'WY'];
      if (!targetContract) {
        return showStates.includes(stateCode) ? stateCode : '';
        // return stateCode;
      }
      var contract = new __WEBPACK_IMPORTED_MODULE_25__models_contract__["a" /* default */](targetContract);

      var markPrice = targetContract.contractName === 'Republican' && markWhenRepublicansAhead.includes(stateCode) || targetContract.contractName === 'Democratic' && markWhenDemocratsAhead.includes(stateCode);
      if (markPrice) {
        return '<div>' + contract.lastTradePriceAsCents + '\xA2</div>';
      }

      return contract.lastTradePriceAsCents + '\xA2';
    }
  }, {
    key: 'formatTooltip',
    value: function formatTooltip() {
      var index = this.point.index;
      var data = this.point.series.userOptions.data[index];
      var marketData = data.marketData;

      if (!marketData.contracts) return false;
      var instance = new MarketStateTooltipComponent({
        propsData: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, {
          type: 'senate'
        })
      });
      instance.$mount();
      return instance.$el.outerHTML;
    }
  }, {
    key: 'getColorAxisStops',
    value: function getColorAxisStops() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].GRAY), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED));
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var _prepareSeries3 = this.prepareSeries(),
          mapData = _prepareSeries3.mapData,
          statesData = _prepareSeries3.statesData;

      var options = this.getBaseOptions({ mapData: mapData, statesData: statesData });
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, options, {
        title: {
          text: ''
        },
        colorAxis: {
          min: 0,
          dataClasses: this.getColorAxisStops()
        }
      });
    }
  }]);

  return ElectionMapChartSenate;
}(ElectionMapChartOverall);

/***/ }),

/***/ "Q/ey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_menu_button_js__ = __webpack_require__("R1ks");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3800d634_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_button_vue__ = __webpack_require__("bG/B");
function injectStyle (ssrContext) {
  __webpack_require__("Ed8h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_menu_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3800d634_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q0u2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_disqus_disqus_vue__ = __webpack_require__("4EoQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_detail_charts_market_detail_charts_vue__ = __webpack_require__("1P9U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_v2_market_contract_horizontal_v2_market_contract_horizontal_v2_vue__ = __webpack_require__("p+B/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_history_market_history_vue__ = __webpack_require__("u3Vs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_market_market_header_title_market_header_title_vue__ = __webpack_require__("JcZ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_market_market_header_title_large_market_header_title_large_vue__ = __webpack_require__("fyXg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_market_market_payout_market_payout_vue__ = __webpack_require__("SdEv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_market_market_related_market_related_vue__ = __webpack_require__("PMnD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_purchase_purchase_desktop_purchase_desktop_vue__ = __webpack_require__("nGzq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_market_market_rules_market_rules_vue__ = __webpack_require__("bynG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_headerTags__ = __webpack_require__("cgm0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_mutex__ = __webpack_require__("EOu+");


























var DEFAULT_PAGE_TITLE = 'PredictIt';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_17__mixins_headerTags__["a" /* default */]],
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_14__components_generics_alert_box_alert_box_vue__["a" /* default */],
    marketHeaderTitle: __WEBPACK_IMPORTED_MODULE_9__components_market_market_header_title_market_header_title_vue__["a" /* default */],
    marketHeaderTitleLarge: __WEBPACK_IMPORTED_MODULE_10__components_market_market_header_title_large_market_header_title_large_vue__["a" /* default */],
    marketCharts: __WEBPACK_IMPORTED_MODULE_6__components_market_market_detail_charts_market_detail_charts_vue__["a" /* default */],
    marketContract: __WEBPACK_IMPORTED_MODULE_7__components_market_v2_market_contract_horizontal_v2_market_contract_horizontal_v2_vue__["a" /* default */],
    marketHistory: __WEBPACK_IMPORTED_MODULE_8__components_market_market_history_market_history_vue__["a" /* default */],
    marketPayout: __WEBPACK_IMPORTED_MODULE_11__components_market_market_payout_market_payout_vue__["a" /* default */],
    marketRelated: __WEBPACK_IMPORTED_MODULE_12__components_market_market_related_market_related_vue__["a" /* default */],
    disqus: __WEBPACK_IMPORTED_MODULE_5__components_disqus_disqus_vue__["a" /* default */],
    purchaseDesktop: __WEBPACK_IMPORTED_MODULE_13__components_purchase_purchase_desktop_purchase_desktop_vue__["a" /* default */],
    marketRules: __WEBPACK_IMPORTED_MODULE_15__components_market_market_rules_market_rules_vue__["a" /* default */],
    tabs: __WEBPACK_IMPORTED_MODULE_16__components_generics_tabs_tabs_vue__["a" /* default */]
  },
  props: {
    showRules: {
      type: Boolean,
      default: false
    },
    marketId: {
      type: Number,
      required: true
    },
    prerendered: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      hasMarketStatusMessage: __WEBPACK_IMPORTED_MODULE_18__utils_helpers__["x" /* hasMarketStatusMessage */],
      ready: false,
      shownOnInit: false,
      isHistoryOpen: false,
      isRelatedOpen: true,
      reinitializeAttempt: 1,
      showAllContracts: false,
      activeTab: null,
      showHistory: false
    };
  },
  metaInfo: function metaInfo() {
    if (this.market && this.market.marketId) {
      return {
        title: this.market.seoTitle,
        link: [{ rel: 'canonical', href: '' + window.location.href }],
        meta: [{ name: 'description', content: this.market.seoDescription }, { itemprop: 'name', content: this.market.seoTitle }, { itemprop: 'description', content: this.market.seoDescription }, { itemprop: 'image', content: this.market.imageName }, { property: 'og:title', content: this.market.seoTitle }, { property: 'og:type', content: 'article' }, { property: 'og:image', content: this.market.imageName }, { property: 'og:description', content: this.market.seoDescription }, { property: 'og:site_name', content: 'Predictit' }, { property: 'og:url', content: '' + window.location.href }]
      };
    }
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('app', ['previousRoute']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('market', ['market', 'contracts', 'marketLoadError', 'marketIsEngineBusy', 'marketIsEngineBusyMessage']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('trade', ['tradeOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('popup', ['currentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('notifications', ['lastConfirmedContractData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('user', ['status']), {
    isSettled: function isSettled() {
      return this.market && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_helpers__["e" /* isMarketSettled */])(this.market);
    },
    isPayoutAvailable: function isPayoutAvailable() {
      return this.isLoggedIn && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_helpers__["y" /* hasMarketPayout */])(this.market) && !this.isSettled;
    },
    historyKey: function historyKey() {
      return this.marketKey() + '-' + this.reinitializeAttempt.toString();
    },
    showMarketHistory: function showMarketHistory() {
      return this.market.userHasTradeHistory || this.showHistory;
    },
    title: function title() {
      return 'Market details for ' + this.market.symbol + '--' + this.market.marketId;
    },
    getLayout: function getLayout() {
      return this.isLayoutDesktop ? 'list' : 'grid';
    },
    visibleContracts: function visibleContracts() {
      return this.showAllContracts ? this.contracts : this.notHiddenContracts;
    },
    notHiddenContracts: function notHiddenContracts() {
      return this.contracts.filter(function (i) {
        return !i.hiddenByDefault;
      });
    },
    hiddenContracts: function hiddenContracts() {
      return this.contracts.filter(function (i) {
        return i.hiddenByDefault;
      });
    },
    hiddenContractsOffersOrSharesCount: function hiddenContractsOffersOrSharesCount() {
      if (this.hiddenContracts.length > 0) {
        return __WEBPACK_IMPORTED_MODULE_2_lodash_sumBy___default()(this.hiddenContracts, __WEBPACK_IMPORTED_MODULE_18__utils_helpers__["m" /* contractOwnershipNum */]);
      }
      return 0;
    },
    shouldShowToggleMoreButton: function shouldShowToggleMoreButton() {
      return this.hiddenContracts.length > 0;
    },
    classModifiers: function classModifiers() {
      return {
        'market-detail': true,
        'market-detail--single': this.isMarketSingle
      };
    },
    toggleMoreModifiers: function toggleMoreModifiers() {
      return {
        'market-detail__contracts-toggle-more': true,
        'market-detail__contracts-toggle-more--offers-or-shares': this.hiddenContractsOffersOrSharesCount > 0,
        'market-detail__contracts-toggle-more--active': this.showAllContracts
      };
    },
    showEngineBusyNotification: function showEngineBusyNotification() {
      return this.market.isEngineBusy && this.market.isEngineBusyMessage || this.marketIsEngineBusy && this.marketIsEngineBusyMessage;
    },
    engineBusyNotificationContent: function engineBusyNotificationContent() {
      return this.market.isEngineBusyMessage || this.marketIsEngineBusyMessage;
    },
    statusMessage: function statusMessage() {
      return this.market.isOpenStatusMessage;
    },
    statusMessageLevel: function statusMessageLevel() {
      if (this.statusMessage === 'This market has settled.') return 'danger';
      return 'warning';
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_helpers__["l" /* isMarketSingle */])(this.market);
    },
    shouldInitializePurchaseOnInit: function shouldInitializePurchaseOnInit() {
      return this.status.hasBeenFunded === true && this.isMarketSingle && !this.shownOnInit && this.isLayoutDesktop && this.isLoggedIn;
    },
    ogImageSrc: function ogImageSrc() {
      return this.prerendered !== '' && this.market && this.market.imageName;
    },
    showTitleBackButton: function showTitleBackButton() {
      return __WEBPACK_IMPORTED_MODULE_21__mixins_userAgent__["c" /* isIos */] && this.previousRoute !== null;
    },
    showEconomicIndicator: function showEconomicIndicator() {
      return [2, 3, 4].includes(this.market.econIndicatorTradeStatus);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('insight', ['getMarketFeeds']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('market', ['getMarket', 'clearMarket', 'clearMarketEngineBusyMessage']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setTradePopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'clearOrderBook']), {
    openContractIfPassedToQueryString: function openContractIfPassedToQueryString() {
      var _this = this;

      if (this.isMarketSingle) return;
      var contractId = parseInt(this.$route.query.contractId, 10);
      var inContracts = this.contracts.map(function (i) {
        return i.contractId;
      }).includes(contractId);
      var inHiddenContracts = this.hiddenContracts.map(function (i) {
        return i.contractId;
      }).includes(contractId);
      if (!inContracts) return;

      if (inHiddenContracts) {
        this.showAllContracts = true;
      }

      this.$nextTick(function () {
        var $el = document.querySelector('[data-contract-id="' + contractId + '"]');
        var destination = Math.max(0, $el.offsetTop - 160);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_scrollTo__["a" /* default */])(destination, 1000, 'linear', function () {
          if (!_this.isLoggedIn) return;
          var timeout = _this.isLayoutMobile ? 2500 : 0;
          setTimeout(function () {
            $el.click();
          }, timeout);
        });
      });
    },
    marketKey: function marketKey() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'market-details';

      var loggedIn = this.isLoggedIn ? 'logged-in' : 'logged-out';
      return this.market ? name + '-' + this.market.marketId + '-' + loggedIn : '';
    },
    onPurchaseShownOnInit: function onPurchaseShownOnInit() {
      this.shownOnInit = true;
    },
    initializePurchase: function initializePurchase() {
      if (this.isLayoutMobile && this.tradeOptions !== null && this.tradeOptions.contractId !== null) {
        if (!this.isLoggedIn && this.currentPopup !== __WEBPACK_IMPORTED_MODULE_20__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN) {
          this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_20__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
        } else if (this.currentPopup !== __WEBPACK_IMPORTED_MODULE_20__components_app_app_modals_app_modals__["a" /* MODALS */].PURCHASE) {
          this.setTradePopup({
            name: __WEBPACK_IMPORTED_MODULE_20__components_app_app_modals_app_modals__["a" /* MODALS */].PURCHASE,
            options: {
              market: this.market
            }
          });
        }
      } else if (!this.isLoggedIn && this.tradeOptions !== null && this.tradeOptions.contractId !== null && this.isPurchaseDesktopMode(this.tradeOptions.contractId) && this.currentPopup !== __WEBPACK_IMPORTED_MODULE_20__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_20__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
      }
    },
    contractKey: function contractKey(prefix, data) {
      var contract = new __WEBPACK_IMPORTED_MODULE_19__models_contract__["a" /* default */](data);
      return prefix + '-' + this.marketKey() + '-' + contract.contractId + '-' + contract.mode + '-' + this.reinitializeAttempt.toString() + '-' + this.isLayoutMobile.toString();
    },
    retrieveMarketData: function retrieveMarketData(marketId) {
      var _this2 = this;

      this.clearOrderBook();
      this.clearMarket();
      if (marketId) {
        var commentThreadId = this.$route.query.commentThreadId;
        return this.getMarket({ marketId: marketId, commentThreadId: commentThreadId }).then(function (data) {
          if (data.econIndicatorTradeStatus === 3) {
            _this2.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_20__components_app_app_modals_app_modals__["a" /* MODALS */].AFFILIATIONS);
          }
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
    },
    isPurchaseDesktopMode: function isPurchaseDesktopMode(contractId) {
      return this.isLayoutDesktop && this.tradeOptions && this.tradeOptions.contractId === contractId;
    },
    onToggleMore: function onToggleMore() {
      this.showAllContracts = !this.showAllContracts;
      if (!this.showAllContracts) {
        window.scrollTo(0, 0);
      }
    },
    onToggleHistory: function onToggleHistory() {
      this.isHistoryOpen = !this.isHistoryOpen;
      this.isRelatedOpen = false;
    },
    onToggleRelated: function onToggleRelated() {
      this.isRelatedOpen = !this.isRelatedOpen;
      this.isHistoryOpen = false;
    },
    loadHandler: function loadHandler(value) {
      var _this3 = this;

      if (value) {
        this.ready = false;
        this.retrieveMarketData(this.marketId).then(__WEBPACK_IMPORTED_MODULE_23__utils_mutex__["b" /* waitForStatusReady */]).then(function () {
          if (!_this3.status.hasBeenFunded) {
            _this3.setTradeOptions(null);
          }
        }).then(function () {
          _this3.ready = true;
          _this3.reorganizeTags();
          _this3.initializePurchase();
          _this3.openContractIfPassedToQueryString();
        });
      } else {
        this.retrieveMarketData(this.marketId).then(function () {
          _this3.ready = true;
          _this3.reorganizeTags();
          _this3.initializePurchase();
          _this3.openContractIfPassedToQueryString();
        });
      }
    }
  }),
  watch: {
    lastConfirmedContractData: function lastConfirmedContractData(data) {
      // showing history on succesfull match
      var contractIds = (this.contracts || []).map(function (i) {
        return i.contractId;
      });
      if (data && data.matched && contractIds.includes(data.id)) {
        this.showHistory = true;
      }
    },
    tradeOptions: function tradeOptions() {
      this.initializePurchase();
    },

    isLoggedIn: {
      handler: 'loadHandler',
      immediate: true
    },
    $route: function $route(to, from) {
      var _this4 = this;

      var dontReload = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(to, 'params.dontReload', false);
      if (from.fullPath !== to.fullPath && !dontReload) {
        this.shownOnInit = false;
        this.retrieveMarketData(to.params.marketId).then(function () {
          _this4.reorganizeTags();
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clearMarketEngineBusyMessage();
    this.setTradeOptions(null);
    document.title = DEFAULT_PAGE_TITLE;
  }
});

/***/ }),

/***/ "Q1xv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q334":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_multiselect_js__ = __webpack_require__("M32j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a0235b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multiselect_vue__ = __webpack_require__("etKJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_multiselect_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a0235b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multiselect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QA2/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_balance_history_balance_history_vue__ = __webpack_require__("aTrv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_export_history_export_history_vue__ = __webpack_require__("cgtd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_select_select_vue__ = __webpack_require__("x+uv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_modules_profile__ = __webpack_require__("PMOm");








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showExport: Boolean
  },
  components: {
    balanceHistory: __WEBPACK_IMPORTED_MODULE_3__components_balance_history_balance_history_vue__["a" /* default */],
    exportHistory: __WEBPACK_IMPORTED_MODULE_4__components_export_history_export_history_vue__["a" /* default */],
    formSelect: __WEBPACK_IMPORTED_MODULE_5__components_forms_select_select_vue__["a" /* default */]
  },
  data: function data() {
    return {
      typeOptions: [],
      yearsOptions: [],
      filter: {
        type: __WEBPACK_IMPORTED_MODULE_6__store_modules_profile__["a" /* ALL_TYPES_OPTION */],
        year: __WEBPACK_IMPORTED_MODULE_6__store_modules_profile__["b" /* ALL_YEARS_OPTION */]
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('profile', ['pendingHistory', 'transactionHistory']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('profile', ['transactionFilters']), {
    items: function items() {
      return this.transactionHistory.data === null ? [] : [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.pendingHistory), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.transactionHistory.data));
    },
    canLoadMore: function canLoadMore() {
      return this.transactionHistory.canLoadMore;
    },
    isExportAvailable: function isExportAvailable() {
      return this.showExport && this.transactionHistory && this.transactionHistory.data && this.transactionHistory.data.length > 0;
    }
  }),
  watch: {
    'filter.type': function watchType() {
      this.handleFilters();
    },
    'filter.year': function watchYear() {
      this.handleFilters();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['getTransactionHistory', 'resetTransactionHistory']), {
    resetFilters: function resetFilters() {
      this.filter.type = __WEBPACK_IMPORTED_MODULE_6__store_modules_profile__["a" /* ALL_TYPES_OPTION */];
      this.filter.year = __WEBPACK_IMPORTED_MODULE_6__store_modules_profile__["b" /* ALL_YEARS_OPTION */];
    },
    handleFilters: function handleFilters() {
      var canLoadMore = this.transactionHistory.canLoadMore;
      this.resetTransactionHistory();
      if (canLoadMore) this.loadHistory();
    },
    loadHistory: function loadHistory() {
      if (this.transactionHistory.canLoadMore) {
        var payload = {
          type: this.filter.type.value,
          year: this.filter.year.value
        };
        this.getTransactionHistory(payload);
      }
    },
    modalExport: function modalExport() {
      this.$emit('export', 'deposit-withdrawals');
    },
    onItemCancelled: function onItemCancelled() {
      this.resetFilters();
      this.resetTransactionHistory();
      this.getTransactionHistory({});
    }
  })
});

/***/ }),

/***/ "QAFl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QJjx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers,style:(_vm.styleModifiers),on:{"click":_vm.onTooltipClick}},[_c('div',{class:_vm.titleClassModifiers,style:(_vm.titleStyleModifiers)},[_vm._v("\n    "+_vm._s(_vm.stateName)+" "),(!_vm.isSenate)?[_vm._v("("+_vm._s(_vm.marketData.stateVotes)),(_vm.showNote)?_c('span',[_vm._v(" STATEWIDE")]):_vm._e(),_vm._v(")")]:(_vm.isSenate && _vm.stateCode === 'GA')?[_vm._v("(REGULAR)")]:(_vm.isSenate && _vm.stateCode === 'GA2')?[_vm._v("(SPECIAL)")]:_vm._e()],2),_vm._v(" "),(_vm.winnerMode)?[_c('div',{staticClass:"market-state-tooltip__winner"},[_c('div',{staticClass:"market-state-tooltip__winner-title"},[_vm._v("\n        "+_vm._s(_vm.targetContract.contractName)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"market-state-tooltip__winner-image",style:(_vm.imageStyleModifiers(_vm.targetContract))}),_vm._v(" "),(_vm.showNote)?_c('div',{staticClass:"market-state-tooltip__winner-name",style:(_vm.winnerBgColorStyleModifiers)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-state-tooltip__winner-price"},[_c('span',{staticClass:"market-state-tooltip__winner-current-price"},[_c('animated-number',{attrs:{"value":_vm.targetContractInstance.lastTradePriceAsCents}})],1),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.targetContractInstance.changePriceAsCents,"lastClosePrice":_vm.targetContractInstance.lastClosePrice,"theme":"chart"}})],1)])]:_vm._l((_vm.contracts),function(contract,index){return _c('div',{key:contract.contractId,class:_vm.contractClassModifiers(contract, index)},[_c('div',{staticClass:"market-state-tooltip__contract-image",style:(_vm.imageStyleModifiers(contract))}),_vm._v(" "),_c('div',{staticClass:"market-state-tooltip__contract-info"},[_c('div',{staticClass:"market-state-tooltip__contract-name"},[_vm._v("\n          "+_vm._s(_vm.getNameDisplay(contract))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"market-state-tooltip__contract-price"},[_c('span',{staticClass:"market-state-tooltip__contract-current-price"},[_c('animated-number',{attrs:{"value":contract.lastTradePriceAsCents}})],1),_vm._v(" "),_c('market-change-price',{attrs:{"price":contract.changePriceAsCents,"lastClosePrice":contract.lastClosePrice,"theme":"chart"}})],1)])])}),_vm._v(" "),(_vm.showNote)?_c('div',{staticClass:"market-state-tooltip__note"},[_vm._v("\n    See separate markets for individual "),_c('br'),_vm._v("congressional districts in "+_vm._s(_vm.capitalizeFirstLetter(_vm.stateName.toLowerCase()))+".\n  ")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QLqa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QLzg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.shouldShowDesktopList || _vm.shouldShowMobileSlider)?_c('div',{staticClass:"market-biggest-gains__swiper-arrows"},[_c('span',{class:_vm.prevArrowModifiers,on:{"click":_vm.prevSlide}}),_vm._v(" "),_c('span',{class:_vm.nextArrowModifiers,on:{"click":_vm.nextSlide}})]):_vm._e(),_vm._v(" "),(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader"},_vm._l((_vm.dummyComponents),function(index){return _c('div',{staticClass:"content-loader-item"},[_c('biggest-gains-loader')],1)}),0):[(_vm.shouldShowMobileSlider)?_c('div',[_c('swiper',{ref:"market-biggest-gains-slider",staticClass:"market-biggest-gains__slider",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.items),function(promo){return _c('swiper-slide',{key:promo.id,staticClass:"market-biggest-gains__slide"},[_c('market-biggest-gains-element',{attrs:{"promo":promo[0]}}),_vm._v(" "),_c('market-biggest-gains-element',{attrs:{"promo":promo[1],"header":false}})],1)}),1)],1):_vm._e(),_vm._v(" "),(_vm.shouldShowDesktopList)?_c('div',{staticClass:"row"},_vm._l((_vm.items),function(promo){return _c('div',{key:promo.id,staticClass:"market-biggest-gains__slide"},[_c('market-biggest-gains-element',{attrs:{"promo":promo}})],1)}),0):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QM9i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__ = __webpack_require__("vJzj");





var CAPTCHA_FIELD = 'g-recaptcha-response';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["b" /* formMixin */]],
  data: function data() {
    return {
      // login attempt counter used to rerender captcha on failed login
      attempt: 1,
      fields: {
        email: null,
        captcha: ''
      }
    };
  },

  validations: {
    fields: {
      email: __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["a" /* validators */].email,
      captcha: __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["a" /* validators */].captcha
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('app', ['systemEmails']), {
    resetUrl: function resetUrl() {
      return window.location.protocol + '//' + window.location.host + '/account/password/reset/';
    },
    resetButtonDisabled: function resetButtonDisabled() {
      return this.invalidOrDisabled || !this.fields.captcha;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['forgotPassword']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotification']), {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formIsValid() && this.formDisable()) {
        var _forgotPassword;

        this.forgotPassword((_forgotPassword = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_forgotPassword, CAPTCHA_FIELD, this.fields.captcha), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_forgotPassword, 'email', this.fields.email), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_forgotPassword, 'url', this.resetUrl), _forgotPassword)).then(function (data) {
          _this.formEnable();
          _this.setSuccessSideNotification(data);
          _this.setCurrentPopup();
        }).catch(function (error) {
          _this.attempt += 1;
          _this.fields.captcha = null;
          _this.formHandleErrors(error);
        });
      }
    }
  })
});

/***/ }),

/***/ "QPgH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IiMzQjU5OTgiIHJ4PSIyIi8+DQogICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEyLjM3NCAxMC4wNjJoLTEuNjZ2Ni4wODVIOC4xOTZ2LTYuMDg1SDdWNy45MjNoMS4xOTdWNi41NGMwLS45OS40Ny0yLjUzOSAyLjUzOS0yLjUzOWwxLjg2NC4wMDh2Mi4wNzZoLTEuMzUzYy0uMjIxIDAtLjUzMy4xMS0uNTMzLjU4M3YxLjI1OGgxLjg4bC0uMjIgMi4xMzd6Ii8+DQogICAgPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "QQW0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QSM8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_already_exists_js__ = __webpack_require__("22Ot");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_235442e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_already_exists_vue__ = __webpack_require__("vUm4");
function injectStyle (ssrContext) {
  __webpack_require__("6pEg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_already_exists_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_235442e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_already_exists_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QVDr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.currentPopupOptions.icon)?_c('div',{staticClass:"popup-generic-small__icon"},[(_vm.currentPopupOptions.icon === 'error')?_c('img',{attrs:{"src":__webpack_require__("z6fO"),"alt":""}}):_vm._e(),_vm._v(" "),(_vm.currentPopupOptions.icon === 'success')?_c('img',{attrs:{"src":__webpack_require__("ihRI"),"alt":""}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"popup-generic-small__content"},[_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QWrq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_range__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showHeader: {
      type: Boolean,
      default: true
    },
    num: {
      type: Number,
      default: 1
    }
  },
  computed: {
    dummyComponents: function dummyComponents() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(0, this.num);
    }
  }
});

/***/ }),

/***/ "Qe7J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_leaderboards__ = __webpack_require__("8mrx");


/* eslint-disable object-shorthand */





var A = { label: 'All Players', value: 'ALL' };

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    backButton: {
      type: Boolean,
      default: false
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["b" /* formMixin */]],
  data: function data() {
    return {
      filter: {
        type: A,
        time: null
      },
      typeOptions: [A],
      timeOptions: [__WEBPACK_IMPORTED_MODULE_4__store_modules_leaderboards__["a" /* TIME_OPTIONS */].PAST_WEEK, __WEBPACK_IMPORTED_MODULE_4__store_modules_leaderboards__["a" /* TIME_OPTIONS */].PAST_MONTH, __WEBPACK_IMPORTED_MODULE_4__store_modules_leaderboards__["a" /* TIME_OPTIONS */].PAST_YEAR]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('leaderboards', ['selectedLeaderboard']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('leaderboards', ['leaderboardsDateRange']), {
    title: function title() {
      var leaderboardName = this.selectedLeaderboard.leaderBoardName;
      if (leaderboardName === 'All Predictors') {
        return leaderboardName;
      }
      return 'Top ' + leaderboardName;
    }
  }),
  watch: {
    'filter.time': function filterTime(option) {
      this.setLeaderboardsDateRange(option.value);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('leaderboards', ['setLeaderboardsDateRange']), {
    setDefaultTimeFilter: function setDefaultTimeFilter() {
      var _this = this;

      this.filter.time = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_4__store_modules_leaderboards__["a" /* TIME_OPTIONS */]).find(function (i) {
        return i.value === _this.leaderboardsDateRange;
      });
    }
  }),
  created: function created() {
    this.setDefaultTimeFilter();
  }
});

/***/ }),

/***/ "QgOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_panel_js__ = __webpack_require__("GMue");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0a5f31a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_panel_vue__ = __webpack_require__("G1Rm");
function injectStyle (ssrContext) {
  __webpack_require__("1PPl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_panel_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0a5f31a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QnsU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-register"},[_c('div',{staticClass:"account-register__socials"},[_c('form-socials',{attrs:{"title":"Sign Up through"}})],1),_vm._v(" "),_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row-xy"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-12 row-y"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"tabindex":1,"disabled":_vm.isFormDisabled,"name":"username","type":"email","required":true,"validation":_vm.$v.fields.email,"autocomplete":"off","gtm":"Registration,Email","placeholder":"Email"},on:{"input":_vm.$v.fields.email.$touch,"focus":_vm.hideFooter,"blur":_vm.showFooter},model:{value:(_vm.fields.email),callback:function ($$v) {_vm.$set(_vm.fields, "email", $$v)},expression:"fields.email"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"tabindex":2,"disabled":_vm.isFormDisabled,"name":"emailConfirmation","type":"email","required":true,"validation":_vm.$v.fields.emailConfirmation,"autocomplete":"off","gtm":"Registration,Confirm Email","placeholder":"Confirm Email"},on:{"input":_vm.$v.fields.emailConfirmation.$touch,"focus":_vm.hideFooter,"blur":_vm.showFooter},model:{value:(_vm.fields.emailConfirmation),callback:function ($$v) {_vm.$set(_vm.fields, "emailConfirmation", $$v)},expression:"fields.emailConfirmation"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{ref:"password",attrs:{"hideIconOnValue":false,"tabindex":3,"disabled":_vm.isFormDisabled,"name":"password","type":_vm.fieldTypePassword,"required":true,"validation":_vm.$v.fields.password,"autocomplete":"new-password","gtm":"Registration,Password","placeholder":"Password"},on:{"input":_vm.$v.fields.password.$touch,"focus":_vm.hideFooter,"blur":_vm.showFooter},model:{value:(_vm.fields.password),callback:function ($$v) {_vm.$set(_vm.fields, "password", $$v)},expression:"fields.password"}},[(!_vm.isIE)?_c('show-password-icon',{attrs:{"slot":"icon"},on:{"showPassword":_vm.showPassword},slot:"icon"}):_vm._e()],1)],1),_vm._v(" "),(_vm.showUsername)?[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"account-register__username-wraper"},[_c('form-input',{attrs:{"tabindex":4,"disabled":_vm.isFormDisabled,"name":"nickname","type":"text","required":true,"validation":_vm.$v.fields.username,"autocomplete":"off","gtm":"Registration,User Name","placeholder":"Username"},on:{"focus":_vm.hideFooter,"blur":_vm.showFooter,"input":_vm.$v.fields.username.$touch},model:{value:(_vm.fields.username),callback:function ($$v) {_vm.$set(_vm.fields, "username", $$v)},expression:"fields.username"}})],1)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"small-12 column"},[_c('form-captcha',{key:_vm.attempt,model:{value:(_vm.fields.captcha),callback:function ($$v) {_vm.$set(_vm.fields, "captcha", $$v)},expression:"fields.captcha"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('p',{staticClass:"account-register__disclaimer"},[_vm._v("\r\n          By clicking \"Create Account\",\r\n          you confirm that you are at least 18 years of age and have read the "),_c('router-link',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"to":{ name: 'terms-and-conditions' }}},[_vm._v("Terms and Conditions")]),_vm._v(". One account per person.\r\n        ")],1)]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-submit',{attrs:{"disabled":_vm.registerButtonDisabled,"label":"Create Account"}})],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--new"},[_vm._v("Sign Up using your email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--new"},[_vm._v("Suggested Username")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qoh4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logger__ = __webpack_require__("G/BR");






var dashboardNotificationMixin = {
  props: {
    autoClose: {
      type: Boolean,
      required: false,
      default: false
    },
    closeButton: {
      type: Boolean,
      required: false,
      default: false
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
    },
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    theme: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      timeout: null,
      interacted: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['remove']), {
    onClose: function onClose() {
      this.remove(this.index);
    },
    onInteract: function onInteract() {
      this.interacted = true;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.$el.addEventListener('click', function () {
      return _this.onInteract();
    });
    if (this.autoClose && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__logger__["b" /* isDebugOn */])()) {
      this.timeout = setTimeout(function () {
        if (!_this.interacted) _this.onClose();
      }, this.closeTimeout);
    }
  },

  computed: {
    timeElapsed: function timeElapsed() {
      var elapsed = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(this.data.dateCreated).fromNow(true);
      return elapsed + ' ago';
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (dashboardNotificationMixin);

/***/ }),

/***/ "QrTx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_podcasts_js__ = __webpack_require__("Rx49");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_podcasts_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5063c782_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_podcasts_vue__ = __webpack_require__("65iJ");
function injectStyle (ssrContext) {
  __webpack_require__("oMCg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_podcasts_js__["b" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5063c782_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_podcasts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QxUi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "Qy6g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R/N+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notifications_list_js__ = __webpack_require__("KUSN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83fb1b80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_list_vue__ = __webpack_require__("ZDdF");
function injectStyle (ssrContext) {
  __webpack_require__("l0DF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notifications_list_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83fb1b80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R1ks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      required: true
    },
    typeThemeEnabled: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    arrow: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'dark'
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classModifier: function classModifier() {
      var _ref;

      return _ref = {
        'market-filters-menu-button': true,
        'market-filters-menu-button--active': this.active,
        'market-filters-menu-button--arrow': this.arrow,
        'market-filters-menu-button--selected': this.selected
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-filters-menu-button--' + this.theme, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-filters-menu-button--' + this.type, this.type && this.typeThemeEnabled), _ref;
    }
  },
  methods: {
    click: function click(e) {
      e.stopPropagation();
      this.$emit('click', this.type);
    }
  }
});

/***/ }),

/***/ "R6p5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_http__ = __webpack_require__("p1CT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__ = __webpack_require__("DECz");




/* harmony default export */ __webpack_exports__["a"] = ({
  getHeaders: function getHeaders() {
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/Headers');
  },
  getFilters: function getFilters(headerId) {
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/Filters/' + headerId);
  },
  getFilteredMarkets: function getFilteredMarkets(headerId, itemsPerPage, page, filterIds, sort, sortParameter) {
    var query = __WEBPACK_IMPORTED_MODULE_0_querystring___default.a.stringify({
      itemsPerPage: itemsPerPage,
      page: page,
      filterIds: filterIds,
      sort: sort,
      sortParameter: sortParameter
    });
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/' + headerId + '?' + query);
  },
  getNewArrivalMarkets: function getNewArrivalMarkets() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/0?itemsPerPage=' + limit + '&page=1&filterIds=&sort=newest&excludeMarketsOutsidePriceLimit=true&sortParameter=');
  },
  getMostPredictedMarkets: function getMostPredictedMarkets() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/0?itemsPerPage=' + limit + '&page=1&filterIds=&sort=traded&excludeMarketsOutsidePriceLimit=true&sortParameter=ALL');
  },
  getTrendingMarkets: function getTrendingMarkets() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/0?itemsPerPage=' + limit + '&page=1&filterIds=&sort=traded&excludeMarketsOutsidePriceLimit=true&sortParameter=TODAY');
  },
  getBiggestMoverMarkets: function getBiggestMoverMarkets() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/FilteredMarkets/0?itemsPerPage=' + limit + '&page=1&filterIds=&sort=movers&excludeMarketsOutsidePriceLimit=true&sortParameter=TODAY');
  },
  getCarousel: function getCarousel() {
    var utmSource = __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__["a" /* default */].get('utm_source');
    if (utmSource) {
      utmSource = utmSource.value;
    }
    var utmCampaign = __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__["a" /* default */].get('utm_campaign');
    if (utmCampaign) {
      utmCampaign = utmCampaign.value;
    }
    var utmCode = __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__["a" /* default */].get('utm_code');
    if (utmCode) {
      utmCode = utmCode.value;
    }
    var PIReferral = __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__["a" /* default */].get('PIReferral');
    if (PIReferral) {
      PIReferral = PIReferral.value;
    }
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/Carousel?promoCode=' + utmCode + '&marketingProgram=' + utmCampaign + '&marketingSource=' + utmSource + '&piReferral=' + PIReferral);
  },
  getSearch: function getSearch(query) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var itemsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;

    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/Search/' + query + '?page=' + page + '&itemsPerPage=' + itemsPerPage);
  },
  getHomePageGainModule: function getHomePageGainModule() {
    var isLoss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var days = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var contracts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

    var url = __webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","FIREBASE_API_KEY_ANONYMOUS":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID_ANONYMOUS":"","FIREBASE_AUTH_DOMAIN_ANONYMOUS":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL_ANONYMOUS":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID_ANONYMOUS":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID_ANONYMOUS":"76708845910","FIREBASE_STORAGE_BUCKET_ANONYMOUS":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_FIREBASE":false,"ANONYMOUS_SIGNALR":false,"ORDER_BOOK_API_CALL_ENABLED":true,"ORDER_BOOK_FIREBASE_ENABLED":true,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","OPTIMOVE_ENABLED":true,"OPTIMOVE_SDK_TOKEN":"3b0d03cb1a8091dcf9b3f84bb2466b968ebf27e1b4d8a50c123316c0d129a99b","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","NEW_HEADER_ENABLED":false,"NEW_HEADER_EXCHANGE_URL":"https://exchange.predictit.com"}).USE_API_WRAPPER ? 'api/Public/GetLiveData?url=/api/Browse/HomePage/GainModule?isLoss=' + isLoss + '&days=' + days + '&contracts=' + contracts : 'api/Browse/HomePage/GainModule?isLoss=' + isLoss + '&days=' + days + '&contracts=' + contracts;
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get(url);
  },
  getWidgets: function getWidgets() {
    // const url = process.env.USE_API_WRAPPER ?
    //   'api/Public/GetLiveData?url=/api/Browse/Widgets' :
    //   'api/Browse/Widgets';
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('/api/Browse/Widgets');
  },
  getStoriesNav: function getStoriesNav() {
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/Stories/Nav');
  },
  getStory: function getStory(index) {
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/Stories/' + index);
  },
  getStoryDetail: function getStoryDetail(index) {
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/Stories/' + index + '/Detail');
  },
  getStaticPageDetail: function getStaticPageDetail(key) {
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/StaticPage/' + key);
  },
  getStaticPagePreview: function getStaticPagePreview(id) {
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/StaticPagePreview/' + id);
  },
  getStoryFullPreview: function getStoryFullPreview(id) {
    return __WEBPACK_IMPORTED_MODULE_1__services_api_http__["b" /* default */].get('api/Browse/StoryFullPreview/' + id);
  }
});

/***/ }),

/***/ "RIDg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-combined-login"},[_c('account-login'),_vm._v(" "),_c('account-login-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RJiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy__ = __webpack_require__("K1hn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__ = __webpack_require__("nYw4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");



 /* eslint-disable max-len */





var WIDTH_PERCENTAGE_THRESHOLD = 5;

var getWidth = function getWidth(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["i" /* roundToTwo */])(value) * 100;
};
var checkThreshold = function checkThreshold(obj) {
  var value = parseInt(obj.width.replace('%', ''), 10);
  return value >= WIDTH_PERCENTAGE_THRESHOLD;
};

var updateCounters = function updateCounters(_ref) {
  var price = _ref.price,
      counter = _ref.counter,
      stateVotes = _ref.stateVotes;

  if (price <= __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["e" /* PRICE_FACTORS */].LOW) {
    counter.low += stateVotes;
  } else if (price <= __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["e" /* PRICE_FACTORS */].MEDIUM) {
    counter.medium += stateVotes;
  } else if (price <= __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["e" /* PRICE_FACTORS */].HIGH) {
    counter.high += stateVotes;
  }
  counter.total += stateVotes;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mapStateData: {},
    type: {}
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    isSenate: function isSenate() {
      return this.type === 'senate';
    },
    show: function show() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.mapStateData).length > 0;
    },
    barStyleModifiers: function barStyleModifiers() {
      // to right pad in case width does not equal 100
      var color = __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH].color;
      if (this.republican.high === 0) {
        color = __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].MEDIUM].color;
      }
      return {
        background: color
      };
    },
    democratLabelStyleModifiers: function democratLabelStyleModifiers() {
      return {
        color: __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE[__WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    republicanLabelStyleModifiers: function republicanLabelStyleModifiers() {
      return {
        color: __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    democratic: function democratic() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.mapStateData).filter(function (i) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default()(i.contracts, function (j) {
          return j.lastTradePrice;
        }).contractName === __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["d" /* CONTRACTS */].DEMOCRATIC;
      });
    },
    democraticCounters: function democraticCounters() {
      var _this = this;

      var counter = {
        total: 5,
        low: 0,
        medium: 0,
        high: 5,
        predefinedReal: 0
      };
      if (this.isSenate) {
        counter.predefined = 14; // wont be displayed, used to reserve width
        counter.predefinedReal = 36;
        // 5 demo
        // 12 repub
      }
      this.democratic.forEach(function (i) {
        var targetContract = __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default()(i.contracts, function (j) {
          return j.lastTradePrice;
        });
        var stateVotes = _this.isSenate ? 1 : i.stateVotes;
        updateCounters({
          counter: counter,
          price: targetContract.lastTradePrice,
          stateVotes: stateVotes
        });
      });
      return counter;
    },
    republican: function republican() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.mapStateData).filter(function (i) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default()(i.contracts, function (j) {
          return j.lastTradePrice;
        }).contractName === __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["d" /* CONTRACTS */].REPUBLICAN;
      });
    },
    republicanCounters: function republicanCounters() {
      var _this2 = this;

      var counter = {
        total: 12,
        low: 0,
        medium: 0,
        high: 12,
        predefinedReal: 0
      };
      if (this.isSenate) {
        counter.predefined = 8; // wont be displayed, used to reserve width
        counter.predefinedReal = 29;
      }
      this.republican.forEach(function (i) {
        var targetContract = __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default()(i.contracts, function (j) {
          return j.lastTradePrice;
        });
        var stateVotes = _this2.isSenate ? 1 : i.stateVotes;
        updateCounters({
          counter: counter,
          price: targetContract.lastTradePrice,
          stateVotes: stateVotes
        });
      });
      return counter;
    },
    totalVotes: function totalVotes() {
      return this.republicanCounters.total + this.democraticCounters.total;
    },
    democraticPredefinedBarSectionStyleModifiers: function democraticPredefinedBarSectionStyleModifiers() {
      return {
        width: getWidth(this.democraticCounters.predefined / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE[__WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    democraticHighBarSectionStyleModifiers: function democraticHighBarSectionStyleModifiers() {
      return {
        width: getWidth(this.democraticCounters.high / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE[__WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    democraticMediumBarSectionStyleModifiers: function democraticMediumBarSectionStyleModifiers() {
      return {
        width: getWidth(this.democraticCounters.medium / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE[__WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].MEDIUM].color
      };
    },
    democraticLowBarSectionStyleModifiers: function democraticLowBarSectionStyleModifiers() {
      return {
        width: getWidth(this.democraticCounters.low / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].BLUE[__WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].LOW].color
      };
    },
    republicanPredefinedBarSectionStyleModifiers: function republicanPredefinedBarSectionStyleModifiers() {
      return {
        width: getWidth(this.republicanCounters.predefined / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    republicanHighBarSectionStyleModifiers: function republicanHighBarSectionStyleModifiers() {
      return {
        width: getWidth(this.republicanCounters.high / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].HIGH].color
      };
    },
    republicanMediumBarSectionStyleModifiers: function republicanMediumBarSectionStyleModifiers() {
      return {
        width: getWidth(this.republicanCounters.medium / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].MEDIUM].color
      };
    },
    republicanLowBarSectionStyleModifiers: function republicanLowBarSectionStyleModifiers() {
      return {
        width: getWidth(this.republicanCounters.low / this.totalVotes) + '%',
        background: __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["b" /* COLOR_MAP */].RED[__WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_election_map_election_map_vue__["c" /* COLOR_INDEXES */].LOW].color
      };
    },
    showDemocraticHighText: function showDemocraticHighText() {
      return this.democraticCounters.high > 0 && checkThreshold(this.democraticHighBarSectionStyleModifiers);
    },
    showDemocraticMediumText: function showDemocraticMediumText() {
      return this.democraticCounters.medium > 0 && checkThreshold(this.democraticMediumBarSectionStyleModifiers);
    },
    showDemocraticLowText: function showDemocraticLowText() {
      return this.democraticCounters.low > 0 && checkThreshold(this.democraticLowBarSectionStyleModifiers);
    },
    showRepublicanHighText: function showRepublicanHighText() {
      return this.republicanCounters.high > 0 && checkThreshold(this.republicanHighBarSectionStyleModifiers);
    },
    showRepublicanMediumText: function showRepublicanMediumText() {
      return this.republicanCounters.medium > 0 && checkThreshold(this.republicanMediumBarSectionStyleModifiers);
    },
    showRepublicanLowText: function showRepublicanLowText() {
      return this.republicanCounters.low > 0 && checkThreshold(this.republicanLowBarSectionStyleModifiers);
    },
    showDemocraticPredefinedText: function showDemocraticPredefinedText() {
      return true;
    },
    showRepublicanPredefinedText: function showRepublicanPredefinedText() {
      return true;
    },
    majorityText: function majorityText() {
      if (this.isSenate) {
        return this.isLayoutDesktop ? '50 Seats' : '50';
      }
      return 'Majority';
    }
  })
});

/***/ }),

/***/ "ROoR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_vm._m(0),_vm._v(" "),(_vm.isPending)?[(_vm.isCard)?[_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n        Your identification documents are under review. We will notify you by email regarding your status within 72 hours of submission. You will be able to deposit funds once your identity has been confirmed.\n      ")]),_vm._v(" "),(false)?_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n        Don’t want to wait? Try Online Banking instead. No document upload required. Start trading now!\n      ")]):_vm._e()]:(_vm.isModal)?_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n      Your identification documents are under review. We will notify you by email regarding your status within 72 hours of submission. You will be able to deposit funds once your identify has been confirmed. Thank you for your patience.\n    ")]):_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n      Your identification documents are under review. We will notify you by email regarding your status within 72 hours of submission. You will be able to deposit funds once your identify has been confirmed. Thank you for your patience.\n    ")])]:[(_vm.isCard)?[_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n        To use a credit card, PredictIt requires all traders to upload a proof of identity document. We will then review the document as quickly as possible so that you can start trading.\n      ")]),_vm._v(" "),(false)?_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n        Don’t want to wait? Try Online Banking instead. No document upload required. Start trading now!\n      ")]):_vm._e()]:(_vm.isModal)?_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n      We are required to collect further documentation in order to process your transaction. Please click to upload an identity document.\n    ")]):_c('p',{staticClass:"account-upload-document__note"},[_vm._v("\n      We are required to collect documentation in order to process further deposits or withdrawals. Please click to upload an identity document.\n    ")]),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width",on:{"click":function($event){$event.preventDefault();return _vm.onButtonClick($event)}}},[_vm._v("\n      Upload Document\n    ")])]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-upload-document__icon"},[_c('img',{attrs:{"src":__webpack_require__("z6fO")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ROsZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_social_avatar_js__ = __webpack_require__("dOsu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9a63ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_social_avatar_vue__ = __webpack_require__("B1kG");
function injectStyle (ssrContext) {
  __webpack_require__("rfGX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_social_avatar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9a63ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_social_avatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RQ5D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_hero_unit_slider_js__ = __webpack_require__("L8Dv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b52436b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_unit_slider_vue__ = __webpack_require__("8Crr");
function injectStyle (ssrContext) {
  __webpack_require__("j8AR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_hero_unit_slider_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b52436b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_unit_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RSTw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_snakeCase__ = __webpack_require__("OAqO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_snakeCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_snakeCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_externalLinks__ = __webpack_require__("ys9T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__ = __webpack_require__("Moaq");








var PROVIDER_FACEBOOK = 'Facebook';
var PROVIDER_TWITTER = 'Twitter';
var CACHE_NAME = 'register-external';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins_externalLinks__["a" /* default */]],
  validations: {
    fields: {
      email: __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["a" /* validators */].email,
      emailConfirmation: __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["a" /* validators */].emailConfirmation('email'),
      username: __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["a" /* validators */].username
    }
  },
  data: function data() {
    return {
      fields: {
        email: '',
        emailConfirmation: '',
        username: ''
      },
      error: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['userInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('popup', ['formDataCache'])),
  mounted: function mounted() {
    if (this.userInfo && this.userInfo.userName) {
      this.fields.username = __WEBPACK_IMPORTED_MODULE_1_lodash_snakeCase___default()(this.userInfo.userName);
      this.$v.fields.username.$touch();
    }
    if (this.formDataCache !== null && CACHE_NAME === this.formDataCache.route) {
      this.fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.fields, this.formDataCache);
    }
    if (this.fields.email) {
      this.$v.fields.email.$touch();
    }
    if (this.fields.emailConfirmation) {
      this.$v.fields.emailConfirmation.$touch();
    }
  },

  watch: {
    userInfo: function userInfo() {
      this.fields.username = __WEBPACK_IMPORTED_MODULE_1_lodash_snakeCase___default()(this.userInfo.userName);
      this.$v.fields.username.$touch();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['registerExternal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'cacheFormData']), {
    closePopupAndRedirect: function closePopupAndRedirect() {
      var _this = this;

      this.setCurrentPopup();
      this.getExternalLogins({}).then(function (response) {
        _this.links = response.data;
        var provider = _this.userInfo.loginProvider;
        switch (provider) {
          case PROVIDER_FACEBOOK:
            _this.facebookLinkClick();
            break;
          case PROVIDER_TWITTER:
            _this.twitterLinkClick();
            break;
          default:
            break;
        }
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'submit',
        label: 'Create Account'
      });
      if (this.formIsValid() && this.formDisable()) {
        var payload = {
          email: this.fields.email,
          userName: __WEBPACK_IMPORTED_MODULE_1_lodash_snakeCase___default()(this.fields.username)
        };
        this.registerExternal(payload).then(this.formEnable).then(function () {
          __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].set('registeredExternal', true);
          _this2.closePopupAndRedirect();
        }).catch(function (error) {
          return _this2.formHandleErrors(error);
        });
      }
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.cacheFormData(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.fields, { route: CACHE_NAME }));
  }
});

/***/ }),

/***/ "RU3U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_news_feed_item_js__ = __webpack_require__("ygM9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65833555_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_feed_item_vue__ = __webpack_require__("tq+R");
function injectStyle (ssrContext) {
  __webpack_require__("yf1d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_news_feed_item_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65833555_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_feed_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RZM5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return $txt; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dcm_json__ = __webpack_require__("yui2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dcm_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dcm_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__predictit_json__ = __webpack_require__("ZjeX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__predictit_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__predictit_json__);

/* eslint-disable */



var DEFAULT_CONF = 'predictit';
var translations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
  dcm: __WEBPACK_IMPORTED_MODULE_1__dcm_json___default.a
}, DEFAULT_CONF, __WEBPACK_IMPORTED_MODULE_2__predictit_json___default.a);

var $txt = function $txt(message) {
  var project = "predictit";
  return translations[project][message] || translations[DEFAULT_CONF][message];
};

/***/ }),

/***/ "RaQB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_social_share_invite_widget_share_invite_widget_vue__ = __webpack_require__("dDcj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_leaderboards_leaderboards_levels_leaderboards_levels_vue__ = __webpack_require__("qvFU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_leaderboards_leaderboards_table_leaderboards_table_vue__ = __webpack_require__("hQjR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_leaderboards_leaderboards_toolbar_leaderboards_toolbar_vue__ = __webpack_require__("YfnU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_headerTags__ = __webpack_require__("cgm0");











/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_headerTags__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  components: {
    leaderboardsLevels: __WEBPACK_IMPORTED_MODULE_5__components_leaderboards_leaderboards_levels_leaderboards_levels_vue__["a" /* default */],
    leaderboardsTable: __WEBPACK_IMPORTED_MODULE_6__components_leaderboards_leaderboards_table_leaderboards_table_vue__["a" /* default */],
    leaderboardsToolbar: __WEBPACK_IMPORTED_MODULE_7__components_leaderboards_leaderboards_toolbar_leaderboards_toolbar_vue__["a" /* default */],
    shareInviteWidget: __WEBPACK_IMPORTED_MODULE_4__components_social_share_invite_widget_share_invite_widget_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Leaderboards',
      link: [{ rel: 'canonical', href: '' + window.location.href }],
      meta: [{ itemprop: 'image', content: window.location.origin + '/static/logo.png' }, { property: 'og:title', content: 'Leaderboards' }, { property: 'og:type', content: 'article' }, { property: 'og:image', content: window.location.origin + '/static/logo.png' }, { property: 'og:site_name', content: 'Predictit' }, { property: 'og:url', content: '' + window.location.href }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('leaderboards', ['selectedLeaderboard']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('leaderboards', ['selectedLeaderboardId', 'leaderboardsDateRange'])),
  watch: {
    selectedLeaderboardId: function selectedLeaderboardId(value) {
      if (value === null || this.leaderboardsDateRange === null) return;

      this.$router.push({
        name: 'leaderboards',
        query: {
          leaderboardId: value,
          dateRange: this.leaderboardsDateRange
        }
      });
    },
    leaderboardsDateRange: function leaderboardsDateRange(value) {
      if (value === null || this.selectedLeaderboardId === null) return;

      this.$router.push({
        name: 'leaderboards',
        query: {
          leaderboardId: this.selectedLeaderboardId,
          dateRange: value
        }
      });
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('leaderboards', ['clearSelectedLeaderboardId', 'resetLeaderboardsDateRange']), {
    onBackClick: function onBackClick() {
      this.clearSelectedLeaderboardId();
      this.resetLeaderboardsDateRange();
      this.$router.push({ name: 'leaderboards' });
    }
  }),
  created: function created() {
    this.reorganizeTags();
  },
  beforeDestroy: function beforeDestroy() {
    this.clearSelectedLeaderboardId();
    this.resetLeaderboardsDateRange();
  }
});

/***/ }),

/***/ "Rlrl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_vue__ = __webpack_require__("O43h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_account_account_details_account_details_vue__ = __webpack_require__("DbLG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_account_social_auth_account_social_auth_vue__ = __webpack_require__("cEur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_account_history_history_vue__ = __webpack_require__("kNWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_account_settings_settings_vue__ = __webpack_require__("YCiF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_profile_page_profile_page_vue__ = __webpack_require__("8nLW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_page_login_page_login_vue__ = __webpack_require__("8G+U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_page_forgotten_password_page_forgotten_password_vue__ = __webpack_require__("FezS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_page_register_page_register_vue__ = __webpack_require__("gVgM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_page_tax_detail_page_tax_detail_vue__ = __webpack_require__("xth1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_account_account_disqus_account_disqus_vue__ = __webpack_require__("IwtE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_wallet_wallet_vue__ = __webpack_require__("sBpB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_home_home_old_home_old_vue__ = __webpack_require__("3Uxo");
















/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/account',
  component: __WEBPACK_IMPORTED_MODULE_0__components_account_account_vue__["a" /* default */],
  props: true,
  meta: {
    requiresAuth: true
  },
  children: [{
    path: 'wallet',
    name: 'wallet',
    component: __WEBPACK_IMPORTED_MODULE_11__components_wallet_wallet_vue__["a" /* default */]
  }, {
    path: '',
    name: 'profile',
    component: __WEBPACK_IMPORTED_MODULE_5__components_account_profile_page_profile_page_vue__["a" /* default */],
    props: true
  }, {
    path: 'details',
    name: 'account-details',
    component: __WEBPACK_IMPORTED_MODULE_1__components_account_account_details_account_details_vue__["a" /* default */]
  }, {
    path: 'details/update',
    name: 'details-update',
    component: __WEBPACK_IMPORTED_MODULE_1__components_account_account_details_account_details_vue__["a" /* default */]
  }, {
    path: 'address/update',
    name: 'address-update',
    component: __WEBPACK_IMPORTED_MODULE_1__components_account_account_details_account_details_vue__["a" /* default */]
  }, {
    path: 'password/update',
    name: 'password-update',
    component: __WEBPACK_IMPORTED_MODULE_1__components_account_account_details_account_details_vue__["a" /* default */]
  }, {
    path: 'password/set',
    name: 'password-set',
    component: __WEBPACK_IMPORTED_MODULE_1__components_account_account_details_account_details_vue__["a" /* default */]
  }, {
    path: 'history/:marketId?',
    name: 'account-history',
    component: __WEBPACK_IMPORTED_MODULE_3__components_account_history_history_vue__["a" /* default */],
    props: true
  }, {
    path: 'settings',
    name: 'account-settings',
    component: __WEBPACK_IMPORTED_MODULE_4__components_account_settings_settings_vue__["a" /* default */]
  }]
}, {
  path: '/account/password/reset',
  name: 'reset-password',
  component: __WEBPACK_IMPORTED_MODULE_14__components_home_home_old_home_old_vue__["a" /* default */],
  beforeEnter: function beforeEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_13__components_app_app_modals_app_modals__["a" /* MODALS */].RESET_PASSWORD);
    __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('popup/setCurrentPopupOptions', {
      token: to.query.token
    });
    next();
  },
  meta: {
    appContentOverflowed: true
  }
}, {
  path: '/account/social/auth',
  name: 'social-auth',
  component: __WEBPACK_IMPORTED_MODULE_2__components_account_account_social_auth_account_social_auth_vue__["a" /* default */]
}, {
  path: '/account/disqus',
  name: 'disqus-auth',
  component: __WEBPACK_IMPORTED_MODULE_10__components_account_account_disqus_account_disqus_vue__["a" /* default */],
  props: true
}, {
  path: '/account/disqus/logout/:routeName/:routeParams?',
  name: 'disqus-logout',
  component: __WEBPACK_IMPORTED_MODULE_10__components_account_account_disqus_account_disqus_vue__["a" /* default */],
  props: true
}, {
  path: '/account/login',
  name: 'account-page-login',
  component: __WEBPACK_IMPORTED_MODULE_6__components_pages_page_login_page_login_vue__["a" /* default */],
  meta: {
    requiresAnonymous: true
  }
}, {
  path: '/account/sign-up',
  name: 'account-page-register',
  component: __WEBPACK_IMPORTED_MODULE_8__components_pages_page_register_page_register_vue__["a" /* default */],
  meta: {
    requiresAnonymous: true
  }
}, {
  path: '/account/password/forgotten',
  name: 'account-password-forgotten',
  component: __WEBPACK_IMPORTED_MODULE_7__components_pages_page_forgotten_password_page_forgotten_password_vue__["a" /* default */],
  meta: {
    requiresAnonymous: true
  }
}, {
  path: '/account/taxdetail',
  name: 'account-page-tax-detail',
  component: __WEBPACK_IMPORTED_MODULE_9__components_pages_page_tax_detail_page_tax_detail_vue__["a" /* default */],
  meta: {
    requiresAuth: true
  }
}]);

/***/ }),

/***/ "RqeL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_contract_market_contract_vue__ = __webpack_require__("HJEq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_list_item_v2_market_list_item_v2_vue__ = __webpack_require__("tPuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_collapsible_panel_collapsible_panel_vue__ = __webpack_require__("NMl0");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_loader__["a" /* default */]],
  components: {
    collapsiblePanel: __WEBPACK_IMPORTED_MODULE_5__components_collapsible_panel_collapsible_panel_vue__["a" /* default */],
    marketContract: __WEBPACK_IMPORTED_MODULE_3__components_market_market_contract_market_contract_vue__["a" /* default */],
    marketListItem: __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_list_item_v2_market_list_item_v2_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.loaderAdd();
    this.getRelatedMarkets(this.market.marketId).then(function () {
      return _this.loaderRemove();
    }).catch(function () {
      return _this.loaderRemove();
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('market', ['related']), {
    show: function show() {
      return this.isLoading || this.related.length > 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('market', ['getRelatedMarkets', 'clearRelatedMarkets'])),
  beforeDestroy: function beforeDestroy() {
    this.clearRelatedMarkets();
  }
});

/***/ }),

/***/ "RuD/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_overlay_js__ = __webpack_require__("Oota");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a10ff46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overlay_vue__ = __webpack_require__("KKxr");
function injectStyle (ssrContext) {
  __webpack_require__("grrE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_overlay_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a10ff46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RuPo":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Rx49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PODCAST; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_shuffle__ = __webpack_require__("yG5q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_shuffle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");


 /* eslint-disable max-len */





var PODCAST = {
  ITUNES: 'itunes',
  SOUNDCLOUD: 'soundcloud',
  BACKTRACKS: 'backtracks',
  POLITICAN_TRADER: 'politicantrader',
  APPLE: 'apple',
  STITCHER: 'stitcher'
};

/* harmony default export */ __webpack_exports__["b"] = ({
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__["swiperSlide"]
  },
  props: {
    title: {
      type: String,
      default: 'Featured Podcasts'
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    theme: {
      type: String,
      default: 'default'
    }
  },
  data: function data() {
    var _this = this;

    var defaultTracks = __WEBPACK_IMPORTED_MODULE_2_lodash_shuffle___default()([{ id: 'id1437934639', type: PODCAST.APPLE }, { id: 'id1496616116', type: PODCAST.APPLE }, { id: 'id1510570053', type: PODCAST.APPLE }, { id: 'id1136826256', type: PODCAST.APPLE }]
    // { id: '505391', type: PODCAST.STITCHER },
    // { id: '', type: PODCAST.POLITICAN_TRADER },
    // { id: 'https://soundcloud.com/stratfortalks', type: PODCAST.SOUNDCLOUD },
    // { id: 'stratfor/stratfor-quick-take/m/a-second-u-s-north-korea-summit', type: PODCAST.BACKTRACKS },
    // { id: '1437934639', type: PODCAST.ITUNES },
    );
    return {
      PODCAST: PODCAST,
      activeIndex: 0,
      isPlaying: true,
      tracks: this.items.length > 0 ? this.items : defaultTracks,
      swiperOptions: {
        loop: false,
        autoplay: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['app/isLayoutMobile'] ? false : 5000,
        direction: 'horizontal',
        spaceBetween: 0,
        onTransitionStart: function onTransitionStart(swp) {
          _this.activeIndex = swp.activeIndex;
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        podcasts: true
      }, 'podcasts--' + this.theme, this.theme);
    },
    height: function height() {
      if (this.theme === 'story') {
        return 450;
      }
      return this.isLayoutMobile ? 450 : 400;
    },
    styleItunesIframe: function styleItunesIframe() {
      if (this.isLayoutMobile) {
        return 'overflow-x:hidden;overflow-y:hidden;height:300px;border:0px';
      }
      return 'overflow-x:hidden;overflow-y:hidden;height:300px;border:0px;width:100%';
    },
    showArrows: function showArrows() {
      return this.tracks.length > 1;
    },
    isPrevArrowDisabled: function isPrevArrowDisabled() {
      return this.activeIndex === 0;
    },
    isNextArrowDisabled: function isNextArrowDisabled() {
      return this.activeIndex === this.tracks.length - 1;
    },
    prevArrowModifiers: function prevArrowModifiers() {
      return {
        'podcasts__header-arrow': true,
        'podcasts__header-arrow--left': true,
        'podcasts__header-arrow--disabled': this.isPrevArrowDisabled
      };
    },
    nextArrowModifiers: function nextArrowModifiers() {
      return {
        'podcasts__header-arrow': true,
        'podcasts__header-arrow--right': true,
        'podcasts__header-arrow--disabled': this.isNextArrowDisabled
      };
    }
  }),
  methods: {
    stopSwiper: function stopSwiper() {
      this.isPlaying = false;
      this.$refs.swiper.swiper.stopAutoplay();
    },
    startSwiper: function startSwiper() {
      this.isPlaying = true;
      this.$refs.swiper.swiper.startAutoplay();
    },
    getPoliticanTraderUrl: function getPoliticanTraderUrl() {
      return '//html5-player.libsyn.com/embed/destination/id/1822847/height/300/theme/custom/thumbnail/yes/direction/backward/no-cache/true/render-playlist/yes/custom-color/2607ab/';
    },
    getBacktracksUrl: function getBacktracksUrl(id) {
      return 'https://player.backtracks.fm/' + id;
    },
    getSoundCloudUrl: function getSoundCloudUrl(track) {
      return 'https://w.soundcloud.com/player/?url=' + track + '&auto_play=false&show_artwork=false';
    },
    getItunesUrl: function getItunesUrl(ids) {
      var width = this.isLayoutMobile ? '290' : '476';
      var query = '?c=us&d=Test&t=Test&m=podcast&e=podcast&w=' + width + '&h=300&ids=' + ids + '&wt=playlist';
      return '//widgets.itunes.apple.com/widget.html' + query;
    },
    getAppleUrl: function getAppleUrl(id) {
      return 'https://embed.podcasts.apple.com/us/podcast/star-spangled-gamblers/' + id + '?itsct=podcast_box&amp;itscg=30200';
    },
    getStitcherUrl: function getStitcherUrl(id) {
      return 'https://www.stitcher.com/embed/' + id;
    },
    prevSlide: function prevSlide() {
      if (!this.isPrevArrowDisabled) this.$refs.swiper.swiper.slidePrev();
    },
    nextSlide: function nextSlide() {
      if (!this.isNextArrowDisabled) this.$refs.swiper.swiper.slideNext();
    }
  }
});

/***/ }),

/***/ "S1Yq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__("G/BR");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    autoClose: {
      type: Boolean,
      required: false,
      default: false
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].DEFAULT_SMALL_POPUP_TIMEOUT
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      required: false,
      default: 'top'
    },
    padding: {
      type: Boolean,
      default: true
    },
    overlay: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    classModifier: function classModifier() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'modal-small--' + this.type, this.type), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'modal-small--no-padding', !this.padding), _ref;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.autoClose && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__logger__["b" /* isDebugOn */])()) {
      setTimeout(function () {
        return _this.close();
      }, this.closeTimeout);
    }
  },

  methods: {
    close: function close() {
      this.$emit('modalClose');
    }
  }
});

/***/ }),

/***/ "S9O8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__("gGqR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__("G/BR");
 /* eslint-disable no-console */
/* global MobileApp:false */




/* harmony default export */ __webpack_exports__["a"] = ({
  userLoggedIn: function userLoggedIn(token) {
    if (__WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__["e" /* iOSWrapper */]) {
      window.location.href = 'pred://userLoggedIn?token=' + token;
    } else {
      if (typeof MobileApp === 'undefined') return;
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(MobileApp.userLoggedIn)) return;
      try {
        MobileApp.userLoggedIn.bind(MobileApp)(token);
      } catch (err) {
        __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].error(err);
      }
    }
  },
  userLoggedOut: function userLoggedOut() {
    if (__WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__["e" /* iOSWrapper */]) {
      window.location.href = 'pred://userLoggedOut';
    } else {
      if (typeof MobileApp === 'undefined') return;
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(MobileApp.userLoggedOut)) return;
      try {
        MobileApp.userLoggedOut.bind(MobileApp)();
      } catch (err) {
        __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].error(err);
      }
    }
  }
});

/***/ }),

/***/ "SCoJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('div',{staticClass:"purchase-desktop"},[(_vm.tradeOptions.contractId)?_c('purchase-journey',_vm._b({attrs:{"closeJourneyAfterSuccess":_vm.closeJourneyAfterSuccess,"market":_vm.market,"kind":"desktop"},on:{"reinitialize":function($event){return _vm.$emit('reinitialize')}}},'purchase-journey',_vm.tradeOptions,false)):_vm._e(),_vm._v(" "),(_vm.showCloseButton)?_c('div',{staticClass:"purchase-desktop__close"},[_c('close-button',{attrs:{"isDark":true},on:{"close":_vm.close}})],1):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SER/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio"},[_c('label',{attrs:{"for":_vm.name}},[_c('div',{staticClass:"radio__input"},[_c('input',{attrs:{"type":"radio","name":_vm.name,"required":_vm.required,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checked === _vm.value},on:{"change":_vm.onChange}})]),_vm._v(" "),_c('div',{staticClass:"radio__label",on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SH6Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SHAV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotificationLoader_vue__ = __webpack_require__("5aqh");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__NotificationLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarketLoader_vue__ = __webpack_require__("fzCn");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__MarketLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MarketSharesItemLoader_vue__ = __webpack_require__("W9Re");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__MarketSharesItemLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MarketWidgetLoader_vue__ = __webpack_require__("ucfo");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__MarketWidgetLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BiggestGainsLoader_vue__ = __webpack_require__("ZC+n");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__BiggestGainsLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TableRowsLoader_vue__ = __webpack_require__("XMP4");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__TableRowsLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccountWithdrawalLoader_vue__ = __webpack_require__("d2fJ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__AccountWithdrawalLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccountFormLoader_vue__ = __webpack_require__("8YSH");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__AccountFormLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LeaderboardsInfoLoader_vue__ = __webpack_require__("2uhI");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__LeaderboardsInfoLoader_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OverviewMapLoader_vue__ = __webpack_require__("8zAU");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__OverviewMapLoader_vue__["a"]; });
/* eslint-disable */












/***/ }),

/***/ "SHkF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_link_tile_js__ = __webpack_require__("Y4EP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1361def5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_link_tile_vue__ = __webpack_require__("bzh+");
function injectStyle (ssrContext) {
  __webpack_require__("b+BV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_link_tile_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1361def5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_link_tile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SM2J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-rules"},[_c('div',{attrs:{"id":"market-rules"}}),_vm._v(" "),_c('div',{class:_vm.marginBoxClass},[_c('h2',{staticClass:"market-rules__title"},[_vm._v("The Rules")]),_vm._v(" "),_c('div',{ref:"wrap",class:_vm.wrapperClass},[_c('div',{ref:"content",staticClass:"market-rules__content",domProps:{"innerHTML":_vm._s(_vm.rules)}})])]),_vm._v(" "),_c('div',{staticClass:"market-rules__footer"},[_c('div',{staticClass:"market-rules__more",on:{"click":_vm.showRulesPopup}},[_vm._v("\r\n      Read the Full Rules\r\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SMhf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_mobile_watchlist_js__ = __webpack_require__("tQ/B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c283326_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_mobile_watchlist_vue__ = __webpack_require__("61rA");
function injectStyle (ssrContext) {
  __webpack_require__("kgr9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_mobile_watchlist_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c283326_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_mobile_watchlist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SO44":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OFFSET_CHECK_TIMEOUT; });
/* unused harmony export MARKET_CONTRACTS_SHOW_MORE_NUM */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_contract_horizontal_v2_market_contract_horizontal_v2_vue__ = __webpack_require__("p+B/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_purchase_purchase_desktop_purchase_desktop_vue__ = __webpack_require__("nGzq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_payout_market_payout_vue__ = __webpack_require__("SdEv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");













// transition time + buffer
var OFFSET_CHECK_TIMEOUT = 300 + 150;
var MARKET_CONTRACTS_SHOW_MORE_NUM = 3;

/* unused harmony default export */ var _unused_webpack_default_export = ({
  props: {
    market: {
      type: Object,
      required: true
    },
    expandingAll: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showAllContracts: false,
      isExpandingAll: this.expandingAll,
      togglePositionTop: null,
      reinitializeAttempt: 1
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_loader__["a" /* default */]],
  components: {
    marketContract: __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_contract_horizontal_v2_market_contract_horizontal_v2_vue__["a" /* default */],
    marketPayout: __WEBPACK_IMPORTED_MODULE_5__components_market_market_payout_market_payout_vue__["a" /* default */],
    purchaseDesktop: __WEBPACK_IMPORTED_MODULE_4__components_purchase_purchase_desktop_purchase_desktop_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('trade', ['tradeOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('popup', ['currentPopup']), {
    showContractsHeader: function showContractsHeader() {
      return this.isLayoutDesktop;
    },
    contractsToShow: function contractsToShow() {
      return !this.showAllContracts && this.shouldShowToggleMoreButton ? this.filteredContracts.slice(0, MARKET_CONTRACTS_SHOW_MORE_NUM) : this.filteredContracts;
    },
    leftContractsToShow: function leftContractsToShow() {
      return this.showAllContracts ? [] : this.filteredContracts.slice(MARKET_CONTRACTS_SHOW_MORE_NUM, this.filteredContracts.length);
    },
    shouldShowToggleMoreButton: function shouldShowToggleMoreButton() {
      return this.expandingAll && this.filteredContracts.length > MARKET_CONTRACTS_SHOW_MORE_NUM;
    },
    toggleMoreModifiers: function toggleMoreModifiers() {
      return {
        'market-list-item-expandable__contracts-toggle-more': true,
        'market-list-item-expandable__contracts-toggle-more--active': this.showAllContracts
      };
    },
    contractLayout: function contractLayout() {
      return this.isLayoutDesktop ? 'dashboard' : 'default';
    },
    titleMobileClassModifiers: function titleMobileClassModifiers() {
      return {
        'market-list-item-expandable__mobile-title': true,
        'market-list-item-expandable__mobile-title--has-open-offers': this.showOpenOffersIndicator
      };
    },
    toggleMobileClassModifiers: function toggleMobileClassModifiers() {
      return {
        'market-list-item-expandable__mobile-toggle': true,
        'market-list-item-expandable__mobile-toggle--expanded': this.expanded
      };
    },
    titleDesktopClassModifiers: function titleDesktopClassModifiers() {
      return {
        'market-list-item-expandable__desktop-title': true,
        'market-list-item-expandable__desktop-title--has-open-offers': this.showOpenOffersIndicator
      };
    },
    toggleDesktopClassModifiers: function toggleDesktopClassModifiers() {
      return {
        'market-list-item-expandable__desktop-toggle': true,
        'market-list-item-expandable__desktop-toggle--expanded': this.expanded
      };
    },
    marketImageStyleModifiers: function marketImageStyleModifiers() {
      var baseGradient = 'linear-gradient(to right, rgba(78, 109, 115, 0.12), rgba(78, 109, 115, 0.16))';
      return {
        'background-image': baseGradient + ', url(' + this.market.marketImageUrl + ')'
      };
    },
    filteredContracts: function filteredContracts() {
      return this.market && this.market.marketContracts ? this.market.marketContracts.filter(function (i) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["m" /* contractOwnershipNum */])(i) > 0;
      }) : [];
    },
    isPayoutAvailable: function isPayoutAvailable() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["y" /* hasMarketPayout */])(this.market);
    },
    openOffers: function openOffers() {
      if (!this.market.isOpen) return 0;
      return __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(this.filteredContracts, function (i) {
        return i.userOpenOrdersBuyQuantity + i.userOpenOrdersSellQuantity;
      });
    },
    showOpenOffersIndicator: function showOpenOffersIndicator() {
      return this.isLayoutDesktop && this.openOffers > 0;
    },
    marketKey: function marketKey() {
      var loggedIn = this.isLoggedIn ? 'logged-in' : 'logged-out';
      return this.market ? 'dashboard-' + this.market.marketId + '-' + loggedIn : null;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('market', ['getMarket']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setTradePopup']), {
    onToggleMore: function onToggleMore() {
      this.showAllContracts = !this.showAllContracts;
      if (!this.showAllContracts) {
        window.scrollTo(0, this.$el.offsetTop);
      }
    },
    onViewMarket: function onViewMarket(market) {
      this.$router.push({
        name: 'market-details',
        params: { marketId: market.marketId, marketUrl: market.marketUrl }
      });
    },
    onReinitializePurchase: function onReinitializePurchase() {
      // this.reinitializeAttempt += 1;
    },
    toggleItem: function toggleItem() {
      this.togglePositionTop = this.$el.offsetTop;
      this.$emit('toggle', {
        expanded: !this.expanded,
        market: this.market
      });
    },
    contractKey: function contractKey(prefix, data) {
      var contract = new __WEBPACK_IMPORTED_MODULE_7__models_contract__["a" /* default */](data);
      return prefix + '-' + this.marketKey + '-' + contract.contractId + '-' + contract.mode + '-' + this.reinitializeAttempt.toString();
    },
    isPurchaseDesktopMode: function isPurchaseDesktopMode(contractId) {
      return this.isLayoutDesktop && this.tradeOptions && this.tradeOptions.contractId === contractId;
    },
    initializePurchase: function initializePurchase() {
      var contracts = this.market.contracts || this.market.marketContracts;
      var contractIds = contracts.map(function (i) {
        return i.contractId;
      });
      if (this.isLayoutMobile && this.tradeOptions !== null && this.tradeOptions.contractId !== null && contractIds.includes(this.tradeOptions.contractId) && this.currentPopup !== __WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].PURCHASE) {
        this.setTradePopup({
          name: __WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].PURCHASE,
          options: {
            market: this.market
          }
        });
      }
    }
  }),
  watch: {
    expanded: function expanded(value) {
      var _this = this;

      if (value && !this.expandingAll) {
        setTimeout(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_scrollTo__["a" /* default */])(_this.$el.offsetTop, 500);
        }, OFFSET_CHECK_TIMEOUT);
      }
    },
    tradeOptions: function tradeOptions() {
      this.initializePurchase();
    }
  }
});

/***/ }),

/***/ "SRJW":
/***/ (function(module, exports) {

/* eslint-disable */

try {
  new MouseEvent('test');
} catch (e) {
  var MouseEvent = function MouseEvent(eventType, params) {
    params = params || { bubbles: false, cancelable: false };
    var mouseEvent = document.createEvent('MouseEvent');
    mouseEvent.initMouseEvent(eventType, params.bubbles, params.cancelable, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

    return mouseEvent;
  };

  MouseEvent.prototype = Event.prototype;

  window.MouseEvent = MouseEvent;
}

/***/ }),

/***/ "SSAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.price > 0)?_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.price),expression:"price",modifiers:{"cents":true}}],staticClass:"button-price__price"}):_c('span',{staticClass:"button-price__price"},[_vm._v(_vm._s(_vm.PURCHASE_DEFAULT_LABEL))]),_vm._v(" "),_c('span',{staticClass:"button-price__text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SSqF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SVQh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__ = __webpack_require__("URu4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");
 /* eslint-disable no-unused-vars */







var COUNTRY_CODE_US = 'US';

var hasOneDigit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'hasOneDigit' }, function (value) {
  return (/\d/.test(value)
  );
});
var hasOneUpper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'hasOneUpper' }, function (value) {
  return (/[A-Z]/.test(value)
  );
});
var hasOneLower = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'hasOneLower' }, function (value) {
  return (/[a-z]/.test(value)
  );
});
var usernameIsValid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'usernameIsValid' }, function (value) {
  return (/^[a-zA-Z0-9_]+$/.test(value)
  );
});
var noSpaces = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'noSpaces' }, function (value) {
  return value.indexOf(' ') === -1;
});
var minLength = function minLength(min) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'minLength', min: min }, function (value) {
    return value.length >= min;
  });
};
var maxLength = function maxLength(max) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'maxLength', max: max }, function (value) {
    return value.length <= max;
  });
};
var minLengthDigit = function minLengthDigit(min) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'minLengthDigit', min: min }, function (value) {
    return value.length >= min;
  });
};
var maxLengthDigit = function maxLengthDigit(max) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'maxLengthDigit', max: max }, function (value) {
    return value.length <= max;
  });
};
var exactLength = function exactLength(target) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'exactLength', target: target }, function (value) {
    return value.length === target;
  });
};
var notEmptyMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'notEmptyMessage' }, function (value) {
  return (/\S\w*/.test(value)
  );
});
var onlyCharacters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'onlyCharacters' }, function (value) {
  return (/^[A-Za-záéíóú\s'`’.,\-()/]*$/.test(value)
  );
});
var requiredNoMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'requiredNoMessage' }, __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["req"]);
var emailNoMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'emailNoMessage' }, __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"]);
var price = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'price' }, function (value) {
  if (value && value.length > 1 && value.startsWith('0')) return false;
  return (/^\d+\.?\d{0,2}$/.test(value)
  );
});

var priceAllowZero = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'price' }, function (value) {
  if (value && value.length > 1 && value.startsWith('.')) return (/^\d+$/.test(value.slice(1))
  );
  return (/^\d+\.?\d{0,2}$/.test(value)
  );
});

var multipleEmails = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'multipleEmails' }, function (value) {
  var emails = value.split(';').map(function (i) {
    return i.replace(' ', '');
  });
  var isValid = true;
  emails.forEach(function (val) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"])(val)) {
      isValid = false;
    }
  });
  return isValid;
});

var minValue = function minValue(min) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'minValue', min: min }, function (value) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["req"])(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

var greaterThan = function greaterThan(min) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'greaterThan', min: min }, function (value) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["req"])(value) || (!/\s/.test(value) || value instanceof Date) && +value > +min;
  });
};

var minValueDeposit = function minValueDeposit(min) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'minValueDeposit', min: min }, function (value) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["req"])(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

var maxValueDeposit = function maxValueDeposit(max) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'maxValueDeposit', max: max }, function (value) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["req"])(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

// this one should work with "fields.email" built in does not
var sameAs = function sameAs(param) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'sameAs' }, function (value, parentVm) {
    var targetParam = parentVm[param];
    return value.toLowerCase() === targetParam.toLowerCase();
  });
};

var _validateIsAdult = function _validateIsAdult(parMonth, parDay) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'validateIsAdult' }, function (value, parentVm) {
    var yearSelect = value || {};
    var monthSelect = parentVm[parMonth] || {};
    var daySelect = parentVm[parDay] || {};
    if (yearSelect.value && monthSelect.value && daySelect.value) {
      var dateOfBirth = new Date(yearSelect.value, monthSelect.value - 1, daySelect.value);
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(dateOfBirth), 'years') >= 18;
    }
    return true;
  });
};

var _customPattern = function _customPattern(parPattern, parMessage) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: '' }, function (value) {
    return new RegExp(parPattern).test(value);
  });
};

var _validatenNscbStatus = function _validatenNscbStatus(parCountry) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'validatenNscbStatus' }, function (value, parentVm) {
    var countrySelect = parentVm[parCountry];
    if (countrySelect.value !== COUNTRY_CODE_US && !value) {
      return false;
    }
    return true;
  });
};

var _validateUSZipCode = function _validateUSZipCode(parCountry) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'validateUSZipCode' }, function (value, parentVm) {
    var countrySelect = parentVm[parCountry];
    var isFieldRequired = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(countrySelect, 'required', true);

    if (!countrySelect || !countrySelect.value) {
      return true;
    }

    if (isFieldRequired && countrySelect.value === COUNTRY_CODE_US) {
      return (/^[0-9\s]*$/.test(value) && value.length === 5
      );
    }

    if (isFieldRequired && value.length === 0) {
      return false;
    }

    return true;
  });
};

var validateCardNumber = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators_common__["withParams"])({ type: 'validateCardNumber' }, function (value, parentVm) {
  var trimmedValue = (value || '').replace(/ /g, '');
  var cardType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["c" /* getCardTypeForNumber */])(trimmedValue);
  return cardType !== __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].CARDS.BLANK;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  withdrawalAmount: function withdrawalAmount(parFrom, parTo) {
    return {
      price: price,
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      between: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["between"])(parFrom, parTo)
    };
  },
  depositAmount: function depositAmount(parFrom, parTo) {
    return {
      price: price,
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      minValueDeposit: minValueDeposit(parFrom),
      maxValueDeposit: maxValueDeposit(parTo)
    };
  },
  depositAmountCoinbase: function depositAmountCoinbase(parFrom, parTo) {
    return {
      price: priceAllowZero,
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      minValueDeposit: minValueDeposit(parFrom),
      maxValueDeposit: maxValueDeposit(parTo)
    };
  },
  onlyCharacters: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    onlyCharacters: onlyCharacters
  },
  cardNumber: {
    validateCardNumber: validateCardNumber
  },
  taxId: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    exactLength: exactLength(9)
  },
  required: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
  },
  email: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"]
  },
  emailConfirmation: function emailConfirmation(par) {
    return {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      sameAs: sameAs(par)
    };
  },
  validateIsAdult: function validateIsAdult(parMonth, parDay) {
    return {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      validateIsAdult: _validateIsAdult(parMonth, parDay)
    };
  },
  validateUSZipCode: function validateUSZipCode(parCountry) {
    return {
      validateUSZipCode: _validateUSZipCode(parCountry)
    };
  },
  validatenNscbStatus: function validatenNscbStatus(parCountry) {
    return {
      validatenNscbStatus: _validatenNscbStatus(parCountry)
    };
  },
  password: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    minLength: minLength(6),
    hasOneDigit: hasOneDigit,
    hasOneLower: hasOneLower,
    hasOneUpper: hasOneUpper
  },
  passwordConfirmation: function passwordConfirmation(par) {
    return {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      // minLength: minLength(6),
      // hasOneDigit,
      // hasOneLower,
      // hasOneUpper,
      sameAs: sameAs(par)
    };
  },
  username: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    noSpaces: noSpaces,
    usernameIsValid: usernameIsValid,
    minLength: minLength(3),
    maxLength: maxLength(14)
  },
  message: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    notEmptyMessage: notEmptyMessage
  },
  requiredNoMessage: { // not mapped in validatorsMessages so error does not display
    requiredNoMessage: requiredNoMessage
  },
  emailNoMessage: { // not mapped in validatorsMessages so error does not display
    emailNoMessage: emailNoMessage
  },
  cvv: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    numeric: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
    minLengthDigit: minLengthDigit(3),
    maxLengthDigit: maxLengthDigit(4)
  },
  accountNumber: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    numeric: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
    minValue: greaterThan(0)
  },
  routingNumber: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    numeric: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
    exactLength: exactLength(9)
  },
  multipleEmails: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
    multipleEmails: multipleEmails
  },
  customPattern: function customPattern(parPattern, parMessage) {
    return {
      customPattern: _customPattern(parPattern, parMessage)
    };
  },
  captcha: {
    required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
  }
});

/***/ }),

/***/ "SYp6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Scap":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("oiih");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_1__components_generics_alert_box_alert_box_vue__["a" /* default */]
  },
  data: function data() {
    return {
      depositWarning: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  created: function created() {
    var _this = this;

    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* STATIC_PAGES */].DEPOSIT_WARNING).then(function (data) {
      _this.depositWarning = data.renderedHTML;
    }).catch(function () {
      _this.depositWarning = '';
    });
  }
});

/***/ }),

/***/ "SdEv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_payout_js__ = __webpack_require__("2O7o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f593cee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_payout_vue__ = __webpack_require__("U4pD");
function injectStyle (ssrContext) {
  __webpack_require__("f3YR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_payout_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f593cee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_payout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Shp1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_overview_map_js__ = __webpack_require__("dcEQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d3710f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overview_map_vue__ = __webpack_require__("XFSI");
function injectStyle (ssrContext) {
  __webpack_require__("TGUm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_overview_map_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d3710f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overview_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SlPv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"coinbase-process-overview",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"coinbase-process-overview__step"},[_c('div',{staticClass:"coinbase-process-overview__step-title"},[_vm._v("\n      Step 1\n    ")]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step-content"},[_vm._v("\n       We initiate a "+_vm._s(_vm.amountDisplay)+" USDC transaction with Coinbase, a leader in digital payment solutions.\n    ")])]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step"},[_c('div',{staticClass:"coinbase-process-overview__step-title"},[_vm._v("\n      Step 2\n    ")]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step-content"},[_vm._v("\n       You are automatically redirected to the Coinbase payment details website where you can see all of the necessary details about your future "+_vm._s(_vm.amountDisplay)+" USDC transaction. "),_c('strong',[_vm._v("Only send USD Coin (USDC), sending any other digital asset, including Ethereum (ETH) will result in permanent loss.")])])]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step"},[_c('div',{staticClass:"coinbase-process-overview__step-title"},[_vm._v("\n      Step 3\n    ")]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step-content"},[_vm._v("\n       Using Coinbase, or your preferred digital payment wallet, you send us the payment using the unique payment details from Step 2."),_c('strong',[_vm._v(" Please Note: While you are technically able to send more or less than the amount you entered on the previous screen ($"+_vm._s(_vm.amountDisplay)+") using your wallet, doing so will result in significant delays in your payment processing.")])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row-x"},[_c('div',{staticClass:"column small-1"},[_c('form-checkbox',{staticClass:"checkbox--no-margin",attrs:{"name":"Afree","label":""},model:{value:(_vm.fields.agreed),callback:function ($$v) {_vm.$set(_vm.fields, "agreed", $$v)},expression:"fields.agreed"}})],1),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"add-funds-coinbase__submit"},[_c('form-submit',{attrs:{"label":"Continue to Coinbase","disabled":_vm.isConfirmDisabled}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coinbase-process-overview__step"},[_c('div',{staticClass:"coinbase-process-overview__step-title"},[_vm._v("\n      Step 4\n    ")]),_vm._v(" "),_c('div',{staticClass:"coinbase-process-overview__step-content"},[_vm._v("\n      While your deposit is being processed by the crypto processing network it will not appear in your PredictIt account balance. Once the payment has been verified by Coinbase your PredictIt account balance will automatically be updated. Depending on network traffic this can take up to 24hrs.\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-11"},[_c('div',{staticClass:"coinbase-process-overview__note"},[_vm._v("\n          I understand the risks of using crypto currencies and that any over-payments can only be 'refunded' via the standard PredictIt Withdrawal process and are subject to standard processing fees.\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SqSL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onCreateAccount: function onCreateAccount() {
      if (this.isPage) {
        this.$router.push({ name: 'account-page-register' });
      } else {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].REGISTER);
      }
    }
  })
});

/***/ }),

/***/ "Sxoj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_header_title_market_header_title_vue__ = __webpack_require__("JcZ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_purchase_purchase_journey_purchase_journey_vue__ = __webpack_require__("sKk/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */]],
  components: {
    marketHeaderTitle: __WEBPACK_IMPORTED_MODULE_2__components_market_market_header_title_market_header_title_vue__["a" /* default */],
    purchaseJourney: __WEBPACK_IMPORTED_MODULE_3__components_purchase_purchase_journey_purchase_journey_vue__["a" /* default */]
  },
  props: {
    market: {}
  },
  data: function data() {
    return {
      ready: false,
      confirmationShown: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'clearOrderBook']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setTradePopupOptions']), {
    onClose: function onClose() {
      this.setCurrentPopup();
      this.setTradePopupOptions({});
      // this.setTradeOptions(null);
    },
    onConfirmationDataChange: function onConfirmationDataChange(val) {
      this.confirmationShown = !!val;
    },
    afterEnter: function afterEnter() {
      if (__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].POPUP_OVERFLOW_MODE) {
        setTimeout(function () {
          return window.scrollTo(0, 0);
        }, 0);
      }

      if (!this.ready) {
        this.ready = true;
        this.loaderRemove(document.body);
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('trade', ['tradeOptions']), {
    showCloseButton: function showCloseButton() {
      return true; // return !this.confirmationShown;
    }
  }),
  created: function created() {
    this.loaderAdd(document.body);
  },
  beforeDestroy: function beforeDestroy() {
    this.clearOrderBook();
  }
});

/***/ }),

/***/ "SygH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T0tA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"learn-the-basics"},[_c('div',{class:_vm.mainRowModifiers},[_c('div',{staticClass:"column small-12"},[(_vm.isLayoutMobile)?_c('content-header',{attrs:{"title":_vm.title}}):_c('div',{staticClass:"learn-the-basics__desktop-header"},[_c('router-link',{staticClass:"learn-the-basics__back",attrs:{"to":{name: 'HelpAndSupport'},"tag":"span"}},[_vm._v("\r\n          Help and Support\r\n        ")])],1)],1),_vm._v(" "),_c('div',{class:_vm.mainColumnModifiers},[_c('div',{staticClass:"learn-the-basics__header"},[_vm._v("\r\n        How to Trade on PredictIt\r\n      ")]),_vm._v(" "),_c('div',{staticClass:"learn-the-basics__content",domProps:{"innerHTML":_vm._s(_vm.content)}})]),_vm._v(" "),(_vm.showVideos)?_c('div',{staticClass:"column large-4"},[_c('videos',{attrs:{"asWidget":true}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T2le":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_plus_minus_sign_js__ = __webpack_require__("0fyw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2287e224_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_plus_minus_sign_vue__ = __webpack_require__("3TJo");
function injectStyle (ssrContext) {
  __webpack_require__("9aRS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_plus_minus_sign_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2287e224_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_plus_minus_sign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T5jF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_order_book_order_book_offers_order_book_offers_vue__ = __webpack_require__("8jtT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_order_book_order_book_prices_order_book_prices_vue__ = __webpack_require__("5V1p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_order_book_order_book_shares_order_book_shares_vue__ = __webpack_require__("GQPr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_mutex__ = __webpack_require__("EOu+");















var ORDER_BOOK_LS_KEY = 'order-book-contract-id';
var TAB_PRICES = 'prices';
var TAB_MY_SHARES = 'my-shares';
var TAB_BUY_OFFERS = 'buy-offers';
var TAB_SELL_OFFERS = 'sell-offers';

var ORDER_BOOK_DEBOUNCE_INTERVAL = 500;
var debounceRefreshOrderBook = __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(function (instance) {
  __WEBPACK_IMPORTED_MODULE_9__logger__["a" /* default */].info('[ORDER BOOK]: api - load contracts and shares');
  var currentContractId = instance.contract.contractId;
  var localStorageContractId = __WEBPACK_IMPORTED_MODULE_10__helpers_localStorage__["a" /* default */].get(ORDER_BOOK_LS_KEY, null);

  if (!(localStorageContractId && localStorageContractId === currentContractId)) {
    __WEBPACK_IMPORTED_MODULE_9__logger__["a" /* default */].info('[ORDER BOOK]: api - clear contracts and shares before load');
    instance.getContractShares(null);
    instance.getContractOffers(null);
  }

  // TODO: think about refactoring
  var promises = [];

  if (instance.contract.userOpenOrdersBuyQuantity > 0 || instance.contract.userOpenOrdersSellQuantity > 0) {
    promises.push(instance.getContractOffers(instance.contract.contractId));
  }

  if (instance.contract.userQuantity > 0) {
    promises.push(instance.getContractShares(instance.contract.contractId));
  }

  if (promises.length > 0) {
    instance.loaderAdd(null, 'is-loading-notify');
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
      // instance.tabChange(instance.defaultTab);
      __WEBPACK_IMPORTED_MODULE_10__helpers_localStorage__["a" /* default */].set(ORDER_BOOK_LS_KEY, currentContractId);
      instance.initialised = true;
      instance.loaderRemove(null, 'is-loading-notify');
    }).catch(function () {
      __WEBPACK_IMPORTED_MODULE_10__helpers_localStorage__["a" /* default */].set(ORDER_BOOK_LS_KEY, null);
      instance.initialised = true;
      instance.loaderRemove(null, 'is-loading-notify');
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_10__helpers_localStorage__["a" /* default */].set(ORDER_BOOK_LS_KEY, currentContractId);
    instance.initialised = true;
  }
}, ORDER_BOOK_DEBOUNCE_INTERVAL);

var debounceGetOrderBook = __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(function (instance) {
  __WEBPACK_IMPORTED_MODULE_9__logger__["a" /* default */].info('[ORDER BOOK]: api - load order book');
  instance.getOrderBook(instance.contract.contractId);
}, ORDER_BOOK_DEBOUNCE_INTERVAL);

var isPricesDisabled = function isPricesDisabled(market) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["q" /* isMarketExpired */])(market) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_helpers__["r" /* isMarketSuspended */])(market);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_loader__["a" /* default */]],
  components: {
    tabs: __WEBPACK_IMPORTED_MODULE_4__components_generics_tabs_tabs_vue__["a" /* default */],
    orderBookOffers: __WEBPACK_IMPORTED_MODULE_5__components_order_book_order_book_offers_order_book_offers_vue__["a" /* default */],
    orderBookPrices: __WEBPACK_IMPORTED_MODULE_6__components_order_book_order_book_prices_order_book_prices_vue__["a" /* default */],
    orderBookShares: __WEBPACK_IMPORTED_MODULE_7__components_order_book_order_book_shares_order_book_shares_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    contract: {
      type: Object,
      required: true
    },
    operationValue: {
      type: String,
      default: 'yes',
      validator: function validator(value) {
        return ['no', 'yes'].indexOf(value) >= 0;
      }
    },
    operationType: {
      type: String,
      default: 'buy'
    },
    defaultTab: {
      type: String,
      default: TAB_PRICES
    }
  },
  data: function data() {
    var INITIALISED_TABS = [TAB_PRICES, null];
    var isInitialised = INITIALISED_TABS.includes(this.defaultTab) && !isPricesDisabled(this.market);
    return {
      initialised: isInitialised,
      activeTab: this.defaultTab || TAB_PRICES
    };
  },

  watch: {
    initialised: function initialised(value) {
      var _this = this;

      if (!value) return;
      if (this.tabs.find(function (tab) {
        return tab.name === _this.activeTab;
      }) === undefined) {
        if (this.tabs.find(function (tab) {
          return tab.name === TAB_PRICES;
        }) !== undefined) {
          this.tabChange(TAB_PRICES);
        } else if (this.tabs.length > 0) {
          this.tabChange(this.tabs[0].name);
        }
      }
      this.$emit('initialised');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('trade', ['orderBook', 'contractShares', 'contractOffers']), {
    buyOffers: function buyOffers() {
      if (this.contract.userOpenOrdersBuyQuantity === 0) return [];
      return this.contractOffers ? this.contractOffers.filter(function (c) {
        return c.tradeType <= 1;
      }) : [];
    },
    sellOffers: function sellOffers() {
      if (this.contract.userOpenOrdersSellQuantity === 0) return [];
      return this.contractOffers ? this.contractOffers.filter(function (c) {
        return c.tradeType > 1;
      }) : [];
    },
    tabs: function tabs() {
      var tabsAvailable = [];
      if (!isPricesDisabled(this.market)) {
        tabsAvailable.push({ name: TAB_PRICES, title: 'Prices' });
      }
      if (this.contract.userQuantity > 0) {
        tabsAvailable.push({ name: TAB_MY_SHARES, title: 'My Shares' });
      }
      if (this.buyOffers && this.buyOffers.length) {
        tabsAvailable.push({ name: TAB_BUY_OFFERS, title: 'Buy Offers' });
      }
      if (this.sellOffers && this.sellOffers.length) {
        tabsAvailable.push({ name: TAB_SELL_OFFERS, title: 'Sell Offers' });
      }
      return tabsAvailable;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('trade', ['getContractShares', 'getContractOffers', 'updateOrderBookPeriodically', 'clearOrderBookUpdates', 'getOrderBook', 'setTradeDefaultTab']), {
    tabChange: function tabChange(name) {
      this.activeTab = name;
      this.setTradeDefaultTab(name);
      // if (
      //   this.activeTab === TAB_MY_SHARES &&
      //   this.contract.userQuantity > 0 &&
      //   this.contractShares.length === 0
      // ) {
      //   this.loaderAdd(null, 'is-loading-notify');
      //   this.getContractShares(this.contract.contractId)
      //     .then(() => {
      //       this.loaderRemove(null, 'is-loading-notify');
      //     })
      //     .catch(() => this.loaderRemove(null, 'is-loading-notify'));
      // }
    },
    tabVisible: function tabVisible(name) {
      return this.orderBook && this.activeTab === name;
    },
    refreshOrderBook: function refreshOrderBook() {
      debounceRefreshOrderBook(this);
    }
  }),
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_9__logger__["a" /* default */].info('[ORDER BOOK]: reinit');
  },
  mounted: function mounted() {
    var _this2 = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_mutex__["a" /* waitForFirebaseInitialized */])().then(function () {
      if (true) {
        debounceGetOrderBook(_this2);
      }
      if (true) {
        _this2.updateOrderBookPeriodically(_this2.contract.contractId);
      }
      _this2.refreshOrderBook();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (true) {
      this.clearOrderBookUpdates(this.contract.contractId);
    }
  }
});

/***/ }),

/***/ "T7ic":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_maintenance_notification_js__ = __webpack_require__("Ffa9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17682d1b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_maintenance_notification_vue__ = __webpack_require__("9t11");
function injectStyle (ssrContext) {
  __webpack_require__("dg2S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_maintenance_notification_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17682d1b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_maintenance_notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T9qA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_filters_market_filters_mixin_market_filters_mixin__ = __webpack_require__("kGlu");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_market_market_filters_market_filters_mixin_market_filters_mixin__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('dashboard', ['mySharesCount']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('dashboard', ['selectedOrder', 'selectedTimespan', 'shouldShowTimespanFilter']), {
    mainClassName: function mainClassName() {
      return 'market-filters-dashboard';
    },
    menuClassModifier: function menuClassModifier() {
      return {
        'market-filters-dashboard__menu': true,
        'market-filters-dashboard__menu--with-timespan-filter': this.shouldShowTimespanFilter
      };
    },
    orderMenuName: function orderMenuName() {
      return this.isLayoutMobile ? this.selectedOrder.name : this.selectedOrder.fullName;
    }
  }),
  methods: {
    dashOrderSelected: function dashOrderSelected(sort) {
      return this.selectedOrder.sort === sort;
    }
  },
  created: function created() {
    this.isDashboardOpen = true;
  }
});

/***/ }),

/***/ "TAlE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TCG6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TGUm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TJ+c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_modal_js__ = __webpack_require__("pqmg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4b6b632_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_modal_vue__ = __webpack_require__("qD3I");
function injectStyle (ssrContext) {
  __webpack_require__("opyh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_modal_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4b6b632_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TKqG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TLs8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var MODE_POPUP = 'popup';
var MODE_PAGE = 'page';

var popupPageModeMixin = {
  props: {
    mode: {
      type: String,
      default: MODE_POPUP
    }
  },
  computed: {
    isPage: function isPage() {
      return this.mode === MODE_PAGE;
    },
    isPopup: function isPopup() {
      return this.mode === MODE_POPUP;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (popupPageModeMixin);

/***/ }),

/***/ "TMp7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_reset_password_js__ = __webpack_require__("Igwv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f0b6b00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_reset_password_vue__ = __webpack_require__("0iiU");
function injectStyle (ssrContext) {
  __webpack_require__("2l91")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_reset_password_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f0b6b00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_reset_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TNLE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wallet_pending_requests_state_icon_state_icon_vue__ = __webpack_require__("uvwz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_staticConf_utils__ = __webpack_require__("RZM5");







var STATUS_CANCELLABLE = 'Pending Approval';
var BASIC_COLUMN_SET = ['DEPOSITS', 'PROMOTIONS'];

var DIMMED_STATUS_LIST = ['Cancelled', 'Rejected', 'Returned', 'Not Approved'];

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */]],
  components: {
    stateIcon: __WEBPACK_IMPORTED_MODULE_2__components_wallet_pending_requests_state_icon_state_icon_vue__["a" /* default */]
  },
  props: {
    type: {
      type: String
    },
    item: {
      type: Object,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    itemDate: function itemDate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["t" /* dateToString */])(this.item.date);
    },
    classModifier: function classModifier() {
      return {
        'balance-history-item--dimmed': DIMMED_STATUS_LIST.includes(this.item.status)
      };
    },
    showAdditionalColumns: function showAdditionalColumns() {
      return !BASIC_COLUMN_SET.includes(this.type) && this.isLayoutDesktop;
    },
    amountColumnModifiers: function amountColumnModifiers() {
      return {
        column: true,
        'small-4': !this.showAdditionalColumns,
        'small-2': this.showAdditionalColumns
      };
    },
    typeColumnModifiers: function typeColumnModifiers() {
      return {
        column: true,
        'small-4': !this.showAdditionalColumns,
        'small-3': this.showAdditionalColumns
      };
    },
    statusColumnModifiers: function statusColumnModifiers() {
      return {
        column: true,
        'small-4': !this.showAdditionalColumns,
        'small-3': this.showAdditionalColumns
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['cancelWithdrawal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']), {
    showCancelRequestButton: function showCancelRequestButton(item) {
      return item.status === STATUS_CANCELLABLE && item.withdrawalId;
    },
    onCancelRequest: function onCancelRequest(item) {
      var _this = this;

      var payload = {
        withdrawalId: item.withdrawalId
      };
      this.loaderAdd();
      this.cancelWithdrawal(payload).then(function () {
        return _this.loaderRemove();
      }).then(function () {
        return _this.setSuccessSideNotification(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__mixins_staticConf_utils__["a" /* $txt */])('balance-history-item.canceled'));
      }).then(function () {
        return _this.$emit('itemCancelled', item);
      }).catch(function () {
        _this.loaderRemove();
        _this.setErrorSideNotification(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__mixins_staticConf_utils__["a" /* $txt */])('balance-history-item.failed'));
      });
    }
  })
});

/***/ }),

/***/ "TONy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('leaderboards', ['playerLeaderboards']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['settings']), {
    items: function items() {
      if (this.playerLeaderboards.length === 0 && this.isSocialReady) {
        var items = [{
          leaderBoardId: 0,
          leaderBoardName: 'All Predictors',
          leaderBoardPosition: 100,
          predefined: true
        }];
        if (this.level.num > 1) {
          items.push({
            leaderBoardId: this.level.num,
            leaderBoardName: this.level.text,
            leaderBoardPosition: 100,
            predefined: true
          });
        }
        return items;
      }
      return this.playerLeaderboards;
    },
    showLeaderboards: function showLeaderboards() {
      return this.settings.privacy ? this.settings.privacy.AllowLeaderboard : true;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('leaderboards', ['getPlayerLeaderboards']), {
    getOrdinalSuffix: __WEBPACK_IMPORTED_MODULE_4__utils_helpers__["B" /* getOrdinalSuffix */],
    sectionClassModifiers: function sectionClassModifiers() {
      return {
        'leaderboards-info-section': true,
        'leaderboards-info-section--clickable': true
      };
    },
    onSectionClick: function onSectionClick(item) {
      // if (item.predefined) return;
      this.$router.push({
        name: 'leaderboards',
        query: {
          leaderboardId: item.leaderBoardId
        }
      });
    }
  }),
  created: function created() {
    var _this = this;

    this.getPlayerLeaderboards().then(function () {
      _this.isComponentReady = true;
    });
  }
});

/***/ }),

/***/ "TQfW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check"},[(!_vm.isComponentReady)?_c('account-form-loader',{attrs:{"theme":"withdraw"}}):[(!_vm.showConfirmation)?_c('div',[(_vm.documentUploadInfoVisible)?_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending}}):[(!_vm.hasErrorMessage)?[_c('alert-box',{attrs:{"level":"warning"}},[_vm._v("\n          Withdrawing funds may cause some or all of your open offers to be cancelled.\n        ")]),_vm._v(" "),_c('form',{staticClass:"form ach__form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('available-balance',{attrs:{"restricted":_vm.restrictedFunds,"balance":_vm.availableBalance}}),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.amount,"theme":"amount","name":"amount","disabled":_vm.isAmountFieldDisabled,"autocomplete":"","placeholder":"Withdrawal Amount (Minimum $1 USD)"},on:{"input":_vm.$v.fields.amount.$touch},model:{value:(_vm.fields.amount),callback:function ($$v) {_vm.$set(_vm.fields, "amount", $$v)},expression:"fields.amount"}})],1)]),_vm._v(" "),_c('h4',{staticClass:"check__section-title"},[_vm._v("\n            Recipient\n          ")]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"check__address"},[_vm._v("\n                "+_vm._s(_vm.check.payeeName)+"\n                "),_c('br'),_vm._v("\n                "+_vm._s(_vm.fields.street)+"\n                "),_c('br'),_vm._v("\n                "+_vm._s(_vm.fields.city)+", "+_vm._s(_vm.fields.zipCode)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-submit',{attrs:{"disabled":_vm.invalidOrDisabled,"label":"Review Request"}})],1)])],1)]:_vm._e(),_vm._v(" "),(_vm.hasErrorMessage)?_c('alert-box',{attrs:{"level":"warning"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]):_vm._e(),_vm._v(" "),(!_vm.hasErrorMessage)?[_c('p',{staticClass:"check__disclaimer"},[_vm._v("\n          "+_vm._s(_vm.check.disclaimer)+"\n        ")])]:_vm._e()]],2):_vm._e(),_vm._v(" "),(_vm.showConfirmation)?_c('withdraw-confirm',{staticClass:"withdraw-confirm--with-margin",attrs:{"kind":"check","amendAvailable":true,"amount":Number(_vm.fields.amount),"fee":Number(_vm.fields.amount) * Number(_vm.check.feePercent),"recipient":_vm.check.payeeName,"addressLine1":_vm.fields.street,"addressLine2":_vm.fields.city,"addressLine3":_vm.fields.zipCode,"country":_vm.fields.country},on:{"edit":_vm.onEdit,"success":_vm.onSuccess}}):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TQoy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_quantity_value_js__ = __webpack_require__("cVLa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c71ddbf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_quantity_value_vue__ = __webpack_require__("4/yT");
function injectStyle (ssrContext) {
  __webpack_require__("q63C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_quantity_value_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c71ddbf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_quantity_value_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TWnl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TZdm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__ = __webpack_require__("vJzj");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["b" /* formMixin */]],
  validations: {
    fields: {
      currentPassword: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].required,
      newPassword: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].password,
      newPasswordConfirmation: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].passwordConfirmation('newPassword')
    }
  },
  data: function data() {
    return {
      fields: {
        currentPassword: '',
        newPassword: '',
        newPasswordConfirmation: ''
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotificationWithTimeoutCallback']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['changePassword']), {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formIsValid() && this.formDisable()) {
        var payload = {
          oldPassword: this.fields.currentPassword,
          newPassword: this.fields.newPassword,
          confirmPassword: this.fields.newPasswordConfirmation
        };
        this.changePassword(payload).then(this.formEnable).then(function () {
          _this.setSuccessSideNotificationWithTimeoutCallback({
            text: 'Password Updated.',
            callback: function callback() {
              return _this.$router.go(-1);
            }
          });
        }).catch(this.formHandleErrors);
      }
    }
  })
});

/***/ }),

/***/ "TZt3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wallet_amount_info_amount_info_vue__ = __webpack_require__("Jm7U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wallet_pending_requests_state_icon_state_icon_vue__ = __webpack_require__("uvwz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");







var TYPE_CHECK = 1;
var TYPE_ACH = 2;
var TYPE_COINBASE = 4;
var TYPE_BANK_TRANSFER = 5;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */]],
  props: {
    request: {
      type: Object,
      required: true
    },
    isDeposit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isAch: function isAch() {
      return this.request.type === TYPE_ACH;
    },
    isCheck: function isCheck() {
      return this.request.type === TYPE_CHECK;
    },
    isCoinbase: function isCoinbase() {
      return this.request.type === TYPE_COINBASE;
    },
    isBankTransfer: function isBankTransfer() {
      return this.request.type === TYPE_BANK_TRANSFER;
    },
    requestDate: function requestDate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["t" /* dateToString */])(this.request.date || this.request.dateCreated);
    },
    paymentMethod: function paymentMethod() {
      if (!this.request) return '';

      switch (this.request.type) {
        case TYPE_ACH:
          return 'ACH';
        case TYPE_CHECK:
          return 'Check';
        case TYPE_COINBASE:
          return 'USD Coin';
        case TYPE_BANK_TRANSFER:
          return 'Bank Transfer';
        default:
          return '';
      }
    }
  },
  components: {
    amountInfo: __WEBPACK_IMPORTED_MODULE_2__components_wallet_amount_info_amount_info_vue__["a" /* default */],
    stateIcon: __WEBPACK_IMPORTED_MODULE_3__components_wallet_pending_requests_state_icon_state_icon_vue__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['cancelWithdrawal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']), {
    onCancel: function onCancel() {
      var _this = this;

      var payload = {
        withdrawalId: this.request.withdrawalId
      };
      this.loaderAdd();
      this.cancelWithdrawal(payload).then(function () {
        return _this.loaderRemove();
      }).then(function () {
        return _this.setSuccessSideNotification('Your withdrawal has been cancelled.');
      }).then(function () {
        return _this.$emit('success');
      }).catch(function () {
        _this.loaderRemove();
        _this.setErrorSideNotification('Operation failed.');
      });
    }
  })
});

/***/ }),

/***/ "TdoF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_yes_no_switcher_js__ = __webpack_require__("vdcn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e2d960_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_yes_no_switcher_vue__ = __webpack_require__("n32v");
function injectStyle (ssrContext) {
  __webpack_require__("OnEi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_yes_no_switcher_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e2d960_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_yes_no_switcher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tl04":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers,on:{"click":_vm.onOutsideClick}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12 large-6"},[_c('div',{staticClass:"purchase-offer-desktop__order-book"},[_c('order-book',{key:_vm.orderBookKey,attrs:{"contract":_vm.contract,"market":_vm.market,"operationType":_vm.tradeOptions.operationType,"operationValue":_vm.tradeOptions.operationValue,"defaultTab":_vm.tradeOptions.defaultTab},on:{"updatePriceAndQuantity":_vm.onUpdatePriceAndQuantity}})],1)]),_vm._v(" "),(_vm.isContractOpen)?_c('div',{staticClass:"column small-12 large-6"},[_c('div',{staticClass:"row row-x purchase-offer-desktop__forms-shares-value"},[_c('div',{staticClass:"column small-6 purchase-offer-desktop__minimum-sell-offer"},[_c('purchase-offer-value',{key:_vm.purchaseOfferKey,attrs:{"tabindex":1,"title":_vm.purchaseOfferTitle,"value":_vm.pricePerShare,"kind":"desktop"},on:{"blur":_vm.onPriceBlur,"focus":_vm.onPriceFocus},model:{value:(_vm.pricePerShare),callback:function ($$v) {_vm.pricePerShare=$$v},expression:"pricePerShare"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6 purchase-offer-desktop__make-an-offer"},[_c('purchase-quantity-value',{attrs:{"tabindex":2,"title":"Number Of Shares","value":_vm.quantity,"kind":"desktop","userQuantity":_vm.contractModel.userQuantity,"operationType":_vm.tradeOptions.operationType,"minValue":_vm.minQuantityValue,"maxValue":_vm.maxQuantityValue,"minimumOwnership":_vm.minimumOwnership},on:{"blur":_vm.onQuantityInputBlur,"focus":_vm.onQuantityInputFocus},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}})],1),_vm._v(" "),(_vm.quantityErrorText)?_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"purchase-offer-desktop__offer-quantity-error"},[_vm._v("\n            "+_vm._s(_vm.quantityErrorText)+"\n          ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"purchase-offer-desktop__footer"},[(_vm.showThresholdInfo)?_c('div',{staticClass:"purchase-offer-desktop__footer-ownership-link",on:{"click":_vm.openThresholdInfoPopup}},[_vm._v("\n          Minimum Ownership Requirement: "+_vm._s(_vm.minimumOwnership)+" Shares\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12"},[_c('button',{staticClass:"button button--primary button--full-width purchase-offer-desktop__footer-next-button",attrs:{"disabled":_vm.nextButtonDisabled},on:{"click":_vm.onClickNext}},[_vm._v("\n              "+_vm._s(_vm.nextButtonTitle)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"column small-7"},[_c('div',{staticClass:"purchase-offer-desktop__footer-review-and-confirm"},[_c('form-checkbox',{staticClass:"checkbox--purchase-offer checkbox--no-margin",attrs:{"name":"checkbox--purchase-offer","small":true,"label":"Skip Offer Confirmation"},model:{value:(_vm.skipConfirmation),callback:function ($$v) {_vm.skipConfirmation=$$v},expression:"skipConfirmation"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column small-5 text-right"},[_c('a',{staticClass:"purchase-offer-desktop__footer-rules-link",on:{"click":function($event){$event.preventDefault();return _vm.onReadRules($event)}}},[_vm._v("\n              Read The Rules\n            ")])])])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Tp6y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_desktop_header_js__ = __webpack_require__("lZ3N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e42c55be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_desktop_header_vue__ = __webpack_require__("xrwi");
function injectStyle (ssrContext) {
  __webpack_require__("Gh0K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_desktop_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e42c55be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_desktop_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TtXC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TzxP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-funds-combined-footer"},[_c('h4',{staticClass:"add-funds-combined-footer__title"},[_vm._v("\n    Looking for Additional Deposit Methods?\n  ")]),_vm._v(" "),_c('a',{staticClass:"add-funds-combined-footer__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onGoToWallet($event)}}},[_vm._v("\n    Open Your Wallet\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U+El":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "U048":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U1mx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentStoryDetail !== null)?_c('div',{staticClass:"page-story-detail"},[_c('div',{staticClass:"page-story-detail__story"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.currentStoryDetail.bodyHTML)}}),_vm._v(" "),(_vm.currentStoryDetail.ctaText)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.currentStoryDetail.ctaText)}}):_vm._e()]),_vm._v(" "),_c('disqus',{attrs:{"disqusId":_vm.currentStoryDetail.disqus_Identifier,"title":_vm.currentStoryDetail.disqus_Title,"auth":_vm.currentStoryDetail.disqus_UserAuth,"url":_vm.currentStoryDetail.disqus_Url,"previous":_vm.currentStoryDetail.disqus_PrevThreadID,"next":_vm.currentStoryDetail.disqus_NextThreadID,"total":_vm.currentStoryDetail.disqus_ArchivedCommentsTotal}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U4pD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"market-payout__col-1"},[_c('div',{directives:[{name:"price-display",rawName:"v-price-display.round2.fixed",value:(_vm.market.userInvestment),expression:"market.userInvestment",modifiers:{"round2":true,"fixed":true}}],staticClass:"market-payout__price"}),_vm._v(" "),(_vm.showLabels)?_c('div',[(_vm.isLayoutDesktop)?[_vm._v("Market ")]:_vm._e(),_vm._v("Investment\n    ")],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"market-payout__col-2"},[_c('div',{staticClass:"market-payout__price"},[_c('market-change-price',{attrs:{"plainStyle":true,"price":_vm.userGainLoss,"fixed":true}})],1),_vm._v(" "),(_vm.showLabels)?_c('div',[_vm._v("\n      "+_vm._s(_vm.gainLossLabel)+"\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"market-payout__col-3"},[_c('div',{staticClass:"market-payout__price"},[(!_vm.showLabels && _vm.isAllPayoutsAvailable)?_c('span',{directives:[{name:"price-display",rawName:"v-price-display.round2.fixed",value:(_vm.market.userMaxPayout),expression:"market.userMaxPayout",modifiers:{"round2":true,"fixed":true}}],staticClass:"market-payout__payout-link-raw",on:{"click":function($event){$event.stopPropagation();return _vm.allPayouts($event)}}}):_c('span',{directives:[{name:"price-display",rawName:"v-price-display.round2.fixed",value:(_vm.market.userMaxPayout),expression:"market.userMaxPayout",modifiers:{"round2":true,"fixed":true}}]})]),_vm._v(" "),(_vm.showLabels)?[(_vm.isAllPayoutsAvailable)?[_c('a',{staticClass:"market-payout__payout-link",on:{"click":function($event){$event.stopPropagation();return _vm.allPayouts($event)}}},[_vm._v("Max. Payout »")])]:[_vm._v("\n        Max. Payout\n      ")]]:_vm._e()],2),_vm._v(" "),(_vm.showMarketLink)?_c('div',{staticClass:"market-payout__col-4"},[_c('router-link',{staticClass:"market-payout__payout-link-market",attrs:{"to":{ name: 'market-details', params: { marketId: _vm.market.marketId, marketUrl: _vm.market.marketUrl } }},nativeOn:{"click":function($event){return $event.stopPropagation()}}},[_vm._v("\n      View "),_c('br'),_vm._v("\n      Market\n    ")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U7Hf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getValidationMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validatorsMessages__ = __webpack_require__("FGdP");



function errorMessage(data) {
  var msg = __WEBPACK_IMPORTED_MODULE_1__validatorsMessages__["a" /* default */][data.type];
  if (typeof msg === 'undefined') return '';
  if (data.type === 'minValue' || data.type === 'minValueDeposit' || data.type === 'greaterThan') {
    var value = data.min < 1 ? data.min.toFixed(2) : data.min;
    return msg.replace(/%v/g, value);
  }
  if (data.type === 'maxValueDeposit') return msg.replace(/%v/g, data.max);
  if (data.type === 'minLength' || data.type === 'minLengthDigit') return msg.replace(/%v/g, data.min);
  if (data.type === 'maxLength' || data.type === 'maxLengthDigit') return msg.replace(/%v/g, data.max);
  if (data.type === 'between') return msg.replace(/%v1/g, data.min.toFixed(2)).replace(/%v2/g, data.max.toFixed(2));
  if (data.type === 'exactLength') return msg.replace(/%v/g, data.target);
  return msg;
}

function getValidationMessage(field) {
  if (field.$invalid) {
    if (field.required === false) {
      return __WEBPACK_IMPORTED_MODULE_1__validatorsMessages__["a" /* default */].required;
    }
    if (field.errorMessage) {
      return field.errorMessage;
    }
    var erMsg = '';
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(field.$params).some(function (obj) {
      if (!field[obj.type]) {
        erMsg = errorMessage(obj);
        return true;
      }
      return false;
    });
    return erMsg;
  }
  return '';
}

/***/ }),

/***/ "U7LV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "U91k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_market_filters_market_filters_desktop_grid_market_filters_desktop_grid_vue__ = __webpack_require__("vxYz");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketFiltersDesktopGrid: __WEBPACK_IMPORTED_MODULE_1__components_market_market_filters_market_filters_desktop_grid_market_filters_desktop_grid_vue__["a" /* default */]
  },
  props: {
    title: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true,
      default: 0
    },
    layout: {
      type: String,
      default: 'grid'
    }
  },
  data: function data() {
    return {
      currentLayout: this.layout
    };
  },

  methods: {
    switchLayoutClicked: function switchLayoutClicked(layout) {
      this.currentLayout = layout;
      this.$emit('toggle', layout);
    },
    classModifier: function classModifier(layout) {
      var _ref;

      return _ref = {
        'market-list-desktop-header__switch-button': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-list-desktop-header__switch-button--' + layout, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-list-desktop-header__switch-button--active', this.currentLayout === layout), _ref;
    }
  }
});

/***/ }),

/***/ "U9bD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-funds-cash"},[(_vm.showPromoNotification)?_c('alert-box',{attrs:{"level":"success"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.promoCodeDetail.friendlyDescription)}})]):_vm._e(),_vm._v(" "),(_vm.depositWarning)?_c('div',{staticClass:"predictit-embedded-alert",domProps:{"innerHTML":_vm._s(_vm.depositWarning)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"add-funds-cash__logo"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/static/img/paynearme.18d924a.jpg"),expression:"`/static/img/paynearme.18d924a.jpg`"}]})]),_vm._v(" "),(_vm.url)?_c('div',{staticClass:"add-funds-cash__button"},[_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"disabled":_vm.buttonDisabled},on:{"click":_vm.onDeposit}},[_vm._v("\n      Deposit\n    ")])]):_vm._e(),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"add-funds-cash__error"},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.url)?[_c('p',{staticClass:"add-funds-cash__note"},[_vm._v("\n      After clicking on the Deposit button above, you will be taken to a third-party site to complete your transaction.\n    ")]),_vm._v(" "),_c('p',{staticClass:"add-funds-cash__note"},[_c('strong',[_vm._v("Note")]),_vm._v(": "+_vm._s(_vm.disclaimer)+"\n    ")])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UFoq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UIPs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_portfolio_my_markets_js__ = __webpack_require__("vV6Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e2ef35f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_portfolio_my_markets_vue__ = __webpack_require__("IBR7");
function injectStyle (ssrContext) {
  __webpack_require__("+a0v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_portfolio_my_markets_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e2ef35f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_portfolio_my_markets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UKGl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showPassword: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: true,
      isOn: this.showPassword
    };
  },

  computed: {
    classModifiers: function classModifiers() {
      return {
        'show-password--on': this.isOn,
        'show-password--off': !this.isOn
      };
    },
    title: function title() {
      return this.isOn ? 'Hide password' : 'Show password';
    }
  },
  methods: {
    onPasswordToggle: function onPasswordToggle() {
      var _this = this;

      this.$emit('showPassword');
      this.show = false;
      this.isOn = !this.isOn;
      setTimeout(function () {
        _this.show = true;
      }, 0);
    }
  }
});

/***/ }),

/***/ "UKic":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    onGoToWallet: function onGoToWallet() {
      this.$router.push({ name: 'wallet' });
    }
  }
});

/***/ }),

/***/ "ULMz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__ = __webpack_require__("sPnT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84f92104_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("/BdM");
function injectStyle (ssrContext) {
  __webpack_require__("JnuS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84f92104_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UMUI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "URmk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      require: false,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 0
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('trade', ['keyboardDoubleSelected']), {
    text: function text() {
      return String(isNaN(this.value) || this.value === null ? '' : this.value);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('trade', ['updateKeyboardDoubleSelected']), {
    buttonClick: function buttonClick(numberChar) {
      if (this.keyboardDoubleSelected) {
        this.updateKeyboardDoubleSelected(false);
        this.$emit('input', Number(numberChar));
        return;
      }
      if (numberChar === '0' && this.text === '') {
        return;
      }
      if (this.maxLength && this.maxLength <= this.text.length) {
        return;
      }
      var text = this.text + numberChar;
      this.$emit('input', Number(text));
    },
    backspaceClick: function backspaceClick() {
      if (this.keyboardDoubleSelected) {
        this.updateKeyboardDoubleSelected(false);
        this.$emit('input', null);
        return;
      }
      if (this.text.length > 0) {
        var text = this.text.substring(0, this.text.length - 1);
        if (text.length > 0) {
          this.$emit('input', Number(text));
        } else {
          this.$emit('input', null);
        }
      }
    },
    outsideClick: function outsideClick() {
      this.$emit('outsideClick');
    }
  })
});

/***/ }),

/***/ "UWgA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_input_js__ = __webpack_require__("V00F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8d8ed62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_vue__ = __webpack_require__("DCmb");
function injectStyle (ssrContext) {
  __webpack_require__("DRzK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_input_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8d8ed62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ucvo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ach_js__ = __webpack_require__("5g2X");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3f1fcae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ach_vue__ = __webpack_require__("XiHx");
function injectStyle (ssrContext) {
  __webpack_require__("32OH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ach_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3f1fcae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ach_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ufge":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    chartOptions: {
      type: Object,
      default: null
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('market', ['chartTimeline', 'chartType', 'market']), {
    showDownload: function showDownload() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'includeDownload', true);
    }
  }),
  methods: {
    onDownload: function onDownload() {
      var url = "/Resource/DownloadMarketChartData" + '?marketid=' + this.market.marketId + '&timespan=' + this.chartTimeline;
      window.open(url, '_blank');
    }
  }
});

/***/ }),

/***/ "Ug2n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");







var DEFAULT_AVATAR = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["s" /* getAssetPath */])('/images/Avatars/default.png');

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['userData']), {
    avatar: function avatar() {
      if (this.userData && this.userData.avatarImage) {
        return this.userData.avatarImage;
      }
      return '';
    },
    showRemoveOption: function showRemoveOption() {
      return this.avatar && this.avatar !== DEFAULT_AVATAR;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['uploadUserImage', 'resetUserImage', 'getAccountDetail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']), {
    fileToBase64: function fileToBase64(file) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          resolve(reader.result.replace(/^data:image\/(png|jpg|jpeg);base64,/, ''));
        };
        reader.onerror = function (error) {
          reject(error);
        };
      });
    },
    onUpload: function onUpload() {
      this.$refs.fileinput.click();
    },
    onRemove: function onRemove() {
      var _this = this;

      this.resetUserImage().then(function () {
        setTimeout(function () {
          _this.setCurrentSmallPopup();
        }, __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT);
        _this.setSuccessSideNotification('Your profile photo has been removed');
      }).then(this.getAccountDetail).catch(function () {});
    },
    onChange: function onChange() {
      var _this2 = this;

      this.loaderAdd();
      var formData = new FormData();
      formData.append('files', this.$refs.fileinput.files[0]);

      this.uploadUserImage(formData).then(function () {
        _this2.loaderRemove();
        setTimeout(function () {
          _this2.setCurrentSmallPopup();
        }, __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT);
        _this2.setSuccessSideNotification('Your profile image has been submitted for review');
      }).then(this.getAccountDetail).catch(function (e) {
        var message = e.response.data && e.response.data.message ? e.response.data.message : 'An error has occurred.';
        _this2.setErrorSideNotification(message);
        _this2.loaderRemove();
      });
    }
  })
});

/***/ }),

/***/ "Ui3/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_item_expandable_js__ = __webpack_require__("K/Lh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51bad625_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_item_expandable_vue__ = __webpack_require__("NGPj");
function injectStyle (ssrContext) {
  __webpack_require__("SSqF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_item_expandable_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51bad625_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_item_expandable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UjwH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"available-balance"},[_c('div',{staticClass:"available-balance__amount",domProps:{"innerHTML":_vm._s(_vm.balance)}}),_vm._v(" "),_c('div',{staticClass:"available-balance__title"},[_vm._v("Available balance")]),_vm._v(" "),(_vm.restricted)?_c('div',{staticClass:"available-balance__restricted"},[_c('div',[_vm._v("\n      Restricted Balance "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.restricted)}})]),_vm._v(" "),_c('div',{staticClass:"available-balance__restricted-icon",on:{"click":function($event){$event.stopPropagation();return _vm.onInfoClick($event)}}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UkAU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uolw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UqqE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_most_predicted_js__ = __webpack_require__("eb91");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a46a52a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_most_predicted_vue__ = __webpack_require__("6Elq");
function injectStyle (ssrContext) {
  __webpack_require__("KKwX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_most_predicted_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a46a52a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_most_predicted_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UtW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_notifications__ = __webpack_require__("tjp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters_consts__ = __webpack_require__("OJH0");




 /* eslint-disable arrow-body-style, max-len */







var KEY_SHOULD_SHOW_TIMESPAN = 'watchlist-should-show-timespan';
var KEY_SELECTED_ORDER = 'watchlist-selected-order';
var KEY_SELECTED_TIMESPAN = 'watchlist-selected-timespan';

var DEFAULT_WATCHLIST = {
  data: [],
  page: 0,
  totalCount: 0,
  canLoadMore: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    orders: __WEBPACK_IMPORTED_MODULE_8__filters_consts__["a" /* ORDERS */],
    timespans: __WEBPACK_IMPORTED_MODULE_8__filters_consts__["b" /* TIMESPANS */],
    watchlist: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(DEFAULT_WATCHLIST),
    selectedOrder: __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].get(KEY_SELECTED_ORDER, __WEBPACK_IMPORTED_MODULE_8__filters_consts__["a" /* ORDERS */][0]),
    selectedTimespan: __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].get(KEY_SELECTED_TIMESPAN, __WEBPACK_IMPORTED_MODULE_8__filters_consts__["c" /* AVAILABLE_TIMESPANS */].ALL),
    shouldShowTimespanFilter: __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].get(KEY_SHOULD_SHOW_TIMESPAN, true)
  },
  mutations: {
    updateWatchlistFromNotification: function updateWatchlistFromNotification(state, data) {
      if (state.watchlist.data) {
        state.watchlist = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.watchlist, {
          data: state.watchlist.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_notifications__["a" /* updateMarket */])(market, data);
          })
        });
      }
    },
    updateWatchlistContractFromNotification: function updateWatchlistContractFromNotification(state, data) {
      if (state.watchlist.data) {
        state.watchlist = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.watchlist, {
          data: state.watchlist.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_notifications__["b" /* updateMarketContracts */])(market, data);
          })
        });
      }
    },
    selectOrder: function selectOrder(state, sort) {
      var selectedOrder = __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(state.orders, { sort: sort });
      var selectedTimespan = __WEBPACK_IMPORTED_MODULE_8__filters_consts__["d" /* DEFAULT_TIMESPANS */][sort] || __WEBPACK_IMPORTED_MODULE_8__filters_consts__["c" /* AVAILABLE_TIMESPANS */].EMPTY;
      var shouldShowTimespan = __WEBPACK_IMPORTED_MODULE_8__filters_consts__["e" /* ORDERS_WITH_TIMESPAN_FILTER */].indexOf(selectedOrder.sort) !== -1;
      state.selectedOrder = selectedOrder;
      state.selectedTimespan = selectedTimespan;
      state.shouldShowTimespanFilter = shouldShowTimespan;
      __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_TIMESPAN, selectedTimespan);
      __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].set(KEY_SHOULD_SHOW_TIMESPAN, shouldShowTimespan);
      __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_ORDER, selectedOrder);
    },
    selectTimespan: function selectTimespan(state, parameter) {
      var selectedTimespan = __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(state.timespans, { parameter: parameter });
      state.selectedTimespan = selectedTimespan;
      __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].set(KEY_SELECTED_TIMESPAN, selectedTimespan);
    },
    updateWatchList: function updateWatchList(state, payload) {
      var sourceData = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.watchlist.data));
      var data = __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default()(sourceData.concat(payload.data.markets || []), 'marketId');
      var page = payload.data.page;
      var totalCount = payload.data.totalMarkets;
      var canLoadMore = totalCount > data.length;

      state.watchlist = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.watchlist, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    resetWatchlist: function resetWatchlist(state) {
      state.watchlist = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(DEFAULT_WATCHLIST);
    }
  },
  actions: {
    resetWatchlist: function resetWatchlist(_ref) {
      var commit = _ref.commit;

      commit('resetWatchlist');
    },
    getWatchList: function getWatchList(_ref2) {
      var state = _ref2.state,
          commit = _ref2.commit;

      if (state.watchlist.canLoadMore) {
        var page = state.watchlist.page + 1;
        return __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].profile.getMarketWatch(state.selectedOrder.sort, state.selectedTimespan.parameter, page).then(function (response) {
          commit('updateWatchList', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return null;
    },
    selectOrder: function selectOrder(_ref3, sort) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      commit('selectOrder', sort);
    },
    selectTimespan: function selectTimespan(_ref4, timespan) {
      var state = _ref4.state,
          dispatch = _ref4.dispatch,
          commit = _ref4.commit;

      commit('selectTimespan', timespan);
    },
    updateWatchlistFromNotification: function updateWatchlistFromNotification(_ref5, payload) {
      var commit = _ref5.commit;

      commit('updateWatchlistFromNotification', payload);
    },
    updateWatchlistContractFromNotification: function updateWatchlistContractFromNotification(_ref6, payload) {
      var commit = _ref6.commit;

      commit('updateWatchlistContractFromNotification', payload);
    }
  }
});

/***/ }),

/***/ "UwQr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_watchlist_js__ = __webpack_require__("exX2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da730890_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_watchlist_vue__ = __webpack_require__("BXSV");
function injectStyle (ssrContext) {
  __webpack_require__("qzEJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_watchlist_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da730890_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_watchlist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UxJK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-option"},[_c('div',{staticClass:"settings-option__left"},[_c('div',{staticClass:"settings-option__wrap"},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"settings-option__right"},[_c('switch-button',{on:{"toggle":_vm.toggle},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V/Y1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_debug_js__ = __webpack_require__("sA4S");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00b28bc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_debug_vue__ = __webpack_require__("MUii");
function injectStyle (ssrContext) {
  __webpack_require__("PMqM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_debug_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00b28bc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_debug_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "V00F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_getValidationMessage__ = __webpack_require__("U7Hf");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      default: 'text'
    },
    autocomplete: {
      type: String,
      required: false
    },
    disabled: Boolean,
    name: {
      type: String,
      required: true
    },
    required: Boolean,
    placeholder: String,
    maxLength: Number,
    max: Number,
    min: Number,
    value: [String, Number],
    // new stuff
    validation: Object,
    theme: {
      type: String,
      default: ''
    },
    tabindex: Number,
    gtm: {
      type: String,
      default: ''
    },
    hideIconOnValue: {
      type: Boolean,
      default: true
    },
    showValidationWithin: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      focus: false
    };
  },

  computed: {
    inputModifiers: function inputModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'input--no-placeholder': !this.placeholder,
        'input--has-value': this.value,
        'input--is-focused': this.focus,
        'input--is-disabled': this.disabled,
        'input--hide-icon': this.hideIconOnValue
      }, 'input--' + this.theme, this.theme);
    },
    errorMessage: function errorMessage() {
      return this.validation ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_getValidationMessage__["a" /* default */])(this.validation) : '';
    },
    error: function error() {
      return this.validation ? this.validation.$error : false;
    },
    successTick: function successTick() {
      if (this.validation) {
        if (this.validation.required === undefined && this.value === '') {
          return false;
        }
        return this.validation.$dirty && !this.validation.$invalid;
      }
      return false;
    },
    hasIcon: function hasIcon() {
      return !!this.$slots.icon;
    },
    gtmObject: function gtmObject() {
      var _gtm$split = this.gtm.split(','),
          _gtm$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_gtm$split, 2),
          category = _gtm$split2[0],
          label = _gtm$split2[1];

      return {
        event: 'eventTrackerTrigger',
        category: category,
        action: 'fill',
        label: label
      };
    }
  },
  methods: {
    handleBlur: function handleBlur(e) {
      this.focus = false;
      this.$emit('blur', e.target.name);
      if (this.gtm && this.value) {
        this.$gtm.trackEvent(this.gtmObject);
      }
    },
    handleFocus: function handleFocus(e) {
      this.focus = true;
      this.$emit('focus', e.target.name);
    },
    updateValue: function updateValue(e) {
      this.$emit('input', e.target.value);
    }
  }
});

/***/ }),

/***/ "V3zd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_login_js__ = __webpack_require__("+poj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fe6199c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_login_vue__ = __webpack_require__("B7kp");
function injectStyle (ssrContext) {
  __webpack_require__("y852")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_login_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fe6199c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V4/F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6qK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"support"},[_c('div',{class:_vm.gridRowModifier},[(_vm.isLoggedIn)?[(!_vm.isLayoutMobile)?_c('div',{staticClass:"column large-4 support__sticky"},[_c('profile')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column large-8 small-12"},[_c('router-view')],1)]:[_c('div',{staticClass:"column small-12"},[_c('router-view')],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V8GJ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSIzOSIgdmlld0JveD0iMCAwIDQwIDM5Ij4NCiAgICA8cGF0aCBmaWxsPSJub25lIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iIzA4NDE0QiIgZD0iTTE5Ljk0OSAxLjIyNmMxMC43NDcgMCAxOS40NDkgOC4yOTIgMTkuNDQ5IDE4LjUwOCAwIDEwLjIxNy04LjcwMiAxOC41MDgtMTkuNDQ5IDE4LjUwOEM5LjIwMiAzOC4yNDIuNSAyOS45NTEuNSAxOS43MzQuNSA5LjUxOCA5LjIwMiAxLjIyNiAxOS45NDkgMS4yMjZ6bTkuMzM0IDE0LjQxMmMuMDAyLjA4NC4wMDMuMTY2LjAwMy4yNSAwIDYuODc1LTUuNTg4IDEyLjcyLTEzLjMyNiAxMi43Mi0yLjU0NiAwLTUuMDI1LS42OTMtNy4xNjktMi4wMDNhLjYwMS42MDEgMCAwIDEtLjI1Mi0uNzI3LjYxMS42MTEgMCAwIDEgLjY0LS4zODhjLjMyNi4wMzcuNjYxLjA1Ni45OTYuMDU2IDEuMzggMCAyLjcwNC0uMzEgMy44OTYtLjkwNy0xLjQ0OC0uNTA0LTIuNjEtMS42MjQtMy4wOTgtMy4wNzlhLjYwMi42MDIgMCAwIDEgLjI0Mi0uNjk1Yy0xLjEzNi0uOTA0LTEuODQtMi4yNjYtMS44NC0zLjc1di0uMDYzYS42MDEuNjAxIDAgMCAxIC4zMTEtLjUxMi42MTQuNjE0IDAgMCAxIC4zOTMtLjA3IDQuNzA1IDQuNzA1IDAgMCAxLS42NjgtMi40MTVjMC0uODY0LjI0LTEuNzEzLjY5NC0yLjQ1NGEuNjEuNjEgMCAwIDEgLjk4Ni0uMDc3YzIuMDA0IDIuMzQyIDQuODk5IDMuODQyIDguMDMyIDQuMTc5YTQuNzcgNC43NyAwIDAgMS0uMDEtLjMxYzAtMi42ODcgMi4yODMtNC44NjIgNS4wNzgtNC44NjIgMS4yNzggMCAyLjUxNy40NjYgMy40NTIgMS4yOTNhOC41OCA4LjU4IDAgMCAwIDIuMzQ2LS45MDIuNjE3LjYxNyAwIDAgMSAuNjc3LjA0Ny42MDIuNjAyIDAgMCAxIC4yMDQuNjY4IDQuNzQ0IDQuNzQ0IDAgMCAxLS41MDggMS4wNTdjLjA5Ni0uMDM3LjE5Mi0uMDc1LjI4Ny0uMTE1YS42MTQuNjE0IDAgMCAxIC43MDMuMTU2LjYuNiAwIDAgMSAuMDQxLjc0MiA5LjM4IDkuMzggMCAwIDEtMi4xMSAyLjE2MXoiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "VJVd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showMenu: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['watchedUserDetails', 'userData']), {
    showMenuToggle: function showMenuToggle() {
      return this.isLoggedIn && this.userData.userName !== this.watchedUserDetails.userName;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    onMenuToggle: function onMenuToggle() {
      this.showMenu = !this.showMenu;
    },
    onReportUser: function onReportUser() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_REPORT_USER);
    }
  })
});

/***/ }),

/***/ "VM/5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MyIgaGVpZ2h0PSI0MyIgdmlld0JveD0iMCAwIDQzIDQzIj4NCiAgICA8ZGVmcz4NCiAgICAgICAgPGZpbHRlciBpZD0iYSIgd2lkdGg9IjEwMy43JSIgaGVpZ2h0PSIxMjIuMiUiIHg9Ii0xLjklIiB5PSItNy45JSIgZmlsdGVyVW5pdHM9Im9iamVjdEJvdW5kaW5nQm94Ij4NCiAgICAgICAgICAgIDxmZU9mZnNldCBkeT0iMiIgaW49IlNvdXJjZUFscGhhIiByZXN1bHQ9InNoYWRvd09mZnNldE91dGVyMSIvPg0KICAgICAgICAgICAgPGZlR2F1c3NpYW5CbHVyIGluPSJzaGFkb3dPZmZzZXRPdXRlcjEiIHJlc3VsdD0ic2hhZG93Qmx1ck91dGVyMSIgc3RkRGV2aWF0aW9uPSIyIi8+DQogICAgICAgICAgICA8ZmVDb2xvck1hdHJpeCBpbj0ic2hhZG93Qmx1ck91dGVyMSIgcmVzdWx0PSJzaGFkb3dNYXRyaXhPdXRlcjEiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4yIDAiLz4NCiAgICAgICAgICAgIDxmZU1lcmdlPg0KICAgICAgICAgICAgICAgIDxmZU1lcmdlTm9kZSBpbj0ic2hhZG93TWF0cml4T3V0ZXIxIi8+DQogICAgICAgICAgICAgICAgPGZlTWVyZ2VOb2RlIGluPSJTb3VyY2VHcmFwaGljIi8+DQogICAgICAgICAgICA8L2ZlTWVyZ2U+DQogICAgICAgIDwvZmlsdGVyPg0KICAgIDwvZGVmcz4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbHRlcj0idXJsKCNhKSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE1IC0xMikiPg0KICAgICAgICA8cGF0aCBzdHJva2U9IiNkOTUzNGYiIGQ9Ik0yMCAzMS41QzIwIDQwLjYxMiAyNy4zODYgNDggMzYuNSA0OCA0NS42MTIgNDggNTMgNDAuNjEyIDUzIDMxLjVTNDUuNjEyIDE1IDM2LjUgMTVDMjcuMzg2IDE1IDIwIDIyLjM4OCAyMCAzMS41eiIvPg0KICAgICAgICA8cGF0aCBmaWxsPSIjZDk1MzRmIiBkPSJNMzkuMTk5IDM3LjA4bC0yLjY5NC0yLjY5Mi0yLjcwNCAyLjdhMi4wNDIgMi4wNDIgMCAxIDEtMi44OS0yLjg4N2wyLjcwMy0yLjcwMi0yLjcwMi0yLjdjLS44LS43OTktLjgtMi4wOTEgMC0yLjg4OGEyLjA0MiAyLjA0MiAwIDAgMSAyLjg5IDBsMi43MDMgMi43TDM5LjIgMjUuOTJhMi4wNDIgMi4wNDIgMCAxIDEgMi44OSAyLjg4N2wtMi42OTQgMi42OTQgMi42OTMgMi42OTJjLjguNzk2LjggMi4wOSAwIDIuODg3YTIuMDQ2IDIuMDQ2IDAgMCAxLTIuODkgMHoiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "VYq2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_modal_switch_switch_vue__ = __webpack_require__("iOeH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");



 /* eslint-disable no-restricted-syntax */





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    switchModal: __WEBPACK_IMPORTED_MODULE_5__components_generics_modal_switch_switch_vue__["a" /* default */]
  },
  props: {
    items: {},
    price: {
      type: Number,
      required: true
    },
    operationType: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    title: function title() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["n" /* capitalizeFirstLetter */])(this.operationType) + ' Offers at ' + this.price + '\xA2';
    },
    hasBeforeMeOffers: function hasBeforeMeOffers() {
      return this.groupedRecords.length > 1 && !this.groupedRecords[0][0].isMine;
    },
    hasAfterMeOffers: function hasAfterMeOffers() {
      return this.groupedRecords.length > 1 && !this.groupedRecords[this.groupedRecords.length - 1][0].isMine;
    },
    groupedRecords: function groupedRecords() {
      if (this.items.length === 0) return [];

      var results = [];
      var temp = [];
      var previousFlag = null;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (previousFlag !== null && item.isMine !== previousFlag) {
            results.push([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(temp)));
            temp = [];
          }

          temp.push(item);
          previousFlag = item.isMine;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      results.push([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(temp)));

      return results;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isFirstGroupedIndex: function isFirstGroupedIndex(index) {
      return index === 0;
    },
    isLastGroupedIndex: function isLastGroupedIndex(index) {
      return index === this.groupedRecords.length - 1;
    },
    areMine: function areMine(records) {
      return records[0].isMine;
    },
    rowClassModifiers: function rowClassModifiers(records) {
      return {
        'offers-indicator--highlight': this.areMine(records)
      };
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('overlay', {
    hideOverlay: 'hide'
  }), {
    displayRecords: function displayRecords(records) {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy___default()(records, function (i) {
        return i.quantity;
      });
    },
    close: function close() {
      this.$emit('modalClose');
    }
  })
});

/***/ }),

/***/ "VZMg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-new__wrap"},[_c('app-header-notification'),_vm._v(" "),_c('header',{staticClass:"header-new"},[_c('div',{staticClass:"header-new-primary"},[(_vm.isLayoutMobile)?[_c('app-header-external-nav')]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"header-new-primary__menu"},[_c('div',{staticClass:"header-new-primary__menu-logo"},[_c('router-link',{attrs:{"to":{name: 'home'},"id":"pl-logo"}},[_c('img',{staticClass:"header-new-primary__logo",attrs:{"src":__webpack_require__("zxL1")}})])],1),_vm._v(" "),(_vm.isLoggedIn)?_c('div',{class:_vm.headerPrimaryMenuModifiers},[_c('div',{staticClass:"header-new-primary__menu-nav-left"},[_c('app-header-external-nav'),_vm._v(" "),_c('app-main-nav')],1),_vm._v(" "),_c('div',{staticClass:"header-new-primary__menu-nav-right"},[(!_vm.isShutdownModeOn && _vm.isLayoutDesktop)?_c('div',{class:_vm.notificationsIconModifiers,on:{"click":function($event){$event.stopPropagation();return _vm.onNotificationsClick($event)}}},[(_vm.showUnreadNotificationCount)?_c('div',{staticClass:"header-new-primary__menu-notifications-count"},[_vm._v("\n                "+_vm._s(_vm.userUnreadNotificationsCountHeader)+"\n              ")]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"header-new-primary__menu-notifications-widget"}},[(_vm.showNotificationsWidget)?_c('div',{staticClass:"header-new-primary__menu-notifications-widget"},[_c('notifications-widget')],1):_vm._e()])],1):_vm._e(),_vm._v(" "),(_vm.showBalanceHeader)?[(_vm.isLayoutDesktop)?_c('router-link',{staticClass:"header-new-primary__menu-item",attrs:{"id":"investment","tag":"div","to":{ name: 'portfolio' }}},[_c('div',{directives:[{name:"price-display",rawName:"v-price-display.floor.fixed",value:(_vm.balance.portfolioBalanceDecimal),expression:"balance.portfolioBalanceDecimal",modifiers:{"floor":true,"fixed":true}}],staticClass:"header-new-primary__menu-item--total-investment"}),_vm._v(" "),_c('div',{staticClass:"header-new-primary__menu-item__title"},[_vm._v("Investment")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"header-new-primary__menu-item",attrs:{"id":"cash"},on:{"click":_vm.onCashClick}},[_c('div',{directives:[{name:"price-display",rawName:"v-price-display.floor.fixed",value:(_vm.balance.accountBalanceDecimal),expression:"balance.accountBalanceDecimal",modifiers:{"floor":true,"fixed":true}}],class:_vm.valueClassModifiers}),_vm._v(" "),_c('div',{staticClass:"header-new-primary__menu-item__title"},[_vm._v("Cash")])])]:_vm._e(),_vm._v(" "),(!_vm.isShutdownModeOn)?[_c('div',{staticClass:"header-new-primary__menu-item",attrs:{"id":"nav-deposit"},on:{"click":function($event){$event.preventDefault();return _vm.openDepositPopup($event)}}},[_c('span',{class:_vm.depositIconModifiers}),_vm._v(" "),_c('div',{class:_vm.depositTitleModifiers},[_vm._v("Deposit")])]),_vm._v(" "),(_vm.isLayoutMobile)?_c('div',{staticClass:"header-new-primary__menu-item"},[_c('div',{class:_vm.notificationsIconModifiers,on:{"click":function($event){$event.stopPropagation();return _vm.onNotificationsClick($event)}}},[(_vm.showUnreadNotificationCount)?_c('div',{staticClass:"header-new-primary__menu-notifications-count"},[_vm._v("\n                    "+_vm._s(_vm.userUnreadNotificationsCountHeader)+"\n                  ")]):_vm._e()])]):_vm._e()]:_vm._e(),_vm._v(" "),(!_vm.isUserRestricted && !_vm.isShutdownModeOn)?_c('div',{staticClass:"header-new-primary__menu-search"},[_c('button',{staticClass:"button header-new-primary__search-button",attrs:{"id":"search"},on:{"click":_vm.toggleSearchBar}},[_vm._v("Search")])]):_vm._e()],2)]):_c('div',{staticClass:"header-new-primary__menu-nav"},[(!_vm.isUserRestricted)?_c('div',{staticClass:"header-new-primary__menu-nav-left"},[_c('app-header-external-nav'),_vm._v(" "),_c('app-main-nav')],1):_vm._e(),_vm._v(" "),(_vm.showLoginAndSignUpButtons)?_c('div',{staticClass:"header-new-primary__menu-nav-right"},[_c('button',{staticClass:"button button--white",attrs:{"id":"login"},on:{"click":function($event){return _vm.setCurrentPopup(_vm.MODALS.LOGIN)}}},[_vm._v("Login")]),_vm._v(" "),(!_vm.isUserRestricted && !_vm.isShutdownModeOn)?_c('button',{staticClass:"button button--darken",attrs:{"id":"signup"},on:{"click":_vm.onSignUp}},[_vm._v("Sign Up")]):_vm._e(),_vm._v(" "),(!_vm.isUserRestricted && !_vm.isShutdownModeOn)?_c('div',{staticClass:"header-new-primary__menu-search"},[_c('button',{staticClass:"button header-new-primary__search-button",attrs:{"id":"search"},on:{"click":_vm.toggleSearchBar}},[_vm._v("Search")])]):_vm._e()]):_vm._e()])])],2)]),_vm._v(" "),(!_vm.isUserRestricted && !_vm.isShutdownModeOn && !_vm.areUserBrowseHeadersEmpty)?_c('app-secondary-nav',{attrs:{"theme":"new"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vd78":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vnj/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_state_tooltip_js__ = __webpack_require__("CAq+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_582f89b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_state_tooltip_vue__ = __webpack_require__("QJjx");
function injectStyle (ssrContext) {
  __webpack_require__("IEE4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_state_tooltip_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_582f89b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_state_tooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W0Ww":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W82P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'click'
  },
  props: {
    checked: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    checked: function checked(val) {
      this.isChecked = val;
    }
  },
  data: function data() {
    return {
      isChecked: this.checked
    };
  },

  computed: {
    isOnModifier: function isOnModifier() {
      return {
        'switch-button--on': this.isChecked,
        'switch-button--disabled': this.disabled
      };
    }
  },
  methods: {
    toggle: function toggle() {
      if (!this.disabled) {
        this.isChecked = !this.isChecked;
        this.$emit('toggle', this.isChecked);
      }
    }
  }
});

/***/ }),

/***/ "W9Re":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketSharesItemLoader_vue__ = __webpack_require__("L6pp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3d5024a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketSharesItemLoader_vue__ = __webpack_require__("DjnW");
function injectStyle (ssrContext) {
  __webpack_require__("knac")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketSharesItemLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3d5024a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketSharesItemLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W9jE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WLVe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_account_social_badge_account_social_badge_vue__ = __webpack_require__("gdGR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dashboard_dashboard_desktop_dashboard_desktop_vue__ = __webpack_require__("OWA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__ = __webpack_require__("BL43");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_headerTags__ = __webpack_require__("cgm0");








var TAB_MARKETS = 'portfolio';
var TAB_INFO = 'info';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_headerTags__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__["a" /* default */]],
  components: {
    accountSocialBadge: __WEBPACK_IMPORTED_MODULE_2__components_account_account_social_badge_account_social_badge_vue__["a" /* default */],
    dashboardDesktop: __WEBPACK_IMPORTED_MODULE_3__components_dashboard_dashboard_desktop_dashboard_desktop_vue__["a" /* default */],
    tabs: __WEBPACK_IMPORTED_MODULE_4__components_generics_tabs_tabs_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Dashboard',
      link: [{ rel: 'canonical', href: '' + window.location.href }],
      meta: [{ itemprop: 'image', content: window.location.origin + '/static/logo.png' }, { property: 'og:title', content: 'Dashboard' }, { property: 'og:type', content: 'article' }, { property: 'og:image', content: window.location.origin + '/static/logo.png' }, { property: 'og:site_name', content: 'Predictit' }, { property: 'og:url', content: '' + window.location.href }]
    };
  },
  data: function data() {
    return {
      activeTab: null,
      tabs: [{ name: TAB_MARKETS, title: 'Markets' }, { name: TAB_INFO, title: 'Info' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    isNotificationsRoute: function isNotificationsRoute() {
      return this.$route.name === 'notifications';
    },
    showSocialBadge: function showSocialBadge() {
      return !this.isNotificationsRoute;
    },
    showTabs: function showTabs() {
      return !this.isNotificationsRoute;
    }
  }),
  methods: {
    tabChange: function tabChange(name) {
      this.activeTab = name;
      this.$router.push({ name: name });
      // if (name === TAB_NOTIFICATIONS) {
      //   this.clearAllNotifications();
      // }
    }
  },
  created: function created() {
    this.reorganizeTags();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isLayoutDesktop) {
      this.clearAllNotifications();
    }
  }
});

/***/ }),

/***/ "WPqe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attach-to-home"},[(_vm.items)?_c('swiper',{attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.items),function(item,index){return _c('swiper-slide',{key:index,staticClass:"attach-to-home__slide"},[(item.textTop)?_c('p',{staticClass:"attach-to-home__slide-text attach-to-home__slide-text--top"},[_vm._v("\n        "+_vm._s(item.textTop)+"\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"attach-to-home__slide-image",class:("attach-to-home__slide-image--" + (item.image))}),_vm._v(" "),(item.textBottom)?_c('p',{staticClass:"attach-to-home__slide-text attach-to-home__slide-text--bottom"},[_vm._v("\n        "+_vm._s(item.textBottom)+"\n      ")]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"attach-to-home__pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"attach-to-home__footer"},[_c('form-checkbox',{staticClass:"checkbox--attach-to-home checkbox--no-margin",attrs:{"label":"Don’t show this message again","name":"dont-show-again","small":true},model:{value:(_vm.dontShowAgain),callback:function ($$v) {_vm.dontShowAgain=$$v},expression:"dontShowAgain"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WRh2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_generic_small_js__ = __webpack_require__("b+hr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c7fe042_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_small_vue__ = __webpack_require__("QVDr");
function injectStyle (ssrContext) {
  __webpack_require__("DUXn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_generic_small_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c7fe042_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_small_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WSTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_app_header_notification_app_header_notification_vue__ = __webpack_require__("dMVO");
/* eslint-disable */




var LAYOUT_MOBILE = 'mobile';
var LAYOUT_DESKTOP = 'desktop';
var LAYOUT_SWITCH_BREAKPOINT = 1024;

function getDefaultLayout() {
  var width = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
  return width >= LAYOUT_SWITCH_BREAKPOINT ? LAYOUT_DESKTOP : LAYOUT_MOBILE;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    newHeaderEnabled: false,
    newHeaderExchangeUrl: "https://exchange.predictit.com",
    previousRoute: null,
    initialVersion: null,
    serverVersion: null,
    skipAttachToHomeNotification: __WEBPACK_IMPORTED_MODULE_0__helpers_localStorage__["a" /* default */].get('skipAttachToHomeNotification', false),
    skipBanner: __WEBPACK_IMPORTED_MODULE_0__helpers_localStorage__["a" /* default */].get('skipBanner', false),
    hasServerErrorOccurred: false,
    layout: getDefaultLayout(),
    isTaxNotificationMandatory: false,
    hiddenMaintenanceMessage: __WEBPACK_IMPORTED_MODULE_0__helpers_localStorage__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_1__components_app_app_header_notification_app_header_notification_vue__["b" /* LS_MAINTENANCE_MESSAGE_KEY */]),
    maintenance: {
      isMaintenanceEnabled: false,
      isTradingEnabled: true,
      maintenanceMessage: '',
      suspendedMessage: '',
      systemMessage: ''
    },
    mobileMenuOpened: false,
    isTabActive: !document.hidden,
    liveUpdatesDisabled: false,
    firebaseInitialized: false,
    systemEmails: {
      support: "support@predictit.org",
      press: "press@predictit.org",
      markets: "markets@predictit.org"
    }
  },
  mutations: {
    setLiveUpdatesDisabled: function setLiveUpdatesDisabled(state, flag) {
      state.liveUpdatesDisabled = flag;
    },
    setIsTabActive: function setIsTabActive(state, data) {
      state.isTabActive = data;
    },
    setPreviousRoute: function setPreviousRoute(state, data) {
      state.previousRoute = data;
    },
    setInitialVersion: function setInitialVersion(state, version) {
      state.initialVersion = version;
    },
    setServerVersion: function setServerVersion(state, version) {
      state.serverVersion = version;
    },
    setLayout: function setLayout(state, layout) {
      state.layout = layout;
    },
    setServerError: function setServerError(state, hasOccurred) {
      state.hasServerErrorOccurred = hasOccurred;
    },
    setFirebaseInitialized: function setFirebaseInitialized(state, flag) {
      state.firebaseInitialized = flag;
    },
    setMaintenance: function setMaintenance(state, data) {
      state.maintenance = data;
    },
    setMandatoryTaxNotification: function setMandatoryTaxNotification(state, flag) {
      state.isTaxNotificationMandatory = flag;
    },
    dontShowAttachToHomeNotification: function dontShowAttachToHomeNotification(state) {
      var expiresAt = 31536000; // 1 year
      __WEBPACK_IMPORTED_MODULE_0__helpers_localStorage__["a" /* default */].set('skipAttachToHomeNotification', true, expiresAt);
      state.skipAttachToHomeNotification = true;
    },
    dontShowBanner: function dontShowBanner(state) {
      state.skipBanner = true;
    },
    toggleMobileMenu: function toggleMobileMenu(state) {
      state.mobileMenuOpened = !state.mobileMenuOpened;
    },
    closeMobileMenu: function closeMobileMenu(state) {
      state.mobileMenuOpened = false;
    },
    setHiddenMaintenanceMessage: function setHiddenMaintenanceMessage(state, value) {
      state.hiddenMaintenanceMessage = value;
    }
  },
  getters: {
    isLayoutMobile: function isLayoutMobile(state) {
      return state.layout === LAYOUT_MOBILE;
    },
    isLayoutDesktop: function isLayoutDesktop(state) {
      return state.layout === LAYOUT_DESKTOP;
    },
    isShutdownModeOn: function isShutdownModeOn(state) {
      return !!false;
    },
    hasMaintenanceMessage: function hasMaintenanceMessage(state) {
      if (state.maintenance.maintenanceMessage) return true;
      var maintenanceMessage = state.maintenance.suspendedMessage || state.maintenance.systemMessage;
      // check if message was hidden by user;
      return maintenanceMessage && maintenanceMessage !== state.hiddenMaintenanceMessage;
    },
    hasMaintenance: function hasMaintenance(state) {
      return state.maintenance.maintenanceMessage || state.maintenance.suspendedMessage;
    },
    hasBanner: function hasBanner(state, getters, rootState, rootGetters) {
      return false && !state.skipBanner && rootGetters['user/isLoggedIn'];
    }
  },
  actions: {
    setHiddenMaintenanceMessage: function setHiddenMaintenanceMessage(_ref, value) {
      var commit = _ref.commit;

      commit('setHiddenMaintenanceMessage', value);
    },
    setInitialVersion: function setInitialVersion(_ref2, data) {
      var commit = _ref2.commit;

      commit('setInitialVersion', data);
    },
    setServerVersion: function setServerVersion(_ref3, data) {
      var commit = _ref3.commit;

      commit('setServerVersion', data);
    },
    setLayoutWidth: function setLayoutWidth(_ref4, width) {
      var commit = _ref4.commit;

      if (width >= LAYOUT_SWITCH_BREAKPOINT) {
        commit('setLayout', LAYOUT_DESKTOP);
      } else {
        commit('setLayout', LAYOUT_MOBILE);
      }
    },
    setServerError: function setServerError(_ref5, hasOccurred) {
      var commit = _ref5.commit;

      commit('setServerError', hasOccurred);
    },
    setMaintenance: function setMaintenance(_ref6, data) {
      var commit = _ref6.commit;

      commit('setMaintenance', data);
    },
    setMandatoryTaxNotification: function setMandatoryTaxNotification(_ref7, flag) {
      var commit = _ref7.commit;

      commit('setMandatoryTaxNotification', flag);
    },
    dontShowAttachToHomeNotification: function dontShowAttachToHomeNotification(_ref8) {
      var commit = _ref8.commit;

      commit('dontShowAttachToHomeNotification');
    },
    dontShowBanner: function dontShowBanner(_ref9) {
      var commit = _ref9.commit;

      commit('dontShowBanner');
    },
    setPreviousRoute: function setPreviousRoute(_ref10, data) {
      var commit = _ref10.commit;

      commit('setPreviousRoute', data);
    },
    toggleMobileMenu: function toggleMobileMenu(_ref11) {
      var commit = _ref11.commit;

      commit('toggleMobileMenu');
    },
    closeMobileMenu: function closeMobileMenu(_ref12) {
      var commit = _ref12.commit;

      commit('closeMobileMenu');
    },
    setIsTabActive: function setIsTabActive(_ref13, flag) {
      var commit = _ref13.commit;

      commit('setIsTabActive', flag);
    },
    setLiveUpdatesDisabled: function setLiveUpdatesDisabled(_ref14, flag) {
      var commit = _ref14.commit;

      commit('setLiveUpdatesDisabled', flag);
    },
    setFirebaseInitialized: function setFirebaseInitialized(_ref15, flag) {
      var commit = _ref15.commit;

      commit('setFirebaseInitialized', flag);
    }
  }
});

/***/ }),

/***/ "WUho":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WXHk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposited_js__ = __webpack_require__("Mq7P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_375528f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposited_vue__ = __webpack_require__("uoxE");
function injectStyle (ssrContext) {
  __webpack_require__("ENjL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_deposited_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_375528f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deposited_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WYZc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_history_trades_refine_history_refine_history_vue__ = __webpack_require__("t3+b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_account_history_trades_button_with_info_button_with_info_vue__ = __webpack_require__("II89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: Object,
    markets: Array,
    recent: Boolean,
    isOpen: Boolean
  },
  components: {
    refineHistory: __WEBPACK_IMPORTED_MODULE_2__components_account_history_trades_refine_history_refine_history_vue__["a" /* default */],
    buttonWithInfo: __WEBPACK_IMPORTED_MODULE_3__components_account_history_trades_button_with_info_button_with_info_vue__["a" /* default */]
  },
  computed: {
    openModifier: function openModifier() {
      return {
        'history-filters--open': this.isOpen
      };
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    onRecent: function onRecent() {
      this.$emit('input', null);
      var params = !this.value ? {} : { marketId: 'all' };
      this.$router.push({ name: 'account-history', params: params });
    },
    onMarkets: function onMarkets() {
      this.$router.push({ name: 'account-history', params: { marketId: 'all' } });
    },
    onInfoClick: function onInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_TRADE_INFO);
    },
    onRefineHistoryInput: function onRefineHistoryInput(e) {
      this.$emit('input', e);
      this.$router.push({ name: 'account-history', params: { marketId: e.marketId } });
    }
  })
});

/***/ }),

/***/ "WeRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some__ = __webpack_require__("mGzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_autosuggest__ = __webpack_require__("aatO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__ = __webpack_require__("vJzj");

 /* eslint-disable */






var OTHER_ID = -1;
var LIMIT = 10;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */]],
  data: function data() {
    return {
      showExplanation: false,
      isSearching: false,
      suggestions: [{ data: [] }],
      current: [],
      currentIds: [],
      fields: {
        query: '',
        agreed: ''
      }
    };
  },

  components: {
    VueAutosuggest: __WEBPACK_IMPORTED_MODULE_3_vue_autosuggest__["a" /* VueAutosuggest */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['status']), {
    universities: function universities() {
      return this.current;
    },
    isConfirmDisabled: function isConfirmDisabled() {
      var isOneOfFieldsEmpty = __WEBPACK_IMPORTED_MODULE_1_lodash_some___default()(this.current, function (x) {
        return !x.name;
      });
      return !this.isFormEnabled || !this.fields.agreed || isOneOfFieldsEmpty;
    },
    showOtherSchoolNote: function showOtherSchoolNote() {
      return this.currentIds.includes(OTHER_ID);
    },
    buttonText: function buttonText() {
      return this.status.isUCAffilSet === null ? 'Continue' : 'Confirm';
    }
  }),
  watch: {
    'fields.agreed': function fieldsAgreed(value) {
      if (value === 'no') {
        this.fields.query = '';
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['getUserAffiliations', 'setUserAffiliations', 'getAffiliations']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getStatus']), {
    onRemove: function onRemove(value) {
      this.current = this.current.filter(function (i) {
        return i.id !== value.id;
      });
      this.currentIds = this.currentIds.filter(function (i) {
        return i !== value.id;
      });
    },
    getKey: function getKey() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    },
    onSelected: function onSelected(value) {
      var _this = this;

      if (this.currentIds.length === LIMIT) {
        return;
      }
      var item = (value || {}).item;
      if (item && (item.id === OTHER_ID || !this.currentIds.includes(item.id))) {
        this.currentIds.push(item.id);
        this.current.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item));
        // this.fields.query = item.name;
      }

      if (item && item.id === OTHER_ID) {
        this.$nextTick(function () {
          var elements = _this.$el.querySelectorAll('.input__value');
          if (elements.length > 0) {
            elements[elements.length - 1].focus();
          }
        });
      }
      // this.suggestions[0].data = [];
    },
    onInputChange: function onInputChange(text) {
      var _this2 = this;

      if (this.isSearching) return;

      if (this.fields.query && this.fields.query.length >= 2) {
        this.isSearching = true;
        setTimeout(function () {
          _this2.getAffiliations(_this2.fields.query).then(function (data) {
            _this2.suggestions[0].data = (data.affiliateEntities || []).map(function (i) {
              return {
                id: i.affiliateEntityId,
                isHidden: false,
                name: i.name,
                key: _this2.getKey()
              };
            });
            _this2.isSearching = false;
          }).catch(function () {
            _this2.isSearching = false;
          });
        }, 500);
      }
    },
    getSuggestionValue: function getSuggestionValue(suggestion) {
      return suggestion.item.name;
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.formDisable();
      this.loaderAdd(document.body);

      var affiliations = [];

      if (this.fields.agreed === 'yes') {
        this.universities.forEach(function (i) {
          var item = {
            id: i.id,
            name: i.id === -1 ? i.name : '',
            isPublic: !i.isHidden
          };
          affiliations.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item));
        });
      } else {
        affiliations = [];
      }
      var payload = {
        isUCAffiliated: this.fields.agreed === 'yes',
        userAffiliations: affiliations
      };

      this.setUserAffiliations(payload).then(function () {
        return _this3.getStatus();
      }).then(function () {
        return _this3.getUserAffiliations();
      }).then(function () {
        return _this3.setCurrentPopup();
      }).then(function () {
        _this3.loaderRemove(document.body);
        _this3.formEnable();
      }).catch(function () {
        _this3.loaderRemove(document.body);
        _this3.formEnable();
      });
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    this.loaderAdd();
    this.getUserAffiliations().then(function (data) {
      (data.affiliateEntities || []).forEach(function (i) {
        _this4.currentIds.push(i.affiliateEntityId);
        var item = {
          id: i.affiliateEntityId,
          isHidden: !i.isPublic,
          name: i.name,
          key: _this4.getKey()
        };
        _this4.current.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item));
      });
      if (_this4.status.isUCAffilSet === true) {
        _this4.fields.agreed = 'yes';
      } else if (_this4.status.isUCAffilSet === false) {
        _this4.fields.agreed = 'no';
      }
      _this4.loaderRemove();
    }).catch(function () {
      return _this4.loaderRemove();
    });
  }
});

/***/ }),

/***/ "WhZX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_market_v2_market_list_item_v2_market_list_item_v2_vue__ = __webpack_require__("tPuv");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    markets: {
      type: Array,
      required: true
    }
  },
  components: {
    marketListItem: __WEBPACK_IMPORTED_MODULE_0__components_market_v2_market_list_item_v2_market_list_item_v2_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "Wngs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-tax-detail"},[_c('div',{staticClass:"page-tax-detail__content"},[_c('div',{staticClass:"page-tax-detail__title"},[_vm._v("Tax Information")]),_vm._v(" "),_c('div',{staticClass:"page-tax-detail__content-wrap"},[_c('tax-info-notification')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wspo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TAB_INDEX_CREDIT */
/* unused harmony export TAB_INDEX_PAY_NEAR_ME */
/* unused harmony export TAB_INDEX_COINBASE */
/* unused harmony export TAB_INDEX_ONLINE_BANKING */
/* unused harmony export TAB_INDEX_PENDING */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wallet_add_funds_card_add_funds_card_vue__ = __webpack_require__("a3Wk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wallet_add_funds_cash_add_funds_cash_vue__ = __webpack_require__("4OEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_wallet_add_funds_coinbase_add_funds_coinbase_vue__ = __webpack_require__("ircP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__ = __webpack_require__("t71M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_wallet_pending_requests_pending_requests_deposits_vue__ = __webpack_require__("rNZt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_loader__ = __webpack_require__("39kf");










var TAB_INDEX_CREDIT = 0;
var TAB_INDEX_PAY_NEAR_ME = 1;
var TAB_INDEX_COINBASE = 2;
var TAB_INDEX_ONLINE_BANKING = 3;
var TAB_INDEX_PENDING = 4;

var GTM_PAGE_NAME = 'deposit';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_loader__["a" /* default */]],
  components: {
    addFundsCard: __WEBPACK_IMPORTED_MODULE_3__components_wallet_add_funds_card_add_funds_card_vue__["a" /* default */],
    addFundsCash: __WEBPACK_IMPORTED_MODULE_4__components_wallet_add_funds_cash_add_funds_cash_vue__["a" /* default */],
    addFundsCoinbase: __WEBPACK_IMPORTED_MODULE_5__components_wallet_add_funds_coinbase_add_funds_coinbase_vue__["a" /* default */],
    addFundsBankTransfer: __WEBPACK_IMPORTED_MODULE_6__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["c" /* default */],
    pendingRequests: __WEBPACK_IMPORTED_MODULE_7__components_wallet_pending_requests_pending_requests_deposits_vue__["a" /* default */],
    tabs: __WEBPACK_IMPORTED_MODULE_2__components_generics_tabs_tabs_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showTabs: false,
      tabIndexOrder: [],
      isCashAvailable: false,
      isCryptoAvailable: false,
      isCreditCardAvailable: false,
      isOnlineBankingAvailable: false,
      cryptoDescription: '',
      activeTab: null,
      cardDepositAttempt: 1
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    showBankingTab: function showBankingTab() {
      return this.activeTab === TAB_INDEX_ONLINE_BANKING;
    },
    showCreditCardTab: function showCreditCardTab() {
      return this.activeTab === TAB_INDEX_CREDIT;
    },
    showCashTab: function showCashTab() {
      return this.activeTab === TAB_INDEX_PAY_NEAR_ME;
    },
    showCoinBaseTab: function showCoinBaseTab() {
      return this.activeTab === TAB_INDEX_COINBASE;
    },
    showPendingTab: function showPendingTab() {
      return this.activeTab === TAB_INDEX_PENDING;
    },
    tabs: function tabs() {
      var _this = this;

      var results = [];
      this.tabIndexOrder.forEach(function (v) {
        if (_this.isOnlineBankingAvailable && v === TAB_INDEX_ONLINE_BANKING) {
          results.push({
            name: TAB_INDEX_ONLINE_BANKING,
            title: _this.isLayoutMobile ? 'Online Banking' : 'Online Banking'
          });
        }
        if (_this.isCreditCardAvailable && v === TAB_INDEX_CREDIT) {
          results.push({
            name: TAB_INDEX_CREDIT,
            title: _this.isLayoutMobile ? 'Credit Card' : 'Credit Card'
          });
        }
        if (_this.isCashAvailable && v === TAB_INDEX_PAY_NEAR_ME) {
          results.push({
            name: TAB_INDEX_PAY_NEAR_ME,
            title: 'Cash'
          });
        }
        if (_this.isCryptoAvailable && v === TAB_INDEX_COINBASE) {
          results.push({
            name: TAB_INDEX_COINBASE,
            title: _this.cryptoDesctiption
          });
        }
      });
      results.push({
        name: TAB_INDEX_PENDING,
        title: 'Pending'
      });
      return results;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['getDepositMethods']), {
    tabChange: function tabChange(name) {
      this.activeTab = name;

      if (this.$route && this.$route.path) {
        this.$gtm.trackEvent({
          event: 'pageviewTrackerEvent',
          virtualPage: this.$route.path + '/' + GTM_PAGE_NAME + '/' + name,
          virtualPageTitle: this.$route.name + ' - ' + GTM_PAGE_NAME + ' - ' + name
        });
      }
    },
    onAddFundsCardSuccess: function onAddFundsCardSuccess() {
      this.cardDepositAttempt += 1;
    }
  }),
  created: function created() {
    var _this2 = this;

    this.loaderAdd(document.body);
    this.getDepositMethods().then(function (data) {
      _this2.showTabs = true;
      _this2.tabIndexOrder = data.tabIndexOrder;
      _this2.isCashAvailable = data.isCashAvailable;
      _this2.isCryptoAvailable = data.isCryptoAvailable;
      _this2.isCreditCardAvailable = data.isCreditCardAvailable;
      _this2.isOnlineBankingAvailable = data.isOnlineBankingAvailable;
      _this2.cryptoDesctiption = data.cryptoDescription || 'USDC';
      _this2.loaderRemove(document.body);
    }).catch(function () {
      return _this2.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "Wxlj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"filter-button",class:_vm.buttonModifier,on:{"click":_vm.toggleFilter}},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wy00":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.market && _vm.market.marketId)?[(_vm.ogImageSrc)?_c('img',{staticClass:"market-detail__og-image",attrs:{"src":_vm.ogImageSrc,"alt":""}}):_vm._e(),_vm._v(" "),(_vm.isLayoutMobile)?_c('market-header-title',{attrs:{"market":_vm.market,"watchIcon":true,"backButton":_vm.showTitleBackButton}}):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('market-header-title-large',{attrs:{"market":_vm.market,"watchIcon":true}}):_vm._e(),_vm._v(" "),(_vm.market && _vm.market.marketWarning)?_c('alert-box',{staticClass:"market-detail__info-message",attrs:{"level":"info-alt"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.market.marketWarning)}})]):_vm._e(),_vm._v(" "),(_vm.showEconomicIndicator)?_c('alert-box',{staticClass:"market-detail__info-message",attrs:{"level":"affiliation"}},[_c('div',[_vm._v("\r\n        "+_vm._s(_vm.$txt('page-market.economic-indicator'))+"\r\n      ")])]):_vm._e(),_vm._v(" "),(_vm.showEngineBusyNotification)?_c('alert-box',{staticClass:"market-detail__info-message",attrs:{"level":"warning"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.engineBusyNotificationContent)}})]):_vm._e(),_vm._v(" "),(_vm.hasMarketStatusMessage(_vm.market))?_c('alert-box',{staticClass:"market-detail__info-message",attrs:{"level":_vm.statusMessageLevel}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.statusMessage)}})]):_vm._e(),_vm._v(" "),(_vm.isPayoutAvailable && _vm.isLayoutDesktop)?_c('div',{staticClass:"market-detail__payout-header"},[_c('div',{staticClass:"market-detail__payout-header-col-1"},[_vm._v("\r\n        "+_vm._s(_vm.$txt('page-market.investment-title'))+"\r\n      ")]),_vm._v(" "),_c('div',{staticClass:"market-detail__payout-header-col-2"},[_vm._v("\r\n        "+_vm._s(_vm.$txt('page-market.gain-loss-title'))+"\r\n      ")]),_vm._v(" "),_c('div',{staticClass:"market-detail__payout-header-col-3"},[_vm._v("\r\n        "+_vm._s(_vm.$txt('page-market.payout-title'))+"\r\n      ")])]):_vm._e(),_vm._v(" "),(_vm.isPayoutAvailable)?_c('market-payout',{key:_vm.marketKey('payout'),attrs:{"showLabels":_vm.isLayoutMobile,"market":_vm.market,"theme":"market"}}):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('div',{staticClass:"market-detail__contracts-header"},[_c('div',{staticClass:"market-detail__contracts-header-col-1"},[_vm._v("\r\n        "+_vm._s(_vm.$txt('page-market.contracts-first-col'))+"\r\n      ")]),_vm._v(" "),_c('div',{staticClass:"market-detail__contracts-header-col-2"},[_vm._v("\r\n        "+_vm._s(_vm.$txt('page-market.contracts-second-col'))+"\r\n      ")]),_vm._v(" "),_c('div',{staticClass:"market-detail__contracts-header-col-3"},[_vm._v("\r\n        "+_vm._s(_vm.$txt('page-market.contracts-third-fourth-col'))+"\r\n      ")]),_vm._v(" "),_c('div',{staticClass:"market-detail__contracts-header-col-4"},[_vm._v("\r\n        "+_vm._s(_vm.$txt('page-market.contracts-third-fourth-col'))+"\r\n      ")])]):_vm._e(),_vm._v(" "),(_vm.ready)?_c('div',{staticClass:"row-x"},[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"market-detail__contracts"},[_vm._l((_vm.visibleContracts),function(item){return [_c('market-contract',{key:_vm.contractKey('market-contract', item),attrs:{"data-contract-id":item.contractId,"showPurchaseOnInit":_vm.shouldInitializePurchaseOnInit,"market":_vm.market,"contract":item},on:{"purchaseShown":_vm.onPurchaseShownOnInit}}),_vm._v(" "),(_vm.isPurchaseDesktopMode(item.contractId))?_c('purchase-desktop',{key:_vm.contractKey('purchase-desktop', item),attrs:{"market":_vm.market,"showCloseButton":false,"closeJourneyAfterSuccess":true}}):_vm._e()]}),_vm._v(" "),(_vm.shouldShowToggleMoreButton)?_c('div',{class:_vm.toggleMoreModifiers,on:{"click":_vm.onToggleMore}},[(!_vm.showAllContracts)?[_vm._v("\r\n              "+_vm._s(_vm.hiddenContracts.length)+" More Contract"),(_vm.hiddenContracts.length > 1)?[_vm._v("s")]:_vm._e(),_vm._v(" "),(_vm.hiddenContractsOffersOrSharesCount > 0)?[_vm._v("\r\n                "+_vm._s(_vm.$txt('page-market.contracts-hidden-info'))+"\r\n              ")]:_vm._e()]:[_vm._v("\r\n              "+_vm._s(_vm.$txt('page-market.fewer'))+"\r\n            ")]],2):_c('div',{staticClass:"market-detail__contracts-toggle-placeholder"},[_vm._v("\r\n             \r\n          ")])],2)]),_vm._v(" "),_c('div',{staticClass:"column small-12 large-8"},[_c('market-rules',{key:_vm.marketKey('rules'),attrs:{"market":_vm.market,"emphasize":_vm.showRules,"dateEnd":_vm.market.dateEndString,"rules":_vm.market.rule}}),_vm._v(" "),_c('market-charts',{key:_vm.marketKey('chart'),attrs:{"market":_vm.market}})],1),_vm._v(" "),(_vm.isLayoutMobile)?_c('div',{staticClass:"column small-12 large-4"},[(_vm.showMarketHistory)?_c('market-history',{key:_vm.historyKey,attrs:{"market":_vm.market,"isOpen":_vm.isHistoryOpen},on:{"toggle-history":_vm.onToggleHistory}}):_vm._e(),_vm._v(" "),_c('market-related',{key:_vm.marketKey('related'),attrs:{"market":_vm.market,"isOpen":_vm.isRelatedOpen},on:{"toggle-related":_vm.onToggleRelated}}),_vm._v(" "),(_vm.market.info)?_c('div',{staticClass:"market-detail__info",domProps:{"innerHTML":_vm._s(_vm.market.info)}}):_vm._e(),_vm._v(" "),_c('disqus',{attrs:{"disqusId":_vm.market.disqus_Identifier,"title":_vm.market.disqus_Title,"auth":_vm.market.disqus_UserAuth,"url":_vm.market.disqus_Url,"previous":_vm.market.disqus_PrevThreadID,"next":_vm.market.disqus_NextThreadID,"total":_vm.market.disqus_ArchivedCommentsTotal,"marketId":_vm.market.marketId}})],1):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('div',{staticClass:"market-detail__right-col-desktop column small-12 large-4"},[(_vm.showMarketHistory)?_c('market-history',{key:_vm.historyKey,attrs:{"market":_vm.market,"isOpen":_vm.isHistoryOpen},on:{"toggle-history":_vm.onToggleHistory}}):_vm._e(),_vm._v(" "),_c('market-related',{key:_vm.marketKey('related'),attrs:{"market":_vm.market,"isOpen":_vm.isRelatedOpen},on:{"toggle-related":_vm.onToggleRelated}})],1):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop && _vm.market.info)?_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"market-detail__info market-detail__info--margin-top",domProps:{"innerHTML":_vm._s(_vm.market.info)}})]):_vm._e(),_vm._v(" "),(_vm.isLayoutDesktop)?_c('div',{staticClass:"column small-12"},[(_vm.marketKey() && _vm.isLayoutDesktop)?_c('disqus',{staticClass:"market-detail__disqus",attrs:{"disqusId":_vm.market.disqus_Identifier,"title":_vm.market.disqus_Title,"auth":_vm.market.disqus_UserAuth,"url":_vm.market.disqus_Url,"previous":_vm.market.disqus_PrevThreadID,"next":_vm.market.disqus_NextThreadID,"total":_vm.market.disqus_ArchivedCommentsTotal,"marketId":_vm.market.marketId}}):_vm._e()],1):_vm._e()]):_vm._e()]:[(!_vm.marketLoadError)?_c('div',{staticClass:"market-detail__spinner"}):_vm._e(),_vm._v(" "),(_vm.marketLoadError)?_c('div',{staticClass:"market-detail__load-error"},[_vm._v("\r\n      "+_vm._s(_vm.$txt('page-market.no-market-message'))+"\r\n    ")]):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wy5T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-list-item-v2-embed"},[_c('div',{staticClass:"market-list-item-v2-embed__header"},[_c('div',{staticClass:"market-list-item-v2-embed__header-text"},[_vm._v("\n      "+_vm._s(_vm.$txt('cms.market-list-embed.title'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"market-list-item-v2-embed__header-outline"},[_vm._v("\n      "+_vm._s(_vm.markets.length)+" Markets\n    ")])]),_vm._v(" "),_c('div',{staticClass:"market-list-item-v2-embed__grid"},_vm._l((_vm.markets),function(market){return _c('div',{staticClass:"market-list-item-v2-embed__grid-item"},[_c('market-list-item',{key:market.marketId,attrs:{"market":market}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X/Fy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    visible: false
  },
  mutations: {
    show: function show(state) {
      state.visible = true;
    },
    hide: function hide(state) {
      state.visible = false;
    }
  },
  actions: {
    show: function show(_ref) {
      var commit = _ref.commit;

      commit('show');
    },
    hide: function hide(_ref2) {
      var commit = _ref2.commit;

      commit('hide');
    }
  }
});

/***/ }),

/***/ "X1oX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password-requirements"},[_c('p',{staticClass:"password-requirements__label"},[_vm._v("Minimum password requirements")]),_vm._v(" "),_c('div',{staticClass:"password-requirements__req"},[_c('form-checkbox',{staticClass:"password-requirements__6plus",attrs:{"name":"password-requirements-min-length","label":"6+characters","disabled":true,"checked":this.validation.minLength,"small":true}}),_vm._v(" "),_c('form-checkbox',{staticClass:"password-requirements__letter",attrs:{"name":"password-requirements-lower","label":"Upper & Lower Case","disabled":true,"checked":_vm.hasOneUpperLower,"small":true}}),_vm._v(" "),_c('form-checkbox',{staticClass:"password-requirements__digit",attrs:{"name":"password-requirements-digit","label":"Number","disabled":true,"checked":this.validation.hasOneDigit,"small":true}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X543":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_link_tile_link_tile_vue__ = __webpack_require__("SHkF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_support_faq_faq_vue__ = __webpack_require__("ZIhC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_icons_support_book_svg__ = __webpack_require__("jDBh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_icons_support_book_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_icons_support_book_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icons_support_faq_svg__ = __webpack_require__("B8JL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icons_support_faq_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_icons_support_faq_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_icons_support_logo_png__ = __webpack_require__("A07q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_icons_support_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_icons_support_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_icons_support_tutorial_svg__ = __webpack_require__("C5mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_icons_support_tutorial_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_icons_support_tutorial_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_support__ = __webpack_require__("33FX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");



/* eslint-disable arrow-body-style */














var TICKET_SEND_MESSAGE = 'Message received!';
// const FILE_PROCESSING_ERROR = 'An error occured while processing your file';

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: 'Help And Support'
    }
  },
  components: {
    linkTile: __WEBPACK_IMPORTED_MODULE_4__components_generics_link_tile_link_tile_vue__["a" /* default */],
    contentHeader: __WEBPACK_IMPORTED_MODULE_5__components_generics_content_header_content_header_vue__["a" /* default */],
    faq: __WEBPACK_IMPORTED_MODULE_6__components_support_faq_faq_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_11__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_12__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__mixins_support__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__["a" /* default */]],
  data: function data() {
    return {
      announcements: [],
      fields: {
        email: '',
        subject: null,
        message: ''
      },
      files: []
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Support'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['userData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('support', ['ticketTypes']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['systemEmails']), {
    items: function items() {
      var items = [{
        href: '/support/what-is-predictit',
        icon: __WEBPACK_IMPORTED_MODULE_9__assets_icons_support_logo_png___default.a,
        title: 'What is PredictIt?',
        subtitle: ''
      }, {
        href: '/support/how-to-trade-on-predictit',
        icon: __WEBPACK_IMPORTED_MODULE_7__assets_icons_support_book_svg___default.a,
        title: 'How to Trade on PredictIt',
        subtitle: ''
      }, {
        href: '/support/faq',
        icon: __WEBPACK_IMPORTED_MODULE_8__assets_icons_support_faq_svg___default.a,
        title: 'FAQs'
      }];

      if (!this.showVideos) {
        items.push({
          href: '/support/videos',
          icon: __WEBPACK_IMPORTED_MODULE_10__assets_icons_support_tutorial_svg___default.a,
          title: 'Videos',
          subtitle: ''
        });
      }

      return items;
    },
    subjectOptions: function subjectOptions() {
      return this.ticketTypes === null ? [] : this.ticketTypes;
    },
    isUploadEnabled: function isUploadEnabled() {
      // return !(this.isIos && this.isStandalone);
      return true;
    },
    messagePlaceholder: function messagePlaceholder() {
      return this.fields.message ? '' : 'Message';
    },
    messageRequired: function messageRequired() {
      return !this.fields.message;
    }
  }),
  validations: {
    fields: {
      email: __WEBPACK_IMPORTED_MODULE_11__components_forms_mixin__["a" /* validators */].email,
      subject: __WEBPACK_IMPORTED_MODULE_11__components_forms_mixin__["a" /* validators */].required,
      message: __WEBPACK_IMPORTED_MODULE_11__components_forms_mixin__["a" /* validators */].message
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup', 'setCurrentPopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('support', ['getTicketsTypes', 'postTicket', 'getAnnouncements']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']), {
    userDataHandler: function userDataHandler(value) {
      if (value && value.email) {
        this.fields.email = value.email;
      }
    },
    showAnnouncement: function showAnnouncement(announcement) {
      if (!announcement.body) return;

      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_15__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_ANNOUNCEMENT);
      this.setCurrentPopupOptions({ announcement: announcement });
    },
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formIsValid() && this.formDisable()) {
        this.loaderAdd(document.body);
        var formData = new FormData();
        formData.append('email', this.fields.email);
        formData.append('subject', this.fields.subject.value);
        formData.append('description', this.fields.message);

        this.files.forEach(function (file) {
          formData.append('uploadedImage', file);
        });

        this.postTicket(formData).then(function () {
          _this.loaderRemove(document.body);
          _this.setSuccessSideNotification(TICKET_SEND_MESSAGE);
          _this.files = [];
          _this.fields.message = '';
          _this.fields.subject = null;
          _this.formEnable();
        }).catch(function (error) {
          _this.loaderRemove(document.body);
          _this.formHandleErrors(error);
        });
      }
    },
    onUpload: function onUpload() {
      this.$refs.fileinput.click();
    },
    fileToBase64: function fileToBase64(file) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          return resolve({
            name: file.name,
            file: reader.result
          });
        };
        reader.onerror = function (error) {
          return reject(error);
        };
      });
    },
    onChange: function onChange() {
      var files = this.$refs.fileinput.files;
      if (files.length) {
        this.files = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.files), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files));
      }
    },
    fileRemove: function fileRemove(index) {
      this.files = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.files.slice(0, index)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.files.slice(index + 1)));
    }
  }),
  watch: {
    userData: {
      handler: 'userDataHandler',
      immediate: true
    }
  },
  created: function created() {
    var _this2 = this;

    this.getAnnouncements().then(function (data) {
      _this2.announcements = data || [];
    });
    this.getTicketsTypes();
  }
});

/***/ }),

/***/ "XCpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-key-stats-element",on:{"click":_vm.onClick}},[_c('div',{staticClass:"market-key-stats-element__title"},[_vm._v("\r\n    "+_vm._s(_vm.obj.title)+"\r\n  ")]),_vm._v(" "),_c('div',{staticClass:"market-key-stats-element__wrap market-key-stats-element__wrap--left"},[_c('div',{staticClass:"market-key-stats-element__center"},[_c('div',{staticClass:"market-key-stats-element__percent"},[_vm._v(_vm._s(Number(_vm.obj.valueA).toFixed(1))),_c('span',{staticClass:"market-key-stats-element__sign"},[_vm._v("%")])]),_vm._v(" "),(_vm.obj.valueAHasTrend)?_c('div',{staticClass:"market-key-stats-element__delta"},[_c('market-change-price',{attrs:{"price":_vm.obj.valueATrendPercentage,"percent":true}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"market-key-stats-element__sub-title"},[_vm._v(_vm._s(_vm.obj.valueASubtitle))])]),_vm._v(" "),_c('div',{staticClass:"market-key-stats-element__wrap market-key-stats-element__wrap--right"},[_c('div',{staticClass:"market-key-stats-element__center"},[_c('div',{staticClass:"market-key-stats-element__percent"},[_vm._v(_vm._s(Number(_vm.obj.valueB).toFixed(1))),_c('span',{staticClass:"market-key-stats-element__sign"},[_vm._v("%")])]),_vm._v(" "),(_vm.obj.valueBHasTrend)?_c('div',{staticClass:"market-key-stats-element__delta"},[_c('market-change-price',{attrs:{"price":_vm.obj.valueBTrendPercentage,"percent":true}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"market-key-stats-element__sub-title"},[_vm._v(_vm._s(_vm.obj.valueBSubtitle))])]),_vm._v(" "),_c('div',{staticClass:"market-key-stats-element__footer"},[(_vm.obj.urlData)?_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":_vm.obj.urlData},on:{"click":function($event){return $event.stopPropagation()}}},[_vm._v("\r\n      "+_vm._s(_vm.obj.source)+"\r\n    ")]):_c('a',{attrs:{"href":"#"}},[_vm._v("\r\n      "+_vm._s(_vm.obj.source)+"\r\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XFSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overview-map"},[(_vm.type === 'electoral')?_c('div',{staticClass:"overview-map__header"},[(_vm.isLayoutMobile)?[_vm._v("\r\n      Who will win the presidential election?\r\n    ")]:[_vm._v("\r\n      Presidential Election Winner?\r\n    ")]],2):_c('div',{staticClass:"overview-map__header"},[_vm._v("\r\n    Control of the Senate\r\n  ")]),_vm._v(" "),_c('div',{staticClass:"overview-map__content"},[(!_vm.isComponentReady)?[_c('div',{staticClass:"content-loader"},_vm._l((_vm.dummyComponents),function(index){return _c('div',{staticClass:"content-loader-item"},[_c('overview-map-loader')],1)}),0)]:_vm._l((_vm.items),function(item){return _c('overview-map-contract',{key:item.contractId,staticClass:"overview-map__content-contract",attrs:{"type":_vm.type,"item":item}})})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XMP4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableRowsLoader_vue__ = __webpack_require__("QWrq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eda171d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableRowsLoader_vue__ = __webpack_require__("+PRK");
function injectStyle (ssrContext) {
  __webpack_require__("SH6Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableRowsLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eda171d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableRowsLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XRns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XS8h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLink)?_c('a',{staticClass:"link link--regular",attrs:{"href":_vm.url}},[_vm._v("\r\n    "+_vm._s(_vm.text)+"\r\n  ")]):_vm._e(),_vm._v(" "),(_vm.isButton)?_c('a',{staticClass:"link link--button",attrs:{"href":_vm.url}},[_vm._v("\r\n    "+_vm._s(_vm.text)+"\r\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XSP/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INITIAL_MAX_CONTRACTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEqual__ = __webpack_require__("hygk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_market_detail_charts_container_container_vue__ = __webpack_require__("M8zO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_detail_charts_header_header_vue__ = __webpack_require__("4pyq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_market_market_detail_charts_table_table_vue__ = __webpack_require__("ZJhQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_market_market_detail_charts_timeline_timeline_vue__ = __webpack_require__("GebD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_market_market_contracts_stats_market_contracts_stats_vue__ = __webpack_require__("Y/q+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__("jPoG");





 /* eslint-disable */











// const YES_CONTRACT_TYPE = 'Yes';
// const NO_CONTRACT_TYPE = 'No';
// const NO_CONTRACT_LINE_COLOR = '#F27130';
var MARKET_SINGLE_CONTRACT_NAME = 'Closing Price';
var INITIAL_SHOW_CONTRACTS = 3;
var INITIAL_MAX_CONTRACTS = 6;

var CHART_TYPES = {
  LINE: 'line',
  CANDLE: 'candle'
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_loader__["a" /* default */]],
  props: {
    market: {
      type: Object,
      required: false
    },
    chartOptions: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    var contractIds = __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.chartOptions, 'contractIds', []) || [];
    return {
      hasMarketHiddenContracts: __WEBPACK_IMPORTED_MODULE_13__utils_helpers__["f" /* hasMarketHiddenContracts */],
      chartType: CHART_TYPES.LINE,
      preparedContractIds: null,
      toggled: false,
      disabledContracts: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(),
      chartShowContractsInitial: INITIAL_SHOW_CONTRACTS,
      chartMaxContracts: contractIds.length > 0 ? contractIds.length : INITIAL_MAX_CONTRACTS,
      chartTimeline: null,
      chartDataLoaded: false,
      chartData: [],
      originalChartData: [],
      showStats: false
    };
  },

  components: {
    chartsContainer: __WEBPACK_IMPORTED_MODULE_7__components_market_market_detail_charts_container_container_vue__["a" /* default */],
    chartsHeader: __WEBPACK_IMPORTED_MODULE_8__components_market_market_detail_charts_header_header_vue__["a" /* default */],
    chartsTable: __WEBPACK_IMPORTED_MODULE_9__components_market_market_detail_charts_table_table_vue__["a" /* default */],
    chartsTimeline: __WEBPACK_IMPORTED_MODULE_10__components_market_market_detail_charts_timeline_timeline_vue__["a" /* default */],
    marketContractsStats: __WEBPACK_IMPORTED_MODULE_11__components_market_market_contracts_stats_market_contracts_stats_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('market', ['marketContractsStats']), {
    title: function title() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.chartOptions, 'chartTitle', null);
    },
    caption: function caption() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.chartOptions, 'chartCaption', null);
    },
    chartContracts: function chartContracts() {
      var _this = this;

      var results = [];
      var contractIdDataGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["g" /* groupByKeepOrder */])(this.chartData, 'contractId');

      // show contracts that represent selected point on time on the chart
      contractIdDataGroup.forEach(function (data) {
        results.push(data[data.length - 1]);
      });
      return results.map(function (item) {
        var contract = _this.market.contracts.find(function (i) {
          return i.contractId === item.contractId;
        }) || {};
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
          contractImageUrl: contract.contractImageUrl,
          contractImageSmallUrl: contract.contractImageSmallUrl
        });
      });
    },
    leftToShowContracts: function leftToShowContracts() {
      if (this.market.contracts.length < INITIAL_MAX_CONTRACTS) {
        return 0;
      }
      return this.showChartsTable && this.market.contracts.length - this.chartMaxContracts;
    },
    showChartsTable: function showChartsTable() {
      var noChartOptionOrLegendOn = this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.chartOptions, 'includeLegend', false);
      return this.chartContracts.length > 1 && (this.isLayoutDesktop || this.toggled) && noChartOptionOrLegendOn;
    },
    showChartsKey: function showChartsKey() {
      return this.chartContracts.length > 1 && this.isLayoutMobile && !this.toggled && this.chartOptions === null;
    },
    filteredChartData: function filteredChartData() {
      return this.chartData.filter(function (el) {
        return el.checked;
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('chart', ['getMarketChartData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('market', ['getMarketContractsStats', 'clearMarketContractsStats']), {
    prepareDisabledContracts: function prepareDisabledContracts(data) {
      var _this2 = this;

      var results = [];
      var contractIdDataGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["g" /* groupByKeepOrder */])(data, 'contractId');
      // show contracts that represent selected point on time on the art
      contractIdDataGroup.forEach(function (groupData) {
        results.push(groupData[groupData.length - 1]);
      });
      results.forEach(function (el, index) {
        if (index >= _this2.chartShowContractsInitial) {
          _this2.disabledContracts.add(el.contractId);
        }
      });
    },
    prepareChartData: function prepareChartData(data) {
      var _this3 = this;

      var contracts = __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default()(data, function (el) {
        return el.contractId;
      });
      var contractIds = contracts.map(function (el) {
        return el.contractId;
      });
      var isYesNoMarket = contracts.length === 1;
      if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(contractIds, this.preparedContractIds)) {
        this.prepareDisabledContracts(data);
        this.preparedContractIds = contractIds;
      }

      data.forEach(function (el) {
        el.additional = false;
        el.checked = _this3.checkIsContractEnabled(el);
        el.chartPrice = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils__["a" /* regularContractPrice */])(el);

        if (isYesNoMarket) {
          el.contractName = MARKET_SINGLE_CONTRACT_NAME;
        }
      });

      return data;
    },
    checkIsContractEnabled: function checkIsContractEnabled(el) {
      return !this.disabledContracts.has(el.contractId);
    },
    loadStats: function loadStats() {
      var _this4 = this;

      this.loaderAdd();
      this.getMarketContractsStats(this.market.marketId).then(function () {
        return _this4.loaderRemove();
      }).catch(function () {
        return _this4.loaderRemove();
      });
    },
    loadChartData: function loadChartData(_ref) {
      var _this5 = this;

      var _ref$useOriginalData = _ref.useOriginalData,
          useOriginalData = _ref$useOriginalData === undefined ? false : _ref$useOriginalData;

      if (useOriginalData) {
        var data = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.originalChartData));
        this.chartData = this.prepareChartData(data);
      } else {
        var params = {
          marketId: this.market.marketId,
          maxContracts: this.chartMaxContracts,
          timespan: this.chartTimeline
        };
        var storyId = __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.chartOptions, 'cmsStoryId', null);
        if (storyId) {
          params.storyId = storyId;
          params.chartStoryVersionId = __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.chartOptions, 'cmsVersionId', null);
          params.chartIndex = __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.chartOptions, 'chartIndex', null);
          params.sectionType = __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.chartOptions, 'sectionType', null);
        }

        this.loaderAdd();
        this.getMarketChartData(params).then(function (data) {
          _this5.originalChartData = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
          _this5.chartData = _this5.prepareChartData(data);
          _this5.chartDataLoaded = true;
          _this5.loaderRemove();
        }).catch(function () {
          return _this5.loaderRemove();
        });
      }
    },
    onShowKey: function onShowKey() {
      this.toggled = true;
    },
    onTimelineChange: function onTimelineChange(timeline) {
      if (timeline === 'stats') {
        this.showStats = true;
        this.loadStats();
      } else {
        this.showStats = false;
        this.chartTimeline = timeline;
        this.loadChartData({});
      }
    },
    onTypeChange: function onTypeChange(type) {
      var _this6 = this;

      this.chartType = type;

      if (type === CHART_TYPES.CANDLE && this.chartData) {
        var contracts = __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default()(this.chartData, function (el) {
          return el.contractId;
        });
        var enabled = contracts.find(function (i) {
          return _this6.checkIsContractEnabled(i);
        }) || contracts[0];
        var contractIds = contracts.map(function (i) {
          return i.contractId;
        }).filter(function (i) {
          return i !== enabled.contractId;
        });
        this.disabledContracts = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(contractIds);
        this.loadChartData({ useOriginalData: true });
      }
    },
    onContractToggle: function onContractToggle(item, checked) {
      var contractId = item.contractId;
      // const contractsNum = Math.min(this.market.contracts.length, INITIAL_MAX_CONTRACTS);
      // const disabledContractsMaxSize = contractsNum;

      if (this.chartType === CHART_TYPES.CANDLE) {
        if (!checked) {
          this.disabledContracts.add(contractId);
        } else {
          var contractIds = __WEBPACK_IMPORTED_MODULE_3_lodash_uniqBy___default()(this.chartData, function (el) {
            return el.contractId;
          }).map(function (i) {
            return i.contractId;
          }).filter(function (i) {
            return i !== contractId;
          });
          this.disabledContracts = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(contractIds);
        }
      } else {
        if (!checked) {
          this.disabledContracts.add(contractId);
        } else {
          this.disabledContracts.delete(contractId);
        }
      }

      this.loadChartData({ useOriginalData: true });
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.clearMarketContractsStats();
  }
});

/***/ }),

/***/ "XWIj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_notifications_proxy__ = __webpack_require__("a0yF");








var BALANCE_DEFAULT = {
  accountBalance: '$0.00',
  accountBalanceDecimal: 0,
  portfolioBalance: '$0.00',
  portfolioBalanceDecimal: 0,
  shareValueDelta: '$0.00',
  shareValueDeltaDecimal: 0,
  isDefault: true
};

var DEFAULT_WIRE_SEARCH = {
  data: [],
  page: 0,
  totalCount: 0,
  canLoadMore: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    ach: {},
    check: {},
    wire: {},
    withdrawCoinbase: {},
    depositMethods: {},
    balance: BALANCE_DEFAULT,
    wireSearchResults: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(DEFAULT_WIRE_SEARCH),
    pendingRequests: [],
    pendingDepositsRequests: [],
    currentDeposit: {},
    firstDepositDone: __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get('firstDepositDone', false),
    bankTransferStep: {}
  },
  getters: {
    portfolioValueDecimal: function portfolioValueDecimal(state, getters, rotState, rootGetters) {
      var totalValue = state.balance.accountBalanceDecimal + state.balance.portfolioBalanceDecimal + rootGetters['dashboard/mySharesTotalGainLoss'];
      return Math.floor(totalValue * 100) / 100;
    },
    portfolioValue: function portfolioValue(state, getters) {
      var value = getters.portfolioValueDecimal.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return '$' + value;
    }
  },
  mutations: {
    setBalance: function setBalance(state, payload) {
      state.balance = payload;
    },
    setCurrentDeposit: function setCurrentDeposit(state, payload) {
      state.currentDeposit = payload;
    },
    setWire: function setWire(state, data) {
      state.wire = data;
    },
    setAch: function setAch(state, data) {
      state.ach = data;
    },
    setCheck: function setCheck(state, data) {
      state.check = data;
    },
    setWithdrawCoinbase: function setWithdrawCoinbase(state, data) {
      state.withdrawCoinbase = data;
    },
    setPendingRequests: function setPendingRequests(state, data) {
      state.pendingRequests = data;
    },
    setPendingDepositsRequests: function setPendingDepositsRequests(state, data) {
      state.pendingDepositsRequests = data;
    },
    updateBalanceFromNotification: function updateBalanceFromNotification(state, data) {
      state.balance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["D" /* updateObjectValues */])(state.balance, data, __WEBPACK_IMPORTED_MODULE_6__services_notifications_proxy__["o" /* ACCOUNT_FUNDS_MAP */]);
    },
    markFirstDepositDone: function markFirstDepositDone(state) {
      var expiresAt = 31536000; // 1 year
      __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].set('firstDepositDone', true, expiresAt);
      state.firstDepositDone = true;
    },
    setDepositMethods: function setDepositMethods(state, value) {
      state.depositMethods = value;
    },
    resetWireSearchResults: function resetWireSearchResults(state) {
      state.wireSearchResults = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(DEFAULT_WIRE_SEARCH);
    },
    setWireSearchResults: function setWireSearchResults(state, payload) {
      var sourceData = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.wireSearchResults.data));
      var data = sourceData.concat(payload.data.results || []);
      var page = payload.data.page;
      var totalCount = payload.data.totalResults;
      var canLoadMore = totalCount > data.length;

      state.wireSearchResults = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.wireSearchResults, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    setBankTransferStep: function setBankTransferStep(state, data) {
      state.bankTransferStep = data;
    }
  },
  actions: {
    clearBalance: function clearBalance(_ref) {
      var commit = _ref.commit;

      commit('setBalance', BALANCE_DEFAULT);
    },
    getBalance: function getBalance(_ref2) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getBalance().then(function (response) {
        commit('setBalance', response.data);
        return response.data;
      });
    },
    getDepositCard: function getDepositCard() {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getDepositCard().then(function (response) {
        return response.data;
      });
    },
    confirmDepositCard: function confirmDepositCard(_ref3, payload) {
      var commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postConfirmDepositCard(payload).then(function (response) {
        return response.data;
      });
    },
    submitDepositCard: function submitDepositCard(_ref4, payload) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postSubmitDepositCard(payload).then(function (response) {
        return response.data;
      });
    },
    submitDepositUSDCoin: function submitDepositUSDCoin(_ref5, payload) {
      var commit = _ref5.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postSubmitDepositUSDCoin(payload).then(function (response) {
        return response.data;
      });
    },
    setCurrentDeposit: function setCurrentDeposit(_ref6, value) {
      var commit = _ref6.commit;

      commit('setCurrentDeposit', value);
    },
    getPayNearMe: function getPayNearMe(_ref7, page) {
      var commit = _ref7.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getPayNearMe(page).then(function (response) {
        return response.data;
      });
    },
    getDepositUSDCoin: function getDepositUSDCoin() {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getDepositUSDCoin().then(function (response) {
        return response.data;
      });
    },
    resetWireSearchResults: function resetWireSearchResults(_ref8) {
      var commit = _ref8.commit;

      commit('resetWireSearchResults');
    },
    getWithdrawWireBankSearch: function getWithdrawWireBankSearch(_ref9, _ref10) {
      var state = _ref9.state,
          commit = _ref9.commit;
      var _ref10$query = _ref10.query,
          query = _ref10$query === undefined ? '' : _ref10$query;

      if (state.wireSearchResults.canLoadMore) {
        var page = state.wireSearchResults.page + 1;
        return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getWithdrawWireBankSearch(page, query).then(function (response) {
          commit('setWireSearchResults', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return null;
    },
    getWithdrawWire: function getWithdrawWire(_ref11) {
      var commit = _ref11.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getWithdrawWire().then(function (response) {
        commit('setWire', response.data);
        return response.data;
      });
    },
    getWithdrawAch: function getWithdrawAch(_ref12) {
      var commit = _ref12.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getWithdrawAch().then(function (response) {
        commit('setAch', response.data);
        return response.data;
      });
    },
    getWithdrawCheck: function getWithdrawCheck(_ref13) {
      var commit = _ref13.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getWithdrawCheck().then(function (response) {
        commit('setCheck', response.data);
        return response.data;
      });
    },
    getWithdrawCoinbase: function getWithdrawCoinbase(_ref14) {
      var commit = _ref14.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getWithdrawUSDC().then(function (response) {
        commit('setWithdrawCoinbase', response.data);
        return response.data;
      });
    },
    postWithdrawAch: function postWithdrawAch(_ref15, payload) {
      var dispatch = _ref15.dispatch;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postWithdrawAch(payload).then(function (response) {
        dispatch('getBalance');
        return response.data;
      });
    },
    postWithdrawCheck: function postWithdrawCheck(_ref16, payload) {
      var dispatch = _ref16.dispatch;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postWithdrawCheck(payload).then(function (response) {
        dispatch('getBalance');
        return response.data;
      });
    },
    postWithdrawCoinbase: function postWithdrawCoinbase(_ref17, payload) {
      var dispatch = _ref17.dispatch;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postWithdrawUSDC(payload).then(function (response) {
        dispatch('getBalance');
        return response.data;
      });
    },
    postWithdrawWireBankInfo: function postWithdrawWireBankInfo(_ref18, payload) {
      var dispatch = _ref18.dispatch;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postWithdrawWireBankInfo(payload).then(function (response) {
        return response.data;
      });
    },
    postWithdrawWireConfirm: function postWithdrawWireConfirm(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postWithdrawWireConfirm(payload).then(function (response) {
        return response.data;
      });
    },
    postWithdrawWireSubmit: function postWithdrawWireSubmit(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postWithdrawWireSubmit(payload).then(function (response) {
        return response.data;
      });
    },
    getPendingWithdrawals: function getPendingWithdrawals(_ref19) {
      var commit = _ref19.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getPendingWithdrawals().then(function (response) {
        commit('setPendingRequests', response.data);
        return response.data;
      });
    },
    getPendingDeposits: function getPendingDeposits(_ref20) {
      var commit = _ref20.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getPendingDeposits().then(function (response) {
        commit('setPendingDepositsRequests', response.data);
        return response.data;
      });
    },
    cancelWithdrawal: function cancelWithdrawal(_ref21, payload) {
      var dispatch = _ref21.dispatch;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postCancelWithdrawal(payload).then(function (response) {
        dispatch('getBalance');
        return response.data;
      });
    },
    updateBalanceFromNotification: function updateBalanceFromNotification(_ref22, payload) {
      var commit = _ref22.commit;

      commit('updateBalanceFromNotification', payload);
    },
    getDepositMethods: function getDepositMethods(_ref23) {
      var commit = _ref23.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getDepositMethods().then(function (response) {
        var data = response.data;
        commit('setDepositMethods', data);
        return data;
      });
    },
    getWithdrawalMethods: function getWithdrawalMethods() {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getWithdrawalMethods().then(function (response) {
        return response.data;
      });
    },
    markFirstDepositDone: function markFirstDepositDone(_ref24) {
      var commit = _ref24.commit;

      commit('markFirstDepositDone');
    },
    getDepositPWMB: function getDepositPWMB(_) {
      var _ref25 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref25$authorizationI = _ref25.authorizationId,
          authorizationId = _ref25$authorizationI === undefined ? '' : _ref25$authorizationI,
          _ref25$returnUrl = _ref25.returnUrl,
          returnUrl = _ref25$returnUrl === undefined ? '' : _ref25$returnUrl,
          _ref25$cancelUrl = _ref25.cancelUrl,
          cancelUrl = _ref25$cancelUrl === undefined ? '' : _ref25$cancelUrl;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getDepositPWMB({ authorizationId: authorizationId, returnUrl: returnUrl, cancelUrl: cancelUrl }).then(function (response) {
        return response.data;
      });
    },
    deletePWMBAccount: function deletePWMBAccount(_, authorizationId) {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.deletePWMBAuthorization(authorizationId).then(function (response) {
        return response.data;
      });
    },
    confirmDepositPWMB: function confirmDepositPWMB(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postConfirmDepositPWMB(payload).then(function (response) {
        return response.data;
      });
    },
    submitDepositPWMB: function submitDepositPWMB(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postSubmitDepositPWMB(payload).then(function (response) {
        return response.data;
      });
    },
    getPWMBAuthorization: function getPWMBAuthorization() {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.getPWMBAuthorization().then(function (response) {
        return response.data;
      });
    },
    setBankTransferStep: function setBankTransferStep(_ref26, data) {
      var commit = _ref26.commit;

      commit('setBankTransferStep', data);
    },
    submitInstantCredit: function submitInstantCredit(_, promoCodeText) {
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].wallet.postInstantCredit({ promoCodeText: promoCodeText }).then(function (response) {
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "XXB4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"app-privacy-statement"},[_c('div',{staticClass:"app-privacy-statement__inner"},[_c('div',{staticClass:"app-privacy-statement__close",on:{"click":_vm.onHide}}),_vm._v(" "),_c('div',{staticClass:"app-privacy-statement__info"},[_vm._v("\n      "+_vm._s(_vm.$txt('app-privacy-statement.info'))+" "),_c('router-link',{staticClass:"app-privacy-statement__link",attrs:{"to":{ name: 'privacy-policy' }}},[_vm._v("Privacy Policy")]),_vm._v(".\n    ")],1),_vm._v(" "),_c('div',{staticClass:"app-privacy-statement__agree"},[_c('button',{staticClass:"button button--primary",on:{"click":_vm.onAgree}},[_vm._v("\n        "+_vm._s(_vm.$txt('app-privacy-statement.button'))+"\n      ")])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xc0v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XiHx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ach"},[(!_vm.isComponentReady)?_c('account-form-loader',{attrs:{"theme":"withdraw"}}):[(!_vm.showConfirmation)?_c('div',[(_vm.documentUploadInfoVisible)?_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending}}):[(!_vm.hasErrorMessage)?[_c('alert-box',{attrs:{"level":"warning"}},[_vm._v("\n          Withdrawing funds may cause some or all of your open offers to be cancelled.\n        ")]),_vm._v(" "),_c('form',{staticClass:"form ach__form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('available-balance',{attrs:{"restricted":_vm.restrictedFunds,"balance":_vm.availableBalance}}),_vm._v(" "),(_vm.newAccountMode)?_c('div',[_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"theme":"amount","name":"amount","validation":_vm.$v.fields.amount,"disabled":_vm.isAmountFieldDisabled,"autocomplete":"","placeholder":"Withdrawal Amount (Minimum $1 USD)"},on:{"input":_vm.$v.fields.amount.$touch},model:{value:(_vm.fields.amount),callback:function ($$v) {_vm.$set(_vm.fields, "amount", $$v)},expression:"fields.amount"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-6"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.routingNumber,"name":"routingNumber","type":"text","required":true,"disabled":_vm.hasErrorMessage,"autocomplete":"","placeholder":"Routing Number"},on:{"input":_vm.$v.fields.routingNumber.$touch},model:{value:(_vm.fields.routingNumber),callback:function ($$v) {_vm.$set(_vm.fields, "routingNumber", $$v)},expression:"fields.routingNumber"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.accountNumber,"name":"accountNumber","type":"text","required":true,"disabled":_vm.hasErrorMessage,"autocomplete":"","placeholder":"Account Number"},on:{"input":_vm.$v.fields.accountNumber.$touch},model:{value:(_vm.fields.accountNumber),callback:function ($$v) {_vm.$set(_vm.fields, "accountNumber", $$v)},expression:"fields.accountNumber"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('notification-icon',{attrs:{"text":"Where can I find this information?"},on:{"showPopup":_vm.showRoutingNumberModal}})],1)]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--left"},[_vm._v("Account Type")])])]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},_vm._l((_vm.accountTypes),function(item){return _c('form-radio',{key:item.index,staticClass:"ach__radio",attrs:{"name":"accountType","label":item.label,"value":item.index,"required":true,"disabled":_vm.hasErrorMessage},model:{value:(_vm.fields.accountType),callback:function ($$v) {_vm.$set(_vm.fields, "accountType", $$v)},expression:"fields.accountType"}})}),1)])]):_c('div',[_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"theme":"amount","validation":_vm.$v.fields.amount,"disabled":_vm.isAmountFieldDisabled,"name":"amount","autocomplete":"","placeholder":"Withdrawal Amount (Minimum $1 USD)"},on:{"input":_vm.$v.fields.amount.$touch},model:{value:(_vm.fields.amount),callback:function ($$v) {_vm.$set(_vm.fields, "amount", $$v)},expression:"fields.amount"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-7"},[_c('div',{staticClass:"ach__account-note"},[_vm._v("\n                  Your withdrawal will be sent to your bank account ending in\n                  "),_c('strong',[_vm._v("*******"+_vm._s(_vm.ach.achAccountNumberLastFour))])])]),_vm._v(" "),_c('div',{staticClass:"column small-5"},[_c('span',{staticClass:"ach__change",on:{"click":function($event){$event.preventDefault();return _vm.onChangeAccount($event)}}},[_vm._v("\n                  Change\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-submit',{attrs:{"disabled":_vm.invalidOrDisabled,"label":"Review Request"}})],1)])],1)]:_vm._e(),_vm._v(" "),(_vm.hasErrorMessage)?_c('alert-box',{attrs:{"level":"warning"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]):_vm._e(),_vm._v(" "),(!_vm.hasErrorMessage)?[_c('p',{staticClass:"ach__disclaimer"},[_vm._v("\n          Your banking information will be saved in a secure environment.\n          PredictIt can store information on only one bank account at a time.\n        ")]),_vm._v(" "),_c('p',{staticClass:"ach__disclaimer"},[_vm._v("\n          We remit funds via ACH only to verified account holders with US bank accounts. Withdrawals are subject to a 5% fee and are typically processed twice per week. If authorized, funds should be deposited to your bank account within five business days.\n        ")])]:_vm._e()]],2):_vm._e(),_vm._v(" "),(_vm.showConfirmation)?_c('withdraw-confirm',{staticClass:"withdraw-confirm--with-margin",attrs:{"kind":"ach","amendAvailable":true,"amount":Number(_vm.fields.amount),"fee":Number(_vm.fields.amount) * Number(_vm.ach.feePercent),"accountDetails":_vm.accountDetails},on:{"edit":_vm.onEdit,"success":_vm.onSuccess}}):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XiJB":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "XqpO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_biggest_gains_js__ = __webpack_require__("HzXs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01feb709_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_biggest_gains_vue__ = __webpack_require__("QLzg");
function injectStyle (ssrContext) {
  __webpack_require__("QLqa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_biggest_gains_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01feb709_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_biggest_gains_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XrgL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "XxaH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amount-info"},[_c('div',{staticClass:"content-header__section-group"},[_c('div',{staticClass:"content-header__section"},[_c('div',{staticClass:"content-header__section--left"},[(_vm.isDeposit)?_c('span',[_vm._v("\n          Deposited Amount\n        ")]):_c('span',[_vm._v("\n          Requested Amount\n        ")])]),_vm._v(" "),_c('div',{staticClass:"amount-info__requested"},[_vm._v("\n        $"+_vm._s(_vm.amount.toFixed(2))+"\n      ")])]),_vm._v(" "),(!_vm.isBankTransfer)?_c('div',{staticClass:"content-header__section"},[_c('div',{staticClass:"content-header__section--left"},[(_vm.isDeposit)?_c('span',[_vm._v("\n          Fees\n        ")]):_c('span',[_vm._v("\n          Fee\n        ")])]),_vm._v(" "),_c('div',{staticClass:"amount-info__fee"},[_vm._v("\n        ($"+_vm._s(_vm.feeRounded.toFixed(2))+")\n      ")])]):[_c('div',{staticClass:"content-header__section"},[_c('div',{staticClass:"content-header__section--left"},[_vm._v("\n          Bank Transfer Fee\n        ")]),_vm._v(" "),_c('div',{staticClass:"amount-info__fee"},[_vm._v("\n          ($"+_vm._s(_vm.flatFeeAmountRounded.toFixed(2))+")\n        ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section"},[_c('div',{staticClass:"content-header__section--left"},[_vm._v("\n          Processing Fee\n        ")]),_vm._v(" "),_c('div',{staticClass:"amount-info__fee"},[_vm._v("\n          ($"+_vm._s(_vm.percentageFeeAmountRounded.toFixed(2))+")\n        ")])])],_vm._v(" "),(!_vm.isDeposit)?_c('div',{staticClass:"content-header__section"},[_c('div',{staticClass:"content-header__section--left"},[_vm._v("\n        Net Withdrawal\n      ")]),_vm._v(" "),_c('div',{staticClass:"amount-info__total"},[_vm._v("\n        $"+_vm._s(_vm.totalRounded.toFixed(2))+"\n      ")])]):_vm._e(),_vm._v(" "),_vm._t("extra-section")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XzHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__ = __webpack_require__("vJzj");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["b" /* formMixin */]],
  data: function data() {
    return {
      statement: '',
      mandatoryStatement: '',
      fields: {
        taxId: '',
        zipCode: '',
        stateCode: '',
        city: '',
        address: '',
        name: ''
      }
    };
  },

  validations: {
    fields: {
      taxId: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].taxId,
      zipCode: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].required,
      stateCode: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].required,
      city: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].required,
      address: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].required,
      name: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].required
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['systemEmails'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['getTaxInfo', 'postTaxInfo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['setMandatoryTaxNotification']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotification']), {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formIsValid() && this.formDisable()) {
        var payload = {
          taxId: this.fields.taxId,
          zipCode: this.fields.zipCode,
          stateCode: this.fields.stateCode,
          city: this.fields.city,
          address1: this.fields.address,
          name: this.fields.name
        };
        this.postTaxInfo(payload).then(function (data) {
          _this.setCurrentPopup();
          _this.setSuccessSideNotification(data.message);
        }).catch(function (error) {
          return _this.formHandleErrors(error);
        });
      }
    }
  }),
  created: function created() {
    var _this2 = this;

    var reasonCode = this.$route.query.reason || '';
    this.getTaxInfo({ reasonCode: reasonCode }).then(function (data) {
      _this2.setMandatoryTaxNotification(data.isMandatory);
      _this2.fields.address = data.address1;
      _this2.fields.city = data.city;
      _this2.fields.name = data.name;
      _this2.fields.zipCode = data.zipCode;
      _this2.fields.stateCode = data.stateCode;
      _this2.mandatoryStatement = data.mandatoryStatement;
      _this2.statement = data.statement;
    });
  }
});

/***/ }),

/***/ "Y+KT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("oiih");


var MODAL_OPEN_CLASS = 'modal-open';

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    bodyClass: {
      type: String,
      default: ''
    },
    headerClass: {
      type: String,
      default: ''
    },
    closeButtonClass: {
      type: String,
      default: ''
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    clickOutsideEnabled: {
      type: Boolean,
      default: false
    },
    gtm: [String, Object],
    fullScreen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasHeader: function hasHeader() {
      return !!this.$slots.header;
    },
    hasFooter: function hasFooter() {
      return !!this.$slots.footer;
    },
    classModifier: function classModifier() {
      return {
        'modal__content--full': this.fullScreen,
        'modal__content--with-footer': this.hasFooter,
        'modal__content--no-padding': this.noPadding
      };
    }
  },
  methods: {
    close: function close() {
      if (this.gtm && this.gtm.closing) {
        this.$gtm.trackEvent(this.gtm.closing);
      }
      this.$emit('modalClose');
    },
    onClickOutside: function onClickOutside() {
      if (this.clickOutsideEnabled) this.close();
    },
    afterEnter: function afterEnter() {
      if (__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].POPUP_OVERFLOW_MODE) {
        setTimeout(function () {
          return window.scrollTo(0, 0);
        }, 0);
      }
    }
  },
  created: function created() {
    document.documentElement.classList.add(MODAL_OPEN_CLASS);
    document.body.classList.add(MODAL_OPEN_CLASS);
    if (this.gtm) {
      var name = this.gtm.virtualPage || (typeof this.gtm === 'string' ? this.gtm : this.gtm.name);
      var virtualPage = this.gtm.virtualPage ? name : this.$route.path + '/' + name;

      if (virtualPage) {
        this.$gtm.trackEvent({
          event: 'pageviewTrackerEvent',
          virtualPage: virtualPage,
          virtualPageTitle: 'modal/' + name
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.gtm && this.$route && this.$route.fullPath) {
      this.$gtm.trackEvent({
        event: 'pageviewTrackerEvent',
        virtualPage: this.$route.fullPath,
        virtualPageTitle: this.$route.name,
        closing: this.gtm
      });
    }
    document.documentElement.classList.remove(MODAL_OPEN_CLASS);
    document.body.classList.remove(MODAL_OPEN_CLASS);
  }
});

/***/ }),

/***/ "Y/q+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_stats_js__ = __webpack_require__("ZllZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5b3515e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_stats_vue__ = __webpack_require__("fUX9");
function injectStyle (ssrContext) {
  __webpack_require__("zJxP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contracts_stats_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5b3515e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contracts_stats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y4EP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    href: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    subtitle: {
      type: String
    },
    isDark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    darkModifier: function darkModifier() {
      return {
        'link-tile--dark': this.isDark
      };
    },
    titleModifier: function titleModifier() {
      return {
        'link-tile__content-title--big': !this.subtitle
      };
    }
  }
});

/***/ }),

/***/ "Y6Bb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_enable_classic_predictit_js__ = __webpack_require__("mskH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba963774_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_enable_classic_predictit_vue__ = __webpack_require__("hZuO");
function injectStyle (ssrContext) {
  __webpack_require__("z52E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_enable_classic_predictit_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba963774_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_enable_classic_predictit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y7WP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_external_nav_js__ = __webpack_require__("fxl/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b708ffb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_external_nav_vue__ = __webpack_require__("6L/K");
function injectStyle (ssrContext) {
  __webpack_require__("yy50")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_external_nav_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b708ffb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_external_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YCiF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_settings_js__ = __webpack_require__("oo9H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa11ea48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__ = __webpack_require__("kcHx");
function injectStyle (ssrContext) {
  __webpack_require__("/z0E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_settings_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa11ea48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YHd0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_overview_map_contract_js__ = __webpack_require__("E5wa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59f7d90e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overview_map_contract_vue__ = __webpack_require__("8sqq");
function injectStyle (ssrContext) {
  __webpack_require__("pWll")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_overview_map_contract_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59f7d90e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overview_map_contract_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YYg9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YYzZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help-and-support"},[_c('div',{class:_vm.mainRowModifiers},[_c('div',{staticClass:"column small-12"},[(_vm.isLayoutMobile)?_c('content-header',{attrs:{"showCloseButton":_vm.isLoggedIn,"returnRoute":"profile","title":_vm.title}}):_c('div',{staticClass:"help-and-support__desktop-header"},[_vm._v(_vm._s(_vm.title))])],1),_vm._v(" "),_c('div',{class:_vm.mainColumnModifiers},[_c('div',{staticClass:"help-and-support__content"},[_vm._l((_vm.items),function(item){return _c('link-tile',{key:item.title,staticClass:"help-and-support__tile",attrs:{"href":item.href,"title":item.title,"icon":item.icon,"subtitle":item.subtitle}})}),_vm._v(" "),_c('router-view')],2),_vm._v(" "),(_vm.announcements.length > 0)?[_c('p',{staticClass:"help-and-support__contact-us"},[_vm._v("Announcements")]),_vm._v(" "),_c('div',{staticClass:"help-and-support__announcements-content"},[_c('ul',{staticClass:"help-and-support__announcements-list"},_vm._l((_vm.announcements),function(announcement){return _c('li',{key:announcement.announcementId,staticClass:"help-and-support__announcement"},[_c('span',{domProps:{"innerHTML":_vm._s(announcement.title)}}),_vm._v(" "),(!!announcement.body)?_c('span',{staticClass:"help-and-support__announcements-link",on:{"click":function($event){return _vm.showAnnouncement(announcement)}}},[_vm._v("(Details)")]):_vm._e()])}),0)])]:_vm._e(),_vm._v(" "),_c('p',{staticClass:"help-and-support__contact-us"},[_vm._v("Contact Us")]),_vm._v(" "),_c('div',{staticClass:"help-and-support__form-box"},[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{ref:"fileuploadform",attrs:{"method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('form-input',{staticClass:"help-and-support__email",attrs:{"disabled":_vm.isFormDisabled,"required":true,"validation":_vm.$v.fields.email,"autocomplete":"off","name":"help-input","placeholder":"Email","type":"email"},on:{"input":_vm.$v.fields.email.$touch},model:{value:(_vm.fields.email),callback:function ($$v) {_vm.$set(_vm.fields, "email", $$v)},expression:"fields.email"}}),_vm._v(" "),_c('form-select',{staticClass:"help-and-support__subject",attrs:{"searchable":false,"maxHeight":300,"adjust":false,"disabled":_vm.isFormDisabled,"options":_vm.subjectOptions,"required":true,"label":"label","placeholder":"Subject","track-by":"value"},on:{"input":_vm.$v.fields.subject.$touch},model:{value:(_vm.fields.subject),callback:function ($$v) {_vm.$set(_vm.fields, "subject", $$v)},expression:"fields.subject"}}),_vm._v(" "),_c('form-textarea',{staticClass:"help-and-support__message",attrs:{"required":_vm.messageRequired,"name":"help-message","placeholder":_vm.messagePlaceholder},model:{value:(_vm.fields.message),callback:function ($$v) {_vm.$set(_vm.fields, "message", $$v)},expression:"fields.message"}}),_vm._v(" "),_c('input',{ref:"fileinput",staticClass:"help-and-support__file",attrs:{"type":"file","multiple":"multiple"},on:{"change":_vm.onChange}}),_vm._v(" "),_c('div',{staticClass:"help-and-support__footer"},[(_vm.isUploadEnabled)?_c('button',{staticClass:"help-and-support__button help-and-support__upload",attrs:{"disabled":_vm.isFormDisabled,"name":"upload-button","type":"button"},on:{"click":_vm.onUpload}},[_vm._v("\r\n              Upload\r\n            ")]):_vm._e(),_vm._v(" "),(false)?_c('p',{staticClass:"help-and-support__press"},[_vm._v("For market suggestions, please email:"),_c('br'),_vm._v(" "),_c('a',{staticClass:"help-and-support__press-link",attrs:{"href":("mailto:" + (_vm.systemEmails.markets))}},[_vm._v(_vm._s(_vm.systemEmails.markets))])]):_vm._e()]),_vm._v(" "),(_vm.files.length > 0)?_c('ul',{staticClass:"help-and-support__files"},[_vm._l((_vm.files),function(file,index){return [_c('li',[_vm._v(_vm._s(file.name)+" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.fileRemove(index)}}},[_vm._v("(Remove)")])])]})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"help-and-support__footer"},[_c('button',{staticClass:"help-and-support__button help-and-support__submit",attrs:{"type":"submit","disabled":_vm.invalidOrDisabled,"name":"help-button"}},[_vm._v("Send")]),_vm._v(" "),_c('p',{staticClass:"help-and-support__press"},[_vm._v("For press inquiries, please contact:"),_c('br'),_vm._v(" "),_c('a',{staticClass:"help-and-support__press-link",attrs:{"href":("mailto:" + (_vm.systemEmails.press))}},[_vm._v(_vm._s(_vm.systemEmails.press))])])])],1)],1)],2),_vm._v(" "),(_vm.showVideos)?_c('div',{staticClass:"column large-4"},[_c('videos',{staticClass:"help-and-support__videos",attrs:{"asWidget":true}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YZ+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");





var Contract = function () {
  function Contract(params) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Contract);

    var getters = ['lastTradePriceAsCents', 'lastClosePriceAsCents', 'changePriceAsCents', 'userAveragePricePerShareAsCents', 'userChangePriceAsCents', 'buyYesCostAsCents', 'buyNoCostAsCents', 'sellYesCostAsCents', 'sellNoCostAsCents', 'userOpenOrders', 'mode'];
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
      if (getters.indexOf(key) < 0) {
        // to avoid setter exception
        _this[key] = params[key];
      }
    });
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Contract, [{
    key: 'lastTradePriceAsCents',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* toCents */])(this.lastTradePrice);
    }
  }, {
    key: 'lastClosePriceAsCents',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* toCents */])(this.lastClosePrice);
    }
  }, {
    key: 'changePriceAsCents',
    get: function get() {
      return this.lastTradePriceAsCents - this.lastClosePriceAsCents;
    }
  }, {
    key: 'userAveragePricePerShareAsCents',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* toCents */])(this.userAveragePricePerShare);
    }
  }, {
    key: 'userChangePriceAsCents',
    get: function get() {
      var roundedAverage = Math.round(this.userAveragePricePerShare * 100) / 100;
      if (this.mode === 'no') {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* toCents */])(1 - this.lastTradePrice - roundedAverage);
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* toCents */])(this.lastTradePrice - roundedAverage);
    }
  }, {
    key: 'buyYesCostAsCents',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["k" /* correctPrice */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* toCents */])(this.bestYesPrice || this.bestYesCost));
    }
  }, {
    key: 'buyNoCostAsCents',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["k" /* correctPrice */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* toCents */])(this.bestNoPrice || this.bestNoCost));
    }
  }, {
    key: 'sellYesCostAsCents',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["k" /* correctPrice */])(100 - this.buyNoCostAsCents);
    }
  }, {
    key: 'sellNoCostAsCents',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["k" /* correctPrice */])(100 - this.buyYesCostAsCents);
    }
  }, {
    key: 'userOpenOrders',
    get: function get() {
      return this.userOpenOrdersBuyQuantity + this.userOpenOrdersSellQuantity;
    }
  }, {
    key: 'mode',
    get: function get() {
      if (this.userQuantity === 0 && this.userOpenOrders === 0) return '';
      if (this.userPrediction === 0) return 'no';
      if (this.userPrediction === 1) return 'yes';
      return '';
    }
  }]);

  return Contract;
}();

/* harmony default export */ __webpack_exports__["a"] = (Contract);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_routes__ = __webpack_require__("KWv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_sessionVars__ = __webpack_require__("DECz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
 /* eslint-disable arrow-body-style, max-len */










var DISABLE_RESTRICTED_ACCESS_ROUTES = ['disqus-auth', 'social-auth', 'home'];

var DISABLE_CHECK_CLASSICS_ACCESS_ROUTES = ['terms-and-conditions'];

var DISABLE_SCROLL_TOP_ROUTE_PATHS = ['/markets/0'];

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var RouterInstance = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  base: "/",
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to && (DISABLE_SCROLL_TOP_ROUTE_PATHS.includes(to.path) || __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(to, 'params.dontReload', false))) {
      return null;
    }
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },

  routes: __WEBPACK_IMPORTED_MODULE_4__router_routes__["a" /* default */]
});

RouterInstance.beforeEach(function (to, from, next) {
  if (from && from.name && from.fullPath) {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('app/setPreviousRoute', from.fullPath);
  }
  if (__WEBPACK_IMPORTED_MODULE_6__mixins_userAgent__["f" /* isStandalone */] && from.name && to.name && to.fullPath) {
    var expiresAt = 31536000;
    __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].set('currentRoutePath', to.fullPath, expiresAt);
  }

  var shouldCheckAccess = function shouldCheckAccess() {
    return false && !DISABLE_RESTRICTED_ACCESS_ROUTES.includes(to.name) || to.matched.some(function (record) {
      return record.meta.requiresAuth;
    });
  };

  var shouldCheckAnonymous = function shouldCheckAnonymous() {
    return to.matched.some(function (record) {
      return record.meta.requiresAnonymous;
    });
  };

  var shouldCheckClassicsEnabled = function shouldCheckClassicsEnabled() {
    return !DISABLE_CHECK_CLASSICS_ACCESS_ROUTES.includes(to.name);
  };

  var serverApiVersion = parseInt(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.app.serverVersion || 0, 10);
  var initialApiVersion = parseInt(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.app.initialVersion || 0, 10);

  if (serverApiVersion && initialApiVersion && serverApiVersion > initialApiVersion) {
    window.location.reload();
  }

  var hasClassicsNotEnabled = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.user.status.isClassicEnabled === false;

  if (shouldCheckAccess()) {
    if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['user/isLoggedIn'] === false) {
      next({
        name: 'home',
        query: { redirect: to.fullPath }
      });
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
    } else if (hasClassicsNotEnabled) {
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC).then(function () {
        return next();
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('popup/setCurrentPopup').then(function () {
        return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('popup/setCurrentSmallPopup');
      }).then(function () {
        return next();
      });
    }
  } else if (shouldCheckAnonymous()) {
    if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters['user/isLoggedIn'] === true) {
      next({ name: 'home' });
    } else {
      next();
    }
  } else if (shouldCheckClassicsEnabled()) {
    if (hasClassicsNotEnabled) {
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('popup/setCurrentPopup', __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC).then(function () {
        return next();
      });
    } else {
      next();
    }
  } else {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('popup/setCurrentPopup').then(function () {
      return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('popup/setCurrentSmallPopup');
    }).then(function () {
      return next();
    });
  }
});

RouterInstance.afterEach(function (to) {
  __WEBPACK_IMPORTED_MODULE_7__helpers_sessionVars__["a" /* default */].check(to);
  window.dataLayer = window.dataLayer || [];
  if (to && to.fullPath) {
    window.dataLayer.push({
      event: 'pageviewTrackerEvent',
      virtualPage: to.fullPath,
      virtualPageTitle: to.name
    });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterInstance);

/***/ }),

/***/ "YfnU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_toolbar_js__ = __webpack_require__("Qe7J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50a561ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_toolbar_vue__ = __webpack_require__("4+3v");
function injectStyle (ssrContext) {
  __webpack_require__("bOvU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_toolbar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50a561ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_toolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ykf8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_daily_markets_details_js__ = __webpack_require__("KfAn");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_daily_markets_details_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0050ef0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_daily_markets_details_vue__ = __webpack_require__("zc3X");
function injectStyle (ssrContext) {
  __webpack_require__("ISj0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_daily_markets_details_js__["b" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0050ef0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_daily_markets_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["b"] = (Component.exports);


/***/ }),

/***/ "Ym4l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_forms_input_input_vue__ = __webpack_require__("UWgA");


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    formInput: __WEBPACK_IMPORTED_MODULE_0__components_forms_input_input_vue__["a" /* default */]
  },
  data: function data() {
    return {
      search: ''
    };
  }
});

/***/ }),

/***/ "YpG9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yph/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YyHL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yz9l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z/tr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__ = __webpack_require__("SqSL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a015af9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("gMF1");
function injectStyle (ssrContext) {
  __webpack_require__("DiJc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a015af9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z05w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_how_it_works_js__ = __webpack_require__("8KbT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e669f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_how_it_works_vue__ = __webpack_require__("EI6j");
function injectStyle (ssrContext) {
  __webpack_require__("+6ap")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_how_it_works_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e669f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_how_it_works_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z4oj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE5IDE3Ij4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8cGF0aCBkPSJNMS4xNiA2Ljg2M2gzLjEzOXY2LjYwMUgxLjE2ek0xNC42OTEgMTAuMjc0aDMuMTM5djMuMTkxaC0zLjEzOXoiLz4NCiAgICAgICAgPHBhdGggZmlsbD0iIzY3OTk5RiIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMTguNDEgMTUuODE0SC41OGMtLjMyIDAtLjU4LjI2NC0uNTguNTkgMCAuMzI1LjI2LjU4OS41OC41ODloMTcuODNjLjMyIDAgLjU4LS4yNjQuNTgtLjU5IDAtLjMyNS0uMjYtLjU5LS41OC0uNTl6TTE4LjQxIDkuMDk1aC00LjNjLS4zMiAwLS41OC4yNjQtLjU4LjU5djQuMzdjMCAuMzI1LjI2LjU4OS41OC41ODloNC4zYy4zMiAwIC41OC0uMjY0LjU4LS41OXYtNC4zN2MwLS4zMjUtLjI2LS41OS0uNTgtLjU5em0tLjU4IDQuMzdoLTMuMTR2LTMuMTkxaDMuMTR2My4xOXpNLjU4IDE0LjY0NGg0LjNjLjMyIDAgLjU4LS4yNjQuNTgtLjU5di03Ljc4YzAtLjMyNi0uMjYtLjU5LS41OC0uNTlILjU4Yy0uMzIgMC0uNTguMjY0LS41OC41OXY3Ljc4YzAgLjMyNi4yNi41OS41OC41OXptLjU4LTcuNzhINC4zdjYuNkgxLjE2di02LjZ6TTcuMzQ1IDE0LjY0NGg0LjNjLjMyIDAgLjU4LS4yNjQuNTgtLjU5Vi42MzZjMC0uMzI1LS4yNi0uNTktLjU4LS41OWgtNC4zYy0uMzIgMC0uNTguMjY1LS41OC41OXYxMy40MThjMCAuMzI2LjI2LjU5LjU4LjU5em0uNTgtMTMuNDE4aDMuMTR2MTIuMjM5aC0zLjE0VjEuMjI1eiIvPg0KICAgIDwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "ZC+n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BiggestGainsLoader_vue__ = __webpack_require__("tV9q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f19feae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BiggestGainsLoader_vue__ = __webpack_require__("PlD9");
function injectStyle (ssrContext) {
  __webpack_require__("Vd78")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BiggestGainsLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f19feae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BiggestGainsLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZDdF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications-list"},[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader content-loader--dashboard-notifications"},[_c('notification-loader'),_vm._v(" "),_c('notification-loader'),_vm._v(" "),_c('notification-loader')],1):[_c('div',{staticClass:"notifications-list__content"},[_vm._l((_vm.items),function(notification,index){return _c('notification-item-dashboard',{key:notification.notificationId,staticClass:"notifications-list__item",attrs:{"theme":_vm.theme,"showTimeElapsed":true,"index":index,"data":notification}})}),_vm._v(" "),(_vm.isScrollMore)?_c('div',{staticClass:"notifications-list__scroll-down"},[_vm._v("Scroll down for more notifications")]):_vm._e(),_vm._v(" "),(_vm.showInfiniteLoading)?_c('infinite-loading',{attrs:{"distance":150},on:{"infinite":_vm.goInfinite}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('div',{staticClass:"notifications-list__spinner"})]),_vm._v(" "),_c('span',{attrs:{"slot":"no-results"},slot:"no-results"}),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})]):_vm._e()],2),_vm._v(" "),(_vm.notificationsCount === 0)?_c('div',{staticClass:"notifications-list__footer-no-notifications"},[_vm._v("\n      There are no notifications to display\n    ")]):_vm._e(),_vm._v(" "),(_vm.limit !== null && _vm.notificationsCount > 0)?_c('div',{staticClass:"notifications-list__link",on:{"click":_vm.onSeeAllClick}},[_vm._v("\n      See All Notifications\n    ")]):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZFw9":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "ZIhC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_faq_js__ = __webpack_require__("4RI/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25b543d3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faq_vue__ = __webpack_require__("waSD");
function injectStyle (ssrContext) {
  __webpack_require__("k2oC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_faq_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25b543d3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZJhQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_table_js__ = __webpack_require__("Oz+7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d5f1011_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_vue__ = __webpack_require__("Cn7X");
function injectStyle (ssrContext) {
  __webpack_require__("qyUj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_table_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d5f1011_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZMD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_export_history_state_button_state_button_vue__ = __webpack_require__("JOj2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__("XILU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);







var DATE_FORMAT = 'MM/DD/YYYY';
var DATE_FORMAT_API = 'MM-DD-YYYY';
var KIND_TRADE = 'trade';
var KIND_TRANSACTION = 'transaction';

function dateFormatter(date) {
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format(DATE_FORMAT);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    stateButton: __WEBPACK_IMPORTED_MODULE_4__components_export_history_state_button_state_button_vue__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a
  },
  props: {
    kind: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      dateFormatter: dateFormatter,
      disabled: {
        from: null
      },
      selected: {
        l30d: false,
        l3m: false,
        ytd: false
      },
      dates: {},
      dateFrom: {
        date: null
      },
      dateTo: {
        date: null
      },
      openCalendar: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('market', ['market']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('overlay', ['visible']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['token']), {
    formAction: function formAction() {
      switch (this.kind) {
        case KIND_TRANSACTION:
          return "/Resource/DownloadWalletHistory";
        case KIND_TRADE:
          return "/Resource/DownloadTradeHistory";
        default:
          return '';
      }
    },
    marketId: function marketId() {
      if (this.$route.params.marketId && this.$route.params.marketId !== 'all') {
        return this.$route.params.marketId;
      }
      return null;
    },
    contractId: function contractId() {
      if (this.$route.query) {
        return this.$route.query.contractId;
      }
      return null;
    },
    contractName: function contractName() {
      var _this = this;

      if (this.contractId) {
        var contract = this.market.contracts.find(function (i) {
          return i.contractId === _this.contractId;
        });
        return (contract || {}).contractName;
      }
      return null;
    }
  }),
  watch: {
    'dateFrom.date': 'watchDateChange',
    'dateTo.date': 'watchDateChange',
    visible: function visible() {
      if (!this.openCalendar && !this.visible) {
        this.setCurrentPopup();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('overlay', {
    hideOverlay: 'hide',
    showOverlay: 'show'
  }), {
    watchDateChange: function watchDateChange() {
      var preset = this.isPreset(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dateFrom.date).format(DATE_FORMAT), __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dateTo.date).format(DATE_FORMAT), this.dates);
      this.setButton(preset);
    },
    onButtonClick: function onButtonClick(btn) {
      this.dateFrom = {
        date: new Date(Date.parse(this.dates[btn.name]))
      };
      this.dateTo = {
        date: new Date(Date.parse(this.dates.today))
      };
    },
    onExport: function onExport() {
      var StartDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dateFrom.date).format(DATE_FORMAT_API);
      var EndDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dateTo.date).format(DATE_FORMAT_API);

      this.$refs.StartDate.value = StartDate;
      this.$refs.EndDate.value = EndDate;
      // this.$refs.bearer.value = this.token; because API wants this as get
      this.$refs.staticForm.action = this.formAction + '?bearer=' + this.token;
      this.$refs.staticForm.submit();
      this.setCurrentPopup();
      this.hideOverlay();
    },
    setButton: function setButton(btn) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selected).forEach(function (a) {
        _this2.selected[a] = btn === a;
      });
    },
    setAllDates: function setAllDates() {
      var dates = this.dates;
      var now = new Date();
      dates.today = __WEBPACK_IMPORTED_MODULE_2_moment___default()(now).format(DATE_FORMAT);
      dates.l30d = __WEBPACK_IMPORTED_MODULE_2_moment___default()(now).subtract(30, 'days').format(DATE_FORMAT);
      dates.l3m = __WEBPACK_IMPORTED_MODULE_2_moment___default()(now).subtract(3, 'months').format(DATE_FORMAT);
      dates.ytd = __WEBPACK_IMPORTED_MODULE_2_moment___default()(now).subtract(1, 'years').format(DATE_FORMAT);
    },
    isPreset: function isPreset(start, end, dates) {
      if (end !== dates.today) {
        return false;
      }
      switch (start) {
        case dates.l30d:
          return 'l30d';
        case dates.l3m:
          return 'l3m';
        case dates.ytd:
          return 'ytd';
        default:
      }
      return false;
    },
    opened: function opened() {
      // show component overlay
      this.openCalendar = true;
      // hide app overlay
      this.hideOverlay();
    },
    closed: function closed() {
      // hide component overlay
      this.openCalendar = false;
      // show app overlay
      this.showOverlay();
    },
    overlayClick: function overlayClick() {
      // hide component overlay
      this.openCalendar = false;
    },
    fromClick: function fromClick() {
      // datepicker has no refs nor showMethod
      var input = this.$refs.fromDatepicker.$el.querySelector('input');
      input.click();
    },
    toClick: function toClick() {
      // datepicker has no refs
      var input = this.$refs.toDatepicker.$el.querySelector('input');
      input.click();
    }
  }),
  mounted: function mounted() {
    this.setAllDates();
    this.onButtonClick({ name: 'ytd' });
    this.disabled.from = new Date();
  }
});

/***/ }),

/***/ "ZMoj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-register-footer"},[_c('h4',{staticClass:"account-register-footer__title"},[_vm._v("\n        "+_vm._s(_vm.$txt('account-register.footer.title'))+"\n      ")]),_vm._v(" "),_c('a',{staticClass:"account-register-footer__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onLogin($event)}}},[_vm._v("\n        "+_vm._s(_vm.$txt('account-register.footer.link'))+"\n      ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZWR/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TAB_INDEX_CREDIT; });
/* unused harmony export TAB_INDEX_PAY_NEAR_ME */
/* unused harmony export TAB_INDEX_COINBASE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TAB_INDEX_ONLINE_BANKING; });
/* unused harmony export TAB_INDEX_PENDING */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wallet_add_funds_card_add_funds_card_vue__ = __webpack_require__("a3Wk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wallet_add_funds_cash_add_funds_cash_vue__ = __webpack_require__("4OEB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_wallet_add_funds_coinbase_add_funds_coinbase_vue__ = __webpack_require__("ircP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__ = __webpack_require__("t71M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_wallet_pending_requests_pending_requests_deposits_vue__ = __webpack_require__("rNZt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_loader__ = __webpack_require__("39kf");










var TAB_INDEX_CREDIT = 0;
var TAB_INDEX_PAY_NEAR_ME = 1;
var TAB_INDEX_COINBASE = 2;
var TAB_INDEX_ONLINE_BANKING = 3;
var TAB_INDEX_PENDING = 4;

var GTM_PAGE_NAME = 'deposit';

/* unused harmony default export */ var _unused_webpack_default_export = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_loader__["a" /* default */]],
  components: {
    addFundsCard: __WEBPACK_IMPORTED_MODULE_3__components_wallet_add_funds_card_add_funds_card_vue__["a" /* default */],
    addFundsCash: __WEBPACK_IMPORTED_MODULE_4__components_wallet_add_funds_cash_add_funds_cash_vue__["a" /* default */],
    addFundsCoinbase: __WEBPACK_IMPORTED_MODULE_5__components_wallet_add_funds_coinbase_add_funds_coinbase_vue__["a" /* default */],
    addFundsBankTransfer: __WEBPACK_IMPORTED_MODULE_6__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["c" /* default */],
    pendingRequests: __WEBPACK_IMPORTED_MODULE_7__components_wallet_pending_requests_pending_requests_deposits_vue__["a" /* default */],
    tabs: __WEBPACK_IMPORTED_MODULE_2__components_generics_tabs_tabs_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showTabs: false,
      tabIndexOrder: [],
      isCashAvailable: false,
      isCryptoAvailable: false,
      isCreditCardAvailable: false,
      isOnlineBankingAvailable: false,
      cryptoDescription: '',
      activeTab: null,
      cardDepositAttempt: 1
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    showBankingTab: function showBankingTab() {
      return this.activeTab === TAB_INDEX_ONLINE_BANKING;
    },
    showCreditCardTab: function showCreditCardTab() {
      return this.activeTab === TAB_INDEX_CREDIT;
    },
    showCashTab: function showCashTab() {
      return this.activeTab === TAB_INDEX_PAY_NEAR_ME;
    },
    showCoinBaseTab: function showCoinBaseTab() {
      return this.activeTab === TAB_INDEX_COINBASE;
    },
    showPendingTab: function showPendingTab() {
      return this.activeTab === TAB_INDEX_PENDING;
    },
    tabs: function tabs() {
      var _this = this;

      var results = [];
      this.tabIndexOrder.forEach(function (v) {
        if (_this.isOnlineBankingAvailable && v === TAB_INDEX_ONLINE_BANKING) {
          results.push({
            name: TAB_INDEX_ONLINE_BANKING,
            title: _this.isLayoutMobile ? 'Online Banking' : 'Online Banking'
          });
        }
        if (_this.isCreditCardAvailable && v === TAB_INDEX_CREDIT) {
          results.push({
            name: TAB_INDEX_CREDIT,
            title: _this.isLayoutMobile ? 'Credit Card' : 'Credit Card'
          });
        }
        if (_this.isCashAvailable && v === TAB_INDEX_PAY_NEAR_ME) {
          results.push({
            name: TAB_INDEX_PAY_NEAR_ME,
            title: 'Cash'
          });
        }
        if (_this.isCryptoAvailable && v === TAB_INDEX_COINBASE) {
          results.push({
            name: TAB_INDEX_COINBASE,
            title: _this.cryptoDesctiption
          });
        }
      });
      results.push({
        name: TAB_INDEX_PENDING,
        title: 'Pending'
      });
      return results;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['getDepositMethods']), {
    tabChange: function tabChange(name) {
      this.activeTab = name;

      if (this.$route && this.$route.path) {
        this.$gtm.trackEvent({
          event: 'pageviewTrackerEvent',
          virtualPage: this.$route.path + '/' + GTM_PAGE_NAME + '/' + name,
          virtualPageTitle: this.$route.name + ' - ' + GTM_PAGE_NAME + ' - ' + name
        });
      }
    },
    onAddFundsCardSuccess: function onAddFundsCardSuccess() {
      this.cardDepositAttempt += 1;
    }
  }),
  created: function created() {
    var _this2 = this;

    this.loaderAdd(document.body);
    this.getDepositMethods().then(function (data) {
      _this2.showTabs = true;
      _this2.tabIndexOrder = data.tabIndexOrder;
      _this2.isCashAvailable = data.isCashAvailable;
      _this2.isCryptoAvailable = data.isCryptoAvailable;
      _this2.isCreditCardAvailable = data.isCreditCardAvailable;
      _this2.isOnlineBankingAvailable = data.isOnlineBankingAvailable;
      _this2.cryptoDesctiption = data.cryptoDescription || 'USDC';
      _this2.loaderRemove(document.body);
    }).catch(function () {
      return _this2.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "Zdym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_account_account_details_update_account_address_update_vue__ = __webpack_require__("jVeD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_account_account_details_update_account_details_update_vue__ = __webpack_require__("a/AT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_account_update_password_account_update_password_vue__ = __webpack_require__("mx5S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_account_account_set_password_account_set_password_vue__ = __webpack_require__("s06T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_account_profile_profile_vue__ = __webpack_require__("lmGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_notification_icon_notification_icon_vue__ = __webpack_require__("qIn7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_loader__ = __webpack_require__("39kf");



var _VERIFICATION_STATUS_;














var ROUTE_DETAILS = 'account-details';
var ROUTE_DETAILS_UPDATE = 'details-update';
var ROUTE_ADDRESS_UPDATE = 'address-update';
var ROUTE_PASS_UPDATE = 'password-update';
var ROUTE_PASS_SET = 'password-set';

var STATUS_NOT_VERIFIED = 0;
var STATUS_BASIC = 1;
var STATUS_IN_PROCESS = 2;
var STATUS_ENHANCED = 3;
var UPLOAD_LINK_SOURCE = 3;

var VERIFICATION_STATUS_MAP = (_VERIFICATION_STATUS_ = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_VERIFICATION_STATUS_, STATUS_NOT_VERIFIED, 'Not Verified'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_VERIFICATION_STATUS_, STATUS_BASIC, 'Basic'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_VERIFICATION_STATUS_, STATUS_IN_PROCESS, 'In Process'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_VERIFICATION_STATUS_, STATUS_ENHANCED, 'Enhanced'), _VERIFICATION_STATUS_);

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_loader__["a" /* default */]],
  components: {
    accountAddressUpdate: __WEBPACK_IMPORTED_MODULE_3__components_account_account_details_update_account_address_update_vue__["a" /* default */],
    accountDetailsUpdate: __WEBPACK_IMPORTED_MODULE_4__components_account_account_details_update_account_details_update_vue__["a" /* default */],
    accountUpdatePassword: __WEBPACK_IMPORTED_MODULE_5__components_account_account_update_password_account_update_password_vue__["a" /* default */],
    accountSetPassword: __WEBPACK_IMPORTED_MODULE_6__components_account_account_set_password_account_set_password_vue__["a" /* default */],
    contentHeader: __WEBPACK_IMPORTED_MODULE_7__components_generics_content_header_content_header_vue__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_8__components_account_profile_profile_vue__["a" /* default */],
    notificationIcon: __WEBPACK_IMPORTED_MODULE_11__components_notification_icon_notification_icon_vue__["a" /* default */]
  },
  data: function data() {
    return {
      hasLocalPassword: false,
      documentUploadLink: '',
      STATUS_NOT_VERIFIED: STATUS_NOT_VERIFIED,
      STATUS_BASIC: STATUS_BASIC,
      STATUS_IN_PROCESS: STATUS_IN_PROCESS,
      STATUS_ENHANCED: STATUS_ENHANCED
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Account Details'
    };
  },

  watch: {
    $route: function $route(v) {
      this.triggerPopup(this.isLayoutMobile, v.name);
    },
    isLayoutMobile: function isLayoutMobile() {
      this.triggerPopup(this.isLayoutMobile, this.$route.name);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('popup', ['currentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('profile', ['userAffiliations', 'isUCAffilSet']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['userData', 'status']), {
    gridRowModifier: function gridRowModifier() {
      return {
        row: this.isLayoutMobile,
        'row-x': !this.isLayoutMobile
      };
    },
    isDetailsShown: function isDetailsShown() {
      return !this.isLayoutMobile || this.$route.name === ROUTE_DETAILS;
    },
    isMobileAddressUpdate: function isMobileAddressUpdate() {
      return this.isLayoutMobile && this.$route.name === ROUTE_ADDRESS_UPDATE;
    },
    isMobileDetailsUpdate: function isMobileDetailsUpdate() {
      return this.isLayoutMobile && this.$route.name === ROUTE_DETAILS_UPDATE;
    },
    isMobilePasswordChange: function isMobilePasswordChange() {
      return this.isLayoutMobile && this.$route.name === ROUTE_PASS_UPDATE;
    },
    isMobilePasswordSet: function isMobilePasswordSet() {
      return this.isLayoutMobile && this.$route.name === ROUTE_PASS_SET;
    },
    isUpdateAddressDisabled: function isUpdateAddressDisabled() {
      var idVerified = this.userData.idVerified;
      return typeof idVerified !== 'undefined' ? !idVerified : false;
    },
    title: function title() {
      if (this.isMobilePasswordChange) return 'Change Password';
      if (this.isMobilePasswordSet) return 'Set Password';
      if (this.isMobileAddressUpdate) return 'Change Address';
      if (this.isMobileDetailsUpdate) return 'Change Username';
      return 'Account Details';
    },
    verificationStatusDisplay: function verificationStatusDisplay() {
      var currentStatus = this.userData.verificationStatus;
      return VERIFICATION_STATUS_MAP[currentStatus];
    },
    showVerificationStatusInfo: function showVerificationStatusInfo() {
      var currentStatus = this.userData.verificationStatus;
      return currentStatus !== STATUS_ENHANCED;
    },
    contentHeaderButtonSectionModifiers: function contentHeaderButtonSectionModifiers() {
      return {
        'content-header__section-alt--right': true,
        'content-header__section-alt--right--large-pad': !this.verificationStatusIs(STATUS_ENHANCED) && !this.verificationStatusIs(STATUS_IN_PROCESS)
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['getUserAffiliations']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentSmallPopup', 'setCurrentPopupOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getAccountDetail', 'getManageInfo', 'getDocumentUploadLink']), {
    onInfoClick: function onInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_PUBLIC_PROFILE_INFO);
    },
    verificationStatusIs: function verificationStatusIs(target) {
      return this.userData.verificationStatus === target;
    },
    onVerifyIdentity: function onVerifyIdentity() {
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
        return;
      }
      this.showAccountVerifyPopup();
    },
    triggerPopup: function triggerPopup(mobile, $route) {
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
        return;
      }
      if (!mobile) {
        if ($route === ROUTE_ADDRESS_UPDATE) {
          this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ADDRESS_UPDATE);
        } else if ($route === ROUTE_DETAILS_UPDATE) {
          this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_DETAIL_UPDATE);
        } else if ($route === ROUTE_PASS_UPDATE) {
          this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_DETAIL_PASSWORD);
        } else if ($route === ROUTE_PASS_SET) {
          this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_DETAIL_PASSWORD_SET);
        } else {
          this.setCurrentPopup();
        }
      } else {
        this.setCurrentPopup();
      }
    },
    onShowVerificationInfo: function onShowVerificationInfo() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_VERIFICATION_INFO);
      this.setCurrentPopupOptions({ verificationStatus: this.userData.verificationStatus });
    },
    onUploadDocuments: function onUploadDocuments() {
      this.getDocumentUploadLink(UPLOAD_LINK_SOURCE).then(function (link) {
        window.location.href = link;
      });
    },
    showAffiliationsPopup: function showAffiliationsPopup() {
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
        return;
      }
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].AFFILIATIONS);
      this.setCurrentPopupOptions({ allowClose: true });
    }
  }),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getAccountDetail().then(this.getUserAffiliations).then(this.getManageInfo).then(function (data) {
      _this.loaderRemove(document.body);
      _this.hasLocalPassword = data.hasLocalPassword;
      _this.isComponentReady = true;
    }).catch(function () {
      _this.loaderRemove(document.body);
      _this.isComponentReady = true;
    });

    this.triggerPopup(this.isLayoutMobile, this.$route.name);
  }
});

/***/ }),

/***/ "Zi8f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_list_item_v2_market_list_item_v2_vue__ = __webpack_require__("tPuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__ = __webpack_require__("P71F");









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */]],
  props: {
    isNewArrival: {
      type: Boolean,
      default: false
    },
    isTopTrending: {
      type: Boolean,
      default: false
    },
    num: {
      type: Number,
      default: 3
    }
  },
  components: {
    marketListItem: __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_list_item_v2_market_list_item_v2_vue__["a" /* default */],
    swiper: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    var _this = this;

    return {
      activeIndex: 0,
      swiperOptions: {
        slidesPerView: 1,
        loop: true,
        direction: 'horizontal',
        spaceBetween: 0,
        onTransitionStart: function onTransitionStart(swp) {
          _this.activeIndex = swp.activeIndex;
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('browse', ['mostPredictedMarkets', 'newArrivalMarkets', 'trendingMarkets']), {
    dummyComponents: function dummyComponents() {
      if (this.isLayoutMobile) return __WEBPACK_IMPORTED_MODULE_1_lodash_range___default()(0, 1);
      return __WEBPACK_IMPORTED_MODULE_1_lodash_range___default()(0, this.num);
    },
    items: function items() {
      if (this.isNewArrival) {
        return this.newArrivalMarkets;
      }
      if (this.isTopTrending) {
        return this.trendingMarkets;
      }
      return this.mostPredictedMarkets;
    },
    title: function title() {
      if (this.isNewArrival) {
        return 'New Arrivals';
      }
      if (this.isTopTrending) {
        return 'Top Trending';
      }
      return 'Most Predicted';
    },
    isPrevArrowDisabled: function isPrevArrowDisabled() {
      return this.activeIndex === 0;
    },
    isNextArrowDisabled: function isNextArrowDisabled() {
      return this.items.length === 0 || this.activeIndex === this.num - 1;
    },
    prevArrowModifiers: function prevArrowModifiers() {
      return {
        'most-predicted-list__header-arrow': true,
        'most-predicted-list__header-arrow--left': true
        // 'most-predicted-list__header-arrow--disabled': this.isPrevArrowDisabled,
      };
    },
    nextArrowModifiers: function nextArrowModifiers() {
      return {
        'most-predicted-list__header-arrow': true,
        'most-predicted-list__header-arrow--right': true
        // 'most-predicted-list__header-arrow--disabled': this.isNextArrowDisabled,
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getMostPredictedMarkets', 'getNewArrivalMarkets', 'getTrendingMarkets']), {
    prevSlide: function prevSlide() {
      this.$refs.swiper.swiper.slidePrev();
    },
    nextSlide: function nextSlide() {
      this.$refs.swiper.swiper.slideNext();
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    var payload = {
      limit: this.num
    };
    var promise = this.getMostPredictedMarkets;

    if (this.isNewArrival) {
      promise = this.getNewArrivalMarkets;
    }

    if (this.isTopTrending) {
      promise = this.getTrendingMarkets;
    }

    this.loaderAdd();

    promise(payload).then(function () {
      _this2.loaderRemove();
      _this2.isComponentReady = true;
    }).catch(function () {
      return _this2.loaderRemove();
    });
  }
});

/***/ }),

/***/ "ZiDD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"show-password"}},[(_vm.show)?_c('button',{staticClass:"show-password",class:_vm.classModifiers,attrs:{"type":"button","tabindex":"-1","title":_vm.title},on:{"click":function($event){$event.stopPropagation();return _vm.onPasswordToggle($event)}}},[_vm._v("\n     \n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZjeX":
/***/ (function(module, exports) {

module.exports = {"page-info.title":"Leaderboard Rank (Past Week)","page-forgotten-password.title":"Forgotten Password","page-leaderboards.note":"Leaderboards are updated nightly.","page-login.title":"Login","page-markets.no-markets.first-line":"No Markets Found.","page-markets.no-markets.second-line":"Please Adjust Filters","page-not-found.title":"Page Not Found","page-not-found.header":"Error 404","page-not-found.message":"Whoops. It looks as if this page doesn't exist.","page-register.title":"Create an Account","page-research.title":"Research Opportunities","page-market.economic-indicator":"Economic Indicator markets like this one require you to be affiliated with a school in order to buy or sell shares","page-market.no-market-message":"The Market could not be located.","page-market.fewer":"Show Fewer","page-market.investment-title":"Market Investment","page-market.gain-loss-title":"Gain/Loss","page-market.payout-title":"Max. Payout","page-market.contracts-first-col":"Contract","page-market.contracts-second-col":"Latest Yes Price","page-market.contracts-third-fourth-col":"Best Offer","page-market.contracts-hidden-info":"(Shares/Offers below)","app-header-notification.inactivity":"Due to page inactivity, live updates, including account balance, have been disabled on this page. To re-enable live updates please refresh the page.","app-privacy-statement.info":"By using our site, you acknowledge that you have read and understand our","app-privacy-statement.button":"I Agree","attach-to-home.txt1":"Follow these quick steps to a place a PredictIt icon on your iPhone.","attach-to-home.txt1-bottom":"First, hit the share button in the footer at the bottom of the screen (available in Safari only).","attach-to-home.txt2":"Scroll left and tap the icon in the image below.","attach-to-home.txt3":"Choose a simple title, hit 'Add' and you are set to go!","balance-history-item.cancel":"Cancel Request","balance-history-item.canceled":"Your withdrawal has been cancelled.","balance-history-item.failed":"Operation failed.","balance-history.type":"Type","balance-history.amount":"Amount","balance-history.fee":"Fee","balance-history.net":"Net","balance-history.status":"Status","balance-history.no-items":"No transactions to display","balance-history.no-more-items":"No further transactions","contracts-history.no-items":"No trades in the past 30 days","contracts-history.no-more-items":"No further trades in the past 30 days","contracts-history.contract":"Contract","contracts-history.profit-loss":"Profit/Loss","contracts-history.fee":"(Fees)","contracts-history.net":"Net P/L","contracts-history.risk":"Risk Adj.","contracts-history.cash":"Cash","contracts-history.no-trades":"You have no trades in the past 30 days","contracts-history.detailed":"For detailed information, see your","contracts-history.history-link":"Account History","portfolio-summary-chart.no-chart":"A graph of your portfolio value will appear here when there is sufficient data to display","cms.market-list-embed.title":"Related Markets:","account-upload-id.info":"Don’t give up though. It’s also possible to tell us who you are by uploading documentation that we can review.","account-upload-id.button":"Upload File","account-update-password.disclaimer":"You will need to enter your current password in order to create a new one.","account-update-password.button":"Save New Password","account-update-image.disclaimer":"Profile images are reviewed before publication. Your new image will be visible after this review.","account-update-image.add":"Upload Photo","account-update-image.remove":"Remove Current Photo","account-login.title":"Login using your email","account-login.button":"Login","account-login.forgot":"Forgot Password?","account-login.footer.title":"Don't have an account?","account-login.footer.link":"Create an Account","account-forgotten.disclaimer":"Enter your email address to receive a link to reset your password. If you don’t hear from us within 15 minutes, check your spam folder and adjust your filtering to allow emails from PredictIt.","account-forgotten.notification":"If you need further assistance, our Support department is here to help you. Please contact us at","account-forgotten.button":"Reset my Password","account-forgotten.footer.cancel":"Cancel","account-register.footer.title":"Already have an account?","account-register.footer.link":"Login to My Account"}

/***/ }),

/***/ "ZllZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_orderBy__ = __webpack_require__("Ba3q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    stats: {
      type: Array,
      required: true
    },
    isFixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      sortParam: 'totalSharesTraded',
      sortOrder: 'desc'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('market', ['market']), {
    isMarketSettled: function isMarketSettled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["e" /* isMarketSettled */])(this.market);
    },
    sortedItems: function sortedItems() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash_orderBy___default()(this.stats, [this.sortParam], [this.sortOrder]);
    },
    isSortable: function isSortable() {
      return this.stats.length > 1;
    },
    secondColumnModifiers: function secondColumnModifiers() {
      return {
        'market-contracts-stats--middle': this.isSortable && !this.isMarketSettled,
        'market-contracts-stats--last-volume': this.isSortable && this.isMarketSettled
      };
    },
    thirdColumnModifiers: function thirdColumnModifiers() {
      return {
        'market-contracts-stats--middle': this.isLayoutDesktop,
        'market-contracts-stats--last': !this.isLayoutDesktop
      };
    },
    totalSharesTradedSum: function totalSharesTradedSum() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(this.stats, function (x) {
        return x.totalSharesTraded;
      }).toLocaleString();
    },
    todaysVolumeSum: function todaysVolumeSum() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(this.stats, function (x) {
        return x.todaysVolume;
      }).toLocaleString();
    },
    openInterestSum: function openInterestSum() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(this.stats, function (x) {
        return x.openInterest;
      }).toLocaleString();
    }
  }),
  methods: {
    headerSortByModifiers: function headerSortByModifiers(name) {
      if (!this.isSortable) return {};

      return {
        'market-contracts-stats--sort-by': this.sortParam === name,
        'market-contracts-stats--asc': this.sortParam === name && this.sortOrder === 'asc',
        'market-contracts-stats--desc': this.sortParam === name && this.sortOrder === 'desc'
      };
    },
    sortBy: function sortBy(name) {
      if (this.sortParam === name) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortOrder = 'desc';
        this.sortParam = name;
      }
    }
  }
});

/***/ }),

/***/ "ZqrY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_section_header_js__ = __webpack_require__("mXqA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c62ea59_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_section_header_vue__ = __webpack_require__("/gmg");
function injectStyle (ssrContext) {
  __webpack_require__("NQP2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_section_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c62ea59_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_section_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZvSa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_faq_search_input_js__ = __webpack_require__("zX9S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9119e6e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faq_search_input_vue__ = __webpack_require__("ySht");
function injectStyle (ssrContext) {
  __webpack_require__("+n+m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_faq_search_input_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9119e6e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faq_search_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a/AT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_details_update_js__ = __webpack_require__("H2eu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1396590_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_details_update_vue__ = __webpack_require__("MBIL");
function injectStyle (ssrContext) {
  __webpack_require__("GUdh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_details_update_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1396590_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_details_update_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a0yF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NOTIFICATION_TRADE_CONFIRMED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NOTIFICATION_SIMPLE; });
/* unused harmony export NOTIFICATION_ACCOUNT_FUNDS */
/* unused harmony export NOTIFICATION_MARKET */
/* unused harmony export NOTIFICATION_MARKET_STATUS */
/* unused harmony export NOTIFICATION_CONTRACT */
/* unused harmony export NOTIFICATION_MARKET_OWNERSHIP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NOTIFICATION_CONTRACT_OWNERSHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NOTIFICATION_SHARES_TRADES; });
/* unused harmony export NOTIFICATION_SITE_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NOTIFICATION_TRADER_LEVEL_CHANGED; });
/* unused harmony export NOTIFICATION_PWMB_DEPOSIT_FINISHED */
/* unused harmony export NOTIFICATION_PWMB_DEPOSIT_SHOW_CONFIRMATION */
/* unused harmony export NOTIFICATION_PWMB_SHOW_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ALLOWED_NOTIFICATION_TYPES; });
/* unused harmony export IGNORE_TIMESTAMP_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NOTIFICATION_MATCHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NOTIFICATION_SETTLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NOTIFICATION_PRICE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NOTIFICATION_LEVEL; });
/* unused harmony export NOTIFICATIONS_ONLINE_BANKING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return NOTIFICATION_TRADE_CONFIRMED_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NOTIFICATION_SHARES_TRADES_CLOSE_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MARKET_DATA_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return MY_SHARES_MARKET_DATA_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CONTRACT_DATA_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ACCOUNT_FUNDS_MAP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_camelCase__ = __webpack_require__("NRb0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_camelCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_reduce__ = __webpack_require__("M+Z9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__ = __webpack_require__("ENdH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_notifications_firebase__ = __webpack_require__("2Pqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__ = __webpack_require__("t71M");



/* eslint-disable no-console, arrow-body-style, no-case-declarations */






// import ss from '@/helpers/sessionStorage';



/*
  List of notification types that come from an signalr.
 */
var NOTIFICATION_TRADE_CONFIRMED = 'tradeConfirmed_data';
var NOTIFICATION_SIMPLE = 'simple';
var NOTIFICATION_ACCOUNT_FUNDS = 'accountfunds_data';
var NOTIFICATION_MARKET = 'market_data';
var NOTIFICATION_MARKET_STATUS = 'market_status';
var NOTIFICATION_CONTRACT = 'contract_data';
var NOTIFICATION_MARKET_OWNERSHIP = 'marketOwnershipUpdate_data';
var NOTIFICATION_CONTRACT_OWNERSHIP = 'contractOwnershipUpdate_data';
var NOTIFICATION_SHARES_TRADES = 'notification_shares_traded';
var NOTIFICATION_SITE_STATUS = 'site_status';
var NOTIFICATION_TRADER_LEVEL_CHANGED = 'notification_trade_level_changed';
var NOTIFICATION_PWMB_DEPOSIT_FINISHED = 'notification_pwmb_deposit_finished';
var NOTIFICATION_PWMB_DEPOSIT_SHOW_CONFIRMATION = 'notification_pwmb_deposit_show_confirmation';
var NOTIFICATION_PWMB_SHOW_ERROR = 'notification_pwmb_show_error';

/*
  List of notification types that *should* display in top right corner of the app.
 */
var ALLOWED_NOTIFICATION_TYPES = [NOTIFICATION_SIMPLE, NOTIFICATION_TRADE_CONFIRMED, NOTIFICATION_SHARES_TRADES, NOTIFICATION_TRADER_LEVEL_CHANGED];

var IGNORE_TIMESTAMP_TYPES = [NOTIFICATION_TRADE_CONFIRMED, NOTIFICATION_SHARES_TRADES, NOTIFICATION_MARKET_STATUS];
/*
  Generic notification types that come from API (backend).
  The reason for separate list is determined by other typing mechanism used by
  API as opposed to signalr notifications.
  For now NOTIFICATION_SHARES_TRADES maps to NOTIFICATION_MATCHED.
  and NOTIFICATION_TRADER_LEVEL_CHANGED to NOTIFICATION_LEVEL
 */
var NOTIFICATION_MATCHED = 1;
var NOTIFICATION_SETTLED = 2;
var NOTIFICATION_PRICE_CHANGE = 3;
var NOTIFICATION_LEVEL = 12;
var NOTIFICATIONS_ONLINE_BANKING = [13, 14];
/*
  Number of milliseconds to delay confirmations so they do not appear instantly after submit click
  because simple notification should display first.
 */
var NOTIFICATION_TRADE_CONFIRMED_DELAY = 1250;
var NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY = 10000;
var NOTIFICATION_SHARES_TRADES_CLOSE_DELAY = 5000;

var MARKET_DATA_MAP = {
  TotalSharesTraded: 'totalSharesTraded',
  UserGainLoss: 'userGainLoss',
  UserInvestment: 'userInvestment',
  UserMaxPayout: 'userMaxPayout',
  Status: 'status',
  IsOpen: 'isOpen',
  IsActive: 'isActive',
  IsProcessed: 'isProcessed',
  UserHasOwnership: 'userHasOwnership'
};

// additional map because of TotalSharesTraded different mapping
var MY_SHARES_MARKET_DATA_MAP = {
  TotalSharesTraded: 'marketSharesTraded',
  UserGainLoss: 'userGainLoss',
  UserInvestment: 'userInvestment',
  UserMaxPayout: 'userMaxPayout',
  Status: 'status',
  IsOpen: 'isOpen',
  IsActive: 'isActive',
  IsProcessed: 'isProcessed',
  IsOpenStatusMessage: 'isOpenStatusMessage',
  UserHasOwnership: 'userHasOwnership'
};

var CONTRACT_DATA_MAP = {
  TimeStamp: 'timestamp',
  BestNoPrice: 'bestNoPrice',
  BestNoCost: 'bestNoPrice',
  BestYesPrice: 'bestYesPrice',
  BestYesCost: 'bestYesPrice',
  LastClosePrice: 'lastClosePrice',
  LastTradePrice: 'lastTradePrice',
  UserAveragePricePerShare: 'userAveragePricePerShare',
  UserQuantity: 'userQuantity',
  UserOpenOrdersBuyQuantity: 'userOpenOrdersBuyQuantity',
  UserOpenOrdersSellQuantity: 'userOpenOrdersSellQuantity',
  UserPrediction: 'userPrediction'
};

var ACCOUNT_FUNDS_MAP = {
  AccountBalance: 'accountBalance',
  AccountBalanceDecimal: 'accountBalanceDecimal',
  PortfolioBalance: 'portfolioBalance',
  PortfolioBalanceDecimal: 'portfolioBalanceDecimal',
  ShareValueDelta: 'shareValueDelta',
  ShareValueDeltaDecimal: 'shareValueDeltaDecimal',
  ProfitablePredictions: 'profitablePredictions'
};

var pageLoad = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
var processedGuids = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();

var updateOrResetCounters = function updateOrResetCounters() {
  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('dashboard/toggleNotifications');

  if (!__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.notifications.showNotificationsWidget) {
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('user/increaseUserUnreadNotificationsCount');
  } else {
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('user/setUserUnreadNotificationsCount', 0);
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('dashboard/markNotificationsAsRead');
  }
};

var addToStore = function addToStore(method, updateType, data) {
  if (!data) return;

  if (data && data.TimeStamp && !IGNORE_TIMESTAMP_TYPES.includes(updateType)) {
    if (__WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(data.TimeStamp).diff(pageLoad, 'seconds') < 0) {
      return;
    }
  }

  if (data.Guid) {
    if (processedGuids.has(data.Guid)) return;
    processedGuids.add(data.Guid);
  }

  data.UpdateType = updateType;
  switch (updateType) {
    case NOTIFICATION_ACCOUNT_FUNDS:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/updateBalanceFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('profile/updateProfileFromNotification', data);
      break;
    case NOTIFICATION_MARKET:
    case NOTIFICATION_MARKET_OWNERSHIP:
    case NOTIFICATION_MARKET_STATUS:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateMarketFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateRelatedMarketFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updateMarketFromNotification', data);
      // store.dispatch('browse/updateGainsLossMarketFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updatePredictedTrendingMarketFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('dashboard/updateMySharesFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('search/updateMarketFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('watchlist/updateWatchlistFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('popup/updateTradePopupOptionsMarketFromNotification', data);
      break;
    case NOTIFICATION_CONTRACT:
    case NOTIFICATION_CONTRACT_OWNERSHIP:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateRelatedContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updateContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updateGainsLossContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updatePredictedTrendingContractsFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('browse/updateMarketWidgetsContractsFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('dashboard/updateMySharesContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('search/updateContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('watchlist/updateWatchlistContractFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('popup/updateTradePopupOptionsContractsFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateMapOverviewDataFromNotification', data);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('market/updateMapOverviewDataSenateFromNotification', data);
      break;
    case NOTIFICATION_SITE_STATUS:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('app/setServerError', false);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('app/setMaintenance', {
        isMaintenanceEnabled: data.IsMaintenance,
        isTradingEnabled: !data.IsTradingSuspended,
        maintenanceMessage: data.MaintenanceMessage,
        suspendedMessage: data.TradingSuspendedMessage,
        systemMessage: data.SystemMessage
      });
      break;
    case NOTIFICATION_SHARES_TRADES:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('notifications/add', {
        method: method,
        type: updateType,
        data: {
          contentJson: data,
          notificationType: NOTIFICATION_MATCHED
        }
      });
      updateOrResetCounters();
      break;
    case NOTIFICATION_TRADER_LEVEL_CHANGED:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('notifications/add', {
        method: method,
        type: updateType,
        data: {
          contentJson: data,
          notificationType: NOTIFICATION_LEVEL
        }
      });
      updateOrResetCounters();
      break;
    case NOTIFICATION_PWMB_DEPOSIT_SHOW_CONFIRMATION:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setBankTransferStep', {
        step: data.PrefilledAmountToDeposit ? __WEBPACK_IMPORTED_MODULE_9__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["a" /* STEPS */].CONFIRM : __WEBPACK_IMPORTED_MODULE_9__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["a" /* STEPS */].AMOUNT_CONFIRM,
        stepData: __WEBPACK_IMPORTED_MODULE_2_lodash_reduce___default()(data, function (result, value, key) {
          result[__WEBPACK_IMPORTED_MODULE_1_lodash_camelCase___default()(key)] = value;
          return result;
        }, {})
      });
      break;
    case NOTIFICATION_PWMB_SHOW_ERROR:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setBankTransferStep', {
        step: __WEBPACK_IMPORTED_MODULE_9__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["a" /* STEPS */].FINISHED_FAILED,
        stepData: {
          error: data.MessageForUser
        }
      });
      break;
    case NOTIFICATION_PWMB_DEPOSIT_FINISHED:
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/getBalance').then(function () {
        return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setCurrentDeposit', {
          amount: data.TotalAmountDeposited,
          matched: data.AmountMatched,
          messageForUser: data.MessageForUser,
          confirmationNumber: data.PWMBCaptureId,
          type: 'bank-transfer',
          account: {
            accountStatus: 1,
            bankInfo: {
              bankIconUrl: data.BankIconURL,
              bankAccountDisplayName: data.BankAccountDisplayName,
              bankDisplayName: data.BankDisplayName
            }
          }
        });
      }).then(function () {
        if (data.Status === __WEBPACK_IMPORTED_MODULE_9__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["b" /* FINISHED_STATUS */].SUCCESS) {
          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setBankTransferStep', {
            step: __WEBPACK_IMPORTED_MODULE_9__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["a" /* STEPS */].FINISHED_SUCCESS,
            stepData: {}
          });
        } else if (data.Status === __WEBPACK_IMPORTED_MODULE_9__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["b" /* FINISHED_STATUS */].FAILED) {
          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setBankTransferStep', {
            step: __WEBPACK_IMPORTED_MODULE_9__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["a" /* STEPS */].FINISHED_FAILED,
            stepData: {
              error: data.MessageForUser
            }
          });
        } else if (data.Status === __WEBPACK_IMPORTED_MODULE_9__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["b" /* FINISHED_STATUS */].EXPIRED) {
          __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('wallet/setBankTransferStep', {
            step: __WEBPACK_IMPORTED_MODULE_9__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["a" /* STEPS */].FINISHED_EXPIRED,
            stepData: {
              pwmbAuthorizationId: data.PWMBAuthorizationId,
              error: data.MessageForUser
            }
          });
        }
      });
      break;
    default:
      {
        var payload = {
          method: method,
          type: updateType,
          data: data
        };
        __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('notifications/add', payload);
      }
  }
};

var KEY_MESSAGING_STATE = 'messagingState';
var MESSAGING_STATES = {
  OPT_IN: 'opt-in',
  OPT_OUT: 'opt-out',
  NO_DECISION: 'no-decision'
};
/* harmony default export */ __webpack_exports__["a"] = ({
  initialisedFirebaseAnonymous: false,
  initialisedFirebase: false,
  initialisedSignalr: false,
  init: function init() {
    this.initFirebase();
    this.initSignalr();
  },
  initFirebase: function initFirebase() {
    var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (!token && !false) {
      return;
    }
    __WEBPACK_IMPORTED_MODULE_5__services_notifications_firebase__["a" /* connect */](token, { onUpdate: addToStore });

    if (token) {
      this.initialisedFirebase = true;
    } else {
      this.initialisedFirebaseAnonymous = true;
    }
  },
  initSignalr: function initSignalr() {
    var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (!token && !false) {
      return;
    }
    __WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__["a" /* createConnection */]();
    if (token) {
      __WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__["b" /* setToken */]({ token: token });
    }
    if (__WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__["c" /* isConnected */]()) {
      __WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__["d" /* addListener */]({ onUpdate: addToStore });
      __WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__["e" /* connect */]();
    }
    this.initialisedSignalr = true;
  },
  authorize: function authorize(token) {
    // reinitialise if it was switched off for anonymous users
    if (!this.initialisedFirebase) this.initFirebase(token);
    if (!this.initialisedSignalr) this.initSignalr(token);
  },
  logout: function logout() {
    __WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__["f" /* forceDisconnect */]();
    if (window.firebase.apps.length > 0) {
      window.firebase.app().delete().then(function () {});
    }
  },
  setupMessaging: function setupMessaging() {
    __WEBPACK_IMPORTED_MODULE_5__services_notifications_firebase__["b" /* setupMessaging */]();
  },
  forceDisconnect: function forceDisconnect() {
    __WEBPACK_IMPORTED_MODULE_4__services_notifications_signal_r__["f" /* forceDisconnect */]();
  },
  shouldSetupMessaging: function shouldSetupMessaging() {
    if (!__webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","FIREBASE_API_KEY_ANONYMOUS":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID_ANONYMOUS":"","FIREBASE_AUTH_DOMAIN_ANONYMOUS":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL_ANONYMOUS":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID_ANONYMOUS":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID_ANONYMOUS":"76708845910","FIREBASE_STORAGE_BUCKET_ANONYMOUS":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_FIREBASE":false,"ANONYMOUS_SIGNALR":false,"ORDER_BOOK_API_CALL_ENABLED":true,"ORDER_BOOK_FIREBASE_ENABLED":true,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","OPTIMOVE_ENABLED":true,"OPTIMOVE_SDK_TOKEN":"3b0d03cb1a8091dcf9b3f84bb2466b968ebf27e1b4d8a50c123316c0d129a99b","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","NEW_HEADER_ENABLED":false,"NEW_HEADER_EXCHANGE_URL":"https://exchange.predictit.com"}).PUSH_NOTIFICATIONS_JOURNEY_ENABLED) return true;

    var state = __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].get(KEY_MESSAGING_STATE, MESSAGING_STATES.NO_DECISION);
    return state === MESSAGING_STATES.OPT_IN;
  },
  showMessagingJourney: function showMessagingJourney(isBuyTradeType) {
    if (!__webpack_require__.i({"NODE_ENV":"production","ROOT_PATH":"/","DOMAIN":"","TWITTER_HANDLE":"PredictIt","REAL_API_URL":"/","SIGNALR_URL":"https://hub.predictit.org/signalr","ASSETS_CDN_URL":"https://cdn1.predictit.org","DISQUS_SSO_BUTTON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","DISQUS_SSO_ICON":"https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png","SOCIAL_AUTH_URL":"","CHART_CSV_DOWNLOAD_URL":"/Resource/DownloadMarketChartData","TRADE_CSV_DOWNLOAD_URL":"/Resource/DownloadTradeHistory","TRANSACTION_CSV_DOWNLOAD_URL":"/Resource/DownloadWalletHistory","DISQUS_SHORTNAME":"PredictIt","DISQUS_IDENTIFIER":"1360 800","DISQUS_PUBLIC_KEY":"kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf","DISQUS_SSO_NAME":"PredictIt","DISQUS_SSO_URL":"/Account/DisqusLogin","DISQUS_SSO_LOGOUT":"/Account/DisqusLogout","DISQUS_SSO_WIDTH":"800","DISQUS_SSO_HEIGHT":"600","REFRESH_TOKEN_INTERVAL":"60","LS_TTL_USER_ACCESS_TOKEN":"31536000","LS_TTL_USER_DISQUS_TOKEN":"3600","LS_TTL_USER_DISQUS_LOGIN":"31536000","LS_TTL_USER_MARKET_DISPLAY":"31536000","LS_TTL_BROWSE_HEADERS":"3600","FIREBASE_API_KEY":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID":"1:76708845910:web:a2746a4abbe584b1911ef7","FIREBASE_AUTH_DOMAIN":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID":"76708845910","FIREBASE_STORAGE_BUCKET":"predictit-f497e.appspot.com","FIREBASE_API_KEY_ANONYMOUS":"AIzaSyDXdDCHMMqgwx2RS1ORhZHeczBgAHyJ3oA","FIREBASE_APP_ID_ANONYMOUS":"","FIREBASE_AUTH_DOMAIN_ANONYMOUS":"predictit-f497e.firebaseapp.com","FIREBASE_DATABASE_URL_ANONYMOUS":"https://predictit-f497e.firebaseio.com","FIREBASE_PROJECT_ID_ANONYMOUS":"predictit-f497e","FIREBASE_MESSAGING_SENDER_ID_ANONYMOUS":"76708845910","FIREBASE_STORAGE_BUCKET_ANONYMOUS":"predictit-f497e.appspot.com","SECONDS_TO_ENABLE_WEBSOCKETS":"3","SECONDS_TO_DISCONNECT_DUE_TO_INACTIVITY_WEBSOCKETS":"0","PI_FACEBOOK_LINK":"https://www.facebook.com/PredictIt/","PI_INSTAGRAM_LINK":"https://www.instagram.com/PredictIt/","PI_TWITTER_LINK":"https://twitter.com/PredictIt","GOOGLE_GTM":"GTM-WGVC48","SHOW_PRICE_NOTIFICATION_SETTINGS":false,"ANONYMOUS_FIREBASE":false,"ANONYMOUS_SIGNALR":false,"ORDER_BOOK_API_CALL_ENABLED":true,"ORDER_BOOK_FIREBASE_ENABLED":true,"RESTRICTED_ACCESS_ENABLED":false,"ALL_MARKETS_HEADER":true,"BANNER_ENABLED":false,"NEWS_FEED_MARKET_PAGE_ENABLED":false,"TOURNAMENT_LINK":"//analysis.predictit.org/tagged/tournament","TOURNAMENT_LINK_ENABLED":false,"LEADERBOARDS_ENABLED":false,"SHOW_MAP_ON_HOMEPAGE":false,"PRIVACY_STATEMENT_ENABLED":false,"SHUTDOWN_ENABLED":false,"PROJECT":"predictit","OPTIMOVE_ENABLED":true,"OPTIMOVE_SDK_TOKEN":"3b0d03cb1a8091dcf9b3f84bb2466b968ebf27e1b4d8a50c123316c0d129a99b","EMAIL_MARKETS":"markets@predictit.org","EMAIL_PRESS":"press@predictit.org","EMAIL_SUPPORT":"support@predictit.org","NEW_HEADER_ENABLED":false,"NEW_HEADER_EXCHANGE_URL":"https://exchange.predictit.com"}).PUSH_NOTIFICATIONS_JOURNEY_ENABLED || !isBuyTradeType) return;

    var state = __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].get(KEY_MESSAGING_STATE, MESSAGING_STATES.NO_DECISION);
    if (state !== MESSAGING_STATES.NO_DECISION) return;

    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('popup/setCurrentSmallPopup', __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_MESSAGING_JOURNEY);
    }, 4000);
  },
  optOutMessaging: function optOutMessaging() {
    __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].set(KEY_MESSAGING_STATE, MESSAGING_STATES.OPT_OUT);
  },
  optInMessaging: function optInMessaging() {
    __WEBPACK_IMPORTED_MODULE_7__helpers_localStorage__["a" /* default */].set(KEY_MESSAGING_STATE, MESSAGING_STATES.OPT_IN);
  }
});

/***/ }),

/***/ "a25Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-research"},[_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12"},[(_vm.isLayoutMobile)?_c('content-header',{attrs:{"showCloseButton":true,"title":_vm.$txt('page-research.title')}}):_c('div',{staticClass:"page-research__desktop-header"},[_c('router-link',{staticClass:"page-research__back",attrs:{"to":{name: 'home'},"tag":"span"}},[_vm._v("\n        "+_vm._s(_vm.$txt('page-research.title'))+"\n      ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('research')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a3Wk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_card_js__ = __webpack_require__("Jjcr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3e0572_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_card_vue__ = __webpack_require__("uAyh");
function injectStyle (ssrContext) {
  __webpack_require__("q6c4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_card_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3e0572_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a5Jt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-invite-widget"},[_c('div',{staticClass:"share-invite-widget__title"},[_c('span',{staticClass:"share-invite-widget__title-text"},[_vm._v("Invite Your Friends")]),_vm._v(" "),_c('div',{staticClass:"share-invite-widget__title-icon",on:{"click":function($event){$event.stopPropagation();return _vm.onInfoClick($event)}}})]),_vm._v(" "),_c('div',{staticClass:"share-invite-widget__content"},[(_vm.successEmail)?_c('div',{staticClass:"share-invite-widget__success"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"share-invite-widget__success-message"},[_vm._v("\n        An invitation has been sent to "+_vm._s(_vm.successEmail)+".\n        "),_c('br'),_c('br'),_vm._v("Invite more friends below.\n      ")])]):_c('div',{staticClass:"share-invite-widget__label"},[_vm._v("\n      Enter an Email Address\n    ")]),_vm._v(" "),_c('div',{staticClass:"share-invite-widget__form"},[_c('div',{staticClass:"share-invite-widget__input"},[_c('form-input',{attrs:{"placeholder":" ","theme":"invite","validation":_vm.$v.fields.email,"name":"email","type":"text","required":false,"autocomplete":"email"},on:{"input":_vm.$v.fields.email.$touch},model:{value:(_vm.fields.email),callback:function ($$v) {_vm.$set(_vm.fields, "email", $$v)},expression:"fields.email"}})],1),_vm._v(" "),_c('div',[_c('button',{staticClass:"button button--primary share-invite-widget__button",attrs:{"disabled":_vm.invalidOrDisabled},on:{"click":_vm.onSend}},[_vm._v("\n            SEND\n          ")])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"share-invite-widget__subtitle"},[_vm._v("\n      Share on Social Media\n    ")]),_vm._v(" "),_c('div',{staticClass:"share-invite-widget__icons"},[_c('div',{staticClass:"share-invite-widget__icon share-invite-widget__icon--facebook",on:{"click":_vm.onFacebookShare}}),_vm._v(" "),_c('div',{staticClass:"share-invite-widget__icon share-invite-widget__icon--twitter",on:{"click":_vm.onTwitterShare}})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-invite-widget__success-icon-wrapper"},[_c('div',{staticClass:"share-invite-widget__success-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-invite-widget__line"},[_c('div',{staticClass:"share-invite-widget__line-part"}),_vm._v(" "),_c('div',[_vm._v("or")]),_vm._v(" "),_c('div',{staticClass:"share-invite-widget__line-part"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a8vN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    label: String,
    checked: Boolean,
    small: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classIsChecked: function classIsChecked() {
      return this.checked ? 'checkbox__tick--checked' : '';
    },
    checkboxModifiers: function checkboxModifiers() {
      return {
        'checkbox--small': this.small
      };
    }
  },
  methods: {
    onChange: function onChange(e) {
      this.$emit('change', e.target.checked);
    }
  }
});

/***/ }),

/***/ "a9og":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.objClass,domProps:{"innerHTML":_vm._s(_vm.changeValue)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aDe5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_captcha_js__ = __webpack_require__("EGLE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c003502_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_captcha_vue__ = __webpack_require__("xbXs");
function injectStyle (ssrContext) {
  __webpack_require__("FdH1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_captcha_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c003502_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_captcha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aEut":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup-generic"},[(_vm.currentPopupOptions.icon)?_c('div',{staticClass:"popup-generic__icon"},[(_vm.currentPopupOptions.icon === 'error')?_c('img',{attrs:{"src":__webpack_require__("z6fO"),"alt":""}}):_vm._e(),_vm._v(" "),(_vm.currentPopupOptions.icon === 'success')?_c('img',{attrs:{"src":__webpack_require__("ihRI"),"alt":""}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.currentPopupOptions.iconTitle)?_c('h5',{staticClass:"popup-generic__icon-title",class:("popup-generic__icon-title--" + (_vm.currentPopupOptions.icon))},[_vm._v("\n    "+_vm._s(_vm.currentPopupOptions.iconTitle)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"popup-generic__content"},[_vm._t("content")],2),_vm._v(" "),(_vm.currentPopupOptions.actionCallback)?_c('div',{staticClass:"popup-generic__button-wrapper"},[_c('button',{staticClass:"popup-generic__button button button--large button--primary button--full-width",on:{"click":function($event){$event.preventDefault();return _vm.currentPopupOptions.actionCallback()}}},[_vm._v("\n      "+_vm._s(_vm.currentPopupOptions.actionTitle)+"\n    ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aFdV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-profile-overview-header"},[(_vm.showMenuToggle)?_c('div',{staticClass:"user-profile-overview-header__toggle",on:{"click":_vm.onMenuToggle}},[_vm._v("•••")]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"user-profile-overview-header"}},[(_vm.showMenu)?_c('div',{staticClass:"user-profile-overview-header__menu"},[_c('div',{staticClass:"user-profile-overview-header__menu-inner",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onReportUser($event)}}},[_vm._v("\n        Report user\n      ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"user-profile-overview-header__text"},[_vm._v("\n    User Profile\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aGuV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_market_detail_js__ = __webpack_require__("Q0u2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54cc2991_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_market_detail_vue__ = __webpack_require__("Wy00");
function injectStyle (ssrContext) {
  __webpack_require__("j7VE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_market_detail_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54cc2991_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_market_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aHny":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_key_stats_js__ = __webpack_require__("2+il");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39c824d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_key_stats_vue__ = __webpack_require__("L2dZ");
function injectStyle (ssrContext) {
  __webpack_require__("rrgr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_key_stats_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39c824d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_key_stats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aNYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_history_trades_refine_link_refine_link_vue__ = __webpack_require__("gFdO");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: Array
  },
  components: {
    refineLink: __WEBPACK_IMPORTED_MODULE_0__components_account_history_trades_refine_link_refine_link_vue__["a" /* default */]
  },
  methods: {
    onClick: function onClick(e) {
      this.$emit('input', e);
    }
  }
});

/***/ }),

/***/ "aQYE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-profile-overview"},[_c('div',{staticClass:"user-profile-overview__avatar"},[_c('account-social-avatar',{attrs:{"avatar":_vm.watchedUserDetails.avatarImage,"showProgress":true,"percentage":100,"progressStrokeColor":_vm.userLevel.currentColor,"showEdit":false,"theme":"user-profile"}})],1),_vm._v(" "),_c('div',{staticClass:"user-profile-overview__name"},[_vm._v("\n    "+_vm._s(_vm.watchedUserDetails.userName)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"user-profile-overview__level"},[_vm._v("\n    "+_vm._s(_vm.userLevel.text)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aTrv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_balance_history_js__ = __webpack_require__("5MMF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_701dd160_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_balance_history_vue__ = __webpack_require__("yHvP");
function injectStyle (ssrContext) {
  __webpack_require__("+VBi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_balance_history_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_701dd160_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_balance_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ae3x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    placeholder: {
      type: String,
      default: '&nbsp;'
    },
    value: {
      default: null
    },
    selected: Boolean,
    symbol: Boolean
  },
  data: function data() {
    return {
      double: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('trade', ['keyboardDoubleSelected']), {
    number: function number() {
      return parseInt(this.value, 10);
    },
    text: function text() {
      return this.number > 0 ? this.number : this.placeholder;
    },
    selectedModifier: function selectedModifier() {
      return {
        'keyboard-numeric-input--double': this.selected && this.keyboardDoubleSelected && this.value !== null,
        'keyboard-numeric-input--selected': this.selected,
        'keyboard-numeric-input--empty': this.value === null
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('trade', ['updateKeyboardDoubleSelected']), {
    click: function click() {
      this.updateKeyboardDoubleSelected(!this.selected || !this.keyboardDoubleSelected);
      this.$emit('click');
    }
  })
});

/***/ }),

/***/ "aeoD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


var DEFAULT_TIMELINE = 7;

/* harmony default export */ __webpack_exports__["a"] = ({
  getProfileDetail: function getProfileDetail() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Detail');
  },
  getMyShares: function getMyShares(sort, sortPar) {
    var sorting = sort ? '?sort=' + sort : '';
    var sortParameter = sorting && sortPar ? '&sortParameter=' + sortPar : '';
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Shares' + sorting + sortParameter);
  },
  getTradeHistory: function getTradeHistory(itemsPerPage, page, marketId) {
    var contractId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var tradeType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Trade/History?itemsPerPage=' + itemsPerPage + '&page=' + page + '&marketId=' + marketId + '&contractId=' + contractId + '&tradeType=' + tradeType);
  },
  getTransactionHistory: function getTransactionHistory(itemsPerPage, page) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ALL';
    var year = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    var url = 'api/User/Wallet/History?itemsPerPage=' + itemsPerPage + '&page=' + page + '&type=' + type;
    var restOfQueryString = year ? '&year=' + year : '';
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get(url.concat(restOfQueryString));
  },
  getMarketPayouts: function getMarketPayouts(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Market/' + marketId + '/Payouts');
  },
  getContractOffers: function getContractOffers(contractId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/contract/' + contractId + '/Offers');
  },
  getContractShares: function getContractShares(contractId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/contract/' + contractId + '/Shares');
  },
  getTradeHistoryMarkets: function getTradeHistoryMarkets() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Trade/History/Markets');
  },
  getMarketWatch: function getMarketWatch(sort, sortPar) {
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var itemsPerPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;

    var sorting = sort ? '?sort=' + sort : '';
    var sortParameter = sorting && sortPar ? '&sortParameter=' + sortPar : '';
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/MarketWatch' + sorting + sortParameter + '&itemsPerPage=' + itemsPerPage + '&page=' + page);
  },
  putMarketWatch: function putMarketWatch(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Profile/MarketWatch/' + marketId);
  },
  deleteMarketWatch: function deleteMarketWatch(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].delete('api/Profile/MarketWatch/' + marketId);
  },
  getPortfolioChart: function getPortfolioChart() {
    var timespan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TIMELINE;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('/api/Profile/Portfolio?timespan=' + timespan);
  },
  putSettings: function putSettings(category, key, value) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Profile/Settings/Categories/' + category + '/Keys/' + key + '/' + value);
  },
  getAllSettings: function getAllSettings(categories) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('/api/Profile/Settings/Categories?categories=' + categories);
  },
  getNotifications: function getNotifications() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var itemsPerPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Notifications?itemsPerPage=' + itemsPerPage + '&page=' + page);
  },
  putNotification: function putNotification(notificationId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Profile/Notifications/' + notificationId + '/read');
  },
  putNotifications: function putNotifications() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Profile/Notifications/markRead');
  },
  postSendInviteEmail: function postSendInviteEmail(email) {
    var payload = {
      email: email
    };
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Profile/invite/email', payload);
  },
  getUnreadNotificationsCount: function getUnreadNotificationsCount() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/UnreadNotificationsCount');
  },
  getUserAffiliations: function getUserAffiliations() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Affiliations');
  },
  setUserAffiliations: function setUserAffiliations(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Profile/Affiliations', payload);
  },
  removeUserAffiliations: function removeUserAffiliations(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].delete('api/Profile/Affiliations', payload);
  },
  getAffiliations: function getAffiliations(search) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Profile/Affiliations/Search/' + search);
  }
});

/***/ }),

/***/ "ahPG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"withdraw-confirm"},[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('h4',{staticClass:"withdraw-confirm__section-title"},[_vm._v("\n    Withdrawal Amount\n    "),(_vm.amendAvailable)?_c('span',{staticClass:"withdraw-confirm__cancel",on:{"click":function($event){$event.preventDefault();return _vm.onEdit($event)}}},[_vm._v("\n      "+_vm._s(_vm.backText)+"\n    ")]):_vm._e()]),_vm._v(" "),(!_vm.isBankTransfer)?_c('amount-info',{attrs:{"amount":_vm.amount,"fee":_vm.fee,"total":_vm.netTotal}}):_c('amount-info',{attrs:{"isBankTransfer":true,"amount":_vm.bankWithdrawAmounts.grossWithdrawalAmount,"flatFeeAmount":_vm.bankWithdrawAmounts.flatFeeAmount,"percentageFeeAmount":_vm.bankWithdrawAmounts.percentageFeeAmount,"total":_vm.bankWithdrawAmounts.netWithdrawalAmount}}),_vm._v(" "),(_vm.isCoinbase)?_c('div',[_c('h4',{staticClass:"withdraw-confirm__section-title"},[_vm._v("\n      Payment Details\n    ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-group"},[_c('div',{staticClass:"content-header__section"},[_c('div',{staticClass:"content-header__section--left"},[_vm._v("\n          Email\n        ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section--right"},[_vm._v("\n          "+_vm._s(_vm.recipient)+"\n        ")])])]),_vm._v(" "),_c('p',{staticClass:"withdraw-confirm__disclaimer"},[_vm._v("\n      Withdrawals are subject to a 5% processing fee and are typically processed twice per week. Once authorized, funds should be deposited within one business day of processing.\n    ")])]):_vm._e(),_vm._v(" "),(_vm.isBankTransfer)?_c('div',[_c('h4',{staticClass:"withdraw-confirm__section-title"},[_vm._v("\n      Payment Details\n    ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-group"},[_c('div',{staticClass:"content-header__section"},[_c('div',{staticClass:"content-header__section--left"},[_vm._v("\n          Bank Name\n        ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section--right"},[_vm._v("\n          "+_vm._s(_vm.beneficiaryInfo.bankName)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section"},[_c('div',{staticClass:"content-header__section--left"},[_vm._v("\n          Account Number\n        ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section--right"},[_vm._v("\n          ********"+_vm._s(_vm.beneficiaryInfo.accountNumberLastFour)+"\n        ")])])])]):_vm._e(),_vm._v(" "),(_vm.isAch)?_c('div',[_c('h4',{staticClass:"withdraw-confirm__section-title"},[_vm._v("\n      Payment Details\n    ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section-group"},[(!_vm.accountDetails.accountId)?[_c('div',{staticClass:"content-header__section"},[_c('div',{staticClass:"content-header__section--left"},[_vm._v("\n            Account Type\n          ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section--right"},[_vm._v("\n            "+_vm._s(_vm.accountDetails.accountTypeLabel)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"content-header__section"},[_c('div',{staticClass:"content-header__section--left"},[_vm._v("\n            Routing Number\n          ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section--right"},[_vm._v("\n            "+_vm._s(_vm.accountDetails.routingNumber)+"\n          ")])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"content-header__section"},[_c('div',{staticClass:"content-header__section--left"},[_vm._v("\n          Account Number\n        ")]),_vm._v(" "),_c('div',{staticClass:"content-header__section--right"},[(_vm.accountDetails.accountId)?_c('span',[_vm._v("********"+_vm._s(_vm.accountDetails.accountLastFourDigits))]):_vm._e(),_vm._v(" "),(!_vm.accountDetails.accountId)?_c('span',[_vm._v(_vm._s(_vm.accountDetails.accountNumber))]):_vm._e()])])],2),_vm._v(" "),_c('p',{staticClass:"withdraw-confirm__disclaimer"},[_vm._v("\n      We remit funds via ACH only to verified account holders with US bank accounts. Withdrawals are subject to a 5% fee and are typically processed twice per week. If authorized, funds should be deposited to your bank account within five business days.\n    ")])]):_vm._e(),_vm._v(" "),(_vm.isCheck)?_c('div',{staticClass:"withdraw-confirm__check"},[_c('h4',{staticClass:"withdraw-confirm__section-title"},[_vm._v("\n      Recipient\n    ")]),_vm._v(" "),_c('div',{staticClass:"withdraw-confirm__address"},[_vm._v("\n      "+_vm._s(_vm.recipient)+"\n      "),_c('br'),_vm._v("\n      "+_vm._s(_vm.addressLine1)+"\n      "),_c('br'),_vm._v("\n      "+_vm._s(_vm.addressLine2)+", "+_vm._s(_vm.addressLine3)+"\n      "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"withdraw-confirm__review-amount-note"},[_vm._v("\n        Our standard processing time for check withdrawals is 7-10 business days.\n      ")]),_vm._v(" "),_c('br')])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"disabled":_vm.hasFailed},on:{"click":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_vm._v("\n    Confirm Request\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aj49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_purchase_purchase_offer_purchase_offer__ = __webpack_require__("JrD7");



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_purchase_purchase_offer_purchase_offer__["a" /* default */]],
  computed: {
    mainClassName: function mainClassName() {
      return 'purchase-offer-desktop';
    },
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--' + this.$router.currentRoute.name, true), _ref;
    }
  }
});

/***/ }),

/***/ "al65":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_button_price_js__ = __webpack_require__("1lzi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd0f8588_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_price_vue__ = __webpack_require__("SSAR");
function injectStyle (ssrContext) {
  __webpack_require__("GC/j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_button_price_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd0f8588_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_price_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ao05":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aoNs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_history_filters_js__ = __webpack_require__("WYZc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a2750ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_filters_vue__ = __webpack_require__("c2tZ");
function injectStyle (ssrContext) {
  __webpack_require__("uWVg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_history_filters_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a2750ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_filters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b+BV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b+hr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('popup', ['currentPopupOptions']), {
    classModifiers: function classModifiers() {
      return {
        'popup-generic-small': true,
        'popup-generic-small--icon': this.currentPopupOptions && this.currentPopupOptions.icon
      };
    }
  })
});

/***/ }),

/***/ "b1G2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b2pe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_index1_js__ = __webpack_require__("j3lF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09c3b56e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index1_vue__ = __webpack_require__("Fq0I");
function injectStyle (ssrContext) {
  __webpack_require__("KCsQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_index1_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09c3b56e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b34v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sold-bought-at"},[_c('span',{staticClass:"sold-bought-at__type"},[_vm._v(_vm._s(_vm.typeToString))]),_vm._v(" "),(_vm.closedText)?[_c('span',{domProps:{"innerHTML":_vm._s(_vm.closedText)}})]:[_c('span',{staticClass:"sold-bought-at__quantity",class:_vm.negativeModifier},[_vm._v(_vm._s(_vm.quantity))]),_vm._v(" at "+_vm._s(_vm.priceToString)+"\r\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b47U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_documentUpload__ = __webpack_require__("9xQS");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["b" /* formMixin */]],
  props: {
    depositPayload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      fields: {
        agreed: false
      }
    };
  },

  computed: {
    amountDisplay: function amountDisplay() {
      return Number(this.depositPayload.amount).toFixed(2);
    },
    isConfirmDisabled: function isConfirmDisabled() {
      return !this.isFormEnabled || !this.fields.agreed;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['submitDepositUSDCoin']), {
    onSubmit: function onSubmit() {
      var _this = this;

      this.formDisable();
      this.loaderAdd(document.body);
      this.submitDepositUSDCoin(this.depositPayload).then(function (data) {
        _this.loaderRemove(document.body);
        if (_this.checkDocumentUploadFlags(data)) return;
        _this.formEnable();
        window.location.href = data.url;
      }).catch(function (error) {
        _this.loaderRemove(document.body);
        if (_this.checkDocumentUploadFlags(error.response.data)) return;
        _this.formEnable();
      });
    }
  })
});

/***/ }),

/***/ "b4Ty":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api_http__ = __webpack_require__("p1CT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__ = __webpack_require__("a0yF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_mobile_wrapper__ = __webpack_require__("S9O8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generics_overlay_overlay_vue__ = __webpack_require__("RuD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_layout_app_layout_vue__ = __webpack_require__("gjXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_app_app_modals_app_modals_vue__ = __webpack_require__("PUuo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_app_app_privacy_statement_app_privacy_statement_vue__ = __webpack_require__("z/nA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_instant_credit__ = __webpack_require__("zAJv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_helpers__ = __webpack_require__("c/9r");


/* eslint-disable consistent-return */


















var RESIZE_HANDLER_TIMEOUT = 500;
var SOCIAL_AUTH_ROUTES = ['disqus-auth', 'social-auth'];

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_userAgent__["a" /* default */]],
  data: function data() {
    return {
      appFlowDisabled: false,
      appInitialPopupShown: false,
      initialised: false,
      disconnectTimeout: null,
      connectTimeout: null,
      connectTimeoutAnonymous: null
    };
  },

  components: {
    overlay: __WEBPACK_IMPORTED_MODULE_7__components_generics_overlay_overlay_vue__["a" /* default */],
    appPrivacyStatement: __WEBPACK_IMPORTED_MODULE_15__components_app_app_privacy_statement_app_privacy_statement_vue__["a" /* default */],
    appLayoutOld: __WEBPACK_IMPORTED_MODULE_8__components_app_app_layout_app_layout_vue__["a" /* default */],
    appModals: __WEBPACK_IMPORTED_MODULE_14__components_app_app_modals_app_modals_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['skipAttachToHomeNotification', 'isTabActive']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['token']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('market', ['activeCategory']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('popup', ['currentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('profile', ['profileStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('user', ['loginWithDisqus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['hasMaintenance', 'isLayoutMobile', 'isShutdownModeOn']), {
    layoutComponent: function layoutComponent() {
      return __WEBPACK_IMPORTED_MODULE_8__components_app_app_layout_app_layout_vue__["a" /* default */];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('app', ['setLayoutWidth', 'setIsTabActive', 'setLiveUpdatesDisabled']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('browse', ['getHeaders']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('user', ['getStatus', 'getAccountDetail', 'getUserInfo', 'login', 'logout', 'setBareToken', 'setUserUnreadNotificationsCount']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('profile', ['getProfileDetail', 'getAllSettings', 'setProfileStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('wallet', ['getBalance', 'clearBalance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('market', ['getBiggestGains']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup', 'setCurrentPopupOptions']), {
    getUserDetailedInformation: function getUserDetailedInformation() {
      var _this = this;

      this.getAccountDetail().then(function (data) {
        _this.setUserUnreadNotificationsCount(data.userUnreadNotificationsCount);
        if (data.idVerified) {
          return _this.getBalance();
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
      }).then(this.getAllSettings).then(this.getStatus).then(function (data) {
        _this.appInitialPopupShown = false;
        if (data && data.isClassicEnabled === false) {
          _this.appFlowDisabled = true;
          _this.appInitialPopupShown = true;
          _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
        }
        var skipRoutes = ['terms-and-conditions', 'password-set'];
        var showVerifyPopup = !skipRoutes.includes(_this.$route.name) && !_this.hasMaintenance && !_this.checkDataIfUserIsVerified(_this.userData);

        if (showVerifyPopup && !_this.appInitialPopupShown) {
          _this.showAccountVerifyPopup();
        } else if (!_this.appInitialPopupShown) {
          _this.showAttachToHomeNotification();
        }
        if (_this.appFlowDisabled) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
        }
        if (_this.userData.idVerified) {
          if (!_this.hasMaintenance && !_this.appInitialPopupShown && _this.balance.accountBalanceDecimal === 0 && !_this.currentPopup && !_this.$route.query.coinbase && // dont show upon returning from coinbase
          _this.$route.name !== 'wallet' && !__WEBPACK_IMPORTED_MODULE_17__services_instant_credit__["a" /* default */].checkIfCanRunAfterLogin() // will be running code check
          ) {
              _this.appInitialPopupShown = true;
              _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS);
            }
          _this.routeQueryHandler();
        } else {
          var showAffiliationPopup = _this.userData.idVerified && data.isUCAffilSet === null && !_this.appInitialPopupShown;
          if (showAffiliationPopup) {
            _this.appInitialPopupShown = true;
            _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__["a" /* MODALS */].AFFILIATIONS);
          }
        }
      }).then(this.getProfileDetail).then(function (data) {
        if (_this.appFlowDisabled) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(1);
        }
        if (__WEBPACK_IMPORTED_MODULE_13__helpers_localStorage__["a" /* default */].get('registeredExternal', false)) {
          __WEBPACK_IMPORTED_MODULE_13__helpers_localStorage__["a" /* default */].del('registeredExternal');
          _this.$gtm.trackEvent({
            event: 'SignUp',
            gtmUserID: data.userGuid,
            otmUserID: data.otmUserId,
            email: _this.userData.email
          });
        } else if (_this.profileStatus.event && _this.profileStatus.event === 'registered') {
          _this.$gtm.trackEvent({
            event: 'SignUp',
            gtmUserID: data.userGuid,
            otmUserID: data.otmUserId,
            email: _this.userData.email
          });
          _this.setProfileStatus({});
        } else if (_this.profileStatus.event && _this.profileStatus.event === 'login') {
          _this.$gtm.trackEvent({ event: 'Login' });
          _this.setProfileStatus({});
          if (__WEBPACK_IMPORTED_MODULE_17__services_instant_credit__["a" /* default */].checkIfCanRunAfterLogin()) {
            // Firing quick deposit with instant credit check
            _this.appInitialPopupShown = true;
            _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS);
            _this.setCurrentPopupOptions({
              checkInstantCredit: true
            });
          }
        } else if (__WEBPACK_IMPORTED_MODULE_17__services_instant_credit__["a" /* default */].checkIfCanRunAfterLogin()) {
          // Firing quick deposit with instant credit check
          _this.appInitialPopupShown = true;
          _this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS);
          _this.setCurrentPopupOptions({
            checkInstantCredit: true
          });
        }
      });
    },
    getUserData: function getUserData() {
      var _this2 = this;

      if (!this.token) return;

      if (SOCIAL_AUTH_ROUTES.includes(this.$route.name)) {
        this.getUserInfo().then(function (response) {
          if (response.data.hasRegistered) {
            _this2.getUserDetailedInformation();
          }
        });
      } else {
        this.getUserDetailedInformation();
      }
    },
    storageHandler: function storageHandler() {
      var storageToken = __WEBPACK_IMPORTED_MODULE_13__helpers_localStorage__["a" /* default */].get('token', null);
      // token removed from localstorage (user logged out in other tab/window)
      if (this.token && !storageToken) {
        this.logout();
        // token added to localstorage and it's different --> update app state
      } else if (this.token && this.token !== storageToken) {
        this.clearBalance();
        this.setBareToken(storageToken);
      }
    },
    resizeHandler: function resizeHandler() {
      var _this3 = this;

      setTimeout(function () {
        var width = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
        _this3.setLayoutWidth(width);
      }, RESIZE_HANDLER_TIMEOUT);
    },
    orientationChangeHandler: function orientationChangeHandler() {
      var _this4 = this;

      setTimeout(function () {
        if (_this4.isLayoutMobile && _this4.getOrientation() === 'landscape' && !_this4.isTablet) {
          _this4.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__["a" /* MODALS */].ORIENTATION);
        } else if (_this4.currentPopup === __WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__["a" /* MODALS */].ORIENTATION) {
          _this4.setCurrentPopup();
        }
      }, 10);
    },
    refreshAccessToken: function refreshAccessToken() {
      var _this5 = this;

      if (!this.token) return;
      var expiresAt = __WEBPACK_IMPORTED_MODULE_13__helpers_localStorage__["a" /* default */].get('tokenExpires', null);
      var threshold = -parseInt("60", 10);
      var hasExpired = expiresAt === null || __WEBPACK_IMPORTED_MODULE_2_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(expiresAt), 'seconds') > threshold;
      // no expires at or expires in less than a minute
      if (hasExpired) {
        var payload = {
          grant_type: 'refresh_token',
          refresh_token: __WEBPACK_IMPORTED_MODULE_13__helpers_localStorage__["a" /* default */].get('refreshToken')
        };
        this.login(payload).catch(function () {
          return _this5.logout();
        });
      }
    },
    accessTokenRenewal: function accessTokenRenewal() {
      var _this6 = this;

      clearInterval(this.tokenInterval);
      this.tokenInterval = setInterval(function () {
        _this6.refreshAccessToken();
      }, parseInt("60", 10) * 1000);
    },
    showAttachToHomeNotification: function showAttachToHomeNotification() {
      var _this7 = this;

      if (!this.token || this.skipAttachToHomeNotification || !this.isIos || this.isStandalone || this.currentPopup || this.hasMaintenance || this.iOSWrapper) return;
      setTimeout(function () {
        return _this7.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__["a" /* MODALS */].ATTACH_TO_HOME);
      }, __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* default */].DEFAULT_SMALL_POPUP_TIMEOUT);
    },
    setupUI: function setupUI() {
      document.body.classList.remove('splash');
      if (this.isStandalone) document.body.classList.add('standalone');
      if (this.isIos) {
        document.documentElement.classList.add('ios');
        document.body.classList.add('ios');
      }
      if (this.isIE) {
        document.body.classList.add('ie');
      }
      if (this.isEdge) {
        document.body.classList.add('edge');
      }
      if (this.isShutdownModeOn) {
        document.body.classList.add('shutdown');
      }
    },
    pwaRedirect: function pwaRedirect() {
      var routePath = __WEBPACK_IMPORTED_MODULE_13__helpers_localStorage__["a" /* default */].get('currentRoutePath', null);
      if (this.isStandalone && routePath && routePath !== '/') {
        this.$router.push(routePath);
      } else if (this.isStandalone && routePath === null) {
        this.$router.push({ name: 'home' });
      }
    },
    routeQueryHandler: function routeQueryHandler() {
      if (this.$route.query.coinbase === 'success') {
        this.$router.push({ name: 'market-list' });
      }
      if (this.$route.name !== 'wallet' && this.$route.query.quickdeposit && this.$route.query.quickdeposit === 'true') {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS);
      }
    },
    initializeUserData: function initializeUserData() {
      // when user comes from social login we need to fetch data manually
      // because he doesnt have refreshToken witch causes
      // token watch to trigger
      if (__WEBPACK_IMPORTED_MODULE_13__helpers_localStorage__["a" /* default */].get('refreshToken', null) && !SOCIAL_AUTH_ROUTES.includes(this.$route.name)) {
        this.refreshAccessToken();
      }
    },
    tokenHandler: function tokenHandler(newToken) {
      var _this8 = this;

      var secondsToDelay = parseInt("3", 10);

      if (this.initialised && !newToken) {
        var routeRequiresAuth = this.$route && this.$route.matched ? this.$route.matched.some(function (record) {
          return record.meta.requiresAuth;
        }) : true;
        __WEBPACK_IMPORTED_MODULE_6__services_mobile_wrapper__["a" /* default */].userLoggedOut();
        __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].logout();
        if (routeRequiresAuth) {
          window.location.href = "/";
        } else {
          window.location.reload();
        }
      } else if (newToken) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_api_http__["a" /* authorizeApi */])(newToken);
        this.getUserData();
        __WEBPACK_IMPORTED_MODULE_6__services_mobile_wrapper__["a" /* default */].userLoggedIn(newToken);
        this.connectTimeout = setTimeout(function () {
          clearTimeout(_this8.connectTimeoutAnonymous);
          __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].init();
          __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].authorize(newToken);
          if (__WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].shouldSetupMessaging()) {
            __WEBPACK_IMPORTED_MODULE_12__logger__["a" /* default */].info('[MESSAGING] User is opted in. Setting up messaging');
            __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].setupMessaging();
          } else {
            __WEBPACK_IMPORTED_MODULE_12__logger__["a" /* default */].info('[MESSAGING] User is opted out or hasnt made messaging decision');
          }
        }, secondsToDelay * 1000);
        // this.accessTokenRenewal();
      } else {
        this.connectTimeoutAnonymous = setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].init();
        }, secondsToDelay * 1000);
      }
      this.initialised = true;
    },
    windowOnFocusHandler: function windowOnFocusHandler() {
      this.setIsTabActive(true);
    },
    windowOnBlurHandler: function windowOnBlurHandler() {
      this.setIsTabActive(false);
    },
    isTabActiveHandler: function isTabActiveHandler(value) {
      var _this9 = this;

      var secondsToDelay = parseInt("0", 10);
      if (!secondsToDelay) return;
      // no need to do that on mobile as browser closes tabs there
      if (this.isLayoutMobile) return;
      if (!this.isLoggedIn && !false) return;

      if (value) {
        clearTimeout(this.disconnectTimeout);
      } else {
        this.disconnectTimeout = setTimeout(function () {
          _this9.setLiveUpdatesDisabled(true);
          __WEBPACK_IMPORTED_MODULE_5__services_notifications_proxy__["a" /* default */].forceDisconnect();
        }, secondsToDelay * 1000);
      }
    },
    optimoveHandler: function optimoveHandler() {
      if (false) {
        return _Promise.resolve(1);
      }
      var url = 'https://sdk-cdn.optimove.net/websdk/sdk-v1.0.4.js';
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_helpers__["a" /* loadScript */])(url, 'optimoveSDK').then(function (optimoveSDK) {
        var options = {
          showDimmer: true,
          showWatermark: false,
          reportEventCallback: function reportEventCallback(response) {
            if (response.Data) {
              var elem = document.createElement('div');
              elem.innerHTML = response.Data;
              document.body.appendChild(elem);
            }
          }
        };
        optimoveSDK.API.setRealTimeOptions(options);
      });
    }
  }),
  watch: {
    token: {
      handler: 'tokenHandler',
      immediate: true
    },
    isTabActive: {
      handler: 'isTabActiveHandler',
      immediate: true
    }
  },
  created: function created() {
    this.setupUI();
    this.pwaRedirect();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_api_http__["a" /* authorizeApi */])(this.token);
    this.getHeaders();
    window.onfocus = this.windowOnFocusHandler;
    window.onblur = this.windowOnBlurHandler;
    window.addEventListener('orientationchange', this.orientationChangeHandler);
    window.addEventListener('resize', this.resizeHandler);
    window.addEventListener('storage', this.storageHandler);
    this.resizeHandler();
    this.initializeUserData();
    // this.optimoveHandler();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('orientationchange', this.orientationChangeHandler);
    window.removeEventListener('resize', this.resizeHandler);
    window.removeEventListener('storage', this.storageHandler);
  }
});

/***/ }),

/***/ "b8IF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bCxM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"insight-widget__header"},[_vm._v("\n    Insights\n  ")]),_vm._v(" "),_c('div',{staticClass:"insight-widget__line"}),_vm._v(" "),_c('div',{staticClass:"insight-widget__content"},[_c('insight-panel',{attrs:{"text":"All Articles","href":_vm.allArticlesLink,"away":_vm.allArticlesAway}},[_c('div',{staticClass:"insight-widget__articles"},_vm._l((_vm.tumblr),function(link){return _c('insight-link',{key:link.title,attrs:{"title":link.title,"href":_vm.createLink(link.url),"url":link.url}})}),1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bFAx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_top_comment_js__ = __webpack_require__("xTWr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5457fc2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_top_comment_vue__ = __webpack_require__("sWg+");
function injectStyle (ssrContext) {
  __webpack_require__("Nm85")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_top_comment_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5457fc2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_top_comment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bG/B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classModifier,on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bGo9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bK7s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bOvU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bREw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_sessionStorage__ = __webpack_require__("63Fj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_notifications_firebase__ = __webpack_require__("2Pqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("oiih");

/* eslint-disable max-len */








var TOKEN_EXPIRES_IN_MINUTES = 28;
var TOKEN_EXPIRES_DATE_FMT = 'YYYY-MM-DD HH:mm:s';

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  getters: {
    isLoggedIn: function isLoggedIn(state) {
      return !!state.token;
    },
    loginWithDisqus: function loginWithDisqus(state) {
      return state.disqusLogin && state.status.useDisqus;
    },
    isUserRestricted: function isUserRestricted(state, getters) {
      return false && !getters.isLoggedIn;
    }
  },
  state: {
    userUnreadNotificationsCount: 0,
    userData: {},
    userInfo: {},
    loginIsBeingCalled: false,
    token: __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get('token'),
    refreshToken: __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get('refreshToken'),
    status: {},
    disqusLogin: __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get('disqusLogin', true),
    marketDisplay: 'grid',
    usernameTries: 0,
    watchedUserDetails: {}
    // marketDisplay: ls.get('marketDisplay', 'grid'),
  },
  mutations: {
    login: function login(state, user) {
      state.token = user.access_token;
      state.refreshToken = user.refresh_token;
      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].set('token', user.access_token);
      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].set('tokenExpires', __WEBPACK_IMPORTED_MODULE_1_moment___default()(user['.expires']).format(TOKEN_EXPIRES_DATE_FMT));
      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].set('refreshToken', user.refresh_token);
    },
    logout: function logout(state) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      state.token = data;
      state.refreshToken = data;
      state.userData = {};
      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].del('tokenExpires');
      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].del('currentRoutePath');
      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].del('token');
      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].del('refreshToken');
      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].del('disqusLogin');
      __WEBPACK_IMPORTED_MODULE_4__helpers_sessionStorage__["a" /* default */].del('lastInstantCredit');
      __WEBPACK_IMPORTED_MODULE_4__helpers_sessionStorage__["a" /* default */].del('PIReferral');
      __WEBPACK_IMPORTED_MODULE_4__helpers_sessionStorage__["a" /* default */].del('utm_campaign');
      __WEBPACK_IMPORTED_MODULE_4__helpers_sessionStorage__["a" /* default */].del('utm_source');
      __WEBPACK_IMPORTED_MODULE_4__helpers_sessionStorage__["a" /* default */].del('utm_code');
      __WEBPACK_IMPORTED_MODULE_4__helpers_sessionStorage__["a" /* default */].del('instant_credit');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_notifications_firebase__["c" /* cleanupMessaging */])();
    },
    clearRefreshToken: function clearRefreshToken(state) {
      state.refreshToken = null;
      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].del('refreshToken');
    },
    setStatus: function setStatus(state, status) {
      state.status = status;
    },
    setUserData: function setUserData(state, data) {
      state.userData = data;
    },
    increaseUserUnreadNotificationsCount: function increaseUserUnreadNotificationsCount(state) {
      state.userUnreadNotificationsCount += 1;
    },
    setUserUnreadNotificationsCount: function setUserUnreadNotificationsCount(state, count) {
      state.userUnreadNotificationsCount = count;
    },
    setUserInfo: function setUserInfo(state, data) {
      state.userInfo = data;
    },
    setBareToken: function setBareToken(state, data) {
      state.token = data;
    },
    setToken: function setToken(state, data) {
      var expires = __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(TOKEN_EXPIRES_IN_MINUTES, 'minutes').format(TOKEN_EXPIRES_DATE_FMT);
      state.token = data;
      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].set('token', data);
      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].set('tokenExpires', expires);
    },
    setRefreshToken: function setRefreshToken(state, data) {
      state.refreshToken = data;
      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].set('refreshToken', data);
    },
    updateMarketDisplay: function updateMarketDisplay(state, payload) {
      state.marketDisplay = payload;
      __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].set('marketDisplay', payload, "31536000");
    },
    setUseDisqus: function setUseDisqus(state, payload) {
      if (payload) {
        state.disqusLogin = true;
        __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].set('disqusLogin', payload, "31536000");
      } else {
        state.disqusLogin = false;
        __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].del('disqusLogin');
      }
    },
    setUsernameTries: function setUsernameTries(state, count) {
      state.usernameTries = count;
    },
    setLoginIsBeingCalled: function setLoginIsBeingCalled(state, value) {
      state.loginIsBeingCalled = value;
    },
    setWatchedUserDetails: function setWatchedUserDetails(state, trader) {
      state.watchedUserDetails = trader;
    }
  },
  actions: {
    loginDisqus: function loginDisqus() {
      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.getDisqusLogin().then(function (response) {
        return response.data;
      });
    },
    logoutDisqus: function logoutDisqus() {
      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.getDisqusLogout().then(function (response) {
        return response.data;
      });
    },
    getDisqusUserAuth: function getDisqusUserAuth() {
      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.getDisqusUserAuth().then(function (response) {
        return response.data;
      });
    },
    login: function login(_ref) {
      var commit = _ref.commit,
          state = _ref.state;
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (state.loginIsBeingCalled) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({});

      commit('setLoginIsBeingCalled', true);
      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.postToken(payload).then(function (response) {
        commit('setLoginIsBeingCalled', false);
        commit('login', response.data);
        return response.data;
      }).catch(function (error) {
        commit('setLoginIsBeingCalled', false);
        throw error;
      });
    },
    logout: function logout(_ref2) {
      var commit = _ref2.commit;
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.postLogout().then(function () {
        commit('logout', data);
      }).catch(function () {
        commit('logout', data);
      });
    },
    register: function register(_ref3, payload) {
      var commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.postRegister(payload);
    },
    registerExternal: function registerExternal(_ref4, payload) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.postRegisterExternal(payload);
    },
    getExternalLogins: function getExternalLogins(_ref5, _ref6) {
      var commit = _ref5.commit;
      var _ref6$pathname = _ref6.pathname,
          pathname = _ref6$pathname === undefined ? window.location.pathname : _ref6$pathname,
          _ref6$type = _ref6.type,
          type = _ref6$type === undefined ? __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].SOCIAL_LOGIN_OR_REGISTER : _ref6$type;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.getExternalLogins(pathname, type);
    },
    addExternal: function addExternal(_ref7, payload) {
      var commit = _ref7.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.postAddExternalLogin(payload).then(function (response) {
        return response.data;
      });
    },
    removeExternal: function removeExternal(_ref8, payload) {
      var commit = _ref8.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.postRemoveLogin(payload).then(function (response) {
        return response.data;
      });
    },
    getUserInfo: function getUserInfo(_ref9) {
      var commit = _ref9.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.getUserInfo().then(function (response) {
        commit('setUserInfo', response.data);
        return response;
      });
    },
    getManageInfo: function getManageInfo() {
      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.getManageInfo().then(function (response) {
        return response.data;
      });
    },
    getAccountDetail: function getAccountDetail(_ref10) {
      var commit = _ref10.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.getAccountDetail().then(function (response) {
        commit('setUserData', response.data);
        return response.data;
      });
    },
    getVerifyID: function getVerifyID() {
      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.getVerifyID().then(function (response) {
        return response;
      });
    },
    verifyID: function verifyID(_ref11, payload) {
      var commit = _ref11.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.postVerifyID(payload).then(function (response) {
        return response.data;
      });
    },
    getStatus: function getStatus(_ref12) {
      var commit = _ref12.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.getStatus().then(function (response) {
        commit('setStatus', response.data);
        return response.data;
      });
    },
    resetPassword: function resetPassword(_ref13, payload) {
      var commit = _ref13.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.postResetPassword(payload);
    },
    forgotPassword: function forgotPassword(_ref14, payload) {
      var commit = _ref14.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.postForgotPassword(payload).then(function (response) {
        return response.data;
      });
    },
    changePassword: function changePassword(_ref15, payload) {
      var commit = _ref15.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.postChangePassword(payload);
    },
    setPassword: function setPassword(_ref16, payload) {
      var commit = _ref16.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.postSetPassword(payload);
    },
    uploadUserImage: function uploadUserImage(_ref17, payload) {
      var commit = _ref17.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.postUploadUserImage(payload);
    },
    resetUserImage: function resetUserImage() {
      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.putResetUserImage();
    },
    getCommunicationPreferences: function getCommunicationPreferences() {
      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.getCommunicationPreferences().then(function (response) {
        return response.data;
      });
    },
    setCommunicationPreferences: function setCommunicationPreferences(_ref18, payload) {
      var commit = _ref18.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.postCommunicationPreferences(payload).then(function (response) {
        return response.data;
      });
    },
    setBareToken: function setBareToken(_ref19, payload) {
      var commit = _ref19.commit;

      commit('setBareToken', payload);
    },
    setToken: function setToken(_ref20, payload) {
      var commit = _ref20.commit;

      commit('setToken', payload);
    },
    setRefreshToken: function setRefreshToken(_ref21, payload) {
      var commit = _ref21.commit;

      commit('setRefreshToken', payload);
    },
    getCaptchaSiteKey: function getCaptchaSiteKey() {
      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.getCaptchaSiteKey().then(function (response) {
        return response.data;
      });
    },
    setUseDisqus: function setUseDisqus(_ref22) {
      var commit = _ref22.commit;
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        commit('setUseDisqus', payload);
        resolve();
      });
    },
    getIdUploadUrl: function getIdUploadUrl() {
      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.getIdUploadUrl().then(function (response) {
        return response.data;
      });
    },
    getTaxInfo: function getTaxInfo(_ref23, _ref24) {
      var commit = _ref23.commit;
      var _ref24$reasonCode = _ref24.reasonCode,
          reasonCode = _ref24$reasonCode === undefined ? '' : _ref24$reasonCode;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.getTaxInfo({ reasonCode: reasonCode }).then(function (response) {
        return response.data;
      });
    },
    postTaxInfo: function postTaxInfo(_ref25, payload) {
      var commit = _ref25.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.postTaxInfo(payload).then(function (response) {
        return response.data;
      });
    },
    updateMarketDisplay: function updateMarketDisplay(_ref26, payload) {
      var commit = _ref26.commit;

      return commit('updateMarketDisplay', payload);
    },
    clearRefreshToken: function clearRefreshToken(_ref27) {
      var commit = _ref27.commit;

      commit('clearRefreshToken');
    },
    setUserUnreadNotificationsCount: function setUserUnreadNotificationsCount(_ref28, count) {
      var commit = _ref28.commit;

      commit('setUserUnreadNotificationsCount', count);
    },
    increaseUserUnreadNotificationsCount: function increaseUserUnreadNotificationsCount(_ref29) {
      var commit = _ref29.commit;

      commit('increaseUserUnreadNotificationsCount');
    },
    getUserNameTries: function getUserNameTries(_ref30) {
      var commit = _ref30.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.getChangeUsername().then(function (response) {
        commit('setUsernameTries', response.data);
        return response.data;
      });
    },
    changeUserName: function changeUserName(_ref31, username) {
      var commit = _ref31.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.postChangeUsername(username).then(function (response) {
        return response.data;
      });
    },
    getDocumentUploadLink: function getDocumentUploadLink(_ref32, source) {
      var commit = _ref32.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.getDocumentUploadLink(source).then(function (response) {
        return response.data;
      });
    },
    setWatchedUserDetails: function setWatchedUserDetails(_ref33, trader) {
      var commit = _ref33.commit;

      commit('setWatchedUserDetails', trader);
    },
    agreeToTerms: function agreeToTerms(_ref34, payload) {
      var commit = _ref34.commit;

      return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].account.putAgreedToTerms(payload).then(function (response) {
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "bTUM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-unit-slider"},[(_vm.items)?_c('swiper',{attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.items),function(banner){return _c('swiper-slide',{key:banner.carouselId,staticClass:"hero-unit-slider__slide"},[_c('div',{staticClass:"hero-unit-slider__image",style:(_vm.bannerImageStyleModifiers(banner.carouselData.image))}),_vm._v(" "),_c('div',{staticClass:"hero-unit-slider__content"},[(banner.carouselData.carouselItemHeader.secondLine)?_c('p',{staticClass:"hero-unit-slider__para",domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemHeader.secondLine)}}):_vm._e(),_vm._v(" "),(banner.carouselData.carouselItemHeader.firstLine)?_c('h2',{staticClass:"hero-unit-slider__headline",domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemHeader.firstLine)}}):_vm._e(),_vm._v(" "),(banner.carouselData.carouselItemButton)?_c('button',{staticClass:"button button--medium button--submit hero-unit-slider__button",style:(_vm.buttonStyleModifiers(banner.carouselData.carouselItemButton)),domProps:{"innerHTML":_vm._s(banner.carouselData.carouselItemButton.text)},on:{"click":function($event){$event.stopPropagation();return _vm.onNavigate(banner)}}}):_vm._e()])])}),_vm._v(" "),_c('div',{staticClass:"hero-unit-slider__pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bTYh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [],
      swiperOptions: {
        loop: false,
        autoplay: 5000,
        direction: 'horizontal',
        pagination: '.hero-unit-slider__pagination',
        paginationClickable: true
      }
    };
  },

  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getCarousel']), {
    onNavigate: function onNavigate(banner) {
      if (banner.carouselData.carouselItemButton.url) {
        window.location.href = banner.carouselData.carouselItemButton.url;
      } else if (banner.carouselData.marketId) {
        this.$router.push({ name: 'market-details', params: { marketId: banner.carouselData.marketId } });
      }
    },
    bannerImageStyleModifiers: function bannerImageStyleModifiers(url) {
      if (!url) return {};
      return {
        'background-image': 'url(\'' + url + '\')'
      };
    },
    buttonStyleModifiers: function buttonStyleModifiers(button) {
      var styles = {};
      if (button.backgroundColor) {
        styles.backgroundColor = button.backgroundColor;
        styles.borderColor = button.backgroundColor;
      }
      return styles;
    }
  }),
  created: function created() {
    var _this = this;

    this.getCarousel().then(function (data) {
      _this.items = data;
    });
  }
});

/***/ }),

/***/ "bVL2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-loader"},[_c('div',{staticClass:"market-loader__data"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bWQR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-related"},[(_vm.show)?[_c('collapsible-panel',{key:_vm.isOpen,attrs:{"noPadding":true,"darkHeader":true,"canClose":false,"isOpen":_vm.isOpen,"showChevron":!_vm.isOpen,"theme":"small-header"},on:{"toggle":function($event){return _vm.$emit('toggle-related')}}},[_c('div',{staticClass:"market-related__title",attrs:{"slot":"title"},slot:"title"},[_c('span',{staticClass:"market-related__title-text"},[_vm._v("Related Markets")])]),_vm._v(" "),_c('div',{staticClass:"market-related__content"},_vm._l((_vm.related),function(item){return _c('div',{staticClass:"market-related__item"},[_c('market-list-item',{key:item.marketId,attrs:{"market":item}})],1)}),0)])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bY65":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bYWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_main_nav_app_main_nav_vue__ = __webpack_require__("3cKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__ = __webpack_require__("BL43");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_notifications_widget_notifications_widget_vue__ = __webpack_require__("oY3V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_header_notification_app_header_notification_vue__ = __webpack_require__("dMVO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_app_app_secondary_nav_app_secondary_nav_vue__ = __webpack_require__("O8vu");











var BALANCE_THRESHOLD = 0;
var DONT_SHOW_LOGIN_AND_SIGN_UP_BUTTONS_ROUTES = ['account-page-login', 'account-page-register', 'account-password-forgotten', 'index1', 'index2'];

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_socialLevel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_unreadNotification__["a" /* default */]],
  components: {
    appMainNav: __WEBPACK_IMPORTED_MODULE_2__components_app_app_main_nav_app_main_nav_vue__["a" /* default */],
    notificationsWidget: __WEBPACK_IMPORTED_MODULE_7__components_notifications_widget_notifications_widget_vue__["a" /* default */],
    appHeaderNotification: __WEBPACK_IMPORTED_MODULE_8__components_app_app_header_notification_app_header_notification_vue__["a" /* default */],
    appSecondaryNav: __WEBPACK_IMPORTED_MODULE_9__components_app_app_secondary_nav_app_secondary_nav_vue__["a" /* default */]
  },
  data: function data() {
    return {
      MODALS: __WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn', 'isUserRestricted']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('browse', ['areUserBrowseHeadersEmpty']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['balance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop', 'isShutdownModeOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['settings']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('notifications', ['showNotificationsWidget']), {
    showLoginAndSignUpButtons: function showLoginAndSignUpButtons() {
      return !DONT_SHOW_LOGIN_AND_SIGN_UP_BUTTONS_ROUTES.includes(this.$route.name);
    },
    showSocialAvatarDesktop: function showSocialAvatarDesktop() {
      return false;
      // return this.isLoggedIn && this.isLayoutDesktop;
    },
    headerPrimaryMenuModifiers: function headerPrimaryMenuModifiers() {
      return {
        'header-old-primary__menu-nav': true,
        'header-old-primary__menu-nav--with-avatar-and-notifications': this.showSocialAvatarDesktop
      };
    },
    showBalanceHeader: function showBalanceHeader() {
      return this.settings.display ? this.settings.display.ShowBalanceHeader : true;
    },
    notifyOnLowBalance: function notifyOnLowBalance() {
      return this.balance.accountBalanceDecimal <= BALANCE_THRESHOLD;
    },
    valueClassModifiers: function valueClassModifiers() {
      var value = this.balance.accountBalanceDecimal;
      return {
        'header-old-primary__menu-item--plus': !this.notifyOnLowBalance && value > 0,
        'header-old-primary__menu-item--neutral': !this.notifyOnLowBalance && (typeof value === 'undefined' || value === 0),
        'header-old-primary__menu-item--minus': this.notifyOnLowBalance || value < 0
      };
    },
    isNotificationIconActive: function isNotificationIconActive() {
      return this.$route.name === 'notifications' || this.showNotificationsWidget;
    },
    showUnreadNotificationCount: function showUnreadNotificationCount() {
      return !this.isNotificationIconActive && this.userUnreadNotificationsCountHeader > 0;
    },
    notificationsIconModifiers: function notificationsIconModifiers() {
      return {
        'header-old-primary__menu-notifications': true,
        'header-old-primary__menu-notifications--unread': this.showUnreadNotificationCount,
        'header-old-primary__menu-notifications--mobile': this.isLayoutMobile,
        'header-old-primary__menu-notifications--active': this.isNotificationIconActive
      };
    },
    depositIconModifiers: function depositIconModifiers() {
      var disabled = this.$route.name === 'wallet';
      return {
        'header-old-primary__menu-item--deposit': true,
        'header-old-primary__menu-item--deposit-disabled': disabled
      };
    },
    depositTitleModifiers: function depositTitleModifiers() {
      var disabled = this.$route.name === 'wallet';
      return {
        'header-old-primary__menu-item__title': true,
        'header-old-primary__menu-item__title--deposit': true,
        'header-old-primary__menu-item__title--deposit-disabled': disabled
      };
    }
  }),
  watch: {
    showNotificationsWidget: function showNotificationsWidget(value) {
      if (!value) {
        this.clearAllNotifications();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['toggleNotificationsWidget']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('search', ['toggleSearchBar']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['logout']), {
    onCashClick: function onCashClick() {
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
        return;
      } else if (!this.isUserVerified) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_VERIFY);
        return;
      }
      this.$router.push({ name: 'wallet' });
    },
    onSignUp: function onSignUp() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].REGISTER);
    },
    openDepositPopup: function openDepositPopup() {
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
      } else if (this.isUserVerified) {
        if (this.$route.name !== 'wallet') {
          this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS);
        }
      } else {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_6__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_VERIFY);
      }
    },
    onAvatarClick: function onAvatarClick() {
      this.$router.push({ name: 'portfolio' });
    },
    onNotificationsClick: function onNotificationsClick() {
      if (this.isLayoutDesktop && this.$route.name !== 'notifications') {
        this.toggleNotificationsWidget();
      } else if (this.isLayoutMobile && this.$route.name === 'notifications') {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: 'notifications' });
      }
    }
  })
});

/***/ }),

/***/ "bbNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: String,
    text: String,
    url: String
  },
  computed: {
    isLink: function isLink() {
      return this.type === 'link';
    },
    isButton: function isButton() {
      return this.type === 'button';
    }
  }
});

/***/ }),

/***/ "bkfp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_footer_js__ = __webpack_require__("NGyh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6acd8d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_footer_vue__ = __webpack_require__("3YBe");
function injectStyle (ssrContext) {
  __webpack_require__("+W5i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6acd8d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "blla":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bvK5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    items: {
      type: Array,
      required: true,
      validator: function validator(value) {
        return value.length > 0;
      }
    },
    theme: {
      type: String,
      required: false,
      default: 'default'
    },
    activeTab: {
      type: String,
      default: null
    }
  },
  created: function created() {
    if (this.activeTab) {
      this.onChange(this.activeTab, true);
    } else {
      this.onChange(this.items[0].name);
    }
  },
  data: function data() {
    return {
      currentTab: this.activeTab
    };
  },

  watch: {
    activeTab: function activeTab(tab) {
      if (tab !== this.currentTab) {
        this.onChange(tab);
      }
    }
  },
  methods: {
    tabLinkModifiers: function tabLinkModifiers(item) {
      var _ref;

      return _ref = {
        tabs__link: true,
        'tabs__link--with-icon': item.icon
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'tabs__link--' + this.theme + '-' + item.name, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'tabs__link--stats', item.kind && item.kind === 'stats'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'tabs__link--active', item.name === this.currentTab), _ref;
    },
    tabItemModifiers: function tabItemModifiers(item) {
      return {
        tabs__item: true,
        'tabs__item--stats': item.kind && item.kind === 'stats'
      };
    },
    tabIconModifiers: function tabIconModifiers(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        tabs__icon: true
      }, 'tabs__icon--' + item.icon, item.icon);
    },
    onChange: function onChange(name) {
      var startedWithActiveTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (name !== this.currentTab) {
        this.currentTab = name;
        this.$emit('tabChange', name);
      } else if (startedWithActiveTab) {
        this.$emit('tabChange', this.currentTab);
      }
    }
  }
});

/***/ }),

/***/ "bwq/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__("H/Zg");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    mostPopular: null,
    analysis: null,
    news: []
  },
  mutations: {
    updateMostPopular: function updateMostPopular(state, payload) {
      state.mostPopular = payload;
    },
    updateAnalysis: function updateAnalysis(state, payload) {
      state.analysis = payload;
    },
    updateNews: function updateNews(state, payload) {
      state.news = payload;
    }
  },
  actions: {
    getMostPopular: function getMostPopular(_ref, payload) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].insight.getMostPopular(payload.interval, payload.count).then(function (response) {
        commit('updateMostPopular', response.data);
        return response.data;
      });
    },
    getAnalysis: function getAnalysis(_ref2, _ref3) {
      var commit = _ref2.commit;
      var _ref3$limit = _ref3.limit,
          limit = _ref3$limit === undefined ? 4 : _ref3$limit,
          _ref3$offset = _ref3.offset,
          offset = _ref3$offset === undefined ? 0 : _ref3$offset;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].insight.getAnalysis(limit, offset).then(function (response) {
        commit('updateAnalysis', response.data);
        return response.data;
      });
    },
    getFeeds: function getFeeds() {
      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].insight.getFeeds().then(function (response) {
        return response.data;
      });
    },
    getMarketFeeds: function getMarketFeeds(_ref4, marketId) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].insight.getMarketFeeds(marketId).then(function (response) {
        return response.data;
      });
    },
    getNews: function getNews(_ref5) {
      var commit = _ref5.commit;

      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref6$limit = _ref6.limit,
          limit = _ref6$limit === undefined ? 4 : _ref6$limit,
          _ref6$offset = _ref6.offset,
          offset = _ref6$offset === undefined ? 0 : _ref6$offset;

      return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].insight.getNews(limit, offset).then(function (response) {
        commit('updateNews', response.data);
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "bynG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_rules_js__ = __webpack_require__("1FJm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68a0d0bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_rules_vue__ = __webpack_require__("SM2J");
function injectStyle (ssrContext) {
  __webpack_require__("Bkaa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_rules_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68a0d0bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_rules_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bzh+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-tile",class:_vm.darkModifier},[_c('router-link',{staticClass:"link-tile__link",attrs:{"to":_vm.href}},[_c('div',{staticClass:"link-tile__icon"},[_c('img',{attrs:{"src":_vm.icon,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"link-tile__content"},[_c('h2',{staticClass:"link-tile__content-title",class:_vm.titleModifier},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.subtitle)?_c('h3',{staticClass:"link-tile__content-subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"link-tile__arrow"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c/9r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return capitalizeFirstLetter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRedirectUrl; });
/* unused harmony export DEFAULT_DATE_FORMAT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return dateToString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return priceDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return updateObjectValues; });
/* unused harmony export capitalize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return toCents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return correctPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return isNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isMarketSingle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return contractOwnershipNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isMarketSettled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isMarketExpired; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return isMarketSuspended; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isMarketClosed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return hasMarketStatusMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return hasMarketPayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasMarketHiddenContracts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isContractOpen; });
/* harmony export (immutable) */ __webpack_exports__["h"] = largeNumberDisplay;
/* unused harmony export elementOffset */
/* harmony export (immutable) */ __webpack_exports__["z"] = marketUserGainLoss;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return smartbtoa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return smartatob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return groupByKeepOrder; });
/* harmony export (immutable) */ __webpack_exports__["i"] = roundToTwo;
/* harmony export (immutable) */ __webpack_exports__["v"] = roundDown;
/* unused harmony export roundTop */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCardTypeForNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getOrdinalSuffix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadScript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return parseQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getAssetPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__ = __webpack_require__("a0yF");





/* eslint-disable */





var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
var getRedirectUrl = function getRedirectUrl(path) {
  var rootPath = "/".slice(0, -1);
  return window.location.protocol + '//' + window.location.host + rootPath + path;
};
var DEFAULT_DATE_FORMAT = 'MM/DD/YYYY hh:mm a';
var dateToString = function dateToString(string) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DATE_FORMAT;
  return __WEBPACK_IMPORTED_MODULE_5_moment___default()(string).format(fmt) + ' (ET)';
};
var priceDisplay = function priceDisplay(num) {
  return num.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
var updateObjectValues = function updateObjectValues(obj, data) {
  var map = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var setTimestampFor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [__WEBPACK_IMPORTED_MODULE_7__services_notifications_proxy__["b" /* NOTIFICATION_CONTRACT_OWNERSHIP */]];

  var result = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, obj);
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
    var timestampKey = 'timestamp';
    var objKey = typeof map[key] !== 'undefined' ? map[key] : key;
    if (typeof result[objKey] !== 'undefined' && objKey !== timestampKey || setTimestampFor.includes(data.UpdateType) && objKey === timestampKey) {
      // timestamp prop is updated only for certain notifications
      result[objKey] = data[key];
    }
  });

  return result;
};
var capitalize = function capitalize(input) {
  return input.charAt(0).toUpperCase() + input.slice(1);
};
var toCents = function toCents(input) {
  return Math.round(100 * input);
};
var correctPrice = function correctPrice(input) {
  return !isNaN(input) && input < 100 ? input : 0;
};
var isNumber = function isNumber(input) {
  return !isNaN(parseFloat(input)) && isFinite(input);
};
var isMarketSingle = function isMarketSingle(market) {
  return market && (market.type === 'Single' || market.marketType === 0 || market.MarketType === 0);
};
var contractOwnershipNum = function contractOwnershipNum(contract) {
  return contract.userQuantity + contract.userOpenOrdersBuyQuantity + contract.userOpenOrdersSellQuantity;
};
var isMarketSettled = function isMarketSettled(market) {
  return market && market.status === __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].MARKET_SETTLED;
};
var isMarketExpired = function isMarketExpired(market) {
  return market && market.status === __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].MARKET_EXPIRED;
};
var isMarketSuspended = function isMarketSuspended(market) {
  return market && market.status === __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].MARKET_SUSPENDED;
};
var isMarketClosed = function isMarketClosed(market) {
  return market && !market.isOpen;
};
var hasMarketStatusMessage = function hasMarketStatusMessage(market) {
  return isMarketClosed(market) && !!market.isOpenStatusMessage;
};
var hasMarketPayout = function hasMarketPayout(market) {
  return market && (market.userInvestment !== 0 || market.userMaxPayout !== 0);
};
var hasMarketHiddenContracts = function hasMarketHiddenContracts(market) {
  var contracts = market.contracts || market.marketContracts || [];
  return typeof contracts.find(function (i) {
    return i.hiddenByDefault;
  }) !== 'undefined';
};
var isContractOpen = function isContractOpen(contract) {
  return typeof contract.isOpen !== 'undefined' && contract.isOpen || typeof contract.contractIsOpen !== 'undefined' && contract.contractIsOpen;
};
/* unused harmony default export */ var _unused_webpack_default_export = ({});

function largeNumberDisplay(x) {
  var largeThousands = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var value = x;
  if (value >= 1.0e+6) {
    if ((value / 1.0e+6).toFixed(1).endsWith('.0')) {
      value = (value / 1.0e+6).toFixed(0) + 'M';
    } else {
      value = (value / 1.0e+6).toFixed(1) + 'M';
    }
  } else if (largeThousands && value >= 1.0e+5) {
    value = (value / 1.0e+3).toFixed(0) + 'K';
  } else if (!largeThousands && value >= 1.0e+3) {
    if ((value / 1.0e+3).toFixed(1).endsWith('.0')) {
      value = (value / 1.0e+3).toFixed(0) + 'K';
    } else {
      value = (value / 1.0e+3).toFixed(1) + 'K';
    }
  } else {
    value = value.toLocaleString();
  }
  return value;
}

function elementOffset(el) {
  var rect = el.getBoundingClientRect();
  var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

function marketUserGainLoss(market) {
  var contracts = market.contracts || market.marketContracts || [];
  return __WEBPACK_IMPORTED_MODULE_3_lodash_sumBy___default()(contracts, function (c) {
    var gainLoss = 0;
    if (c.userPrediction === 0 && c.userOpenOrders !== 0) {
      gainLoss = (1 - c.lastTradePrice - c.userAveragePricePerShare) * c.userQuantity;
    } else {
      gainLoss = (c.lastTradePrice - c.userAveragePricePerShare) * c.userQuantity;
    }
    return gainLoss;
  });
}

var smartbtoa = function smartbtoa(input) {
  return btoa(unescape(encodeURIComponent(input)));
};
var smartatob = function smartatob(input) {
  return decodeURIComponent(escape(atob(input)));
};

var groupByKeepOrder = function groupByKeepOrder(arr, prop) {
  var newArr = [];
  var wrapObj = {};

  arr.forEach(function (item) {
    var propName = item[prop];
    if (propName) {
      propName = propName.toString();
      if (!wrapObj[propName]) {
        wrapObj[propName] = [];
        newArr.push(wrapObj[propName]);
      }
      wrapObj[propName].push(item);
    }
  });

  return newArr;
};

function roundToTwo(value) {
  return Math.round(value * 100) / 100;
}

function roundDown(value) {
  return Math.floor(value * 100) / 100;
}

function roundTop(value) {
  return Math.ceil(value * 100) / 100;
}

var getCardTypeForNumber = function getCardTypeForNumber(value) {
  if (/^(?:4\d{12}(?:\d{3})?)$/.test(value)) return __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].CARDS.VISA;
  if (/^(?:3[47]\d{13})$/.test(value)) return __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].CARDS.AMERICAN_EXPRESS;
  if (/^6(?:011\d{12,15}|5\d{14,17}|4[4-9]\d{13,16}|22(?:1(?:2[6-9]|[3-9]\d)|[2-8]\d{2}|9(?:[01]\d|2[0-5]))\d{10,13})$/.test(value)) return __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].CARDS.DISCOVER;
  if (/^(?:5[1-5]\d{14})$/.test(value)) return __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].CARDS.MASTERCARD;
  return __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].CARDS.BLANK;
};

var getOrdinalSuffix = function getOrdinalSuffix(value) {
  var symbols = ['th', 'st', 'nd', 'rd'];
  var v = value % 100;
  return symbols[(v - 20) % 10] || symbols[v] || symbols[0];
};

var loadedScripts = {};
var loadScript = function loadScript(url, windowVariable) {
  if (!loadedScripts[url]) {
    loadedScripts[url] = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.addEventListener('load', function () {
        return resolve(windowVariable ? __WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(window, windowVariable) : undefined);
      }, false);
      script.addEventListener('error', function (e) {
        return reject(e);
      }, false);
      document.body.appendChild(script);
    });
  }
  return loadedScripts[url];
};

var parseQuery = function parseQuery(queryString) {
  var query = {};
  var a = (queryString[0] === '?' || queryString[0] === '#' ? queryString.substr(1) : queryString).split('&');
  for (var i = 0; i < a.length; i += 1) {
    var b = a[i].split('=');
    query[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '');
  }
  return query;
};

var getAssetPath = function getAssetPath(path) {
  return '' + "https://cdn1.predictit.org" + path;
};

/***/ }),

/***/ "c2tZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history-filters",class:_vm.openModifier},[(_vm.value)?_c('div',{staticClass:"history-filters__selected"},[_c('div',{staticClass:"history-filters__selected-back",on:{"click":_vm.onRecent}}),_vm._v(" "),_c('div',{staticClass:"history-filters__selected-wrap"},[_c('span',{staticClass:"history-filters__selected-title"},[_c('router-link',{attrs:{"to":{ name: 'market-details', params: { marketId: _vm.value.marketId } }}},[_vm._v(_vm._s(_vm.value.marketTitle))])],1)])]):_vm._e(),_vm._v(" "),(!_vm.value)?_c('div',[_c('div',{staticClass:"history-filters__recent"},[_c('button-with-info',{attrs:{"text":"Most Recent","selected":_vm.recent},on:{"click":_vm.onRecent,"infoClick":_vm.onInfoClick}})],1),_vm._v(" "),_c('div',{staticClass:"history-filters__markets"},[_c('button-with-info',{attrs:{"text":"Markets","selected":!_vm.recent,"infoOnLeft":false},on:{"click":_vm.onMarkets,"infoClick":_vm.onInfoClick}})],1),_vm._v(" "),(_vm.isOpen)?_c('div',{staticClass:"column small-12"},[_c('refine-history',{attrs:{"list":_vm.markets},on:{"input":_vm.onRefineHistoryInput}})],1):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cDJX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cEur":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_social_auth_js__ = __webpack_require__("I4ul");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a46af89_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_social_auth_vue__ = __webpack_require__("4opG");
function injectStyle (ssrContext) {
  __webpack_require__("P5pR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_social_auth_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a46af89_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_social_auth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cFI2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_minBy__ = __webpack_require__("to0n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_minBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_minBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_modal_switch_switch_vue__ = __webpack_require__("iOeH");

 /* eslint-disable quotes */




var csvPrefix = 'data:text/csv;charset=utf-8,';
var csvHeader = 'Market Outcome,Type,Shares,Avg Price,Share Value,If Yes,If No,Risk,Payout';
var csvInfoOne = '"Your Risk in any contract is the sum of your profits and losses, across all contracts, should that contract resolve to \'Yes\'. To work out this sum, add the \'If Yes\' figure for the contract to the \'If No\' figures for all other contracts."';
var csvInfoTwo = '"Your Investment in the market as a whole is equal to your greatest Risk in any one contract. This is the amount PredcitIt debits from your account to cover your position."';
var csvInfoThree = '"Your Payout is the amount you would be credited if the contract resolves to Yes. It is the difference between your total Investment (greatest Risk) and the Risk in the winning contract."';
var csvInfoFour = '"Share Value corresponds to the face value of your position in each contract (shares multiplied by average purchase price)."';

function predictionTypeToString(type) {
  return type === 0 || type === 2 ? 'No' : 'Yes';
}
function formatData(o) {
  return o < 0 ? '($' + Math.abs(o).toFixed(3) + ')' : '$' + o.toFixed(3);
}
var COLUMNS = ['averagePrice', 'investment', 'profitYes', 'profitNo', 'riskAmount', 'payoutAmount'];
var COLUMNS_LAST = COLUMNS.slice(1);
function csvObjectToString(o, i, c) {
  if (i + 1 === c.length) {
    var _formatedData = COLUMNS_LAST.map(function (prop) {
      return formatData(o[prop]);
    });
    return o.contractName + ',,,,' + _formatedData.join(',');
  }
  var type = predictionTypeToString(o.predictionType);
  var formatedData = COLUMNS.map(function (prop) {
    return formatData(o[prop]);
  });
  return o.contractName + ',' + type + ',' + o.sharesOwned + ',' + formatedData.join(',');
}

function toCsv(contractsArray, filename, link) {
  var arr = contractsArray.map(csvObjectToString);

  if (window.navigator.msSaveBlob) {
    var IE = new Blob([csvHeader + '\n' + arr.join('\n') + '\n\n\n' + csvInfoOne + '\n' + csvInfoTwo + '\n' + csvInfoThree + '\n' + csvInfoFour], { type: 'text/csv;charset=utf-8' });
    window.navigator.msSaveBlob(IE, filename);
  } else {
    var data = void 0;
    if (window.Blob) {
      var csvNoPrefix = csvHeader + '\n' + arr.join('\n') + '\n\n\n' + csvInfoOne + '\n' + csvInfoTwo + '\n' + csvInfoThree + '\n' + csvInfoFour;
      var blob = new Blob([csvNoPrefix], { type: 'text/csv;charset=utf-8' });
      data = window.URL.createObjectURL(blob);
    } else {
      var csv = '' + csvPrefix + csvHeader + '\n' + arr.join('\n') + '\n\n\n' + csvInfoOne + '\n' + csvInfoTwo + '\n' + csvInfoThree + '\n' + csvInfoFour;
      data = encodeURI(csv);
    }
    link.setAttribute('href', data);
    link.setAttribute('download', filename);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    switchModal: __WEBPACK_IMPORTED_MODULE_3__components_generics_modal_switch_switch_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      toggleIndex: 1,
      faqlink: {
        name: 'Faq',
        params: { faqid: 666 }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('profile', ['marketPayouts']), {
    itemWithGreatestRisk: function itemWithGreatestRisk() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_minBy___default()(this.payouts, function (x) {
        return x.riskAmount;
      });
    },
    payouts: function payouts() {
      return this.marketPayouts === null ? [] : this.marketPayouts.contracts;
    },
    showSpinner: function showSpinner() {
      return this.payouts.length === 0;
    },
    classModifier: function classModifier() {
      return {
        'potential-payouts__content--long': this.payouts.length > 5
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('overlay', { hideOverlay: 'hide' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('profile', ['getMarketPayouts', 'clearMarketPayouts']), {
    isNo: function isNo(item) {
      return item.predictionType === 0 || item.predictionType === 2;
    },
    yourOwnText: function yourOwnText(item) {
      return predictionTypeToString(item.predictionType);
    },
    yourOwnModifiers: function yourOwnModifiers(item) {
      var isNo = this.isNo(item);
      return {
        'potential-payouts--bar': true,
        'potential-payouts--no': isNo,
        'potential-payouts--yes': !isNo
      };
    },
    isWithGreatestRisk: function isWithGreatestRisk(item) {
      if (!this.itemWithGreatestRisk) return false;
      return item.riskAmount === this.itemWithGreatestRisk.riskAmount;
    },
    toggle: function toggle() {
      this.toggleIndex += 1;
    },
    close: function close() {
      this.$emit('modalClose');
    },
    whileRouting: function whileRouting() {
      this.$emit('modalClose');
      this.hideOverlay();
    },
    onExport: function onExport() {
      toCsv(this.marketPayouts.contracts, 'Potential Payouts-' + this.market.marketId + '.csv', this.$refs.export);
    }
  }),
  mounted: function mounted() {
    this.getMarketPayouts(this.market.marketId);
  },
  beforeDestroy: function beforeDestroy() {
    this.clearMarketPayouts();
  }
});

/***/ }),

/***/ "cFQ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cT9C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_insight_insight_panel_insight_panel_vue__ = __webpack_require__("QgOX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_insight_insight_link_insight_link_vue__ = __webpack_require__("DXdo");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    insightPanel: __WEBPACK_IMPORTED_MODULE_3__components_insight_insight_panel_insight_panel_vue__["a" /* default */],
    insightLink: __WEBPACK_IMPORTED_MODULE_4__components_insight_insight_link_insight_link_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('insight', ['analysis']), {
    allArticlesAway: function allArticlesAway() {
      return !this.isLayoutMobile;
    },
    allArticlesLink: function allArticlesLink() {
      if (!this.isLayoutMobile) {
        return 'https://analysis.predictit.org/';
      }
      return {
        path: '/insight/' + btoa(encodeURI('//analysis.predictit.org/'))
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('insight', ['getAnalysis']), {
    createLink: function createLink(url) {
      return {
        path: '/insight/' + btoa(encodeURI(url))
      };
    },
    createDate: function createDate(date) {
      if (date) {
        var dt = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date.split(' ')[0]);
        var diff = __WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(dt, 'days');
        var map = {
          0: 'Today',
          1: 'Yesterday',
          2: dt.format('dddd'),
          3: dt.format('dddd'),
          4: dt.format('dddd'),
          5: dt.format('dddd'),
          6: dt.format('dddd')
        };
        return map[diff] || dt.format('MMM. D');
      }
      return '';
    }
  }),
  mounted: function mounted() {
    this.getAnalysis({});
  }
});

/***/ }),

/***/ "cUo6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_pending_request_js__ = __webpack_require__("TZt3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a8a66d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_request_vue__ = __webpack_require__("oo4y");
function injectStyle (ssrContext) {
  __webpack_require__("nxw+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_pending_request_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a8a66d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_request_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cVLa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_keyboard_numeric_input_keyboard_numeric_input_vue__ = __webpack_require__("HCce");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    keyboardNumericInput: __WEBPACK_IMPORTED_MODULE_1__components_keyboard_numeric_input_keyboard_numeric_input_vue__["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: 'Minimum Sell Price'
    },
    value: {
      type: Number,
      default: 50
    },
    kind: {
      type: String,
      default: 'modal'
    },
    selected: Boolean,
    userQuantity: {},
    threshold: {
      type: Number,
      default: 25
    },
    operationType: {
      type: String,
      default: 'buy'
    },
    tabindex: Number,
    minimumOwnership: {
      type: Number,
      default: 1
    },
    minValue: {
      type: Number,
      default: 1
    },
    maxValue: {
      type: Number,
      default: 9999
    }
  },
  data: function data() {
    return {
      updated: false,
      val: this.value !== null ? parseInt(this.value, 10) : null
    };
  },

  computed: {
    classModifier: function classModifier() {
      var _ref;

      return _ref = {
        'purchase-quantity-value': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'purchase-quantity-value--' + this.kind, this.kind), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'purchase-quantity-value--selected', this.selected), _ref;
    }
  },
  watch: {
    val: 'updateOffer',
    value: function value(_value) {
      this.val = _value !== null ? parseInt(_value, 10) : null;
    }
  },
  methods: {
    add: function add() {
      if (isNaN(this.val) || this.val === null || this.val === 1) {
        this.val = 0;
      }
      var newValue = this.val + this.threshold;
      if (this.userQuantity && this.operationType === 'sell' && this.val <= this.userQuantity && newValue > this.userQuantity) {
        newValue = this.userQuantity;
      }
      this.val = Math.min(newValue, this.maxValue);
    },
    subtract: function subtract() {
      if (isNaN(this.val) || this.val === null || this.val < this.threshold + 1) {
        this.val = this.threshold + 1;
      }
      var newValue = this.val - this.threshold;
      this.val = Math.max(newValue, this.minValue);
    },
    updateOffer: function updateOffer() {
      this.updated = true;
      this.val = parseInt(this.val, 10);
      if (isNaN(this.val) || this.val < 1) this.val = null;

      if (this.val !== null) {
        this.$emit('input', Number(this.val));
      } else {
        this.$emit('input', this.val);
      }
    },
    click: function click() {
      this.$emit('click');
    }
  }
});

/***/ }),

/***/ "cVuz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__ = __webpack_require__("0O9D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f66a746c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("ZMoj");
function injectStyle (ssrContext) {
  __webpack_require__("d3LK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f66a746c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cW54":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__ = __webpack_require__("DECz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("oiih");
/* eslint-disable max-len */






/* harmony default export */ __webpack_exports__["a"] = ({
  getManageInfo: function getManageInfo() {
    var returnUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var generateState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'false';

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/ManageInfo?returnUrl=' + returnUrl + '&generateState=' + generateState);
  },
  postToken: function postToken() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/token', payload);
  },
  getUserInfo: function getUserInfo() {
    var options = {};
    var token = __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get('externalToken', null);
    if (token) {
      options.headers = {
        Authorization: 'Bearer ' + token
      };
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/UserInfo', options);
  },
  getAccountDetail: function getAccountDetail() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/Detail');
  },
  postLogout: function postLogout() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var options = {
      withCredentials: true
    };
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/Logout', payload, options);
  },
  getStatus: function getStatus() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/Status');
  },
  postRegister: function postRegister(payload) {
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__["a" /* default */].payload(payload, 'PIReferral', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/Register', marketingPayload);
  },
  postRegisterExternal: function postRegisterExternal(payload) {
    var options = {};
    var token = __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get('externalToken', null);
    if (token) {
      options.headers = {
        Authorization: 'Bearer ' + token
      };
    }
    var marketingPayload = __WEBPACK_IMPORTED_MODULE_2__helpers_sessionVars__["a" /* default */].payload(payload, 'PIReferral', 'utm_campaign', 'utm_source');
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/RegisterExternal', marketingPayload, options);
  },
  postResetPassword: function postResetPassword(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/ResetPassword', payload);
  },
  postForgotPassword: function postForgotPassword(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/ForgotPassword', payload);
  },
  postChangePassword: function postChangePassword(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/ChangePassword', payload);
  },
  postSetPassword: function postSetPassword(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/SetPassword', payload);
  },
  postRemoveLogin: function postRemoveLogin(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/RemoveLogin', payload);
  },
  postAddExternalLogin: function postAddExternalLogin(payload) {
    var options = {
      withCredentials: true
    };
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/AddExternalLogin', payload, options);
  },
  getExternalLogins: function getExternalLogins() {
    var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.pathname;
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].SOCIAL_LOGIN_OR_REGISTER;

    var redirect = pathname.replace("/", '/');
    var accessToken = __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get('token');

    if (accessToken !== null || redirect.includes('account/login') || redirect.includes('account/sign-up')) {
      redirect = '/';
    }

    var options = {
      params: {
        returnUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["b" /* getRedirectUrl */])('/account/social/auth/?redirect=' + redirect + '&type=' + type),
        generateState: true
      }
    };
    var token = __WEBPACK_IMPORTED_MODULE_3__helpers_localStorage__["a" /* default */].get('externalToken', null);
    if (token) {
      options.headers = {
        Authorization: 'Bearer ' + token
      };
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('/api/Account/ExternalLogins', options);
  },
  getVerifyID: function getVerifyID() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/VerifyID');
  },
  postVerifyID: function postVerifyID(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/VerifyID', payload);
  },
  postUploadUserImage: function postUploadUserImage(payload) {
    var options = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/UploadUserImage', payload, options);
  },
  putResetUserImage: function putResetUserImage() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Account/ResetUserImage');
  },
  getCommunicationPreferences: function getCommunicationPreferences() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/CommunicationPreferences');
  },
  postCommunicationPreferences: function postCommunicationPreferences(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/CommunicationPreferences', payload);
  },
  getCaptchaSiteKey: function getCaptchaSiteKey() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/CaptchaSiteKey');
  },
  getDisqusLogin: function getDisqusLogin() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/DisqusLogin');
  },
  getDisqusLogout: function getDisqusLogout() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/DisqusLogout');
  },
  getDisqusUserAuth: function getDisqusUserAuth() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/DisqusUserAuth');
  },
  getIdUploadUrl: function getIdUploadUrl() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/IdUploadUrl');
  },
  getTaxInfo: function getTaxInfo(_ref) {
    var _ref$reasonCode = _ref.reasonCode,
        reasonCode = _ref$reasonCode === undefined ? '' : _ref$reasonCode;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/TaxInfo?reasonCode=' + reasonCode);
  },
  postTaxInfo: function postTaxInfo(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/TaxInfo', payload);
  },
  putMessagingToken: function putMessagingToken(token) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Account/MessagingToken?token=' + token);
  },
  getChangeUsername: function getChangeUsername() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/ChangeUsername');
  },
  postChangeUsername: function postChangeUsername(username) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].post('api/Account/ChangeUsername?username=' + username);
  },
  getDocumentUploadLink: function getDocumentUploadLink(source) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Account/DocumentUploadLink?source=' + source);
  },
  putAgreedToTerms: function putAgreedToTerms(payload) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].put('api/Account/UpdateAgreedToTerms', payload);
  }
});

/***/ }),

/***/ "cbPA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    predictionType: Number,
    tradeType: Number,
    quantity: Number,
    price: Number
  },
  computed: {
    typeToString: function typeToString() {
      switch (this.tradeType) {
        case 0: // Buy No
        case 1:
          // Buy Yes
          return 'Bought';
        case 2: // Sell No
        case 3:
          // Sell Yes
          return 'Sold';
        default:
          return 'Closed'; // 4 - Closed
      }
    },
    closedText: function closedText() {
      if (this.tradeType === 4) {
        var price = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* toCents */])(this.price);
        var yesNo = this.predictionType === 0 ? '<span class="sold-bought-at__quantity sold-bought-at--negative">' + this.quantity + '</span>' : '<span class="sold-bought-at__quantity">' + this.quantity + '</span>';

        if (price === 0) {
          return yesNo + ' pays $0';
        }
        var pays = price === 100 ? '$1' : this.priceToString;
        return yesNo + ' pays ' + pays;
      }
      return null;
    },
    priceToString: function priceToString() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["j" /* toCents */])(this.price) + '\xA2';
    },
    negativeModifier: function negativeModifier() {
      return {
        'sold-bought-at--negative': this.tradeType === 0 || this.tradeType === 2
      };
    }
  }
});

/***/ }),

/***/ "cdg3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cgm0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* global $:false */
/*
  Mixin used to move some meta tags used for SEO just after
  header's title node. Supposedly it affects prerender.io.
 */
var headerTagsMixin = {
  methods: {
    reorganizeTags: function reorganizeTags() {
      setTimeout(function () {
        if (!window.$) return;
        $('meta[name="description"]').detach().insertAfter('title');
        $('meta[itemprop]').detach().insertAfter('title');
        $('meta[property]').detach().insertAfter('title');
      }, 0);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (headerTagsMixin);

/***/ }),

/***/ "cgtd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_export_history_js__ = __webpack_require__("ZMD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27eb1088_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_export_history_vue__ = __webpack_require__("pnzO");
function injectStyle (ssrContext) {
  __webpack_require__("yyG2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_export_history_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27eb1088_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_export_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "civT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-notification-items"}},[(_vm.shouldDisplayNotifications)?_c('div',{staticClass:"notification-items"},[_c('div',{staticClass:"notification-items__container"},[_c('transition-group',{attrs:{"name":"slide-notification"}},[_vm._l((_vm.notificationsToDisplay),function(notification){return [(_vm.shouldDisplayNotificationSimple(notification))?_c('notification-item-simple',{key:notification.index,attrs:{"autoClose":true,"text":notification.data.text,"icon":notification.data.icon,"closeTimeout":notification.data.closeTimeout,"index":notification.index}}):_vm._e(),_vm._v(" "),(_vm.shouldDisplayNotificationTradeConfirmed(notification))?_c('notification-item-trade-confirmed',{key:notification.index,attrs:{"autoClose":true,"closeTimeout":_vm.NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY,"index":notification.index,"data":notification.data}}):_vm._e(),_vm._v(" "),(_vm.shouldDisplayDashboardNotification(notification))?_c('notification-item-dashboard',{key:notification.index,attrs:{"autoClose":true,"closeButton":true,"closeTimeout":_vm.NOTIFICATION_SHARES_TRADES_CLOSE_DELAY,"theme":"notifications","index":notification.index,"data":notification.data}}):_vm._e()]})],2)],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "clCm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "co1A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cyZn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cz2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");





var disConfig = {
  api_key: "kFBKlQsMshYuhdZooAFKnNw8fY1ffTSWB5KIUfvCplLPajtuLRW2TdCevg8VCKDf",
  sso: {
    name: "PredictIt",
    button: "https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png",
    icon: "https://cdn1.predictit.org/images/5ce4210c-439b-464f-b509-fb2bc058a921.png",
    url: "/Account/DisqusLogin",
    logout: "/Account/DisqusLogout",
    width: "800",
    height: "600"
  }
};

function disqusConfig() {
  this.page.identifier = disConfig.identifier;
  this.page.url = disConfig.url;
  this.page.title = disConfig.title;
  this.page.api_key = disConfig.api_key;
  this.sso = disConfig.sso;

  this.page.remote_auth_s3 = disConfig.remote_auth_s3 ? disConfig.remote_auth_s3 : '';
}

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    disqusId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    auth: String,
    url: String,
    marketId: {
      default: null
    },
    previous: {
      default: null
    },
    next: {
      default: null
    },
    total: {
      default: null
    }
  },
  data: function data() {
    return {
      currentThread: null,
      currentTitle: this.title,
      previousThread: this.previous,
      nextThread: this.next,
      totalComments: this.total
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn'])),
  mounted: function mounted() {
    if (this.auth && this.isLoggedIn) {
      this.enableDisqus(this.auth);
    } else {
      this.enableDisqus(null);
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('market', ['getCommentThread']), {
    reload: function reload(payload) {
      var _this = this;

      this.$router.push({
        name: this.$route.name,
        params: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.params, {
          dontReload: true
        }),
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
          commentThreadId: payload.threadId
        })
      });
      this.getCommentThread(payload).then(function (data) {
        _this.currentTitle = data.disqus_ThreadName;
        _this.nextThread = data.disqus_NextThreadID;
        _this.previousThread = data.disqus_PrevThreadID;
        _this.totalComments = data.disqus_ArchivedCommentsTotal;

        window.DISQUS.reset({
          reload: true,
          config: function config() {
            this.page.identifier = data.disqus_Identifier;
            this.page.title = data.disqus_ThreadName;
            this.page.url = data.disqus_Url;
          }
        });
      });
    },
    onCurrent: function onCurrent(commentThreadId) {
      var payload = {
        threadId: commentThreadId,
        marketId: this.marketId
      };
      this.currentThread = commentThreadId;
      this.reload(payload);
    },
    onPrevious: function onPrevious() {
      var payload = {
        threadId: this.previousThread,
        marketId: this.marketId
      };
      this.currentThread = this.previousThread;
      this.reload(payload);
    },
    onNext: function onNext() {
      var payload = {
        threadId: this.nextThread,
        marketId: this.marketId
      };
      this.currentThread = this.nextThread;
      this.reload(payload);
    },
    enableDisqus: function enableDisqus(auth) {
      var shortname = "PredictIt";
      var resolvedAuth = this.$router.resolve({
        name: 'disqus-auth'
      });
      var resolvedLogout = this.$router.resolve({
        name: 'disqus-logout',
        params: {
          routeName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["w" /* smartbtoa */])(this.$route.name),
          routeParams: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["w" /* smartbtoa */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$route.params))
        }
      });

      disConfig.identifier = this.disqusId;
      disConfig.url = this.url || '' + window.location.href;
      disConfig.title = this.title;
      disConfig.sso.width = this.isLayoutMobile ? 320 : 800;
      disConfig.sso.url = '' + window.location.origin + resolvedAuth.href;
      disConfig.sso.logout = '' + window.location.origin + resolvedLogout.href;
      // Note: SSO payloads expire after 2 hours. - now storing in ls
      disConfig.remote_auth_s3 = auth || '';

      if (window.DISQUS) {
        window.DISQUS.reset({
          reload: true,
          config: disqusConfig
        });
      } else {
        window.disqus_config = disqusConfig;
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '//' + shortname + '.disqus.com/embed.js';
        document.body.appendChild(script);
      }
    }
  })
});

/***/ }),

/***/ "d0qv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d1Ib":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d2fJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountWithdrawalLoader_vue__ = __webpack_require__("6iuM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9a7030c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountWithdrawalLoader_vue__ = __webpack_require__("12Ru");
function injectStyle (ssrContext) {
  __webpack_require__("TCG6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountWithdrawalLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9a7030c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountWithdrawalLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d3LK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d3y4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getMarket: function getMarket(marketId) {
    var commentThreadId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (commentThreadId) {
      return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '?commentThreadId=' + commentThreadId);
    }
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId);
  },
  getCommentThread: function getCommentThread(_ref) {
    var marketId = _ref.marketId,
        threadId = _ref.threadId;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '/CommentThread/' + threadId);
  },
  getMarketRules: function getMarketRules(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '/Rule');
  },
  getContract: function getContract(contractId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/Contract/' + contractId);
  },
  getMarketContracts: function getMarketContracts(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '/Contracts');
  },
  getMarketContractsStats: function getMarketContractsStats(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '/Contracts/Stats');
  },
  getMarketRelated: function getMarketRelated(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Market/' + marketId + '/Related');
  }
});

/***/ }),

/***/ "d4Dm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_v2_market_contract_horizontal_v2_market_contract_horizontal_v2__ = __webpack_require__("fvX1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");


/* eslint-disable arrow-body-style */








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */]],
  props: {
    slim: {
      type: Boolean,
      default: false
    },
    contract: {
      type: Object,
      required: true
    },
    orderBook: {
      type: Object,
      required: true
    },
    buyOffers: {
      type: Array,
      default: []
    },
    sellOffers: {
      type: Array,
      default: []
    },
    operationValue: {
      type: String,
      default: 'yes',
      validator: function validator(value) {
        return ['no', 'yes'].indexOf(value) >= 0;
      }
    },
    operationType: {
      type: String,
      default: 'buy'
    }
  },
  data: function data() {
    return {
      hoveredIndex: null,
      leftPricesUnavailable: true,
      rightPricesUnavailable: true,
      sideActive: 'left'
    };
  },

  watch: {
    orderBook: function orderBook() {
      this.leftPricesUnavailable = true;
      this.rightPricesUnavailable = true;
    }
  },
  computed: {
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_6__models_contract__["a" /* default */](this.contract);
    },
    tableModifiers: function tableModifiers() {
      return {
        'order-book__table': true,
        'order-book__table--slim': this.slim
      };
    },
    leftSideNoOffersModifiers: function leftSideNoOffersModifiers() {
      return {
        column: true,
        'small-6': true,
        'order-book__unavailable': true,
        'order-book__unavailable--active': this.sideActive === 'left'
      };
    },
    rightSideNoOffersModifiers: function rightSideNoOffersModifiers() {
      return {
        column: true,
        'small-6': true,
        'order-book__unavailable': true,
        'order-book__unavailable--right': true,
        'order-book__unavailable--active': this.sideActive === 'right'
      };
    },
    leftSideHeaderModifiers: function leftSideHeaderModifiers() {
      return {
        column: true,
        'small-6': true,
        'order-book__header-cell': true,
        'order-book__header-cell--highlight-light': !(this.sideActive === 'left'),
        'order-book__header-cell--highlight-strong': this.sideActive === 'left'
      };
    },
    rightSideHeaderModifiers: function rightSideHeaderModifiers() {
      return {
        column: true,
        'small-6': true,
        'order-book__header-cell': true,
        'order-book__header-cell--highlight-light': !(this.sideActive === 'right'),
        'order-book__header-cell--highlight-strong': this.sideActive === 'right'
      };
    },
    isSharesOwned: function isSharesOwned() {
      return this.contract.userQuantity > 0 || this.buyOffers.length > 0;
    },
    operationValueText: function operationValueText() {
      return this.operationValue.charAt(0).toUpperCase() + this.operationValue.slice(1);
    },
    operationTypeLeftText: function operationTypeLeftText() {
      return 'Buy';
    },
    operationTypeRightText: function operationTypeRightText() {
      return 'Sell';
    },
    operationValueRightText: function operationValueRightText() {
      // const opposite = this.operationValue === 'yes' ? 'No' : 'Yes';
      return this.operationValueText;
    },
    pricesGrouped: function pricesGrouped() {
      var _this = this;

      var prices = [];
      var yesOrders = this.orderBook ? this.orderBook.yesOrders || [] : [];
      var noOrders = this.orderBook ? this.orderBook.noOrders || [] : [];

      var leftPrices = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(yesOrders));
      var rightPrices = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(noOrders));
      var leftField = 'pricePerShare';
      var rightField = 'costPerShareYes';
      var leftOffers = this.sellOffers;
      var rightOffers = this.buyOffers;
      this.sideActive = 'left';

      if (this.isSharesOwned) {
        if (this.operationValue === 'yes' && this.operationType === 'buy' || this.operationType === 'sell' && this.operationValue === 'no') {
          leftPrices = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(yesOrders));
          rightPrices = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(noOrders));
          leftField = 'pricePerShare';
          rightField = 'costPerShareYes';
          leftOffers = this.sellOffers;
          rightOffers = this.buyOffers;
          if (this.operationType === 'sell') {
            this.sideActive = 'right';
            leftPrices = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(noOrders));
            rightPrices = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(yesOrders));
            leftOffers = this.sellOffers;
            rightOffers = this.buyOffers;
            leftField = 'pricePerShare';
            rightField = 'costPerShareNo';
          }
        } else {
          leftPrices = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(noOrders));
          rightPrices = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(yesOrders));
          leftField = 'pricePerShare';
          rightField = 'costPerShareNo';
          leftOffers = this.sellOffers;
          rightOffers = this.buyOffers;
          if (this.operationType === 'sell') {
            this.sideActive = 'right';
            leftPrices = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(yesOrders));
            rightPrices = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(noOrders));
            leftField = 'pricePerShare';
            rightField = 'costPerShareYes';
            leftOffers = this.sellOffers;
            rightOffers = this.buyOffers;
          }
        }
      } else if (this.operationValue === 'no') {
        rightField = 'costPerShareNo';
        leftPrices = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(noOrders));
        rightPrices = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(yesOrders));
      }

      var leftOffersField = leftField;
      var rightOffersField = rightField;

      var max = leftPrices.length > rightPrices.length ? leftPrices.length : rightPrices.length;

      var _loop = function _loop(i) {
        if (leftPrices[i]) {
          _this.leftPricesUnavailable = false;
        }
        if (rightPrices[i]) {
          _this.rightPricesUnavailable = false;
        }

        prices.push({
          index: i,
          buyPrice: leftPrices[i] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* toCents */])(leftPrices[i][leftField]) : null,
          buyQuantity: leftPrices[i] ? leftPrices[i].quantity : null,
          buyOwned: leftPrices[i] ? leftOffers.find(function (s) {
            return s.pricePerShare === leftPrices[i][leftOffersField];
          }) !== undefined : false,
          sellPrice: rightPrices[i] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* toCents */])(rightPrices[i][rightField]) : null,
          sellQuantity: rightPrices[i] ? rightPrices[i].quantity : null,
          sellOwned: rightPrices[i] ? rightOffers.find(function (s) {
            return s.pricePerShare === rightPrices[i][rightOffersField];
          }) !== undefined : false
        });
      };

      for (var i = 0; i < max; i += 1) {
        _loop(i);
      }
      return prices;
    },
    pricesOwned: function pricesOwned() {
      return this.pricesGrouped.find(function (item) {
        return item.buyOwned || item.sellOwned;
      });
    },
    firstItemForActiveSideOwned: function firstItemForActiveSideOwned() {
      var _this2 = this;

      return this.pricesGrouped.find(function (item) {
        return _this2.sideActive === 'right' ? item.sellOwned : item.buyOwned;
      });
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setGenericSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('trade', ['getOrderBookTradeInfo', 'toggleTradeOperation']), {
    getTradeType: function getTradeType(operationType, operationValue) {
      if (operationType === 'buy' && operationValue === 'no') return 0;
      if (operationType === 'buy' && operationValue === 'yes') return 1;
      if (operationType === 'sell' && operationValue === 'no') return 2;
      if (operationType === 'sell' && operationValue === 'yes') return 3;
      return 1;
    },
    onMouseOver: function onMouseOver(index, side) {
      if (!(this.sideActive === side)) return;
      this.hoveredIndex = index;
    },
    onMouseLeave: function onMouseLeave(side) {
      if (!(this.sideActive === side)) return;
      this.hoveredIndex = null;
    },
    headerStrongModifier: function headerStrongModifier(side) {
      var isActive = side === this.sideActive;
      return {
        'order-book__header-cell--legend-light': !isActive,
        'order-book__header-cell--legend-strong': isActive
      };
    },
    hoverQuantityClassModifier: function hoverQuantityClassModifier(owned, index, side) {
      var isSideActive = this.sideActive === side;
      return {
        'order-book__body-cell--owned': owned,
        'order-book__body-cell--hover': isSideActive && this.hoveredIndex === index,
        'order-book__body-cell--clickable': isSideActive,
        'order-book__body-cell--inactive': !isSideActive
      };
    },
    showTradeInfo: function showTradeInfo(item, operationType, operationValue, side) {
      var _this3 = this;

      var price = side === 'right' ? item.sellPrice : item.buyPrice;
      var payload = {
        tradeType: this.getTradeType(operationType, operationValue),
        contractId: this.contract.contractId,
        price: price
      };
      this.loaderAdd(document.body);
      this.getOrderBookTradeInfo(payload).then(function (data) {
        setTimeout(function () {
          _this3.loaderRemove(document.body);
          _this3.setGenericSmallPopup({
            name: __WEBPACK_IMPORTED_MODULE_8__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_OFFERS_INDICATOR,
            options: {
              items: data,
              operationType: operationType,
              price: price
            }
          });
        }, 400);
      }).catch(function () {
        return _this3.loaderRemove(document.body);
      });
    },
    handleClick: function handleClick(item, isMine, operationType, operationValue, side) {
      if (!isMine && this.firstItemForActiveSideOwned && item.index > this.firstItemForActiveSideOwned.index) {
        return;
      }
      if (isMine) {
        this.showTradeInfo(item, operationType, operationValue, side);
        return;
      }
      var quantity = this.pricesGrouped.slice(0, item.index + 1).reduce(function (prev, curr) {
        return prev + curr.buyQuantity;
      }, 0);
      var price = this.pricesGrouped[item.index].buyPrice;

      if (side === 'right') {
        quantity = this.pricesGrouped.slice(0, item.index + 1).reduce(function (prev, curr) {
          return prev + curr.sellQuantity;
        }, 0);
        price = this.pricesGrouped[item.index].sellPrice;
      }

      if (price === null) return;
      if (operationType === 'sell' && quantity > this.contract.userQuantity) {
        quantity = this.contract.userQuantity;
      }
      this.$emit('click', {
        quantity: quantity,
        price: price
      });
    },
    onClick: function onClick(item, isMine, side) {
      if (this.sideActive !== side) {
        __WEBPACK_IMPORTED_MODULE_5__logger__["a" /* default */].info('[ORDER BOOK]: switching side from ' + this.sideActive + ' to ' + side);
        // this.toggleTradeOperation(side);
        var button = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__components_market_v2_market_contract_horizontal_v2_market_contract_horizontal_v2__["a" /* getActiveButtonAfterSwitch */])(this.contractModel, side);
        if (isMine) {
          this.showTradeInfo(item, button.type, button.value, side);
        }
      } else {
        this.handleClick(item, isMine, this.operationType, this.operationValue, this.sideActive);
      }
    }
  })
});

/***/ }),

/***/ "d4Jq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"in-the-news-old"},[_c('h2',{staticClass:"in-the-news-old__title"},[_vm._v("PredictIt in the News")]),_vm._v(" "),_c('div',{staticClass:"in-the-news-old__title--border"}),_vm._v(" "),_c('div',{staticClass:"in-the-news-old__wrapper"},[(_vm.isLayoutMobile)?_c('swiper',{attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.itemsPaged),function(page){return _c('swiper-slide',{key:page.key,staticClass:"in-the-news__slide"},_vm._l((page.items),function(logo){return _c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":logo.href}},[_c('img',{class:_vm.getImgModifiers(logo),attrs:{"src":logo.src,"alt":logo.alt}})])}),0)}),_vm._v(" "),_c('div',{staticClass:"in-the-news-old__pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2):_c('div',_vm._l((_vm.items),function(logo){return _c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":logo.href}},[_c('img',{class:_vm.getImgModifiers(logo),attrs:{"src":logo.src,"alt":logo.alt}})])}),0)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dDcj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_share_invite_widget_js__ = __webpack_require__("dNf9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55b2723a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_share_invite_widget_vue__ = __webpack_require__("a5Jt");
function injectStyle (ssrContext) {
  __webpack_require__("rium")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_share_invite_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55b2723a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_share_invite_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dI8L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_notifications__ = __webpack_require__("tjp7");



/* eslint-disable max-len */




var DEFAULT_SEARCH = {
  data: [],
  page: 0,
  totalCount: 0,
  canLoadMore: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    searchBarVisible: false,
    hasSearched: false,
    searchQuery: '',
    searchResults: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(DEFAULT_SEARCH)
  },
  mutations: {
    toggleSearchBar: function toggleSearchBar(state) {
      state.searchBarVisible = !state.searchBarVisible;
    },
    closeSearchBar: function closeSearchBar(state) {
      state.searchBarVisible = false;
    },
    resetSearchResults: function resetSearchResults(state) {
      state.searchResults = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(DEFAULT_SEARCH);
    },
    setSearchResults: function setSearchResults(state, payload) {
      var sourceData = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.searchResults.data));
      var data = sourceData.concat(payload.data.markets || []);
      var page = payload.data.page;
      var totalCount = payload.data.totalMarkets;
      var canLoadMore = totalCount > data.length;

      state.searchResults = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.searchResults, {
        data: data,
        page: page,
        totalCount: totalCount,
        canLoadMore: canLoadMore
      });
    },
    setHasSearched: function setHasSearched(state, flag) {
      state.hasSearched = flag;
    },
    setSearchQuery: function setSearchQuery(state, query) {
      state.searchQuery = query;
    },
    updateMarketFromNotification: function updateMarketFromNotification(state, data) {
      if (state.searchResults.data) {
        state.searchResults = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.searchResults, {
          data: state.searchResults.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_notifications__["a" /* updateMarket */])(market, data);
          })
        });
      }
    },
    updateContractFromNotification: function updateContractFromNotification(state, data) {
      if (state.searchResults.data) {
        state.searchResults = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.searchResults, {
          data: state.searchResults.data.map(function (market) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_notifications__["b" /* updateMarketContracts */])(market, data);
          })
        });
      }
    }
  },
  actions: {
    toggleSearchBar: function toggleSearchBar(_ref) {
      var commit = _ref.commit;

      commit('toggleSearchBar');
    },
    closeSearchBar: function closeSearchBar(_ref2) {
      var commit = _ref2.commit;

      commit('closeSearchBar');
    },
    getSearch: function getSearch(_ref3, query) {
      var state = _ref3.state,
          commit = _ref3.commit;

      if (state.searchResults.canLoadMore) {
        var page = state.searchResults.page + 1;
        return __WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].browse.getSearch(query, page).then(function (response) {
          commit('setHasSearched', true);
          commit('setSearchResults', {
            page: page,
            data: response.data
          });
          return response.data;
        });
      }
      return null;
    },
    resetSearchResults: function resetSearchResults(_ref4, query) {
      var commit = _ref4.commit;

      commit('resetSearchResults');
      commit('setSearchQuery', query);
      if (!query) {
        commit('setHasSearched', false);
      }
    },
    updateMarketFromNotification: function updateMarketFromNotification(_ref5, payload) {
      var commit = _ref5.commit;

      commit('updateMarketFromNotification', payload);
    },
    updateContractFromNotification: function updateContractFromNotification(_ref6, payload) {
      var commit = _ref6.commit;

      commit('updateContractFromNotification', payload);
    }
  }
});

/***/ }),

/***/ "dK2d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el) {
    var isStandalone = !!window.navigator.standalone;
    if (!isStandalone) el.setAttribute('target', '_blank');
  }
});

/***/ }),

/***/ "dLt5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__ = __webpack_require__("tQfv");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__["a" /* default */]],
  metaInfo: function metaInfo() {
    return {
      title: 'Platform Announcements'
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  created: function created() {
    var _this = this;

    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* STATIC_PAGES */].PLATFORM_ANNOUNCEMENTS).then(function (data) {
      _this.installDynamicControls({ data: data });
    });
  }
});

/***/ }),

/***/ "dMVO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_notification_js__ = __webpack_require__("qidN");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_notification_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b012270_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_notification_vue__ = __webpack_require__("p1AJ");
function injectStyle (ssrContext) {
  __webpack_require__("rQvC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_notification_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b012270_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dNf9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  validations: {
    fields: {
      email: __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["a" /* validators */].multipleEmails
    }
  },
  data: function data() {
    return {
      fields: {
        email: ''
      },
      successEmail: ''
    };
  },

  watch: {
    'fields.email': function fieldsEmail(value) {
      if (value) {
        this.successEmail = '';
      }
    }
  },
  computed: {
    shareUrl: function shareUrl() {
      return window.location.origin;
    },
    shareText: function shareText() {
      return 'Hey, I\'m playing @PredictIt and I think you should, too. You can make some money and have some fun picking political futures like election results and world events. Don\u2019t miss out!';
    },
    facebookShareUrl: function facebookShareUrl() {
      return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.shareUrl);
    },
    twitterShareUrl: function twitterShareUrl() {
      return 'http://twitter.com/share?url=' + encodeURIComponent(this.shareUrl) + '&text=' + encodeURIComponent(this.shareText);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('profile', ['sendInviteEmail']), {
    onSend: function onSend() {
      var _this = this;

      this.loaderAdd();
      this.sendInviteEmail(this.fields.email).then(function () {
        _this.loaderRemove();
        _this.successEmail = _this.fields.email.split(';').map(function (i) {
          return i.replace(' ', '');
        }).join(', ');
        _this.fields.email = '';
        _this.$nextTick(function () {
          _this.$v.$reset();
        });
      }).catch(function () {
        return _this.loaderRemove();
      });
    },
    openShareDialog: function openShareDialog(url) {
      window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
    },
    onFacebookShare: function onFacebookShare() {
      this.openShareDialog(this.facebookShareUrl);
    },
    onTwitterShare: function onTwitterShare() {
      this.openShareDialog(this.twitterShareUrl);
    },
    onInfoClick: function onInfoClick() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_SHARE_INVITE_INFO);
    }
  })
});

/***/ }),

/***/ "dOsu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_userAgent__["a" /* default */]],
  props: {
    avatar: {},
    theme: {
      type: String,
      default: ''
    },
    radius: {
      type: Number,
      default: 58
    },
    percentage: {
      type: Number,
      default: 5
    },
    progressStrokeColor: {
      type: String,
      default: ''
    },
    backgroundStrokeColor: {
      type: String,
      default: '#e6e6e6'
    },
    showProgress: {
      type: Boolean,
      default: true
    },
    showEdit: {
      type: Boolean,
      default: true
    },
    notificationsCount: {
      type: Number,
      required: false,
      default: -1
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['hasBanner', 'hasMaintenanceMessage']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('app', ['hasServerErrorOccurred']), {
    isRouteActive: function isRouteActive() {
      return this.$route.name === 'portfolio';
    },
    strokeWidth: function strokeWidth() {
      if (this.isRouteActive && this.theme === 'nav-top') return 7;
      return 5;
    },
    size: function size() {
      if (this.theme === 'markets') return 45;
      if (this.theme === 'nav-top') return 32;
      if (this.theme === 'nav-bottom') return 34;
      if (this.theme === 'nav-bottom-old') return 48;
      if (this.theme === 'large') return 100;
      if (this.theme === 'leaderboards') return 32;
      if (this.theme === 'mobile-menu') return 32;
      if (this.theme === 'user-profile') return 100;
      return 84;
    },
    classModifiers: function classModifiers() {
      var _ref;

      return _ref = {
        'account-social-avatar': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'account-social-avatar--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'account-social-avatar--server-error', this.hasServerErrorOccurred || this.hasMaintenanceMessage || this.hasBanner), _ref;
    },
    imageClassModifiers: function imageClassModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'account-social-avatar__oval': true
      }, 'account-social-avatar__oval--' + this.theme, this.theme);
    },
    imageStyleModifiers: function imageStyleModifiers() {
      return {
        'background-image': 'url(\'' + this.avatar + '\')',
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    labelClassModifiers: function labelClassModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'account-social-avatar__label': true
      }, 'account-social-avatar__label--' + this.theme, this.theme);
    },
    circReference: function circReference() {
      return 2 * Math.PI * this.radius;
    },
    styleModifiers: function styleModifiers() {
      return {
        strokeDashoffset: this.circReference * (1 - this.percentage / 100),
        strokeDasharray: this.circReference,
        stroke: this.progressStrokeColor
      };
    },
    isEditEnabled: function isEditEnabled() {
      // return this.showEdit && !(this.isIos && this.isStandalone);
      return this.showEdit;
    },
    showNotificationsCount: function showNotificationsCount() {
      return this.avatar && this.notificationsCount > 0;
    },
    hasLabel: function hasLabel() {
      return !!this.$slots.label;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    onShowEditPopup: function onShowEditPopup() {
      if (this.isEditEnabled) this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_EDIT_IMAGE);
    }
  })
});

/***/ }),

/***/ "dVCa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_desktop_grid_watchlist_js__ = __webpack_require__("MH7L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46f3cb0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_desktop_grid_watchlist_vue__ = __webpack_require__("9k2S");
function injectStyle (ssrContext) {
  __webpack_require__("UkAU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_desktop_grid_watchlist_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46f3cb0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_desktop_grid_watchlist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dZzV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dcEQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_overview_map_overview_map_contract_overview_map_contract_vue__ = __webpack_require__("YHd0");








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  components: {
    overviewMapContract: __WEBPACK_IMPORTED_MODULE_5__components_pages_page_election_map_new_overview_map_overview_map_contract_overview_map_contract_vue__["a" /* default */]
  },
  props: {
    mapOverviewData: {},
    type: {
      type: String,
      default: 'electoral'
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), {
    num: function num() {
      return 2;
    },
    dummyComponents: function dummyComponents() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_range___default()(0, this.num);
    },
    items: function items() {
      return this.mapOverviewData.slice(0, this.num);
    }
  }),
  methods: {
    mapOverviewDataHandler: function mapOverviewDataHandler(value) {
      if (value.length > 0) {
        this.isComponentReady = true;
      }
    }
  },
  watch: {
    mapOverviewData: {
      handler: 'mapOverviewDataHandler',
      immediate: true
    }
  }
});

/***/ }),

/***/ "dg2S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dimc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_errors_js__ = __webpack_require__("zNKi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_675d6556_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_errors_vue__ = __webpack_require__("HKaI");
function injectStyle (ssrContext) {
  __webpack_require__("qt4T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_errors_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_675d6556_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_errors_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dlHv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_public_profile_widget_js__ = __webpack_require__("3wpX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4ba9c26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_public_profile_widget_vue__ = __webpack_require__("rtSD");
function injectStyle (ssrContext) {
  __webpack_require__("d0qv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_public_profile_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4ba9c26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_public_profile_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dq6O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('div',{staticClass:"add-funds-coinbase"},[(_vm.documentUploadInfoVisible)?_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending,"theme":"page-padded"}}):[(_vm.showPromoNotification)?_c('alert-box',{staticClass:"add-funds-coinbase__alert-box",attrs:{"level":"success"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.promoCodeDetail.friendlyDescription)}})]):_vm._e(),_vm._v(" "),(_vm.depositWarning)?_c('div',{staticClass:"predictit-embedded-alert",domProps:{"innerHTML":_vm._s(_vm.depositWarning)}}):_vm._e(),_vm._v(" "),(_vm.error)?_c('alert-box',{staticClass:"add-funds-coinbase__alert-box",attrs:{"level":"warning"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.error)}})]):[_c('p',{staticClass:"add-funds-coinbase__note add-funds-coinbase__note--bold"},[_vm._v("\n        You can deposit funds into your PredictIt account using a "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":"https://www.coinbase.com/usdc"}},[_vm._v("USD Coin")]),_vm._v(" wallet. After clicking on the Confirm button below, you will be taken to Coinbase to complete your transaction.\n      ")]),_vm._v(" "),_c('p',{staticClass:"add-funds-coinbase__note add-funds-coinbase__note--bold"},[_vm._v("\n        Please note that "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":"https://www.coinbase.com"}},[_vm._v("Coinbase")]),_vm._v(" charges a network fee to transfer funds. You should expect a delay between the time you transfer funds from your wallet and the time you receive a credit in your PredictIt account.\n      ")]),_vm._v(" "),_c('form',{staticClass:"add-funds-coinbase__form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('h5',{staticClass:"form__title form__title--left form__title--margin"},[_vm._v("Deposit Amount ($"+_vm._s(_vm.minimumDepositAmount.toFixed(2))+" Minimum)")]),_vm._v(" "),_c('div',{staticClass:"row-x"},[(_vm.amountHasError)?_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"add-funds-coinbase__error"},[_vm._v("\n              "+_vm._s(_vm.amountValidationMessage)+"\n            ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"small-12 medium-4 column"},[_c('div',{staticClass:"input-group input-group--large"},[_c('span',{staticClass:"input-group__addon"},[_vm._v("$")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fields.amount),expression:"fields.amount"}],staticClass:"input-group__input",attrs:{"tabindex":"1","validation":_vm.$v.fields.amount},domProps:{"value":(_vm.fields.amount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.fields, "amount", $event.target.value)},_vm.$v.fields.amount.$touch],"blur":_vm.handleAmountBlur}})])]),_vm._v(" "),_c('div',{staticClass:"small-12 medium-8 column"},[_c('div',{staticClass:"row-x"},_vm._l((_vm.depositAmounts),function(amount){return _c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"button button--primary add-funds-coinbase__button",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onUpdateAmount(amount)}}},[_c('span',{staticClass:"add-funds-coinbase__button-plus"},[_vm._v("+")]),_vm._v(" $"+_vm._s(amount)+"\n                  ")])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"add-funds-coinbase__submit"},[_c('form-submit',{attrs:{"label":"Confirm","disabled":_vm.isConfirmDisabled}})],1)]),_vm._v(" "),(_vm.disclaimer)?[_c('br'),_vm._v(" "),(_vm.disclaimer)?_c('p',{staticClass:"add-funds-coinbase__note"},[_c('strong',[_vm._v("Note")]),_vm._v(": "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.disclaimer)}})]):_vm._e(),_vm._v(" "),(false)?_c('p',{staticClass:"add-funds-coinbase__note"},[_vm._v("\n          Due to anti-money laundering and anti-terrorism laws we have a "),_c('strong',[_vm._v("$10K daily deposit limit")]),_vm._v(". If your daily deposit(s) total more $10k on any given day you will automatically trigger a $500 processing fee and your account will be suspended for 7 days for processing.\n        ")]):_vm._e()]:_vm._e()]]],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "drjh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__ = __webpack_require__("Moaq");

/* eslint-disable */







var refreshSubscribers = [];
var isRefreshing = false;

function tokenRefreshSubscribe(cb) {
  refreshSubscribers.push(cb);
}

function tokenRefreshComplete(token) {
  refreshSubscribers.map(function (cb) {
    return cb(token);
  });
  refreshSubscribers = [];
}

var skipFromInterceptor = ['api/Account/UploadUserImage', 'api/Support/Ticket', 'api/Profile/SetUserAffiliations', 'api/Profile/RemoveUserAffiliations', "/" + 'api/Account/UploadUserImage', "/" + 'api/Support/Ticket', "/" + 'api/Profile/SetUserAffiliations', "/" + 'api/Profile/RemoveUserAffiliations'];

function checkRequest(request) {
  return request.method === 'post' && skipFromInterceptor.indexOf(request.url) === -1;
}

/* harmony default export */ __webpack_exports__["a"] = (function (request) {
  if (checkRequest(request)) {
    request.data = __WEBPACK_IMPORTED_MODULE_2_querystring___default.a.stringify(request.data);
  }
  if (!__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['user/isLoggedIn']) return request;

  var expiresAt = __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get('tokenExpires', null);
  var threshold = -60;
  var expiresOrIsAboutToExpires = expiresAt === null || __WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(expiresAt), 'seconds') > threshold;

  if (expiresOrIsAboutToExpires && !isRefreshing) {
    isRefreshing = true;
    var payload = {
      grant_type: 'refresh_token',
      refresh_token: __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get('refreshToken')
    };
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('user/login', payload).then(function () {
      isRefreshing = false;
      __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[TOKEN] REFRESHED');
      tokenRefreshComplete(__WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get('token'));
    }).catch(function () {
      __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[TOKEN] CANNOT REFRESH');
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('user/setToken', null);
    });

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      tokenRefreshSubscribe(function (token) {
        request.headers.Authorization = 'Bearer ' + token;
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].info('[TOKEN] Retry');
        resolve(request);
      });
    });
  }

  return request;
});

/***/ }),

/***/ "dstN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wallet_ach_ach_vue__ = __webpack_require__("Ucvo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wallet_check_check_vue__ = __webpack_require__("ep7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_wallet_bank_transfer_bank_transfer_vue__ = __webpack_require__("3mSF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wallet_coinbase_withdraw_coinbase_withdraw_vue__ = __webpack_require__("1ri1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_wallet_pending_requests_pending_requests_vue__ = __webpack_require__("EhGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_loader__ = __webpack_require__("39kf");










var TAB_ACH = 'ach';
var TAB_CHECK = 'check';
var TAB_COIN_BASE = 'coinbase';
var TAB_PENDING_REQUESTS = 'pending';
var TAB_BANK_TRANSFER = 'bank-transfer';
var GTM_PAGE_NAME = 'withdraw';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_loader__["a" /* default */]],
  components: {
    ach: __WEBPACK_IMPORTED_MODULE_3__components_wallet_ach_ach_vue__["a" /* default */],
    check: __WEBPACK_IMPORTED_MODULE_4__components_wallet_check_check_vue__["a" /* default */],
    bankTransfer: __WEBPACK_IMPORTED_MODULE_5__components_wallet_bank_transfer_bank_transfer_vue__["a" /* default */],
    coinbaseWithdraw: __WEBPACK_IMPORTED_MODULE_6__components_wallet_coinbase_withdraw_coinbase_withdraw_vue__["a" /* default */],
    pendingRequests: __WEBPACK_IMPORTED_MODULE_7__components_wallet_pending_requests_pending_requests_vue__["a" /* default */],
    tabs: __WEBPACK_IMPORTED_MODULE_2__components_generics_tabs_tabs_vue__["a" /* default */]
  },
  data: function data() {
    return {
      cryptoDesctiption: '',
      showTabs: false,
      activeTab: null,
      isCryptoAvailable: false,
      isCheckAvailable: false,
      isAchAvailable: false,
      isWireTransferAvailable: false
    };
  },

  computed: {
    showAchTab: function showAchTab() {
      return this.activeTab === TAB_ACH;
    },
    showCheckTab: function showCheckTab() {
      return this.activeTab === TAB_CHECK;
    },
    showPendingTab: function showPendingTab() {
      return this.activeTab === TAB_PENDING_REQUESTS;
    },
    showCryptoTab: function showCryptoTab() {
      return this.activeTab === TAB_COIN_BASE;
    },
    showBankTransferTab: function showBankTransferTab() {
      return this.activeTab === TAB_BANK_TRANSFER;
    },
    tabs: function tabs() {
      var results = [];
      if (this.isAchAvailable) {
        results.push({
          name: TAB_ACH,
          title: 'ACH'
        });
      }
      if (this.isCheckAvailable) {
        results.push({
          name: TAB_CHECK,
          title: 'Check'
        });
      }
      if (this.isCryptoAvailable) {
        results.push({
          name: TAB_COIN_BASE,
          title: this.cryptoDesctiption
        });
      }
      if (this.isWireTransferAvailable) {
        results.push({
          name: TAB_BANK_TRANSFER,
          title: 'Wire Transfer'
        });
      }
      results.push({ name: TAB_PENDING_REQUESTS, title: 'Pending' });
      return results;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['getWithdrawalMethods']), {
    onSuccessWithdraw: function onSuccessWithdraw() {
      this.activeTab = TAB_PENDING_REQUESTS;
    },
    tabChange: function tabChange(name) {
      this.activeTab = name;

      if (this.$route && this.$route.path) {
        this.$gtm.trackEvent({
          event: 'pageviewTrackerEvent',
          virtualPage: this.$route.path + '/' + GTM_PAGE_NAME + '/' + name,
          virtualPageTitle: this.$route.name + ' - ' + GTM_PAGE_NAME + ' - ' + name
        });
      }
    }
  }),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getWithdrawalMethods().then(function (data) {
      _this.showTabs = true;
      _this.isCheckAvailable = data.isCheckAvailable;
      _this.isAchAvailable = data.isAchAvailable;
      _this.isWireTransferAvailable = data.isWireTransferAvailable;
      _this.isCryptoAvailable = data.isCryptoAvailable;
      _this.cryptoDesctiption = data.cryptoDescription || 'USDC';
      _this.loaderRemove(document.body);
    }).catch(function () {
      return _this.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "dxV0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_link_js__ = __webpack_require__("bbNg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_147193f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_link_vue__ = __webpack_require__("XS8h");
function injectStyle (ssrContext) {
  __webpack_require__("szK9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_link_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_147193f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dywA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_trends_js__ = __webpack_require__("mka8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b433c5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trends_vue__ = __webpack_require__("xPvc");
function injectStyle (ssrContext) {
  __webpack_require__("zXob")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_trends_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b433c5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trends_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e/7H":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hbr.1e3fe64.png";

/***/ }),

/***/ "eExV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eFE/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_generics_modal_switch_switch_vue__ = __webpack_require__("iOeH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_market_market_contracts_stats_market_contracts_stats_vue__ = __webpack_require__("Y/q+");
/* eslint-disable no-restricted-syntax */




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketContractsStats: __WEBPACK_IMPORTED_MODULE_1__components_market_market_contracts_stats_market_contracts_stats_vue__["a" /* default */],
    switchModal: __WEBPACK_IMPORTED_MODULE_0__components_generics_modal_switch_switch_vue__["a" /* default */]
  },
  props: {
    stats: {
      type: Array,
      required: true
    },
    isFixed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return {
        'market-contracts-stats-popup__content': true,
        'market-contracts-stats-popup__content--long': this.stats.length > 5
      };
    }
  },
  methods: {
    close: function close() {
      this.$emit('modalClose');
    }
  }
});

/***/ }),

/***/ "eGtO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_processing_transaction_js__ = __webpack_require__("vJHd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62c6f73e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processing_transaction_vue__ = __webpack_require__("uVwX");
function injectStyle (ssrContext) {
  __webpack_require__("PadP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_processing_transaction_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62c6f73e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processing_transaction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eHhE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eInO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: String,
    data: Object
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click', this.data);
    }
  }
});

/***/ }),

/***/ "eLuk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_hero_unit_slider_js__ = __webpack_require__("bTYh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_073c7216_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_unit_slider_vue__ = __webpack_require__("bTUM");
function injectStyle (ssrContext) {
  __webpack_require__("yMNL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_hero_unit_slider_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_073c7216_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_unit_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eMds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_transactions_js__ = __webpack_require__("QA2/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b513f60a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_transactions_vue__ = __webpack_require__("iIRX");
function injectStyle (ssrContext) {
  __webpack_require__("tCjQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_transactions_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b513f60a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_transactions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eNZS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eNmc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_research_js__ = __webpack_require__("E2Y7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca33e24e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_research_vue__ = __webpack_require__("nK2W");
function injectStyle (ssrContext) {
  __webpack_require__("5yZz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_research_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca33e24e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_research_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eNoA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-modals"},[(_vm.isCurrentModal(_vm.MODALS.LOGIN))?_c('modal',{attrs:{"gtm":_vm.gtmLogin,"bodyClass":_vm.footerHideBodyClass,"closeButton":!_vm.isUserRestricted},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Login")]),_vm._v(" "),_c('account-login',{attrs:{"slot":"content","email":_vm.currentPopupOptions.email},slot:"content"}),_vm._v(" "),(!_vm.isUserRestricted && !_vm.isShutdownModeOn)?_c('account-login-footer',{attrs:{"slot":"footer"},slot:"footer"}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.FORGOTTEN))?_c('modal',{attrs:{"gtm":"forgotten","bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Forgotten Password")]),_vm._v(" "),_c('account-forgotten',{attrs:{"slot":"content"},slot:"content"}),_vm._v(" "),_c('account-forgotten-footer',{attrs:{"slot":"footer"},slot:"footer"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ACCOUNT_ALREADY_EXISTS))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","closeButton":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Account Already Exists")]),_vm._v(" "),_c('account-already-exists',{attrs:{"slot":"content","email":_vm.currentPopupOptions.email},slot:"content"}),_vm._v(" "),_c('account-already-exists-footer',{attrs:{"slot":"footer"},slot:"footer"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ACCOUNT_ENABLE_CLASSIC))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","closeButton":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Enable PredictIt Classic")]),_vm._v(" "),_c('account-enable-classic-predictit',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.RESET_PASSWORD))?_c('modal',{attrs:{"gtm":"reset-password","bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Reset Your Password")]),_vm._v(" "),_c('account-reset-password',{attrs:{"slot":"content","token":_vm.currentPopupOptions.token},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.REGISTER))?_c('modal',{attrs:{"gtm":_vm.gtmSignUp,"bodyClass":_vm.footerHideBodyClass},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Create an Account")]),_vm._v(" "),_c('account-register',{attrs:{"slot":"content"},slot:"content"}),_vm._v(" "),_c('account-register-footer',{attrs:{"slot":"footer"},slot:"footer"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.REGISTER_EXTERNAL))?_c('modal',{attrs:{"gtm":"SignUp-external","bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closeModalWithLogout()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Create an Account")]),_vm._v(" "),_c('account-register-external',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ACCOUNT_VERIFY))?_c('modal',{attrs:{"gtm":_vm.gtmAccountVerify,"bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('account-details-verify',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.UPLOAD_ID))?_c('modal',{attrs:{"gtm":"upload-id","bodyClass":"modal__body--medium","headerClass":"modal__header--small modal__header--gray"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("We are unable to verfiy your identity")]),_vm._v(" "),_c('account-upload-id',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.UPLOAD_DOCUMENT))?_c('modal',{attrs:{"gtm":"upload-document","bodyClass":"modal__body--medium","headerClass":"modal__header--small modal__header--gray"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_vm._v("\n    >\n      "),_c('div',{attrs:{"slot":"header"},slot:"header"},[(_vm.currentPopupOptions.isPending)?[_vm._v("Identity Verification Pending ")]:[_vm._v("Document Upload Required ")]],2),_vm._v(" "),_c('account-upload-document',{attrs:{"slot":"content","source":_vm.currentPopupOptions.source,"isPending":_vm.currentPopupOptions.isPending,"isModal":true},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.TAX_INFO))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","closeButton":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Tax Information")]),_vm._v(" "),_c('tax-info-notification',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ATTACH_TO_HOME))?_c('small-modal',{attrs:{"type":"top-alt","padding":false},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Add to Home Screen")]),_vm._v(" "),_c('attach-to-home',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ORIENTATION))?_c('modal',{attrs:{"bodyClass":"modal__body--full","closeButton":false,"fullScreen":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('orientation-info',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ACCOUNT_DETAIL_UPDATE) || _vm.isCurrentModal(_vm.MODALS.ACCOUNT_DETAIL_PASSWORD) || _vm.isCurrentModal(_vm.MODALS.ACCOUNT_DETAIL_PASSWORD_SET) || _vm.isCurrentModal(_vm.MODALS.ACCOUNT_ADDRESS_UPDATE))?_c('account-details-update-modal',{attrs:{"what":_vm.currentPopup}}):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.ADD_FUNDS))?_c('modal',{attrs:{"bodyClass":"modal__body--medium modal__body--show-ready","closeButtonClass":"modal__close--quick-deposit","gtm":_vm.gtmAddFunds},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Quick Deposit")]),_vm._v(" "),_c('add-funds-combined',{attrs:{"slot":"content","checkInstantCredit":_vm.currentPopupOptions.checkInstantCredit},slot:"content"}),_vm._v(" "),_c('add-funds-combined-footer',{attrs:{"slot":"footer"},slot:"footer"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.PAYMENT_SUCCESS))?_c('modal',{attrs:{"closeButton":!_vm.currentPopupOptions.noClose,"bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closePaymentSuccessModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('generic-popup',{attrs:{"slot":"content"},slot:"content"},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('deposited'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button button--large button--submit button--full-width",on:{"click":_vm.paymentSuccessDone}},[_c('span',[_vm._v("\n              Done\n            ")])]),_vm._v(" "),_c('div',{staticClass:"app-modals__payment-success-get-in-actions"},[_vm._v("\n            Get in the action: "),_c('router-link',{attrs:{"to":{ name: 'market-list' }}},[_vm._v("View All Markets")])],1)],1)])],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.PAYMENT_ERROR))?_c('modal',{attrs:{"bodyClass":"modal__body--medium"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('generic-popup',{attrs:{"slot":"content"},slot:"content"},[_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.currentPopupOptions.error)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.currentPopupOptions.error)}}):_c('p',[_vm._v("Unfortunately, we could not process your payment.")])])])],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.POTENTIAL_PAYOUTS))?_c('potential-payouts',{attrs:{"market":_vm.currentPopupOptions.market},on:{"modalClose":function($event){return _vm.closeModal()}}}):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.MARKET_CONTRACT_STATS))?_c('market-contracts-stats-popup',{attrs:{"stats":_vm.currentPopupOptions.stats,"isFixed":_vm.currentPopupOptions.isFixed},on:{"modalClose":function($event){return _vm.closeModal()}}}):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_OFFERS_INDICATOR))?_c('offers-indicator-popup',{attrs:{"items":_vm.currentPopupOptions.items,"operationType":_vm.currentPopupOptions.operationType,"price":_vm.currentPopupOptions.price},on:{"modalClose":function($event){return _vm.closeSmallModal()}}}):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.RESEARCH))?_c('modal',{attrs:{"bodyClass":"modal__body--gray modal__body--medium","noPadding":true,"gtm":"research"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Research Opportunities")]),_vm._v(" "),_c('research',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.TWITTER))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","noPadding":true,"clickOutsideEnabled":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Latest Tweets")]),_vm._v(" "),_c('twitter-timeline',{attrs:{"slot":"content","inOverlay":true},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.NEWS_FEED))?_c('modal',{attrs:{"bodyClass":"modal__body--medium","noPadding":true,"clickOutsideEnabled":true},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Latest News")]),_vm._v(" "),_c('news-feed',{attrs:{"slot":"content","inOverlay":true,"marketId":_vm.currentPopupOptions.marketId},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_SWIFT))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Info")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n        Text\n      ")])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_CVV))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Where is my CVV?")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("6M/o")}})])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_VERIFICATION_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),(_vm.currentPopupOptions.verificationStatus === 0)?_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          You need to have your identity verified in order to make a deposit. Click \"Verify\" to provide the necessary information.\n        ")]):_vm._e(),_vm._v(" "),(_vm.currentPopupOptions.verificationStatus === 1)?_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Some deposits and withdrawals will require us to perform an enhanced verification check. Click on \"Upgrade\" to prevent a delay in processing your transactions.\n        ")]):_vm._e(),_vm._v(" "),(_vm.currentPopupOptions.verificationStatus === 2)?_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Your identification documents are under review. We will notify you by email regarding your status within 72 hours of submission. You will be able to deposit funds once your identify has been confirmed. Thank you for your patience.\n        ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_ROUTING_NUMBER))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Sample Check")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/static/img/check.96fa935.jpg"),expression:"`/static/img/check.96fa935.jpg`"}]})])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_EDIT_IMAGE))?_c('small-modal',{attrs:{"type":"bottom"},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Change Profile Image")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('account-update-image')],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.PURCHASE))?_c('purchase-modal',{attrs:{"market":_vm.tradePopupOptions.market},on:{"modalClose":function($event){return _vm.closeModal()}}}):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.INSIGHT))?_c('insight-modal',{on:{"modalClose":function($event){return _vm.closeModal()}}}):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.GENERIC))?_c('modal',{attrs:{"bodyClass":"modal__body--gray"},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('generic-popup',{attrs:{"slot":"content"},slot:"content"},[(_vm.currentPopupOptions.content)?_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n          "+_vm._s(_vm.currentPopupOptions.content)+"\n        ")]):_vm._e()])],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_MARKET_RULES))?_c('modal',{attrs:{"autoClose":false},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('generic-small-popup',{attrs:{"slot":"content"},slot:"content"},[(_vm.currentPopupOptions.content)?_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"modal__content--rules",domProps:{"innerHTML":_vm._s(_vm.currentPopupOptions.content)}})]):_vm._e()])],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_GENERIC))?_c('small-modal',{attrs:{"autoClose":true},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('generic-small-popup',{attrs:{"slot":"content"},slot:"content"},[(_vm.currentPopupOptions.content)?_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n          "+_vm._s(_vm.currentPopupOptions.content)+"\n        ")]):_vm._e()])],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.EXPORT_TRADE_HISTORY))?_c('small-modal',{attrs:{"type":"bottom","padding":false},on:{"modalClose":function($event){return _vm.closeModalHideOverlay()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[(_vm.$route.query && _vm.$route.query.contractId)?[_vm._v("\n          Export Contract History\n        ")]:(_vm.$route.params.marketId && _vm.$route.params.marketId !== 'all')?[_vm._v("\n          Export Market History\n        ")]:[_vm._v("\n          Export Trade History\n        ")]],2),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('export-history',{attrs:{"kind":"trade"}})],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.EXPORT_TRANSACTION_HISTORY))?_c('small-modal',{attrs:{"type":"bottom","padding":false},on:{"modalClose":function($event){return _vm.closeModalHideOverlay()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Export Transaction History")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('export-history',{attrs:{"kind":"transaction"}})],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_USERNAME))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Username")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/static/img/avatar.9ff8844.svg"),expression:"`/static/img/avatar.9ff8844.svg`"}]}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n         A username is required to preserve your anominity when using third-party services.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_TRADE_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[(_vm.currentPopupOptions.completeInfo)?[_vm._v("\n          \"Net P/L\" is the sum of your profit/loss"),_c('br'),_vm._v(" and any trading fees. "),_c('br'),_c('br')]:_vm._e(),_vm._v("\n          Figures are calculated to the tenth of a cent, but rounded for display purposes.\n        ")],2)])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_OWNERSHIP_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Minimum Ownership Requirement")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Traders are required to purchase and maintain a minimum ownership of "+_vm._s(_vm.currentPopupOptions.shares)+" share"),(_vm.currentPopupOptions.shares > 1)?[_vm._v("s")]:_vm._e(),_vm._v(" in this contract.\n        ")],2)])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_ROI_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\nReturn on Investment (ROI) is calculated as the % gain or loss in the value of your portfolio over the time period. Deposits and withdrawals during that period are not included in this calculation. You must have a minimum portfolio value of $10 at both the beginning and end of the period to appear on the leaderboard.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_FEE_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\nThe fees listed here are the fees that PredictIt charges and do not include fees charged by any bank, crypto-network, or other 3rd party involved in transferring money.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_WINS_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          You are credited with a win whenever you sell a share at a profit.\n        ")]),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Trophies for Wins are awarded as follows:\n        ")]),_vm._v(" "),_c('leaderboards-trophy-pyramid')],1)]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_LEADERBOARDS_UPDATE_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Leaderboards are updated nightly. Your preference will be reflected in the next update.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_ANNOUNCEMENT))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Announcement")]),_vm._v(" "),_c('announcement',{attrs:{"slot":"content","announcement":_vm.currentPopupOptions.announcement},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_PUBLIC_PROFILE_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("About Your Profile")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          To make PredictIt more fun and social in the future we will allow traders to share information from their profiles. If there is anything you would rather keep private you can always mark it as hidden. On your profile pages hidden items are still shown but include an asterisk (*) to let you know they are hidden from other users.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_RESTRICTED_FUNDS_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Funds awarded as part of promotional offer cannot be withdrawn until traded.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_SHARE_INVITE_INFO))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":__webpack_require__("x0s9")}}),_vm._v(" "),_c('p',{staticClass:"modal-small__disclaimer"},[_vm._v("\n          Separate multiple email addresses with a semi-colon.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_MESSAGING_JOURNEY))?_c('small-modal',{attrs:{"closeButton":false}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Information")]),_vm._v(" "),_c('messaging-journey-info',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_PWMB_ACCOUNT_CONFIRM_DELETE))?_c('small-modal',{on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Confirmation")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("\n          Are you sure you want to remove this bank authorization?\n        ")]),_vm._v(" "),_c('div',{staticClass:"add-funds-bank-transfer__buttons"},[_c('button',{staticClass:"button button--large button--primary button--full-width",on:{"click":function($event){$event.stopPropagation();return _vm.currentPopupOptions.onConfirm($event)}}},[_vm._v("\n            Yes\n          ")]),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width button--focused",attrs:{"autofocus":""},on:{"click":function($event){$event.stopPropagation();return _vm.closeSmallModal()}}},[_vm._v("\n            No\n          ")])])])]):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_BADGES))?_c('modal',{attrs:{"headerClass":"modal__header--light modal__header--no-border","bodyClass":"modal__body--medium","autoClose":false},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Badges")]),_vm._v(" "),_c('account-badges-list',{staticClass:"modal__content--badges",attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_USER_PROFILE))?_c('modal',{attrs:{"headerClass":"modal__header--light modal__header--no-border","bodyClass":"modal__body--medium","autoClose":false},on:{"modalClose":function($event){return _vm.closeSmallModal()}}},[_c('user-profile-overview-header',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('user-profile-overview',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentSmallModal(_vm.MODALS.SMALL_REPORT_USER))?_c('modal',{attrs:{"headerClass":"modal__header--light modal__header--no-border","bodyClass":"modal__body--medium","autoClose":false},on:{"modalClose":function($event){return _vm.closeUserReportModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Report User")]),_vm._v(" "),_c('user-report',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.COINBASE))?_c('modal',{attrs:{"headerClass":"modal__header--light modal__header--no-border","bodyClass":"modal__body--medium","autoClose":false},on:{"modalClose":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n        Process Overview\n      ")]),_vm._v(" "),_c('coinbase-process-overview',{attrs:{"slot":"content","depositPayload":_vm.currentPopupOptions.depositPayload},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.AFFILIATIONS))?_c('modal',{attrs:{"closeButton":!!_vm.currentPopupOptions.allowClose,"noPadding":true,"bodyClass":"modal__body--slim modal__body--show-ready modal__body--no-overflow"},on:{"modalClose":_vm.closeModal}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("College Affiliation")]),_vm._v(" "),_c('affiliations-popup',{attrs:{"slot":"content"},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCurrentModal(_vm.MODALS.VIDEO))?_c('modal',{on:{"modalClose":_vm.closeModal}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.currentPopupOptions.title))]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('br'),_vm._v(" "),_c('youtube',{attrs:{"player-width":"100%","player-height":400,"video-id":_vm.currentPopupOptions.id}}),_vm._v(" "),_c('div',{staticClass:"app-modals__note"},[_vm._v("\n        For more information on how to trade on PredictIt, visit our "),_c('router-link',{staticClass:"app-modals__note-link",attrs:{"to":{name: 'HelpAndSupport'}}},[_vm._v("Support")]),_vm._v(" page.\n        ")],1)],1)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eWdu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wallet_withdraw_confirm_withdraw_confirm_vue__ = __webpack_require__("waMS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_wallet_available_balance_available_balance_vue__ = __webpack_require__("3PvP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__("c/9r");












/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["b" /* formMixin */]],
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_4__components_generics_alert_box_alert_box_vue__["a" /* default */],
    availableBalance: __WEBPACK_IMPORTED_MODULE_5__components_wallet_available_balance_available_balance_vue__["a" /* default */],
    withdrawConfirm: __WEBPACK_IMPORTED_MODULE_3__components_wallet_withdraw_confirm_withdraw_confirm_vue__["a" /* default */]
  },
  validations: function validations() {
    return {
      fields: {
        amount: __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["a" /* validators */].depositAmountCoinbase(this.minWithdrawal, this.maxWithdrawal)
      }
    };
  },
  created: function created() {
    this.checkWithdrawCoinbase();
  },
  data: function data() {
    return {
      countries: [],
      error: '',
      showConfirmation: false,
      fields: {
        amount: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('wallet', ['withdrawCoinbase']), {
    availableBalance: function availableBalance() {
      return this.withdrawCoinbase && this.withdrawCoinbase.availableFundsString ? this.withdrawCoinbase.availableFundsString : '$0.00';
    },
    restrictedFunds: function restrictedFunds() {
      return this.withdrawCoinbase && this.withdrawCoinbase.restrictedFundsString ? this.withdrawCoinbase.restrictedFundsString : '';
    },
    minWithdrawal: function minWithdrawal() {
      return this.maxWithdrawal > 0 ? 0.1 : 0;
    },
    maxWithdrawal: function maxWithdrawal() {
      return this.withdrawCoinbase ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["v" /* roundDown */])(this.withdrawCoinbase.availableFunds) : 0;
    },
    isWithdrawalDisabled: function isWithdrawalDisabled() {
      return Number(this.fields.amount || 0) === 0;
    },
    isAmountFieldDisabled: function isAmountFieldDisabled() {
      return this.minWithdrawal < 0.1 || this.maxWithdrawal < 1;
    },
    errorMessage: function errorMessage() {
      return this.error || this.withdrawCoinbase.errorMessage;
    },
    hasErrorMessage: function hasErrorMessage() {
      return this.error || !!this.withdrawCoinbase.errorMessage;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getVerifyID']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('wallet', ['getWithdrawCoinbase']), {
    onSubmit: function onSubmit() {
      this.showConfirmation = true;
    },
    onSuccess: function onSuccess() {
      this.fields.amount = '';
      this.showConfirmation = false;
      // this.$nextTick(() => { this.$v.$reset(); });
      this.checkWithdrawCoinbase();
      this.$emit('success');
    },
    onEdit: function onEdit() {
      this.showConfirmation = false;
    },
    checkWithdrawCoinbase: function checkWithdrawCoinbase() {
      var _this = this;

      this.getWithdrawCoinbase().then(function (data) {
        _this.checkDocumentUploadFlags(data);
        _this.isComponentReady = true;
      }).catch(function (error) {
        _this.isComponentReady = true;
        _this.error = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', '');
      });
    }
  })
});

/***/ }),

/***/ "eX9O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('transition',{attrs:{"name":"slide"}},[_c('nav-browse',{key:_vm.rotationIndex,attrs:{"theme":_vm.theme}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eaFd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"market-biggest-gains-element",attrs:{"tag":"div","to":{name: 'market-details', params: {marketId: _vm.promo.marketId, marketUrl: _vm.promo.marketUrl}}}},[(_vm.header)?_c('div',{staticClass:"market-biggest-gains-element__header"},[_vm._v("\n    "+_vm._s(_vm.promo.sectionTitle)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-biggest-gains-element__content"},[_c('div',{staticClass:"market-biggest-gains-element__market"},[_vm._v("\n      "+_vm._s(_vm.promo.marketName)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"market-biggest-gains-element__wrapper"},[_c('div',{staticClass:"market-biggest-gains-element__contract"},[_vm._v("\n        "+_vm._s(_vm.promo.contractName)+"\n      ")]),_vm._v(" "),_c('div',[_c('span',{staticClass:"market-biggest-gains-element__current-price"},[_c('animated-number',{attrs:{"value":_vm.contract.lastTradePriceAsCents}})],1),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.contract.changePriceAsCents,"lastClosePrice":_vm.contract.lastClosePrice}})],1),_vm._v(" "),_c('div',{class:_vm.iconModifiers})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eb91":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_list_item_v2_market_list_item_v2_vue__ = __webpack_require__("tPuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */]],
  props: {
    num: {
      type: Number,
      default: 3
    }
  },
  components: {
    marketListItem: __WEBPACK_IMPORTED_MODULE_3__components_market_v2_market_list_item_v2_market_list_item_v2_vue__["a" /* default */],
    swiper: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    var _this = this;

    return {
      activeIndex: 0,
      swiperOptions: {
        slidesPerView: 1,
        direction: 'horizontal',
        spaceBetween: 0,
        onTransitionStart: function onTransitionStart(swp) {
          _this.activeIndex = swp.activeIndex;
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('browse', ['newArrivalMarkets']), {
    title: function title() {
      return 'New Arrivals';
    },
    items: function items() {
      return this.newArrivalMarkets;
    },
    isPrevArrowDisabled: function isPrevArrowDisabled() {
      return this.activeIndex === 0;
    },
    isNextArrowDisabled: function isNextArrowDisabled() {
      return this.items.length === 0 || this.activeIndex === this.num - 1;
    },
    prevArrowModifiers: function prevArrowModifiers() {
      return {
        'most-predicted__header-arrow': true,
        'most-predicted__header-arrow--left': true,
        'most-predicted__header-arrow--disabled': this.isPrevArrowDisabled
      };
    },
    nextArrowModifiers: function nextArrowModifiers() {
      return {
        'most-predicted__header-arrow': true,
        'most-predicted__header-arrow--right': true,
        'most-predicted__header-arrow--disabled': this.isNextArrowDisabled
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getNewArrivalMarkets']), {
    prevSlide: function prevSlide() {
      if (!this.isPrevArrowDisabled) this.$refs.swiper.swiper.slidePrev();
    },
    nextSlide: function nextSlide() {
      if (!this.isNextArrowDisabled) this.$refs.swiper.swiper.slideNext();
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    var payload = {
      limit: this.num
    };

    this.loaderAdd();

    this.getNewArrivalMarkets(payload).then(function () {
      _this2.loaderRemove();
      _this2.isComponentReady = true;
    }).catch(function () {
      return _this2.loaderRemove();
    });
  }
});

/***/ }),

/***/ "ed4I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_switch_button_js__ = __webpack_require__("W82P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d66d03d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_switch_button_vue__ = __webpack_require__("3982");
function injectStyle (ssrContext) {
  __webpack_require__("u0LV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_switch_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d66d03d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_switch_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ep7m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_check_js__ = __webpack_require__("mcLx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21dfc379_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_check_vue__ = __webpack_require__("TQfW");
function injectStyle (ssrContext) {
  __webpack_require__("KmKt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_check_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21dfc379_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_check_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "etKJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multiselect",class:{ 'multiselect--active': _vm.isOpen, 'multiselect--disabled': _vm.disabled, 'multiselect--above': _vm.isAbove },attrs:{"tabindex":_vm.searchable ? -1 : _vm.tabindex},on:{"focus":function($event){return _vm.activate()},"blur":function($event){_vm.searchable ? false : _vm.deactivate()},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }if($event.target !== $event.currentTarget){ return null; }$event.preventDefault();return _vm.pointerForward()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }if($event.target !== $event.currentTarget){ return null; }$event.preventDefault();return _vm.pointerBackward()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }$event.stopPropagation();if($event.target !== $event.currentTarget){ return null; }return _vm.addPointerElement($event)}],"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.deactivate()}}},[_vm._t("caret",[_c('div',{staticClass:"multiselect__select",on:{"mousedown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggle()}}})],{"toggle":_vm.toggle}),_vm._v(" "),_vm._t("clear",null,{"search":_vm.search}),_vm._v(" "),_c('div',{ref:"tags",staticClass:"multiselect__tags"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visibleValue.length > 0),expression:"visibleValue.length > 0"}],staticClass:"multiselect__tags-wrap"},[_vm._l((_vm.visibleValue),function(option){return [_vm._t("tag",[_c('span',{staticClass:"multiselect__tag"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getOptionLabel(option))}}),_vm._v(" "),_c('i',{staticClass:"multiselect__tag-icon",attrs:{"aria-hidden":"true","tabindex":"1"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.removeElement(option)},"mousedown":function($event){$event.preventDefault();return _vm.removeElement(option)}}})])],{"option":option,"search":_vm.search,"remove":_vm.removeElement})]})],2),_vm._v(" "),(_vm.internalValue && _vm.internalValue.length > _vm.limit)?[_c('strong',{staticClass:"multiselect__strong",domProps:{"textContent":_vm._s(_vm.limitText(_vm.internalValue.length - _vm.limit))}})]:_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"multiselect__loading"}},[_vm._t("loading",[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"multiselect__spinner"})])],2),_vm._v(" "),(_vm.searchable)?_c('input',{ref:"search",staticClass:"multiselect__input",style:(_vm.inputStyle),attrs:{"name":_vm.name,"id":_vm.id,"type":"text","autocomplete":"off","placeholder":_vm.placeholder,"disabled":_vm.disabled,"tabindex":_vm.tabindex},domProps:{"value":_vm.isOpen ? _vm.search : _vm.currentOptionLabel},on:{"input":function($event){return _vm.updateSearch($event.target.value)},"focus":function($event){$event.preventDefault();return _vm.activate()},"blur":function($event){$event.preventDefault();return _vm.deactivate()},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.deactivate()},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.pointerForward()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.pointerBackward()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();if($event.target !== $event.currentTarget){ return null; }return _vm.addPointerElement($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){ return null; }$event.stopPropagation();return _vm.removeLastElement()}]}}):_vm._e(),_vm._v(" "),(!_vm.searchable)?_c('span',{staticClass:"multiselect__single",domProps:{"innerHTML":_vm._s(_vm.currentOptionLabel)},on:{"mousedown":function($event){$event.preventDefault();return _vm.toggle($event)}}}):_vm._e()],2),_vm._v(" "),_c('transition',{attrs:{"name":"multiselect"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],ref:"list",staticClass:"multiselect__content-wrapper",style:({ maxHeight: _vm.optimizedHeight + 'px' }),on:{"focus":_vm.activate,"mousedown":function($event){$event.preventDefault();}}},[_c('ul',{staticClass:"multiselect__content",style:(_vm.contentStyle)},[_vm._t("beforeList"),_vm._v(" "),(_vm.multiple && _vm.max === _vm.internalValue.length)?_c('li',[_c('span',{staticClass:"multiselect__option"},[_vm._t("maxElements",[_vm._v("Maximum of "+_vm._s(_vm.max)+" options selected. First remove a selected option to select another.")])],2)]):_vm._e(),_vm._v(" "),(!_vm.max || _vm.internalValue.length < _vm.max)?_vm._l((_vm.filteredOptions),function(option,index){return _c('li',{key:index,staticClass:"multiselect__element"},[(!(option && (option.$isLabel || option.$isDisabled)))?_c('span',{staticClass:"multiselect__option",class:_vm.optionHighlight(index, option),attrs:{"data-select":option && option.isTag ? _vm.tagPlaceholder : _vm.selectLabelText,"data-selected":_vm.selectedLabelText,"data-deselect":_vm.deselectLabelText},on:{"click":function($event){$event.stopPropagation();return _vm.select(option)},"mouseenter":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.pointerSet(index, option)}}},[_vm._t("option",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getOptionLabel(option))}})],{"option":option,"search":_vm.search})],2):_vm._e(),_vm._v(" "),(option && (option.$isLabel || option.$isDisabled))?_c('span',{staticClass:"multiselect__option multiselect__option--disabled",class:_vm.optionHighlight(index, option)},[_vm._t("option",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getOptionLabel(option))}})],{"option":option,"search":_vm.search})],2):_vm._e()])}):_vm._e(),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNoResults && (_vm.filteredOptions.length === 0 && _vm.search && !_vm.loading)),expression:"showNoResults && (filteredOptions.length === 0 && search && !loading)"}]},[_c('span',{staticClass:"multiselect__option"},[_vm._t("noResult",[_vm._v("No elements found. Consider changing the search query.")])],2)]),_vm._v(" "),_vm._t("afterList")],2)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "evoN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "exX2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__ = __webpack_require__("gnYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_list_item_v2_market_list_item_v2_vue__ = __webpack_require__("tPuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_market_filters_market_filters_desktop_grid_watchlist_market_filters_desktop_grid_watchlist_vue__ = __webpack_require__("dVCa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_market_market_filters_market_filters_mobile_watchlist_market_filters_mobile_watchlist_vue__ = __webpack_require__("SMhf");










var NO_ITEMS_MESSAGE = 'There are no markets in your Watchlist';
var NO_MORE_ITEMS_MESSAGE = 'No more markets to display';
var SCROLL_FOR_MORE = 'Scroll down for more markets';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_contentLoader__["a" /* default */]],
  props: {
    theme: {
      type: String,
      default: ''
    }
  },
  components: {
    marketFiltersDesktopGrid: __WEBPACK_IMPORTED_MODULE_7__components_market_market_filters_market_filters_desktop_grid_watchlist_market_filters_desktop_grid_watchlist_vue__["a" /* default */],
    marketFiltersMobile: __WEBPACK_IMPORTED_MODULE_8__components_market_market_filters_market_filters_mobile_watchlist_market_filters_mobile_watchlist_vue__["a" /* default */],
    marketListItem: __WEBPACK_IMPORTED_MODULE_4__components_market_v2_market_list_item_v2_market_list_item_v2_vue__["a" /* default */],
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Watchlist'
    };
  },
  data: function data() {
    return {
      loadedInfo: SCROLL_FOR_MORE,
      infiniteLoader: null,
      stickyOptions: __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__["a" /* default */].mobile,
      watchersDisabled: false,
      watchersRemoved: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('watchlist', ['selectedOrder', 'selectedTimespan']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('watchlist', ['watchlist']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['watchToggle']), {
    items: function items() {
      return this.watchlist.data === null ? [] : this.watchlist.data;
    },
    showNoMarketsMessage: function showNoMarketsMessage() {
      return !this.isLoading && this.items.length === 0;
    },
    filtering: function filtering() {
      return this.selectedOrder.name + this.selectedTimespan.name;
    },
    infiniteLoadingKey: function infiniteLoadingKey() {
      return 'watchlist-' + this.selectedOrder.sort + '-' + this.selectedTimespan.parameter + '-' + this.watchersRemoved;
    }
  }),
  watch: {
    filtering: 'filteringChanged',
    watchToggle: {
      handler: 'watchToggleHandler',
      immediate: true
    },
    items: function items() {
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        if (!this.watchlist.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }

      if (!this.watchlist.canLoadMore) {
        this.loadedInfo = this.items.length > 0 ? NO_MORE_ITEMS_MESSAGE : NO_ITEMS_MESSAGE;
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['clearOrder', 'clearTimespan']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('watchlist', ['resetWatchlist', 'getWatchList']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('profile', ['removeMarketFromWatchList']), {
    filteringChanged: function filteringChanged() {
      if (this.watchersDisabled) return;

      this.$router.push({
        name: 'market-watchlist',
        query: {
          sort: this.selectedOrder.sort,
          sortParameter: this.selectedTimespan.parameter
        }
      });
      this.resetWatchlist();
    },
    onRemoveMarketFromWatchList: function onRemoveMarketFromWatchList(item) {
      this.removeMarketFromWatchList(item.marketId);
    },
    watchToggleHandler: function watchToggleHandler() {
      this.watchersRemoved += 1;
      this.resetWatchlist();
    },
    goInfinite: function goInfinite(infi) {
      var _this = this;

      this.infiniteLoader = infi;

      if (this.watchlist.canLoadMore) {
        this.isLoading = true;
        this.getWatchList().then(function () {
          _this.isLoading = false;
        }).catch(function () {
          _this.isLoading = false;
        });
      }
    }
  }),
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // browse.selectedOrder etc i shared by watchlist and markets page
    this.watchersDisabled = true;
    this.clearTimespan().then(this.clearOrder()).then(function () {
      return next();
    });
  }
});

/***/ }),

/***/ "f3YR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fSu0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fUX9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contracts-stats"},[(_vm.isLayoutDesktop)?_c('div',{staticClass:"market-contracts-stats__market-name"},[_vm._v(_vm._s(_vm.market.marketName))]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"market-contracts-stats__table"},[_c('thead',{staticClass:"market-contracts-stats__thead"},[(_vm.isSortable)?_c('th',{staticClass:"market-contracts-stats__table-name",on:{"click":function($event){return _vm.sortBy('displayOrder')}}},[_c('span',{class:_vm.headerSortByModifiers('displayOrder')},[_vm._v("\n          Contract\n        ")])]):_vm._e(),_vm._v(" "),_c('th',{class:_vm.secondColumnModifiers,on:{"click":function($event){return _vm.sortBy('totalSharesTraded')}}},[_c('span',{class:_vm.headerSortByModifiers('totalSharesTraded')},[_vm._v("\n          Total Volume\n        ")])]),_vm._v(" "),(!_vm.isMarketSettled)?[_c('th',{class:_vm.thirdColumnModifiers,on:{"click":function($event){return _vm.sortBy('todaysVolume')}}},[_c('span',{class:_vm.headerSortByModifiers('todaysVolume')},[_vm._v("\n            Today's Volume\n          ")])]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('th',{staticClass:"market-contracts-stats--last",on:{"click":function($event){return _vm.sortBy('openInterest')}}},[_c('span',{class:_vm.headerSortByModifiers('openInterest')},[_vm._v("\n            Active Shares\n          ")])]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('tbody',[_vm._l((_vm.sortedItems),function(item,index){return _c('tr',{key:index},[(_vm.isSortable)?_c('td',{staticClass:"market-contracts-stats__table-name"},[_vm._v("\n          "+_vm._s(item.contractName)+"\n        ")]):_vm._e(),_vm._v(" "),_c('td',{class:_vm.secondColumnModifiers},[_vm._v("\n          "+_vm._s(item.totalSharesTraded.toLocaleString())+"\n        ")]),_vm._v(" "),(!_vm.isMarketSettled)?[_c('td',{class:_vm.thirdColumnModifiers},[_vm._v("\n            "+_vm._s(item.todaysVolume.toLocaleString())+"\n          ")]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('td',{staticClass:"market-contracts-stats--last"},[_vm._v("\n            "+_vm._s(item.openInterest.toLocaleString())+"\n          ")]):_vm._e()]:_vm._e()],2)}),_vm._v(" "),(_vm.isSortable)?_c('tr',[_c('td',{staticClass:"market-contracts-stats__table-name market-contracts-stats__table-name--bold market-contracts-stats__table-summary"},[_vm._v("\n          Total\n        ")]),_vm._v(" "),_c('td',{staticClass:"market-contracts-stats__table-summary",class:_vm.secondColumnModifiers},[_vm._v("\n          "+_vm._s(_vm.totalSharesTradedSum)+"\n        ")]),_vm._v(" "),(!_vm.isMarketSettled)?[_c('td',{staticClass:"market-contracts-stats__table-summary",class:_vm.thirdColumnModifiers},[_vm._v("\n            "+_vm._s(_vm.todaysVolumeSum)+"\n          ")]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('td',{staticClass:"market-contracts-stats__table-summary market-contracts-stats--last"},[_vm._v("\n            "+_vm._s(_vm.openInterestSum)+"\n          ")]):_vm._e()]:_vm._e()],2):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "flEW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_upload_id_js__ = __webpack_require__("LyDt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f96b755_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_upload_id_vue__ = __webpack_require__("EvDZ");
function injectStyle (ssrContext) {
  __webpack_require__("nqig")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_upload_id_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f96b755_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_upload_id_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fmhl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_ORDER_BOOK */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_notifications_firebase__ = __webpack_require__("2Pqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__ = __webpack_require__("Moaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("oiih");








var DEFAULT_ORDER_BOOK = {
  noOrders: 0,
  yesOrders: 0
};

function makeTradeOptions() {
  return {
    contractId: null,
    operationType: 'buy', // buy | sell
    operationValue: 'yes', // yes | no
    pricePerShare: null,
    quantity: __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* default */].DEFAULT_QUANTITY,
    skipConfirmation: __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].get('skipConfirmation', false),
    defaultTab: null
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    orderBook: null,
    contractShares: [],
    contractOffers: [],
    tradeOptions: makeTradeOptions(),
    tradeSuccess: false,
    keyboardDoubleSelected: false,
    cancelToggle: false,
    tradeOperationToggle: null,
    confirmationToggle: false
  },
  mutations: {
    setOrderBook: function setOrderBook(state, payload) {
      state.orderBook = payload;
    },
    clearOrderBook: function clearOrderBook(state) {
      state.orderBook = null;
    },
    setContractShares: function setContractShares(state, payload) {
      state.contractShares = payload;
    },
    setContractOffers: function setContractOffers(state, payload) {
      state.contractOffers = payload;
    },
    setTradeOptions: function setTradeOptions(state, payload) {
      if (state.tradeOptions !== null && payload !== null && state.tradeOptions.contractId === payload.contractId && state.tradeOptions.operationType === payload.operationType && state.tradeOptions.operationValue === payload.operationValue) {
        state.tradeOptions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.tradeOptions, payload);
      } else {
        var defaults = makeTradeOptions();
        var pricePerShare = defaults.pricePerShare;
        if (payload && state.tradeOptions.contractId === payload.contractId) {
          pricePerShare = state.tradeOptions.pricePerShare;
        }

        state.tradeOptions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, defaults, payload, {
          pricePerShare: pricePerShare
        });
      }
    },
    setTradeSuccess: function setTradeSuccess(state, flag) {
      state.tradeSuccess = flag;
    },
    setTradeQuantity: function setTradeQuantity(state, quantity) {
      state.tradeOptions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.tradeOptions, { quantity: parseInt(quantity, 10) || null });
    },
    setTradeDefaultTab: function setTradeDefaultTab(state, tab) {
      state.tradeOptions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.tradeOptions, { defaultTab: tab });
    },
    setTradePrice: function setTradePrice(state, pricePerShare) {
      var min = 1;
      var max = 99;
      var price = parseInt(pricePerShare, 10);

      if (price < min) {
        price = min;
      }
      if (price > max) {
        price = max;
      }
      state.tradeOptions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.tradeOptions, { pricePerShare: price });
    },
    setTradeSkipConfirmation: function setTradeSkipConfirmation(state, skipConfirmation) {
      var value = !!skipConfirmation;
      var expiresAt = 31536000; // 1 year
      __WEBPACK_IMPORTED_MODULE_5__helpers_localStorage__["a" /* default */].set('skipConfirmation', value, expiresAt);
      state.tradeOptions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.tradeOptions, { skipConfirmation: value });
    },
    updateKeyboardDoubleSelected: function updateKeyboardDoubleSelected(state, selected) {
      state.keyboardDoubleSelected = selected;
    },
    setCancelToggle: function setCancelToggle(state, flag) {
      state.cancelToggle = flag;
    },
    setConfirmationToggle: function setConfirmationToggle(state, flag) {
      state.confirmationToggle = flag;
    },
    toggleTradeOperation: function toggleTradeOperation(state, side) {
      state.tradeOperationToggle = side;
    }
  },
  actions: {
    confirmTrade: function confirmTrade(_ref, payload) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].trade.postConfirmTrade(payload);
    },
    submitTrade: function submitTrade(_ref2, payload) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].trade.postSubmitTrade(payload);
    },
    getOrderBook: function getOrderBook(_ref3, contractId) {
      var commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].trade.getOrderBook(contractId).then(function (response) {
        commit('setOrderBook', response.data);
        return response.data;
      });
    },
    updateOrderBookPeriodically: function updateOrderBookPeriodically(_ref4, contractId) {
      var commit = _ref4.commit;

      __WEBPACK_IMPORTED_MODULE_3__services_notifications_firebase__["d" /* addOrderBookListener */](contractId, function (data) {
        commit('setOrderBook', data);
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(DEFAULT_ORDER_BOOK));
    },
    clearOrderBookUpdates: function clearOrderBookUpdates(_ref5, contractId) {
      var commit = _ref5.commit;

      __WEBPACK_IMPORTED_MODULE_3__services_notifications_firebase__["e" /* clearOrderBookListeners */](contractId);
    },
    clearOrderBook: function clearOrderBook(_ref6) {
      var commit = _ref6.commit;

      commit('clearOrderBook');
    },
    getContractShares: function getContractShares(_ref7, contractId) {
      var commit = _ref7.commit;

      if (contractId === null) {
        commit('setContractShares', []);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve([]);
      }

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].profile.getContractShares(contractId).then(function (response) {
        commit('setContractShares', response.data.shares);
        return response.data.shares;
      });
    },
    getContractOffers: function getContractOffers(_ref8, contractId) {
      var commit = _ref8.commit;

      if (contractId === null) {
        commit('setContractOffers', []);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve([]);
      }

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].profile.getContractOffers(contractId).then(function (response) {
        commit('setContractOffers', response.data.offers);
        return response.data.offers;
      });
    },
    cancelAllOffers: function cancelAllOffers(_ref9, payload) {
      var commit = _ref9.commit;

      var contractId = payload.contractId;
      delete payload.contractId;
      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].trade.postCancelAllOffers(contractId, payload).then(function (response) {
        commit('setCancelToggle', true);
        return response.data;
      });
    },
    cancelOffer: function cancelOffer(_ref10, offerId) {
      var commit = _ref10.commit;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].trade.postCancelOffer(offerId).then(function (response) {
        commit('setCancelToggle', true);
        return response.data;
      });
    },
    setCancelToggle: function setCancelToggle(_ref11, flag) {
      var commit = _ref11.commit;

      commit('setCancelToggle', flag);
    },
    setConfirmationToggle: function setConfirmationToggle(_ref12, flag) {
      var commit = _ref12.commit;

      commit('setConfirmationToggle', flag);
    },
    setTradeOptions: function setTradeOptions(_ref13, payload) {
      var commit = _ref13.commit;

      commit('setTradeOptions', payload);
    },
    setTradeQuantity: function setTradeQuantity(_ref14, quantity) {
      var commit = _ref14.commit;

      commit('setTradeQuantity', quantity);
    },
    setTradePrice: function setTradePrice(_ref15, pricePerShare) {
      var commit = _ref15.commit;

      commit('setTradePrice', pricePerShare);
    },
    setTradeDefaultTab: function setTradeDefaultTab(_ref16, tab) {
      var commit = _ref16.commit;

      commit('setTradeDefaultTab', tab);
    },
    setTradeSuccess: function setTradeSuccess(_ref17, flag) {
      var commit = _ref17.commit;

      commit('setTradeSuccess', flag);
    },
    setTradeSkipConfirmation: function setTradeSkipConfirmation(_ref18, skipConfirmation) {
      var commit = _ref18.commit;

      commit('setTradeSkipConfirmation', skipConfirmation);
    },
    toggleTradeOperation: function toggleTradeOperation(_ref19, side) {
      var commit = _ref19.commit;

      commit('toggleTradeOperation', side);
    },
    updateKeyboardDoubleSelected: function updateKeyboardDoubleSelected(_ref20, selected) {
      var commit = _ref20.commit;

      commit('updateKeyboardDoubleSelected', selected);
    },
    getOrderBookTradeInfo: function getOrderBookTradeInfo(_ref21, _ref22) {
      var commit = _ref21.commit;
      var contractId = _ref22.contractId,
          tradeType = _ref22.tradeType,
          price = _ref22.price;

      return __WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].trade.getOrderBookTradeInfo(contractId, tradeType, price).then(function (response) {
        return response.data;
      });
    }
  }
});

/***/ }),

/***/ "foFW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit"},[(_vm.showTabs)?_c('div',{staticClass:"deposit__tabs"},[_c('tabs',{attrs:{"items":_vm.tabs,"theme":"alt"},on:{"tabChange":_vm.tabChange}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"deposit__content"},[(_vm.showCreditCardTab)?_c('add-funds-card',{key:_vm.cardDepositAttempt,attrs:{"mode":"page"},on:{"success":_vm.onAddFundsCardSuccess}}):_vm._e(),_vm._v(" "),(_vm.showCashTab)?_c('add-funds-cash'):_vm._e(),_vm._v(" "),(_vm.showCoinBaseTab)?_c('add-funds-coinbase'):_vm._e(),_vm._v(" "),(_vm.showBankingTab)?_c('add-funds-bank-transfer'):_vm._e(),_vm._v(" "),(_vm.showPendingTab)?_c('pending-requests'):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fp8t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-portfolio"},[_c('div',{staticClass:"dashboard-portfolio__summary"},[_c('div',{staticClass:"dashboard-portfolio__summary-item"},[(_vm.portfolioValueReady)?_c('div',{directives:[{name:"price-display",rawName:"v-price-display.fixed",value:(_vm.portfolioValueDecimal),expression:"portfolioValueDecimal",modifiers:{"fixed":true}}],staticClass:"dashboard-portfolio__summary-item-value"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dashboard-portfolio__summary-item-subtitle"},[_vm._v("Portfolio Value")])]),_vm._v(" "),_c('div',{staticClass:"dashboard-portfolio__summary-item"},[(_vm.portfolioValueReady)?_c('div',{directives:[{name:"price-display",rawName:"v-price-display.floor.fixed",value:(_vm.balance.portfolioBalanceDecimal),expression:"balance.portfolioBalanceDecimal",modifiers:{"floor":true,"fixed":true}}],staticClass:"dashboard-portfolio__summary-item-value"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dashboard-portfolio__summary-item-subtitle"},[_vm._v("Investment")])]),_vm._v(" "),_c('div',{staticClass:"dashboard-portfolio__summary-item"},[(_vm.portfolioValueReady)?_c('div',{directives:[{name:"price-display",rawName:"v-price-display.fixed",value:(Math.abs(_vm.mySharesTotalGainLoss)),expression:"Math.abs(mySharesTotalGainLoss)",modifiers:{"fixed":true}}],staticClass:"dashboard-portfolio__summary-item-value",class:_vm.gainLossClassModifiers}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dashboard-portfolio__summary-item-subtitle"},[_vm._v("Gain/Loss")])])]),_vm._v(" "),_c('div',{staticClass:"dashboard-portfolio__content"},[_c('dashboard-markets-toggle',{attrs:{"theme":"portfolio"}}),_vm._v(" "),_c('dashboard-market-filters'),_vm._v(" "),_c('portfolio-my-markets')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fpwF":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "fvSV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fvX1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getActiveButtonAfterSwitch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_shares_bar_market_shares_bar_vue__ = __webpack_require__("HvTw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_v2_button_price_button_price_vue__ = __webpack_require__("al65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_mutex__ = __webpack_require__("EOu+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_accountVerify__ = __webpack_require__("yZQa");



/* eslint-disable max-len, arrow-body-style, no-mixed-operators */











var thousandDisplay = function thousandDisplay(value) {
  if (value >= 1.0e+4) {
    return Math.round(value / 1.0e+3) + 'K';
  }
  return value >= 1.0e+3 ? Math.floor(10 * value / 1.0e+3) / 10 + 'K' : value;
};

var TITLE_LATEST_PRICE = 'Latest Price';
var OPERATIONS = {
  BUY: 'buy',
  SELL: 'sell'
};
var VALUES = {
  YES: 'yes',
  NO: 'no'
};
var BUTTONS = {
  BUY_NO: {
    id: 'buy-no',
    type: OPERATIONS.BUY,
    value: VALUES.NO
  },
  BUY_NO_ALT: {
    id: 'buy-no-alt',
    type: OPERATIONS.BUY,
    value: VALUES.NO
  },
  BUY_YES: {
    id: 'buy-yes',
    type: OPERATIONS.BUY,
    value: VALUES.YES
  },
  SELL_NO: {
    id: 'sell-no',
    type: OPERATIONS.SELL,
    value: VALUES.NO
  },
  SELL_YES: {
    id: 'sell-yes',
    type: OPERATIONS.SELL,
    value: VALUES.YES
  }
};

function getActiveButtonAfterSwitch(contractModel, switchTo) {
  var button = BUTTONS.BUY_NO_ALT;

  if (switchTo === 'right') {
    if (contractModel.mode === VALUES.NO) {
      button = BUTTONS.SELL_NO;
    } else if (contractModel.mode === VALUES.YES) {
      button = BUTTONS.SELL_YES;
    }
  } else if (switchTo === 'left') {
    if (contractModel.mode === VALUES.NO) {
      button = BUTTONS.BUY_NO;
    } else {
      button = BUTTONS.BUY_YES;
    }
  }

  return button;
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_accountVerify__["a" /* default */]],
  components: {
    buttonPrice: __WEBPACK_IMPORTED_MODULE_7__components_market_v2_button_price_button_price_vue__["a" /* default */],
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    marketSharesBar: __WEBPACK_IMPORTED_MODULE_6__components_market_market_shares_bar_market_shares_bar_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    contract: {
      type: Object,
      required: true
    },
    layout: {
      type: String,
      default: 'default'
    },
    showPurchaseOnInit: {
      type: Boolean,
      default: false
    },
    forCmsWidget: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      BUTTONS: BUTTONS,
      OPERATIONS: OPERATIONS,
      VALUES: VALUES,
      isWaiting: false,
      activeButton: null
    };
  },
  created: function created() {
    this.activatePurchaseJourneyForMarket();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile', 'isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'tradeOperationToggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('user', ['status']), {
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_4__models_contract__["a" /* default */](this.contract);
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["l" /* isMarketSingle */])(this.market);
    },
    singleMarketTitle: function singleMarketTitle() {
      return this.isMarketSingle ? TITLE_LATEST_PRICE : this.contractModel.contractName || this.contractModel.name;
    },
    title: function title() {
      return this.isMarketSingle ? this.singleMarketTitle : this.contractModel.contractName || this.contractModel.name;
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'market-contract-horizontal-v2': true,
        'market-contract-horizontal-v2--no-shares-or-offers': !this.showOffersOrShares
      }, 'market-contract-horizontal-v2--' + this.layout, this.layout);
    },
    rowModifiers: function rowModifiers() {
      return {
        row: true,
        'row-y': this.isLayoutDesktop,
        'row-large-100': true
      };
    },
    titleModifiers: function titleModifiers() {
      return {
        'market-contract-horizontal-v2__title': true,
        'market-contract-horizontal-v2__title--no-shares': !this.showSharesBar,
        'market-contract-horizontal-v2__title--no-offers': !this.showOpenOffers
      };
    },
    classModifiersMobileHeaderTitle: function classModifiersMobileHeaderTitle() {
      return {
        'market-contract-horizontal-v2__mobile-header-title': true,
        'market-contract-horizontal-v2__mobile-header-title--single': this.isMarketSingle
      };
    },
    isLayoutDashboard: function isLayoutDashboard() {
      return this.layout === 'dashboard';
    },
    infoPartModifiers: function infoPartModifiers() {
      return {
        column: true,
        'small-12': true,
        'column-large-100': true,
        'column-valign': true,
        'market-contract--dashboard': this.isLayoutDashboard,
        'market-contract--infopart': true
      };
    },
    pricePartModifiers: function pricePartModifiers() {
      return {
        column: true,
        'small-12': true,
        'column-large-100': true,
        'column-valign': true,
        'medium-5': !this.isLayoutDashboard,
        'medium-3': this.isLayoutDashboard
      };
    },
    imageAltText: function imageAltText() {
      return this.contractModel.contractName;
    },
    imageUrl: function imageUrl() {
      return this.contractModel.contractImageSmallUrl || this.contractModel.contractImageUrl;
    },
    contractImageStyleModifiers: function contractImageStyleModifiers() {
      return {
        'background-image': 'url(' + this.imageUrl + ')'
      };
    },
    isMarketDisabled: function isMarketDisabled() {
      var statuses = [__WEBPACK_IMPORTED_MODULE_9__constants__["a" /* default */].MARKET_EXPIRED, __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* default */].MARKET_SUSPENDED, __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* default */].MARKET_SETTLED, __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* default */].MARKET_MAINTENANCE];
      return this.market && statuses.includes(this.market.status);
    },
    isMarketSettled: function isMarketSettled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["e" /* isMarketSettled */])(this.market);
    },
    openOffersText: function openOffersText() {
      var buyOffers = thousandDisplay(this.contractModel.userOpenOrdersBuyQuantity, false);
      var sellOffers = thousandDisplay(this.contractModel.userOpenOrdersSellQuantity, false);
      // const prefix = (this.isLayoutDesktop && !this.isLayoutDashboard) ? 'Offers: ' : '';
      return buyOffers + '/' + sellOffers;
    },
    showOpenOffers: function showOpenOffers() {
      return !this.isMarketSettled && this.contractModel.userOpenOrders > 0;
    },
    showSharesBar: function showSharesBar() {
      return !this.isMarketSettled && this.contractModel.userQuantity > 0;
    },
    showOffersOrShares: function showOffersOrShares() {
      return this.showSharesBar || this.showOpenOffers;
    },
    showOuterPriceButton: function showOuterPriceButton() {
      return !this.isLayoutDashboard && this.isLayoutDesktop;
    },
    showInnerPriceButton: function showInnerPriceButton() {
      return this.isLayoutDashboard || this.isLayoutMobile;
    },
    disabledMarketButtonText: function disabledMarketButtonText() {
      return this.market.status;
    },
    shouldClosePurchaseJourney: function shouldClosePurchaseJourney() {
      return this.isLayoutDesktop && this.tradeOptions && this.tradeOptions.contractId === this.contract.contractId;
    },
    currentPrice: function currentPrice() {
      return this.contractModel.lastTradePriceAsCents;
    }
  }),
  watch: {
    // opposite side of order book was clicked -- switching sides
    tradeOperationToggle: function tradeOperationToggle(switchTo) {
      if (this.contract.contractId !== this.tradeOptions.contractId || !switchTo) return;
      var button = getActiveButtonAfterSwitch(this.contractModel, switchTo);
      this.toggleTradeOperation(null);
      this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, null, button.id);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('trade', ['setTradeOptions', 'toggleTradeOperation']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    findActiveButton: function findActiveButton() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(BUTTONS).find(function (i) {
        return i.id === _this.activeButton;
      });
    },
    getTypeAndValueIfButtonActiveOrDefaults: function getTypeAndValueIfButtonActiveOrDefaults() {
      var type = this.tradeOptions.operationType;
      var value = this.tradeOptions.operationValue;
      if (this.activeButton) {
        var button = this.findActiveButton();
        type = button.type;
        value = button.value;
      }
      return { type: type, value: value };
    },
    onClickSharesBar: function onClickSharesBar() {
      var _getTypeAndValueIfBut = this.getTypeAndValueIfButtonActiveOrDefaults(),
          type = _getTypeAndValueIfBut.type,
          value = _getTypeAndValueIfBut.value;

      this.openPurchaseJourney(this.contractModel.contractId, type, value, 'my-shares');
    },
    onClickOpenOffers: function onClickOpenOffers() {
      var tab = 'sell-offers';
      var operationType = this.tradeOptions.operationType || '';
      if (operationType === '' && this.contractModel.userOpenOrdersBuyQuantity || operationType === OPERATIONS.BUY && this.contractModel.userOpenOrdersBuyQuantity) {
        tab = 'buy-offers';
      }

      var _getTypeAndValueIfBut2 = this.getTypeAndValueIfButtonActiveOrDefaults(),
          type = _getTypeAndValueIfBut2.type,
          value = _getTypeAndValueIfBut2.value;

      this.openPurchaseJourney(this.contractModel.contractId, type, value, tab);
    },
    activatePurchaseJourneyForMarket: function activatePurchaseJourneyForMarket() {
      var button = this.contractModel.mode === VALUES.NO ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
      this.activeButton = button.id;
      if (this.showPurchaseOnInit) {
        this.$emit('purchaseShown');
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, null, null);
      } else if ((!this.isMarketSingle || this.isLayoutMobile) && this.tradeOptions && this.contract.contractId === this.tradeOptions.contractId && (button.type !== this.tradeOptions.operationType || button.value !== this.tradeOptions.operationValue)) {
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, null, null);
      }
    },
    onContractClick: function onContractClick() {
      if (this.shouldClosePurchaseJourney) {
        this.setTradeOptions(null);
        return;
      }
      if (!this.isMarketDisabled && this.activeButton) {
        var $el = this.$refs[this.activeButton];
        if (!$el) return;
        var ev = new MouseEvent('click');
        $el.dispatchEvent(ev);
      } else {
        var button = this.contractModel.mode === VALUES.NO ? BUTTONS.BUY_NO : BUTTONS.BUY_YES;
        this.openPurchaseJourney(this.contractModel.contractId, button.type, button.value, null, null);
      }
    },
    isButtonActive: function isButtonActive(index) {
      var isOn = this.activeButton === index;
      return {
        'market-contract-horizontal-v2__button-single--on': isOn,
        'market-contract-horizontal-v2__button-single--off': !isOn
      };
    },
    openPurchaseJourney: function openPurchaseJourney(contractId, operationType, operationValue) {
      var _this2 = this;

      var defaultTab = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var activateButton = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      if (this.isWaiting) {
        return;
      }

      this.isWaiting = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_mutex__["a" /* waitForFirebaseInitialized */])().then(function () {
        _this2.isWaiting = false;
        // contract does not modify tradeOptions, is simply used as a widget somewhere
        if (_this2.forCmsWidget) {
          _this2.$emit('contractClicked', { contractId: contractId });
          return;
        }
        if (_this2.isLoggedIn && _this2.status.isClassicEnabled === false) {
          _this2.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
          return;
        }
        if (_this2.isLoggedIn && !_this2.isUserVerified) {
          _this2.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_VERIFY);
          return;
        }
        if (_this2.isLoggedIn && !_this2.status.hasBeenFunded) {
          _this2.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS);
          return;
        }
        if (_this2.isMarketSettled) return;
        if (_this2.isMarketDisabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["m" /* contractOwnershipNum */])(_this2.contractModel) === 0) return;
        if (activateButton) {
          _this2.activeButton = activateButton;
        }

        _this2.setTradeOptions({
          contractId: contractId,
          operationType: operationType,
          defaultTab: defaultTab,
          operationValue: operationValue !== null ? operationValue : _this2.contractModel.mode || VALUES.YES
        });
      });
    }
  })
});

/***/ }),

/***/ "fvt5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");


/* eslint-disable no-restricted-syntax, arrow-body-style */




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    slim: {
      type: Boolean,
      default: false
    },
    contract: {
      type: Object,
      required: true
    },
    items: {
      type: Array,
      required: true,
      default: []
    },
    operationValue: {
      type: String,
      default: 'yes',
      validator: function validator(value) {
        return ['no', 'yes'].indexOf(value) >= 0;
      }
    },
    operationType: {
      type: String,
      default: 'buy',
      validator: function validator(value) {
        return ['buy', 'sell'].indexOf(value) >= 0;
      }
    }
  },
  data: function data() {
    return {
      deleteAllMode: false,
      deleteOfferId: null
    };
  },

  computed: {
    classModifiers: function classModifiers() {
      return {
        'order-book-offers': true,
        'order-book-offers--delete-all': this.deleteAllMode
      };
    },
    tableModifiers: function tableModifiers() {
      return {
        'order-book__table': true,
        'order-book__table--slim': this.slim
      };
    },
    offers: function offers() {
      var _this = this;

      var items = this.items.map(function (o) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, o, {
          pricePerShare: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["j" /* toCents */])(o.pricePerShare)
        });
      });
      items.sort(function (prev, next) {
        if (prev.pricePerShare === next.pricePerShare) {
          return 0;
        }
        var result = 1;
        if (prev.pricePerShare < next.pricePerShare) result = -1;

        return _this.operationType === 'buy' ? -result : result;
      });
      return items;
    },
    showProcessedNotice: function showProcessedNotice() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.offers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (!item.isProcessed) return true;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('market', ['getMarket']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('trade', ['cancelOffer', 'cancelAllOffers', 'getContractOffers', 'getOrderBook', 'setTradeOptions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotification']), {
    deleteClicked: function deleteClicked(offerId) {
      this.cancelClicked();
      this.deleteOfferId = offerId;
    },
    confirmDeleteClicked: function confirmDeleteClicked(offerId) {
      var _this2 = this;

      this.cancelOffer(offerId).then(function () {
        _this2.setCurrentPopup();
        _this2.setTradeOptions(null);
        _this2.setSuccessSideNotification('Your offer has been removed.');
        _this2.getContractOffers(_this2.contract.contractId);
      }).catch(function () {
        return _this2.cancelClicked();
      });
    },
    confirmDeleteAllClicked: function confirmDeleteAllClicked() {
      var _this3 = this;

      var payload = {
        contractId: this.contract.contractId,
        offerType: this.operationType
      };
      this.cancelAllOffers(payload).then(function () {
        _this3.setCurrentPopup();
        _this3.setTradeOptions(null);
        _this3.setSuccessSideNotification('Your offers have been removed.');
        _this3.getContractOffers(_this3.contract.contractId);
        _this3.cancelClicked();
      }).catch(function () {
        return _this3.cancelClicked();
      });
    },
    deleteAllClicked: function deleteAllClicked() {
      this.cancelClicked();
      this.deleteAllMode = true;
    },
    cancelClicked: function cancelClicked() {
      this.deleteAllMode = false;
      this.deleteOfferId = null;
    }
  }),
  created: function created() {
    this.cancelClicked();
  }
});

/***/ }),

/***/ "fwL7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fxl/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['newHeaderExchangeUrl']), {
    exchangeNavigateUrl: function exchangeNavigateUrl() {
      return this.newHeaderExchangeUrl + '?welcome=true';
    }
  })
});

/***/ }),

/***/ "fyXg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_header_title_large_js__ = __webpack_require__("526r");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd90a4a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_header_title_large_vue__ = __webpack_require__("O8wz");
function injectStyle (ssrContext) {
  __webpack_require__("Nb1x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_header_title_large_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd90a4a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_header_title_large_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fzCn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketLoader_vue__ = __webpack_require__("HPJt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35809d05_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketLoader_vue__ = __webpack_require__("bVL2");
function injectStyle (ssrContext) {
  __webpack_require__("5oDx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35809d05_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g1ej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_account_details_update_account_address_update_vue__ = __webpack_require__("jVeD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_account_account_details_update_account_details_update_vue__ = __webpack_require__("a/AT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_account_account_update_password_account_update_password_vue__ = __webpack_require__("mx5S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_account_set_password_account_set_password_vue__ = __webpack_require__("s06T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generics_modal_modal_vue__ = __webpack_require__("CAzF");








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    what: String
  },
  components: {
    accountAddressUpdate: __WEBPACK_IMPORTED_MODULE_2__components_account_account_details_update_account_address_update_vue__["a" /* default */],
    accountDetailsUpdate: __WEBPACK_IMPORTED_MODULE_3__components_account_account_details_update_account_details_update_vue__["a" /* default */],
    accountUpdatePassword: __WEBPACK_IMPORTED_MODULE_4__components_account_account_update_password_account_update_password_vue__["a" /* default */],
    accountSetPassword: __WEBPACK_IMPORTED_MODULE_5__components_account_account_set_password_account_set_password_vue__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_6__components_generics_modal_modal_vue__["a" /* default */]
  },
  methods: {
    closeModal: function closeModal() {
      this.$router.go(-1);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    noPadding: function noPadding() {
      return this.isLayoutMobile;
    },
    header: function header() {
      switch (this.what) {
        case 'account-detail-password-set':
          return 'Set Password';
        case 'account-detail-password':
          return 'Change Password';
        case 'account-detail-update':
          return 'Change Username';
        default:
          return 'Change Address';
      }
    }
  })
});

/***/ }),

/***/ "gCuu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    amount: {
      type: Number,
      required: false
    },
    fee: {
      type: Number,
      required: false
    },
    total: {
      type: Number,
      required: false
    },
    isBankTransfer: {
      type: Boolean,
      default: false
    },
    isDeposit: {
      type: Boolean,
      default: false
    },
    flatFeeAmount: {
      type: Number,
      required: false
    },
    percentageFeeAmount: {
      type: Number,
      required: false
    }
  },
  computed: {
    flatFeeAmountRounded: function flatFeeAmountRounded() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(this.flatFeeAmount);
    },
    percentageFeeAmountRounded: function percentageFeeAmountRounded() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(this.percentageFeeAmount);
    },
    feeRounded: function feeRounded() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(this.fee || 0);
    },
    totalRounded: function totalRounded() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["i" /* roundToTwo */])(this.total);
    }
  }
});

/***/ }),

/***/ "gFdO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_refine_link_js__ = __webpack_require__("eInO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65906468_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refine_link_vue__ = __webpack_require__("nULK");
function injectStyle (ssrContext) {
  __webpack_require__("oQNj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_refine_link_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65906468_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refine_link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gJ7L":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "gLxY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gMF1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-already-exists-footer"},[_c('h4',{staticClass:"account-already-exists-footer__title"},[_vm._v("\n        Don't have an account?\n      ")]),_vm._v(" "),_c('a',{staticClass:"account-already-exists-footer__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onCreateAccount($event)}}},[_vm._v("\n        Create an Account\n      ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gQ0Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_landing_pages_index1_index1_vue__ = __webpack_require__("b2pe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_landing_pages_index2_index2_vue__ = __webpack_require__("gSES");



/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/index1',
  name: 'index1',
  component: __WEBPACK_IMPORTED_MODULE_0__components_landing_pages_index1_index1_vue__["a" /* default */],
  meta: {
    requiresAnonymous: true
  }
}, {
  path: '/index2',
  name: 'index2',
  component: __WEBPACK_IMPORTED_MODULE_1__components_landing_pages_index2_index2_vue__["a" /* default */],
  meta: {
    requiresAnonymous: true
  }
}]);

/***/ }),

/***/ "gQIB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gSES":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_index2_js__ = __webpack_require__("9eDo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42456ef2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index2_vue__ = __webpack_require__("p4qN");
function injectStyle (ssrContext) {
  __webpack_require__("1PxF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_index2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42456ef2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gTQM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_potential_payouts_js__ = __webpack_require__("cFI2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ee6f6d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_potential_payouts_vue__ = __webpack_require__("OU80");
function injectStyle (ssrContext) {
  __webpack_require__("J3xD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_potential_payouts_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ee6f6d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_potential_payouts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gVgM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_register_js__ = __webpack_require__("klsN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54d80b5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_register_vue__ = __webpack_require__("zoV9");
function injectStyle (ssrContext) {
  __webpack_require__("fwL7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_register_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54d80b5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gYFg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"market-watch"}},[(_vm.show)?_c('button',{staticClass:"market-watch",class:_vm.classModifiers,attrs:{"title":_vm.title},on:{"click":function($event){$event.stopPropagation();return _vm.onWatchToggle($event)}}},[_vm._v("\n     \n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gYkw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_collapsible_panel_simple_js__ = __webpack_require__("M0+2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e84e31a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapsible_panel_simple_vue__ = __webpack_require__("DZrC");
function injectStyle (ssrContext) {
  __webpack_require__("ybwC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_collapsible_panel_simple_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e84e31a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapsible_panel_simple_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gatU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_http__ = __webpack_require__("p1CT");


/* harmony default export */ __webpack_exports__["a"] = ({
  getMostPopular: function getMostPopular() {
    var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '12h';
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

    // from disqus api
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Insight/MostPopular/' + interval + '?count=' + count);
  },
  getAnalysis: function getAnalysis() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    // from tumblr api
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Insight/Analysis?limit=' + limit + '&offset=' + offset);
  },
  getFeeds: function getFeeds() {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Insight/Feeds');
  },
  getMarketFeeds: function getMarketFeeds(marketId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Insight/Feeds/Markets/' + marketId);
  },
  getNews: function getNews() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return __WEBPACK_IMPORTED_MODULE_0__services_api_http__["b" /* default */].get('api/Insight/News?limit=' + limit + '&offset=' + offset);
  }
});

/***/ }),

/***/ "gdGR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_social_badge_js__ = __webpack_require__("3yfD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a54eb02e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_social_badge_vue__ = __webpack_require__("uaDr");
function injectStyle (ssrContext) {
  __webpack_require__("6SU6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_social_badge_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a54eb02e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_social_badge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gjXf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_layout_js__ = __webpack_require__("EyLR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f3a4630_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_layout_vue__ = __webpack_require__("h4Lw");
function injectStyle (ssrContext) {
  __webpack_require__("yNb/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_layout_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f3a4630_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gnYi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  desktop: { zIndex: 3, stickyTop: 90 },
  mobile: { zIndex: 3, stickyTop: 90 }
  // TODO change back
  // desktop: { zIndex: 3, stickyTop: 109 },
  // mobile: { zIndex: 3, stickyTop: 109 },
});

/***/ }),

/***/ "grrE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gwUB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_v2_market_contract_v2_market_contract_v2_vue__ = __webpack_require__("D5rx");







var MAX_CONTRACTS_TO_DISPLAY = 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketContract: __WEBPACK_IMPORTED_MODULE_5__components_market_v2_market_contract_v2_market_contract_v2_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    layout: {
      type: String,
      default: 'grid'
    },
    theme: {
      type: String
    },
    watchIcon: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hovered: false,
      showMarketImages: this.showImage && this.market.marketImageUrl
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({
        'market-list-item-v2': true,
        'market-list-item-v2--large': true,
        'market-list-item-v2--hover': this.hovered,
        'market-list-item-v2--not-logged': !this.isLoggedIn
      }, 'market-list-item-v2--' + this.layout, true);
    },
    styleModifiers: function styleModifiers() {
      var extraGradient = 'linear-gradient(to right, rgba(0, 0, 0, 0.62) 0%,rgba(0, 0, 0,0.2) 30px,rgba(0,0,0,0) 100%)';

      return {
        'background-image': extraGradient + ',  url(' + this.market.marketImageUrl + ')'
      };
    },
    contracts: function contracts() {
      var results = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(this.market.contracts) || [];
      if (!results) return [];

      /* Add fake copy of a contract that represents NO contracts */
      if (results.length === 1) {
        var noContract = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ noContract: true }, results[0]);
        results.push(noContract);
      }

      return results.slice(0, MAX_CONTRACTS_TO_DISPLAY);
    },
    showSharesOwnedNotification: function showSharesOwnedNotification() {
      return this.market.userHasOwnership;
    },
    onClick: function onClick() {
      this.$router.push({
        name: 'market-details',
        params: {
          marketId: this.market.marketId,
          marketUrl: this.market.marketUrl
        }
      });
    }
  }),
  methods: {
    contractKey: function contractKey(contract) {
      var suffix = contract.noContract ? 'no' : 'yes';
      return contract.contractId + '-' + suffix;
    },
    onMouseOver: function onMouseOver() {
      this.hovered = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.hovered = false;
    }
  }
});

/***/ }),

/***/ "h/F2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    account: {
      type: Object,
      required: true
    },
    removable: {
      type: Boolean,
      default: true
    },
    selectable: {
      type: Boolean,
      default: true
    },
    showMessage: {
      type: Boolean,
      default: true
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showStatusMessage: function showStatusMessage() {
      return this.showMessage && typeof this.account.accountStatus !== 'undefined' && this.account.accountStatus !== 1;
    },
    classModifiers: function classModifiers() {
      return {
        'bank-account': true,
        'bank-account--selectable': this.selectable
      };
    }
  }
});

/***/ }),

/***/ "h1Ye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    theme: {
      type: String,
      default: ''
    }
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'account-form-loader': true
      }, 'account-form-loader--' + this.theme, this.theme);
    }
  }
});

/***/ }),

/***/ "h4Lw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.appModifiers},[(!_vm.isSimpleLayout)?[_c('maintenance-notification'),_vm._v(" "),_c('search-bar'),_vm._v(" "),_c('transition',{attrs:{"name":"app-layout-side-notification"}},[(_vm.sideNotificationShouldDisplay)?_c('side-notification',{attrs:{"level":_vm.sideNotificationLevel,"text":_vm.sideNotificationText,"sideNotificationOnCloseCallback":_vm.sideNotificationOnCloseCallback}}):_vm._e()],1),_vm._v(" "),_c(_vm.headerComponent,{tag:"component",class:_vm.headerModifiers})]:_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"app-layout","mode":"out-in"}},[_c('div',[_c('div',{class:_vm.contentModifiers},[_c('notification-items'),_vm._v(" "),_c('router-view')],1),_vm._v(" "),(!_vm.isSimpleLayout)?_c('div',{staticClass:"app-layout-old__footer"},[_c('app-footer')],1):_vm._e()])]),_vm._v(" "),(!_vm.isUserRestricted)?_c('div',{staticClass:"app-layout-old__bottom-nav"},[_c('app-main-nav',{key:_vm.$router.currentRoute.path,attrs:{"showIcons":true}})],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h9LM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_friends_search_js__ = __webpack_require__("Ym4l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e408598a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_friends_search_vue__ = __webpack_require__("F2lC");
function injectStyle (ssrContext) {
  __webpack_require__("gQIB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_friends_search_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e408598a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_friends_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hBWk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hQjR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_table_js__ = __webpack_require__("AxKI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d48877b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_table_vue__ = __webpack_require__("N2S3");
function injectStyle (ssrContext) {
  __webpack_require__("uY68")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_table_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d48877b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hZuO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-enable-classic-predictit"},[_c('form-errors',{staticClass:"account-enable-classic-predictit__errors",attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('p',{staticClass:"account-enable-classic-predictit__first"},[_vm._v("\r\n      Your PredictIt account gives you access to all PredictIt products. Since each product has different terms you must enable each product individually.\r\n    ")]),_vm._v(" "),_c('p',{staticClass:"account-enable-classic-predictit__second"},[_vm._v("\r\n      By clicking \"Enable PredictIt Classic\", you confirm that you are at least 18 years of age and have read the "),_c('router-link',{staticClass:"account-enable-classic-predictit__link",attrs:{"to":{ name: 'terms-and-conditions', params: { noPopup: true } },"target":"_blank"}},[_vm._v("\r\n          Terms and Conditions\r\n        ")]),_vm._v(". One account per person.\r\n    ")],1),_vm._v(" "),_c('div',{staticClass:"account-enable-classic-predictit__button"},[_c('form-submit',{attrs:{"disabled":!_vm.isFormEnabled,"label":"Enable PredictIt Classic"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "haTa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hene":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-login"},[_c('div',{staticClass:"page-login__content"},[_c('div',{staticClass:"page-login__title"},[_vm._v("\n      "+_vm._s(_vm.$txt('page-login.title'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"page-login__content-wrap"},[_c('account-login',{attrs:{"mode":"page"}}),_vm._v(" "),_c('account-login-footer',{attrs:{"mode":"page"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hfa6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "htEh":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "i3z8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__ = __webpack_require__("gnYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_filters_market_filters_mobile_market_filters_mobile_vue__ = __webpack_require__("EvOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_section_header_market_section_header_vue__ = __webpack_require__("ZqrY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_list_desktop_header_market_list_desktop_header_vue__ = __webpack_require__("/v52");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_market_v2_market_list_item_v2_market_list_item_v2_vue__ = __webpack_require__("tPuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_headerTags__ = __webpack_require__("cgm0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__logger__ = __webpack_require__("G/BR");














var CLASS_IS_LOADING_DESKTOP = 'is-loading-small';
var CLASS_IS_LOADING_MOBILE = 'is-loading';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_headerTags__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_userAgent__["a" /* default */]],
  components: {
    infiniteLoading: __WEBPACK_IMPORTED_MODULE_8_vue_infinite_loading___default.a,
    marketFiltersMobile: __WEBPACK_IMPORTED_MODULE_4__components_market_market_filters_market_filters_mobile_market_filters_mobile_vue__["a" /* default */],
    marketSectionHeader: __WEBPACK_IMPORTED_MODULE_5__components_market_market_section_header_market_section_header_vue__["a" /* default */],
    marketListDesktopHeader: __WEBPACK_IMPORTED_MODULE_6__components_market_market_list_desktop_header_market_list_desktop_header_vue__["a" /* default */],
    marketListItem: __WEBPACK_IMPORTED_MODULE_7__components_market_v2_market_list_item_v2_market_list_item_v2_vue__["a" /* default */]
  },
  props: {
    notificationText: {
      type: String,
      required: false
    },
    notificationLevel: {
      type: String,
      required: false
    },
    headerId: Number,
    headerUrl: String
  },
  data: function data() {
    return {
      isLoading: true,
      isFiltering: false,
      infiniteLoader: null,
      filtersUsed: false,
      stickyOptions: __WEBPACK_IMPORTED_MODULE_3__helpers_stickyConstants__["a" /* default */].mobile,
      watchersDisabled: false
    };
  },
  metaInfo: function metaInfo() {
    if (this.currentHeader !== null) {
      return {
        title: this.currentHeader.seoTitle || 'Markets',
        link: [{ rel: 'canonical', href: '' + window.location.href }],
        meta: [{ name: 'description', content: this.currentHeader.seoDescription }, { itemprop: 'name', content: this.currentHeader.seoTitle }, { itemprop: 'description', content: this.currentHeader.seoDescription }, { property: 'og:title', content: this.currentHeader.seoTitle }, { property: 'og:type', content: 'website' }, { property: 'og:description', content: this.currentHeader.seoDescription }, { property: 'og:site_name', content: 'Predictit' }, { property: 'og:url', content: '' + window.location.href }]
      };
    }
    return {
      title: 'Markets'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('browse', ['selectedFilters', 'selectedOrder', 'selectedTimespan', 'filteredMarkets', 'headers', 'latestHeaderId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['marketDisplay']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('app', ['previousRoute']), {
    items: function items() {
      var markets = this.filteredMarkets.data === null ? [] : this.filteredMarkets.data;
      var statuses = [__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* default */].MARKET_SETTLED, __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* default */].MARKET_EXPIRED, __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* default */].MARKET_SUSPENDED];
      return markets.filter(function (m) {
        return !statuses.includes(m.status);
      });
    },
    showNoMarketsMessage: function showNoMarketsMessage() {
      return !this.isLoading && this.items.length === 0;
    },
    currentHeader: function currentHeader() {
      var _this = this;

      var header = this.headers ? this.headers.find(function (h) {
        return h.headerId === _this.headerId;
      }) : null;
      return header || null;
    },
    currentHeaderName: function currentHeaderName() {
      var header = this.currentHeader;
      return header ? header.name : 'All Markets';
    },
    showBiggestGains: function showBiggestGains() {
      return this.isLayoutMobile && !this.filtersUsed;
    },
    sectionHeaderClass: function sectionHeaderClass() {
      return {
        'page-markets__section-header': true,
        'page-markets__section-header--padding': true
      };
    },
    filtering: function filtering() {
      return this.selectedFilters.toString() + this.selectedOrder.name + this.selectedTimespan.name;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['clearFilters', 'clearTimespan', 'clearOrder', 'getFilters', 'getFilteredMarkets', 'setLatestHeaderId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['updateMarketDisplay']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['setSideNotification']), {
    fetchData: function fetchData() {
      var _this2 = this;

      this.isLoading = true;
      this.infiniteLoader = null;
      if (this.isFiltering) return;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(this.headerId)) {
        __WEBPACK_IMPORTED_MODULE_12__logger__["a" /* default */].info('[MARKETS] Fetching Data');
        this.isFiltering = true;
        this.reorganizeTags();
        this.getFilters(this.headerId).then(function () {
          _this2.getMarkets(true).then(function () {
            _this2.isFiltering = false;
            _this2.isLoading = false;
          }).catch(function () {
            _this2.isLoading = false;
            _this2.isFiltering = false;
          });
        }).catch(function () {
          _this2.isFiltering = false;
          _this2.isLoading = false;
        });
      }
    },
    getMarkets: function getMarkets() {
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return this.getFilteredMarkets({
        headerId: this.headerId || 0,
        reset: reset
      });
    },
    onLayoutToggle: function onLayoutToggle(layout) {
      this.updateMarketDisplay(layout);
    },
    onFiltersUsed: function onFiltersUsed() {
      this.filtersUsed = true;
    },
    filteringChanged: function filteringChanged() {
      if (this.watchersDisabled) return;

      __WEBPACK_IMPORTED_MODULE_12__logger__["a" /* default */].info('[MARKETS] Filtering. Is in Progress: ' + this.isFiltering.toString());
      if (this.isFiltering) return;
      this.$router.push({
        name: 'market-list',
        params: {
          headerId: this.headerId,
          headerUrl: this.headerUrl
        },
        query: {
          filterIds: this.selectedFilters.join(','),
          sort: this.selectedOrder.sort,
          sortParameter: this.selectedTimespan.parameter
        }
      });
      this.fetchData();
    },
    headerIdChanged: function headerIdChanged(newValue, oldValue) {
      __WEBPACK_IMPORTED_MODULE_12__logger__["a" /* default */].info('[MARKETS] headerId Changed', this.latestHeaderId, oldValue, newValue);

      var shouldClearHeaderData = typeof oldValue !== 'undefined' && oldValue !== newValue && this.latestHeaderId !== newValue || newValue === 0 && this.previousRoute;

      if (shouldClearHeaderData) {
        // this.clearOrder();
        // this.clearTimespan();
        this.setLatestHeaderId(newValue);
        var location = window.location.href;
        if (!location.includes('widget')) {
          __WEBPACK_IMPORTED_MODULE_12__logger__["a" /* default */].info('[MARKETS] Clearing Filters');
          this.clearFilters();
        }
      }
      this.filtersUsed = false;
      this.fetchData();
    },
    goInfinite: function goInfinite(infi) {
      this.infiniteLoader = infi;

      if (this.filteredMarkets.canLoadMore) {
        this.getMarkets(false);
      }
    }
  }),
  watch: {
    headerId: {
      handler: 'headerIdChanged',
      immediate: true
    },
    filtering: 'filteringChanged',
    isLoggedIn: 'fetchData',
    isFiltering: function isFiltering(value) {
      var target = this.isLayoutDesktop ? this.$refs.desktopHeader.$el : this.$refs.mobileHeader.$el;
      var targetClass = this.isLayoutDesktop ? CLASS_IS_LOADING_DESKTOP : CLASS_IS_LOADING_MOBILE;
      if (value) {
        target.classList.add(targetClass);
      } else {
        target.classList.remove(targetClass);
      }
    },
    items: function items() {
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        if (!this.filteredMarkets.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }
    }
  },
  created: function created() {
    if (this.notificationText && this.notificationLevel) {
      this.setSideNotification({
        text: this.notificationText,
        level: this.notificationLevel
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.watchersDisabled = true;
    if (to.name !== 'market-details') {
      this.clearFilters();
    }
    next();
  }
});

/***/ }),

/***/ "i6WZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i8vA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_nav_browse_js__ = __webpack_require__("/Tgi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ead897a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_browse_vue__ = __webpack_require__("8YBB");
function injectStyle (ssrContext) {
  __webpack_require__("9qAd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_nav_browse_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ead897a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_browse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iE4u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iHjQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_research_research_vue__ = __webpack_require__("eNmc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_support_videos_videos_vue__ = __webpack_require__("HSd1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_twitter_twitter_timeline_twitter_timeline_vue__ = __webpack_require__("FM5G");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    contentHeader: __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__["a" /* default */],
    research: __WEBPACK_IMPORTED_MODULE_3__components_research_research_vue__["a" /* default */],
    twitterTimeline: __WEBPACK_IMPORTED_MODULE_5__components_twitter_twitter_timeline_twitter_timeline_vue__["a" /* default */],
    videos: __WEBPACK_IMPORTED_MODULE_4__components_support_videos_videos_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Research'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']))
});

/***/ }),

/***/ "iIRX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transactions"},[_c('div',{staticClass:"row row-xy"},[_c('div',{staticClass:"column small-8"},[_c('form-select',{attrs:{"searchable":false,"placeholder":"Type","options":_vm.transactionFilters.typeOptions,"track-by":"value","label":"label"},model:{value:(_vm.filter.type),callback:function ($$v) {_vm.$set(_vm.filter, "type", $$v)},expression:"filter.type"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-4"},[_c('form-select',{attrs:{"searchable":false,"maxHeight":300,"placeholder":"Year","options":_vm.transactionFilters.yearOptions,"track-by":"value","label":"label"},model:{value:(_vm.filter.year),callback:function ($$v) {_vm.$set(_vm.filter, "year", $$v)},expression:"filter.year"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12"},[_c('balance-history',{attrs:{"type":_vm.filter.type.value,"items":_vm.items,"canLoadMore":_vm.canLoadMore},on:{"itemCancelled":_vm.onItemCancelled,"loading":_vm.loadHistory}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iOeH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_switch_js__ = __webpack_require__("/gy2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c979503_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_switch_vue__ = __webpack_require__("/nxz");
function injectStyle (ssrContext) {
  __webpack_require__("K9BP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_switch_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c979503_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iPAm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-badges-list"},[_c('div',{staticClass:"account-badges-list__title"},[_vm._v("\n    You earned "+_vm._s(_vm.earned.length)+" badge"),(_vm.earned.length !== 1)?[_vm._v("s")]:_vm._e(),_vm._v(" today\n  ")],2),_vm._v(" "),_c('div',{staticClass:"account-badges-list__content"},_vm._l((_vm.earned),function(badge,index){return _c('div',{key:index,staticClass:"account-badges-list__badge"},[_c('div',{staticClass:"account-badges-list__badge-icon"}),_vm._v(" "),_c('div',{staticClass:"account-badges-list__badge-title"},[_vm._v(_vm._s(badge.title))])])}),0),_vm._v(" "),_c('div',{staticClass:"account-badges-list__title"},[_vm._v("\n    You now have "+_vm._s(_vm.current.length)+" badge"),(_vm.current.length !== 1)?[_vm._v("s")]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"account-badges-list__content"},_vm._l((_vm.current),function(badge,index){return _c('div',{key:index,staticClass:"account-badges-list__badge"},[_c('div',{staticClass:"account-badges-list__badge-icon"}),_vm._v(" "),_c('div',{staticClass:"account-badges-list__badge-title"},[_vm._v(_vm._s(badge.title))])])}),0),_vm._v(" "),_c('div',{staticClass:"account-badges-list__title"},[_vm._v("\n    Still to discover\n  ")]),_vm._v(" "),_c('div',{staticClass:"account-badges-list__content"},_vm._l((_vm.toDiscover),function(badge,index){return _c('div',{key:index,staticClass:"account-badges-list__badge"},[_c('div',{staticClass:"account-badges-list__badge-icon account-badges-list__badge-icon--locked"}),_vm._v(" "),_c('div',{staticClass:"account-badges-list__badge-title"},[_vm._v(_vm._s(badge.title))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iRLs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iSsy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iYpn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    contract: {
      type: Object,
      required: true
    },
    layout: {
      type: String,
      default: 'grid'
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_3__models_contract__["a" /* default */](this.contract);
    },
    isMarketSingle: function isMarketSingle() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["l" /* isMarketSingle */])(this.market);
    },
    title: function title() {
      if (!this.isMarketSingle) return this.contractModel.contractName || this.contractModel.name;
      return this.contract.noContract ? 'No' : 'Yes';
    },
    price: function price() {
      var lastPrice = this.contractModel.lastTradePriceAsCents;
      if (!this.isMarketSingle) return lastPrice;
      if (this.contract.noContract) {
        return lastPrice === 0 ? 0 : 100 - lastPrice;
      }
      return lastPrice === 0 ? 0 : lastPrice;
    },
    changePrice: function changePrice() {
      var price = this.contractModel.changePriceAsCents;
      return this.contract.noContract ? -price : price;
    },
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'market-contract-v2': true
      }, 'market-contract-v2--' + this.layout, true);
    },
    isDisabled: function isDisabled() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["o" /* isContractOpen */])(this.contractModel);
    }
  })
});

/***/ }),

/***/ "icPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contract-list-v2-embed"},[_c('div',{staticClass:"market-contract-list-v2-embed__contracts"},_vm._l((_vm.market.contracts),function(contract){return _c('market-contract',{key:contract.contractId,attrs:{"data-contract-id":contract.contractId,"showPurchaseOnInit":false,"market":_vm.market,"contract":contract,"forCmsWidget":true},on:{"contractClicked":_vm.onContractClick}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ihRI":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MiIgaGVpZ2h0PSI4MiIgdmlld0JveD0iMCAwIDgyIDgyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8Y2lyY2xlIGN4PSI0MCIgY3k9IjQwIiByPSI0MC41IiBzdHJva2U9IiM0MkNGMjYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiLz4NCiAgICAgICAgPHBhdGggZmlsbD0iIzQyQ0YyNiIgZD0iTTYwLjY0MiAzMS4yNDJsLTIxLjkyNCAyMi45NGEzLjQ5NSAzLjQ5NSAwIDAgMS01LjEwNiAwbC05LjE1OC05LjU3OWMtMS40MDgtMS40NzctMS40MDgtMy44NjkgMC01LjM0NmEzLjUwMSAzLjUwMSAwIDAgMSA1LjEwNiAwbDYuNjA1IDYuOTFMNTUuNTM1IDI1LjlhMy40OTUgMy40OTUgMCAwIDEgNS4xMDcgMGMxLjQxMiAxLjQ3NCAxLjQxMiAzLjg2NiAwIDUuMzQzIi8+DQogICAgPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "imWh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "imzz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_learn_the_basics_js__ = __webpack_require__("nHRj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5559ae45_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_learn_the_basics_vue__ = __webpack_require__("T0tA");
function injectStyle (ssrContext) {
  __webpack_require__("dZzV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_learn_the_basics_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5559ae45_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_learn_the_basics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ircP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_coinbase_js__ = __webpack_require__("/JWN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df7224be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_coinbase_vue__ = __webpack_require__("dq6O");
function injectStyle (ssrContext) {
  __webpack_require__("U048")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_coinbase_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df7224be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_coinbase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j3lF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_register_account_register_vue__ = __webpack_require__("61DT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_account_account_register_footer_footer_vue__ = __webpack_require__("cVuz");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    accountRegister: __WEBPACK_IMPORTED_MODULE_0__components_account_account_register_account_register_vue__["a" /* default */],
    accountRegisterFooter: __WEBPACK_IMPORTED_MODULE_1__components_account_account_register_footer_footer_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "j519":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{staticClass:"wallet"},[(_vm.isLayoutMobile)?_c('content-header',{staticClass:"content-header--account",attrs:{"title":_vm.mobilePageTitle}}):_vm._e(),_vm._v(" "),_c('div',{class:_vm.gridRowModifier},[(!_vm.isLayoutMobile)?_c('div',{staticClass:"column large-4 wallet__sticky"},[_c('profile')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column large-8 small-12"},[(!_vm.hasMaintenance)?[(_vm.isLayoutMobile && !_vm.isShutdownModeOn)?_c('div',{staticClass:"wallet__tabs"},[_c('tabs',{attrs:{"items":_vm.tabs},on:{"tabChange":_vm.tabChange}})],1):_vm._e(),_vm._v(" "),(!_vm.isLayoutMobile)?_c('account-desktop-header',{attrs:{"title":"Wallet","activeTab":_vm.activeTab,"tabs":_vm.tabs},on:{"tabChange":_vm.tabChange}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wallet__content"},[(_vm.showDepositTab)?_c('deposit'):_vm._e(),_vm._v(" "),(_vm.showWithdrawTab)?_c('withdraw'):_vm._e()],1)]:[_c('div',{staticClass:"wallet__content-maintenance"},[_c('alert-box',{attrs:{"level":"warning"}},[_vm._v("\r\n            Due to site maintenance, it is not possible to deposit or withdraw funds at this time. Please try again later.\r\n          ")])],1)]],2)])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j7VE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j8AR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j9oC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('h2',{staticClass:"purchase-offer-value__header"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"purchase-offer-value__wrap"},[_c('button',{staticClass:"purchase-offer-value__button purchase-offer-value__button--left",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.subtract($event)}}},[_vm._v("-1¢")]),_vm._v(" "),_c('div',{staticClass:"purchase-offer-value__box",on:{"click":_vm.onBoxClick}},[(_vm.kind === 'modal')?_c('keyboard-numeric-input',{attrs:{"value":_vm.cents,"selected":_vm.selected,"symbol":true},on:{"click":_vm.click},model:{value:(_vm.cents),callback:function ($$v) {_vm.cents=$$v},expression:"cents"}}):[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cents),expression:"cents"}],ref:"input",staticClass:"purchase-offer-value__input",attrs:{"tabindex":_vm.tabindex,"maxlength":"2","placeholder":""},domProps:{"value":(_vm.cents)},on:{"blur":function($event){return _vm.$emit('blur')},"focus":function($event){return _vm.$emit('focus')},"input":function($event){if($event.target.composing){ return; }_vm.cents=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"purchase-offer-value__symbol"},[_vm._v("¢")])]],2),_vm._v(" "),_c('button',{staticClass:"purchase-offer-value__button purchase-offer-value__button--right",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.add($event)}}},[_vm._v("+1¢")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jDBh":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4NCiAgICA8cGF0aCBmaWxsPSIjMDdBMEJCIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMyAxNi44NzVWMS4xMjVDMjMgLjUwMiAyMi40OTggMCAyMS44NzUgMEg2LjVBNC41MDEgNC41MDEgMCAwIDAgMiA0LjV2MTVDMiAyMS45ODQgNC4wMTYgMjQgNi41IDI0aDE1LjM3NWMuNjIzIDAgMS4xMjUtLjUwMiAxLjEyNS0xLjEyNXYtLjc1YzAtLjM1Mi0uMTY0LS42Ny0uNDE3LS44NzctLjE5Ny0uNzIxLS4xOTctMi43OCAwLTMuNTAxLjI1My0uMjAyLjQxNy0uNTIuNDE3LS44NzJ6TTggNi4yODFDOCA2LjEyNyA4LjEyNyA2IDguMjgxIDZoOS45MzhjLjE1NCAwIC4yODEuMTI3LjI4MS4yODF2LjkzOGEuMjgyLjI4MiAwIDAgMS0uMjgxLjI4MUg4LjI4QS4yODIuMjgyIDAgMCAxIDggNy4yMTlWNi4yOHptMCAzQzggOS4xMjcgOC4xMjcgOSA4LjI4MSA5aDkuOTM4Yy4xNTQgMCAuMjgxLjEyNy4yODEuMjgxdi45MzhhLjI4Mi4yODIgMCAwIDEtLjI4MS4yODFIOC4yOEEuMjgyLjI4MiAwIDAgMSA4IDEwLjIxOVY5LjI4ek0xOS44NzggMjFINi41Yy0uODMgMC0xLjUtLjY3LTEuNS0xLjUgMC0uODI1LjY3NS0xLjUgMS41LTEuNWgxMy4zNzhjLS4wODkuODAyLS4wODkgMi4xOTggMCAzeiIvPg0KPC9zdmc+DQo="

/***/ }),

/***/ "jI1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_affiliations_popup_js__ = __webpack_require__("WeRi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65933f2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_affiliations_popup_vue__ = __webpack_require__("nT5N");
function injectStyle (ssrContext) {
  __webpack_require__("MXhm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_affiliations_popup_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65933f2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_affiliations_popup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jJDj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"close-button",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.close($event)}}},[(!_vm.isDark)?_c('img',{attrs:{"src":__webpack_require__("srjS"),"alt":"Close"}}):_vm._e(),_vm._v(" "),(_vm.isDark)?_c('img',{attrs:{"src":__webpack_require__("gJ7L"),"alt":"Close"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jLJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) {
  window.Swiper = __webpack_require__("gsqX");
  __webpack_require__("v2ns");
}
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function mount() {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    };
    this.options.notNextTick ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),

/***/ "jPoG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return regularContractPrice; });
/* unused harmony export noContractPrice */
function regularContractPrice(contractData) {
  if (contractData.closeSharePrice === null) return null;
  return Number((100 * contractData.closeSharePrice).toFixed(2));
}

function noContractPrice(contractData) {
  if (contractData.closeSharePrice === null) return null;
  return Number((100 - contractData.closeSharePrice * 100).toFixed(2));
}



/***/ }),

/***/ "jVeD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_address_update_js__ = __webpack_require__("kwj7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00fb1e30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_address_update_vue__ = __webpack_require__("tI6S");
function injectStyle (ssrContext) {
  __webpack_require__("UMUI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_address_update_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00fb1e30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_address_update_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jeW4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jh2l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jl5J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-top-comments"},[_c('div',{staticClass:"market-top-comments__header"},[_c('div',{staticClass:"market-top-comments__title"},[_vm._v(_vm._s(_vm.obj.title))]),_vm._v(" "),_c('div',{staticClass:"market-top-comments__arrows"},[_c('span',{class:_vm.prevArrowModifiers,on:{"click":_vm.prevSlide}}),_vm._v(" "),_c('span',{class:_vm.nextArrowModifiers,on:{"click":_vm.nextSlide}})])]),_vm._v(" "),_c('div',{staticClass:"row market-top-comments__content"},[(!!_vm.obj)?_c('swiper',{ref:"swiper",staticClass:"market-top-comments__slider",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.items),function(comment,index){return _c('swiper-slide',{key:index,staticClass:"market-top-comments__slide"},[_c('top-comment',{attrs:{"comment":comment}})],1)}),1):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "joAC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    checked: {
      type: String
    },
    value: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('change', this.value);
    },
    onChange: function onChange(e) {
      this.$emit('change', e.target.value);
    }
  }
});

/***/ }),

/***/ "jtWA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['setWatchedUserDetails']), {
    showUserDetails: function showUserDetails(item) {
      var profitablePredictions = (typeof item.totalProfitablePredictions !== 'undefined' ? item.totalProfitablePredictions : item.profitablePredictions) || 0;
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_USER_PROFILE);
      var trader = {
        userName: item.userName,
        avatarImage: item.avatarImage,
        traderLevel: item.traderLevel || null,
        profitablePredictions: profitablePredictions
      };
      this.setWatchedUserDetails(trader);
    }
  })
});

/***/ }),

/***/ "k+5b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k2oC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k6pL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-with-info",class:_vm.selectedModifier,on:{"click":_vm.onClick}},[_c('span',{staticClass:"button-with-info__text"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),(_vm.selected)?_c('div',{staticClass:"button-with-info__icon",class:_vm.iconModifier,on:{"click":function($event){$event.stopPropagation();return _vm.onInfoClick($event)}}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k843":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kGlu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_filters_filter_button_filter_button_vue__ = __webpack_require__("3GDC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_filters_menu_button_menu_button_vue__ = __webpack_require__("Q/ey");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    filterButton: __WEBPACK_IMPORTED_MODULE_4__components_market_market_filters_filter_button_filter_button_vue__["a" /* default */],
    menuButton: __WEBPACK_IMPORTED_MODULE_5__components_market_market_filters_menu_button_menu_button_vue__["a" /* default */]
  },
  data: function data() {
    return {
      ordersOpen: false,
      filtersOpen: false,
      timespansOpen: false,
      isDashboardOpen: false,
      isWatchlistOpen: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('browse', ['filters', 'orders', 'timespans', 'selectedFilters', 'selectedOrder', 'selectedTimespan', 'shouldShowTimespanFilter']), {
    mainClassName: function mainClassName() {
      return 'market-filters';
    },
    filterMenuName: function filterMenuName() {
      var prefix = this.isLayoutMobile ? 'Keywds' : 'Keywords';
      if (this.selectedFilters && this.selectedFilters.length > 0) {
        return prefix + ' (' + this.selectedFilters.length + ')';
      }
      return prefix;
    },
    orderMenuName: function orderMenuName() {
      return 'Sort By';
    },
    classModifier: function classModifier() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName, true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--is-open', this.filtersOpen || this.ordersOpen || this.timespansOpen), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--is-open-order', this.ordersOpen), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--is-open-filters', this.filtersOpen), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, this.mainClassName + '--is-open-timespans', this.timespansOpen), _ref;
    },
    availableTimespanOptions: function availableTimespanOptions() {
      if (this.selectedOrder && this.selectedOrder.sort === 'movers') {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.timespans)).filter(function (i) {
          return i.parameter !== 'ALL';
        });
      }
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.timespans)).filter(function (i) {
        return i.parameter !== '3DAY';
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('browse', ['addFilter', 'removeFilter', 'selectOrder', 'selectTimespan', 'clearFilters']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('overlay', {
    hideOverlay: 'hide',
    showOverlay: 'show'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('dashboard', {
    dashSelectOrder: 'selectOrder',
    dashSelectTimespan: 'selectTimespan'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('watchlist', {
    watchSelectOrder: 'selectOrder',
    watchSelectTimespan: 'selectTimespan'
  }), {
    orderList: function orderList(kind) {
      var marketsDisabledSorts = ['gain', 'loss', 'investment'];

      return kind === 'markets' ? this.orders.filter(function (i) {
        return !marketsDisabledSorts.includes(i.sort);
      }) : this.orders;
    },
    onAddFilter: function onAddFilter(filterId) {
      this.addFilter(filterId);
      this.$emit('used');
    },
    onRemoveFilter: function onRemoveFilter(filterId) {
      this.removeFilter(filterId);
      this.$emit('used');
    },
    toggleFilters: function toggleFilters() {
      this.filtersOpen = !this.filtersOpen;
      this.ordersOpen = false;
      this.timespansOpen = false;
    },
    toggleOrder: function toggleOrder() {
      this.ordersOpen = !this.ordersOpen;
      this.filtersOpen = false;
      this.timespansOpen = false;
    },
    toggleTimespans: function toggleTimespans() {
      this.timespansOpen = !this.timespansOpen;
      this.filtersOpen = false;
      this.ordersOpen = false;
    },
    selectOrderAndClose: function selectOrderAndClose(sort) {
      if (this.isWatchlistOpen) {
        this.watchSelectOrder(sort);
      } else if (this.isDashboardOpen) {
        this.dashSelectOrder(sort);
      } else {
        this.selectOrder(sort);
      }
      this.toggleOrder();
      this.$emit('used');
    },
    selectTimespanAndClose: function selectTimespanAndClose(timespan) {
      if (this.isWatchlistOpen) {
        this.watchSelectTimespan(timespan);
      } else if (this.isDashboardOpen) {
        this.dashSelectTimespan(timespan);
      } else {
        this.selectTimespan(timespan);
      }
      this.toggleTimespans();
      this.$emit('used');
    },
    selectTimespanOnly: function selectTimespanOnly(timespan) {
      this.selectTimespan(timespan);
      this.$emit('used');
    },
    filterSelected: function filterSelected(filterId) {
      return this.selectedFilters.includes(filterId);
    },
    orderSelected: function orderSelected(sort) {
      return this.selectedOrder.sort === sort;
    },
    closeFilters: function closeFilters() {
      this.filtersOpen = false;
      this.ordersOpen = false;
      this.timespansOpen = false;
    },
    onClearFilters: function onClearFilters() {
      this.clearFilters();
    },
    filterKey: function filterKey(filter) {
      return filter.filterId.toString() + this.filterSelected(filter.filterId).toString();
    }
  })
});

/***/ }),

/***/ "kI67":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kNWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_history_js__ = __webpack_require__("HOak");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a210a28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_vue__ = __webpack_require__("sa2z");
function injectStyle (ssrContext) {
  __webpack_require__("M8Zh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_history_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a210a28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kO8i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kTJW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contract-image",style:(_vm.imageStyleModifiers)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kVWy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_social_share_invite_widget_share_invite_widget_vue__ = __webpack_require__("dDcj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_leaderboards_leaderboards_info_leaderboards_info_vue__ = __webpack_require__("HkCn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_profile_public_profile_widget_public_profile_widget_vue__ = __webpack_require__("dlHv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_accountVerify__ = __webpack_require__("yZQa");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_accountVerify__["a" /* default */]],
  components: {
    publicProfileWidget: __WEBPACK_IMPORTED_MODULE_4__components_profile_public_profile_widget_public_profile_widget_vue__["a" /* default */],
    leaderboardsInfo: __WEBPACK_IMPORTED_MODULE_3__components_leaderboards_leaderboards_info_leaderboards_info_vue__["a" /* default */],
    shareInviteWidget: __WEBPACK_IMPORTED_MODULE_2__components_social_share_invite_widget_share_invite_widget_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isShutdownModeOn']), {
    showInfo: function showInfo() {
      return false && !this.isShutdownModeOn;
    }
  })
});

/***/ }),

/***/ "kYNi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kafY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kb5U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kbwM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-notification"},[(_vm.showIcon)?_c('div',{staticClass:"side-notification__icon"},[(_vm.level === 'danger')?_c('img',{attrs:{"src":__webpack_require__("z6fO"),"alt":""}}):_vm._e(),_vm._v(" "),(_vm.level === 'success')?_c('img',{attrs:{"src":__webpack_require__("ihRI"),"alt":""}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.contentModifiers,domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),_c('div',[_c('button',{staticClass:"side-notification__close",on:{"click":_vm.onClose}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kcHx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-settings"},[(_vm.isLayoutMobile)?_c('content-header',{attrs:{"title":"Settings"}}):_vm._e(),_vm._v(" "),(_vm.settingsReady)?[_c('div',{class:_vm.gridRowModifier},[(!_vm.isLayoutMobile)?_c('div',{staticClass:"column large-4 account-settings__sticky"},[_c('profile')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column large-8 small-12"},[(!_vm.isLayoutMobile)?_c('div',{staticClass:"account-settings__header"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"account-settings__content"},[_c('h4',{staticClass:"content-header__section-title content-header__section-title--margin-top"},[_vm._v("Privacy")]),_vm._v(" "),_c('div',{ref:"general",staticClass:"account-settings__container"},_vm._l((_vm.sectionPrivacy),function(item){return (_vm.hasPrivacy)?_c('div',{staticClass:"account-settings__section"},[_c('settings-option',{key:item.key,attrs:{"category":_vm.categories.privacy,"obj":item},on:{"toggle":function($event){return _vm.onToggleSetting(item, $event)},"error":_vm.doError}},[_vm._v(_vm._s(item.info)+"\r\n              ")])],1):_vm._e()}),0),_vm._v(" "),_c('h4',{staticClass:"content-header__section-title content-header__section-title--margin-top"},[_vm._v("In-app Notifications")]),_vm._v(" "),_c('div',{staticClass:"account-settings__container"},[_c('div',[_c('div',{staticClass:"account-settings__push-section"},[_c('div',{staticClass:"account-settings__push-section-wrap"},[_c('div',{staticClass:"account-settings__push-section-inner"},_vm._l((_vm.sectionNotifications),function(item){return _c('check-option',{key:item.key,attrs:{"category":_vm.categories.inApp,"obj":item},on:{"error":_vm.doError}})}),1)])])])]),_vm._v(" "),_c('h4',{staticClass:"content-header__section-title content-header__section-title--margin-top"},[_vm._v("Push Notifications")]),_vm._v(" "),_c('div',{ref:"push",staticClass:"account-settings__container"},[(_vm.hasPush)?_c('div',[_c('div',{staticClass:"account-settings__section"},[_c('settings-option',{staticClass:"account-settings__no-margin",attrs:{"category":_vm.categories.push,"obj":_vm.optionPush},on:{"error":_vm.doError,"toggle":_vm.togglePush}},[_vm._v("Allow Notifications\r\n              ")])],1),_vm._v(" "),_c('div',{staticClass:"account-settings__push-section"},[_c('div',{staticClass:"account-settings__push-section-wrap"},[_c('div',{staticClass:"account-settings__push-section-inner"},_vm._l((_vm.sectionNotifications),function(item){return _c('check-option',{key:item.key,attrs:{"category":_vm.categories.push,"obj":item,"disabled":_vm.isPushDisabled},on:{"error":_vm.doError}})}),1),_vm._v(" "),(_vm.isPushDisabled)?_c('div',{staticClass:"account-settings__push-section--disabled"}):_vm._e()])])]):_vm._e()]),_vm._v(" "),(_vm.hasLocalPassword)?[_c('h4',{staticClass:"content-header__section-title content-header__section-title--margin-top"},[_vm._v("Social Logins")]),_vm._v(" "),_c('div',{staticClass:"account-settings__section"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"account-settings__section--right"},[_c('switch-button',{key:_vm.hasFacebook,attrs:{"checked":_vm.hasFacebook,"disabled":_vm.isFacebookDisabled},on:{"toggle":function($event){return _vm.onToggleProvider('Facebook', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"account-settings__section"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"account-settings__section--right"},[_c('switch-button',{key:_vm.hasTwitter,attrs:{"checked":_vm.hasTwitter,"disabled":_vm.isTwitterDisabled},on:{"toggle":function($event){return _vm.onToggleProvider('Twitter', $event)}}})],1)])]:_vm._e(),_vm._v(" "),(_vm.manageInfoLoaded && !_vm.hasLocalPassword)?[_c('div',{staticClass:"account-settings__section account-settings__section--clickable",on:{"click":function($event){$event.preventDefault();return _vm.onSetPassword($event)}}},[_c('alert-box',{attrs:{"level":"danger"}},[_vm._v("\r\n                You must create a password for your account before you can manage your External Logins.\r\n              ")])],1)]:_vm._e()],2)])])]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"large-6 column"},[_vm._v("Settings")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-settings__section--left account-settings__section--facebook"},[_c('img',{staticClass:"account-settings__section-img",attrs:{"src":__webpack_require__("ntlj"),"alt":""}}),_vm._v(" Facebook\r\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-settings__section--left account-settings__section--twitter"},[_c('img',{staticClass:"account-settings__section-img",attrs:{"src":__webpack_require__("kjlw"),"alt":""}}),_vm._v(" Twitter\r\n              ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kdSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_desktop_js__ = __webpack_require__("aj49");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92ff9c38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_desktop_vue__ = __webpack_require__("Tl04");
function injectStyle (ssrContext) {
  __webpack_require__("6mGA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_offer_desktop_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92ff9c38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_offer_desktop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kgr9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kjlw":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IiM1NUFDRUUiIHJ4PSIyIi8+DQogICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTE1LjkxMiA2LjM0NmMtLjQzOC4xOTQtLjkxLjMyNi0xLjQwNC4zODRhMi40NSAyLjQ1IDAgMCAwIDEuMDc1LTEuMzUxYy0uNDcyLjI4LS45OTUuNDgzLTEuNTUyLjU5M2EyLjQ0NCAyLjQ0NCAwIDAgMC00LjE2NSAyLjIzQTYuOTM3IDYuOTM3IDAgMCAxIDQuODMgNS42NDZhMi40NDQgMi40NDQgMCAwIDAgLjc1NiAzLjI2MyAyLjQyNyAyLjQyNyAwIDAgMS0xLjEwNy0uMzA2di4wMzFjMCAxLjE4NC44NDMgMi4xNzIgMS45NiAyLjM5NmEyLjQzNSAyLjQzNSAwIDAgMS0xLjEwMy4wNDIgMi40NDcgMi40NDcgMCAwIDAgMi4yODMgMS42OThBNC45MDMgNC45MDMgMCAwIDEgNCAxMy43ODNhNi45MTMgNi45MTMgMCAwIDAgMy43NDYgMS4wOThjNC40OTUgMCA2Ljk1NC0zLjcyNCA2Ljk1NC02Ljk1NGE2Ljk5IDYuOTkgMCAwIDAtLjAwOC0uMzE2IDQuOTU2IDQuOTU2IDAgMCAwIDEuMjItMS4yNjV6Ii8+DQogICAgPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "klsN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_register_account_register_vue__ = __webpack_require__("61DT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_account_account_register_footer_footer_vue__ = __webpack_require__("cVuz");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    accountRegister: __WEBPACK_IMPORTED_MODULE_0__components_account_account_register_account_register_vue__["a" /* default */],
    accountRegisterFooter: __WEBPACK_IMPORTED_MODULE_1__components_account_account_register_footer_footer_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "knac":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "koWp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__ = __webpack_require__("laM4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1863c082_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("n3z+");
function injectStyle (ssrContext) {
  __webpack_require__("7jIy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1863c082_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kolS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kwj7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__ = __webpack_require__("vJzj");


/* eslint-disable object-shorthand */





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    contentHeader: __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["b" /* formMixin */]],
  validations: {
    fields: {
      address: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required,
      city: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required,
      zipCode: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].validateUSZipCode('country'),
      country: __WEBPACK_IMPORTED_MODULE_4__components_forms_mixin__["a" /* validators */].required
    }
  },
  watch: {
    userData: function userData(value) {
      if (value) {
        this.assignFields(value);
      }
    },
    'fields.address': function fieldsAddress(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        this.dataUpdated = true;
      }
    },
    'fields.city': function fieldsCity(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        this.dataUpdated = true;
      }
    },
    'fields.zipCode': function fieldsZipCode(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        this.dataUpdated = true;
      }
    },
    'fields.country': function fieldsCountry(newValue, oldValue) {
      if (oldValue && newValue.value !== oldValue.value) {
        this.dataUpdated = true;
      }
    }
  },
  data: function data() {
    return {
      dataUpdated: false,
      countries: [],
      fields: {
        country: '',
        address: '',
        city: '',
        zipCode: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('user', ['userData']), {
    isNotUnitedStates: function isNotUnitedStates() {
      return this.fields.country && this.fields.country.value && this.fields.country.value !== 'US';
    },
    isSubmitButtonDisabled: function isSubmitButtonDisabled() {
      return !this.dataUpdated || this.invalidOrDisabled;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('notifications', ['setSuccessSideNotificationWithTimeoutCallback']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['verifyID', 'getAccountDetail', 'getVerifyID']), {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formIsValid() && this.formDisable()) {
        var payload = {
          address1: this.fields.address,
          city: this.fields.city,
          postalCode: this.fields.zipCode,
          countryID: this.fields.country.value
        };
        if (!this.isNotUnitedStates) {
          payload.nscbStatus = -1;
        }
        this.verifyID(payload).then(function (data) {
          if (_this.isNotUnitedStates) {
            window.location.href = data;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('');
          }
          _this.dataUpdated = false;
          return _this.setSuccessSideNotificationWithTimeoutCallback({
            text: 'Account Address Updated.',
            callback: function callback() {
              return _this.$router.go(-1);
            }
          });
        }).then(this.formEnable).then(this.getAccountDetail).catch(function (e) {
          _this.formHandleErrors(e);
        });
      }
    },
    assignFields: function assignFields(value) {
      this.fields.address = value.address;
      this.fields.city = value.city;
      this.fields.zipCode = value.postalCode;

      if (value.countryCode) {
        this.fields.country = this.countries.find(function (i) {
          return i.value === value.countryCode;
        }) || '';
      }
    }
  }),
  created: function created() {
    var _this2 = this;

    this.getVerifyID().then(function (response) {
      var data = response.data;
      _this2.countries = data.countryList.map(function (el) {
        return {
          required: el.validatePostalCode,
          label: el.countryName,
          value: el.countryCode
        };
      });

      _this2.fields.country = _this2.countries.find(function (i) {
        return i.value === data.countryID;
      }) || '';
      if (_this2.userData) _this2.assignFields(_this2.userData);
    });
  }
});

/***/ }),

/***/ "l0DF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l9wN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_combined_js__ = __webpack_require__("oaFs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23847479_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_combined_vue__ = __webpack_require__("CuUC");
function injectStyle (ssrContext) {
  __webpack_require__("pBJa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_combined_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23847479_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_combined_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lDBc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('collapsible-panel',{key:_vm.isOpen,attrs:{"noPadding":true,"darkHeader":true,"canClose":false,"isOpen":_vm.isOpen,"showChevron":!_vm.isOpen,"theme":"small-header"},on:{"toggle":function($event){return _vm.$emit('toggle-history')}}},[_c('div',{staticClass:"market-history__title",attrs:{"slot":"title"},slot:"title"},[_c('span',{staticClass:"market-history__title-text"},[_vm._v("Trading History")]),_vm._v(" "),_c('div',{staticClass:"market-history__title-icon",on:{"click":function($event){$event.stopPropagation();return _vm.onInfoClick($event)}}})]),_vm._v(" "),_c('div',{staticClass:"market-history__content"},[_c('contracts-history',{attrs:{"contracts":_vm.historyContracts,"compactMode":true,"lightHeader":true,"showMarketNames":false,"canLoadMore":false,"marketId":this.market.marketId},on:{"loading":_vm.loadHistory}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lFoL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_login_account_login_vue__ = __webpack_require__("V3zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_account_account_login_footer_footer_vue__ = __webpack_require__("ULMz");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    accountLogin: __WEBPACK_IMPORTED_MODULE_0__components_account_account_login_account_login_vue__["a" /* default */],
    accountLoginFooter: __WEBPACK_IMPORTED_MODULE_1__components_account_account_login_footer_footer_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "lJBn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('div',{staticClass:"market-contract__info"},[(_vm.shouldShowImage)?_c('div',{staticClass:"market-contract__image"},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":_vm.imageAltText},on:{"error":_vm.onImageLoadError}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract__wrap"},[_c('div',{staticClass:"market-contract__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.layout==='grid')?_c('div',{staticClass:"market-contract__current-price"},[_vm._v("\n        "+_vm._s(_vm.contractModel.lastTradePriceAsCents)+"¢\n        "),_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice}})],1):_vm._e(),_vm._v(" "),(_vm.showSharesBar)?_c('div',{staticClass:"market-contract__shares",on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId, 'buy', null, 'my-shares')}}},[_c('market-shares-bar',{attrs:{"mode":_vm.contractModel.mode,"number":_vm.contract.userQuantity,"average":_vm.contractModel.userAveragePricePerShareAsCents,"difference":_vm.contractModel.userChangePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice}})],1):_vm._e(),_vm._v(" "),_c('div',{class:_vm.forcePadding})]),_vm._v(" "),(_vm.layout==='list')?_c('div',{staticClass:"market-contract__current-price"},[_c('span',{staticClass:"market-contract__current-price-display"},[_vm._v(_vm._s(_vm.contractModel.lastTradePriceAsCents)+"¢")]),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"market-contract__buttons"},[_c('div',{staticClass:"market-contract__buttons--left"},[(_vm.contractModel.mode == 'no')?[(_vm.contractModel.userOpenOrdersBuyQuantity > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6"},[_c('button',{staticClass:"market-contract__button-single market-contract__button-single--buy-no market-contract__button-single--small market-contract__button-single--small-left",attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId, 'buy', 'no')}}},[(_vm.contractModel.buyNoCostAsCents > 0)?_c('div',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.contractModel.buyNoCostAsCents),expression:"contractModel.buyNoCostAsCents",modifiers:{"cents":true}}],staticClass:"market-contract__price"}):_vm._e(),_vm._v(" Buy No\n            ")])]),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('button',{staticClass:"market-contract__button-single market-contract__button-single--buy-no market-contract__button-single--small market-contract__button-single--small-right",attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId,'buy', 'no', 'buy-offers')}}},[_c('div',{staticClass:"market-contract__price"},[_vm._v(_vm._s(_vm.contractModel.userOpenOrdersBuyQuantity))]),_vm._v(" Buy Offers\n            ")])])]):[_c('button',{staticClass:"market-contract__button-single market-contract__button-single--buy-no",attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId,'buy', 'no')}}},[(_vm.contractModel.buyNoCostAsCents > 0)?_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.contractModel.buyNoCostAsCents),expression:"contractModel.buyNoCostAsCents",modifiers:{"cents":true}}],staticClass:"market-contract__price"}):_vm._e(),_vm._v(" Buy No\n            ")])]]:[(_vm.contractModel.userOpenOrdersBuyQuantity > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6"},[_c('button',{staticClass:"market-contract__button-single market-contract__button-single--buy-yes market-contract__button-single--small market-contract__button-single--small-left",attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId,'buy', 'yes')}}},[(_vm.contractModel.buyYesCostAsCents > 0)?_c('div',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.contractModel.buyYesCostAsCents),expression:"contractModel.buyYesCostAsCents",modifiers:{"cents":true}}],staticClass:"market-contract__price"}):_vm._e(),_vm._v(" Buy Yes\n            ")])]),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('button',{staticClass:"market-contract__button-single market-contract__button-single--buy-yes market-contract__button-single--small market-contract__button-single--small-right",attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId,'buy', 'yes', 'buy-offers')}}},[_c('div',{staticClass:"market-contract__price"},[_vm._v(_vm._s(_vm.contractModel.userOpenOrdersBuyQuantity))]),_vm._v(" Buy Offers\n            ")])])]):[_c('button',{staticClass:"market-contract__button-single market-contract__button-single--buy-yes",attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId,'buy', 'yes')}}},[(_vm.contractModel.buyYesCostAsCents > 0)?_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.contractModel.buyYesCostAsCents),expression:"contractModel.buyYesCostAsCents",modifiers:{"cents":true}}],staticClass:"market-contract__price"}):_vm._e(),_vm._v(" Buy Yes\n            ")])]]],2),_vm._v(" "),_c('div',{staticClass:"market-contract__buttons--right"},[(_vm.contractModel.mode == 'no')?[(_vm.contractModel.userOpenOrdersSellQuantity > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6"},[_c('button',{staticClass:"market-contract__button-single market-contract__button-single--sell-no market-contract__button-single--small market-contract__button-single--small-left",attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId,'sell', 'no')}}},[(_vm.contractModel.sellNoCostAsCents > 0)?_c('div',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.contractModel.sellNoCostAsCents),expression:"contractModel.sellNoCostAsCents",modifiers:{"cents":true}}],staticClass:"market-contract__price"}):_vm._e(),_vm._v(" Sell No\n            ")])]),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('button',{staticClass:"market-contract__button-single market-contract__button-single--sell-no market-contract__button-single--small market-contract__button-single--small-right",attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId,'sell', 'no', 'sell-offers')}}},[_c('div',{staticClass:"market-contract__price"},[_vm._v(_vm._s(_vm.contractModel.userOpenOrdersSellQuantity))]),_vm._v(" Sell Offers\n            ")])])]):[_c('button',{staticClass:"market-contract__button-single market-contract__button-single--sell-no",attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId,'sell', 'no')}}},[(_vm.contractModel.sellNoCostAsCents > 0)?_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.contractModel.sellNoCostAsCents),expression:"contractModel.sellNoCostAsCents",modifiers:{"cents":true}}],staticClass:"market-contract__price"}):_vm._e(),_vm._v(" Sell No\n            ")])]]:(_vm.contractModel.mode == 'yes')?[(_vm.contractModel.userOpenOrdersSellQuantity > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6"},[_c('button',{staticClass:"market-contract__button-single market-contract__button-single--sell-yes market-contract__button-single--small market-contract__button-single--small-left",attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId,'sell', 'yes')}}},[(_vm.contractModel.sellYesCostAsCents > 0)?_c('div',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.contractModel.sellYesCostAsCents),expression:"contractModel.sellYesCostAsCents",modifiers:{"cents":true}}],staticClass:"market-contract__price"}):_vm._e(),_vm._v(" Sell Yes\n            ")])]),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('button',{staticClass:"market-contract__button-single market-contract__button-single--sell-yes market-contract__button-single--small market-contract__button-single--small-right",attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId,'sell', 'yes', 'sell-offers')}}},[_c('div',{staticClass:"market-contract__price"},[_vm._v(_vm._s(_vm.contractModel.userOpenOrdersSellQuantity))]),_vm._v(" Sell Offers\n            ")])])]):[_c('button',{staticClass:"market-contract__button-single market-contract__button-single--sell-yes",attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId,'sell', 'yes')}}},[(_vm.contractModel.sellYesCostAsCents > 0)?_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.contractModel.sellYesCostAsCents),expression:"contractModel.sellYesCostAsCents",modifiers:{"cents":true}}],staticClass:"market-contract__price"}):_vm._e(),_vm._v(" Sell Yes\n            ")])]]:[_c('button',{staticClass:"market-contract__button-single market-contract__button-single--buy-no",attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.openPurchaseJourney(_vm.contractModel.contractId,'buy', 'no')}}},[(_vm.contractModel.buyNoCostAsCents > 0)?_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.contractModel.buyNoCostAsCents),expression:"contractModel.buyNoCostAsCents",modifiers:{"cents":true}}],staticClass:"market-contract__price"}):_vm._e(),_vm._v(" Buy No\n            ")])]],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lZ3N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    showExport: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: Array
    },
    activeTab: {
      type: String,
      default: null
    }
  },
  created: function created() {
    if (this.activeTab) {
      this.onChange(this.activeTab);
    } else {
      this.onChange(this.tabs[0].name);
    }
  },
  data: function data() {
    return {
      currentTab: null
    };
  },

  methods: {
    onExport: function onExport() {
      this.$emit('export', this.currentTab);
    },
    tabClass: function tabClass(item) {
      return item.name === this.currentTab ? 'account-desktop-header__button--active' : '';
    },
    onChange: function onChange(name) {
      if (name !== this.currentTab) {
        this.currentTab = name;
        this.$emit('tabChange', name);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['transactionHistory', 'tradeHistory']), {
    isExportAvailable: function isExportAvailable() {
      var hasItems = false;
      switch (this.currentTab) {
        case 'trades':
          hasItems = true;
          // hasItems = this.tradeHistory &&
          //   this.tradeHistory.data &&
          //   this.tradeHistory.data.length > 0;
          break;
        case 'deposit-withdrawals':
          hasItems = this.transactionHistory && this.transactionHistory.data && this.transactionHistory.data.length > 0;
          break;
        default:
          break;
      }
      return this.showExport && hasItems;
    }
  })
});

/***/ }),

/***/ "laM4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onCancel: function onCancel() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
    }
  })
});

/***/ }),

/***/ "ldne":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lfj9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-platform-announcements",domProps:{"innerHTML":_vm._s(_vm.content)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lkXP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_watch_js__ = __webpack_require__("32Fy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0f1096e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_watch_vue__ = __webpack_require__("gYFg");
function injectStyle (ssrContext) {
  __webpack_require__("8X7E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_watch_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0f1096e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_watch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ll9a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lmGd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_profile_js__ = __webpack_require__("y8UT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7496f3a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__ = __webpack_require__("P9X2");
function injectStyle (ssrContext) {
  __webpack_require__("4ntM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_profile_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7496f3a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mBdA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboards-trophy-pyramid"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__row"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophies"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"})]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__equal"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__wins"},[_vm._v("1 to 99")])]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__row"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophies"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"})]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__equal"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__wins"},[_vm._v("100 to 999")])]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__row"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophies"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"})]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__equal"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__wins"},[_vm._v("1,000 to 9,999")])]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__row"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophies"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"})]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__equal"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__wins"},[_vm._v("10,000 to 99,999")])]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__row"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophies"},[_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__trophy"})]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__equal"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-trophy-pyramid__wins"},[_vm._v("100,000 and over")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mBiY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    lastClosePrice: {},
    price: {
      type: Number,
      default: 0
    },
    fixed: {
      type: Boolean,
      default: false
    },
    percent: {
      type: Boolean,
      default: false
    },
    plainStyle: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    }
  },
  computed: {
    isPriceEqual: function isPriceEqual() {
      // lastClosePrice === null must be checked so
      // new contracts does show price gain on day 1
      // null must be checked in case parameter is not passed (undefined)
      return this.price === 0 || this.lastClosePrice === null;
    },
    priceDisplay: function priceDisplay() {
      return this.fixed ? Math.abs(this.price).toFixed(2) : '' + Math.abs(this.price);
    },
    changeValue: function changeValue() {
      var symbol = this.percent ? '%' : '¢';
      if (this.fixed) {
        return !this.isPriceEqual ? '$' + this.priceDisplay : 'NC';
      }
      return !this.isPriceEqual ? '' + this.priceDisplay + symbol : 'NC';
    },
    objClass: function objClass() {
      var _ref;

      return _ref = {
        'market-change-price': true
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--plain', this.plainStyle), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--up', !this.isPriceEqual && this.price > 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--down', !this.isPriceEqual && this.price < 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--equal', this.isPriceEqual), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'market-change-price--wide', this.theme === 'page-market' && this.priceDisplay.length === 1), _ref;
    }
  }
});

/***/ }),

/***/ "mGCv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offers-indicator"},[_c('switch-modal',{staticClass:"modal-switch--offers-indicator",attrs:{"showSwitchButton":false},on:{"modalClose":_vm.close}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Offer Sequence")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.groupedRecords.length > 0)?[_c('div',{staticClass:"offers-indicator__title"},[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"offers-indicator__subtitle"},[(_vm.operationType === 'buy')?[_vm._v("\n            Your Sell Offers appear as Buy Offers to other traders.\n          ")]:[_vm._v("\n            Your Buy Offers appear as Sell Offers to other traders.\n          ")]],2),_vm._v(" "),_c('div',{staticClass:"offers-indicator__table-container"},[_c('table',{staticClass:"offers-indicator__table"},[_c('tbody',_vm._l((_vm.groupedRecords),function(records,index){return _c('tr',{class:_vm.rowClassModifiers(records)},[_c('td',{staticClass:"offers-indicator__label"},[(_vm.isFirstGroupedIndex(index) && _vm.hasBeforeMeOffers)?[_vm._v("\n                    Offers before You\n                  ")]:(_vm.isLastGroupedIndex(index) && _vm.hasAfterMeOffers)?[_vm._v("\n                    Offers after You\n                  ")]:(_vm.areMine(records))?[_vm._v("\n                    Your Offers\n                  ")]:[_vm._v("\n                    Subsequent Offers\n                  ")]],2),_vm._v(" "),_c('td',{staticClass:"offers-indicator__num"},[_vm._v("\n                  "+_vm._s(_vm.displayRecords(records))+"\n                ")])])}),0)])])]:_c('div',{staticClass:"offers-indicator__no-data"},[_vm._v("\n        No data to display.\n      ")])],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mQlD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: 'Community Forums'
    }
  },
  components: {
    contentHeader: __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__["a" /* default */]
  },
  data: function data() {
    return {
      url: ''
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Support'
    };
  },
  created: function created() {
    this.loadForum();
  },

  watch: {
    isLoggedIn: function isLoggedIn() {
      this.loadForum();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('support', ['getForumUrl']), {
    loadForum: function loadForum() {
      var _this = this;

      this.getForumUrl().then(function (data) {
        _this.url = data;
      });
    },
    onClose: function onClose() {
      this.$router.push({
        name: 'HelpAndSupport'
      });
    }
  })
});

/***/ }),

/***/ "mThu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_switch_button_switch_button_vue__ = __webpack_require__("ed4I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  props: {
    obj: Object,
    category: String
  },
  components: {
    switchButton: __WEBPACK_IMPORTED_MODULE_2__components_generics_switch_button_switch_button_vue__["a" /* default */]
  },
  data: function data() {
    return {
      checked: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['settings']), {
    classObject: function classObject() {
      return {
        'settings-option': true,
        'settings-option--disabled': this.disabled
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('profile', ['updateSettings']), {
    toggle: function toggle(e) {
      var _this = this;

      this.loaderAdd();
      this.checked = e;
      this.updateSettings({
        category: this.category,
        key: this.obj.key,
        value: e
      }).then(function () {
        return _this.loaderRemove();
      }).catch(function () {
        _this.loaderRemove();
        _this.checked = !e;
        _this.$emit('error', 'Could not set "' + _this.obj.info + '"');
      });
      this.$emit('toggle', e);
    }
  }),
  created: function created() {
    var k = this.settings[this.category][this.obj.key];
    this.checked = k !== undefined ? k : false;
  }
});

/***/ }),

/***/ "mWAA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mXqA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true,
      default: 0
    }
  }
});

/***/ }),

/***/ "mbbC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mbvb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PURCHASE_DEFAULT_LABEL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");





var PURCHASE_DEFAULT_LABEL = 'N/A';

/* unused harmony default export */ var _unused_webpack_default_export = ({
  data: function data() {
    return {
      capitalizeFirstLetter: __WEBPACK_IMPORTED_MODULE_3__utils_helpers__["n" /* capitalizeFirstLetter */]
    };
  },

  props: {
    contract: {
      type: Object,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('trade', ['tradeOptions']), {
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_2__models_contract__["a" /* default */](this.contract);
    },
    typeFirst: function typeFirst() {
      return 'buy';
    },
    typeSecond: function typeSecond() {
      if (this.contractModel.mode === 'yes') {
        return 'sell';
      } else if (this.contractModel.mode === 'no') {
        return 'sell';
      }
      return 'buy';
    },
    valueFirst: function valueFirst() {
      if (this.contractModel.mode === 'no') {
        return 'no';
      }
      return 'yes';
    },
    valueSecond: function valueSecond() {
      if (this.contractModel.mode === 'yes') {
        return 'yes';
      } else if (this.contractModel.mode === 'no') {
        return 'no';
      }
      return 'no';
    },
    priceFirst: function priceFirst() {
      var price = this.contractModel.buyYesCostAsCents;
      if (this.contractModel.mode === 'no') {
        price = this.contractModel.buyNoCostAsCents;
      }
      if (price === 100) {
        return '$1';
      }
      return price > 0 ? price + '\xA2' : PURCHASE_DEFAULT_LABEL;
    },
    priceSecond: function priceSecond() {
      var price = this.contractModel.buyNoCostAsCents;
      if (this.contractModel.mode === 'yes') {
        price = this.contractModel.sellYesCostAsCents;
      } else if (this.contractModel.mode === 'no') {
        price = this.contractModel.sellNoCostAsCents;
      }
      if (price === 100) {
        return '$1';
      }
      return price > 0 ? price + '\xA2' : PURCHASE_DEFAULT_LABEL;
    },
    priceFirstClassModifier: function priceFirstClassModifier() {
      return {
        'purchase-yes-no-switcher__button': true,
        'purchase-yes-no-switcher__button--yes': this.contractModel.mode !== 'no',
        'purchase-yes-no-switcher__button--no': this.contractModel.mode === 'no',
        'purchase-yes-no-switcher__button--active': this.isFirstActive
      };
    },
    priceSecondClassModifier: function priceSecondClassModifier() {
      return {
        'purchase-yes-no-switcher__button': true,
        'purchase-yes-no-switcher__button--yes': this.contractModel.mode === 'yes',
        'purchase-yes-no-switcher__button--no': this.contractModel.mode !== 'yes',
        'purchase-yes-no-switcher__button--active': !this.isFirstActive
      };
    },
    isFirstActive: function isFirstActive() {
      if (this.contractModel.mode !== '') {
        return this.tradeOptions.operationType === 'buy';
      }
      return this.tradeOptions.operationType === 'buy' && this.tradeOptions.operationValue !== 'no';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('trade', ['setTradeOptions']), {
    switchOperation: function switchOperation(operationType, operationValue) {
      this.setTradeOptions({
        contractId: this.contract.contractId,
        operationType: operationType,
        defaultTab: null,
        operationValue: operationValue
      });
    },
    priceFirstClicked: function priceFirstClicked() {
      if (this.isFirstActive) return;
      this.switchOperation(this.typeFirst, this.valueFirst);
    },
    priceSecondClicked: function priceSecondClicked() {
      if (!this.isFirstActive) return;
      this.switchOperation(this.typeSecond, this.valueSecond);
    }
  })
});

/***/ }),

/***/ "mcLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wallet_withdraw_confirm_withdraw_confirm_vue__ = __webpack_require__("waMS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_wallet_available_balance_available_balance_vue__ = __webpack_require__("3PvP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__("c/9r");












/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["b" /* formMixin */]],
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_4__components_generics_alert_box_alert_box_vue__["a" /* default */],
    availableBalance: __WEBPACK_IMPORTED_MODULE_5__components_wallet_available_balance_available_balance_vue__["a" /* default */],
    withdrawConfirm: __WEBPACK_IMPORTED_MODULE_3__components_wallet_withdraw_confirm_withdraw_confirm_vue__["a" /* default */]
  },
  validations: function validations() {
    return {
      fields: {
        amount: __WEBPACK_IMPORTED_MODULE_6__components_forms_mixin__["a" /* validators */].withdrawalAmount(this.minWithdrawal, this.maxWithdrawal)
      }
    };
  },
  created: function created() {
    this.checkWithdrawCheck();
  },
  data: function data() {
    return {
      countries: [],
      error: '',
      showConfirmation: false,
      fields: {
        street: '',
        city: '',
        zipCode: '',
        amount: '',
        country: ''
      }
    };
  },

  watch: {
    check: function check(value) {
      this.fields.country = value.countryCode;
      this.fields.street = value.address1;
      this.fields.city = value.city;
      this.fields.zipCode = value.postalCode;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('wallet', ['check']), {
    availableBalance: function availableBalance() {
      return this.check && this.check.availableFundsString ? this.check.availableFundsString : '$0.00';
    },
    restrictedFunds: function restrictedFunds() {
      return this.check && this.check.restrictedFundsString ? this.check.restrictedFundsString : '';
    },
    minWithdrawal: function minWithdrawal() {
      return this.maxWithdrawal > 0 ? 1 : 0;
    },
    maxWithdrawal: function maxWithdrawal() {
      return this.check ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["v" /* roundDown */])(this.check.availableFunds) : 0;
    },
    isWithdrawalDisabled: function isWithdrawalDisabled() {
      return Number(this.fields.amount || 0) === 0;
    },
    isAmountFieldDisabled: function isAmountFieldDisabled() {
      return this.minWithdrawal < 1 || this.maxWithdrawal < 1;
    },
    errorMessage: function errorMessage() {
      return this.error || this.check.errorMessage;
    },
    hasErrorMessage: function hasErrorMessage() {
      return this.error || !!this.check.errorMessage;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getVerifyID']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('wallet', ['getWithdrawCheck']), {
    onSubmit: function onSubmit() {
      this.showConfirmation = true;
    },
    onSuccess: function onSuccess() {
      this.fields.amount = '';
      this.showConfirmation = false;
      // this.$nextTick(() => { this.$v.$reset(); });
      this.checkWithdrawCheck();
      this.$emit('success');
    },
    onEdit: function onEdit() {
      this.showConfirmation = false;
    },
    checkWithdrawCheck: function checkWithdrawCheck() {
      var _this = this;

      this.getWithdrawCheck().then(function (data) {
        _this.checkDocumentUploadFlags(data);
        _this.isComponentReady = true;
      }).catch(function (error) {
        _this.isComponentReady = true;
        _this.error = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', '');
      });
    }
  })
});

/***/ }),

/***/ "mgKt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_trophy_pyramid_js__ = __webpack_require__("7Ez+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e98d627e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_trophy_pyramid_vue__ = __webpack_require__("mBdA");
function injectStyle (ssrContext) {
  __webpack_require__("6bRq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_trophy_pyramid_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e98d627e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_trophy_pyramid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mjGX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_close_button_js__ = __webpack_require__("0OLA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_353d839b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_close_button_vue__ = __webpack_require__("jJDj");
function injectStyle (ssrContext) {
  __webpack_require__("evoN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_close_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_353d839b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_close_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mka8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_home_old_hero_unit_slider_hero_unit_slider_vue__ = __webpack_require__("RQ5D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_home_old_quotes_quotes_vue__ = __webpack_require__("PElc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_home_home_old_how_it_works_how_it_works_vue__ = __webpack_require__("Z05w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_home_home_old_most_predicted_most_predicted_vue__ = __webpack_require__("UqqE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_home_home_old_most_predicted_list_most_predicted_list_vue__ = __webpack_require__("4p0o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_home_home_old_podcasts_podcasts_vue__ = __webpack_require__("QrTx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_research_widget_research_widget_vue__ = __webpack_require__("/yTp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_home_home_old_in_the_news_in_the_news_vue__ = __webpack_require__("y1jZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_twitter_twitter_timeline_twitter_timeline_vue__ = __webpack_require__("FM5G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_home_home_old_news_feed_news_feed_vue__ = __webpack_require__("xJ4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_insight_insight_widget_insight_widget_vue__ = __webpack_require__("w0Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_market_market_biggest_gains_market_biggest_gains_vue__ = __webpack_require__("XqpO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_market_market_money_widget_market_money_widget_vue__ = __webpack_require__("JVxM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_market_market_currently_predicting_market_currently_predicting_vue__ = __webpack_require__("Dksu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_market_market_key_stats_market_key_stats_vue__ = __webpack_require__("aHny");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_market_market_top_comments_market_top_comments_vue__ = __webpack_require__("KvDS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mixins_disqus__ = __webpack_require__("oeb2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_home_home_old_home_videos__ = __webpack_require__("CPvM");
























var REFRSEH_ENABLED = true;
var REFRESH_INTERVAL = 10 * 60 * 1000;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_19__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__mixins_disqus__["a" /* default */]],
  components: {
    heroUnitSlider: __WEBPACK_IMPORTED_MODULE_3__components_home_home_old_hero_unit_slider_hero_unit_slider_vue__["a" /* default */],
    quotes: __WEBPACK_IMPORTED_MODULE_4__components_home_home_old_quotes_quotes_vue__["a" /* default */],
    howItWorks: __WEBPACK_IMPORTED_MODULE_5__components_home_home_old_how_it_works_how_it_works_vue__["a" /* default */],
    mostPredicted: __WEBPACK_IMPORTED_MODULE_6__components_home_home_old_most_predicted_most_predicted_vue__["a" /* default */],
    podcasts: __WEBPACK_IMPORTED_MODULE_8__components_home_home_old_podcasts_podcasts_vue__["a" /* default */],
    researchWidget: __WEBPACK_IMPORTED_MODULE_9__components_research_widget_research_widget_vue__["a" /* default */],
    inTheNews: __WEBPACK_IMPORTED_MODULE_10__components_home_home_old_in_the_news_in_the_news_vue__["a" /* default */],
    twitterTimeline: __WEBPACK_IMPORTED_MODULE_11__components_twitter_twitter_timeline_twitter_timeline_vue__["a" /* default */],
    newsFeed: __WEBPACK_IMPORTED_MODULE_12__components_home_home_old_news_feed_news_feed_vue__["a" /* default */],
    mostPredictedList: __WEBPACK_IMPORTED_MODULE_7__components_home_home_old_most_predicted_list_most_predicted_list_vue__["a" /* default */],
    insightWidget: __WEBPACK_IMPORTED_MODULE_13__components_insight_insight_widget_insight_widget_vue__["a" /* default */],
    marketBiggestGains: __WEBPACK_IMPORTED_MODULE_14__components_market_market_biggest_gains_market_biggest_gains_vue__["a" /* default */],
    marketMoneyWidget: __WEBPACK_IMPORTED_MODULE_15__components_market_market_money_widget_market_money_widget_vue__["a" /* default */],
    marketCurrentlyPredicting: __WEBPACK_IMPORTED_MODULE_16__components_market_market_currently_predicting_market_currently_predicting_vue__["a" /* default */],
    marketKeyStats: __WEBPACK_IMPORTED_MODULE_17__components_market_market_key_stats_market_key_stats_vue__["a" /* default */],
    marketTopComments: __WEBPACK_IMPORTED_MODULE_18__components_market_market_top_comments_market_top_comments_vue__["a" /* default */],
    homeVideos: __WEBPACK_IMPORTED_MODULE_21__components_home_home_old_home_videos__["a" /* default */]
  },
  data: function data() {
    return {
      interval: null
    };
  },
  metaInfo: function metaInfo() {
    var title = this.$route.name === 'trends' ? 'Trends' : 'PredictIt';
    return {
      title: title
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('user', ['isUserRestricted', 'isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('popup', ['currentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('browse', ['widgets']), {
    shouldShowKeyStatsWidgets: function shouldShowKeyStatsWidgets() {
      return (__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.widgets, 'key.widgetKeyStats', []) || []).length > 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getWidgets']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    fetchWidgetsData: function fetchWidgetsData() {
      var _this = this;

      this.getWidgets().then(function () {
        _this.isComponentReady = true;
      });
      if (REFRSEH_ENABLED) {
        if (this.interval) clearInterval(this.interval);
        this.interval = setInterval(function () {
          _this.getWidgets();
        }, REFRESH_INTERVAL);
      }
    }
  }),
  mounted: function mounted() {
    this.setupDisqus();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  created: function created() {
    this.fetchWidgetsData();
  }
});

/***/ }),

/***/ "mo3u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-book"},[(_vm.initialised)?[(_vm.tabs.length > 1)?_c('div',{staticClass:"order-book__tabs"},[_c('tabs',{attrs:{"items":_vm.tabs,"activeTab":_vm.activeTab,"theme":"order-book"},on:{"tabChange":_vm.tabChange}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"order-book__content"},[(_vm.tabVisible('prices'))?_c('order-book-prices',{attrs:{"slim":_vm.tabs.length === 1,"contract":_vm.contract,"buyOffers":_vm.buyOffers,"sellOffers":_vm.sellOffers,"operationType":_vm.operationType,"operationValue":_vm.operationValue,"orderBook":_vm.orderBook},on:{"click":function($event){return _vm.$emit('updatePriceAndQuantity', $event)}}}):_vm._e(),_vm._v(" "),(_vm.tabVisible('my-shares'))?_c('order-book-shares',{attrs:{"items":_vm.contractShares}}):_vm._e(),_vm._v(" "),(_vm.tabVisible('buy-offers'))?_c('order-book-offers',{key:"buyOffers",attrs:{"slim":_vm.tabs.length === 1,"contract":_vm.contract,"items":_vm.buyOffers,"operationValue":_vm.operationValue,"operationType":"buy"}}):_vm._e(),_vm._v(" "),(_vm.tabVisible('sell-offers'))?_c('order-book-offers',{key:"sellOffers",attrs:{"slim":_vm.tabs.length === 1,"contract":_vm.contract,"items":_vm.sellOffers,"operationValue":_vm.operationValue,"operationType":"sell"}}):_vm._e()],1)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mskH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['agreeToTerms', 'getStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.formDisable()) {
        this.loaderAdd(document.body);
        var payload = {
          isNALTermsAgreedTo: true
        };
        this.agreeToTerms(payload).then(function () {
          return _this.getStatus();
        }).then(function () {
          _this.loaderRemove(document.body);
          _this.setCurrentPopup();
        }).catch(function (e) {
          _this.loaderRemove(document.body);
          _this.formEnable();
          _this.formHandleErrors(e);
        });
      }
    }
  })
});

/***/ }),

/***/ "mx5S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_update_password_js__ = __webpack_require__("TZdm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a757388_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_update_password_vue__ = __webpack_require__("ED1x");
function injectStyle (ssrContext) {
  __webpack_require__("Uolw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_update_password_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a757388_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_update_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n/Ch":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_notifications_proxy__ = __webpack_require__("a0yF");




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), {
    onOptIn: function onOptIn() {
      __WEBPACK_IMPORTED_MODULE_2__services_notifications_proxy__["a" /* default */].optInMessaging();
      __WEBPACK_IMPORTED_MODULE_2__services_notifications_proxy__["a" /* default */].setupMessaging();
      this.setCurrentSmallPopup();
    },
    onOptOut: function onOptOut() {
      __WEBPACK_IMPORTED_MODULE_2__services_notifications_proxy__["a" /* default */].optOutMessaging();
      this.setCurrentSmallPopup();
    }
  })
});

/***/ }),

/***/ "n2FT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_generics_close_button_close_button_vue__ = __webpack_require__("mjGX");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: false
    },
    silent: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    returnRoute: {
      type: String
    },
    returnRouteGoTo: {
      type: String
    },
    theme: {
      type: String,
      default: ''
    }
  },
  components: {
    closeButton: __WEBPACK_IMPORTED_MODULE_1__components_generics_close_button_close_button_vue__["a" /* default */]
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'content-header': true
      }, 'content-header--' + this.theme, this.theme);
    }
  },
  methods: {
    close: function close() {
      this.$emit('close');
      if (this.silent) return;
      if (this.returnRoute) {
        var routeObj = { name: this.returnRoute };
        if (this.returnRouteGoTo) {
          routeObj.query = { el: this.returnRouteGoTo };
        }
        this.$router.push(routeObj);
      } else {
        this.$router.go(-1);
      }
    }
  }
});

/***/ }),

/***/ "n32v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purchase-yes-no-switcher"},[_c('div',{class:_vm.priceFirstClassModifier,on:{"click":_vm.priceFirstClicked}},[_c('div',{staticClass:"purchase-yes-no-switcher__button-price"},[_vm._v(_vm._s(_vm.priceFirst))]),_vm._v(" "),_c('div',{staticClass:"purchase-yes-no-switcher__button-label"},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(_vm.typeFirst))+" "+_vm._s(_vm.valueFirst.toUpperCase()))])]),_vm._v(" "),_c('div',{class:_vm.priceSecondClassModifier,on:{"click":_vm.priceSecondClicked}},[_c('div',{staticClass:"purchase-yes-no-switcher__button-price"},[_vm._v(_vm._s(_vm.priceSecond))]),_vm._v(" "),_c('div',{staticClass:"purchase-yes-no-switcher__button-label"},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(_vm.typeSecond))+" "+_vm._s(_vm.valueSecond.toUpperCase()))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n3z+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-forgotten-footer"},[_c('a',{staticClass:"account-forgotten-footer__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onCancel($event)}}},[_vm._v("\n    "+_vm._s(_vm.$txt('account-forgotten.footer.cancel'))+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n58p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_static_preview_js__ = __webpack_require__("1/XJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_077ac420_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_static_preview_vue__ = __webpack_require__("uK2H");
function injectStyle (ssrContext) {
  __webpack_require__("ywdO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_static_preview_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_077ac420_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_static_preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n8WA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/newyorktimes.e9fbf1a.png";

/***/ }),

/***/ "nBxi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__ = __webpack_require__("9cGE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecf69662_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("sFJp");
function injectStyle (ssrContext) {
  __webpack_require__("wh8u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecf69662_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nE9/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tax_info_notification_tax_info_notification_vue__ = __webpack_require__("wQDz");


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    taxInfoNotification: __WEBPACK_IMPORTED_MODULE_0__components_tax_info_notification_tax_info_notification_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "nGgz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_page_daily_markets_details_page_daily_markets_details_vue__ = __webpack_require__("Ykf8");


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ link: __WEBPACK_IMPORTED_MODULE_0__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].MONDAY.id, title: __WEBPACK_IMPORTED_MODULE_0__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].MONDAY.title }, { link: __WEBPACK_IMPORTED_MODULE_0__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].TUESDAY.id, title: __WEBPACK_IMPORTED_MODULE_0__components_pages_page_daily_markets_details_page_daily_markets_details_vue__["a" /* DAILY_PAGES */].TUESDAY.title }]
    };
  },

  methods: {
    dailyMarketPageLink: function dailyMarketPageLink(item) {
      return { name: item.link };
    }
  }
});

/***/ }),

/***/ "nGzq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_desktop_js__ = __webpack_require__("GOHg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50793d90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_desktop_vue__ = __webpack_require__("SCoJ");
function injectStyle (ssrContext) {
  __webpack_require__("O7RW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_desktop_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50793d90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_desktop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nHRj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_catchHtmlClickMixin__ = __webpack_require__("xO2F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_support_faq_faq_vue__ = __webpack_require__("ZIhC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_support__ = __webpack_require__("33FX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__("oiih");









var DEFAULT_TITLE = 'How to Trade on PredictIt';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__helpers_catchHtmlClickMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_support__["a" /* default */]],
  props: {
    title: {
      type: String,
      default: DEFAULT_TITLE
    }
  },
  components: {
    contentHeader: __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__["a" /* default */],
    faq: __WEBPACK_IMPORTED_MODULE_4__components_support_faq_faq_vue__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  metaInfo: function metaInfo() {
    return {
      title: 'Support'
    };
  },
  created: function created() {
    var _this = this;

    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* STATIC_PAGES */].HOW_TO_TRADE).then(function (data) {
      _this.installDynamicControls({ data: data });
    });
  }
});

/***/ }),

/***/ "nHn7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cookie__ = __webpack_require__("o+KH");



var COOKIE_ACCEPTED = 'accepted';
var COOKIE_NAME = 'PrivacyStatement';

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hidden: false
    };
  },

  computed: {
    show: function show() {
      return false && __WEBPACK_IMPORTED_MODULE_1__helpers_cookie__["a" /* default */].get(COOKIE_NAME) === null && !this.hidden;
    }
  },
  methods: {
    onAgree: function onAgree() {
      __WEBPACK_IMPORTED_MODULE_1__helpers_cookie__["a" /* default */].setForever(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, COOKIE_NAME, COOKIE_ACCEPTED));
      this.onHide();
    },
    onHide: function onHide() {
      this.hidden = true;
    }
  }
});

/***/ }),

/***/ "nIvA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-privacy-policy",domProps:{"innerHTML":_vm._s(_vm.content)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nK2W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"research",domProps:{"innerHTML":_vm._s(_vm.content)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nNeU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_user_profile_overview_header_js__ = __webpack_require__("VJVd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cc30c18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_profile_overview_header_vue__ = __webpack_require__("aFdV");
function injectStyle (ssrContext) {
  __webpack_require__("ufSN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_user_profile_overview_header_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cc30c18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_profile_overview_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nPqm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_0__components_generics_alert_box_alert_box_vue__["a" /* default */]
  },
  data: function data() {
    return {
      promoCodeDetail: {},
      instantCreditDetail: {}
    };
  },

  computed: {
    showInstantCreditNotification: function showInstantCreditNotification() {
      return this.instantCreditDetail && typeof this.instantCreditDetail.success !== 'undefined';
    },
    instantCreditBoxLevel: function instantCreditBoxLevel() {
      return this.instantCreditDetail.success ? 'success' : 'warning';
    },
    instantCreditBoxMessage: function instantCreditBoxMessage() {
      return this.instantCreditDetail.success ? this.instantCreditDetail.friendlyDescription : this.instantCreditDetail.errorMessage;
    },
    showPromoNotification: function showPromoNotification() {
      return this.promoCodeDetail && this.promoCodeDetail.showPromoCodeBox;
    },
    showPromoCode: function showPromoCode() {
      return this.promoCodeDetail && this.promoCodeDetail.promoCodeText;
    }
  }
});

/***/ }),

/***/ "nT5N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"affiliations-popup",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"affiliations-popup__note"},[_vm._v("\r\n    We are adding new social features to PredictIt and would like to know a little more about you. Are you a student, teacher, staff or alumnus/alumna at an accredited college or university?\r\n  ")]),_vm._v(" "),_c('div',{staticClass:"affiliations-popup__form"},[_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-6"},[_c('form-radio',{staticClass:"affiliations-popup__radio",attrs:{"name":"accountType","label":"Yes","checked":_vm.fields.agreed === 'yes',"value":"yes"},model:{value:(_vm.fields.agreed),callback:function ($$v) {_vm.$set(_vm.fields, "agreed", $$v)},expression:"fields.agreed"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('form-radio',{staticClass:"affiliations-popup__radio",attrs:{"name":"accountType","label":"No","checked":_vm.fields.agreed === 'no',"value":"no"},model:{value:(_vm.fields.agreed),callback:function ($$v) {_vm.$set(_vm.fields, "agreed", $$v)},expression:"fields.agreed"}})],1),_vm._v(" "),(_vm.fields.agreed === 'yes')?[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"affiliations-popup__autosuggest"},[_c('h5',{staticClass:"form__title form__title--left"},[_vm._v("\r\n              (Optional) Please tell us your university or college affiliation\r\n            ")]),_vm._v(" "),_c('vue-autosuggest',{attrs:{"suggestions":_vm.suggestions,"input-props":{id:'autosuggest__input', placeholder:'Search...'}},on:{"input":_vm.onInputChange,"selected":_vm.onSelected},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var suggestion = ref.suggestion;
return _c('div',{staticClass:"affiliations-popup__result-item",attrs:{"onclick":""}},[_c('span',{staticClass:"my-suggestion-item"},[_vm._v("\r\n                "+_vm._s(suggestion.item.name)+"\r\n              ")])])}}],null,false,1470449839),model:{value:(_vm.fields.query),callback:function ($$v) {_vm.$set(_vm.fields, "query", $$v)},expression:"fields.query"}})],1)])]:_vm._e()],2)]),_vm._v(" "),(_vm.fields.agreed === 'yes')?_c('div',{staticClass:"affiliations-popup__universities-container"},[(_vm.universities.length > 0)?_c('div',{staticClass:"affiliations-popup__universities"},_vm._l((_vm.universities),function(item){return _c('div',{key:item.key,staticClass:"affiliations-popup__university"},[_c('div',{staticClass:"affiliations-popup__university-name"},[(item.id === -1)?[_c('form-input',{attrs:{"maxLength":100,"theme":"affiliation","type":"text","name":"text","label":""},model:{value:(item.name),callback:function ($$v) {_vm.$set(item, "name", $$v)},expression:"item.name"}})]:[_vm._v("\r\n            "+_vm._s(item.name)+"\r\n          ")]],2),_vm._v(" "),_c('div',{staticClass:"affiliations-popup__university-option",attrs:{"title":"This will keep it in your profile and still allow you to participate in markets, but not allow other users to view it."}},[_c('form-checkbox',{staticClass:"checkbox--no-margin",attrs:{"small":true,"name":_vm.getKey(),"label":"Hidden"},model:{value:(item.isHidden),callback:function ($$v) {_vm.$set(item, "isHidden", $$v)},expression:"item.isHidden"}})],1),_vm._v(" "),_c('div',{staticClass:"affiliations-popup__university-icon",on:{"click":function($event){return _vm.onRemove(item)}}})])}),0):_vm._e(),_vm._v(" "),(_vm.showOtherSchoolNote)?_c('div',{staticClass:"affiliations-popup__note affiliations-popup__note--other"},[_vm._v("\r\n      We will save your school as Pending Approval and we periodically review and add schools. If you have questions about the process please contact PredictIt Support.\r\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"affiliations-popup__note affiliations-popup__note--bottom"},[_c('span',{staticClass:"affiliations-popup__note-title",on:{"click":function($event){_vm.showExplanation = !_vm.showExplanation}}},[_vm._v("\r\n        About Your Profile\r\n      ")]),_vm._v(" "),_c('transition',{attrs:{"name":"affiliations-popup"}},[(_vm.showExplanation)?_c('div',[_vm._v("\r\n          To make PredictIt more fun and social in the future we will allow traders to share information from their profiles. If there is anything you would rather keep private you can always mark it as hidden. On your profile pages hidden items are still shown but include an asterisk (*) to let you know they are hidden from other users.\r\n        ")]):_vm._e()])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"affiliations-popup__submit"},[_c('form-submit',{attrs:{"label":_vm.buttonText,"disabled":_vm.isConfirmDisabled}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nULK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"refine-link",on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nYw4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_js__ = __webpack_require__("CAth");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_js__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_js__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_js__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_js__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_js__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7896205a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_vue__ = __webpack_require__("NvUv");
function injectStyle (ssrContext) {
  __webpack_require__("bGo9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_js__["c" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7896205a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["f"] = (Component.exports);


/***/ }),

/***/ "nlkt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_login_account_login_vue__ = __webpack_require__("V3zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_account_account_login_footer_footer_vue__ = __webpack_require__("ULMz");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    accountLogin: __WEBPACK_IMPORTED_MODULE_0__components_account_account_login_account_login_vue__["a" /* default */],
    accountLoginFooter: __WEBPACK_IMPORTED_MODULE_1__components_account_account_login_footer_footer_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "nqig":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ns37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ntlj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IiMzQjU5OTgiIHJ4PSIyIi8+DQogICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEyLjU3NCAxMC4wNjJoLTEuNjZ2Ni4wODVIOC4zOTZ2LTYuMDg1SDcuMlY3LjkyM2gxLjE5N1Y2LjU0YzAtLjk5LjQ3LTIuNTM5IDIuNTM5LTIuNTM5bDEuODY0LjAwOHYyLjA3NmgtMS4zNTNjLS4yMjEgMC0uNTMzLjExLS41MzMuNTgzdjEuMjU4aDEuODhsLS4yMiAyLjEzN3oiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "nuYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-details-verify"},[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),(_vm.ready)?_c('div',{staticClass:"modal__header"},[_vm._v("\n      Personal Details "),_c('button',{staticClass:"modal__close",on:{"click":function($event){$event.preventDefault();return _vm.setCurrentPopup()}}})]):_vm._e(),_vm._v(" "),(!_vm.ready)?_c('div',{staticClass:"account-details-verify__loader"}):_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"tabindex":1,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.firstName,"name":"firstName","autocomplete":"given-name","required":true,"gtm":"ID Verification,First Name","placeholder":"First Name"},on:{"input":_vm.$v.fields.firstName.$touch,"blur":_vm.$v.fields.firstName.$touch},model:{value:(_vm.fields.firstName),callback:function ($$v) {_vm.$set(_vm.fields, "firstName", $$v)},expression:"fields.firstName"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"tabindex":2,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.lastName,"name":"lastName","autocomplete":"family-name","required":true,"gtm":"ID Verification,Last Name","placeholder":"Last Name"},on:{"input":_vm.$v.fields.lastName.$touch,"blur":_vm.$v.fields.lastName.$touch},model:{value:(_vm.fields.lastName),callback:function ($$v) {_vm.$set(_vm.fields, "lastName", $$v)},expression:"fields.lastName"}})],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-4"},[_c('form-select',{attrs:{"searchable":_vm.isLayoutDesktop,"tabindex":3,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.dateOfBirthMonth,"autocomplete":"bday-month","placeholder":"MM","options":_vm.months,"track-by":"value","label":"label","gtm":"ID Verification,DOB-Month","required":true},on:{"input":_vm.$v.fields.dateOfBirthMonth.$touch,"select":function (e) { return _vm.tabTo(e, 'day'); }},model:{value:(_vm.fields.dateOfBirthMonth),callback:function ($$v) {_vm.$set(_vm.fields, "dateOfBirthMonth", $$v)},expression:"fields.dateOfBirthMonth"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-4"},[_c('form-select',{ref:"day",attrs:{"searchable":_vm.isLayoutDesktop,"tabindex":4,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.dateOfBirthDay,"autocomplete":"bday-day","placeholder":"DD","options":_vm.days,"track-by":"value","label":"label","gtm":"ID Verification,DOB-Day","required":true},on:{"input":_vm.$v.fields.dateOfBirthDay.$touch,"select":function (e) { return _vm.tabTo(e, 'year'); }},model:{value:(_vm.fields.dateOfBirthDay),callback:function ($$v) {_vm.$set(_vm.fields, "dateOfBirthDay", $$v)},expression:"fields.dateOfBirthDay"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-4"},[_c('form-select',{ref:"year",attrs:{"searchable":_vm.isLayoutDesktop,"tabindex":5,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.dateOfBirthYear,"autocomplete":"bday-year","placeholder":"YYYY","options":_vm.years,"track-by":"value","label":"label","gtm":"ID Verification,DOB-Year","required":true},on:{"input":_vm.$v.fields.dateOfBirthYear.$touch,"select":function (e) { return _vm.tabTo(e, 'street'); }},model:{value:(_vm.fields.dateOfBirthYear),callback:function ($$v) {_vm.$set(_vm.fields, "dateOfBirthYear", $$v)},expression:"fields.dateOfBirthYear"}})],1),_vm._v(" "),(_vm.errorNotAdult)?_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"account-details-verify__error"},[_vm._v("\n          "+_vm._s(_vm.errorNotAdult)+"\n        ")])]):_vm._e(),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{ref:"street",attrs:{"tabindex":6,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.street,"name":"street","autocomplete":"street","type":"text","required":true,"gtm":"ID Verification,Home Address","placeholder":"Street Address"},on:{"input":_vm.$v.fields.street.$touch,"blur":_vm.$v.fields.street.$touch},model:{value:(_vm.fields.street),callback:function ($$v) {_vm.$set(_vm.fields, "street", $$v)},expression:"fields.street"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"tabindex":7,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.city,"name":"city","autocomplete":"city","type":"text","required":true,"gtm":"ID Verification,City","placeholder":"City"},on:{"input":_vm.$v.fields.city.$touch,"blur":_vm.$v.fields.city.$touch},model:{value:(_vm.fields.city),callback:function ($$v) {_vm.$set(_vm.fields, "city", $$v)},expression:"fields.city"}})],1),_vm._v(" "),(_vm.countries.length > 0)?_c('div',{class:_vm.countriesModifier},[(_vm.countries.length > 1)?_c('form-select',{attrs:{"searchable":_vm.isLayoutDesktop,"tabindex":8,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.country,"placeholder":"Country","options":_vm.countries,"track-by":"value","label":"label","gtm":"ID Verification,Country","required":true},on:{"input":_vm.$v.fields.country.$touch,"close":function (e) { return _vm.tabTo(e, 'zipcode'); }},model:{value:(_vm.fields.country),callback:function ($$v) {_vm.$set(_vm.fields, "country", $$v)},expression:"fields.country"}}):_c('form-input',{attrs:{"tabindex":8,"name":"country","placeholder":"Country","track-by":"value","label":"label","gtm":"ID Verification,Country","disabled":true},model:{value:(_vm.fields.country.label),callback:function ($$v) {_vm.$set(_vm.fields.country, "label", $$v)},expression:"fields.country.label"}})],1):_vm._e(),_vm._v(" "),_c('div',{class:_vm.zipCodeModifier},[_c('form-input',{ref:"zipcode",attrs:{"tabindex":9,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.zipCode,"name":"zipCode","autocomplete":"zipCode","type":"text","gtm":"ID Verification,Postal Code","required":_vm.fields.country.required,"placeholder":"Zip/Postal Code"},on:{"input":_vm.$v.fields.zipCode.$touch,"blur":_vm.$v.fields.zipCode.$touch},model:{value:(_vm.fields.zipCode),callback:function ($$v) {_vm.$set(_vm.fields, "zipCode", $$v)},expression:"fields.zipCode"}})],1)]),_vm._v(" "),(_vm.showNoSolicitingNotice)?_c('div',{staticClass:"row-x"},[_c('div',{staticClass:"column small-1"},[_c('form-checkbox',{staticClass:"checkbox--no-margin",attrs:{"name":"rememberMe","label":""},model:{value:(_vm.fields.nscbStatus),callback:function ($$v) {_vm.$set(_vm.fields, "nscbStatus", $$v)},expression:"fields.nscbStatus"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-11"},[_c('div',{staticClass:"account-details-verify__non-us-info"},[_vm._v("\n          Please check this box to confirm that you are a "),_c('router-link',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"to":{ name: 'terms-and-conditions', query: { section: 'us-person' } }}},[_vm._v("U.S. Person")]),_vm._v(" (a U.S. Citizen living anywhere in the world or a Resident Alien), that were not solicited by PredictIt or any PredictIt employee and that you have a valid U.S. Social Security Number (SSN) or Individual Tax Identification Number (ITIN). If you believe you were personally solicited by PredictIt or do not have the required identification do not check this box.\n        ")],1),_vm._v(" "),_c('div',{staticClass:"account-details-verify__non-us-link",on:{"click":function($event){_vm.showNscbStatusExplanation = !_vm.showNscbStatusExplanation}}},[_vm._v("\n          What does this mean?\n        ")]),_vm._v(" "),_c('transition',{attrs:{"name":"account-details-verify"}},[(_vm.showNscbStatusExplanation)?_c('div',{staticClass:"account-details-verify__non-us-info account-details-verify__non-us-info--margin"},[_vm._v("\n            Predictit accepts applications from "),_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],attrs:{"href":"https://www.irs.gov/individuals/international-taxpayers/classification-of-taxpayers-for-us-tax-purposes"}},[_vm._v("U.S. Persons")]),_vm._v(" in numerous countries; however, PredictIt is a U.S. platform and does not solicit or market outside the United States. Check this box to certify that you have a valid U.S. SSN or ITIN, and that you have not been solicited by PredictIt or a PredictIt employee or representative about applying for, opening, or trading in a Predictit account. If you do not have a valid U.S. SSN or ITIN, or if you believe you were solicited by Predictit, do not check this box.\n          ")]):_vm._e()])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"account-details-verify__submit"},[_c('form-submit',{attrs:{"disabled":_vm.isSubmitButtonDisabled,"label":"Next"}})],1),_vm._v(" "),_c('p',{staticClass:"account-details-verify__disclaimer",domProps:{"innerHTML":_vm._s(_vm.disclaimer)},on:{"!click":function($event){return _vm.catchHtmlClick($event)}}})])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--left"},[_vm._v("Date Of Birth")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--left"},[_vm._v("Home Address")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nxw+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nyTk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wallet_pending_requests_pending_request_pending_request_vue__ = __webpack_require__("cUo6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_contentLoader__ = __webpack_require__("P71F");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_contentLoader__["a" /* default */]],
  components: {
    pendingRequest: __WEBPACK_IMPORTED_MODULE_2__components_wallet_pending_requests_pending_request_pending_request_vue__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    this.getPendingDeposits().then(function () {
      _this.isComponentReady = true;
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['pendingDepositsRequests'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['getPendingDeposits']), {
    onSuccess: function onSuccess() {
      this.getPendingDeposits();
    }
  })
});

/***/ }),

/***/ "nygi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_image_js__ = __webpack_require__("J+13");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b3d2fc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_image_vue__ = __webpack_require__("kTJW");
function injectStyle (ssrContext) {
  __webpack_require__("oXfj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_image_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b3d2fc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nzpA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_notifications_js__ = __webpack_require__("NLYo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c2253d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_notifications_vue__ = __webpack_require__("M1ko");
function injectStyle (ssrContext) {
  __webpack_require__("re9M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_notifications_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c2253d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o+KH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EXPIRY_TIME */
/* unused harmony export EXPIRY_FOREVER */
/* unused harmony export extractHostname */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forOwn__ = __webpack_require__("AVgl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forOwn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_forOwn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cookie__ = __webpack_require__("sp77");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cookie__);




var EXPIRY_TIME = 5;
var EXPIRY_FOREVER = 'Fri, 31 Dec 9999 23:59:59 GMT';

var extractHostname = function extractHostname() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$delimiter = options.delimiter,
      delimiter = _options$delimiter === undefined ? '.' : _options$delimiter,
      _options$deep = options.deep,
      deep = _options$deep === undefined ? 2 : _options$deep;
  var hostname = window.location.hostname;

  var parts = hostname.split(delimiter);
  return parts.slice(-deep).join(delimiter);
};

var set = function set(data, expires) {
  var date = new Date();
  date.setMinutes(date.getMinutes() + EXPIRY_TIME);
  __WEBPACK_IMPORTED_MODULE_0_lodash_forOwn___default()(data, function (value, key) {
    document.cookie = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_cookie__["serialize"])(key, value, {
      expires: expires || date,
      domain: extractHostname()
    });
  });
};

var setForever = function setForever(data) {
  return set(data, new Date(EXPIRY_FOREVER));
};

var get = function get(key) {
  var cookie = document.cookie ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_cookie__["parse"])(document.cookie) : {};
  return cookie[key] || null;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  get: get,
  set: set,
  setForever: setForever
});

/***/ }),

/***/ "oB/D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.classModifiers},[(_vm.numberOnly)?[_c('span',{on:{"click":function($event){$event.stopPropagation();return _vm.onClickNumber($event)}}},[_c('span',{staticClass:"market-shares-bar__number"},[_vm._v(_vm._s(_vm.number))])])]:(_vm.avgPriceOnly)?[_c('span',{staticClass:"market-shares-bar__price"},[_vm._v("\n      "+_vm._s(_vm.text)+" "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.average),expression:"average",modifiers:{"cents":true}}]})]),_vm._v(" "),_c('market-change-price',{attrs:{"theme":_vm.changePriceTheme,"price":_vm.difference}})]:[_c('span',{on:{"click":function($event){$event.stopPropagation();return _vm.onClickNumber($event)}}},[_c('span',{staticClass:"market-shares-bar__number"},[_vm._v(_vm._s(_vm.number))]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.average),expression:"average",modifiers:{"cents":true}}]})]),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.difference}})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oKYE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint no-underscore-dangle: ["error", { "allow": ["__vueClickOutside__"] }] */

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    var bubble = binding.modifiers.bubble;
    var handler = function handler(e) {
      if (bubble || !el.contains(e.target) && el !== e.target) {
        binding.value(e);
      }
    };
    el.__vueClickOutside__ = handler;
    document.addEventListener('click', handler);
  },
  unbind: function unbind(el) {
    document.removeEventListener('click', el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  }
});

/***/ }),

/***/ "oMCg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oQNj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oTR+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_account_desktop_header_account_desktop_header_vue__ = __webpack_require__("Tp6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_wallet_deposit_deposit_vue__ = __webpack_require__("NVO6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_profile_profile_vue__ = __webpack_require__("lmGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_wallet_withdraw_withdraw_vue__ = __webpack_require__("rdUu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_app_modals_app_modals__ = __webpack_require__("E3zi");












var TAB_DEPOSIT = 'deposit';
var TAB_WITHDRAW = 'withdraw';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_accountVerify__["a" /* default */]],
  components: {
    accountDesktopHeader: __WEBPACK_IMPORTED_MODULE_2__components_account_account_desktop_header_account_desktop_header_vue__["a" /* default */],
    alertBox: __WEBPACK_IMPORTED_MODULE_9__components_generics_alert_box_alert_box_vue__["a" /* default */],
    contentHeader: __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__["a" /* default */],
    deposit: __WEBPACK_IMPORTED_MODULE_4__components_wallet_deposit_deposit_vue__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_5__components_account_profile_profile_vue__["a" /* default */],
    tabs: __WEBPACK_IMPORTED_MODULE_6__components_generics_tabs_tabs_vue__["a" /* default */],
    withdraw: __WEBPACK_IMPORTED_MODULE_7__components_wallet_withdraw_withdraw_vue__["a" /* default */]
  },
  data: function data() {
    return {
      ready: false,
      activeTab: ''
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Wallet'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile', 'hasMaintenance', 'isShutdownModeOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['userData']), {
    tabs: function tabs() {
      if (this.isShutdownModeOn) {
        return [{ name: TAB_WITHDRAW, title: 'Withdraw' }];
      }
      return [{ name: TAB_DEPOSIT, title: 'Deposit' }, { name: TAB_WITHDRAW, title: 'Withdraw' }];
    },
    gridRowModifier: function gridRowModifier() {
      return {
        row: this.isLayoutMobile,
        'row-x': !this.isLayoutMobile
      };
    },
    showDepositTab: function showDepositTab() {
      return this.activeTab === TAB_DEPOSIT;
    },
    showWithdrawTab: function showWithdrawTab() {
      return this.activeTab === TAB_WITHDRAW;
    },
    mobilePageTitle: function mobilePageTitle() {
      return this.isShutdownModeOn ? 'Wallet - Withdrawal' : 'Wallet';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    tabChange: function tabChange(name) {
      this.activeTab = name;
      if (this.isLayoutDesktop) {
        this.$router.push({
          name: 'wallet',
          query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query, {
            tabId: this.activeTab
          })
        });
      }
    }
  }),
  created: function created() {
    if (!this.hasUserClassicEnabled) {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_10__app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_ENABLE_CLASSIC);
    } else if (!this.isUserVerified) {
      this.showAccountVerifyPopup();
    }
    if (this.isShutdownModeOn) {
      this.activeTab = TAB_WITHDRAW;
    }
    if (this.$route.query.tabId && this.isLayoutDesktop) {
      this.activeTab = this.$route.query.tabId;
    }
    this.ready = true;
  }
});

/***/ }),

/***/ "oXfj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oY3V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notifications_widget_js__ = __webpack_require__("ORlq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c05f3f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_widget_vue__ = __webpack_require__("HjfT");
function injectStyle (ssrContext) {
  __webpack_require__("xqpA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notifications_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c05f3f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oaFs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_wallet_add_funds_card_add_funds_card_vue__ = __webpack_require__("a3Wk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__ = __webpack_require__("t71M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_wallet_deposit_deposit__ = __webpack_require__("ZWR/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_instant_credit__ = __webpack_require__("zAJv");









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_accountVerify__["a" /* default */]],
  components: {
    addFundsBankTransfer: __WEBPACK_IMPORTED_MODULE_3__components_wallet_add_funds_bank_transfer_add_funds_bank_transfer_vue__["c" /* default */],
    addFundsCard: __WEBPACK_IMPORTED_MODULE_2__components_wallet_add_funds_card_add_funds_card_vue__["a" /* default */],
    tabs: __WEBPACK_IMPORTED_MODULE_4__components_generics_tabs_tabs_vue__["a" /* default */]
  },
  props: {
    checkInstantCredit: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showTabs: false,
      hideTabs: false,
      activeTab: null,
      tabIndexOrder: [],
      isCreditCardAvailable: false,
      isOnlineBankingAvailable: false,
      instantCreditData: {}
    };
  },

  computed: {
    tabs: function tabs() {
      var _this = this;

      var results = [];
      this.tabIndexOrder.forEach(function (v) {
        if (_this.isOnlineBankingAvailable && v === __WEBPACK_IMPORTED_MODULE_6__components_wallet_deposit_deposit__["a" /* TAB_INDEX_ONLINE_BANKING */]) {
          results.push({
            name: __WEBPACK_IMPORTED_MODULE_6__components_wallet_deposit_deposit__["a" /* TAB_INDEX_ONLINE_BANKING */],
            title: 'Online Banking'
          });
        }
        if (_this.isCreditCardAvailable && v === __WEBPACK_IMPORTED_MODULE_6__components_wallet_deposit_deposit__["b" /* TAB_INDEX_CREDIT */]) {
          results.push({
            name: __WEBPACK_IMPORTED_MODULE_6__components_wallet_deposit_deposit__["b" /* TAB_INDEX_CREDIT */],
            title: 'Credit Card'
          });
        }
      });
      return results;
    },
    showCardTab: function showCardTab() {
      return this.activeTab === __WEBPACK_IMPORTED_MODULE_6__components_wallet_deposit_deposit__["b" /* TAB_INDEX_CREDIT */];
    },
    showBankingTab: function showBankingTab() {
      return this.activeTab === __WEBPACK_IMPORTED_MODULE_6__components_wallet_deposit_deposit__["a" /* TAB_INDEX_ONLINE_BANKING */];
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['getStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['getDepositMethods']), {
    tabChange: function tabChange(name) {
      this.activeTab = name;
      // upon initial tab change if there is one tab hide options
      if (this.tabs.length === 1) {
        this.hideTabs = true;
      }
    },
    onBankTransferStep: function onBankTransferStep(step) {
      if (step === 3) {
        this.hideTabs = true;
      } else if (step === 1 || step === 2) {
        this.hideTabs = false;
      }
    }
  }),
  created: function created() {
    var _this2 = this;

    this.getDepositMethods().then(function (data) {
      _this2.tabIndexOrder = data.tabIndexOrder;
      _this2.isCreditCardAvailable = data.isCreditCardAvailable;
      _this2.isOnlineBankingAvailable = data.isOnlineBankingAvailable;
      var shouldGoToWalletPage = !data.isCreditCardAvailable && !data.isOnlineBankingAvailable && _this2.isUserVerifiedFully;

      if (shouldGoToWalletPage) {
        if (_this2.$route.name === 'wallet') {
          _this2.setCurrentPopup();
        } else {
          _this2.$router.push({ name: 'wallet' });
        }
      } else if (_this2.checkInstantCredit) {
        __WEBPACK_IMPORTED_MODULE_7__services_instant_credit__["a" /* default */].run().then(function (instantCreditData) {
          _this2.instantCreditData = instantCreditData;
          _this2.showTabs = true;

          if (_this2.instantCreditData.success) {
            _this2.getStatus();
          }
        });
      } else {
        _this2.showTabs = true;
      }
    });
  }
});

/***/ }),

/***/ "oeb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_disqus_disqus_vue__ = __webpack_require__("4EoQ");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    disqus: __WEBPACK_IMPORTED_MODULE_2__components_disqus_disqus_vue__["a" /* default */]
  },
  data: function data() {
    return {
      disqusReady: false,
      disqusAuth: ''
    };
  },

  computed: {
    disqusId: function disqusId() {
      return this.$route.name;
    },
    disqusTitle: function disqusTitle() {
      return document.title;
    },
    disqusUrl: function disqusUrl() {
      return window.location.href;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['getDisqusUserAuth']), {
    setupDisqus: function setupDisqus() {
      var _this = this;

      this.getDisqusUserAuth().then(function (data) {
        _this.disqusReady = true;
        _this.disqusAuth = data;
      });
    }
  })
});

/***/ }),

/***/ "of0E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_dashboard_js__ = __webpack_require__("T9qA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1823620a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_dashboard_vue__ = __webpack_require__("CGiI");
function injectStyle (ssrContext) {
  __webpack_require__("I0OX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_dashboard_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1823620a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oiih":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STATIC_PAGES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

/* eslint-disable */

var DEFAULT_SMALL_POPUP_TIMEOUT = 3500;
var DEFAULT_SIMPLE_NOTIFICATION_TIMEOUT = 3500;
var DEFAULT_NOTIFICATION_CLOSE_TIMEOUT = 5000;
var DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT = 250;
var DEFAULT_QUANTITY = 1;
var MARKET_OPEN = 'Open';
var MARKET_SUSPENDED = 'Suspended';
var MARKET_EXPIRED = 'Expired';
var MARKET_SETTLED = 'Settled';
var MARKET_CLOSED = 'Closed';
var MARKET_MAINTENANCE = 'Maintenance';
var SOCIAL_LOGIN_OR_REGISTER = 'login-register';
var SOCIAL_LOGIN_ADD = 'add';
var POPUP_OVERFLOW_MODE = false;

var CARDS = {
  VISA: 'visa',
  AMERICAN_EXPRESS: 'americanexpress',
  DISCOVER: 'discover',
  MASTERCARD: 'mastercard',
  BLANK: 'blank'
};

function getDay(index) {
  var value = index + 1;
  return {
    label: value < 10 ? '0' + value.toString() : value.toString(),
    value: value
  };
}

function getMonth(index) {
  var value = index + 1;
  return {
    label: value < 10 ? '0' + value.toString() : value.toString(),
    value: value
  };
}

function getYear(index) {
  var year = new Date().getFullYear();
  var value = year - index;

  return {
    label: value.toString(),
    value: value
  };
}

function getExpiryYear(index) {
  var year = new Date().getFullYear();
  var value = year + index;

  return {
    label: value.toString(),
    value: value
  };
}

function getBirthYear(index) {
  var year = new Date().getFullYear() - 18;
  var value = year - index;

  return {
    label: value.toString(),
    value: value
  };
}

var days = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(new Array(31))).map(function (el, index) {
  return getDay(index);
});
var months = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(new Array(12))).map(function (el, index) {
  return getMonth(index);
});
var years = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(new Array(100))).map(function (el, index) {
  return getYear(index);
});
var expiryYears = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(new Array(13))).map(function (el, index) {
  return getExpiryYear(index);
});
var birthYears = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(new Array(101))).map(function (el, index) {
  return getBirthYear(index);
});

var statesCodeToNameMap = {
  "AL": "Alabama",
  "AK": "Alaska",
  "AS": "American Samoa",
  "AZ": "Arizona",
  "AR": "Arkansas",
  "CA": "California",
  "CO": "Colorado",
  "CT": "Connecticut",
  "DE": "Delaware",
  "DC": "District Of Columbia",
  "FM": "Federated States Of Micronesia",
  "FL": "Florida",
  "GA": "Georgia",
  "GU": "Guam",
  "HI": "Hawaii",
  "ID": "Idaho",
  "IL": "Illinois",
  "IN": "Indiana",
  "IA": "Iowa",
  "KS": "Kansas",
  "KY": "Kentucky",
  "LA": "Louisiana",
  "ME": "Maine",
  "MH": "Marshall Islands",
  "MD": "Maryland",
  "MA": "Massachusetts",
  "MI": "Michigan",
  "MN": "Minnesota",
  "MS": "Mississippi",
  "MO": "Missouri",
  "MT": "Montana",
  "NE": "Nebraska",
  "NV": "Nevada",
  "NH": "New Hampshire",
  "NJ": "New Jersey",
  "NM": "New Mexico",
  "NY": "New York",
  "NC": "North Carolina",
  "ND": "North Dakota",
  "MP": "Northern Mariana Islands",
  "OH": "Ohio",
  "OK": "Oklahoma",
  "OR": "Oregon",
  "PW": "Palau",
  "PA": "Pennsylvania",
  "PR": "Puerto Rico",
  "RI": "Rhode Island",
  "SC": "South Carolina",
  "SD": "South Dakota",
  "TN": "Tennessee",
  "TX": "Texas",
  "UT": "Utah",
  "VT": "Vermont",
  "VI": "Virgin Islands",
  "VA": "Virginia",
  "WA": "Washington",
  "WV": "West Virginia",
  "WI": "Wisconsin",
  "WY": "Wyoming"
};

var statesCodeToElectoralVotesMap = {
  "NE03": 1,
  "NE02": 1,
  "NE01": 1,
  "NE-03": 1,
  "NE-02": 1,
  "NE-01": 1,
  "WA": 12,
  "DE": 3,
  "DC": 3,
  "WI": 10,
  "WV": 5,
  "HI": 4,
  "FL": 29,
  "WY": 3,
  "NH": 4,
  "NJ": 14,
  "NM": 5,
  "TX": 38,
  "LA": 8,
  "NC": 15,
  "ND": 3,
  "NE": 2, // 5
  "TN": 11,
  "NY": 29,
  "PA": 20,
  "CA": 55,
  "NV": 6,
  "VA": 13,
  "CO": 9,
  "AK": 3,
  "AL": 9,
  "AR": 6,
  "VT": 3,
  "IL": 20,
  "GA": 16,
  "IN": 11,
  "IA": 6,
  "OK": 7,
  "AZ": 11,
  "ID": 4,
  "CT": 7,
  "ME": 2, // 4
  "MD": 10,
  "MA": 11,
  "OH": 18,
  "UT": 6,
  "MO": 10,
  "MN": 10,
  "MI": 16,
  "RI": 4,
  "KS": 6,
  "MT": 3,
  "ME02": 1,
  "MS": 6,
  "ME01": 1,
  "ME-01": 1,
  "ME-02": 1,
  "SC": 9,
  "KY": 8,
  "OR": 7,
  "SD": 3
};

var SMALL_STATE_CODES = ['VT', 'NH', 'MA', 'RI', 'CT', 'NJ', 'DE', 'MD', 'DC'];

var STATIC_PAGES = {
  TERMS: 'TandC',
  RESEARCH: 'ResearchPage',
  PRIVACY: 'PrivacyPolicy',
  WHAT_IS: 'WhatIsPredictIt',
  HOW_TO_TRADE: 'HowToTradeOnPredictIt',
  PLATFORM_ANNOUNCEMENTS: 'PlatformAnnouncements',
  DEPOSIT_WARNING: 'DepositWarning'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  CARDS: CARDS,
  DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT: DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT,
  DEFAULT_NOTIFICATION_CLOSE_TIMEOUT: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
  DEFAULT_SIMPLE_NOTIFICATION_TIMEOUT: DEFAULT_SIMPLE_NOTIFICATION_TIMEOUT,
  DEFAULT_SMALL_POPUP_TIMEOUT: DEFAULT_SMALL_POPUP_TIMEOUT,
  DEFAULT_QUANTITY: DEFAULT_QUANTITY,
  MARKET_OPEN: MARKET_OPEN,
  MARKET_SUSPENDED: MARKET_SUSPENDED,
  MARKET_EXPIRED: MARKET_EXPIRED,
  MARKET_SETTLED: MARKET_SETTLED,
  MARKET_CLOSED: MARKET_CLOSED,
  MARKET_MAINTENANCE: MARKET_MAINTENANCE,
  POPUP_OVERFLOW_MODE: POPUP_OVERFLOW_MODE,
  SOCIAL_LOGIN_ADD: SOCIAL_LOGIN_ADD,
  SOCIAL_LOGIN_OR_REGISTER: SOCIAL_LOGIN_OR_REGISTER,
  SMALL_STATE_CODES: SMALL_STATE_CODES,
  birthYears: birthYears,
  expiryYears: expiryYears,
  years: years,
  months: months,
  days: days,
  statesCodeToNameMap: statesCodeToNameMap,
  statesCodeToElectoralVotesMap: statesCodeToElectoralVotesMap,
  STATIC_PAGES: STATIC_PAGES
});

/***/ }),

/***/ "oo4y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pending-request"},[_c('div',{staticClass:"pending-request__section-title"},[_c('div',{staticClass:"pending-request__section-title-text"},[_vm._v("\r\n      "+_vm._s(_vm.requestDate)+"\r\n    ")]),_vm._v(" "),(!_vm.isDeposit)?_c('div',{staticClass:"pending-request__section-title-cancel-wrap"},[_c('div',{staticClass:"pending-request__section-title-cancel",on:{"click":function($event){$event.preventDefault();return _vm.onCancel($event)}}},[_vm._v("\r\n        Cancel Request\r\n      ")])]):_vm._e()]),_vm._v(" "),_c('amount-info',{attrs:{"isDeposit":_vm.isDeposit,"amount":_vm.request.amount,"fee":_vm.request.fee,"total":_vm.request.net}},[_c('div',{staticClass:"content-header__section content-header__section--full-height",attrs:{"slot":"extra-section"},slot:"extra-section"},[(_vm.isDeposit)?[_c('div',{staticClass:"pending-request__table"},[_c('div',{staticClass:"pending-request__table-row"},[_c('div',{staticClass:"pending-request__table-label"},[_vm._v("\r\n              Payment Method:\r\n            ")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.request.paymentMethod))])])])])]:_vm._e(),_vm._v(" "),(_vm.isAch)?[_c('div',{staticClass:"pending-request__table"},[_c('div',{staticClass:"pending-request__table-row"},[_c('div',{staticClass:"pending-request__table-label"},[_vm._v("\r\n              Payment Method:\r\n            ")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.paymentMethod))])])]),_vm._v(" "),_c('div',{staticClass:"pending-request__table-row"},[_c('div',{staticClass:"pending-request__table-label"},[_vm._v("\r\n              Account:\r\n            ")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.request.accountType))])])]),_vm._v(" "),_c('div',{staticClass:"pending-request__table-row"},[_c('div',{staticClass:"pending-request__table-label"},[_vm._v("\r\n              Routing Number:\r\n            ")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.request.routingNumber))])])]),_vm._v(" "),_c('div',{staticClass:"pending-request__table-row"},[_c('div',{staticClass:"pending-request__table-label"},[_vm._v("\r\n              Account Number:\r\n            ")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("********"+_vm._s(_vm.request.accountNumberLastFour))])])])])]:_vm._e(),_vm._v(" "),(_vm.isBankTransfer)?[_c('div',{staticClass:"pending-request__table"},[_c('div',{staticClass:"pending-request__table-row"},[_c('div',{staticClass:"pending-request__table-label"},[_vm._v("\r\n              Payment Method:\r\n            ")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.paymentMethod))])])]),_vm._v(" "),_c('div',{staticClass:"pending-request__table-row"},[_c('div',{staticClass:"pending-request__table-label"},[_vm._v("\r\n              Confirmation Number:\r\n            ")]),_vm._v(" "),_c('div',[_vm._v("\r\n              "+_vm._s(_vm.request.confirmationNumber)+"\r\n            ")])])])]:_vm._e(),_vm._v(" "),(_vm.isCheck)?[_c('div',{staticClass:"pending-request__table"},[_c('div',{staticClass:"pending-request__table-row"},[_c('div',{staticClass:"pending-request__table-label"},[_vm._v("\r\n              Payment Method:\r\n            ")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.paymentMethod))])])]),_vm._v(" "),_c('div',{staticClass:"pending-request__table-row"},[_c('div',{staticClass:"pending-request__table-label"},[_vm._v("\r\n              Check payable to:\r\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.request.payeeName))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.request.address))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.request.city)+", "+_vm._s(_vm.request.postalCode))])])])])]:_vm._e(),_vm._v(" "),(_vm.isCoinbase)?[_c('div',{staticClass:"pending-request__table"},[_c('div',{staticClass:"pending-request__table-row"},[_c('div',{staticClass:"pending-request__table-label"},[_vm._v("\r\n              Payment Method:\r\n            ")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.paymentMethod))])])]),_vm._v(" "),_c('div',{staticClass:"pending-request__table-row"},[_c('div',{staticClass:"pending-request__table-label"},[_vm._v("\r\n              Recipient:\r\n            ")]),_vm._v(" "),_c('div',[_vm._v("\r\n              "+_vm._s(_vm.request.email)+"\r\n            ")])])])]:_vm._e()],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oo9H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_checkbox_checkbox_vue__ = __webpack_require__("vXhB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_account_profile_profile_vue__ = __webpack_require__("lmGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generics_switch_button_switch_button_vue__ = __webpack_require__("ed4I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generics_alert_box_alert_box_vue__ = __webpack_require__("+Cz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_externalLinks__ = __webpack_require__("ys9T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__settings_option_settings_option_vue__ = __webpack_require__("7DQ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__check_option_check_option_vue__ = __webpack_require__("9zdy");

/* eslint-disable no-console */













var PROVIDER_FACEBOOK = 'Facebook';
var PROVIDER_TWITTER = 'Twitter';

var optionPush = {
  key: 'AllowPushNotifications',
  info: 'Push Notifications'
};

var sectionNotifications = [{
  key: 'OpenOfferMatched',
  info: 'One of my offers has been matched'
}, {
  key: 'MarketClosed',
  info: 'One of my markets has closed'
}];

if (false) {
  sectionNotifications.push({
    key: 'ContractPriceChange',
    info: 'One of my contracts changes in price by:',
    withValue: 'ContractPriceChangeAmount',
    validate: function validate(x) {
      return x >= 5 && x < 100;
    },
    currencyInitial: 5
  });
}

var sectionGeneral = [
  // {
  //   key: 'ShowBalanceHeader',
  //   info: 'Show my available balances in header',
  // },
];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    alertBox: __WEBPACK_IMPORTED_MODULE_6__components_generics_alert_box_alert_box_vue__["a" /* default */],
    contentHeader: __WEBPACK_IMPORTED_MODULE_2__components_generics_content_header_content_header_vue__["a" /* default */],
    formCheckbox: __WEBPACK_IMPORTED_MODULE_3__components_forms_checkbox_checkbox_vue__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_4__components_account_profile_profile_vue__["a" /* default */],
    switchButton: __WEBPACK_IMPORTED_MODULE_5__components_generics_switch_button_switch_button_vue__["a" /* default */],
    settingsOption: __WEBPACK_IMPORTED_MODULE_11__settings_option_settings_option_vue__["a" /* default */],
    checkOption: __WEBPACK_IMPORTED_MODULE_12__check_option_check_option_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_externalLinks__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_loader__["a" /* default */]],
  data: function data() {
    return {
      manageInfoLoaded: false,
      correspondence: false,
      logins: [],
      hasLocalPassword: false,
      sectionGeneral: sectionGeneral,
      sectionNotifications: sectionNotifications,
      optionPush: optionPush,
      sectionPushEnabled: false,
      categories: {
        privacy: 'privacy',
        general: 'display',
        push: 'PushNotifications',
        inApp: 'InAppNotifications'
      }
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Settings'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('profile', ['settingsReady']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('profile', ['settings']), {
    sectionPrivacy: function sectionPrivacy() {
      var results = [{
        key: 'ShowTradeHistory',
        info: "Show my trade activity in 'Currently Predicting'"
      }];
      if (false) {
        results.push({
          key: 'AllowLeaderboard',
          info: 'Show my ranking in the Leaderboards'
        });
      }
      return results;
    },
    gridRowModifier: function gridRowModifier() {
      return {
        row: this.isLayoutMobile,
        'row-x': !this.isLayoutMobile
      };
    },
    isFacebookDisabled: function isFacebookDisabled() {
      return !this.hasLocalPassword;
    },
    isTwitterDisabled: function isTwitterDisabled() {
      return !this.hasLocalPassword;
    },
    hasFacebook: function hasFacebook() {
      return this.checkLogin(PROVIDER_FACEBOOK);
    },
    hasTwitter: function hasTwitter() {
      return this.checkLogin(PROVIDER_TWITTER);
    },
    hasGeneral: function hasGeneral() {
      if (this.settings.display && typeof this.settings.display.ShowBalanceHeader !== 'undefined') {
        this.loaderRemove(document.body);
        return true;
      }
      return false;
    },
    hasPrivacy: function hasPrivacy() {
      if (this.settings.privacy && typeof this.settings.privacy.ShowTradeHistory !== 'undefined' && typeof this.settings.privacy.AllowLeaderboard !== 'undefined') {
        this.loaderRemove(document.body);
        return true;
      }
      return false;
    },
    hasPush: function hasPush() {
      if (this.settings.PushNotifications && typeof this.settings.PushNotifications.AllowPushNotifications !== 'undefined') {
        this.sectionPushEnabled = this.settings.PushNotifications.AllowPushNotifications;
        this.loaderRemove(document.body);
        return true;
      }
      return false;
    },
    isPushDisabled: function isPushDisabled() {
      return !this.sectionPushEnabled;
    }
  }),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getAllSettings().then(this.checkManageInfo).then(function () {
      _this.manageInfoLoaded = true;
    }).then(function () {
      return _this.getExternalLogins({
        type: __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* default */].SOCIAL_LOGIN_ADD
      });
    }).then(function (response) {
      _this.links = response.data;
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['getManageInfo', 'removeExternal', 'logout']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('profile', ['getAllSettings']), {
    checkProvider: function checkProvider(x, target) {
      return x.loginProvider.toLowerCase() === target.toLowerCase();
    },
    checkLogin: function checkLogin(target) {
      var _this2 = this;

      return this.logins && this.logins.length > 0 && this.logins.filter(function (x) {
        return _this2.checkProvider(x, target);
      }).length === 1;
    },
    getProviderKey: function getProviderKey(target) {
      var _this3 = this;

      if (this.logins && this.logins.length > 0) {
        var login = this.logins.filter(function (x) {
          return _this3.checkProvider(x, target);
        })[0];
        return login ? login.providerKey : {};
      }
      return {};
    },
    checkManageInfo: function checkManageInfo() {
      var _this4 = this;

      return this.getManageInfo().then(function (data) {
        _this4.hasLocalPassword = data.hasLocalPassword;
        _this4.logins = data.logins;
      });
    },
    onToggleProvider: function onToggleProvider(provider, value) {
      var _this5 = this;

      if (value) {
        this.loaderAdd(document.body);
        if (provider === PROVIDER_FACEBOOK) this.facebookLinkClick();
        if (provider === PROVIDER_TWITTER) this.twitterLinkClick();
      } else {
        var payload = {
          loginProvider: provider,
          providerKey: this.getProviderKey(provider)
        };
        this.removeExternal(payload).then(function () {
          return _this5.setSuccessSideNotification('Settings updated successfully.');
        }).then(this.getAllSettings).then(this.checkManageInfo).catch(function () {
          return _this5.setErrorSideNotification('Error has occured.');
        });
      }
    },
    onToggleSetting: function onToggleSetting(item) {
      if (item.key === 'AllowLeaderboard') {
        this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_10__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_LEADERBOARDS_UPDATE_INFO);
      }
    },
    onSetPassword: function onSetPassword() {
      this.$router.push({ name: 'password-set' });
    },
    doError: function doError(e) {
      this.setErrorSideNotification(e);
    },
    togglePush: function togglePush(e) {
      this.sectionPushEnabled = e;
    }
  })
});

/***/ }),

/***/ "ooVM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STEPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FINISHED_STATUS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNumber__ = __webpack_require__("J009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil__ = __webpack_require__("q16o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_omitBy__ = __webpack_require__("uN7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_omitBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_omitBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_promoCode__ = __webpack_require__("nPqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_documentUpload__ = __webpack_require__("9xQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_getValidationMessage__ = __webpack_require__("U7Hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_wallet_deposited_deposited_vue__ = __webpack_require__("WXHk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_bank_account_bank_account_vue__ = __webpack_require__("5r1F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_processing_transaction_processing_transaction_vue__ = __webpack_require__("eGtO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_depositWarningMixin__ = __webpack_require__("Scap");





/* global PayWithMyBank */
/* eslint-disable */















var AMOUNT_STEP_ONE = 10;
var AMOUNT_STEP_THREE = 50;
var AMOUNT_STEP_FOUR = 100;

var CLOSE_PAYMENT_SUCCESS_TIMEOUT = 1500;

var ERROR_MESSAGE_GENERIC = 'Unable to remove the authorization, please try again later.';

var randomNumber = function randomNumber() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 99999;
  return Math.floor(Math.random() * (max - min + 1) + min);
};

var STEPS = {
  INITIAL: 1,
  AMOUNT_CONFIRM: 2,
  CONFIRM: 3,
  PROCESSING: 4,
  FINISHED_SUCCESS: 5,
  FINISHED_FAILED: 6,
  FINISHED_EXPIRED: 7
};

var FINISHED_STATUS = {
  SUCCESS: 1,
  FAILED: 2,
  EXPIRED: 3
};

/* harmony default export */ __webpack_exports__["c"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_documentUpload__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14_vuelidate__["validationMixin"], __WEBPACK_IMPORTED_MODULE_7__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_promoCode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__mixins_depositWarningMixin__["a" /* default */]],
  components: {
    bankAccount: __WEBPACK_IMPORTED_MODULE_15__components_bank_account_bank_account_vue__["a" /* default */],
    processingTransaction: __WEBPACK_IMPORTED_MODULE_16__components_processing_transaction_processing_transaction_vue__["a" /* default */],
    deposited: __WEBPACK_IMPORTED_MODULE_13__components_wallet_deposited_deposited_vue__["a" /* default */]
  },
  props: {
    isPopup: {
      type: Boolean,
      default: false
    },
    instantCreditData: {}
  },
  data: function data() {
    return {
      errors: [],
      fields: {},
      isFormEnabled: true,
      timeout: null,
      amount: 0,
      disclaimer: '',
      payWithMyBankId: 'paywithmybank-' + randomNumber(),
      canDeposit: false,
      smallPopupShown: false,
      depositAmounts: [AMOUNT_STEP_ONE, AMOUNT_STEP_THREE, AMOUNT_STEP_FOUR],
      currentStep: STEPS.INITIAL,
      currentStepData: {},
      requestSignature: '',
      authorizationId: null,
      errorMessage: '',
      refreshDataObject: {},
      existingAccounts: [],
      account: null,
      STEPS: STEPS,
      instantCreditDetail: this.instantCreditData
    };
  },
  validations: function validations() {
    return {
      amount: __WEBPACK_IMPORTED_MODULE_11__components_forms_mixin__["a" /* validators */].depositAmountCoinbase(this.minimumDepositAmount, this.maximumDepositAmount)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('wallet', ['depositMethods', 'bankTransferStep']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('user', ['status']), {
    accountUploadDocumentTheme: function accountUploadDocumentTheme() {
      return this.isPopup ? '' : 'page-padded';
    },
    classModifiers: function classModifiers() {
      return {
        'add-funds-bank-transfer': true,
        'add-funds-bank-transfer--popup': this.isPopup,
        'add-funds-bank-transfer--regular': !this.isPopup
      };
    },
    alertBoxPromoModifiers: function alertBoxPromoModifiers() {
      return {
        'add-funds-bank-transfer__alert-box': true,
        'add-funds-bank-transfer__alert-box--promo-popup': this.isPopup
      };
    },
    infoAmount: function infoAmount() {
      var number = Number(this.amount).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return '$' + number;
    },
    isConfirmDisabled: function isConfirmDisabled() {
      return this.invalidOrDisabled || !this.canDeposit;
    },
    amountHasError: function amountHasError() {
      return this.$v.amount.$error;
    },
    amountValidationMessage: function amountValidationMessage() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helpers_getValidationMessage__["a" /* default */])(this.$v.amount);
    },
    minimumDepositAmount: function minimumDepositAmount() {
      return this.depositMethods.minimumDepositAmount || 10.0;
    },
    maximumDepositAmount: function maximumDepositAmount() {
      return 99999;
    },
    isFormDisabled: function isFormDisabled() {
      return this.isFormEnabled === false;
    },
    invalidOrDisabled: function invalidOrDisabled() {
      return this.$v.$invalid || !this.isFormEnabled;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('popup', ['setCurrentSmallPopup', 'setCurrentPopupOptions', 'setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('wallet', ['getDepositPWMB', 'deletePWMBAccount', 'confirmDepositPWMB', 'submitDepositPWMB']), {
    formIsValid: function formIsValid() {
      return !this.$v.$invalid;
    },
    formEnable: function formEnable() {
      this.isFormEnabled = true;
    },
    formDisable: function formDisable() {
      this.formReset();
      this.isFormEnabled = false;
      return true;
    },
    formReset: function formReset() {
      this.errors = [];
    },
    onSuccess: function onSuccess() {
      if (this.isPopup) {
        this.setCurrentPopup();
      } else {
        this.onLoadInitial();
      }
    },
    isStep: function isStep(name) {
      return this.currentStep === name;
    },
    cleanup: function cleanup() {
      if (typeof PayWithMyBank !== 'undefined') {
        PayWithMyBank.destroy();
      }
    },
    handleAmountBlur: function handleAmountBlur() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'fill',
        label: 'Amount'
      });
    },
    handleDepositFail: function handleDepositFail(error) {
      this.currentStepData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.currentStepData, {
        error: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', '')
      });
      this.currentStep = STEPS.FINISHED_FAILED;
    },
    onRemove: function onRemove(account) {
      var _this = this;

      this.errorMessage = '';
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_PWMB_ACCOUNT_CONFIRM_DELETE);
      this.smallPopupShown = true;
      this.setCurrentPopupOptions({
        onConfirm: function onConfirm() {
          _this.loaderAdd();
          _this.deletePWMBAccount(account.authorizationId).then(function (data) {
            if (data) {
              _this.setup({ loadWidget: false });
            } else {
              _this.errorMessage = ERROR_MESSAGE_GENERIC;
            }
            _this.loaderRemove();
            _this.smallPopupShown = false;
            _this.setCurrentSmallPopup();
          }).catch(function () {
            _this.errorMessage = ERROR_MESSAGE_GENERIC;
            _this.loaderRemove();
            _this.smallPopupShown = false;
            _this.setCurrentSmallPopup();
          });
        }
      });
    },
    onSelect: function onSelect(account) {
      if (account.accountStatus === 2) {
        this.authorizationId = account.authorizationId;
        this.account = account;
        this.setup({ authorizationId: account.authorizationId });
      } else {
        this.authorizationId = account.authorizationId;
        this.account = account;
        this.cleanup();
        this.currentStep = STEPS.AMOUNT_CONFIRM;
      }
    },
    onLoadInitial: function onLoadInitial() {
      this.currentStep = STEPS.INITIAL;
      this.setup();
    },
    onCancelConfirm: function onCancelConfirm() {
      this.currentStep = STEPS.AMOUNT_CONFIRM;
    },
    onReviewAndConfirm: function onReviewAndConfirm() {
      var _this2 = this;

      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'submit',
        label: 'Submit Deposit'
      });
      if (this.formIsValid() && this.formDisable()) {
        this.loaderAdd();
        var payload = {
          amount: this.amount
        };
        this.confirmDepositPWMB(payload).then(function (data) {
          _this2.loaderRemove();
          _this2.formEnable();
          if (_this2.checkDocumentUploadFlags(data)) return;
          _this2.currentStep = STEPS.CONFIRM;
        }).catch(function (error) {
          _this2.loaderRemove();
          if (_this2.checkDocumentUploadFlags(error.response.data)) return;
          _this2.formEnable();
          _this2.handleDepositFail(error);
        });
      }
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.formDisable();
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit Confirm',
        action: 'submit',
        label: 'Confirm Deposit'
      });
      this.loaderAdd();
      var payload = {
        amount: this.amount,
        pwmbAuthorizationId: this.authorizationId
      };
      this.submitDepositPWMB(payload).then(function (data) {
        _this3.loaderRemove();
        if (_this3.checkDocumentUploadFlags(data)) return;
        _this3.$gtm.trackEvent({ event: _this3.status.hasBeenFunded ? 'MultiDeposit' : 'Deposit' });
        if (data.isBankReauthorizationRequired) {
          _this3.currentStep = STEPS.FINISHED_EXPIRED;
          _this3.setupReauthorization();
        } else if (data.waitForResponseEvent) {
          _this3.currentStep = STEPS.PROCESSING;
        } else {
          setTimeout(function () {
            _this3.setCurrentPopup();
          }, CLOSE_PAYMENT_SUCCESS_TIMEOUT);
        }
        _this3.formEnable();
      }).then(this.getBalance).catch(function (error) {
        _this3.loaderRemove();
        if (_this3.checkDocumentUploadFlags(error.response.data)) return;
        _this3.formEnable();
        _this3.handleDepositFail(error);
      });
    },
    setup: function setup() {
      var _this4 = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$loadWidget = _ref.loadWidget,
          loadWidget = _ref$loadWidget === undefined ? true : _ref$loadWidget,
          _ref$authorizationId = _ref.authorizationId,
          authorizationId = _ref$authorizationId === undefined ? '' : _ref$authorizationId;

      var url = window.location.origin + window.location.pathname;
      var payload = {
        returnUrl: url + '?pwmbDeposit=success',
        cancelUrl: url + '?pwmbDeposit=cancel',
        authorizationId: authorizationId
      };
      this.loaderAdd();
      return this.getDepositPWMB(payload).then(function (data) {
        _this4.loaderRemove();
        _this4.checkDocumentUploadFlags(data);
        _this4.errorMessage = data.errorMessage;
        _this4.promoCodeDetail = data.promoCodeDetail || {};
        _this4.disclaimer = data.disclaimer;
        _this4.canDeposit = data.canDeposit;
        _this4.existingAccounts = data.existingAccounts || [];
        if (loadWidget && data.refreshDataObject && _this4.$refs.paywithmybank) {
          _this4.loadWidget(data);
        }
        return data;
      }).catch(function (error) {
        _this4.loaderRemove();
        _this4.errorMessage = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data.message', null);
      });
    },
    loadWidget: function loadWidget(apiData) {
      var _this5 = this;

      this.refreshDataObject = apiData.refreshDataObject;
      this.amount = apiData.refreshDataObject.amount;
      this.requestSignature = apiData.pwmbRequestSignature;
      var url = apiData.refreshDataObject.pwmbSDKUrl;
      if (this.$refs.paywithmybank) {
        this.loaderAdd(this.$refs.paywithmybank.parentElement, 'is-loading', false);
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["a" /* loadScript */])(url, 'PayWithMyBank').then(function () {
        setTimeout(function () {
          if (_this5.$refs.paywithmybank) {
            _this5.loaderRemove(_this5.$refs.paywithmybank.parentElement, 'is-loading', false);
          }
        }, 2000);
        var options = {
          closeButton: false,
          dragAndDrop: true,
          widgetContainerId: _this5.payWithMyBankId
        };
        var data = __WEBPACK_IMPORTED_MODULE_4_lodash_omitBy___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, apiData.refreshDataObject, {
          requestSignature: apiData.pwmbRequestSignature
        }), __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default.a);

        PayWithMyBank.addPanelListener(function (command, obj) {
          switch (command) {
            case 'event':
              switch (obj.type) {
                case 'close':
                  if (_this5.currentStep === STEPS.FINISHED_EXPIRED) {
                    _this5.onLoadInitial();
                  }
                  break;
                case 'new_location':
                  obj.preventDefault();
                  break;
                default:
                  break;
              }
              break;
            default:
              break;
          }
        });
        if (apiData.refreshDataObject.authToken) {
          PayWithMyBank.establish(data, options);
        } else {
          PayWithMyBank.selectBankWidget(data, options);
        }
      });
    },
    onUpdateAmount: function onUpdateAmount(value) {
      if (this.amount === '' || Number(this.amount) === 0.0) {
        this.amount = value;
      } else if (__WEBPACK_IMPORTED_MODULE_2_lodash_isNumber___default()(this.amount)) {
        this.amount = Number(this.amount) + value;
      } else {
        this.amount = Number(this.amount) + value;
      }
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: 'Amount ' + value + ' Button'
      });
    },
    setupReauthorization: function setupReauthorization() {
      var _this6 = this;

      this.timeout = window.setTimeout(function () {
        _this6.setup({
          authorizationId: _this6.account.authorizationId
        });
      }, 3500);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === 13 && this.smallPopupShown) {
        this.smallPopupShown = false;
        this.setCurrentSmallPopup();
      }
    },
    currentStepHandler: function currentStepHandler(value) {
      this.$emit('step', value);
    }
  }),
  watch: {
    bankTransferStep: function bankTransferStep(value) {
      var _this7 = this;

      this.currentStep = value.step;
      this.currentStepData = value.stepData;
      if (value.step === STEPS.AMOUNT_CONFIRM) {
        this.cleanup();
        this.setup({ loadWidget: false }).then(function (data) {
          _this7.authorizationId = _this7.currentStepData.pwmbAuthorizationId;
          _this7.account = data.existingAccounts.find(function (i) {
            return i.authorizationId === _this7.authorizationId;
          });
        });
      } else if (value.step === STEPS.FINISHED_EXPIRED) {
        this.cleanup();
        this.setup({ loadWidget: false }).then(function (data) {
          _this7.authorizationId = _this7.currentStepData.pwmbAuthorizationId;
          _this7.account = data.existingAccounts.find(function (i) {
            return i.authorizationId === _this7.authorizationId;
          });
        }).then(function () {
          return _this7.setupReauthorization();
        });
      } else if (value.step === STEPS.CONFIRM) {
        this.amount = Number(this.currentStepData.prefilledAmountToDeposit);
      }
    },

    currentStep: {
      handler: 'currentStepHandler',
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cleanup();
    window.removeEventListener('keyup', this.onKeyDown);
    if (this.timeout) {
      window.clearTimeout(this.timeout);
    }
  },
  mounted: function mounted() {
    this.setup();
    window.addEventListener('keyup', this.onKeyDown);
  }
});

/***/ }),

/***/ "opyh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ovgP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "owqz":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAt1BMVEUAAACzxsa5xsa3xcX///+5xce4xca7zMy4xca4xcW4xca5xce3xMa5xMe4xca7xMS4xca4w8O5w8i4xca4xca4xca3xca4xcW/v7+5xcW5xcW5xcWqqqq3w8e3xsa5udG4xcW4xce4xMS4xcW5xce3xsa4xcaxxMS4xca4xce4xMa3xcW4xsa4xsa5xcW5xsa4xMS4xca4xca4xsa3xMa2yMi5xce4xMa4xcW4xca5xca4xcYAAACBS8jKAAAAO3RSTlMAG0xYAW3mD7yf8pVjSdQe/C8z/tPXq6gMPlQsA0BRC13QK3PHQ+ENwoy7avS/FpxB6PmBixyRocbs4TuKakIAAAABYktHRACIBR1IAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4gwECBkTzGfTAQAAASpJREFUWMPtlnlPwkAQxRe2HC1XoYWCyqECHqAihwLv+38vuxuI2hLSnSGBkL5/Nt12ftl5M+mOEKlSXY4yWWmsbGYfbeXyICmfs1R8oUgLVyoWQoANOKWyeQrlkgPYQlSAao3mXK0KVMIDuHWq9w0vPIIPn169ZhjsokUHtOAKINg9tTtS3tzeHfrQ6kYc7PX1fgD8AgaOrsz9wwHAY6yAwxhg5O1ejZ9ogGd4L1IOXoEJLYUp3tTyDnwkN/EvILqeFjD7jFgwX5ilsIyZODYzcfUV/Nf3zKyMSTw42kiJAMdaORmAoKsBrM1/qHutNYCnUwA29BQ2GrClm7i9FgDbxPP3AbOV2ZerjyYdoK53G16DGq8HDPaIwx6y+GMee9BU4o26qVJdgH4ANBK/Pw4bXI4AAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMTItMDRUMDg6MjU6MTkrMDE6MDADEIs/AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTEyLTA0VDA4OjI1OjE5KzAxOjAwck0zgwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII="

/***/ }),

/***/ "p+/I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_story_detail_js__ = __webpack_require__("xVgH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4fe50f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_story_detail_vue__ = __webpack_require__("U1mx");
function injectStyle (ssrContext) {
  __webpack_require__("cFQ7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_story_detail_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4fe50f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_story_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p+B/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_horizontal_v2_js__ = __webpack_require__("E/7D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80c45542_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_horizontal_v2_vue__ = __webpack_require__("uU/O");
function injectStyle (ssrContext) {
  __webpack_require__("fvSV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_contract_horizontal_v2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80c45542_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_contract_horizontal_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p1AJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.hasServerMessage)?[(_vm.maintenance.suspendedMessage)?_c('div',{staticClass:"app-header-notification app-header-notification--with-close app-header-notification--not-clickable"},[_c('div',{staticClass:"app-header-notification__content",domProps:{"innerHTML":_vm._s(_vm.maintenanceMessageText)}})]):(_vm.maintenance.systemMessage)?_c('div',{staticClass:"app-header-notification app-header-notification--with-close app-header-notification--system",on:{"click":function($event){$event.stopPropagation();return _vm.onSystemMessageClick($event)}}},[_c('div',{staticClass:"app-header-notification__content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.maintenanceMessageText)}}),_vm._v(" "),_c('div',{staticClass:"app-header-notification__close",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onCloseMaintenanceMessage($event)}}},[_c('div',{staticClass:"app-header-notification__close-icon"})])])]):_vm._e()]:(_vm.liveUpdatesDisabled)?_c('div',{staticClass:"app-header-notification app-header-notification--system",on:{"click":function($event){$event.stopPropagation();return _vm.onErrorClick($event)}}},[_c('div',{staticClass:"app-header-notification__content"},[_vm._v("\n      "+_vm._s(_vm.$txt('app-header-notification.inactivity'))+"\n    ")])]):(_vm.showErrorNotification)?_c('div',{staticClass:"app-header-notification",on:{"click":function($event){$event.stopPropagation();return _vm.onErrorClick($event)}}},[_vm._m(0)]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-header-notification__content"},[_vm._v("\n      An error has occurred.\n      Click "),_c('a',{staticClass:"app-header-notification__link",attrs:{"href":"#"}},[_vm._v("here")]),_vm._v(" to reload the page.\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p1CT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authorizeApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_interceptors_request__ = __webpack_require__("drjh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_interceptors_responseSuccess__ = __webpack_require__("rxGt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_interceptors_responseError__ = __webpack_require__("P3oX");





var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: "/"
});

http.interceptors.request.use(__WEBPACK_IMPORTED_MODULE_1__services_interceptors_request__["a" /* default */]);
http.interceptors.response.use(__WEBPACK_IMPORTED_MODULE_2__services_interceptors_responseSuccess__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__services_interceptors_responseError__["a" /* default */]);

function authorizeApi(token) {
  if (token) {
    http.defaults.headers.common.Authorization = 'Bearer ' + token;
  } else {
    delete http.defaults.headers.common.Authorization;
  }
}

/* harmony default export */ __webpack_exports__["b"] = (http);


/***/ }),

/***/ "p4qN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index2"},[_c('section',{staticClass:"index2__banner"},[_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12 large-8 index2__hero-container"},[_c('hero-unit-slider'),_vm._v(" "),_c('div',{staticClass:"index2__quotes"},[_c('quotes')],1)],1),_vm._v(" "),_c('div',{staticClass:"column small-12 large-4"},[_c('div',{staticClass:"index2__sign-up"},[_c('div',{staticClass:"index2__modal__header"},[_vm._v("Create an Account")]),_vm._v(" "),_c('account-register',{attrs:{"mode":"page"}})],1)])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('section',{staticClass:"index2__properties"},[_c('div',{staticClass:" "},[_c('div',{staticClass:"index2__properties-container"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/4300778c-1f81-48dd-bc0f-34c7b1390ac8.png"),expression:"`/images/4300778c-1f81-48dd-bc0f-34c7b1390ac8.png`"}]})]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/010db909-3592-4dd7-8fe9-53d40fba2b8f.png"),expression:"`/images/010db909-3592-4dd7-8fe9-53d40fba2b8f.png`"}]})]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/33cc985e-910b-41a6-93b8-bdad5cd60908.png"),expression:"`/images/33cc985e-910b-41a6-93b8-bdad5cd60908.png`"}]})]),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/262950df-75d5-4d67-ae63-eb12878c3a0a.png"),expression:"`/images/262950df-75d5-4d67-ae63-eb12878c3a0a.png`"}]})]),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"},[_c('div',{staticClass:"properties-icon"},[_c('img',{directives:[{name:"asset-cdn-src",rawName:"v-asset-cdn-src",value:("/images/ce63ef48-3790-471d-88cd-dec2880845c1.png"),expression:"`/images/ce63ef48-3790-471d-88cd-dec2880845c1.png`"}]})]),_vm._v(" "),_vm._m(7)]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-2 col-sm-half-offset"})])])]),_vm._v(" "),_vm._m(8)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"index2__prediction"},[_c('div',{staticClass:"row row-x "},[_c('div',{staticClass:"column small-12 medium-4"},[_c('a',{attrs:{"href":"https://www.predictit.org/markets/detail/8100/Will-Congress-confirm-a-Supreme-Court-justice-in-2025","target":"_blank"}},[_c('div',{staticClass:"index2__prediction-img index2__prediction-img--left"},[_c('p',{staticClass:"index2__prediction--prediction-text"},[_vm._v("New justice "),_c('br'),_vm._v(" confirmed?")])])])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4"},[_c('a',{attrs:{"href":"https://www.predictit.org/markets/detail/8142/How-many-vetoes-will-Trump-issue-in-2025","target":"_blank"}},[_c('div',{staticClass:"index2__prediction-img index2__prediction-img--middle"},[_c('p',{staticClass:"index2__prediction--prediction-text"},[_vm._v("Number of "),_c('br'),_vm._v(" vetoes?")])])])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4"},[_c('a',{attrs:{"href":"https://www.predictit.org/markets/detail/8099/Which-party-will-win-the-2025-gubernatorial-election-in-Virginia","target":"_blank"}},[_c('div',{staticClass:"index2__prediction-img index2__prediction-img--right"},[_c('p',{staticClass:"index2__prediction--prediction-text"},[_vm._v("Next Virginia "),_c('br'),_vm._v(" Governor?")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"index2__video"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"index2__video--video-container"},[_c('div',{staticClass:"column small-12 index2__video--videowrapper"},[_c('iframe',{attrs:{"height":"608","width":"100%","src":"https://www.youtube.com/embed/XxHBRkqT5YQ?rel=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12 large-12"},[_c('div',{staticClass:"index2__process-heading"},[_c('h2',[_vm._v("Start Now")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index2__process-text"},[_c('p',[_vm._v("Shares priced 1¢ - 99¢. Winning shares pay $1.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index2__process-text"},[_c('p',[_vm._v("Think your shares hit the roof? Sell them to other buyers.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index2__process-text"},[_c('p',[_vm._v("Safe and Secure: Operated by the Prediction Market Research Consortium.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index2__process-text"},[_c('p',[_vm._v("Trade on over 300 political futures markets.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index2__process-text"},[_c('p',[_vm._v("Join the prediction market for politics.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"index2__work"},[_c('div',{staticClass:"row row-x index2__work-container "},[_c('div',{staticClass:"col-sm-12 index2__process-heading"},[_c('h2',[_vm._v("How Does It Work")])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4 index2__work--work-info"},[_c('div',{staticClass:"index2__work--work-icon"},[_vm._v("\n\t\t\t\t\t1\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"index2__process-text"},[_c('h3',[_vm._v("Browse Markets")]),_vm._v(" "),_c('p',[_vm._v("Look for opportunities on market prices.")])])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4 index2__work--work-info"},[_c('div',{staticClass:"index2__work--work-icon"},[_vm._v("\n\t\t\t\t\t2\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"index2__process-text"},[_c('h3',[_vm._v("Make a Prediction")]),_vm._v(" "),_c('p',[_vm._v("Think everyone's got it wrong? Buy shares for or against an event taking place. ")])])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4 index2__work--work-info"},[_c('div',{staticClass:"index2__work--work-icon"},[_vm._v("\n\t\t\t\t\t3\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"index2__process-text"},[_c('h3',[_vm._v("Trade your shares")]),_vm._v(" "),_c('p',[_vm._v("Buy your shares low and sell them high once the crowd figures out you were right.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p82I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p8bb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_account_social_avatar_account_social_avatar_vue__ = __webpack_require__("ROsZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__ = __webpack_require__("GOBe");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__["a" /* default */]],
  components: {
    accountSocialAvatar: __WEBPACK_IMPORTED_MODULE_2__components_account_account_social_avatar_account_social_avatar_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['watchedUserDetails']), {
    userLevel: function userLevel() {
      if (this.watchedUserDetails.traderLevel) {
        return this.getLevelByNumber(this.watchedUserDetails.traderLevel);
      }
      return this.getLevelByPredictions(this.watchedUserDetails.profitablePredictions);
    }
  })
});

/***/ }),

/***/ "pBJa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pBjg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pEUD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pIbi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pIon":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-bar"}},[(_vm.searchBarVisible)?_c('div',{staticClass:"search-bar-old"},[_c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('label',{staticClass:"search-bar-old__control",attrs:{"for":"search"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],ref:"searchInput",staticClass:"search-bar-old__input",attrs:{"id":"search","type":"text","placeholder":"Search Markets"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-bar-old__submit",attrs:{"type":"submit"}},[_vm._v("SEARCH")])])]),_vm._v(" "),_c('button',{staticClass:"button search-bar-old__close",on:{"click":_vm.onClose}},[_vm._v("Close")])]),_vm._v(" "),(_vm.showSummary)?_c('div',{class:_vm.summaryClassModifiers},[(_vm.searchTotal > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6 text-left"},[_c('strong',[_vm._v("Search Results")]),_vm._v(": "+_vm._s(_vm.searchFor)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"column small-6 text-right"},[_vm._v("\n          "+_vm._s(_vm.searchTotal)+" Market"),(_vm.searchTotal !== 1)?_c('span',[_vm._v("s")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.searchTotal === 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-8 text-left"},[_c('strong',[_vm._v("No Search Results")]),_vm._v(": "+_vm._s(_vm.searchFor)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"column small-4 text-right"},[_vm._v("\n          0 Markets\n        ")])]):_vm._e()]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pSOo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLayoutDesktop)?_c('div',{class:_vm.classModifiers},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__content"},[((_vm.theme === 'currently' || _vm.theme === 'comments'))?[_c('div',{staticClass:"market-widget-loader__avatarised"},[_vm._m(1),_vm._v(" "),(_vm.theme === 'currently')?_c('div',{staticClass:"market-widget-loader__avatarised-item"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text market-widget-loader__avatarised-text--short"})]):_vm._e()])]:_vm._e(),_vm._v(" "),(_vm.theme === 'money')?[_vm._m(3)]:_vm._e(),_vm._v(" "),(_vm.theme === 'stats')?[_vm._m(4)]:_vm._e()],2)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-widget-loader__header"},[_c('div',{staticClass:"market-widget-loader__header-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-widget-loader__avatarised-item"},[_c('div',{staticClass:"market-widget-loader__avatarised-head"},[_c('div',{staticClass:"market-widget-loader__avatarised-avatar"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-title"})]),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-text market-widget-loader__avatarised-text--short"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-widget-loader__avatarised-head"},[_c('div',{staticClass:"market-widget-loader__avatarised-avatar"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__avatarised-title"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-widget-loader__simple"},[_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--large"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--short"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-widget-loader__stats"},[_c('div',{staticClass:"market-widget-loader__simple"},[_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--large"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--short"})]),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple"},[_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--large"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text"}),_vm._v(" "),_c('div',{staticClass:"market-widget-loader__simple-text market-widget-loader__simple-text--short"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pTAt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pWll":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pbJv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__ = __webpack_require__("vJzj");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_forms_mixin__["b" /* formMixin */]],
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      dontShowAgain: false,
      swiperOptions: {
        direction: 'horizontal',
        pagination: '.attach-to-home__pagination',
        paginationClickable: true
      },
      items: [{
        textTop: this.$txt('attach-to-home.txt1'),
        image: 'step1',
        textBottom: this.$txt('attach-to-home.txt1-bottom')
      }, {
        textTop: this.$txt('attach-to-home.txt2'),
        image: 'step2',
        textBottom: ''
      }, {
        textTop: this.$txt('attach-to-home.txt3'),
        image: 'step3',
        textBottom: ''
      }]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['dontShowAttachToHomeNotification'])),
  beforeDestroy: function beforeDestroy() {
    if (this.dontShowAgain) this.dontShowAttachToHomeNotification();
  }
});

/***/ }),

/***/ "peeU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pgVC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    text: {
      type: String,
      required: true
    },
    infoOnLeft: {
      type: Boolean,
      default: true
    },
    selected: Boolean
  },
  data: function data() {
    return {};
  },

  computed: {
    selectedModifier: function selectedModifier() {
      return {
        'button-with-info--selected': this.selected
      };
    },
    iconModifier: function iconModifier() {
      return {
        'button-with-info__icon--right': !this.infoOnLeft
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click');
    },
    onInfoClick: function onInfoClick() {
      this.$emit('infoClick');
    }
  }
});

/***/ }),

/***/ "pjhW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pnzO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"export-history row-xy"},[(_vm.openCalendar)?_c('div',{staticClass:"export-history__transparent-overlay",on:{"click":_vm.overlayClick}}):_vm._e(),_vm._v(" "),(_vm.contractName)?_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"export-history__market"},[_vm._v("\r\n      "+_vm._s(_vm.contractName)+"\r\n    ")])]):(_vm.marketId)?_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"export-history__market"},[_vm._v("\r\n      "+_vm._s(_vm.market.marketName)+"\r\n    ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column small-4"},[_c('state-button',{ref:"l30d",staticClass:"export-history__button",attrs:{"selected":_vm.selected.l30d,"name":"l30d"},on:{"click":_vm.onButtonClick}},[_vm._v("Past Month")])],1),_vm._v(" "),_c('div',{staticClass:"column small-4"},[_c('state-button',{ref:"l3m",staticClass:"export-history__button",attrs:{"selected":_vm.selected.l3m,"name":"l3m"},on:{"click":_vm.onButtonClick}},[_vm._v("Past 3 Months")])],1),_vm._v(" "),_c('div',{staticClass:"column small-4"},[_c('state-button',{ref:"ytd",staticClass:"export-history__button",attrs:{"selected":_vm.selected.ytd,"name":"ytd"},on:{"click":_vm.onButtonClick}},[_vm._v("Past Year")])],1),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('div',{staticClass:"export-history__date",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }$event.stopPropagation();return _vm.fromClick($event)}}},[_c('label',{staticClass:"export-history__label",attrs:{"for":"fromDatepicker"}},[_vm._v("From")]),_vm._v(" "),_c('datepicker',{ref:"fromDatepicker",attrs:{"format":_vm.dateFormatter,"disabled":_vm.disabled,"maximum-view":"month","input-class":"export-history__input","wrapper-class":"export-history__wrap","calendar-class":"export-history__calendar","id":"fromDatepicker","name":"fromDatepicker"},on:{"opened":_vm.opened,"closed":_vm.closed},model:{value:(_vm.dateFrom.date),callback:function ($$v) {_vm.$set(_vm.dateFrom, "date", $$v)},expression:"dateFrom.date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column small-6"},[_c('div',{staticClass:"export-history__date",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }$event.stopPropagation();return _vm.toClick($event)}}},[_c('label',{staticClass:"export-history__label",attrs:{"for":"toDatepicker"}},[_vm._v("To")]),_vm._v(" "),_c('datepicker',{ref:"toDatepicker",attrs:{"format":_vm.dateFormatter,"disabled":_vm.disabled,"maximum-view":"month","input-class":"export-history__input","wrapper-class":"export-history__wrap","calendar-class":"export-history__calendar","id":"toDatepicker","name":"toDatepicker"},on:{"opened":_vm.opened,"closed":_vm.closed},model:{value:(_vm.dateTo.date),callback:function ($$v) {_vm.$set(_vm.dateTo, "date", $$v)},expression:"dateTo.date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('button',{staticClass:"button button--large button--full-width button--primary",on:{"click":function($event){$event.preventDefault();return _vm.onExport($event)}}},[_vm._v("Export")]),_vm._v(" "),_c('form',{ref:"staticForm",attrs:{"action":_vm.formAction,"method":"post"}},[(_vm.contractId)?_c('input',{attrs:{"type":"hidden","name":"ContractIdForExport"},domProps:{"value":_vm.contractId}}):(_vm.marketId)?_c('input',{attrs:{"type":"hidden","name":"MarketIdForExport"},domProps:{"value":_vm.marketId}}):_vm._e(),_vm._v(" "),_c('input',{ref:"StartDate",attrs:{"type":"hidden","name":"StartDate","value":""}}),_vm._v(" "),_c('input',{ref:"EndDate",attrs:{"type":"hidden","name":"EndDate","value":""}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pqmg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { contentHeader: __WEBPACK_IMPORTED_MODULE_0__components_generics_content_header_content_header_vue__["a" /* default */] },
  computed: {
    title: function title() {
      return this.url.includes('news.predictit') ? "What's New?" : 'Analysis';
    },
    url: function url() {
      // because atob errors on slug === undefined
      return this.$route.params.slug ? atob(decodeURI(this.$route.params.slug)) : '';
    }
  }
});

/***/ }),

/***/ "psIE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pt4Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_order_book_order_book_vue__ = __webpack_require__("M4KV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_keyboard_numeric_keyboard_numeric_vue__ = __webpack_require__("2wsJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_keyboard_numeric_input_keyboard_numeric_input_vue__ = __webpack_require__("HCce");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_purchase_purchase_yes_no_switcher_purchase_yes_no_switcher_vue__ = __webpack_require__("TdoF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_purchase_purchase_offer_value_purchase_offer_value_vue__ = __webpack_require__("DE6t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_purchase_purchase_quantity_value_purchase_quantity_value_vue__ = __webpack_require__("TQoy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_forms_mixin__ = __webpack_require__("vJzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");


 /* eslint-disable */
















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_13__components_forms_mixin__["b" /* formMixin */], __WEBPACK_IMPORTED_MODULE_14__mixins_loader__["a" /* default */]],
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_5__components_market_market_change_price_market_change_price_vue__["a" /* default */],
    keyboardNumeric: __WEBPACK_IMPORTED_MODULE_7__components_keyboard_numeric_keyboard_numeric_vue__["a" /* default */],
    keyboardNumericInput: __WEBPACK_IMPORTED_MODULE_8__components_keyboard_numeric_input_keyboard_numeric_input_vue__["a" /* default */],
    orderBook: __WEBPACK_IMPORTED_MODULE_6__components_order_book_order_book_vue__["a" /* default */],
    purchaseYesNoSwitcher: __WEBPACK_IMPORTED_MODULE_9__components_purchase_purchase_yes_no_switcher_purchase_yes_no_switcher_vue__["a" /* default */],
    purchaseOfferValue: __WEBPACK_IMPORTED_MODULE_10__components_purchase_purchase_offer_value_purchase_offer_value_vue__["a" /* default */],
    purchaseQuantityValue: __WEBPACK_IMPORTED_MODULE_11__components_purchase_purchase_quantity_value_purchase_quantity_value_vue__["a" /* default */]
  },
  props: {
    market: {},
    contract: {
      type: Object,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'cancelToggle', 'confirmationToggle']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'purchase-offer': true
      }, 'purchase-offer--' + this.$router.currentRoute.name, true);
    },
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_4__models_contract__["a" /* default */](this.contract);
    },
    contractName: function contractName() {
      if (!this.market || !this.contract) return '';
      var name = this.market.marketType === 0 ? this.tradeOptions.operationValue : this.contractModel.contractName;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["n" /* capitalizeFirstLetter */])(name);
    },
    minQuantityValue: function minQuantityValue() {
      if (this.tradeOptions.operationType === 'buy') {
        return this.contractModel.userQuantity >= this.minimumOwnership ? 1 : Math.min(this.minimumOwnership, this.minimumOwnership - this.contractModel.userQuantity);
      } else {
        return this.contractModel.userQuantity === 0 ? 1 : this.contractModel.userQuantity > this.minimumOwnership ? 1 : this.contractModel.userQuantity;
      }
    },
    maxQuantityValue: function maxQuantityValue() {
      if (this.tradeOptions.operationType === 'buy') {
        return 9999;
      } else {
        return this.contractModel.userQuantity === 0 ? 1 : this.contractModel.userQuantity;
        // CR
        // : (this.contractModel.userQuantity > this.minimumOwnership)
        //   ? this.contractModel.userQuantity - this.minimumOwnership
        //   : this.contractModel.userQuantity;
      }
    },
    minimumOwnership: function minimumOwnership() {
      return Math.max(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(this.contract, 'minimumClipSize', 1), 1);
    },
    showThresholdInfo: function showThresholdInfo() {
      return this.minimumOwnership > 1;
    },
    initialPricePerShare: function initialPricePerShare() {
      var initialPrice = 0;
      // buy
      if (this.tradeOptions.operationType === 'buy') {
        if (this.tradeOptions.operationValue === 'yes') {
          initialPrice = this.contractModel.buyYesCostAsCents;
        } else {
          initialPrice = this.contractModel.buyNoCostAsCents;
        }
      } else if (this.tradeOptions.operationValue === 'yes') {
        // sell
        initialPrice = this.contractModel.sellYesCostAsCents;
      } else {
        initialPrice = this.contractModel.sellNoCostAsCents;
      }

      if (initialPrice === 0) {
        initialPrice = this.contractModel.lastTradePriceAsCents;
        if (initialPrice > 0 && this.tradeOptions.operationValue === 'no') {
          initialPrice = 100 - initialPrice;
        }
      }

      if (initialPrice === 0) {
        initialPrice = 50;
      }

      return initialPrice;
    },
    mainClassName: function mainClassName() {
      return 'purchase-offer';
    },
    classSharesOwnedLabel: function classSharesOwnedLabel() {
      var _ref2;

      return _ref2 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, this.mainClassName + '__offer-table-contract-shares-owned--no', this.contractModel.mode === 'no'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, this.mainClassName + '__offer-table-contract-shares-owned--yes', this.contractModel.mode === 'yes'), _ref2;
    },
    quantityInputClass: function quantityInputClass() {
      var _ref3;

      return _ref3 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, this.mainClassName + '__offer-quantity-input', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, this.mainClassName + '__offer-quantity-input--empty', !this.tradeOptions.quantity), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, this.mainClassName + '__offer-quantity-input--error', this.quantityError), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, this.mainClassName + '__offer-quantity-input--focus', this.quantityFocused), _ref3;
    },
    quantitySelectedClass: function quantitySelectedClass() {
      return {
        'offer-quantity--selected': this.keyboardNumericType === 'quantity'
      };
    },
    quantityErrorText: function quantityErrorText() {
      var _getReducedQuantity = this.getReducedQuantity(),
          reduced = _getReducedQuantity.reduced,
          min = _getReducedQuantity.min,
          max = _getReducedQuantity.max;
      // console.log(`DEBUG reduced=${reduced}, minimumOwnership=${this.minimumOwnership}, quantity=${this.quantity}, max=${max}`)

      if (this.tradeOptions.operationType === 'buy' && this.quantity && this.quantity < reduced) {
        return 'You must own at least ' + min + ' shares in this contract';
      }
      if (this.tradeOptions.operationType === 'sell' && this.quantity > this.contractModel.userQuantity) {
        if (this.contractModel.userQuantity === 1) {
          return 'You have only 1 share to sell';
        }
        if (this.contractModel.userQuantity === 0) {
          return "You don't have any shares to sell";
        }
        return 'You have only ' + this.contractModel.userQuantity + ' shares to sell';
      }
      if (this.tradeOptions.operationType === 'sell' && this.quantity && this.quantity < reduced) {
        return 'You must maintain ownership of at least ' + min + ' shares';
      }
      // CR
      if (this.tradeOptions.operationType === 'sell' && this.quantity && max && this.quantity > max && this.quantity !== this.contractModel.userQuantity) {
        return 'You must maintain ownership of at least ' + min + ' shares';
      }
      return null;
    },
    isPriceValid: function isPriceValid() {
      if (this.pricePerShare === null || isNaN(this.pricePerShare) || this.pricePerShare === 0) {
        return false;
      }
      return true;
    },
    isQuantityValid: function isQuantityValid() {
      if (this.quantity === null) return false;
      if (this.tradeOptions.operationType === 'sell') {
        if (this.quantity > this.contractModel.userQuantity) return false;
      }
      return !this.quantityErrorText;
    },
    purchaseOfferTitle: function purchaseOfferTitle() {
      var prefix = this.tradeOptions.operationType === 'buy' ? 'Maximum' : 'Minimum';
      return prefix + ' ' + this.tradeOptions.operationType + ' Price';
    },
    nextButtonTitle: function nextButtonTitle() {
      return this.tradeOptions && this.tradeOptions.skipConfirmation ? 'Submit Offer' : 'Next';
    },
    nextButtonDisabled: function nextButtonDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["p" /* isMarketClosed */])(this.market) || !this.isQuantityValid || !this.isPriceValid || this.isLoading;
    },
    purchaseOfferKey: function purchaseOfferKey() {
      var timestamp = this.contractModel.timestamp || '-';
      return this.contractModel.contractId + '-' + timestamp + '-' + this.contractModel.mode + '-' + this.contractModel.userOpenOrders + '-' + this.tradeOptions.operationType + '-' + this.tradeOptions.operationValue;
    },
    orderBookKey: function orderBookKey() {
      return this.purchaseOfferKey;
    },
    isContractOpen: function isContractOpen() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_helpers__["o" /* isContractOpen */])(this.contract);
    }
  }),
  data: function data() {
    return {
      isMarketClosed: __WEBPACK_IMPORTED_MODULE_12__utils_helpers__["p" /* isMarketClosed */],
      pricePerShareUpdateCount: 0,
      pricePerShare: 0,
      quantity: __WEBPACK_IMPORTED_MODULE_15__constants__["a" /* default */].DEFAULT_QUANTITY,
      skipConfirmation: false,
      keyboardNumericType: null,
      quantityError: null,
      quantityFocused: false,
      priceFocused: false
    };
  },

  watch: {
    'tradeOptions.operationType': function watchOperationType() {
      this.pricePerShareUpdateCount += 1;
      this.pricePerShare = this.getDefaultPricePerShare();
      this.setDefaultQuantity();
    },
    'tradeOptions.operationValue': function watchOperationValue() {
      this.pricePerShareUpdateCount += 1;
      this.pricePerShare = this.getDefaultPricePerShare();
      this.setDefaultQuantity();
    },
    contractModel: function contractModel() {
      // reinit contract after offer cancelation
      if (this.cancelToggle) {
        this.setCancelToggle(false);
        // this.pricePerShare = this.getDefaultPricePerShare();
        // this.quantity = this.getDefaultQuantity();
        // if (!(this.keyboardNumericType || this.quantityFocused || this.priceFocused)) {
        //   this.pricePerShare = this.initialPricePerShare;
        //   this.quantity = constants.DEFAULT_QUANTITY;
        // }
      }
    },
    pricePerShare: function pricePerShare(value) {
      this.setTradePrice(value);
      this.pricePerShare = this.tradeOptions.pricePerShare;
    },
    quantity: function quantity(value) {
      this.setTradeQuantity(value);
      this.quantity = this.tradeOptions.quantity;
    },
    skipConfirmation: function skipConfirmation(value) {
      this.setTradeSkipConfirmation(value);
      this.skipConfirmation = this.tradeOptions.skipConfirmation;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('market', ['getMarketRules']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('trade', ['setTradeQuantity', 'setTradePrice', 'setTradeSkipConfirmation', 'setCancelToggle', 'setConfirmationToggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('popup', ['setGenericSmallPopup', 'setCurrentSmallPopup', 'setCurrentPopupOptions']), {
    openThresholdInfoPopup: function openThresholdInfoPopup() {
      this.setCurrentSmallPopup(__WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_OWNERSHIP_INFO);
      this.setCurrentPopupOptions({ shares: this.minimumOwnership });
    },
    getDefaultPricePerShare: function getDefaultPricePerShare() {
      return this.initialPricePerShare;
    },
    getReducedQuantity: function getReducedQuantity() {
      if (this.tradeOptions.operationType === 'sell') {
        return this.contractModel.userQuantity === 0 ? {
          reduced: 1,
          min: this.minimumOwnership,
          max: null
        } : this.contractModel.userQuantity > this.minimumOwnership ? {
          reduced: 1,
          min: this.minimumOwnership,
          max: this.contractModel.userQuantity - this.minimumOwnership
        } : {
          reduced: this.contractModel.userQuantity,
          min: this.minimumOwnership,
          max: null
        };
      } else if (this.tradeOptions.operationType === 'buy') {
        return this.contractModel.userQuantity >= this.minimumOwnership ? {
          reduced: 1,
          min: this.minimumOwnership,
          max: null
        } : {
          reduced: Math.min(this.minimumOwnership, this.minimumOwnership - this.contractModel.userQuantity),
          min: this.minimumOwnership,
          max: null
        };
      }
    },
    setDefaultQuantity: function setDefaultQuantity() {
      var _getReducedQuantity2 = this.getReducedQuantity(),
          reduced = _getReducedQuantity2.reduced,
          min = _getReducedQuantity2.min;
      // console.log(`DEBUG set default: ${reduced}`)


      this.quantity = reduced;
      this.setTradeQuantity(this.quantity);
    },
    onUpdatePriceAndQuantity: function onUpdatePriceAndQuantity(data) {
      this.setTradeQuantity(Math.min(data.quantity, 9999));
      this.quantity = this.tradeOptions.quantity;
      this.setTradePrice(data.price);
      this.pricePerShare = this.tradeOptions.pricePerShare;
    },
    onClickQuantityInput: function onClickQuantityInput() {
      this.keyboardNumericType = 'quantity';
    },
    onClickPricePerShareInput: function onClickPricePerShareInput() {
      this.keyboardNumericType = 'pricePerShare';
    },
    onOutsideClick: function onOutsideClick() {
      this.keyboardNumericType = null;
    },
    onClickNext: function onClickNext() {
      if (this.isQuantityValid && !this.isLoading) {
        this.$emit('submit');
      } else {
        this.quantityError = true;
      }
    },
    onReadRules: function onReadRules() {
      var _this = this;

      if (this.$router.currentRoute.name === 'portfolio') {
        this.loaderAdd(document.body);
        this.getMarketRules(this.market.marketId).then(function (data) {
          _this.loaderRemove(document.body);
          _this.setGenericSmallPopup({
            name: __WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_MARKET_RULES,
            options: {
              title: 'The Rules',
              content: data.rule
            }
          });
        }).catch(function () {
          return _this.loaderRemove(document.body);
        });
      } else {
        this.setGenericSmallPopup({
          name: __WEBPACK_IMPORTED_MODULE_16__components_app_app_modals_app_modals__["a" /* MODALS */].SMALL_MARKET_RULES,
          options: {
            title: 'The Rules',
            content: this.market.rule
          }
        });
      }
    },
    onQuantityInputFocus: function onQuantityInputFocus() {
      this.quantityFocused = true;
    },
    onQuantityInputBlur: function onQuantityInputBlur() {
      this.quantityFocused = false;
      // console.log(`DEBUG minQuantityValue=${this.minQuantityValue} maxQuantityValue=${this.maxQuantityValue}`)

      // if (this.quantity === null || this.quantity < this.minQuantityValue) {
      //   this.quantity = this.minQuantityValue;
      // } else if (this.quantity > this.maxQuantityValue) {
      //   this.quantity = this.maxQuantityValue
      // }
    },
    onPriceFocus: function onPriceFocus() {
      this.priceFocused = true;
    },
    onPriceBlur: function onPriceBlur() {
      this.priceFocused = false;
    },
    onClickQuantityBox: function onClickQuantityBox() {
      this.$refs.sharesNumberInput.click();
    }
  }),
  created: function created() {
    // do not reinit contract if user comes back from confirm page
    if (this.confirmationToggle && this.tradeOptions.pricePerShare !== null) {
      this.quantity = this.tradeOptions.quantity;
      this.setConfirmationToggle(false);
    } else {
      this.setTradePrice(this.getDefaultPricePerShare());
      this.setDefaultQuantity();
    }

    this.pricePerShare = this.tradeOptions.pricePerShare;
    // this.quantity = (defaultQuantity === null) ? defaultQuantity : this.tradeOptions.quantity;
    this.skipConfirmation = this.tradeOptions.skipConfirmation;
  }
});

/***/ }),

/***/ "ptZl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_price_change_chart_js__ = __webpack_require__("1Lmp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f259c1f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_price_change_chart_vue__ = __webpack_require__("AsKc");
function injectStyle (ssrContext) {
  __webpack_require__("iSsy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_price_change_chart_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f259c1f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_price_change_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q+n/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('overlay'),_vm._v(" "),_c(_vm.layoutComponent,{tag:"component"}),_vm._v(" "),_c('app-modals'),_vm._v(" "),_c('app-privacy-statement')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q/KQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers,on:{"click":_vm.onOutsideClick}},[_c('div',{staticClass:"row purchase-offer__title"},[_vm._v("\n    Make a Trade\n  ")]),_vm._v(" "),(_vm.contractName)?_c('div',{staticClass:"row purchase-offer__sub-title"},[_vm._v("\n    "+_vm._s(_vm.contractName)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"purchase-offer__offer-table"},[(_vm.contractModel.userQuantity > 0)?_c('div',{staticClass:"purchase-offer__offer-table-contract-shares"},[_c('span',{staticClass:"purchase-offer__offer-table-contract-shares-owned",class:_vm.classSharesOwnedLabel},[_vm._v("\n          "+_vm._s(_vm.contractModel.userQuantity)+"\n        ")]),_vm._v(" @ avg. "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.contractModel.userAveragePricePerShareAsCents),expression:"contractModel.userAveragePricePerShareAsCents",modifiers:{"cents":true}}]}),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.contractModel.userChangePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice}})],1):_c('div',{staticClass:"purchase-offer__offer-table-contract-shares"},[_vm._v("\n       \n    ")]),_vm._v(" "),_c('div',{staticClass:"purchase-offer__price"},[_c('span',{staticClass:"purchase-offer__price-change"},[_vm._v(_vm._s(_vm.contractModel.lastTradePriceAsCents)+"¢")]),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice}})],1),_vm._v(" "),(!_vm.isMarketClosed(_vm.market))?_c('purchase-yes-no-switcher',{staticClass:"purchase-offer__offer-table-yes-no-switcher",attrs:{"contract":_vm.contract}}):_vm._e()],1),_vm._v(" "),(_vm.isContractOpen)?_c('div',{staticClass:"row row-x purchase-offer__forms-shares-value"},[_c('div',{staticClass:"column small-6 purchase-offer__minimum-sell-offer"},[_c('purchase-offer-value',{key:_vm.purchaseOfferKey,attrs:{"title":_vm.purchaseOfferTitle,"value":_vm.pricePerShare,"selected":_vm.keyboardNumericType === 'pricePerShare'},on:{"click":_vm.onClickPricePerShareInput},model:{value:(_vm.pricePerShare),callback:function ($$v) {_vm.pricePerShare=$$v},expression:"pricePerShare"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-6 purchase-offer__minimum-sell-offer"},[_c('purchase-quantity-value',{key:_vm.purchaseOfferKey,attrs:{"title":"Number Of Shares","value":_vm.quantity,"selected":_vm.keyboardNumericType === 'quantity',"userQuantity":_vm.contractModel.userQuantity,"operationType":_vm.tradeOptions.operationType,"minValue":_vm.minQuantityValue,"maxValue":_vm.maxQuantityValue,"minimumOwnership":_vm.minimumOwnership},on:{"click":_vm.onClickQuantityInput},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}})],1),_vm._v(" "),(_vm.quantityErrorText)?_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"purchase-offer__offer-quantity-error"},[_vm._v("\n        "+_vm._s(_vm.quantityErrorText)+"\n      ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.keyboardNumericType === 'pricePerShare')?_c('keyboard-numeric',{key:_vm.keyboardNumericType,attrs:{"value":_vm.pricePerShare,"maxLength":2},on:{"outsideClick":_vm.onOutsideClick},model:{value:(_vm.pricePerShare),callback:function ($$v) {_vm.pricePerShare=$$v},expression:"pricePerShare"}}):_vm._e(),_vm._v(" "),(_vm.keyboardNumericType === 'quantity')?_c('keyboard-numeric',{key:_vm.keyboardNumericType,attrs:{"value":_vm.quantity,"maxLength":4},on:{"outsideClick":_vm.onOutsideClick},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"purchase-offer__order-book"},[_c('order-book',{key:_vm.orderBookKey,attrs:{"contract":_vm.contract,"market":_vm.market,"operationType":_vm.tradeOptions.operationType,"operationValue":_vm.tradeOptions.operationValue,"defaultTab":_vm.tradeOptions.defaultTab},on:{"updatePriceAndQuantity":_vm.onUpdatePriceAndQuantity}})],1),_vm._v(" "),(_vm.isContractOpen)?_c('div',{staticClass:"purchase-offer__footer"},[(_vm.showThresholdInfo)?_c('div',{staticClass:"purchase-offer__footer-ownership-link",on:{"click":_vm.openThresholdInfoPopup}},[_vm._v("\n      Minimum Ownership Requirement: "+_vm._s(_vm.minimumOwnership)+" Shares\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12"},[_c('button',{staticClass:"button button--primary button--full-width purchase-offer__footer-next-button",attrs:{"disabled":_vm.nextButtonDisabled},on:{"click":_vm.onClickNext}},[_vm._v("\n          "+_vm._s(_vm.nextButtonTitle)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-7 purchase-offer__footer-review-and-confirm"},[_c('form-checkbox',{staticClass:"checkbox--purchase-offer checkbox--no-margin",attrs:{"name":"checkbox--purchase-offer","label":"Skip Offer Confirmation"},model:{value:(_vm.skipConfirmation),callback:function ($$v) {_vm.skipConfirmation=$$v},expression:"skipConfirmation"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-4 purchase-offer__footer-rules-link",on:{"click":_vm.onReadRules}},[_vm._v("\n        Read Rules\n      ")])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q1v3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q63C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q6c4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q6iB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"purchase-modal"},on:{"after-enter":_vm.afterEnter}},[_c('div',{staticClass:"purchase-modal__overlay"},[_c('div',{staticClass:"purchase-modal__wrapper"},[(_vm.ready)?_c('div',{staticClass:"purchase-modal__body"},[_c('div',{staticClass:"purchase-modal__header"},[(_vm.market)?_c('market-header-title',{staticClass:"purchase-modal__market-header-title",attrs:{"market":_vm.market,"watchIcon":false,"closeButton":_vm.showCloseButton},on:{"close":_vm.onClose}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"purchase-modal__content"},[(_vm.tradeOptions.contractId)?_c('purchase-journey',_vm._b({attrs:{"market":_vm.market},on:{"confirmationDataChange":_vm.onConfirmationDataChange}},'purchase-journey',_vm.tradeOptions,false)):_vm._e()],1)]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qD3I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insight-modal"},[_c('div',{staticClass:"insight-modal__inner"},[_c('content-header',{attrs:{"title":_vm.title,"returnRoute":"home","returnRouteGoTo":"insight-widget"}}),_vm._v(" "),_c('div',{staticClass:"insight-modal__content"},[_c('iframe',{staticClass:"insight-modal__iframe",attrs:{"src":_vm.url,"frameborder":"0"}})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qGTQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messaging-journey-info"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"messaging-journey-info__buttons"},[_c('div',{staticClass:"button button--primary button--medium messaging-journey-info__button",on:{"click":_vm.onOptIn}},[_vm._v("\n      Opt In (tries to show native window)\n    ")]),_vm._v(" "),_c('div',{staticClass:"button button--primary button--medium",on:{"click":_vm.onOptOut}},[_vm._v("\n      Opt Out (info stored in browser)\n    ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messaging-journey-info__note"},[_vm._v("\n    Copy for user whether or not he'd like to receive notifications.\n    "),_c('br'),_vm._v("\n    API Call required on opt in\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qHZ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"balance-history-item",class:_vm.classModifier},[_c('div',{staticClass:"row balance-history-item__main-row"},[_c('div',{class:_vm.typeColumnModifiers},[_c('div',{staticClass:"balance-history-item__type text-left"},[_vm._v("\n        "+_vm._s(_vm.item.typeName)+" "),(_vm.item.providerId)?_c('a',{directives:[{name:"outer-link",rawName:"v-outer-link"}],staticClass:"balance-history-item__provider-order",attrs:{"href":("https://commerce.coinbase.com/receipts/" + (_vm.item.providerId))}},[(_vm.isLayoutDesktop)?_c('span',[_vm._v("("+_vm._s(_vm.item.providerId)+")")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{class:_vm.amountColumnModifiers},[_c('div',{staticClass:"balance-history-item__amount text-center"},[(_vm.item.requested)?_c('span',[_vm._v(_vm._s(_vm.item.requested))]):_c('span',[_vm._v(_vm._s(_vm.item.amount))])])]),_vm._v(" "),(_vm.showAdditionalColumns)?[_c('div',{staticClass:"column small-2"},[_c('div',{staticClass:"balance-history-item__fee text-center"},[(_vm.item.fee)?_c('span',[_vm._v(_vm._s(_vm.item.fee))]):_c('span',[_vm._v("-")])])]),_vm._v(" "),_c('div',{staticClass:"column small-2"},[_c('div',{staticClass:"balance-history-item__fee text-center"},[(_vm.item.requested)?_c('span',[_vm._v(_vm._s(_vm.item.amount))]):_c('span',[_vm._v("-")])])])]:_vm._e(),_vm._v(" "),_c('div',{class:_vm.statusColumnModifiers},[_c('div',{staticClass:"balance-history-item__status"},[_c('state-icon',{attrs:{"state":_vm.item.status,"theme":"transaction"}})],1)])],2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-6"},[_c('div',{staticClass:"balance-history-item__date text-left"},[_vm._v("\n        "+_vm._s(_vm.itemDate)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"column small-6 text-right"},[_c('div',{staticClass:"balance-history-item__confirmation-number"},[_vm._v("\n        "+_vm._s(_vm.item.confirmationNumber)+"\n      ")]),_vm._v(" "),(_vm.showCancelRequestButton(_vm.item))?_c('div',{staticClass:"balance-history-item__cancel",on:{"click":function($event){return _vm.onCancelRequest(_vm.item)}}},[_vm._v("\n        "+_vm._s(_vm.$txt('balance-history-item.cancel'))+"\n      ")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qIn7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_icon_js__ = __webpack_require__("4/Ye");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cbe6ea1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_icon_vue__ = __webpack_require__("u71h");
function injectStyle (ssrContext) {
  __webpack_require__("7A0p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_icon_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cbe6ea1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qV4T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qVoY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-report"},[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{ref:"fileuploadform",attrs:{"method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('form-select',{staticClass:"user-report__subject",attrs:{"searchable":false,"maxHeight":300,"adjust":false,"disabled":_vm.isFormDisabled,"options":_vm.reasonOptions,"required":true,"label":"label","placeholder":"Reason","track-by":"value"},on:{"input":_vm.$v.fields.reason.$touch},model:{value:(_vm.fields.reason),callback:function ($$v) {_vm.$set(_vm.fields, "reason", $$v)},expression:"fields.reason"}}),_vm._v(" "),_c('form-textarea',{staticClass:"user-report__message",attrs:{"required":_vm.messageRequired,"name":"help-message","placeholder":_vm.messagePlaceholder},model:{value:(_vm.fields.message),callback:function ($$v) {_vm.$set(_vm.fields, "message", $$v)},expression:"fields.message"}}),_vm._v(" "),_c('input',{ref:"fileinput",staticClass:"user-report__file",attrs:{"type":"file","multiple":"multiple"},on:{"change":_vm.onChange}}),_vm._v(" "),_c('div',{staticClass:"user-report__footer"},[(_vm.isUploadEnabled)?_c('button',{staticClass:"user-report__button user-report__upload",attrs:{"disabled":_vm.isFormDisabled,"name":"upload-button","type":"button"},on:{"click":_vm.onUpload}},[_vm._v("\n        Upload\n      ")]):_vm._e()]),_vm._v(" "),(_vm.files.length > 0)?_c('ul',{staticClass:"user-report__files"},[_vm._l((_vm.files),function(file,index){return [_c('li',[_vm._v(_vm._s(file.name)+" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.fileRemove(index)}}},[_vm._v("(Remove)")])])]})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"user-report__footer"},[_c('button',{staticClass:"user-report__button user-report__submit",attrs:{"type":"submit","disabled":_vm.invalidOrDisabled,"name":"help-button"}},[_vm._v("Send")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qXT1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");






function getPriceOrZero(target) {
  // value may be empty or can come as fraction like 0.99 or 99
  if (isNaN(target)) return 0;
  return target < 1 ? Math.round(100 * target) : Math.round(target);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_loader__["a" /* default */]],
  props: {
    widget: Object,
    theme: {
      type: String,
      default: ''
    }
  },
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_2__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  computed: {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'market-money-widget': true
      }, 'market-money-widget--' + this.theme, this.theme);
    },
    iconModifiers: function iconModifiers() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'market-money-widget__icon': true
      }, 'market-money-widget__icon--' + this.iconTargetClass, this.iconTargetClass);
    },
    iconTargetClass: function iconTargetClass() {
      return this.delta ? 'price-up' : 'price-down';
    },
    obj: function obj() {
      return this.widget ? this.widget : {};
    },
    price: function price() {
      return getPriceOrZero(this.obj.lastTradePrice);
    },
    delta: function delta() {
      return getPriceOrZero(this.obj.lastTradePrice) - getPriceOrZero(this.obj.lastClosePrice);
    },
    percent: function percent() {
      var value = (this.obj.percentValue || '0').toString();
      if (value.endsWith('%')) {
        return value;
      }
      var parsed = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(value, 10);
      return isNaN(parsed) ? '0%' : parsed + '%';
    },
    contractName: function contractName() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["l" /* isMarketSingle */])(this.obj) ? 'Latest Price' : this.obj.contractName;
    }
  },
  methods: {
    onClick: function onClick() {
      this.$router.push({
        name: 'market-details',
        params: {
          marketId: this.obj.marketId,
          marketUrl: this.obj.marketUrl
        }
      });
    }
  },
  watch: {
    widget: function widget(val) {
      if (val) {
        this.loaderRemove();
      }
    }
  },
  mounted: function mounted() {
    if (!this.widget) {
      this.loaderAdd();
    }
  }
});

/***/ }),

/***/ "qYhg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    level: {
      type: String,
      default: 'success'
    }
  },
  computed: {
    levelModifier: function levelModifier() {
      return 'alert-box--' + this.level;
    }
  }
});

/***/ }),

/***/ "qcXe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qidN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LS_MAINTENANCE_MESSAGE_KEY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_localStorage__ = __webpack_require__("Moaq");




var LS_MAINTENANCE_MESSAGE_KEY = 'maintenanceMessageHidden';

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['hasBanner']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['hasServerErrorOccurred', 'maintenance', 'liveUpdatesDisabled', 'hiddenMaintenanceMessage', 'newHeaderEnabled']), {
    classModifiers: function classModifiers() {
      return {
        'app-header-notification__wrapper': true,
        'app-header-notification__wrapper--new-header': this.newHeaderEnabled
      };
    },
    maintenanceMessageText: function maintenanceMessageText() {
      return this.maintenance.suspendedMessage || this.maintenance.systemMessage;
    },
    hasServerMessage: function hasServerMessage() {
      return !!this.maintenanceMessageText && this.maintenanceMessageText !== this.hiddenMaintenanceMessage;
    },
    showErrorNotification: function showErrorNotification() {
      return !this.hasServerMessage && this.hasServerErrorOccurred;
    },
    showBannerNotification: function showBannerNotification() {
      return !this.hasServerMessage && this.hasBanner && !this.hasServerErrorOccurred;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['dontShowBanner', 'setServerError', 'setHiddenMaintenanceMessage']), {
    onCloseMaintenanceMessage: function onCloseMaintenanceMessage() {
      var expiresAt = 86400 * 3; // 3 days
      __WEBPACK_IMPORTED_MODULE_2__helpers_localStorage__["a" /* default */].set(LS_MAINTENANCE_MESSAGE_KEY, this.maintenanceMessageText, expiresAt);
      this.setHiddenMaintenanceMessage(this.maintenanceMessageText);
    },
    onErrorClick: function onErrorClick() {
      this.setServerError(false);
      var dt = new Date();
      this.$router.go({
        path: this.$router.path,
        query: {
          t: +dt
        }
      });
    },
    onBannerClick: function onBannerClick() {
      this.dontShowBanner();
    },
    onSystemMessageClick: function onSystemMessageClick() {
      this.$router.push({ name: 'platform-announcements' });
    }
  })
});

/***/ }),

/***/ "qikT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-page"},[_c('profile')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qniv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qt4T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qtti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__("G/BR");





var appNotificationMixin = {
  props: {
    autoClose: {
      type: Boolean,
      required: false,
      default: true
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
    },
    index: {
      type: Number,
      required: true
    },
    closeButton: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      timeout: null,
      interacted: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['remove']), {
    onClose: function onClose() {
      this.remove(this.index);
    },
    onInteract: function onInteract() {
      this.interacted = true;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.$el.addEventListener('click', function () {
      return _this.onInteract();
    });
    if (this.autoClose && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__logger__["b" /* isDebugOn */])()) {
      this.timeout = setTimeout(function () {
        if (!_this.interacted) _this.onClose();
      }, this.closeTimeout);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (appNotificationMixin);

/***/ }),

/***/ "qvFU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_levels_js__ = __webpack_require__("z++8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83787280_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_levels_vue__ = __webpack_require__("LKuo");
function injectStyle (ssrContext) {
  __webpack_require__("0u6x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_leaderboards_levels_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83787280_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leaderboards_levels_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qyUj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qzEJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r4gD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-timeline"},[(_vm.isLayoutDesktop && _vm.statsOptionAvailable)?_c('div',{staticClass:"charts-timeline__title",on:{"click":_vm.onTitleClick}},[_vm._v("\n    Stats\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"charts-timeline__tabs-period",style:(_vm.tabsPeriodStyleModifiers)},[_c('tabs',{attrs:{"activeTab":_vm.activeTabPeriod,"items":_vm.tabsPeriod,"theme":"timeline"},on:{"tabChange":_vm.tabChangePeriod}})],1),_vm._v(" "),(_vm.isLayoutDesktop)?_c('div',{staticClass:"charts-timeline__tabs-type"},[_c('tabs',{attrs:{"activeTab":_vm.activeTabType,"items":_vm.tabsType,"theme":"timeline"},on:{"tabChange":_vm.tabChangeType}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r6f4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_attach_to_home_js__ = __webpack_require__("pbJv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a669663_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attach_to_home_vue__ = __webpack_require__("WPqe");
function injectStyle (ssrContext) {
  __webpack_require__("Yph/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_attach_to_home_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a669663_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attach_to_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r78W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_community_forums_js__ = __webpack_require__("mQlD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbbc5462_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_community_forums_vue__ = __webpack_require__("CdV1");
function injectStyle (ssrContext) {
  __webpack_require__("yh8I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_community_forums_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbbc5462_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_community_forums_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r7L0":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABQCAYAAADvCdDvAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAABpwSURBVHhe7V0HeBVV9j8zryUvjRQIIQklhdBFcFVACEXRFVllFV2aiK4U0QVZFtfuuoiF3WVFEFGKZVdxBZF1YZGiQugQkJaEFAgllBACCZDyysz/d+bNCynvvcwrhP1/n798983cOzN3Zs65p90yEeh/BJIk3YLN/Ui9kFKQIpBsSOeRspF+RFouiuIZbDUD9SZjMwKpP1InpBgkHdIlpDykzUhc7y5sfwYINliW5T1INZBsdtlWelm2XbyCjFoI4FwL0hKkOPVyt8DprXHel0h2x9WybLPa5ZLzV+SzZ8rlsrLK+nXvQOqnXn7DcMMkBDQIQponCMITnK/KLaKShWupbM0eqs47TbJdUs7ThQWT+db2FDmsF0WNGUC6cDNfW4pDo9Gq/6ucVA8g7P2o9xPsRlRUWGhLRiHt3X2KCgsvkl2tlxEaaqQuXeNowKBkSkqO5nplFM/Btc8hsXQ2OW4IQ0CwYGxW46UHSFcq6dRzHyvMcDLBHfTRYRQ/ayzFPHk3ySTbUM9ovV7/pXpYAcpGYQNmCLofv8+nb74+RBUVVsdBD7jl1kQaNaaHwiTwZTmebcSNYMqNYsgyvOwjluPFlHfva1SVdVI9og1RowdQ2yVTwCGxGtl0SMpOLke9fbD5QZJkw+KPdtHund7VGxMTQlOn96PY2FBmyruod6p6qMnQ5AzhVg1mfGY9d4mO9JpO1cfOqUe8Q8y4O6kNmALC5aO+rtiyoT6I/XZLFu2i7VuPO070ElFRZnrh5UEUHmFi9XU3mLLecaRpIKrbJgGIxnbjbexQ4Zi/+cwMRsnSDVS6LIPAgBTU+QyKpjEzdu444TMzGKWlFbT4o51cLzfWOai7SWnU1AwZgRbX6uKKbVS+fp9a6juKnv8YlsTOu88iTWGD/fXyg5z3C9lZxZQJJwA86YxnvlctbhI0KUOAkfxz7i8rlYy/sBQWK14ZCBeHFH1w/1kqvVChHvUP3609ou7RGHXbJGgyhsB2mLDpazlVQld31rys3yhbvVvdIzqw/7S65z+OHS1V1BfAcVKT0akpJaQDWrGpYk++mg0MKvYeVfeIjh/n4DtwOFpQytLXDAzhnoMmQVMyJJ5/rEUXlEygYIXEOXHR0aIDhlr1tVO31x0BYwirJKQEtKbW58+fD1OLa4NVVsAhVV8L+qxWxcAHDIhn1D0KVbd1wKoMKaChg18MAQN6IM1BOoxsBcSbI7HjMTEx5Sg7ifQPPPADSHqUK/pEH9uMNwGDLiRI3SN6b8Ew+mjpcPpwyXB652/3UWKif/cKD6+pu4p/8B4dkF7De/1gt9uLsW/jhPxp5NdhOwMpUbnCR/jEENy0E9JaMCATaSpSJ7JUiFJxAUlnjpB8uYR1bwISd2OsxEPnYtudrzXfFFjpN8RHqXvXUHislD5csINOnvTPpiS05g5nIhCb3/kbvEcWsq/ivfpbZaF5cYVduFQtiXjZOLjzd6H8bRw/inOXIjXaAeoKXosbbsRB2Gzc3CRfKSXr9i/Itn8NSadzuAk5TgKEiFjSdx1MhjseJTGWe8Cv4VDSb/0KCmsjamQ6tfvndDWHUP3AWZo/d2udTkRf0KxZMKRsCDcszpYhRRSWWeiDny7QtwXllHOhipwaLdyoo9tbmWlY+wga1SmSwowiSxN3gI4Do/7tOEsbvJIQMGMmHnCuIEsmy/cLqWJmP7Ks+StJRdl1mMGQy86RdctnVPHOPVT9zUwim0U94uiLChRMKXUb4rJ/7vObGYxefdo4mUE2SY54ZctZSluUQ2/vLKaskmvMYJRb7LSu8DJNWneK2i3MpoVgGi5m0WXtMN5xljZoZojNZuM+qBflqitU+cFYsnz7NsnVGrwayU7WTUuocsEY4msZzSfcQ4KBu578hymllbpHdKHkKhUXO+7hD0RRoPQBDqmusEl034pj9Odt58hir9voXOFCpY0mgjGj/3OCcDob/QVoyPephxuFJoagwniI3nwmbtWSCWTP26Ye0Q770d1UtXSSwiBDfDQ1G8YDg/4jqJaEXLlyTQr9QbfurSg6msddiEZ9e4K+O3ZZPaIdn2ddpCfXKt0vTONPtNoUrRLyZ1Qcbtm4EMzYrhZ5D3vuVrJs/EDZb/G05kbjEbVVVlCwQd3zDwMGOqRj7t4S+iaPzYdv+PhQKS05qASXrL7Y4DeKRhkCkWuJzWjFgG9431HoByzr58O+nKXQvp0p2E+PSxcRQvrmDk+IERNjJp3Ov7CgZVwYdewUS2ev2ujlDK+G713ij5vO0BWLYtNGgpZJSqEHaGHIcHDYYN35L5ItAYiErVVk2bRU2fVXSuobdJ1OVAaZ/EF/SAfb8r/sKqbLDkL6hfMVNvr08EWWEh1oOVotdgstKmsg/9gPrlMygYBNZS67rPool0GwJtRnCCO2patOAm0wBempd5+2SotefIC91sBg+ZGaeGiwunULLQzpQnYr2U8dUrP+Q64oI9vulSSaTRT9+F1qqfcISr3mYTkRG+s7Q27v1YaCYYe4RV+qDlw3zM4zFU43uZvy6wFaGBIrlxVDRAI73m/N+FiJXZpPuhdPoeUxGsK1hPgucWzMmW7zYMwDiQqrRMVQXVBbYVBbZrXYJbRQQpQhIYGGdK6A7DmbyZTUkiKG8Bw57xFIldU+rTnFJ0TQBgR42YjCA41qNVgFQzx6HVoYclEICWyHoBOWzf4Z99pBoRO+qqwBgxxDHu9lBlY6GMyBaNgnMKMSUuLRM9LCkFzB3Ezpmwo07EcyFEkJv6s7BaUpwyWawRPoDC56jptFBpPJxJ3L2sHX3NyjFRVcstDqo+VqaeDQrpmRQo0KqXPAEI/hvhaGKJGgvkO6kgkoYEOsm2FL4Gc2f2qIWqgNrtQVg13WFrHe2ZF+6UmKyzwftqN2H1WgcG9SuLpHGerWLbQwZBX/6Hsr8xMCDtuerxWvK/qxQUqr1wpX6soJb9QWM6Jf/yTF1eWoOtAQ0UAmdI9Wc7RC3bpFowwRRXE3dN9PutbdSN898DNiZEslWXcsU+bsRo1RQh5NcCchDG88rR63xFNERJDi6pYF0NV1YmyXKOoSE8T2gyfxBURCGK/yj+nB10mIdN8yfQV305NkpxaTobbULu/G4Jkh2iWEjfn1cHUZqZEmmjOwhl4vN2Y/GJoYwoMs4PAKITSKgscvJSGsuXokMJAvnibbge8oqFMihQ1sNHZSEORRZWmTEB7iTU2NuS6ubmK4gf47PIkiTMoww1egoaL6G4NWCWE8jpQptkyl4KnLSUzo7CgNEKxeusCBkBBehsCYG2BX97Y4M20blUrJ8K7QkPch/VY91CgaZQgqE5A6YJcnjC2TJKlUjEok89SvyThoImoIzECT/VgmSScOUMTQW8nYpoVa6hpiSBAZ4iLVXEOEhMDNDPM8ycVsNtBtt7dWXN01AXJ19bDgL/eOpYxRKZQQZmDaFaD4DaiqVNBNUytxyxAeUEGahUpPIJuNSr9Cmg3Rc8wq0BnIeN8MCn56GYkxbZQif8GBogCvR+lO8QBTMqSjEVvTmNrqc0c7MiJeCZSr2z7KRFvAiNfvaEkGdq0A0CsZaTl29yBdBD23Ik1Cctsl3eCtwAA90h+w+xIqM5NkIfnSbqLyA/CIINqCnoRgBHERPWBLWG0JSs+tZdUsZcIDKlDq8QlgcsgrGWS3BtHBxHEkVboeAWz2696UvOJ5NecaSxfvpm1bCtVcXeC9aOab95A50kwJC7L88q64XUzqHkOz+8eR2eBo3ycrz9O+S3l0puoCqCNQfHAM3RKZRrEmh1SDvjzDYwae4zOkOgSrwxCcGIG0AicNItsVko69R/LJxWi6bvzz4NYkth5HQuITkNdQsudsoqplf1QmOPgK4+CnyfjLaVT4+Lt0YekGtbQuWs54kOLffkzNucaa1Tm00s1M+C5dW9KUaX3p/X0lNHl9kVrqPeJDDbT4l4l0d7swsssSfVW0iRYcXQVmNJwuy4y5I6YLTU15iO5q0VMpA6154dI4pBqPokZlsRjhhO+YGXLZPrJv7UNywWz3zGBUniDpyJ/InvELks/9h3SI5s0z1pK+x1D1BO9h3fY5fqo9GndTqnuD7kRLDyprwEC4umiX8/b6Pq31Nx2b0YHH0xRmZF0+TgM2T6Pxe//qkhkMGX8ZJQfpwR2v0pjdb1KZ9SpL6m9Ac/ZgjeppdWzIQpxwm3xxO0m7QNBKL5aDVZ8jad+jJB18hgSjjoLGvEtBj75HvnRKKkPFe1eRuUcyhfbuqJbWhaco3Ql3nlZM8xDqelNL2nDcN1c3KkhHXwxto6RmJpHmQyLSN02ln8q0TyJfdWYrDd4yg85XX2Km3AVhmKsecjAEBUNwYBRVFZG0dwxcHt+GauWif0Ky+iKu2En6m4co0qLryMvDvYPSvwU0dyMlnlxeJ1q0CFVsRX30H8BDtIJPru5gSANLBUtHUWUJPbDjJXr+0EdULXk/PJENqXp45+vKtXCUJkBK7uRy52ThmZyRDv8e1PCzP6fyOCTsPpLyZpIQGolAcgmZHn6DBJP2sW6eBcmzWyIf7N3AvRWDjWSMr+kbcgsDJDUqqm7fmMGgoz5923nt6rKxnndnPK1FoMd2Y0XRZur149P04/n96hm+IfNSLr19BI4QAD7M4i0zpBdaTHdWVfL5AI2by3bYn7+RtGMw0dVcMvQaQcF/WE26JO0DURwoCkY9xYy/Ry1xQIvL60R9tXXrbYnKsmdvXF0O8vaNbU+Te8RQOfT+b/f+hcZlvkOXrP5PyGO8V/ANna1Spgr9AprqVlZZw/iAfNKhJgIJuXw/2bcNIPnEIhKjE5WYxTj0OXhkNTbMLWyHvyep5Lg6y/Ha+IYWdeVE/V5f7rfS2qvLscSfEFNwbMExRkbJAUUq/nWKv/AROFQjrPj0RI0gPMAM6c17cqn3sxE1wV5JUtYMkvY8DI+tmIwDJ5B52ioS4/mzIx4AN9Ka8SlUVpSiupzwiiG1en2TkqOoTdtI+vRwaaNxR8foINo+OpVeQdRtJxu9lLWEhm5/kU4hvrgeWF+cqWwhJb2ZISlMNKoK3Po8V5BLNpJ9yx1wj78lMS6NzM+uJOOdT0Fpuu96se36SpkPXNu4a/GwnKitshRXF1tPri4H2FN6xlDm2FTq2TKYssoLFXd2bv7XUHF+BLyN4FDZMWUL89GeGRJFVp43dP1uWAM4DNK+sXCPJ+N2VWQcMp2Cn/mSxOZt1RPqgpnBTAnt05HMNzsm/dWey9sYnN0nYWEm5dMZ6z306rYON9C6h5Pp74PiyaQTaB50e/rmZ+lQuYNY1xNX7VVKApopbi+J3o1B+wu56AvVPd5OurY9yDx9NRn6jHZprK0Zn+ACqUZKvFFZ0TEhpNeL1De9nbJ1N4FhdOdI2j8ujQa1CVXc2fu3v0QvHF7kkzvrKziSB6zMkAtkgBspXlsa1iTgKB8BqJT7Zxh5HZkeep2CJ3xMQgRPJb4GqeSEYuCjRqSToVU0GRP5c1fawMsKWG2l90926erGBOvpq/vb0mdDWiPI09Hyok2K4d5U4p876y3C9WYy65Te6bPMkCMkiCSEaxsYCijQ8uWjcxzu8ZUjpEvrS+bn/kv6nvwds2tgF5jjj/g3ELR6Oalu8N3tKSra3MDVHZIcTgcR5D2UFqG4sE9kzqbHkQLlznqDbhE1c7AP8dvxF9VIiG3SL0jUgVx+wOEeH/+QhOBwCho9h4LGziMhxBEUcpDIwWL0o9rH3J3glVC1XV2ejrPw7gT69sF21DJET5vhzvb+8RmlY/BGYXBsTXz2AzPkX7wnxI8i0vk3c9wvSFUkZf8R7vFDcM7PKBMqlI7KTg4mKCOK6jiDN+BuEqer2yc+hH56LI3G3xRNFtiHFw8vpl9dR3dWC0yigUYkDmIPi+fqfi0CB5H5jozRJCb/3nHWDYRc8oPDPT67Cmq0OQU9uYhMj8yCHdlI8hXve2fZW/1wfynN6hdHm0YmK8Oqh+HO9ocH9V7ByuvqzmrBhKShznESHnc/rTQ5hOxdsNkjkGSS9gwn+UJgo1FfIbT6DYmd3oLRDyfpwkkEr6dIl+rdUrjjZRa6COno3iIYxJeU3tnXsz9tUg/KHTqGtaYf+s2hYNHIPm9XMCS/RgeAKU9BvOcrA1N7R+Llt6hHbjB4EKzb+yREXovWfQGrpYn75ig2438Brc0taE3vt5QtNNRUMONdLq+jlMEUnjv0OslWkvLeIrlwHgpvfEtSvMB2z5CY8jzsSOP9YPXBBnvagfeVQaH/BaTH3ESLek5XVBWY8QGYMUk9VJchDDCFv77wPhgTThWFJB1fSPK5fxNV+b/ezl8I4V1J6LaQhFCeBNM42IVlRiwvUhzJGwqdoKNeUZ1oImzG0DioXR5CJHoLdH4RqcaQuXRbwBSeio6IjUbhZDRJnF9ZRHJloTp4dQMNIQJYIZo/r+vy0etgf1mBMtHgRkLEX6QxlDrAXoQhAGRAKlhvspr6QSmoBY9vhQtb2u32R3Ahrzu7GYnXJIhgUuPU+BkKQENuvfz1VP6w1xaQ7itsN9aWitrwirComxeCG7D9mSHaIYH41Uj+L+n9Gf8/wNLxs4Rog9e0cntyenq6/uyps32h6gbipJuh8JKgtNiGKN2SEMEKlJ3HsVPQkjnY7pb14sacnByX7ljn1NSOdtmxrMETYJ3mZ+fluV1H0SE1dSx8il+q2RrgutO4bhp2xQ4pqZ87SrVBIEWfVzveRyqwi2JmXFzcvk2bNmlaetyzZ09DxeXL/RB3cj9Pd4HkJNTFE5S5C13Cw7EnhLrlUyjPgcrfZbDbNx461vAbVQ0Y0qlTp1DZap2Cl56MirQPPjjAPRHfY/NOTn5+nS9Cd0hJSRcEsfEuAFk+IxgNPbKyss6qJXXQIaX9uyD+79TsNcjykez8PF54py9Obe9/8CTLJTIJn5BefBONzKWrlpKSEq4n8VlQcRII6e0iTDtusgEN+52s3FzQzIE6fdlpyWn9JastC3ya6QMzGPDA6E4Qfh1a8pfMXLVcO3BfNIgvWELVkhsDQYjBu/xesEn7O6ek1P0CG9AxNfVOAwnZOOc1H5jB0OEmd6MBbwSt/tEzrqfiE9cwpGP79o/AEViHyj1+MxDixq2vHFuP4gw18LBksa1mcVaLvIDQv/jUaY6DAgrEYpA6+dv6CUThfxjjGgLFS4JY50s+HZPbj8E1a8E0jwP8tWjlcVYFaDXqakj5v7kRKgzpkNyhlyzJn0J83BIPlX4jy1Kv2PhW5uy83IiQiHBwVL4db+mY6eUCaD39rpZdflrNegdReA5qTtvqHY1AY9sFO/Or+iknP7cL3m+jeloDgPg1U2RY9cqCvAS08rQwZjnsxW1OWolGg1mW7L3RIJShDldAfYPOFZ0ZL3ILFgT7UhS47STCA83Oyc8bBruww2noMjMzrXiZndn5uSNxhtvvNoEpjX4Bxw1AP+GTtLQ01zMgAojhCj08EFiQ+V8jsc2AQyMyM9yqU9DqDTBheFZe3i4nrWAPLTkFBdtz8vIewQmLlBNdgGklQH+NgMi490pkObdFfKvOnjwOthWI6F1+/IrFNjc3N8eTUcc5pXjJhp8XZcjyHivJd+Tn53O0669R55Gonxy7tSBTMtjv7ltWcFSkgWiMm9JSUx8TSXCsvXMJ+RAaKX991a2KQgPjuUnuGplFgIu4EsR4QC1oAIjeC+D2m2rWZ3hkCMncKJZg1+VCdRxfgNb1FO83mZcFoKFUyAJNPpKXp0zrBK3WgFYNXG4nJJKn49y/qlmfwN+c7aruu4QsCA1bVIAhSNJBEH2Kmm0AMGtSWkrK9flygTvIVCSIwignMxhghkda6QTB7//BUcftdQVZkjQFR/4CEvCRRweBhIUcXKrZ6w94V3ielZCKjbAdCVzE0aMnSJLk+9o4FSJi1Bx13yXQKpqMCFaSJuKlFQNaH3iOUDsJy2FgfZ6JAYO7GYQeVj9BLT2JYy41Ae47EPHGhoSEhGBwxCOtEIRpG6jxAKFjSspEEsQFar4BoEe3wsO6Q826BBt1qUpyaahkg2w9AniM1CV7l+yCAv5+PFzw5B6CqOOZ3y7XNbOTACI1dM+12ZDP4QHxAFwD4B2iJIv1rMu6AajUkYIstwCt/q4WNQCe7XvQapCadQk26oJVcL1s2UgWUTAa/4FWWawWNQAesA8HjWrWJRAAPi/opIOukijJXq1zgHu4Fy9/7dvh9eCOYP5CsFpjUbdb1xc+eEK1JH0Mqrsd8cL1A0Ertw4SQ7DLr7iik5Ls0oe4jyNKRxNYplzhGlUg0u+g59kTqtGTHFmeO316Iq7lf8bo0jfHdSNw3TKtEuJEx5T2K0CFX6vZxqFBQtDwDuOnwScuBEFuIZPwEIjhdlFkzXukpj4Ke8b/tNIlcI8KUZaezsrP53NqxkA43uMgGR7ibGRdMh73+LXCEAZ87NfgcnnujZXl03j6bbiwDFfHYP92VOC2Hwd6eSGi4Im87y1DbmrTppnFYNyHe2gLDK+D2+sEiHzRYre1O3r0qPJVZTSWWWgsHhfK45pT+OVvjfGE4uZg4u3Yuv1EBWg1F7SaUuNlwb17DYQeDz3ofmqGo+8GLUl4AhJxvztmoA4Lfl/CDWpmU3iL/fz/iwTiZcMBJa4PqJYl4TEnMxjZ+bkvgICTsVvpKGkI0CYBdBqu0IqEX6HIHTMQ8MozQCvln1jWcXvZ9RRs+s44gcN7tzfzgEo0jU/IruuKiPUN5NFQfAd3zYiNtMTrBaVRwe2VbMIvjhQcafAvJ0DA9+0CdcYLcuTu9fpqNP4KpCVQb53xnqzGFFrVqKz6SEpKijDqdPciMoSqoW54wra4IhqSwX1eeF75Ki4+j7JjqIWno2aQTrcODpXLL9d3Sk5OkQRdwwib4RhzcDfPSEB0/jK2HtchwA4U48V4NbGI8916Qu6A622yLFyFW30O75VjleVd+fn5mpbqdm3dOtJuDL4XBO4HWnQDLVjNRtWllVCM48dAywOgWYZoMKzPysqqN9We6P8AbFxsAFV7KbIAAAAASUVORK5CYII="

/***/ }),

/***/ "rEDR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_items_js__ = __webpack_require__("EcaT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd4014a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_items_vue__ = __webpack_require__("civT");
function injectStyle (ssrContext) {
  __webpack_require__("G4zp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_items_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd4014a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_items_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rEh3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-loader"},[_c('div',{staticClass:"notification-loader__avatar"},[_c('div',{staticClass:"notification-loader__avatar-circle"})]),_vm._v(" "),_c('div',{staticClass:"notification-loader__content"},[_c('div',{staticClass:"notification-loader__text-1"}),_vm._v(" "),_c('div',{staticClass:"notification-loader__text-2"}),_vm._v(" "),_c('div',{staticClass:"notification-loader__text-3"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rFhE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLayoutMobile)?_c('router-link',{staticClass:"insight-link__link",attrs:{"to":_vm.href}},[_c('div',{staticClass:"insight-link__content"},[_vm._v("\r\n      "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"insight-link__date"},[_vm._v(_vm._s(_vm.date))])])]):_c('a',{staticClass:"insight-link__link",attrs:{"href":_vm.url,"target":"_blank"}},[_c('div',{staticClass:"insight-link__content"},[_vm._v("\r\n      "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"insight-link__date"},[_vm._v(_vm._s(_vm.date))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rGOk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-book-prices"},[_c('div',{class:_vm.tableModifiers},[_c('div',{staticClass:"order-book__header row"},[_c('div',{class:_vm.leftSideHeaderModifiers},[_vm._v(_vm._s(_vm.operationTypeLeftText)+" "+_vm._s(_vm.operationValueText))]),_vm._v(" "),_c('div',{class:_vm.rightSideHeaderModifiers},[_vm._v(_vm._s(_vm.operationTypeRightText)+" "+_vm._s(_vm.operationValueRightText))])]),_vm._v(" "),(_vm.leftPricesUnavailable || _vm.rightPricesUnavailable)?_c('div',{staticClass:"row"},[(_vm.leftPricesUnavailable)?[(_vm.pricesGrouped.length === 0)?_c('div',{staticClass:"column small-6 order-book__header-cell order-book__header-cell--unavailable"}):_vm._e(),_vm._v(" "),_c('div',{class:_vm.leftSideNoOffersModifiers},[_vm._v("No offers available")])]:_vm._e(),_vm._v(" "),(_vm.rightPricesUnavailable)?[(_vm.pricesGrouped.length === 0)?_c('div',{staticClass:"column small-6 order-book__header-cell order-book__header-cell--unavailable"}):_vm._e(),_vm._v(" "),_c('div',{class:_vm.rightSideNoOffersModifiers},[_vm._v("No offers available")])]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"order-book__body"},_vm._l((_vm.pricesGrouped),function(item,index){return _c('div',{staticClass:"row"},[(_vm.leftPricesUnavailable)?[_c('div',{staticClass:"column small-6 order-book__body-cell order-book__body-cell--unavailable"})]:[_c('div',{staticClass:"column small-3 order-book__body-cell order-book__body-cell--highlight",class:_vm.hoverQuantityClassModifier(item.buyOwned, index, 'left'),on:{"mouseover":function($event){return _vm.onMouseOver(index, 'left')},"mouseleave":function($event){return _vm.onMouseLeave('left')},"click":function($event){return _vm.onClick(item, item.buyOwned, 'left')}}},[_vm._v(_vm._s(item.buyPrice)),(item.buyPrice)?_c('span',[_vm._v("¢")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column small-3 order-book__body-cell",class:_vm.hoverQuantityClassModifier(item.buyOwned, index, 'left'),on:{"mouseover":function($event){return _vm.onMouseOver(index, 'left')},"mouseleave":function($event){return _vm.onMouseLeave('left')},"click":function($event){return _vm.onClick(item, item.buyOwned, 'left')}}},[(item.buyQuantity)?[_vm._v(_vm._s(item.buyQuantity.toLocaleString()))]:[_vm._v(" ")]],2)],_vm._v(" "),(_vm.rightPricesUnavailable)?[_c('div',{staticClass:"column small-6 order-book__body-cell order-book__body-cell--unavailable"})]:[_c('div',{staticClass:"column small-3 order-book__body-cell order-book__body-cell--highlight",class:_vm.hoverQuantityClassModifier(item.sellOwned, index, 'right'),on:{"mouseover":function($event){return _vm.onMouseOver(index, 'right')},"mouseleave":function($event){return _vm.onMouseLeave('right')},"click":function($event){return _vm.onClick(item, item.sellOwned, 'right')}}},[_vm._v(_vm._s(item.sellPrice)),(item.sellPrice)?_c('span',[_vm._v("¢")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column small-3 order-book__body-cell",class:_vm.hoverQuantityClassModifier(item.sellOwned, index, 'right'),on:{"mouseover":function($event){return _vm.onMouseOver(index, 'right')},"mouseleave":function($event){return _vm.onMouseLeave('right')},"click":function($event){return _vm.onClick(item, item.sellOwned, 'right')}}},[(item.sellQuantity)?[_vm._v(_vm._s(item.sellQuantity.toLocaleString()))]:[_vm._v(" ")]],2)]],2)}),0)]),_vm._v(" "),(_vm.pricesOwned)?_c('div',{staticClass:"order-book__footer"},[_c('div',{staticClass:"order-book__footer-cell"},[_vm._v("\n        Tap on prices in blue to see sequence of your open offers\n      ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rLrd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rNZt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_pending_requests_deposits_js__ = __webpack_require__("nyTk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_732533c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_requests_deposits_vue__ = __webpack_require__("1zZw");
function injectStyle (ssrContext) {
  __webpack_require__("YYg9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_pending_requests_deposits_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_732533c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_requests_deposits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rQvC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rWm4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




var DATE_FORMAT = 'MM/DD/YYYY';

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    slim: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true,
      default: []
    }
  },
  computed: {
    tableModifiers: function tableModifiers() {
      return {
        'order-book__table': true,
        'order-book__table--slim': this.slim
      };
    },
    shares: function shares() {
      return this.items.map(function (s) {
        var shares = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, s, {
          pricePerShare: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["j" /* toCents */])(s.pricePerShare),
          dateExecuted: __WEBPACK_IMPORTED_MODULE_2_moment___default()(s.dateExecuted).format(DATE_FORMAT)
        });
        return shares;
      });
    }
  }
});

/***/ }),

/***/ "rbjD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_watch_market_watch_vue__ = __webpack_require__("lkXP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("oiih");





var marketHeaderMixin = {
  components: {
    marketWatch: __WEBPACK_IMPORTED_MODULE_2__components_market_market_watch_market_watch_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    watchIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('browse', ['currentStoryDetail']), {
    isMarketWithinStory: function isMarketWithinStory() {
      return this.currentStoryDetail !== null;
    },
    watchIconVisible: function watchIconVisible() {
      var statuses = [__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].MARKET_EXPIRED, __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].MARKET_SETTLED];
      return this.watchIcon && this.isLoggedIn && !statuses.includes(this.market.status);
    }
  })
};

/* harmony default export */ __webpack_exports__["a"] = (marketHeaderMixin);

/***/ }),

/***/ "rdUu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_withdraw_js__ = __webpack_require__("dstN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d71c91d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_withdraw_vue__ = __webpack_require__("Msc9");
function injectStyle (ssrContext) {
  __webpack_require__("PTlq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_withdraw_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d71c91d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_withdraw_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "re9M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "reBV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rfGX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rium":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rixl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rjQl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_news_js__ = __webpack_require__("cT9C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f9fe258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_news_vue__ = __webpack_require__("0KCx");
function injectStyle (ssrContext) {
  __webpack_require__("JDJa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_news_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f9fe258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_news_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rkCW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rmwD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('h2',{staticClass:"research-widget__title"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"research-widget__content"},[(_vm.shutdown)?[_c('p',{staticClass:"research-widget__para"},[_vm._v("\n        PredictIt started as a project of Victoria University of Wellington, to facilitate research into the way markets forecast events. Now through our application as a federally regulated Event Market platform we are expanding into markets beyond politics.\n      ")]),_vm._v(" "),_c('p',{staticClass:"research-widget__para"},[_vm._v("\n        We are excited for this transition and hope you follow us on Twitter to learn more about future market launches.\n      ")]),_vm._v(" "),_c('button',{staticClass:"button button--medium button--submit",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v("Learn More")])]:[_c('p',{staticClass:"research-widget__para"},[_vm._v("\n        A project of the Prediction Market Research Consortium, PredictIt has been established to facilitate research into the way markets forecast events.\n      ")]),_vm._v(" "),_c('p',{staticClass:"research-widget__para"},[_vm._v("\n        In order to enable researchers to take advantage of the opportunities presented by prediction markets, we make our data available to the academic community at no cost.\n      ")]),_vm._v(" "),_c('div',{staticClass:"research-widget__button"},[_c('button',{staticClass:"button button--medium button--submit",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v("Learn More")])])]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rmxY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textarea",class:_vm.textAreaModifiers},[_c('label',{staticClass:"textarea__label",attrs:{"for":_vm.name}},[_c('div',{staticClass:"textarea__placeholder"},[_vm._v(_vm._s(_vm.placeholder)),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('textarea',{staticClass:"textarea__value",attrs:{"disabled":_vm.disabled,"name":_vm.name,"id":_vm.name,"maxlenght":_vm.maxLength},domProps:{"value":_vm.value},on:{"input":_vm.updateValue,"blur":_vm.handleBlur,"focus":_vm.handleFocus}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rpQZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rrO7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollTo;
/* eslint-disable */
function scrollTo(destination) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'linear';
  var callback = arguments[3];


  var easings = {
    linear: function linear(t) {
      return t;
    },
    easeInQuad: function easeInQuad(t) {
      return t * t;
    },
    easeOutQuad: function easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad: function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic: function easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic: function easeOutCubic(t) {
      return --t * t * t + 1;
    },
    easeInOutCubic: function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart: function easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart: function easeOutQuart(t) {
      return 1 - --t * t * t * t;
    },
    easeInOutQuart: function easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    easeInQuint: function easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint: function easeOutQuint(t) {
      return 1 + --t * t * t * t * t;
    },
    easeInOutQuint: function easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    }
  };

  var start = window.pageYOffset;
  var prevPageYOffset = start;
  var scrollCheckCount = 5;
  var startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

  var documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
  var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
  var destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
  var destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

  if ('requestAnimationFrame' in window === false) {
    window.scroll(0, destinationOffsetToScroll);
    if (callback) {
      callback();
    }
    return;
  }

  function scroll() {
    var now = 'now' in window.performance ? performance.now() : new Date().getTime();
    var time = Math.min(1, (now - startTime) / duration);
    var timeFunction = easings[easing](time);
    window.scroll(0, Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start));

    if (prevPageYOffset === window.pageYOffset) {
      scrollCheckCount--;
    }
    if (window.pageYOffset === destinationOffsetToScroll || scrollCheckCount < 0) {
      if (callback) {
        callback();
      }
      return;
    }

    prevPageYOffset = window.pageYOffset;
    requestAnimationFrame(scroll);
  }

  scroll();
}

/***/ }),

/***/ "rrgr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rtSD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public-profile-widget"},[_c('div',{staticClass:"public-profile-widget__title"},[_c('span',{staticClass:"public-profile-widget__title-text"},[_vm._v("Public Profile")]),_vm._v(" "),_c('div',{staticClass:"public-profile-widget__title-icon",on:{"click":function($event){$event.stopPropagation();return _vm.onInfoClick($event)}}})]),_vm._v(" "),_c('div',{staticClass:"public-profile-widget__section"},[_c('div',{staticClass:"public-profile-widget__section-title"},[_c('div',{staticClass:"public-profile-widget__section-title-prefix"},[_vm._v("\r\n        College Affiliation\r\n      ")]),_vm._v(" "),(_vm.isUCAffilSet === false)?_c('div',{staticClass:"public-profile-widget__info"},[_vm._v("\r\n        Not Affiliated\r\n      ")]):(_vm.userAffiliations.length === 0)?_c('div',{staticClass:"public-profile-widget__info"},[_vm._v("\r\n        No Affiliations Specified\r\n      ")]):_vm._e()]),_vm._v(" "),(_vm.userAffiliations.length > 0)?_c('div',{staticClass:"public-profile-widget__items"},_vm._l((_vm.userAffiliations),function(item){return _c('div',[_vm._v("\r\n        "+_vm._s(item.name)),(item.isPendingApproval)?_c('span',[_vm._v(" (Pending)")]):_vm._e(),(!item.isPublic)?_c('span',[_vm._v(" *")]):_vm._e()])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"public-profile-widget__note"},[_c('span',{staticClass:"public-profile-widget__link",on:{"click":_vm.showAffiliationsPopup}},[_vm._v("Edit")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rtt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rxGt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("8/3H");



/* harmony default export */ __webpack_exports__["a"] = (function (response) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* checkResponseForMaintenance */])(response);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* checkResponseForTaxInfo */])(response);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* checkResponseForDocumentUpload */])(response);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* checkResponseVersion */])(response);
  __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].info('API - SUCCESS', response.status, response.config.method, response.config.url, response);
  return response;
});

/***/ }),

/***/ "rzQJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_purchase_purchase_offer_purchase_offer_vue__ = __webpack_require__("GBcl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_purchase_purchase_offer_desktop_purchase_offer_desktop_vue__ = __webpack_require__("kdSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_purchase_purchase_yes_no_switcher_purchase_yes_no_switcher_vue__ = __webpack_require__("TdoF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_purchase_purchase_review_and_confirm_purchase_review_and_confirm_vue__ = __webpack_require__("6sKT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_notifications_proxy__ = __webpack_require__("a0yF");










/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_loader__["a" /* default */]],
  components: {
    purchaseOffer: __WEBPACK_IMPORTED_MODULE_2__components_purchase_purchase_offer_purchase_offer_vue__["a" /* default */],
    purchaseOfferDesktop: __WEBPACK_IMPORTED_MODULE_3__components_purchase_purchase_offer_desktop_purchase_offer_desktop_vue__["a" /* default */],
    purchaseYesNoSwitcher: __WEBPACK_IMPORTED_MODULE_4__components_purchase_purchase_yes_no_switcher_purchase_yes_no_switcher_vue__["a" /* default */],
    purchaseReviewAndConfirm: __WEBPACK_IMPORTED_MODULE_5__components_purchase_purchase_review_and_confirm_purchase_review_and_confirm_vue__["a" /* default */]
  },
  props: {
    market: {},
    kind: {
      type: String,
      default: 'modal'
    },
    closeJourneyAfterSuccess: {
      type: Boolean,
      default: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('trade', ['tradeOptions', 'tradeSuccess']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    contract: function contract() {
      var _this = this;

      if (!this.tradeOptions.contractId) return null;
      var contracts = this.market.contracts || this.market.marketContracts;
      return contracts.find(function (c) {
        return c.contractId === _this.tradeOptions.contractId;
      });
    },
    payload: function payload() {
      return {
        quantity: this.tradeOptions.quantity,
        pricePerShare: this.tradeOptions.pricePerShare,
        contractId: this.tradeOptions.contractId,
        tradeType: this.tradeType
      };
    },
    tradeType: function tradeType() {
      switch (this.tradeOptions.operationType + '_' + this.tradeOptions.operationValue) {
        case 'buy_no':
          return 0;
        case 'buy_yes':
          return 1;
        case 'sell_no':
          return 2;
        case 'sell_yes':
          return 3;
        default:
          return -1;
      }
    }
  }),
  data: function data() {
    return {
      hasInitialised: false,
      confirmationData: null,
      confirmationDoneData: null
    };
  },

  watch: {
    tradeOptions: {
      handler: 'tradeOptionsHandler',
      immediate: true
    },
    tradeSuccess: function tradeSuccess(value) {
      if (value) {
        this.setCurrentPopup();
        this.$emit('reinitialize');
        // desktop exclusive
        if (this.closeJourneyAfterSuccess) {
          this.setTradeOptions(null);
        }
        this.setTradeSuccess(false);
      }
    },
    confirmationData: function confirmationData() {
      this.$emit('confirmationDataChange', this.confirmationData);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('profile', ['clearTradedMarkets']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('market', ['getContract', 'setMarketEngineBusyMessage']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('trade', ['submitTrade', 'confirmTrade', 'setTradeOptions', 'setTradeQuantity', 'setTradeSuccess']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('notifications', ['addSimple']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    getErrorFromResponse: function getErrorFromResponse(response) {
      if (!response) return '';
      if (typeof response.data === 'string') {
        return response.data;
      }
      return response.data ? response.data.message : '';
    },
    tradeOptionsHandler: function tradeOptionsHandler(tradeOptions) {
      var oldOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (oldOptions.contractId !== tradeOptions.contractId) {
        this.confirmationData = null;
        this.confirmationData = null;
      }
      if (oldOptions.operationValue !== tradeOptions.operationValue || oldOptions.operationType !== tradeOptions.operationType) {
        this.confirmationData = null;
        this.confirmationDoneData = null;
      }
    },
    onClickNext: function onClickNext() {
      var _this2 = this;

      if (this.isLoading) {
        return;
      }

      if (!this.isUserVerified) {
        this.showAccountVerifyPopup();
        return;
      }

      // if (this.isUserBalanceEmpty) {
      //   this.showAddFundsPopup();
      //   return;
      // }

      if (this.tradeOptions.skipConfirmation) {
        this.submitTradeAction();
      } else {
        this.loaderAdd();
        this.confirmTrade(this.payload).then(function (response) {
          _this2.loaderRemove();
          _this2.confirmationDoneData = null;
          _this2.confirmationData = response.data;
          // when quantity is reduced it has to be set
          if (_this2.confirmationData.quantity) {
            _this2.setTradeQuantity(_this2.confirmationData.quantity);
          }
        }).catch(function (error) {
          _this2.loaderRemove();
          var message = _this2.getErrorFromResponse(error.response);
          if (message) {
            _this2.addSimple({
              icon: 'cancel',
              text: message
            });
          }
        });
      }
    },
    submitTradeAction: function submitTradeAction() {
      var _this3 = this;

      this.loaderAdd();
      this.submitTrade(this.payload).then(function (response) {
        var data = response.data;
        _this3.$gtm.trackEvent({ event: 'Trade' });
        _this3.loaderRemove();
        _this3.confirmationData = null;
        _this3.confirmationDoneData = data;
        _this3.addSimple({
          externalId: data.offer ? data.offer.offerId : null,
          closeTimeout: 3500,
          icon: 'pending',
          text: 'Offer received. You will be notified when processing is complete.'
        });
        _this3.setMarketEngineBusyMessage({
          isEngineBusy: data.isEngineBusy,
          isEngineBusyMessage: data.isEngineBusyMessage
        });
        _this3.setTradeSuccess(true);
        _this3.clearTradedMarkets();
        var isBuyTradeType = [0, 1].includes(_this3.tradeType);
        __WEBPACK_IMPORTED_MODULE_8__services_notifications_proxy__["a" /* default */].showMessagingJourney(isBuyTradeType);
      }).catch(function (error) {
        _this3.setTradeSuccess(false);
        _this3.loaderRemove();
        var message = _this3.getErrorFromResponse(error.response);
        if (message) {
          _this3.addSimple({
            icon: 'cancel',
            text: message
          });
        }
      });
    },
    onClickSubmit: function onClickSubmit() {
      this.submitTradeAction();
    },
    onClickAmend: function onClickAmend() {
      this.confirmationData = null;
      this.confirmationDoneData = null;
    }
  })
});

/***/ }),

/***/ "s06T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_set_password_js__ = __webpack_require__("+8fj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_715a71b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_set_password_vue__ = __webpack_require__("x4Jj");
function injectStyle (ssrContext) {
  __webpack_require__("cdg3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_set_password_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_715a71b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_set_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sA4S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_app_header_app_header_new_vue__ = __webpack_require__("siP5");


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    appHeaderNew: __WEBPACK_IMPORTED_MODULE_0__components_app_app_header_app_header_new_vue__["a" /* default */]
  },
  data: function data() {
    return {
      toggled: false,
      value: 10,
      updateValue: 22
    };
  },

  methods: {
    onClick: function onClick() {
      this.value = this.updateValue;
    }
  }
});

/***/ }),

/***/ "sAT+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sB0D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:_vm.checkboxModifiers},[_c('label',{attrs:{"for":_vm.name}},[_c('input',{attrs:{"type":"checkbox","name":_vm.name,"id":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_vm._v(" "),_c('div',{staticClass:"checkbox__tick",class:_vm.classIsChecked}),_vm._v(" "),_c('div',{staticClass:"checkbox__label"},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sBFK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sBpB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_wallet_js__ = __webpack_require__("oTR+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b465f576_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wallet_vue__ = __webpack_require__("j519");
function injectStyle (ssrContext) {
  __webpack_require__("HCbx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_wallet_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b465f576_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wallet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sCGU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "sFJp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-enable-classic-predictit-footer"},[_c('h4',{staticClass:"account-enable-classic-predictit-footer__title"},[_vm._v("\n        Already have an account\n      ")]),_vm._v(" "),_c('a',{staticClass:"account-enable-classic-predictit-footer__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onLogin($event)}}},[_vm._v("\n        Login to My Account\n      ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sIse":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_messaging_journey_info_js__ = __webpack_require__("n/Ch");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_717f775a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_messaging_journey_info_vue__ = __webpack_require__("qGTQ");
function injectStyle (ssrContext) {
  __webpack_require__("mWAA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_messaging_journey_info_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_717f775a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_messaging_journey_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sJdJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_tabs_js__ = __webpack_require__("bvK5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_160c55d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabs_vue__ = __webpack_require__("5/dB");
function injectStyle (ssrContext) {
  __webpack_require__("W9jE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_tabs_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_160c55d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sKk/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_journey_js__ = __webpack_require__("rzQJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d04f2bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_journey_vue__ = __webpack_require__("+i2i");
function injectStyle (ssrContext) {
  __webpack_require__("reBV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_purchase_journey_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d04f2bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_journey_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sLBT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


/* eslint-disable no-restricted-syntax */
function stringifyQuery(obj) {
  var res = obj ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
    var value = obj[key];

    if (value === undefined) {
      return '';
    }

    if (value === null) {
      return encodeURIComponent(key);
    }

    if (Array.isArray(value)) {
      var result = [];
      value.forEach(function (el) {
        if (el === undefined) {
          return;
        }
        if (el === null) {
          result.push(encodeURIComponent(key));
        } else {
          result.push(encodeURIComponent(key) + '=' + encodeURIComponent(el));
        }
      });
      return result.join('&');
    }

    return encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }).filter(function (x) {
    return x.length > 0;
  }).join('&') : null;
  return res ? '?' + res : '';
}

function unserializeQuery(url) {
  var searchParams = url.split('?')[1];
  var result = {};
  if (searchParams !== undefined) {
    var paramParts = searchParams.split('&');
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(paramParts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var part = _step.value;

        var paramValuePair = part.split('=');
        if (paramValuePair.length === 2) {
          result[paramValuePair[0]] = decodeURIComponent(paramValuePair[1]);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  stringifyQuery: stringifyQuery,
  unserializeQuery: unserializeQuery
});

/***/ }),

/***/ "sPnT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__ = __webpack_require__("TLs8");





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_popupPageModeMixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onCreateAccount: function onCreateAccount() {
      if (this.isPage) {
        this.$router.push({ name: 'account-page-register' });
      } else {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].REGISTER);
      }
    }
  })
});

/***/ }),

/***/ "sWg+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-comment",on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.showUserDetails(_vm.comment)}}},[_c('div',{staticClass:"top-comment__avatar"},[_c('account-social-avatar',{attrs:{"avatar":_vm.comment.avatarImage,"showProgress":false,"percentage":100,"showEdit":false,"theme":"markets"}})],1),_vm._v(" "),_c('div',{staticClass:"top-comment__info"},[_c('div',{staticClass:"top-comment__name"},[_vm._v("\r\n        "+_vm._s(_vm.comment.userName)+"\r\n      ")]),_vm._v(" "),(_vm.comment.profitablePredictions)?_c('div',{staticClass:"top-comment__active"},[_vm._v("\r\n        "+_vm._s(_vm.traderLevelDisplay(_vm.comment))+"\r\n      ")]):_vm._e()])]),_vm._v(" "),(_vm.comment.marketTitle)?_c('div',{staticClass:"top-comment__market",domProps:{"innerHTML":_vm._s(_vm.comment.marketTitle)}}):_vm._e(),_vm._v(" "),_c('div',{ref:"text",staticClass:"top-comment__comment",domProps:{"innerHTML":_vm._s(_vm.comment.comment)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sa2z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-history"},[(_vm.isLayoutMobile)?_c('content-header',{staticClass:"content-header--account",attrs:{"title":"History","returnRoute":"profile"}}):_vm._e(),_vm._v(" "),_c('div',{class:_vm.gridRowModifier},[(!_vm.isLayoutMobile)?_c('div',{staticClass:"column large-4 account-history__sticky"},[_c('profile')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column large-8 small-12"},[(_vm.isLayoutMobile)?_c('div',{staticClass:"account-history__tabs"},[_c('tabs',{attrs:{"items":_vm.tabs},on:{"tabChange":_vm.tabChange}})],1):_c('account-desktop-header',{attrs:{"title":"History","showExport":true,"tabs":_vm.tabs,"activeTab":_vm.activeTab},on:{"tabChange":_vm.tabChange,"export":_vm.onExport}}),_vm._v(" "),_c('div',{staticClass:"account-history__content"},[(_vm.showTradesTab)?_c('trades',{key:_vm.tradesKey,attrs:{"showExport":_vm.isLayoutMobile},on:{"export":_vm.onExport}}):_vm._e(),_vm._v(" "),(_vm.showTransactionsTab)?_c('transactions',{key:_vm.transactionsKey,attrs:{"showExport":_vm.isLayoutMobile},on:{"export":_vm.onExport}}):_vm._e()],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sdj+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboards-info-loader"},[_c('div',{staticClass:"leaderboards-info-loader__text"}),_vm._v(" "),_c('div',{staticClass:"leaderboards-info-loader__position"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "shsd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"daily-markets"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"daily-markets__info"},[_vm._v("\n    Access the Market Focus and Daily Markets newsletters to receive comprehensive market insights, news, data analysis, and key indicators at the intersection of politics and prediction markets.\n  ")]),_vm._v(" "),_c('div',{staticClass:"daily-markets__line"}),_vm._v(" "),_c('div',{staticClass:"daily-markets__articles"},_vm._l((_vm.items),function(item){return _c('div',{key:item.link},[_c('router-link',{staticClass:"daily-markets__link",attrs:{"to":_vm.dailyMarketPageLink(item)}},[_vm._v("\n        "+_vm._s(item.title)+"\n      ")])],1)}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"daily-markets__header"},[_c('div',{staticClass:"daily-markets__header-title"},[_vm._v("\n      Newsletters\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "siP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_new_js__ = __webpack_require__("2DHc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10f7192f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_new_vue__ = __webpack_require__("VZMg");
function injectStyle (ssrContext) {
  __webpack_require__("zJ+0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_header_new_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10f7192f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_new_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "smEl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "smaH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flatten__ = __webpack_require__("rCVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_collapsible_panel_collapsible_panel_vue__ = __webpack_require__("NMl0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__news_feed_item_news_feed_item_vue__ = __webpack_require__("RU3U");









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    collapsiblePanel: __WEBPACK_IMPORTED_MODULE_5__components_collapsible_panel_collapsible_panel_vue__["a" /* default */],
    newsFeedItem: __WEBPACK_IMPORTED_MODULE_6__news_feed_item_news_feed_item_vue__["a" /* default */]
  },
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    inOverlay: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    },
    numArticles: {
      type: Number,
      default: 3
    },
    marketId: {
      type: Number,
      default: null
    },
    source: {
      type: Array,
      default: null
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    collapsible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showAllArticles: this.inOverlay,
      feeds: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    classModifiers: function classModifiers() {
      return {
        'news-feed': true,
        'news-feed--collapsible': this.collapsible
      };
    },
    contentClassModifiers: function contentClassModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'news-feed__content': true,
        'news-feed__content--no-more': !this.showMoreButton
      }, 'news-feed__content--' + this.theme, this.theme);
    },
    articles: function articles() {
      try {
        var articles = __WEBPACK_IMPORTED_MODULE_3_lodash_flatten___default()(this.feeds.map(function (feed) {
          return feed.items;
        }));
        var articlesWithoutDuplicates = __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default()(articles, 'id');
        return articlesWithoutDuplicates.sort(function (a, b) {
          return parseInt(b.published, 10) - parseInt(a.published, 10);
        });
      } catch (exc) {
        return [];
      }
    },
    items: function items() {
      return this.showAllArticles ? this.articles : this.articles.slice(0, this.numArticles);
    },
    showMoreButton: function showMoreButton() {
      return !this.showAllArticles && this.numArticles <= this.articles.length;
    },
    showNewsFeed: function showNewsFeed() {
      return this.marketId ? this.items.length > 0 : true;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('popup', ['setGenericPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('insight', ['getFeeds', 'getMarketFeeds']), {
    setupFeeds: function setupFeeds() {
      var _this = this;

      /* if source is passed then feed is not loaded via api calls */
      if (this.source) {
        this.feeds = this.source;
      } else if (this.marketId) {
        this.getMarketFeeds(this.marketId).then(function (data) {
          _this.feeds = data;
        });
      } else {
        this.getFeeds().then(function (data) {
          _this.feeds = data;
        });
      }
    },
    loadMore: function loadMore(e) {
      e.stopPropagation();
      if (this.isLayoutDesktop) {
        this.setGenericPopup({
          name: 'news-feed',
          options: {
            marketId: this.marketId
          }
        });
      } else {
        this.showAllArticles = true;
      }
    }
  }),
  created: function created() {
    this.setupFeeds();
  }
});

/***/ }),

/***/ "sof5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



var DISABLED_GROUPS = ['insights'];

/* harmony default export */ __webpack_exports__["a"] = ({
  metaInfo: function metaInfo() {
    return {
      title: 'Site Map'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('about', ['sitemap']), {
    filteredGroups: function filteredGroups() {
      return this.sitemap.groups.filter(function (group) {
        return !DISABLED_GROUPS.includes(group.name.toLowerCase());
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('about', ['getSitemap'])),
  created: function created() {
    this.getSitemap();
  }
});

/***/ }),

/***/ "srjS":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDEzIDE1Ij4NCiAgICA8cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik02LjQxMyA1LjI2NEwyLjM2Ljc0MmEuOTM4LjkzOCAwIDAgMC0uNzI1LS4zMzNjLS4yOCAwLS41MjMuMTEtLjczMy4zMzNsLS42MDQuNjczQTEuMjI0IDEuMjI0IDAgMCAwIDAgMi4yMzNjMCAuMzE4LjEuNTg3LjI5OC44MDlsMy45MTQgNC4zNjctMy45MTQgNC4zNjdhMS4xNjkgMS4xNjkgMCAwIDAtLjI5OC44MDljMCAuMzExLjEuNTg0LjI5OC44MThsLjYwNC42NjVhLjk1MS45NTEgMCAwIDAgLjczMy4zNDFjLjI5IDAgLjUzMi0uMTE0LjcyNS0uMzQxbDQuMDQ1LTQuNTE0IDQuMDUzIDQuNTIyYy4xOTkuMjIyLjQ0LjMzMy43MjUuMzMzLjI4IDAgLjUyNC0uMTEuNzMzLS4zMzNsLjYwNC0uNjczYy4xOTktLjIzNC4yOTgtLjUwNy4yOTgtLjgxOCAwLS4zMTgtLjEtLjU4Ny0uMjk4LS44MDlMOC42MDYgNy40MWwzLjkxNC00LjM2N2MuMTk5LS4yMjIuMjk4LS40OTEuMjk4LS44MDkgMC0uMzExLS4xLS41ODQtLjI5OC0uODE4TDExLjkxNi43NWEuOTUxLjk1MSAwIDAgMC0uNzMzLS4zNDEuOTEyLjkxMiAwIDAgMC0uNzI1LjM0MUw2LjQxMyA1LjI2NHoiLz4NCjwvc3ZnPg=="

/***/ }),

/***/ "ssm7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"learn-the-basics"},[_c('div',{class:_vm.mainRowModifiers},[_c('div',{staticClass:"column small-12"},[(_vm.isLayoutMobile)?_c('content-header',{attrs:{"title":_vm.title}}):_c('div',{staticClass:"learn-the-basics__desktop-header"},[_c('router-link',{staticClass:"learn-the-basics__back",attrs:{"to":{name: 'HelpAndSupport'},"tag":"span"}},[_vm._v("\r\n          Help and Support\r\n        ")])],1)],1),_vm._v(" "),_c('div',{class:_vm.mainColumnModifiers},[_vm._l((_vm.topics),function(item){return [_c('div',{staticClass:"learn-the-basics__header"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),(item.text)?_c('div',{staticClass:"learn-the-basics__desc"},[_vm._v(_vm._s(item.text))]):_vm._e()]}),_vm._v(" "),_c('div',{staticClass:"what-is-predictit__content",domProps:{"innerHTML":_vm._s(_vm.content)}})],2),_vm._v(" "),(_vm.showVideos)?_c('div',{staticClass:"column large-4"},[_c('videos',{attrs:{"asWidget":true}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "swNj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.isColumnCountExceeding)?_c('alert-box',{staticClass:"page-story-preview__box",attrs:{"level":"warning"}},[_vm._v("\n    Column setup appears to be invalid (either exceeds 100% or content column broke to next row).\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row row-xy"},[_c('div',{staticClass:"column small-12 medium-4"},[_c('form-select',{attrs:{"searchable":true,"placeholder":"Left Column","options":_vm.COLUMN_OPTIONS,"track-by":"value","label":"label"},model:{value:(_vm.columnChoice.left),callback:function ($$v) {_vm.$set(_vm.columnChoice, "left", $$v)},expression:"columnChoice.left"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4"},[_c('form-select',{attrs:{"searchable":true,"placeholder":"Preview","options":_vm.TYPE_OPTIONS,"track-by":"value","label":"label"},model:{value:(_vm.typeChoice),callback:function ($$v) {_vm.typeChoice=$$v},expression:"typeChoice"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-4"},[_c('form-select',{attrs:{"searchable":true,"placeholder":"Right Column","options":_vm.COLUMN_OPTIONS,"track-by":"value","label":"label"},model:{value:(_vm.columnChoice.right),callback:function ($$v) {_vm.$set(_vm.columnChoice, "right", $$v)},expression:"columnChoice.right"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{class:_vm.leftColumnClasses},[_vm._v("\n       \n    ")]),_vm._v(" "),_c('div',{class:_vm.middleColumnClasses,domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),_c('div',{class:_vm.rightColumnClasses},[_vm._v("\n       \n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "szK9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t3+b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_refine_history_js__ = __webpack_require__("aNYI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16323cae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refine_history_vue__ = __webpack_require__("9aIe");
function injectStyle (ssrContext) {
  __webpack_require__("bK7s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_refine_history_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16323cae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refine_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t45u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isOfferMatched;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__ = __webpack_require__("a0yF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");

/* eslint-disable max-len */



function isOfferMatched(data) {
  return data.History !== null && data.History.length > 0 && data.Offer.RemainingQuantity === 0;
}

/* harmony default export */ __webpack_exports__["b"] = ({
  namespaced: true,
  state: {
    notificationList: [],
    sideNotificationLevel: '',
    sideNotificationText: '',
    sideNotificationOnCloseCallback: null,
    lastConfirmedContractData: {},
    showNotificationsWidget: false
  },
  mutations: {
    add: function add(state, notification) {
      notification.index = new Date().getTime() + Math.floor(Math.random() * 10000);
      state.notificationList.push(notification);
    },
    remove: function remove(state, index) {
      var target = state.notificationList.find(function (i) {
        return i.index === index;
      });
      var indexToSlice = state.notificationList.indexOf(target);
      if (indexToSlice === -1) return;
      var firstSlice = state.notificationList.slice(0, indexToSlice);
      var secondSlice = state.notificationList.slice(indexToSlice + 1);
      state.notificationList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(firstSlice), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(secondSlice));
    },
    clear: function clear(state) {
      state.notificationList = [];
    },
    setSideNotification: function setSideNotification(state, _ref) {
      var text = _ref.text,
          level = _ref.level,
          onCloseCallback = _ref.onCloseCallback;

      state.sideNotificationLevel = level;
      state.sideNotificationText = text;
      state.sideNotificationOnCloseCallback = onCloseCallback;
    },
    clearSideNotification: function clearSideNotification(state) {
      state.sideNotificationLevel = '';
      state.sideNotificationText = '';
      state.sideNotificationOnCloseCallback = null;
    },
    setLastConfirmedContractData: function setLastConfirmedContractData(state, payload) {
      state.lastConfirmedContractData = payload;
    },
    toggleNotificationsWidget: function toggleNotificationsWidget(state) {
      state.showNotificationsWidget = !state.showNotificationsWidget;
    },
    closeNotificationsWidget: function closeNotificationsWidget(state) {
      state.showNotificationsWidget = false;
    }
  },
  actions: {
    add: function add(_ref2, notification) {
      var commit = _ref2.commit,
          state = _ref2.state;

      if (notification.type === __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["j" /* NOTIFICATION_TRADE_CONFIRMED */]) {
        setTimeout(function () {
          commit('add', notification);
          commit('setLastConfirmedContractData', {
            id: notification.data.ContractId,
            matched: isOfferMatched(notification.data)
          });
          if (notification.data && notification.data.Offer && notification.data.Offer.OfferId) {
            var associatedNotification = state.notificationList.filter(function (i) {
              return i.type === 'simple';
            }).find(function (i) {
              return i.externalId === notification.data.Offer.OfferId;
            });

            if (!associatedNotification) return;
            commit('remove', associatedNotification.index);
          }
        }, __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["m" /* NOTIFICATION_TRADE_CONFIRMED_DELAY */]);
      } else if (notification.type === __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["k" /* NOTIFICATION_SHARES_TRADES */]) {
        commit('setLastConfirmedContractData', {
          id: notification.data.contentJson.ContractId,
          matched: true
        });
        commit('add', notification);
      } else if (__WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["n" /* ALLOWED_NOTIFICATION_TYPES */].includes(notification.type)) {
        commit('add', notification);
      }
    },
    remove: function remove(_ref3, notificationIndex) {
      var commit = _ref3.commit;

      commit('remove', notificationIndex);
    },
    clear: function clear(_ref4) {
      var commit = _ref4.commit;

      commit('clear');
    },
    addSimple: function addSimple(_ref5, _ref6) {
      var commit = _ref5.commit;
      var icon = _ref6.icon,
          text = _ref6.text,
          _ref6$externalId = _ref6.externalId,
          externalId = _ref6$externalId === undefined ? null : _ref6$externalId,
          _ref6$closeTimeout = _ref6.closeTimeout,
          closeTimeout = _ref6$closeTimeout === undefined ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DEFAULT_NOTIFICATION_CLOSE_TIMEOUT : _ref6$closeTimeout;

      var notification = {
        method: null,
        type: 'simple',
        externalId: externalId,
        data: {
          icon: icon,
          text: text,
          closeTimeout: closeTimeout
        }
      };
      commit('add', notification);
    },
    setSideNotification: function setSideNotification(_ref7, _ref8) {
      var commit = _ref7.commit;
      var text = _ref8.text,
          level = _ref8.level;

      commit('setSideNotification', { text: text, level: level });
    },
    setSuccessSideNotification: function setSuccessSideNotification(_ref9, text) {
      var commit = _ref9.commit;

      commit('setSideNotification', { text: text, level: 'success' });
    },
    setSuccessSideNotificationWithTimeoutCallback: function setSuccessSideNotificationWithTimeoutCallback(_ref10, _ref11) {
      var _this = this;

      var commit = _ref10.commit;
      var text = _ref11.text,
          _ref11$callback = _ref11.callback,
          callback = _ref11$callback === undefined ? function () {} : _ref11$callback;

      var callBackApplied = false;
      var timeout = setTimeout(function () {
        callBackApplied = true;
        callback.apply(_this);
      }, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT);
      commit('setSideNotification', {
        text: text,
        level: 'success',
        onCloseCallback: function onCloseCallback() {
          if (!callBackApplied) {
            clearTimeout(timeout);
            callback.apply(_this);
          }
        }
      });
    },
    setErrorSideNotification: function setErrorSideNotification(_ref12, text) {
      var commit = _ref12.commit;

      commit('setSideNotification', { text: text, level: 'danger' });
    },
    clearSideNotification: function clearSideNotification(_ref13) {
      var commit = _ref13.commit;

      commit('clearSideNotification');
    },
    toggleNotificationsWidget: function toggleNotificationsWidget(_ref14) {
      var commit = _ref14.commit;

      commit('toggleNotificationsWidget');
    },
    closeNotificationsWidget: function closeNotificationsWidget(_ref15) {
      var commit = _ref15.commit;

      commit('closeNotificationsWidget');
    }
  }
});

/***/ }),

/***/ "t4XB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trades"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12"},[_c('history-filters',{attrs:{"recent":_vm.recent,"isOpen":_vm.isOpen,"markets":_vm.tradedMarkets},model:{value:(_vm.activeFilter),callback:function ($$v) {_vm.activeFilter=$$v},expression:"activeFilter"}})],1),_vm._v(" "),(_vm.showMessage)?_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"trades__message"},[(_vm.$route.query.contractId)?[_vm._v("\r\n          Click "),_c('strong',[_c('router-link',{attrs:{"to":{ name: 'account-history', params: { marketId: _vm.market.marketId } }}},[_vm._v("here")])],1),_vm._v(" to see your History in all Contracts.\r\n        ")]:[_vm._v("\r\n          To see your History in an individual Contract, click on the Contract name.\r\n        ")]],2)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isOpen),expression:"!isOpen"}],staticClass:"column small-12"},[_c('contracts-history',{attrs:{"contracts":_vm.filteredContracts,"showMarketNames":_vm.showMarketNames,"canLoadMore":_vm.canLoadMore},on:{"loading":_vm.loadHistory}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t5ec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyboard-numeric-input-wrap",on:{"click":function($event){$event.stopPropagation();return _vm.click($event)}}},[_c('div',{staticClass:"keyboard-numeric-input",class:_vm.selectedModifier,domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),(_vm.symbol)?[_c('span',{staticClass:"keyboard-numeric-input__symbol"},[_vm._v("\n      ¢\n    ")])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t71M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_bank_transfer_js__ = __webpack_require__("ooVM");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_bank_transfer_js__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_bank_transfer_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee67f6e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_bank_transfer_vue__ = __webpack_require__("I0mR");
function injectStyle (ssrContext) {
  __webpack_require__("28H6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_add_funds_bank_transfer_js__["c" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee67f6e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_funds_bank_transfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["c"] = (Component.exports);


/***/ }),

/***/ "tCjQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tE+S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_market_market_filters_market_filters_mixin_market_filters_mixin__ = __webpack_require__("kGlu");


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_market_market_filters_market_filters_mixin_market_filters_mixin__["a" /* default */]],
  computed: {
    orderMenuName: function orderMenuName() {
      return this.selectedOrder.name;
    },
    mainClassName: function mainClassName() {
      return 'market-filters-mobile';
    },
    orderButtonTheme: function orderButtonTheme() {
      return this.ordersOpen ? 'dark' : 'dark';
    },
    filtersButtonTheme: function filtersButtonTheme() {
      return this.shouldShowTimespanFilter && !this.filtersOpen ? 'dark' : 'dark';
    },
    timespansButtonTheme: function timespansButtonTheme() {
      return this.shouldShowTimespanFilter && !this.timespansOpen ? 'dark' : 'dark';
    },
    menuClassModifier: function menuClassModifier() {
      return {
        'market-filters-mobile__menu': true,
        'market-filters-mobile__menu--with-timespan-filter': this.shouldShowTimespanFilter
      };
    }
  }
});

/***/ }),

/***/ "tGWZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_profile_profile_vue__ = __webpack_require__("lmGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    contentHeader: __WEBPACK_IMPORTED_MODULE_3__components_generics_content_header_content_header_vue__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_2__components_account_profile_profile_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), {
    gridRowModifier: function gridRowModifier() {
      return {
        row: this.isLayoutMobile,
        'row-x': !this.isLayoutMobile
      };
    }
  })
});

/***/ }),

/***/ "tI6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{staticClass:"account-address-update form content-header__section-group",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('br'),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[(_vm.countries.length > 1)?_c('form-select',{attrs:{"searchable":_vm.isLayoutDesktop,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.country,"placeholder":"Country","options":_vm.countries,"track-by":"value","label":"label","required":true},on:{"input":_vm.$v.fields.country.$touch},model:{value:(_vm.fields.country),callback:function ($$v) {_vm.$set(_vm.fields, "country", $$v)},expression:"fields.country"}}):_c('form-input',{attrs:{"tabindex":8,"name":"country","placeholder":"Country","track-by":"value","label":"label","gtm":"ID Verification,Country","disabled":true},model:{value:(_vm.fields.country.label),callback:function ($$v) {_vm.$set(_vm.fields.country, "label", $$v)},expression:"fields.country.label"}})],1),_vm._v(" "),_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.address,"name":"street","type":"text","required":true,"autocomplete":"street-address","placeholder":"House/Number/Street name"},on:{"input":_vm.$v.fields.address.$touch},model:{value:(_vm.fields.address),callback:function ($$v) {_vm.$set(_vm.fields, "address", $$v)},expression:"fields.address"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-6 column"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.city,"name":"city","type":"text","required":true,"autocomplete":"address-line1","placeholder":"Town/City"},on:{"input":_vm.$v.fields.city.$touch},model:{value:(_vm.fields.city),callback:function ($$v) {_vm.$set(_vm.fields, "city", $$v)},expression:"fields.city"}})],1),_vm._v(" "),_c('div',{staticClass:"small-6 column"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.zipCode,"name":"zipCode","type":"text","required":_vm.fields.country.required,"autocomplete":"postal-code","placeholder":"Zip/Postal Code"},on:{"input":_vm.$v.fields.zipCode.$touch},model:{value:(_vm.fields.zipCode),callback:function ($$v) {_vm.$set(_vm.fields, "zipCode", $$v)},expression:"fields.zipCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"account-address-update__buttons"},[_c('form-submit',{attrs:{"disabled":_vm.isSubmitButtonDisabled,"label":"Next"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tLgC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-small",class:_vm.classModifier},[(_vm.overlay)?_c('div',{staticClass:"modal-small__overlay",on:{"click":_vm.close}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-small__wrap"},[_c('div',{staticClass:"modal-small__header"},[_vm._t("header"),_vm._v(" "),(_vm.closeButton)?_c('button',{staticClass:"modal-small__close",on:{"click":_vm.close}}):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"modal-small__content"},[_vm._t("content")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tPuv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_item_v2_js__ = __webpack_require__("gwUB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e59b068_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_item_v2_vue__ = __webpack_require__("0Gi+");
function injectStyle (ssrContext) {
  __webpack_require__("hfa6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_list_item_v2_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e59b068_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_list_item_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tQ/B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_market_market_filters_market_filters_mixin_market_filters_mixin__ = __webpack_require__("kGlu");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_market_market_filters_market_filters_mixin_market_filters_mixin__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('watchlist', ['selectedOrder', 'selectedTimespan', 'shouldShowTimespanFilter']), {
    orderMenuName: function orderMenuName() {
      return this.selectedOrder.name;
    },
    mainClassName: function mainClassName() {
      return 'market-filters-mobile-watchlist';
    },
    orderButtonTheme: function orderButtonTheme() {
      return this.ordersOpen ? 'dark' : 'dark';
    },
    filtersButtonTheme: function filtersButtonTheme() {
      return this.shouldShowTimespanFilter && !this.filtersOpen ? 'dark' : 'dark';
    },
    timespansButtonTheme: function timespansButtonTheme() {
      return this.shouldShowTimespanFilter && !this.timespansOpen ? 'dark' : 'dark';
    },
    menuClassModifier: function menuClassModifier() {
      return {
        'market-filters-mobile-watchlist__menu': true,
        'market-filters-mobile-watchlist__menu--with-timespan-filter': this.shouldShowTimespanFilter
      };
    }
  }),
  created: function created() {
    this.isWatchlistOpen = true;
  }
});

/***/ }),

/***/ "tQfv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_shuffle__ = __webpack_require__("yG5q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_shuffle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_collapsible_panel_collapsible_panel_vue__ = __webpack_require__("NMl0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_twitter_twitter__ = __webpack_require__("tWDM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_cms_account_combined_login_account_combined_login_vue__ = __webpack_require__("7GI3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_cms_market_list_item_v2_embed_market_list_item_v2_embed_vue__ = __webpack_require__("JSpR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_cms_market_contract_list_v2_embed_market_contract_list_v2_embed_vue__ = __webpack_require__("KsCZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_generics_link_link_vue__ = __webpack_require__("dxV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_market_market_detail_charts_market_detail_charts_vue__ = __webpack_require__("1P9U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_home_home_old_podcasts_podcasts_vue__ = __webpack_require__("QrTx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store__ = __webpack_require__("IcnI");




 /* eslint-disable */














var LoginComponent = __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_10__components_cms_account_combined_login_account_combined_login_vue__["a" /* default */]);
var CollapsiblePanelComponent = __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_7__components_collapsible_panel_collapsible_panel_vue__["a" /* default */]);
var MarketListItemEmbedComponent = __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_11__components_cms_market_list_item_v2_embed_market_list_item_v2_embed_vue__["a" /* default */]);
var MarketContractListEmbedComponent = __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_12__components_cms_market_contract_list_v2_embed_market_contract_list_v2_embed_vue__["a" /* default */]);
var LinkComponent = __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_13__components_generics_link_link_vue__["a" /* default */]);
var PodcastsComponent = __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_15__components_home_home_old_podcasts_podcasts_vue__["a" /* default */]);
var MarketChartsComponent = __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_14__components_market_market_detail_charts_market_detail_charts_vue__["a" /* default */]);

var dateGoDisplay = function dateGoDisplay(dt) {
  var daysDiff = __WEBPACK_IMPORTED_MODULE_5_moment___default()().diff(dt, 'days');
  var hoursDiff = __WEBPACK_IMPORTED_MODULE_5_moment___default()().diff(dt, 'hours');
  if (daysDiff > 365) {
    var years = Math.floor(daysDiff / 365);
    return years === 1 ? '1 year ago' : years + ' years ago';
  } else if (daysDiff > 30) {
    var months = Math.floor(daysDiff / 30);
    return months === 1 ? '1 month ago' : months + ' months ago';
  } else if (hoursDiff > 24) {
    return daysDiff === 1 ? '1 day ago' : daysDiff + ' days ago';
  } else if (hoursDiff >= 1) {
    return hoursDiff === 1 ? '1 hour ago' : Math.floor(hoursDiff) + ' hours ago';
  }
  return 'Within the last hour';
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      content: '',
      marketTileMarkets: [],
      contractListMarkets: [],
      cmsAccordionContentObjects: [],
      podcastItemContentObjects: [],
      chartWidgetObjects: []
    };
  },

  methods: {
    installAccordions: function installAccordions() {
      var _this = this;

      var accordionHeaders = this.$el.querySelectorAll('.predictit__accordion');

      var _loop = function _loop(el) {
        var index = parseInt(el.getAttribute('data-accordionindex'), 10);
        var title = el.getAttribute('data-accordiontitle');
        var accordionObj = _this.cmsAccordionContentObjects.find(function (i) {
          return i.accordionIndex === index;
        });

        if (accordionObj) {
          var content = accordionObj.content || '';
          var instance = new CollapsiblePanelComponent({
            parent: _this,
            propsData: {
              title: title,
              content: content,
              isOpen: accordionObj.isOpenByDefault
            }
          });
          instance.$mount(el);
        }
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(accordionHeaders), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var el = _step.value;

          _loop(el);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    installTweets: function installTweets() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__components_twitter_twitter__["a" /* default */])().ready(function (twt) {
        var twitterWidgets = _this2.$el.querySelectorAll('.predictit__twitter');
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(twitterWidgets), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var widget = _step2.value;

            var tweetId = widget.getAttribute('data-tweetid');
            twt.widgets.createTweet(tweetId, widget, {
              theme: 'light'
            });
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      });
    },
    installDateElapsed: function installDateElapsed() {
      var dateEls = this.$el.querySelectorAll('.predictit__elapsedtime');
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(dateEls), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var el = _step3.value;

          var date = __WEBPACK_IMPORTED_MODULE_5_moment___default()(el.getAttribute('data-publishdate'));
          el.innerHTML = dateGoDisplay(date);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    installLoginAndSignUpControls: function installLoginAndSignUpControls() {
      var _this3 = this;

      var loginButtons = this.$el.querySelectorAll('.predictit-login-button');
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(loginButtons), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var button = _step4.value;

          button.addEventListener('click', function () {
            _this3.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__["a" /* MODALS */].LOGIN);
          });
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var loginControls = this.$el.querySelectorAll('.predictit-login-control');
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(loginControls), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _button = _step5.value;

          var instance = new LoginComponent({
            parent: this,
            propsData: {}
          });
          instance.$mount(_button);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var signUpButtons = this.$el.querySelectorAll('.predictit-signup-button');
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(signUpButtons), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var _button2 = _step6.value;

          _button2.addEventListener('click', function () {
            _this3.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_9__components_app_app_modals_app_modals__["a" /* MODALS */].REGISTER);
          });
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    },
    installMarketLists: function installMarketLists() {
      var _this4 = this;

      var marketListEls = this.$el.querySelectorAll('.predictit__markettilelist');

      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(marketListEls), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var el = _step7.value;

          var marketIds = el.getAttribute('data-marketids').replace(' ', '').split(',').map(function (i) {
            return parseInt(i, 10);
          });
          var markets = marketIds.map(function (marketId) {
            return _this4.marketTileMarkets.find(function (i) {
              return i.marketId === marketId;
            });
          }).filter(function (i) {
            return !!i;
          });

          if (markets.length > 0) {
            var instance = new MarketListItemEmbedComponent({
              parent: this,
              propsData: {
                markets: markets
              }
            });
            instance.$mount(el);
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }
    },
    installMarketContracts: function installMarketContracts() {
      var _this5 = this;

      var marketContractsEl = this.$el.querySelectorAll('.predictit__marketpreview');

      var _loop2 = function _loop2(el) {
        var marketId = parseInt(el.getAttribute('data-marketid'), 10);
        var market = _this5.contractListMarkets.find(function (i) {
          return i.marketId === marketId;
        });
        if (market) {
          var contractIds = el.getAttribute('data-contractids').replace(' ', '').split(',').map(function (i) {
            return parseInt(i, 10);
          });
          var contracts = market.contracts.filter(function (i) {
            return contractIds.includes(i.contractId);
          });
          var instance = new MarketContractListEmbedComponent({
            parent: _this5,
            propsData: {
              market: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, market, {
                contracts: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(contracts))
              })
            }
          });
          instance.$mount(el);
        }
      };

      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(marketContractsEl), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var el = _step8.value;

          _loop2(el);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    },
    installButtonsAndLinks: function installButtonsAndLinks() {
      var links = this.$el.querySelectorAll('[data-buttontype="Link"]');
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(links), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var el = _step9.value;

          var url = el.getAttribute('data-detailpath');
          var instance = new LinkComponent({
            parent: this,
            propsData: {
              type: 'link',
              text: el.innerHTML,
              url: url
            }
          });
          instance.$mount(el);
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      var buttons = this.$el.querySelectorAll('[data-buttontype="Button"]');
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(buttons), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var _el = _step10.value;

          var url = _el.getAttribute('data-detailpath');
          var instance = new LinkComponent({
            parent: this,
            propsData: {
              type: 'button',
              text: _el.innerHTML,
              url: url
            }
          });
          instance.$mount(_el);
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }
    },
    installPodcasts: function installPodcasts() {
      var _this6 = this;

      var podcastSliders = this.$el.querySelectorAll('.predictit__podcastslider');
      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(podcastSliders), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var el = _step11.value;

          var podcastIndexes = el.getAttribute('data-podcastids').replace(' ', '').split(',').map(function (i) {
            return parseInt(i, 10);
          });
          var podcasts = podcastIndexes.map(function (index) {
            return _this6.podcastItemContentObjects.find(function (podcast) {
              return podcast.podcastIndex === index;
            });
          });
          var _title = el.getAttribute('data-podcasttitle');
          var isRandomized = el.getAttribute('data-podcastisrandomized');
          var items = podcasts.map(function (i) {
            var chunks = i.podcastUrl.split('/');
            return {
              id: chunks[chunks.length - 1],
              type: __WEBPACK_IMPORTED_MODULE_15__components_home_home_old_podcasts_podcasts_vue__["b" /* PODCAST */].APPLE
            };
          });

          if (isRandomized === 'True') {
            items = __WEBPACK_IMPORTED_MODULE_3_lodash_shuffle___default()(items);
          }
          var instance = new PodcastsComponent({
            parent: this,
            propsData: {
              theme: 'story',
              title: _title,
              items: items
            }
          });
          instance.$mount(el);
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }
    },
    installMarketCharts: function installMarketCharts() {
      var _this7 = this;

      var marketChartsEl = this.$el.querySelectorAll('.predictit__datachart');

      var _loop3 = function _loop3(el) {
        var index = parseInt(el.getAttribute('data-chartindex'), 10);
        var versionId = el.getAttribute('data-chartstoryversionid');
        var storyId = el.getAttribute('data-chartstoryid');

        var chartObj = _this7.chartWidgetObjects.find(function (i) {
          return i.chartIndex === index;
        });
        __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch('market/getMarket', { marketId: chartObj.marketId, modifyState: false }).then(function (market) {
          var result = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, market);
          if (chartObj.contractIds) {
            result = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, result, {
              contracts: result.contracts.filter(function (i) {
                return chartObj.contractIds.includes(i.contractId);
              })
            });
          }
          var instance = new MarketChartsComponent({
            parent: _this7,
            propsData: {
              market: result,
              chartOptions: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, chartObj, {
                cmsStoryId: storyId,
                cmsVersionId: versionId,
                includeDownload: false
                // showContractImagesOnLegend: true,
                // showContractImagesOnChart: true,
              })
            }
          });
          instance.$mount(el);
        });
      };

      var _iteratorNormalCompletion12 = true;
      var _didIteratorError12 = false;
      var _iteratorError12 = undefined;

      try {
        for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(marketChartsEl), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
          var el = _step12.value;

          _loop3(el);
        }
      } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion12 && _iterator12.return) {
            _iterator12.return();
          }
        } finally {
          if (_didIteratorError12) {
            throw _iteratorError12;
          }
        }
      }
    },
    installDynamicControls: function installDynamicControls() {
      var _this8 = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$data = _ref.data,
          data = _ref$data === undefined ? {} : _ref$data;

      this.content = __WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(data, 'renderedHTML', '');
      this.cmsAccordionContentObjects = __WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(data, 'cmsContentObject.accordionContentObjects', []);
      this.podcastItemContentObjects = __WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(data, 'cmsContentObject.podcastItemContentObjects', []);
      this.contractListMarkets = __WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(data, 'cmsContentObject.contractListMarkets', []);
      this.marketTileMarkets = __WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(data, 'cmsContentObject.marketTileMarkets', []);
      this.chartWidgetObjects = __WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(data, 'cmsContentObject.chartWidgetObjects', []);

      this.$nextTick(function () {
        _this8.installAccordions();
        _this8.installTweets();
        _this8.installDateElapsed();
        _this8.installLoginAndSignUpControls();
        _this8.installMarketLists();
        _this8.installMarketContracts();
        _this8.installButtonsAndLinks();
        _this8.installPodcasts();
        _this8.installMarketCharts();
      });
    }
  }
});

/***/ }),

/***/ "tSuy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tV9q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "tWDM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint no-underscore-dangle: ["error", { "allow": ["_e"] }] */
var init = false;

function twitter() {
  if (init) {
    return window.twttr;
  }

  window.twttr = function (d, s, id) {
    var fjs = d.getElementsByTagName(s)[0];
    var t = {};
    var js = d.createElement(s);
    js.id = id;
    js.src = 'https://platform.twitter.com/widgets.js';
    fjs.parentNode.insertBefore(js, fjs);

    t._e = [];
    t.ready = function (f) {
      t._e.push(f);
    };
    return t;
  }(document, 'script', 'twitter-wjs');

  init = true;
  return window.twttr;
}

/* harmony default export */ __webpack_exports__["a"] = (twitter);

/***/ }),

/***/ "tdTh":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tdTh";

/***/ }),

/***/ "tjp7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateMarket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateContract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateMarketContracts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateMySharesMarket; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__ = __webpack_require__("a0yF");



var updateMarket = function updateMarket(market, data) {
  if (market.marketId === data.MarketId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["D" /* updateObjectValues */])(market, data, __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["p" /* MARKET_DATA_MAP */]);
  }
  return market;
};

var updateContract = function updateContract(contract, data) {
  if (contract.contractId === data.ContractId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["D" /* updateObjectValues */])(contract, data, __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["q" /* CONTRACT_DATA_MAP */]);
  }
  return contract;
};

var updateMarketContracts = function updateMarketContracts(market, data) {
  if (market.contracts) {
    market.contracts = market.contracts.map(function (contract) {
      return updateContract(contract, data);
    });
    // CONTRACTS SORT
    // market.contracts.sort((prev, next) => {
    //   if (prev.lastTradePrice < next.lastTradePrice) {
    //     return 1;
    //   } else if (prev.lastTradePrice > next.lastTradePrice) {
    //     return -1;
    //   }
    //   return 0;
    // });
  }
  if (market.marketContracts) {
    market.marketContracts = market.marketContracts.map(function (contract) {
      return updateContract(contract, data);
    });
    // CONTRACTS SORT
    // market.marketContracts.sort((prev, next) => {
    //   if (prev.lastTradePrice < next.lastTradePrice) {
    //     return 1;
    //   } else if (prev.lastTradePrice > next.lastTradePrice) {
    //     return -1;
    //   }
    //   return 0;
    // });
  }
  return market;
};

var updateMySharesMarket = function updateMySharesMarket(market, data) {
  if (market.marketId === data.MarketId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_helpers__["D" /* updateObjectValues */])(market, data, __WEBPACK_IMPORTED_MODULE_1__services_notifications_proxy__["r" /* MY_SHARES_MARKET_DATA_MAP */]);
  }
  return market;
};

/***/ }),

/***/ "tkSH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tq+R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"row news-feed-item",class:_vm.containerModifier,attrs:{"href":_vm.url,"target":_vm.target}},[(_vm.shouldShowImage)?_c('div',{staticClass:"column small-4 news-feed-item__image"},[_c('img',{attrs:{"src":_vm.getItemImage(_vm.data)},on:{"error":_vm.onImageLoadError}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column news-feed-item__content",class:_vm.contentModifier},[_c('h4',[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),(_vm.showSubtitle)?_c('h5',{staticClass:"news-feed-item__subtitle"},[_vm._v("\r\n      "+_vm._s(_vm.data.origin.title)+"\r\n    ")]):_vm._e(),_vm._v(" "),(_vm.data.summary)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.data.summary.content)}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ttZ6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "tumW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_twitter_twitter__ = __webpack_require__("tWDM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");






function styleTwitterTimeline($content) {
  if ($content) {
    var style = document.createElement('style');
    style.innerHTML += 'a {color:#67999f;}';
    style.innerHTML += '.timeline-Widget {padding:19px 13px;}';
    style.innerHTML += '.timeline-Header {margin-bottom:9px;padding:0;}';
    style.innerHTML += '.timeline-Header-title {color:#263b3f;font-size:26px;line-height:17px;letter-spacing:0.03em;font-weight:500;}';
    style.innerHTML += '.timeline-Header-byline {color:#263b3f;}';
    style.innerHTML += '.SandboxRoot.env-bp-430 .timeline-Tweet-text {font-size:14px;line-height:18px;font-weight:500;color:#263b3f;}';
    style.innerHTML += '.timeline-TweetList-tweet {border-top:1px solid #b8c5c6;}';
    style.innerHTML += '.timeline-Body {border-top:1px solid #b8c5c6;border-bottom:1px solid #b8c5c6;}';
    var head = $content.getElementsByTagName('head');

    if (head && head.length > 0) {
      head[0].appendChild(style);
    }
  }
}

function createTimeline(twt, el) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var width = window.innerWidth > 0 ? window.innerWidth : screen.width;

  var options = {
    chrome: 'nofooter'
  };

  if (width <= 320) {
    options.width = 300;
  }

  if (limit !== -1) options.tweetLimit = limit;
  twt.widgets.createTimeline({
    sourceType: 'profile',
    screenName: "PredictIt"
  }, el, options).then(function (iframeEl) {
    if (!iframeEl) return;
    // const $content = iframeEl.contentDocument;
    // styleTwitterTimeline($content);

    if (callback !== null && typeof callback === 'function') {
      callback();
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    inOverlay: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    },
    numTweets: {
      type: Number,
      default: 6
    }
  },
  data: function data() {
    return {
      identifier: +new Date(),
      loading: false,
      ready: false,
      hideFooter: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isShutdownModeOn']), {
    getMoreTweetsLabel: function getMoreTweetsLabel() {
      return this.isLayoutDesktop ? 'More Tweets' : 'Load more';
    },
    classModifiers: function classModifiers() {
      return {
        twittertimeline: true,
        'twittertimeline--loading': this.loading
      };
    },
    initClassModifiers: function initClassModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'twittertimeline__iframe-wrapper': true
      }, 'twittertimeline__iframe-wrapper--' + this.identifier, this.identifier);
    },
    contentClassModifiers: function contentClassModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        twittertimeline__content: true,
        'twittertimeline__content--shutdown': this.isShutdownModeOn
      }, 'twittertimeline__content--' + this.theme, this.theme);
    },
    showFooter: function showFooter() {
      return !this.inOverlay && !this.hideFooter;
    },
    tweetLimit: function tweetLimit() {
      return !this.inOverlay ? this.numTweets : undefined;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    onFooterMoreButtonClick: function onFooterMoreButtonClick(e) {
      var _this = this;

      e.stopPropagation();
      if (this.isLayoutDesktop) {
        this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_4__components_app_app_modals_app_modals__["a" /* MODALS */].TWITTER);
      } else {
        this.loading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_twitter_twitter__["a" /* default */])().ready(function (twt) {
          return createTimeline(twt, _this.$refs.more, undefined, function () {
            _this.loading = false;
            _this.hideFooter = true;
            _this.$refs.init.remove();
          });
        });
      }
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.loading = true;
    setTimeout(function () {
      _this2.loading = false;
    }, 5000);
    this.$nextTick(function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_twitter_twitter__["a" /* default */])().ready(function (twt) {
        twt.events.bind('loaded', function () {
          _this2.loading = false;
          _this2.ready = true;
        });
        createTimeline(twt, _this2.$refs.init, _this2.tweetLimit, function () {
          _this2.loading = false;
        });
      });
    });
  }
});

/***/ }),

/***/ "u+c/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-portfolio"},[_c('dashboard-portfolio')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u0LV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u0d3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_support_support_support_vue__ = __webpack_require__("0fv4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_support_help_and_support_help_and_support_vue__ = __webpack_require__("wv8k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_support_learn_the_basics_learn_the_basics_vue__ = __webpack_require__("imzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_support_community_forums_community_forums_vue__ = __webpack_require__("r78W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_support_faq_faq_vue__ = __webpack_require__("ZIhC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_support_what_is_predictit_what_is_predictit_vue__ = __webpack_require__("CCA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_support_videos_videos_vue__ = __webpack_require__("HSd1");








/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/support',
  component: __WEBPACK_IMPORTED_MODULE_0__components_support_support_support_vue__["a" /* default */],
  props: true,
  children: [{
    path: '',
    name: 'HelpAndSupport',
    component: __WEBPACK_IMPORTED_MODULE_1__components_support_help_and_support_help_and_support_vue__["a" /* default */],
    props: true
  }, {
    path: 'what-is-predictit',
    name: 'WhatIsPredictIt',
    component: __WEBPACK_IMPORTED_MODULE_5__components_support_what_is_predictit_what_is_predictit_vue__["a" /* default */],
    props: true
  }, {
    path: 'how-to-trade-on-predictit',
    name: 'LearnTheBasics',
    component: __WEBPACK_IMPORTED_MODULE_2__components_support_learn_the_basics_learn_the_basics_vue__["a" /* default */],
    props: true
  }, {
    path: 'community-forums',
    name: 'ComunityForums',
    component: __WEBPACK_IMPORTED_MODULE_3__components_support_community_forums_community_forums_vue__["a" /* default */],
    props: true
  }, {
    path: 'faq',
    name: 'Faq',
    component: __WEBPACK_IMPORTED_MODULE_4__components_support_faq_faq_vue__["a" /* default */],
    props: true
  }, {
    path: 'videos',
    name: 'Videos',
    component: __WEBPACK_IMPORTED_MODULE_6__components_support_videos_videos_vue__["a" /* default */],
    props: true
  }]
}]);

/***/ }),

/***/ "u3Vs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_history_js__ = __webpack_require__("Oi4w");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ba1d840_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_history_vue__ = __webpack_require__("lDBc");
function injectStyle (ssrContext) {
  __webpack_require__("rtt5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_history_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ba1d840_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u71h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-icon"},[(!_vm.reversed)?_c('div',[_c('img',{staticClass:"notification-icon__img",attrs:{"src":__webpack_require__("EoBZ")},on:{"click":function($event){$event.preventDefault();return _vm.onClick($event)}}}),_vm._v(" "),_c('span',{staticClass:"notification-icon__text"},[_vm._v(_vm._s(_vm.text))])]):_vm._e(),_vm._v(" "),(_vm.reversed)?_c('div',[_c('span',{staticClass:"notification-icon__text"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('img',{staticClass:"notification-icon__img",attrs:{"src":__webpack_require__("EoBZ")},on:{"click":function($event){$event.preventDefault();return _vm.onClick($event)}}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u9HT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_userDetails__ = __webpack_require__("jtWA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_socialLevel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_userDetails__["a" /* default */]],
  props: {
    widget: Object
  },
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
  },
  data: function data() {
    return {
      swiperOptions: {
        loop: true,
        autoplay: 5000,
        slidesPerGroup: 2,
        slidesPerView: 2,
        slidesPerColumn: 1,
        spaceBetween: 0,
        breakpoints: {
          768: {
            slidesPerGroup: 1,
            slidesPerView: 1,
            slidesPerColumn: 2
          }
        }
      }
    };
  },

  computed: {
    obj: function obj() {
      return this.widget ? this.widget : {};
    },
    traderCount: function traderCount() {
      return this.widget ? this.widget.activeTraderCount.toLocaleString('en-US') : '';
    },
    traders: function traders() {
      return this.obj.traders;
    }
  },
  watch: {
    widget: function widget(val) {
      if (val) {
        this.loaderRemove();
      }
    }
  },
  methods: {
    traderLevelDisplay: function traderLevelDisplay(item) {
      var level = this.getLevelByPredictions(item.profitablePredictions);
      return 'Level ' + level.num + ' (' + level.text + ')';
    },
    priceClassModifiers: function priceClassModifiers() {
      return {
        'market-currently-predicting__price': true
        // 'market-currently-predicting__price--multiple': !this.isMarketSingle(market),
        // 'market-currently-predicting__price--single': this.isMarketSingle(market),
      };
    },
    isMarketSingle: function isMarketSingle(market) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["l" /* isMarketSingle */])(market);
    },
    boughtSold: function boughtSold(type) {
      return type < 2 ? 'Bought' : 'Sold';
    },
    yesNo: function yesNo(type) {
      return type % 2 === 0 ? 'No' : 'Yes';
    },
    classModifier: function classModifier(type) {
      return {
        'market-currently-predicting__type': true,
        'market-currently-predicting__type--no': type % 2 === 0
      };
    },
    onClick: function onClick(pred) {
      if (pred.marketId) {
        this.$router.push({
          name: 'market-details',
          params: { marketId: pred.marketId, marketUrl: pred.marketUrl }
        });
      }
    }
  },
  mounted: function mounted() {
    if (!this.widget) {
      this.loaderAdd();
    }
  }
});

/***/ }),

/***/ "uAyh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isComponentReady)?_c('account-form-loader',{attrs:{"theme":"deposit"}}):(_vm.documentUploadInfoVisible)?_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending,"theme":_vm.accountUploadDocumentTheme,"type":"card"}}):[(_vm.isStepInitial)?_c('form',{class:_vm.classModifiers,on:{"submit":function($event){$event.preventDefault();return _vm.onConfirmDeposit($event)}}},[(_vm.errorMessage)?_c('alert-box',{staticClass:"add-funds__alert-box",attrs:{"level":"warning"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]):_vm._e(),_vm._v(" "),(_vm.avsMessage)?_c('alert-box',{staticClass:"add-funds__alert-box",attrs:{"level":"warning"}},[_vm._v("\n        Please provide a billing address.\n      ")]):_vm._e(),_vm._v(" "),(_vm.showPromoNotification)?_c('alert-box',{staticClass:"add-funds__alert-box",attrs:{"level":"success"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.promoCodeDetail.friendlyDescription)}})]):_vm._e(),_vm._v(" "),(_vm.depositWarning)?_c('div',{staticClass:"predictit-embedded-alert",domProps:{"innerHTML":_vm._s(_vm.depositWarning)}}):_vm._e(),_vm._v(" "),(_vm.showInstantCreditNotification)?_c('alert-box',{staticClass:"add-funds__alert-box",attrs:{"level":_vm.instantCreditBoxLevel}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.instantCreditBoxMessage)}})]):_vm._e(),_vm._v(" "),(!_vm.errorMessage)?[_c('h5',{staticClass:"form__title form__title--left form__title--margin"},[_vm._v("Deposit Amount ($"+_vm._s(_vm.minimumDepositAmount.toFixed(2))+" Minimum)")]),_vm._v(" "),_c('div',{staticClass:"row-x"},[(_vm.amountHasError)?_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"add-funds__error"},[_vm._v("\n              "+_vm._s(_vm.amountValidationMessage)+"\n            ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"small-12 medium-4 column"},[_c('div',{staticClass:"input-group input-group--large"},[_c('span',{staticClass:"input-group__addon"},[_vm._v("$")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fields.amount),expression:"fields.amount"}],staticClass:"input-group__input",attrs:{"tabindex":"1","validation":_vm.$v.fields.amount},domProps:{"value":(_vm.fields.amount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.fields, "amount", $event.target.value)},_vm.$v.fields.amount.$touch],"blur":_vm.handleAmountBlur}})])]),_vm._v(" "),_c('div',{staticClass:"small-12 medium-8 column"},[_c('div',{staticClass:"row-x"},_vm._l((_vm.depositAmounts),function(amount){return _c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"button button--primary add-funds__button",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onUpdateAmount(amount)}}},[_c('span',{staticClass:"add-funds__button-plus"},[_vm._v("+")]),_vm._v(" $"+_vm._s(amount)+"\n                  ")])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"tabindex":2,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.name,"name":_vm.fieldName('name'),"autocomplete":"name","type":"text","required":true,"gtm":"Deposit,Credit Card Name","placeholder":"Name on Card"},on:{"input":_vm.$v.fields.name.$touch},model:{value:(_vm.fields.name),callback:function ($$v) {_vm.$set(_vm.fields, "name", $$v)},expression:"fields.name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[(_vm.cardTypeHasError)?_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"add-funds__error add-funds__error--no-margin-bottom"},[_vm._v("\n              "+_vm._s(_vm.cardTypeValidationMessage)+"\n            ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"small-12 column"},[_c('form-input',{ref:"cnumber",attrs:{"theme":"card-type","tabindex":4,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.number,"name":_vm.fieldName('number'),"autocomplete":"off","type":"text","gtm":"Deposit,Credit Card Number","hideIconOnValue":false,"required":true},on:{"input":_vm.$v.fields.number.$touch},model:{value:(_vm.fields.number),callback:function ($$v) {_vm.$set(_vm.fields, "number", $$v)},expression:"fields.number"}},[_c('img',{staticClass:"add-funds__card-type",attrs:{"slot":"icon","src":_vm.cardTypeImage},slot:"icon"})])],1)]),_vm._v(" "),_c('h5',{staticClass:"form__title form__title--left form__title--margin"},[_vm._v("Expiry Date")]),_vm._v(" "),_c('div',{staticClass:"row-x"},[_c('div',{staticClass:"small-4 column"},[_c('form-select',{attrs:{"searchable":_vm.isLayoutDesktop,"tabindex":5,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.expiryDateMonth,"placeholder":"MM","options":_vm.months,"track-by":"value","label":"label","gtm":"Deposit,Credit Card Expiry Month","required":true},on:{"select":function (e) { return _vm.tabTo(e, 'year'); },"input":_vm.$v.fields.expiryDateMonth.$touch},model:{value:(_vm.fields.expiryDateMonth),callback:function ($$v) {_vm.$set(_vm.fields, "expiryDateMonth", $$v)},expression:"fields.expiryDateMonth"}})],1),_vm._v(" "),_c('div',{staticClass:"small-4 column"},[_c('form-select',{ref:"year",attrs:{"searchable":_vm.isLayoutDesktop,"tabindex":6,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.expiryDateYear,"placeholder":"YYYY","options":_vm.years,"track-by":"value","label":"label","gtm":"Deposit,Credit Card Expiry Year","required":true},on:{"select":function (e) { return _vm.tabTo(e, 'cvv'); },"input":_vm.$v.fields.expiryDateYear.$touch},model:{value:(_vm.fields.expiryDateYear),callback:function ($$v) {_vm.$set(_vm.fields, "expiryDateYear", $$v)},expression:"fields.expiryDateYear"}})],1),_vm._v(" "),_c('div',{staticClass:"small-4 column"},[_c('form-input',{ref:"cvv",attrs:{"tabindex":7,"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.cvv,"name":_vm.fieldName('cvv'),"autocomplete":"cvv","type":"text","required":true,"gtm":"Deposit,Security Code","placeholder":"CVV"},on:{"input":_vm.$v.fields.cvv.$touch},model:{value:(_vm.fields.cvv),callback:function ($$v) {_vm.$set(_vm.fields, "cvv", $$v)},expression:"fields.cvv"}},[_c('notification-icon',{attrs:{"slot":"icon","reversed":true},on:{"showPopup":_vm.showCVVModal},slot:"icon"})],1)],1)]),_vm._v(" "),(_vm.avsFlag)?[_c('h5',{staticClass:"form__title form__title--left form__title--margin-alt"},[_vm._v("Billing Address")]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.address,"disabled":_vm.isFormDisabled,"name":"street","type":"text","required":true,"autocomplete":"street-address","placeholder":"Street Address"},on:{"input":_vm.$v.fields.address.$touch},model:{value:(_vm.fields.address),callback:function ($$v) {_vm.$set(_vm.fields, "address", $$v)},expression:"fields.address"}})],1),_vm._v(" "),_c('div',{staticClass:"small-6 column"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.city,"disabled":_vm.isFormDisabled,"name":"city","type":"text","required":true,"autocomplete":"address-line1","placeholder":"City"},on:{"input":_vm.$v.fields.city.$touch},model:{value:(_vm.fields.city),callback:function ($$v) {_vm.$set(_vm.fields, "city", $$v)},expression:"fields.city"}})],1),_vm._v(" "),_c('div',{staticClass:"small-6 column"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.zipCode,"disabled":_vm.isFormDisabled,"name":"zipCode","type":"text","required":true,"autocomplete":"postal-code","placeholder":"Zip/Postal Code"},on:{"input":_vm.$v.fields.zipCode.$touch},model:{value:(_vm.fields.zipCode),callback:function ($$v) {_vm.$set(_vm.fields, "zipCode", $$v)},expression:"fields.zipCode"}})],1)])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"add-funds__submit"},[_c('form-submit',{attrs:{"label":"Review And Confirm","disabled":_vm.isConfirmDisabled}})],1),_vm._v(" "),(_vm.disclaimer)?_c('p',{staticClass:"add-funds__note"},[_c('strong',[_vm._v("Note")]),_vm._v(": "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.disclaimer)}})]):_vm._e()]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.isStepConfirm)?_c('div',{staticClass:"add-funds__info"},[_c('div',{staticClass:"add-funds__info-content"},[(_vm.mode === 'page')?_c('span',{staticClass:"add-funds__info-cancel-button",on:{"click":function($event){$event.preventDefault();return _vm.onTryAgain($event)}}},[_vm._v("\n            Cancel\n          ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"add-funds__info-large-para"},[_vm._v("\n            Are you sure you want to deposit\n          ")]),_vm._v(" "),_c('p',{staticClass:"add-funds__info-amount"},[_vm._v("\n            "+_vm._s(_vm.infoAmount)+"\n          ")]),_vm._v(" "),_c('p',{staticClass:"add-funds__info-large-para"},[_vm._v("\n            on your credit card?\n          ")])]),_vm._v(" "),_c('div',{staticClass:"add-funds__info-button-wrapper"},[_c('div',{staticClass:"row row-xy"},[_c('div',{staticClass:"column small-12"},[_c('button',{staticClass:"button button--large button--primary button--full-width",attrs:{"disabled":_vm.isConfirmDisabled},on:{"click":function($event){$event.preventDefault();return _vm.onSubmitDeposit($event)}}},[_vm._v("\n              Confirm & Deposit\n            ")])])])])]):_vm._e(),_vm._v(" "),(_vm.isStepTryAgain)?_c('div',{staticClass:"add-funds__info"},[_c('div',{staticClass:"add-funds__info-icon"},[_c('img',{attrs:{"src":__webpack_require__("z6fO")}})]),_vm._v(" "),_c('div',{staticClass:"add-funds__info-content"},[(_vm.errorMessageDepositFail)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.errorMessageDepositFail)}}):_c('p',[_vm._v("\n            Unfortunately, your payment was not processed. Please try again.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"add-funds__info-button-wrapper"},[_c('button',{staticClass:"button button--large button--primary button--full-width",on:{"click":function($event){$event.preventDefault();return _vm.onTryAgain($event)}}},[_vm._v("\n          Please Try Again\n        ")])])]):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uCSF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDSN":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNSIgaGVpZ2h0PSIzNSIgdmlld0JveD0iMCAwIDM1IDM1Ij4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8Y2lyY2xlIGN4PSIxNi41IiBjeT0iMTYuNSIgcj0iMTciIHN0cm9rZT0iIzQyQ0YyNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAxKSIvPg0KICAgICAgICA8cGF0aCBmaWxsPSIjNDJDRjI2IiBkPSJNMjUuMjYgMTMuNTUzbC04LjkxIDkuMTI1YTEuNDQyIDEuNDQyIDAgMCAxLTIuMDc1IDBsLTMuNzIyLTMuODFhMS41MzIgMS41MzIgMCAwIDEgMC0yLjEyNyAxLjQ0NCAxLjQ0NCAwIDAgMSAyLjA3NSAwbDIuNjg1IDIuNzUgNy44NzItOC4wNjNhMS40NDIgMS40NDIgMCAwIDEgMi4wNzYgMCAxLjUyNyAxLjUyNyAwIDAgMSAwIDIuMTI1Ii8+DQogICAgPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "uK2H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-static-preview"},[(_vm.isColumnCountExceeding)?_c('alert-box',{staticClass:"page-static-preview__box",attrs:{"level":"warning"}},[_vm._v("\n    Column setup appears to be invalid (either exceeds 100% or content column broke to next row).\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row row-xy"},[_c('div',{staticClass:"column small-12 medium-6"},[_c('form-select',{attrs:{"searchable":true,"placeholder":"Left Column","options":_vm.COLUMN_OPTIONS,"track-by":"value","label":"label"},model:{value:(_vm.columnChoice.left),callback:function ($$v) {_vm.$set(_vm.columnChoice, "left", $$v)},expression:"columnChoice.left"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-6"},[_c('form-select',{attrs:{"searchable":true,"placeholder":"Right Column","options":_vm.COLUMN_OPTIONS,"track-by":"value","label":"label"},model:{value:(_vm.columnChoice.right),callback:function ($$v) {_vm.$set(_vm.columnChoice, "right", $$v)},expression:"columnChoice.right"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{class:_vm.leftColumnClasses},[_vm._v("\n       \n    ")]),_vm._v(" "),_c('div',{class:_vm.middleColumnClasses,domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),_c('div',{class:_vm.rightColumnClasses},[_vm._v("\n       \n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uU/O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers,on:{"click":_vm.onContractClick}},[(_vm.isLayoutDesktop && _vm.isLayoutDashboard)?[_c('div',{staticClass:"market-contract-horizontal-v2__content"},[_c('div',{staticClass:"market-contract-horizontal-v2__content-item-1"},[_c('div',{staticClass:"market-contract-horizontal-v2__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-v2__content-item-2"},[_c('animated-number',{attrs:{"value":_vm.currentPrice}})],1),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-v2__content-item-3"},[(_vm.showSharesBar)?_c('market-shares-bar',{attrs:{"mode":_vm.contractModel.mode,"number":_vm.contract.userQuantity,"average":_vm.contractModel.userAveragePricePerShareAsCents,"difference":_vm.contractModel.userChangePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice,"numberOnly":true,"theme":"dashboard"},on:{"click":_vm.onClickSharesBar}}):_c('div',{staticClass:"market-contract-horizontal-v2__empty-shares"},[_vm._v("--")])],1),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-v2__content-item-4"},[(_vm.showSharesBar)?[_c('span',{directives:[{name:"price-display",rawName:"v-price-display.cents",value:(_vm.contractModel.userAveragePricePerShareAsCents),expression:"contractModel.userAveragePricePerShareAsCents",modifiers:{"cents":true}}],staticClass:"market-contract-horizontal-v2__avg-paid"}),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.contractModel.userChangePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice,"theme":"dashboard"}})]:_c('div',{staticClass:"market-contract-horizontal-v2__empty-paid"},[_vm._v("--")])],2),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-v2__content-item-5"},[(_vm.showOpenOffers)?_c('span',{staticClass:"market-contract-horizontal-v2__open-offers",on:{"click":function($event){$event.stopPropagation();return _vm.onClickOpenOffers($event)}}},[_vm._v("\n            "+_vm._s(_vm.openOffersText)+"\n          ")]):_c('div',{staticClass:"market-contract-horizontal-v2__empty-offers"},[_vm._v("--")])]),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-v2__content-item-6"},[_c('div',{staticClass:"market-contract-horizontal-v2__buttons"},[(_vm.isMarketDisabled)?[_c('button',{staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--disabled"},[_vm._v("\n              "+_vm._s(_vm.disabledMarketButtonText)+"\n            ")])]:[_c('div',{staticClass:"market-contract-horizontal-v2__buttons--left"},[(_vm.contractModel.mode === _vm.VALUES.NO)?[(_vm.showOuterPriceButton)?_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyNoCostAsCents,"text":"Buy"}}):_vm._e(),_vm._v(" "),_c('button',{ref:_vm.BUTTONS.BUY_NO.id,staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--buy-no",class:_vm.isButtonActive(_vm.BUTTONS.BUY_NO.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                      _vm.contractModel.contractId, _vm.BUTTONS.BUY_NO.type, _vm.BUTTONS.BUY_NO.value, null, _vm.BUTTONS.BUY_NO.id)}}},[(_vm.showInnerPriceButton)?_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyNoCostAsCents,"layout":"inner","text":"Buy"}}):_c('span',[_vm._v("Buy")])],1)]:[(_vm.showOuterPriceButton)?_c('button-price',{key:_vm.contractModel.buyYesCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyYesCostAsCents,"text":"Buy"}}):_vm._e(),_vm._v(" "),_c('button',{ref:_vm.BUTTONS.BUY_YES.id,staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--buy-yes",class:_vm.isButtonActive(_vm.BUTTONS.BUY_YES.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                      _vm.contractModel.contractId, _vm.BUTTONS.BUY_YES.type, _vm.BUTTONS.BUY_YES.value, null, _vm.BUTTONS.BUY_YES.id)}}},[(_vm.showInnerPriceButton)?_c('button-price',{key:_vm.contractModel.buyYesCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyYesCostAsCents,"layout":"inner","text":"Buy"}}):_c('span',[_vm._v("Buy")])],1)]],2),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-v2__buttons--right"},[(_vm.contractModel.mode === _vm.VALUES.NO)?[_c('button',{ref:_vm.BUTTONS.SELL_NO.id,staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--sell-no",class:_vm.isButtonActive(_vm.BUTTONS.SELL_NO.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                      _vm.contractModel.contractId, _vm.BUTTONS.SELL_NO.type, _vm.BUTTONS.SELL_NO.value, null, _vm.BUTTONS.SELL_NO.id)}}},[(_vm.showInnerPriceButton)?_c('button-price',{key:_vm.contractModel.sellNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.sellNoCostAsCents,"layout":"inner","text":"Sell"}}):_c('span',[_vm._v("Sell")])],1),_vm._v(" "),(_vm.showOuterPriceButton)?_c('button-price',{key:_vm.contractModel.sellNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.sellNoCostAsCents,"text":"Sell"}}):_vm._e()]:(_vm.contractModel.mode === _vm.VALUES.YES)?[_c('button',{ref:_vm.BUTTONS.SELL_YES.id,staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--sell-yes",class:_vm.isButtonActive(_vm.BUTTONS.SELL_YES.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                      _vm.contractModel.contractId, _vm.BUTTONS.SELL_YES.type, _vm.BUTTONS.SELL_YES.value, null, _vm.BUTTONS.SELL_YES.id)}}},[(_vm.showInnerPriceButton)?_c('button-price',{key:_vm.contractModel.sellYesCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.sellYesCostAsCents,"layout":"inner","text":"Sell"}}):_c('span',[_vm._v("Sell")])],1),_vm._v(" "),(_vm.showOuterPriceButton)?_c('button-price',{key:_vm.contractModel.sellYesCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.sellYesCostAsCents,"text":"Sell"}}):_vm._e()]:[_c('button',{ref:_vm.BUTTONS.BUY_NO_ALT.id,staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--buy-no",class:_vm.isButtonActive(_vm.BUTTONS.BUY_NO_ALT.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                      _vm.contractModel.contractId, _vm.BUTTONS.BUY_NO_ALT.type, _vm.BUTTONS.BUY_NO_ALT.value, null, _vm.BUTTONS.BUY_NO_ALT.id)}}},[(_vm.showInnerPriceButton)?_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyNoCostAsCents,"layout":"inner","text":"Buy"}}):_c('span',[_vm._v("Buy")])],1),_vm._v(" "),(_vm.showOuterPriceButton)?_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyNoCostAsCents,"text":"Buy"}}):_vm._e()]],2)]],2)])])]:(_vm.isLayoutDesktop)?[_c('div',{staticClass:"market-contract-horizontal-v2__image",style:(_vm.contractImageStyleModifiers)}),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-v2__content"},[_c('div',{staticClass:"row row-100 market-contract-horizontal-v2__row"},[_c('div',{staticClass:"column small-12 medium-6 column-large-100"},[_c('div',{class:_vm.rowModifiers},[_c('div',{class:_vm.infoPartModifiers},[_c('div',{staticClass:"market-contract-horizontal-v2__title-container"},[_c('div',{class:_vm.titleModifiers},[_c('span',{staticClass:"market-contract-horizontal-v2__title-text"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.isLayoutMobile)?_c('span',{staticClass:"market-contract-horizontal-v2__title-price"},[_c('span',{staticClass:"market-contract-horizontal-v2__current-price-display"},[_c('animated-number',{attrs:{"value":_vm.currentPrice}})],1),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice}})],1):_vm._e()]),_vm._v(" "),(_vm.isLayoutDesktop)?[_c('div',{staticClass:"market-contract-horizontal-v2__shares-offers"},[(_vm.showSharesBar)?_c('market-shares-bar',{attrs:{"mode":_vm.contractModel.mode,"number":_vm.contract.userQuantity,"average":_vm.contractModel.userAveragePricePerShareAsCents,"difference":_vm.contractModel.userChangePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice,"theme":"page-market"},on:{"click":_vm.onClickSharesBar}}):_vm._e(),_vm._v(" "),(_vm.showOpenOffers)?_c('span',{staticClass:"market-contract-horizontal-v2__open-offers",on:{"click":function($event){$event.stopPropagation();return _vm.onClickOpenOffers($event)}}},[_vm._v("\n                      "+_vm._s(_vm.openOffersText)+"\n                    ")]):_vm._e()],1)]:(_vm.showSharesBar || _vm.showOpenOffers)?[_c('div',{staticClass:"market-contract-horizontal-v2__shares-offers"},[(_vm.showSharesBar)?_c('market-shares-bar',{attrs:{"mode":_vm.contractModel.mode,"number":_vm.contract.userQuantity,"average":_vm.contractModel.userAveragePricePerShareAsCents,"difference":_vm.contractModel.userChangePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice},on:{"click":_vm.onClickSharesBar}}):[_c('span',[_vm._v(" ")])],_vm._v(" "),(_vm.showOpenOffers)?_c('span',{staticClass:"market-contract-horizontal-v2__open-offers",on:{"click":function($event){$event.stopPropagation();return _vm.onClickOpenOffers($event)}}},[_vm._v("\n                      "+_vm._s(_vm.openOffersText)+"\n                    ")]):_vm._e()],2)]:_vm._e()],2)]),_vm._v(" "),(_vm.isLayoutDesktop)?_c('div',{class:_vm.pricePartModifiers},[_c('div',{staticClass:"market-contract-horizontal-v2__current-price"},[_c('span',{staticClass:"market-contract-horizontal-v2__current-price-display"},[_c('animated-number',{attrs:{"value":_vm.currentPrice}})],1),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice,"theme":"page-market"}})],1)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"column small-12 medium-6 column-large-100 market-contract-horizontal-v2__buttons-col"},[_c('div',{staticClass:"market-contract-horizontal-v2__buttons"},[(_vm.isMarketDisabled)?[_c('button',{staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--disabled"},[_vm._v("\n                "+_vm._s(_vm.disabledMarketButtonText)+"\n              ")])]:[_c('div',{staticClass:"market-contract-horizontal-v2__buttons--left"},[(_vm.contractModel.mode === _vm.VALUES.NO)?[(_vm.showOuterPriceButton)?_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyNoCostAsCents,"text":"Buy No"}}):_vm._e(),_vm._v(" "),_c('button',{ref:_vm.BUTTONS.BUY_NO.id,staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--buy-no",class:_vm.isButtonActive(_vm.BUTTONS.BUY_NO.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                        _vm.contractModel.contractId, _vm.BUTTONS.BUY_NO.type, _vm.BUTTONS.BUY_NO.value, null, _vm.BUTTONS.BUY_NO.id)}}},[(_vm.showInnerPriceButton)?_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyNoCostAsCents,"layout":"inner","text":"Buy No"}}):_c('span',[_vm._v("Buy No")])],1)]:[(_vm.showOuterPriceButton)?_c('button-price',{key:_vm.contractModel.buyYesCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyYesCostAsCents,"text":"Buy Yes"}}):_vm._e(),_vm._v(" "),_c('button',{ref:_vm.BUTTONS.BUY_YES.id,staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--buy-yes",class:_vm.isButtonActive(_vm.BUTTONS.BUY_YES.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                        _vm.contractModel.contractId, _vm.BUTTONS.BUY_YES.type, _vm.BUTTONS.BUY_YES.value, null, _vm.BUTTONS.BUY_YES.id)}}},[(_vm.showInnerPriceButton)?_c('button-price',{key:_vm.contractModel.buyYesCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyYesCostAsCents,"layout":"inner","text":"Buy Yes"}}):_c('span',[_vm._v("Buy Yes")])],1)]],2),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-v2__buttons--right"},[(_vm.contractModel.mode === _vm.VALUES.NO)?[_c('button',{ref:_vm.BUTTONS.SELL_NO.id,staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--sell-no",class:_vm.isButtonActive(_vm.BUTTONS.SELL_NO.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                        _vm.contractModel.contractId, _vm.BUTTONS.SELL_NO.type, _vm.BUTTONS.SELL_NO.value, null, _vm.BUTTONS.SELL_NO.id)}}},[(_vm.showInnerPriceButton)?_c('button-price',{key:_vm.contractModel.sellNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.sellNoCostAsCents,"layout":"inner","text":"Sell No"}}):_c('span',[_vm._v("Sell No")])],1),_vm._v(" "),(_vm.showOuterPriceButton)?_c('button-price',{key:_vm.contractModel.sellNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.sellNoCostAsCents,"text":"Sell No"}}):_vm._e()]:(_vm.contractModel.mode === _vm.VALUES.YES)?[_c('button',{ref:_vm.BUTTONS.SELL_YES.id,staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--sell-yes",class:_vm.isButtonActive(_vm.BUTTONS.SELL_YES.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                        _vm.contractModel.contractId, _vm.BUTTONS.SELL_YES.type, _vm.BUTTONS.SELL_YES.value, null, _vm.BUTTONS.SELL_YES.id)}}},[(_vm.showInnerPriceButton)?_c('button-price',{key:_vm.contractModel.sellYesCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.sellYesCostAsCents,"layout":"inner","text":"Sell Yes"}}):_c('span',[_vm._v("Sell Yes")])],1),_vm._v(" "),(_vm.showOuterPriceButton)?_c('button-price',{key:_vm.contractModel.sellYesCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.sellYesCostAsCents,"text":"Sell Yes"}}):_vm._e()]:[_c('button',{ref:_vm.BUTTONS.BUY_NO_ALT.id,staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--buy-no",class:_vm.isButtonActive(_vm.BUTTONS.BUY_NO_ALT.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                        _vm.contractModel.contractId, _vm.BUTTONS.BUY_NO_ALT.type, _vm.BUTTONS.BUY_NO_ALT.value, null, _vm.BUTTONS.BUY_NO_ALT.id)}}},[(_vm.showInnerPriceButton)?_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyNoCostAsCents,"layout":"inner","text":"Buy No"}}):_c('span',[_vm._v("Buy No")])],1),_vm._v(" "),(_vm.showOuterPriceButton)?_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyNoCostAsCents,"text":"Buy No"}}):_vm._e()]],2)]],2)])])])]:[_c('div',{staticClass:"market-contract-horizontal-v2__mobile-header"},[_c('div',{class:_vm.classModifiersMobileHeaderTitle},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]),_vm._v(" "),(!_vm.isLayoutDashboard)?_c('div',{staticClass:"market-contract-horizontal-v2__mobile-header-price"},[_c('span',{staticClass:"market-contract-horizontal-v2__current-price-display"},[_c('animated-number',{attrs:{"value":_vm.currentPrice}})],1),_vm._v(" "),_c('market-change-price',{attrs:{"price":_vm.contractModel.changePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-v2__mobile-header-buttons"},[(_vm.isMarketDisabled)?[_c('button',{staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--disabled"},[_vm._v("\n            "+_vm._s(_vm.disabledMarketButtonText)+"\n          ")])]:[_c('div',{staticClass:"market-contract-horizontal-v2__buttons--left"},[(_vm.contractModel.mode === _vm.VALUES.NO)?[(_vm.showOuterPriceButton)?_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyNoCostAsCents,"text":"Buy"}}):_vm._e(),_vm._v(" "),_c('button',{ref:_vm.BUTTONS.BUY_NO.id,staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--buy-no",class:_vm.isButtonActive(_vm.BUTTONS.BUY_NO.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                    _vm.contractModel.contractId, _vm.BUTTONS.BUY_NO.type, _vm.BUTTONS.BUY_NO.value, null, _vm.BUTTONS.BUY_NO.id)}}},[(_vm.showInnerPriceButton)?_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyNoCostAsCents,"layout":"inner","text":"Buy"}}):_c('span',[_vm._v("Buy")])],1)]:[(_vm.showOuterPriceButton)?_c('button-price',{key:_vm.contractModel.buyYesCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyYesCostAsCents,"text":"Buy"}}):_vm._e(),_vm._v(" "),_c('button',{ref:_vm.BUTTONS.BUY_YES.id,staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--buy-yes",class:_vm.isButtonActive(_vm.BUTTONS.BUY_YES.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                    _vm.contractModel.contractId, _vm.BUTTONS.BUY_YES.type, _vm.BUTTONS.BUY_YES.value, null, _vm.BUTTONS.BUY_YES.id)}}},[(_vm.showInnerPriceButton)?_c('button-price',{key:_vm.contractModel.buyYesCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyYesCostAsCents,"layout":"inner","text":"Buy"}}):_c('span',[_vm._v("Buy")])],1)]],2),_vm._v(" "),_c('div',{staticClass:"market-contract-horizontal-v2__buttons--right"},[(_vm.contractModel.mode === _vm.VALUES.NO)?[_c('button',{ref:_vm.BUTTONS.SELL_NO.id,staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--sell-no",class:_vm.isButtonActive(_vm.BUTTONS.SELL_NO.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                    _vm.contractModel.contractId, _vm.BUTTONS.SELL_NO.type, _vm.BUTTONS.SELL_NO.value, null, _vm.BUTTONS.SELL_NO.id)}}},[(_vm.showInnerPriceButton)?_c('button-price',{key:_vm.contractModel.sellNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.sellNoCostAsCents,"layout":"inner","text":"Sell"}}):_c('span',[_vm._v("Sell")])],1),_vm._v(" "),(_vm.showOuterPriceButton)?_c('button-price',{key:_vm.contractModel.sellNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.sellNoCostAsCents,"text":"Sell"}}):_vm._e()]:(_vm.contractModel.mode === _vm.VALUES.YES)?[_c('button',{ref:_vm.BUTTONS.SELL_YES.id,staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--sell-yes",class:_vm.isButtonActive(_vm.BUTTONS.SELL_YES.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                    _vm.contractModel.contractId, _vm.BUTTONS.SELL_YES.type, _vm.BUTTONS.SELL_YES.value, null, _vm.BUTTONS.SELL_YES.id)}}},[(_vm.showInnerPriceButton)?_c('button-price',{key:_vm.contractModel.sellYesCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.sellYesCostAsCents,"layout":"inner","text":"Sell"}}):_c('span',[_vm._v("Sell")])],1),_vm._v(" "),(_vm.showOuterPriceButton)?_c('button-price',{key:_vm.contractModel.sellYesCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.sellYesCostAsCents,"text":"Sell"}}):_vm._e()]:[_c('button',{ref:_vm.BUTTONS.BUY_NO_ALT.id,staticClass:"market-contract-horizontal-v2__button-single market-contract-horizontal-v2__button-single--buy-no",class:_vm.isButtonActive(_vm.BUTTONS.BUY_NO_ALT.id),on:{"click":function($event){$event.stopPropagation();return _vm.openPurchaseJourney(
                    _vm.contractModel.contractId, _vm.BUTTONS.BUY_NO_ALT.type, _vm.BUTTONS.BUY_NO_ALT.value, null, _vm.BUTTONS.BUY_NO_ALT.id)}}},[(_vm.showInnerPriceButton)?_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyNoCostAsCents,"layout":"inner","text":"Buy"}}):_c('span',[_vm._v("Buy No")])],1),_vm._v(" "),(_vm.showOuterPriceButton)?_c('button-price',{key:_vm.contractModel.buyNoCostAsCents,staticClass:"market-contract-horizontal-v2__button-price",attrs:{"price":_vm.contractModel.buyNoCostAsCents,"text":"Buy"}}):_vm._e()]],2)]],2)]),_vm._v(" "),(_vm.showOffersOrShares)?_c('div',{staticClass:"market-contract-horizontal-v2__mobile-footer"},[_c('div',{staticClass:"market-contract-horizontal-v2__shares-offers"},[(_vm.showSharesBar)?_c('div',[(_vm.isLayoutDashboard)?_c('span',{staticClass:"market-contract-horizontal-v2__mobile-footer-title"},[_vm._v("Shares\n          ")]):_vm._e(),_vm._v(" "),_c('market-shares-bar',{attrs:{"mode":_vm.contractModel.mode,"number":_vm.contract.userQuantity,"average":_vm.contractModel.userAveragePricePerShareAsCents,"difference":_vm.contractModel.userChangePriceAsCents,"lastClosePrice":_vm.contractModel.lastClosePrice,"theme":"mobile"},on:{"click":_vm.onClickSharesBar}})],1):[_c('span',[_vm._v(" ")])],_vm._v(" "),(_vm.showOpenOffers)?_c('div',[(_vm.isLayoutDashboard)?_c('span',{staticClass:"market-contract-horizontal-v2__mobile-footer-title"},[_vm._v("\n            Offers\n          ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"market-contract-horizontal-v2__open-offers",on:{"click":function($event){$event.stopPropagation();return _vm.onClickOpenOffers($event)}}},[_vm._v("\n            "+_vm._s(_vm.openOffersText)+"\n          ")])]):_vm._e()],2)]):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uVqX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_trade_confirmed_js__ = __webpack_require__("BmES");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4440742_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_trade_confirmed_vue__ = __webpack_require__("LBfO");
function injectStyle (ssrContext) {
  __webpack_require__("iRLs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_notification_item_trade_confirmed_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4440742_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_trade_confirmed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uVwX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"processing-transaction"},[(_vm.showTimeout)?[_c('div',{staticClass:"processing-transaction__headline"},[_c('h5',{staticClass:"processing-transaction__title processing-transaction__title--warn"},[_vm._v("\n        Processing Timeout\n      ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"button button--large button--primary button--full-width processing-transaction__button",on:{"click":_vm.openDepositHistory}},[_vm._v("\n        Open Deposit History\n      ")])])]:[_c('div',{staticClass:"processing-transaction__loader"}),_vm._v(" "),_c('div',{staticClass:"processing-transaction__processing"},[_vm._v("\n      Processing Transaction...\n    ")])]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("\n          It looks like we are having some communication issues. Don't worry, we will keep trying to complete your deposit. Please check your Deposit History as usually these issues resolve within a few minutes.\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uWVg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uY68":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uaDr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.backgroundModifiers},[_c('div',{staticClass:"row row-xy row-100"},[_c('div',{staticClass:"column small-4 large-12 column-100 account-social-badge__avatar"},[_c('account-social-avatar',{attrs:{"avatar":_vm.userAvatar,"showProgress":!_vm.isTopLevelTrader,"percentage":_vm.progressPercentage,"progressStrokeColor":_vm.progressColor,"backgroundStrokeColor":_vm.levelColor,"theme":_vm.avatarTheme}})],1),_vm._v(" "),_c('div',{staticClass:"column small-8 large-12 large-text-center column-100 account-social-badge__text"},[(_vm.isSocialReady)?[_c('div',{staticClass:"account-social-badge__headline"},[_vm._v("\n          "+_vm._s(_vm.username)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"account-social-badge__level"},[_c('span',{staticClass:"account-social-badge__level-text"},[_vm._v(_vm._s(_vm.level.text))]),_vm._v(" "),_c('span',{staticClass:"account-social-badge__level-num"},[_vm._v("Level "+_vm._s(_vm.level.num))])]),_vm._v(" "),_c('div',{staticClass:"account-social-badge__progress"},[_c('div',{class:_vm.progressBarClassModifiers},[_vm._v(_vm._s(_vm.progressPercentage)+"%")]),_vm._v(" "),_c('div',{staticClass:"account-social-badge__progress-fill",style:(_vm.progressBarStyleModifiers)})]),_vm._v(" "),_c('div',{staticClass:"account-social-badge__footer"},[(_vm.isTopLevelTrader)?[_vm._v("\n            You are a top-level trader!\n          ")]:[_vm._v("\n            "+_vm._s(_vm.progressInfoText)+"\n          ")]],2),_vm._v(" "),(false)?_c('span',{staticClass:"account-social-badge__link",on:{"click":_vm.showBadgesPopup}},[_vm._v(" Your Badges »\n        ")]):_vm._e()]:_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uath":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_contracts_history_js__ = __webpack_require__("1/Lc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42003f4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contracts_history_vue__ = __webpack_require__("Njid");
function injectStyle (ssrContext) {
  __webpack_require__("tkSH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_contracts_history_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42003f4f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contracts_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ucfo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketWidgetLoader_vue__ = __webpack_require__("7Ymm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e12a8e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketWidgetLoader_vue__ = __webpack_require__("pSOo");
function injectStyle (ssrContext) {
  __webpack_require__("8rZo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketWidgetLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e12a8e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketWidgetLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ucfx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TAB_SEVEN_DAYS; });
/* unused harmony export TAB_THIRTY_DAYS */
/* unused harmony export TAB_NINETY_DAYS */
/* unused harmony export TAB_TWENTY_FOUR_HOURS */
/* unused harmony export TAB_RANGE */
/* unused harmony export TAB_STATS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generics_tabs_tabs_vue__ = __webpack_require__("sJdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__("c/9r");









var MARKET_OPEN_DAYS_TWENTY_HOUR_CHART = 2;
var TAB_SEVEN_DAYS = '7d';
var TAB_THIRTY_DAYS = '30d';
var TAB_NINETY_DAYS = '90d';
var TAB_TWENTY_FOUR_HOURS = '24h';
var TAB_RANGE = '0';
var TAB_STATS = 'stats';

var TAB_LINE = 'line';
var TAB_CANDLE = 'candle';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */]],
  components: {
    tabs: __WEBPACK_IMPORTED_MODULE_4__components_generics_tabs_tabs_vue__["a" /* default */]
  },
  props: {
    market: {
      type: Object,
      required: true
    },
    chartOptions: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      activeTabPeriod: null,
      activeTabType: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop', 'isLayoutMobile']), {
    tabsPeriodStyleModifiers: function tabsPeriodStyleModifiers() {
      if (this.isLayoutDesktop) {
        return {
          width: this.tabsPeriod.length * 70 + 'px'
        };
      }
      return {};
    },
    statsOptionAvailable: function statsOptionAvailable() {
      return this.chartOptions === null;
    },
    useDateRange: function useDateRange() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'useDateRange', false);
    },
    defaultOffsetValue: function defaultOffsetValue() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'defaultOffsetValue', null);
    },
    showDateRangeTab: function showDateRangeTab() {
      return this.useDateRange && __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'startDate', null) !== null && __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'endDate', null) !== null;
    },
    showDefaultOffsetTab: function showDefaultOffsetTab() {
      return !this.useDateRange && this.defaultOffsetValue !== null;
    },
    showAxisAsHours: function showAxisAsHours() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'showAxisAsHours', false);
    },
    defaultOffsetTab: function defaultOffsetTab() {
      var titleSuffix = this.showAxisAsHours ? 'hr' : ' Day';
      // const title = `${this.defaultOffsetValue} ${titleSuffix}`;
      var nameSuffix = this.showAxisAsHours ? 'h' : 'd';
      var name = '' + this.defaultOffsetValue + nameSuffix;
      return { name: name, title: null, icon: 'calendar' };
    },
    defaultRangeTab: function defaultRangeTab() {
      var suffix = this.showAxisAsHours ? 'h' : 'd';
      return { name: '' + TAB_RANGE + suffix, title: null, icon: 'calendar' };
    },
    tabsPeriod: function tabsPeriod() {
      var _this = this;

      var items = [];

      if (this.statsOptionAvailable && !this.isLayoutDesktop) {
        items.push({ name: TAB_STATS, title: 'Stats', kind: 'stats' });
      }

      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'include24hr', false)) {
        items.push({ name: TAB_TWENTY_FOUR_HOURS, title: '24hr' });
      }
      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'include7day', false)) {
        items.push({ name: TAB_SEVEN_DAYS, title: '7 Day' });
      }
      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'include30day', false)) {
        items.push({ name: TAB_THIRTY_DAYS, title: '30 Day' });
      }
      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'include90day', false)) {
        items.push({ name: TAB_NINETY_DAYS, title: '90 Day' });
      }
      if (this.showDateRangeTab) {
        items.push(this.defaultRangeTab);
      } else if (this.showDefaultOffsetTab && !items.find(function (i) {
        return i.name === _this.defaultOffsetTab.name;
      })) {
        items.push(this.defaultOffsetTab);
      }
      return items;
    },
    tabsType: function tabsType() {
      var items = [];
      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'includeCandle', false)) {
        items.push({ name: TAB_CANDLE, title: 'Candle' });
      }
      if (this.chartOptions === null || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.chartOptions, 'includeLine', false)) {
        items.push({ name: TAB_LINE, title: 'Line' });
      }
      return items;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('popup', ['setGenericPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('market', ['setChartTimeline', 'getMarketContractsStats', 'setChartType']), {
    onTitleClick: function onTitleClick() {
      var _this2 = this;

      this.loaderAdd();
      this.getMarketContractsStats(this.market.marketId).then(function (data) {
        _this2.loaderRemove();
        _this2.setGenericPopup({
          name: 'market-contracts-stats',
          options: {
            stats: data,
            isFixed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["f" /* hasMarketHiddenContracts */])(_this2.market)
          }
        });
      }).catch(function () {
        return _this2.loaderRemove();
      });
    },
    tabChangePeriod: function tabChangePeriod(name) {
      this.activeTabPeriod = name;
      this.setChartTimeline(name);
      this.$emit('timelineChange', this.activeTabPeriod);
    },
    tabChangeType: function tabChangeType(name) {
      this.activeTabType = name;
      this.setChartType(name);
      this.$emit('typeChange', this.activeTabType);
    },
    tabsPeriodHandler: function tabsPeriodHandler(value) {
      var dateOpenedDayDiff = __WEBPACK_IMPORTED_MODULE_3_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.market.dateOpened), 'days');
      var activeTabPeriod = dateOpenedDayDiff < MARKET_OPEN_DAYS_TWENTY_HOUR_CHART ? TAB_TWENTY_FOUR_HOURS : TAB_SEVEN_DAYS;

      if (this.showDateRangeTab) {
        activeTabPeriod = this.defaultRangeTab.name;
      } else if (this.showDefaultOffsetTab) {
        activeTabPeriod = this.defaultOffsetTab.name;
      }

      var activeTab = value.find(function (i) {
        return i.name === activeTabPeriod;
      });
      if (activeTab) {
        this.activeTabPeriod = activeTabPeriod;
      } else {
        this.activeTabPeriod = value[0].name;
      }
    },
    tabsTypeHandler: function tabsTypeHandler(value) {
      if (value.find(function (i) {
        return i.name === TAB_LINE;
      })) {
        this.activeTabType = TAB_LINE;
      } else {
        this.activeTabType = value[0].name;
      }
    }
  }),
  watch: {
    tabsPeriod: {
      handler: 'tabsPeriodHandler',
      immediate: true
    },
    tabsType: {
      handler: 'tabsTypeHandler',
      immediate: true
    }
  }
});

/***/ }),

/***/ "ue1S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mySharesCount > 0)?_c('div',{class:_vm.classModifiers},[_c('button',{staticClass:"button button--primary dashboard-markets-toggle__button",on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_vm._v(_vm._s(_vm.buttonText))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ufSN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "umUo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_cmsContent__ = __webpack_require__("tQfv");







var toRoute = '';
var restore = true;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_cmsContent__["a" /* default */]],
  metaInfo: function metaInfo() {
    return {
      title: 'Privacy Policy'
    };
  },
  data: function data() {
    return {
      content: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  created: function created() {
    var _this = this;

    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* STATIC_PAGES */].PRIVACY).then(function (data) {
      _this.installDynamicControls({ data: data });
    });
  },
  beforeDestroy: function beforeDestroy() {
    // firest after router loop
    if (restore) {
      __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].dispatch('popup/restorePopup', toRoute);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var popup = to.params.noPopup ? null : __WEBPACK_IMPORTED_MODULE_3__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_VERIFY;
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].dispatch('popup/rememberPopup', {
      route: from.name,
      popup: popup
    });
    next();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // fires before router loop closes popup
    restore = to.name !== 'terms-and-conditions';
    toRoute = to.name;
    next();
  }
});

/***/ }),

/***/ "uoxE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposited"},[_c('div',{staticClass:"row"},[(_vm.currentDeposit.account && _vm.currentDeposit.matched > 0)?[_c('div',{class:_vm.leftColClassModifiers},[_c('div',{staticClass:"deposited__title deposited__title--small"},[_vm._v("Transferred")]),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small",domProps:{"innerHTML":_vm._s(_vm.amountFormatted)}})]),_vm._v(" "),(_vm.hasPromotionalCredit)?_c('div',{staticClass:"small-4 column deposited__divider"},[_c('div',{staticClass:"deposited__title deposited__title--small"},[(_vm.isLayoutDesktop)?[_vm._v("\n            Promotional Credit\n          ")]:[_vm._v("\n            Credit\n          ")]],2),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small",domProps:{"innerHTML":_vm._s(_vm.matchedFormatted)}})]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.rightColClassModifiers},[_c('div',{staticClass:"deposited__title deposited__title--small"},[_vm._v("Available")]),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small"},[_vm._v(_vm._s(_vm.balance.accountBalance))])])]:[_c('div',{class:_vm.leftColClassModifiers},[_c('div',{staticClass:"deposited__title deposited__title--small"},[_vm._v("Deposited")]),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small",domProps:{"innerHTML":_vm._s(_vm.amountFormatted)}})]),_vm._v(" "),(_vm.hasPromotionalCredit)?_c('div',{staticClass:"small-4 column deposited__divider"},[_c('div',{staticClass:"deposited__title deposited__title--small"},[(_vm.isLayoutDesktop)?[_vm._v("\n            Promotional Credit\n          ")]:[_vm._v("\n            Credit\n          ")]],2),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small",domProps:{"innerHTML":_vm._s(_vm.promoAmountFormatted)}})]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.rightColClassModifiers},[_c('div',{staticClass:"deposited__title deposited__title--small"},[_vm._v("Available")]),_vm._v(" "),_c('div',{staticClass:"deposited__amount deposited__amount--small"},[_vm._v(_vm._s(_vm.balance.accountBalance))])])],_vm._v(" "),_c('div',{staticClass:"column small-12"},[(_vm.currentDeposit.account)?_c('div',{staticClass:"deposited__confirmation-number",domProps:{"innerHTML":_vm._s(_vm.currentDeposit.messageForUser)}}):_c('div',{staticClass:"deposited__confirmation-number"},[_vm._v("\n        Your confirmation number for this transaction is "+_vm._s(_vm.currentDeposit.confirmationNumber)+".\n      ")])]),_vm._v(" "),(_vm.currentDeposit.account)?_c('div',{staticClass:"column small-12"},[_c('bank-account',{staticClass:"deposited__account",attrs:{"preview":true,"account":_vm.currentDeposit.account}})],1):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "urbP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "uvwz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_state_icon_js__ = __webpack_require__("0HU1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_793b52de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_state_icon_vue__ = __webpack_require__("+YUt");
function injectStyle (ssrContext) {
  __webpack_require__("rkCW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_state_icon_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_793b52de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_state_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v+Mv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_terms_and_conditions_js__ = __webpack_require__("xqHz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6df6f9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_terms_and_conditions_vue__ = __webpack_require__("ECXD");
function injectStyle (ssrContext) {
  __webpack_require__("9kST")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_terms_and_conditions_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6df6f9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_terms_and_conditions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v0+/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-contracts-stats-popup"},[_c('switch-modal',{staticClass:"modal-switch--contracts-stats",attrs:{"showSwitchButton":false},on:{"modalClose":_vm.close}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Trading Statistics")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{class:_vm.classModifiers},[_c('market-contracts-stats',{attrs:{"isFixed":_vm.isFixed,"stats":_vm.stats}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v0Cj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_orientation_info_js__ = __webpack_require__("XrgL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c1bb005_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orientation_info_vue__ = __webpack_require__("G6+2");
function injectStyle (ssrContext) {
  __webpack_require__("72gB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_orientation_info_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c1bb005_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orientation_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v8MK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dashboard_portfolio_my_markets_portfolio_my_markets_vue__ = __webpack_require__("UIPs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_market_market_filters_market_filters_dashboard_market_filters_dashboard_vue__ = __webpack_require__("of0E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dashboard_dashboard_markets_toggle_dashboard_markets_toggle_vue__ = __webpack_require__("zkja");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    dashboardMarketFilters: __WEBPACK_IMPORTED_MODULE_3__components_market_market_filters_market_filters_dashboard_market_filters_dashboard_vue__["a" /* default */],
    portfolioMyMarkets: __WEBPACK_IMPORTED_MODULE_2__components_dashboard_portfolio_my_markets_portfolio_my_markets_vue__["a" /* default */],
    dashboardMarketsToggle: __WEBPACK_IMPORTED_MODULE_4__components_dashboard_dashboard_markets_toggle_dashboard_markets_toggle_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('dashboard', ['mySharesTotalGainLoss']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('wallet', ['portfolioValueDecimal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('dashboard', ['mySharesReady']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['balance']), {
    portfolioValueReady: function portfolioValueReady() {
      return !this.balance.isDefault && this.mySharesReady;
    },
    gainLossClassModifiers: function gainLossClassModifiers() {
      var value = this.mySharesTotalGainLoss;
      return {
        'dashboard-portfolio__summary-item-value--plus': value > 0,
        'dashboard-portfolio__summary-item-value--minus': value < 0
      };
    }
  })
});

/***/ }),

/***/ "vJHd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



var PROCESSING_TRANSACTION_TIMEOUT = 20;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      timeout: null,
      showTimeout: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('wallet', ['getBalance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    openDepositHistory: function openDepositHistory() {
      this.getBalance();
      this.setCurrentPopup();
      this.$router.push({ name: 'account-history', query: { tabId: 'deposit-withdrawals' } });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.timeout = setTimeout(function () {
      _this.showTimeout = true;
    }, PROCESSING_TRANSACTION_TIMEOUT * 1000);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
});

/***/ }),

/***/ "vJzj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_captcha_captcha_vue__ = __webpack_require__("aDe5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_checkbox_checkbox_vue__ = __webpack_require__("vXhB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_errors_errors_vue__ = __webpack_require__("dimc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_input_input_vue__ = __webpack_require__("UWgA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_radio_radio_vue__ = __webpack_require__("K2ud");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_select_select_vue__ = __webpack_require__("x+uv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_forms_socials_socials_vue__ = __webpack_require__("NqVK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_forms_submit_submit_vue__ = __webpack_require__("GgQs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_forms_textarea_textarea_vue__ = __webpack_require__("3ggI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_forms_password_requirements_password_requirements_vue__ = __webpack_require__("EjHU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_show_password_icon_show_password_icon_vue__ = __webpack_require__("OIiS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_validators__ = __webpack_require__("SVQh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_12__helpers_validators__["a"]; });















var ERROR_GENERIC = 'There was an error processing your request. Please try again.';
var ERROR_UNAUTHORIZED = '401 Unauthorized';
var ERROR_UNAUTHORIZED_MESSAGE = 'This account has been closed.';

var formMixin = {
  components: {
    formCaptcha: __WEBPACK_IMPORTED_MODULE_1__components_forms_captcha_captcha_vue__["a" /* default */],
    formCheckbox: __WEBPACK_IMPORTED_MODULE_2__components_forms_checkbox_checkbox_vue__["a" /* default */],
    formErrors: __WEBPACK_IMPORTED_MODULE_3__components_forms_errors_errors_vue__["a" /* default */],
    formInput: __WEBPACK_IMPORTED_MODULE_4__components_forms_input_input_vue__["a" /* default */],
    formRadio: __WEBPACK_IMPORTED_MODULE_5__components_forms_radio_radio_vue__["a" /* default */],
    formSelect: __WEBPACK_IMPORTED_MODULE_6__components_forms_select_select_vue__["a" /* default */],
    formSocials: __WEBPACK_IMPORTED_MODULE_7__components_forms_socials_socials_vue__["a" /* default */],
    formSubmit: __WEBPACK_IMPORTED_MODULE_8__components_forms_submit_submit_vue__["a" /* default */],
    formTextarea: __WEBPACK_IMPORTED_MODULE_9__components_forms_textarea_textarea_vue__["a" /* default */],
    passwordRequirements: __WEBPACK_IMPORTED_MODULE_10__components_forms_password_requirements_password_requirements_vue__["a" /* default */],
    showPasswordIcon: __WEBPACK_IMPORTED_MODULE_11__components_show_password_icon_show_password_icon_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      errors: [],
      fields: {},
      isFormEnabled: true
    };
  },

  computed: {
    isFormDisabled: function isFormDisabled() {
      return this.isFormEnabled === false;
    },
    invalidOrDisabled: function invalidOrDisabled() {
      return this.$v.$invalid || !this.isFormEnabled;
    }
  },
  methods: {
    formIsValid: function formIsValid() {
      return !this.$v.$invalid;
    },
    formEnable: function formEnable() {
      this.isFormEnabled = true;
    },
    formDisable: function formDisable() {
      this.formReset();
      this.isFormEnabled = false;
      return true;
    },
    formReset: function formReset() {
      this.errors = [];
    },
    formHandleErrors: function formHandleErrors(error) {
      var _this = this;

      this.formEnable();
      try {
        if (error && error.response && error.response.data) {
          if (error.response.data instanceof Array) {
            error.response.data.forEach(function (e) {
              return _this.errors.push(e.message);
            });
          } else if (error.response.data.error_description) {
            var description = error.response.data.error_description;
            if (typeof description === 'string') {
              description = JSON.parse(description);
            }
            description.forEach(function (e) {
              return _this.errors.push(e.Message);
            });
          } else if (error.response.data.message) {
            this.errors.push(error.response.data.message);
          } else if (error.response.data.error) {
            if (error.response.data.error === ERROR_UNAUTHORIZED) {
              this.errors.push(ERROR_UNAUTHORIZED_MESSAGE);
            } else {
              this.errors.push(error.response.data.error);
            }
          }
        }
      } catch (e) {
        this.errors.push(ERROR_GENERIC);
      }

      if (__WEBPACK_IMPORTED_MODULE_13__mixins_userAgent__["c" /* isIos */]) {
        this.$el.scrollIntoView(true);
      }
    },
    tabTo: function tabTo(e, next) {
      if (e) {
        if (!this.$refs[next]) return;
        var input = this.$refs[next].$el.getElementsByTagName('input')[0];
        if (input) {
          input.focus();
        }
      }
    }
  }
};


/* unused harmony default export */ var _unused_webpack_default_export = (formMixin);

/***/ }),

/***/ "vTdY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-not-found"},[_c('div',{staticClass:"page-not-found__header"},[_vm._v("\n    "+_vm._s(_vm.$txt('page-not-found.title'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"page-not-found__content"},[_c('h1',{staticClass:"page-not-found__header-main"},[_vm._v("\n      "+_vm._s(_vm.$txt('page-not-found.header'))+"\n    ")]),_vm._v(" "),_c('h3',{staticClass:"page-not-found__header-secondary"},[_vm._v("\n      "+_vm._s(_vm.$txt('page-not-found.message'))+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vUm4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-already-exists"},[_c('p',[_vm._v("\r\n    Your account '"+_vm._s(_vm.email)+"' already exists. Click Next to sign in with that account.\r\n  ")]),_vm._v(" "),_c('div',{staticClass:"account-already-exists__button"},[_c('button',{staticClass:"button button--large button--primary button--full-width",on:{"click":_vm.onLogin}},[_vm._v("\r\n        Next\r\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vV6Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_sumBy__ = __webpack_require__("XDNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flatten__ = __webpack_require__("rCVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_market_market_list_item_expandable_market_list_item_expandable_vue__ = __webpack_require__("Ui3/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_market_market_list_item_expandable_market_list_item_expandable__ = __webpack_require__("SO44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");




/* eslint-disable arrow-body-style */










var MY_SHARES_INITIAL = 0.0;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_contentLoader__["a" /* default */]],
  components: {
    marketListItemExpandable: __WEBPACK_IMPORTED_MODULE_5__components_market_market_list_item_expandable_market_list_item_expandable_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: true,
      toggledItems: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('dashboard', ['myShares', 'marketsToggle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('popup', ['currentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('trade', ['tradeOptions']), {
    marketsNumber: function marketsNumber() {
      return this.myShares ? this.myShares.markets.length : 0;
    },
    marketsShares: function marketsShares() {
      var markets = this.myShares && this.myShares.markets ? this.myShares.markets : [];
      return markets.reduce(function (previous, current) {
        var userQuantity = __WEBPACK_IMPORTED_MODULE_2_lodash_sumBy___default()(current.marketContracts, function (i) {
          return i.userQuantity;
        });
        return previous + userQuantity;
      }, MY_SHARES_INITIAL);
    },
    filteredMarkets: function filteredMarkets() {
      var markets = this.myShares && this.myShares.markets ? this.myShares.markets : [];
      var statuses = [__WEBPACK_IMPORTED_MODULE_9__constants__["a" /* default */].MARKET_SETTLED];
      return markets.filter(function (m) {
        return !statuses.includes(m.status);
      }).filter(function (m) {
        return __WEBPACK_IMPORTED_MODULE_2_lodash_sumBy___default()(m.marketContracts, function (i) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["m" /* contractOwnershipNum */])(i);
        }) > 0;
      });
    },
    filteredMarketsContractsIds: function filteredMarketsContractsIds() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_flatten___default()(this.filteredMarkets.map(function (market) {
        return market.marketContracts;
      })).filter(function (i) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["m" /* contractOwnershipNum */])(i) > 0;
      }).map(function (i) {
        return i.contractId;
      });
    },
    showMarketsList: function showMarketsList() {
      return this.marketsNumber > 0;
    },
    showNoSharesPlaceholder: function showNoSharesPlaceholder() {
      return this.marketsNumber === 0 && !this.isLoading;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('dashboard', ['getMyShares', 'setDashboardOpen']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('trade', ['setTradeOptions']), {
    isItemExpanded: function isItemExpanded(marketId) {
      var item = this.toggledItems.find(function (i) {
        return i.marketId === marketId;
      });
      return !!item;
    },
    isExpandingAllTriggered: function isExpandingAllTriggered(marketId) {
      var item = this.toggledItems.find(function (i) {
        return i.marketId === marketId;
      }) || {};
      return item.expandAll;
    },
    onMarketListItemToggle: function onMarketListItemToggle(data) {
      if (data.expanded) {
        this.toggledItems.push({
          marketId: data.market.marketId,
          expandAll: false
        });
      } else {
        this.toggledItems = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.toggledItems.filter(function (i) {
          return i.marketId !== data.market.marketId;
        })));
      }
    },
    scrollToMarketsSection: function scrollToMarketsSection() {
      var _this = this;

      setTimeout(function () {
        var elOffset = _this.$refs.myshares.offsetTop;
        var offset = _this.isLayoutMobile ? elOffset - 45 : elOffset - 95;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_scrollTo__["a" /* default */])(offset, 500);
      }, __WEBPACK_IMPORTED_MODULE_6__components_market_market_list_item_expandable_market_list_item_expandable__["a" /* OFFSET_CHECK_TIMEOUT */]);
    }
  }),
  watch: {
    marketsToggle: function marketsToggle(value) {
      if (value) {
        this.toggledItems = this.filteredMarkets.map(function (i) {
          return {
            marketId: i.marketId,
            expandAll: true
          };
        });
        this.scrollToMarketsSection();
      } else {
        this.toggledItems = [];
      }
    },
    filteredMarketsContractsIds: function filteredMarketsContractsIds() {
      if (this.currentPopup === __WEBPACK_IMPORTED_MODULE_11__components_app_app_modals_app_modals__["a" /* MODALS */].PURCHASE && this.tradeOptions && this.tradeOptions.contractId && !this.filteredMarketsContractsIds.includes(this.tradeOptions.contractId)) {
        this.setCurrentPopup();
        this.setTradeOptions(null);
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.getMyShares().then(function () {
      _this2.isLoading = false;
      _this2.isComponentReady = true;
    }).catch(function () {
      _this2.isLoading = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.setTradeOptions(null);
  }
});

/***/ }),

/***/ "vXhB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_checkbox_js__ = __webpack_require__("a8vN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46a22c4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__ = __webpack_require__("sB0D");
function injectStyle (ssrContext) {
  __webpack_require__("cyZn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_checkbox_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46a22c4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vdcn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PURCHASE_DEFAULT_LABEL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_contract__ = __webpack_require__("YZ+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");





var PURCHASE_DEFAULT_LABEL = 'N/A';

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      capitalizeFirstLetter: __WEBPACK_IMPORTED_MODULE_3__utils_helpers__["n" /* capitalizeFirstLetter */]
    };
  },

  props: {
    contract: {
      type: Object,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('trade', ['tradeOptions']), {
    contractModel: function contractModel() {
      return new __WEBPACK_IMPORTED_MODULE_2__models_contract__["a" /* default */](this.contract);
    },
    typeFirst: function typeFirst() {
      return 'buy';
    },
    typeSecond: function typeSecond() {
      if (this.contractModel.mode === 'yes') {
        return 'sell';
      } else if (this.contractModel.mode === 'no') {
        return 'sell';
      }
      return 'buy';
    },
    valueFirst: function valueFirst() {
      if (this.contractModel.mode === 'no') {
        return 'no';
      }
      return 'yes';
    },
    valueSecond: function valueSecond() {
      if (this.contractModel.mode === 'yes') {
        return 'yes';
      } else if (this.contractModel.mode === 'no') {
        return 'no';
      }
      return 'no';
    },
    priceFirst: function priceFirst() {
      var price = this.contractModel.buyYesCostAsCents;
      if (this.contractModel.mode === 'no') {
        price = this.contractModel.buyNoCostAsCents;
      }
      if (price === 100) {
        return '$1';
      }
      return price > 0 ? price + '\xA2' : PURCHASE_DEFAULT_LABEL;
    },
    priceSecond: function priceSecond() {
      var price = this.contractModel.buyNoCostAsCents;
      if (this.contractModel.mode === 'yes') {
        price = this.contractModel.sellYesCostAsCents;
      } else if (this.contractModel.mode === 'no') {
        price = this.contractModel.sellNoCostAsCents;
      }
      if (price === 100) {
        return '$1';
      }
      return price > 0 ? price + '\xA2' : PURCHASE_DEFAULT_LABEL;
    },
    priceFirstClassModifier: function priceFirstClassModifier() {
      return {
        'purchase-yes-no-switcher__button': true,
        'purchase-yes-no-switcher__button--yes': this.contractModel.mode !== 'no',
        'purchase-yes-no-switcher__button--no': this.contractModel.mode === 'no',
        'purchase-yes-no-switcher__button--active': this.isFirstActive
      };
    },
    priceSecondClassModifier: function priceSecondClassModifier() {
      return {
        'purchase-yes-no-switcher__button': true,
        'purchase-yes-no-switcher__button--yes': this.contractModel.mode === 'yes',
        'purchase-yes-no-switcher__button--no': this.contractModel.mode !== 'yes',
        'purchase-yes-no-switcher__button--active': !this.isFirstActive
      };
    },
    isFirstActive: function isFirstActive() {
      if (this.contractModel.mode !== '') {
        return this.tradeOptions.operationType === 'buy';
      }
      return this.tradeOptions.operationType === 'buy' && this.tradeOptions.operationValue !== 'no';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('trade', ['setTradeOptions']), {
    switchOperation: function switchOperation(operationType, operationValue) {
      this.setTradeOptions({
        contractId: this.contract.contractId,
        operationType: operationType,
        defaultTab: null,
        operationValue: operationValue
      });
    },
    priceFirstClicked: function priceFirstClicked() {
      if (this.isFirstActive) return;
      this.switchOperation(this.typeFirst, this.valueFirst);
    },
    priceSecondClicked: function priceSecondClicked() {
      if (!this.isFirstActive) return;
      this.switchOperation(this.typeSecond, this.valueSecond);
    }
  })
});

/***/ }),

/***/ "vgpr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "voqc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.classModifiers,attrs:{"to":_vm.routeTo}},[_c('div',{class:_vm.iconClassModifiers,style:(_vm.iconStyleModifiers)}),_vm._v(" "),_c('div',{staticClass:"notification-item-dashboard__content"},[_c('div',{staticClass:"notification-item-dashboard__title"},[_c('div',{staticClass:"notification-item-dashboard__title-left"},[_vm._v("\n        "+_vm._s(_vm.data.contentJson.Title)+"\n      ")]),_vm._v(" "),(_vm.showPriceChange)?[_c('div',{staticClass:"notification-item-dashboard__title-right"},[_vm._v("\n          "+_vm._s(_vm.lastTradePriceAsCents)+"¢\n          "),_c('market-change-price',{attrs:{"price":_vm.data.contentJson.PriceDelta}})],1)]:_vm._e()],2),_vm._v(" "),(_vm.showContractName)?_c('h5',{staticClass:"notification-item-dashboard__contract-name"},[_vm._v("\n      "+_vm._s(_vm.data.contentJson.ContractName)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.showLevelChanged)?[_c('h5',{staticClass:"notification-item-dashboard__level-changed-body"},[_vm._v("\n        "+_vm._s(_vm.data.contentJson.Body)+"\n      ")]),_vm._v(" "),(_vm.showNextLevelInfo)?_c('h5',{staticClass:"notification-item-dashboard__level-changed-info"},[_vm._v("\n        "+_vm._s(_vm.getProgressInfoTextForLevel(_vm.data.contentJson.NewTraderLevel, _vm.data.contentJson.ProfitablePredictions))+"\n      ")]):_vm._e()]:_c('h5',{staticClass:"notification-item-dashboard__market-name"},[_vm._v("\n      "+_vm._s(_vm.data.contentJson.MarketName)+"\n    ")]),_vm._v(" "),(_vm.showPayout)?[_c('div',{staticClass:"notification-item-dashboard__payout"},[_vm._v("\n        Payout: "),_c('span',{directives:[{name:"price-display",rawName:"v-price-display.round2.fixed",value:(_vm.data.contentJson.Cash),expression:"data.contentJson.Cash",modifiers:{"round2":true,"fixed":true}}]})])]:_vm._e(),_vm._v(" "),(_vm.showSellInfo)?[_c('div',{staticClass:"notification-item-dashboard__sell-info"},[_vm._v("\n        "+_vm._s(_vm.tradeTypeOperation)+" "),_c('span',{class:_vm.quantityModifiers},[_vm._v(_vm._s(_vm.quantity))]),_vm._v(" "),(_vm.tradeTypeShare)?_c('span',{staticClass:"notification-item-dashboard__sell-info-contract"},[_vm._v("\n          in "+_vm._s(_vm.tradeTypeShare)+"\n        ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"notification-item-dashboard__sell-info-price"},[_vm._v("\n          @ "+_vm._s(_vm.pricePerShare)+"¢\n        ")])])]:_vm._e(),_vm._v(" "),(_vm.showSharesOwned)?[_c('div',{staticClass:"notification-item-dashboard__shares"},[_c('span',{class:_vm.quantityModifiers},[_vm._v(_vm._s(_vm.sharesOwned))]),_vm._v(" Share"),(_vm.sharesOwned >1)?[_vm._v("s")]:_vm._e(),_vm._v(" Owned\n      ")],2)]:_vm._e(),_vm._v(" "),(_vm.showTimeElapsed)?_c('div',{staticClass:"notification-item-dashboard__time-elapsed"},[_vm._v("\n      "+_vm._s(_vm.timeElapsed)+"\n    ")]):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.closeButton),expression:"closeButton"}],staticClass:"notification-item-dashboard__close",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onClose($event)}}})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vxYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_desktop_grid_js__ = __webpack_require__("D+Yn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cbb9f02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_desktop_grid_vue__ = __webpack_require__("4n2q");
function injectStyle (ssrContext) {
  __webpack_require__("9W9C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_filters_desktop_grid_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cbb9f02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_filters_desktop_grid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w009":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_change_price_js__ = __webpack_require__("mBiY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60329490_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_change_price_vue__ = __webpack_require__("a9og");
function injectStyle (ssrContext) {
  __webpack_require__("CBfy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_market_change_price_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60329490_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_market_change_price_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w0Aq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_widget_js__ = __webpack_require__("Efhk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e9ece3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_widget_vue__ = __webpack_require__("bCxM");
function injectStyle (ssrContext) {
  __webpack_require__("haTa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_widget_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e9ece3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w1pb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_youtube_embed__ = __webpack_require__("5/be");



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    getYoutubeUrl: function getYoutubeUrl() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_youtube_embed__["b" /* getIdFromURL */])('https://www.youtube.com/watch?v=NfWU0Wiixuo');
    }
  }
});

/***/ }),

/***/ "w4tW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.preview)?_c('div',[_c('div',{staticClass:"bank-account bank-account--preview"},[_c('div',{staticClass:"bank-account__icon"},[_c('img',{attrs:{"src":_vm.account.bankInfo.bankIconUrl}})]),_vm._v(" "),_c('div',{staticClass:"bank-account__bank-title bank-account__bank-title--summary"},[_vm._v("\n        "+_vm._s(_vm.account.bankInfo.bankDisplayName)+"\n      ")]),_vm._v(" "),_c('div',[_vm._v("\n        "+_vm._s(_vm.account.bankInfo.bankAccountDisplayName)+"\n      ")])])]):_c('div',{class:_vm.classModifiers,on:{"click":function($event){return _vm.$emit('select')}}},[_c('div',{staticClass:"bank-account__icon"},[_c('img',{attrs:{"src":_vm.account.bankInfo.bankIconUrl}})]),_vm._v(" "),_c('div',{staticClass:"bank-account__bank"},[_c('div',{staticClass:"bank-account__bank-title"},[_vm._v("\n        "+_vm._s(_vm.account.bankInfo.bankDisplayName)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"bank-account__bank-account"},[_vm._v("\n        "+_vm._s(_vm.account.bankInfo.bankAccountDisplayName)+"\n      ")])]),_vm._v(" "),(_vm.removable)?_c('div',{staticClass:"bank-account__remove-wrapper",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('remove', _vm.account)}}},[_c('div',{staticClass:"bank-account__remove"})]):_vm._e(),_vm._v(" "),(_vm.showStatusMessage)?_c('div',{staticClass:"bank-account__message"},[_vm._v("\n      "+_vm._s(_vm.account.accountStatusMessage)+"\n    ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w70/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    },
    href: {
      type: Object,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    date: {
      type: String,
      default: ''
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']))
});

/***/ }),

/***/ "wOlf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"currency-input"},[_c('input',{ref:"input",domProps:{"value":_vm.valueWithCent},on:{"input":function($event){return _vm.updateValue($event.target.value)},"blur":_vm.onBlur,"focus":_vm.onFocus,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onBlur($event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wQDz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_tax_info_notification_js__ = __webpack_require__("XzHq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76aa5b50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tax_info_notification_vue__ = __webpack_require__("GnhT");
function injectStyle (ssrContext) {
  __webpack_require__("iE4u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_tax_info_notification_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76aa5b50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tax_info_notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wU6a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },

  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),

/***/ "wWzM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__("G/BR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_query__ = __webpack_require__("sLBT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__ = __webpack_require__("w009");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    marketChangePrice: __WEBPACK_IMPORTED_MODULE_4__components_market_market_change_price_market_change_price_vue__["a" /* default */]
  },
  props: {
    widget: Object
  },
  computed: {
    obj: function obj() {
      return this.widget ? this.widget : {};
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['addFilter', 'setTimespanFromQuery', 'setOrderFromQuery']), {
    onClick: function onClick() {
      var _this = this;

      if (this.obj.marketUrl) {
        var queryObj = __WEBPACK_IMPORTED_MODULE_3__helpers_query__["a" /* default */].unserializeQuery(this.obj.marketUrl);
        var storeModified = false;
        if (queryObj.filterIds) {
          queryObj.filterIds.split(',').forEach(function (i) {
            var filterId = parseInt(i, 10);
            __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].info('[MARKETS] filterId passed: ' + filterId);
            if (filterId) {
              storeModified = true;
              _this.addFilter(filterId);
            }
          });
        }
        if (queryObj.sortParameter) {
          storeModified = true;
          this.setTimespanFromQuery(queryObj.sortParameter);
        }
        if (queryObj.sort) {
          storeModified = true;
          this.setOrderFromQuery(queryObj.sort);
        }
        var url = storeModified ? this.obj.marketUrl + '&widget' : this.obj.marketUrl;
        this.$router.push(url);
      }
    }
  })
});

/***/ }),

/***/ "waMS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_withdraw_confirm_js__ = __webpack_require__("8I/4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64207097_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_withdraw_confirm_vue__ = __webpack_require__("ahPG");
function injectStyle (ssrContext) {
  __webpack_require__("gLxY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_withdraw_confirm_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64207097_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_withdraw_confirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "waSD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq"},[_c('div',{class:_vm.mainRowModifiers},[_c('div',{staticClass:"column small-12"},[(_vm.isLayoutMobile)?_c('content-header',{attrs:{"title":_vm.title}}):_c('div',{staticClass:"faq__desktop-header"},[_c('router-link',{staticClass:"faq__back",attrs:{"to":{name: 'HelpAndSupport'},"tag":"span"}},[_vm._v("\r\n          Help and Support\r\n        ")])],1)],1),_vm._v(" "),_c('div',{class:_vm.mainColumnModifiers},[(!_vm.isLayoutMobile)?_c('div',{staticClass:"faq__header"},[_vm._v("Frequently Asked Questions")]):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('div',{staticClass:"faq__content"},[_c('faq-search-input',{staticClass:"faq__search",attrs:{"initial":_vm.$route.query.query},on:{"init":_vm.initializeComponentWithSearchTerm,"search":_vm.updateSearch}}),_vm._v(" "),_vm._l((_vm.filteredFAQs),function(item,index){return _c('div',{attrs:{"id":("faq-" + index)}},[_c('collapsible-panel',{key:item.id,attrs:{"isOpen":_vm.expanded,"title":item.name,"accordion":_vm.accordion,"id":("faq-" + index)},on:{"open":_vm.accordionOpen}},_vm._l((item.faqs),function(qa){return _c('collapsible-panel-simple',{key:qa.id,staticClass:"faq__qa",attrs:{"isOpen":_vm.expanded,"title":qa.title,"accordion":_vm.accordionQA,"id":qa.id},on:{"open":_vm.accordionOpenQA}},[_c('div',{domProps:{"innerHTML":_vm._s(qa.description)}})])}),1)],1)}),_vm._v(" "),(_vm.isEmpty)?_c('p',{staticClass:"faq__no-result"},[_vm._v("\r\n          No results found for \""+_vm._s(_vm.searchTerm)+"\"\r\n        ")]):_vm._e()],2):_vm._e()]),_vm._v(" "),(_vm.showVideos)?_c('div',{staticClass:"column large-4"},[_c('videos',{attrs:{"asWidget":true}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wfyV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_account_account_forgotten_account_forgotten_vue__ = __webpack_require__("8TeC");


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    accountForgotten: __WEBPACK_IMPORTED_MODULE_0__components_account_account_forgotten_account_forgotten_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "wh8u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "whbd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-form-loader"},[(_vm.theme === 'details')?[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)]:_vm._e(),_vm._v(" "),(_vm.theme === 'withdraw')?[_c('div',{staticClass:"account-form-loader__alert"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__balance"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__input"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__line"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__button"})]:_vm._e(),_vm._v(" "),(_vm.theme === 'deposit')?[_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-form-loader__section"},[_c('div',{staticClass:"account-form-loader__section-title"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-row"},[_c('div',{staticClass:"account-form-loader__section-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-row"},[_c('div',{staticClass:"account-form-loader__section-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-row"},[_c('div',{staticClass:"account-form-loader__section-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-col-2"})]),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-row"},[_c('div',{staticClass:"account-form-loader__section-col-1"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-col-2"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-form-loader__section"},[_c('div',{staticClass:"account-form-loader__section-title"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-button"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-form-loader__section"},[_c('div',{staticClass:"account-form-loader__section-title"}),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-button"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-button"}),_vm._v(" "),_c('div',{staticClass:"account-form-loader__section-button"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-x"},[_c('div',{staticClass:"small-12 medium-4 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-12 medium-8 column"},[_c('div',{staticClass:"row-x"},[_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"account-form-loader__block"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"account-form-loader__block"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-x"},[_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-4 column"},[_c('div',{staticClass:"account-form-loader__block"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-6 column"},[_c('div',{staticClass:"account-form-loader__block"})]),_vm._v(" "),_c('div',{staticClass:"small-6 column"},[_c('div',{staticClass:"account-form-loader__block"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-x"},[_c('div',{staticClass:"small-12 column"},[_c('div',{staticClass:"account-form-loader__block"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wlxR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[(_vm.showMap)?_c('div',{staticClass:"row row-x"},[_c('election-map'),_vm._v(" "),_c('div',{staticClass:"column small-12 home-old__how-it-works-alt"},[_c('how-it-works')],1)],1):_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"row row-x home-old__three-elements-row"},[_c('div',{staticClass:"column small-12 large-8 home-old__element"},[_c('hero-unit-slider')],1),_vm._v(" "),_c('div',{staticClass:"column small-12 large-4 home-old__biggest-gains"},[(!_vm.isShutdownModeOn)?[(_vm.isLoggedIn)?_c('most-predicted-list',{attrs:{"isTopTrending":true,"num":2}}):_c('most-predicted-list',{attrs:{"num":2}})]:[_c('research-widget',{attrs:{"shutdown":true}},[_vm._v("\r\n              What's Next for PredictIt\r\n            ")])]],2)]),_vm._v(" "),_c('div',{staticClass:"column small-12 home-old__how-it-works"},[_c('how-it-works')],1)]),_vm._v(" "),_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12 large-6"},[_c('daily-markets',{staticClass:"home-old__daily"}),_vm._v(" "),(false)?_c('home-videos',{staticClass:"home-old__videos"}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"column small-12 large-6"},[_c('research-widget',[_vm._v("Empowering Research")]),_vm._v(" "),(false)?_c('podcasts',{staticClass:"home-old__podcasts"}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12 home-old__element"},[_c('in-the-news')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wv8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_help_and_support_js__ = __webpack_require__("X543");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72de0a10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_and_support_vue__ = __webpack_require__("YYzZ");
function injectStyle (ssrContext) {
  __webpack_require__("N5+X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_help_and_support_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72de0a10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_and_support_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x+uv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_select_js__ = __webpack_require__("x3ff");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_518bffad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_vue__ = __webpack_require__("Gik0");
function injectStyle (ssrContext) {
  __webpack_require__("ldne")
  __webpack_require__("O1+7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_select_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_518bffad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x0s9":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "x3ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__multiselect_vue__ = __webpack_require__("Q334");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    multiselect: __WEBPACK_IMPORTED_MODULE_1__multiselect_vue__["a" /* default */]
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    required: Boolean,
    placeholder: String,
    label: {
      type: String,
      required: true
    },
    trackBy: {
      type: String,
      required: true
    },
    value: [String, Object],
    small: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Number,
      default: 200
    },
    customLabel: {
      type: Function
    },
    searchable: {
      type: Boolean,
      default: true
    },
    showNoResults: {
      type: Boolean,
      default: false
    },
    tabindex: Number,
    gtm: {
      type: String,
      default: ''
    },
    adjust: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    selectModifiers: function selectModifiers() {
      return {
        'select--has-value': this.value,
        'select--small': this.small
      };
    },
    gtmObject: function gtmObject() {
      var _gtm$split = this.gtm.split(','),
          _gtm$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_gtm$split, 2),
          category = _gtm$split2[0],
          label = _gtm$split2[1];

      return {
        event: 'eventTrackerTrigger',
        category: category,
        action: 'select',
        label: label
      };
    }
  },
  methods: {
    updateValue: function updateValue(e) {
      this.$emit('input', e);
      if (this.gtm && this.value) {
        this.$gtm.trackEvent(this.gtmObject);
      }
    }
  }
});

/***/ }),

/***/ "x4Jj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-set-password"},[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{staticClass:"account-set-password form  content-header__section-group",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.newPassword,"name":"newPassword","type":"password","validator":"password","required":true,"autocomplete":"new-password","placeholder":"Password"},on:{"input":_vm.$v.fields.newPassword.$touch},model:{value:(_vm.fields.newPassword),callback:function ($$v) {_vm.$set(_vm.fields, "newPassword", $$v)},expression:"fields.newPassword"}})],1),_vm._v(" "),_c('div',{staticClass:"small-12 column"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"validation":_vm.$v.fields.newPasswordConfirmation,"name":"newPasswordConfirmation","type":"password","validator":"password","required":true,"autocomplete":"new-password","placeholder":"Confirm Password"},on:{"input":_vm.$v.fields.newPasswordConfirmation.$touch},model:{value:(_vm.fields.newPasswordConfirmation),callback:function ($$v) {_vm.$set(_vm.fields, "newPasswordConfirmation", $$v)},expression:"fields.newPasswordConfirmation"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('password-requirements',{attrs:{"validation":_vm.$v.fields.newPassword}})],1)]),_vm._v(" "),_c('div',{staticClass:"account-set-password__buttons"},[_c('form-submit',{attrs:{"disabled":_vm.invalidOrDisabled,"label":"Save Password"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x8VV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJ4c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_news_feed_js__ = __webpack_require__("smaH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfe036f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_feed_vue__ = __webpack_require__("HBSA");
function injectStyle (ssrContext) {
  __webpack_require__("bY65")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_news_feed_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfe036f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_feed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xKzW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboards-info"},[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader"},_vm._l((_vm.loaderItems(2)),function(item){return _c('div',{staticClass:"content-loader-item"},[_c('leaderboards-info-loader')],1)}),0):[(!_vm.showLeaderboards)?_c('div',{staticClass:"leaderboards-info__message"},[_vm._v("\n      Go to "),_c('router-link',{staticClass:"leaderboards-info__link",attrs:{"to":{ name: 'account-settings'}}},[_vm._v("Settings")]),_vm._v(" to opt to have your rank shown on the Leaderboards.\n    ")],1):[_vm._l((_vm.items),function(item){return _c('div',{key:item.leaderBoardId,class:_vm.sectionClassModifiers(item),on:{"click":function($event){return _vm.onSectionClick(item)}}},[_c('div',{staticClass:"leaderboards-info-section-title"},[_vm._v("\n          "+_vm._s(_vm._f("pluralize")(item.leaderBoardName))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"leaderboards-info-section-position"},[(item.predefined)?_c('div',{staticClass:"leaderboards-info__number leaderboards-info__number--no-margin"},[_vm._v("\n            Not Ranked\n          ")]):_c('div',{staticClass:"leaderboards-info__number"},[_vm._v("\n            "+_vm._s(item.leaderBoardPosition)+"\n            "),_c('div',{staticClass:"leaderboards-info__number-suffix"},[_vm._v("\n              "+_vm._s(_vm.getOrdinalSuffix(item.leaderBoardPosition))+"\n            ")])])])])}),_vm._v(" "),_c('div',{staticClass:"leaderboards-info__note"},[_vm._v("\n        Leaderboards are updated nightly.\n      ")])]]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xLZ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"announcement"},[_c('div',{staticClass:"announcement__icon"}),_vm._v(" "),_c('div',{staticClass:"announcement__title",domProps:{"innerHTML":_vm._s(_vm.announcement.title)}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"announcement__content",domProps:{"innerHTML":_vm._s(_vm.announcement.body)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xMYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_currency_input_js__ = __webpack_require__("MGrt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f2365a7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_currency_input_vue__ = __webpack_require__("wOlf");
function injectStyle (ssrContext) {
  __webpack_require__("mbbC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_currency_input_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f2365a7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_currency_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xO2F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // because if content loaded vie v-html that has links
    // router will not kick in, and app state is lost and app reloads
    catchHtmlClick: function catchHtmlClick(e) {
      var href = e.srcElement.href;
      if (href.indexOf(window.location.origin) === 0) {
        e.preventDefault();
        var path = href.substr(window.location.origin.length);
        this.$router.push({ path: path });
      }
    }
  }
});

/***/ }),

/***/ "xPvc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trends"},[_c('div',{staticClass:"row row-x"},[(!_vm.isUserRestricted)?_c('div',{staticClass:"row row-x trends__three-elements-row"},[_c('div',{staticClass:"column small-12 large-8 trends__element"},[_c('hero-unit-slider')],1),_vm._v(" "),_c('div',{staticClass:"column small-12 large-4 trends__biggest-gains"},[_c('most-predicted-list',{attrs:{"isNewArrival":true,"num":2}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"trends__markets"},[_c('div',{staticClass:"row row-x"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-12 large-4 large-push-8"},[_c('market-biggest-gains',{attrs:{"extended":_vm.shouldShowKeyStatsWidgets}}),_vm._v(" "),(!_vm.shouldShowKeyStatsWidgets)?[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader content-loader-market-widget"},[_c('market-widget-loader',{attrs:{"theme":"comments"}})],1):[(_vm.widgets.comments && _vm.widgets.comments.widgetTopComments.length > 0)?_c('market-top-comments',{staticClass:"trends__widget-comments",attrs:{"widget":_vm.widgets.comments}}):_vm._e()]]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"column small-12 large-8 large-pull-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column small-12"},[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader content-loader-market-widget"},[_c('market-widget-loader',{attrs:{"theme":"currently"}})],1):[(_vm.widgets.currently)?_c('market-currently-predicting',{attrs:{"widget":_vm.widgets.currently}}):_vm._e()]],2),_vm._v(" "),_c('div',{staticClass:"column small-12 large-6 trends--left"},[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader content-loader-market-widget"},[_c('market-widget-loader',{attrs:{"theme":"money"}})],1):[(_vm.widgets.smart)?_c('market-money-widget',{attrs:{"widget":_vm.widgets.smart,"theme":"margin"}}):_vm._e()]],2),_vm._v(" "),_c('div',{staticClass:"column small-12 large-6 trends--right"},[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader content-loader-market-widget"},[_c('market-widget-loader',{attrs:{"theme":"money"}})],1):[(_vm.widgets.most)?_c('market-money-widget',{attrs:{"widget":_vm.widgets.most}}):_vm._e()]],2)])]),_vm._v(" "),(_vm.shouldShowKeyStatsWidgets)?_c('div',{staticClass:"column small-12 trends__markets--top-distance"},[_c('div',{staticClass:"row-x"},[_c('div',{staticClass:"column small-12 large-8"},[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader content-loader-market-widget"},[_c('market-widget-loader',{attrs:{"theme":"stats"}})],1):[_c('market-key-stats',{attrs:{"widget":_vm.widgets.key}})]],2),_vm._v(" "),_c('div',{staticClass:"column small-12 large-4"},[(!_vm.isComponentReady)?_c('div',{staticClass:"content-loader content-loader-market-widget"},[_c('market-widget-loader',{attrs:{"theme":"comments"}})],1):[(_vm.widgets.comments && _vm.widgets.comments.widgetTopComments.length > 0)?_c('market-top-comments',{attrs:{"widget":_vm.widgets.comments}}):_vm._e()]],2)])]):_vm._e()])]),_vm._v(" "),(_vm.disqusReady)?_c('div',{staticClass:"row row-x"},[_c('div',{staticClass:"column small-12 trends__element"},[_c('div',{staticClass:"trends__comments-title"},[_vm._v("\r\n        Comments\r\n      ")]),_vm._v(" "),_c('disqus',{attrs:{"showTitle":false,"disqusId":_vm.disqusId,"title":"","auth":_vm.disqusAuth,"url":_vm.disqusUrl}})],1)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"trends__desktop-header"},[_c('span',{staticClass:"trends__desktop-title"},[_vm._v("Latest Trends")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xTWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_userDetails__ = __webpack_require__("jtWA");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_socialLevel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_userDetails__["a" /* default */]],
  props: {
    comment: Object
  },
  methods: {
    traderLevelDisplay: function traderLevelDisplay(item) {
      var level = this.getLevelByPredictions(item.profitablePredictions);
      return 'Level ' + level.num + ' (' + level.text + ')';
    },
    ellipsizeTextBox: function ellipsizeTextBox(el) {
      var wordArray = el.innerHTML.split(' ');
      while (el.scrollHeight > el.offsetHeight) {
        wordArray.pop();
        el.innerHTML = wordArray.join(' ') + '...';
      }
    },
    onClick: function onClick() {
      if (this.comment && this.comment.commentUrl && !__WEBPACK_IMPORTED_MODULE_1__mixins_userAgent__["f" /* isStandalone */]) {
        window.location.href = this.comment.commentUrl;
      }
    }
  },
  mounted: function mounted() {
    // this.ellipsizeTextBox(this.$refs.text);
  }
});

/***/ }),

/***/ "xVgH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_disqus__ = __webpack_require__("oeb2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_cmsContent__ = __webpack_require__("tQfv");

/* eslint-disable no-restricted-syntax */





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_disqus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_loader__["a" /* default */]],
  props: {
    storyId: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      pageComponent: null
    };
  },
  metaInfo: function metaInfo() {
    if (this.currentStoryDetail !== null) {
      return {
        title: this.currentStoryDetail.seoTitle
      };
    }
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('browse', ['currentStoryDetail'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getStoryDetail', 'clearCurrentStoryDetail'])),
  mounted: function mounted() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getStoryDetail(this.storyId).then(function () {
      _this.loaderRemove(document.body);
      _this.installDynamicControls({
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.currentStoryDetail)
      });
    }).catch(function () {
      return _this.loaderRemove(document.body);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.clearCurrentStoryDetail();
  }
});

/***/ }),

/***/ "xbXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"captcha",staticClass:"captcha",style:(_vm.styleModifiers)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xqHz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_cmsContent__ = __webpack_require__("tQfv");









var toRoute = '';
var restore = true;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_cmsContent__["a" /* default */]],
  metaInfo: function metaInfo() {
    return {
      title: 'Terms and Conditions'
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  created: function created() {
    var _this = this;

    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* STATIC_PAGES */].TERMS).then(function (data) {
      _this.installDynamicControls({ data: data });
    });
  },
  mounted: function mounted() {
    var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["A" /* parseQuery */])(window.location.search);
    if (query && query.section) {
      setTimeout(function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_scrollTo__["a" /* default */])(document.getElementById(query.section), 0);
      }, 50);
    }
  },
  beforeDestroy: function beforeDestroy() {
    // firest after router loop
    if (restore) {
      __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].dispatch('popup/restorePopup', toRoute);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var popup = to.params.noPopup ? null : __WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_app_modals__["a" /* MODALS */].REGISTER;
    __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].dispatch('popup/rememberPopup', {
      route: from.name,
      popup: popup
    });
    next();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // fires before router loop closes popup
    restore = to.name !== 'privacy-policy';
    toRoute = to.name;
    next();
  }
});

/***/ }),

/***/ "xqpA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xrwi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-desktop-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"large-2 column account-desktop-header__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"large-8 column"},[_c('div',{staticClass:"account-desktop-header__tabs"},_vm._l((_vm.tabs),function(tab){return _c('div',{staticClass:"account-desktop-header__column"},[_c('button',{staticClass:"account-desktop-header__button",class:_vm.tabClass(tab),on:{"click":function($event){$event.preventDefault();return _vm.onChange(tab.name)}}},[_vm._v(_vm._s(tab.title))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"large-2 column text-center"},[(_vm.isExportAvailable)?_c('button',{staticClass:"account-desktop-header__button account-desktop-header__button--export",on:{"click":_vm.onExport}},[_vm._v("Export")]):[_vm._v(" ")]],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xth1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_tax_detail_js__ = __webpack_require__("nE9/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cde31bac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_tax_detail_vue__ = __webpack_require__("Wngs");
function injectStyle (ssrContext) {
  __webpack_require__("sAT+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_tax_detail_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cde31bac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_tax_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xxJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-search"},[(!_vm.isLoading && _vm.items.length === 0)?_c('div',{staticClass:"page-search__disclaimer"},[_vm._v("\n    No results found. Please try again.\n  ")]):_c('div',[_c('div',{staticClass:"page-search__header"},[_c('div',{staticClass:"page-search__header-text"},[_vm._v("\n        Search Results:\n        "),_c('span',{staticClass:"page-search__header-text--small"},[_vm._v("\n          "+_vm._s(_vm.searchQuery)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"page-search__header-text page-search__header-text--right"},[_vm._v("\n         "+_vm._s(_vm.searchResults.totalCount)+" Market"),(_vm.searchResults.totalCount !== 1)?_c('span',[_vm._v("s")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"page-search__grid"},[_vm._l((_vm.items),function(item){return _c('div',{staticClass:"page-search__grid-item"},[_c('market-list-item',{key:item.marketId,attrs:{"market":item}})],1)}),_vm._v(" "),(_vm.searchResults.canLoadMore)?_c('infinite-loading',{on:{"infinite":_vm.goInfinite}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('div',{staticClass:"page-search__spinner"})]),_vm._v(" "),_c('span',{attrs:{"slot":"no-results"},slot:"no-results"}),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})]):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xyij":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "y1jZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_in_the_news_js__ = __webpack_require__("6b0c");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37c1d6fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_in_the_news_vue__ = __webpack_require__("d4Jq");
function injectStyle (ssrContext) {
  __webpack_require__("eExV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_in_the_news_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37c1d6fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_in_the_news_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y5Vv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifier},[_c('div',{class:_vm.menuClassModifier},[_c('div',{staticClass:"market-filters-mobile__menu-order"},[_c('menu-button',{attrs:{"theme":_vm.orderButtonTheme,"type":_vm.selectedOrder.sort,"name":_vm.orderMenuName,"active":_vm.ordersOpen,"arrow":true},on:{"click":_vm.toggleOrder}})],1),_vm._v(" "),(_vm.shouldShowTimespanFilter)?_c('div',{staticClass:"market-filters-mobile__menu-timespans"},[_c('menu-button',{attrs:{"type":"timespan","name":_vm.selectedTimespan.name,"theme":_vm.timespansButtonTheme,"active":_vm.timespansOpen,"arrow":true},on:{"click":_vm.toggleTimespans}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"market-filters-mobile__menu-filters"},[_c('menu-button',{attrs:{"type":"filters","name":_vm.filterMenuName,"theme":_vm.filtersButtonTheme,"active":_vm.filtersOpen,"arrow":true},on:{"click":_vm.toggleFilters}})],1)]),_vm._v(" "),(_vm.ordersOpen)?_c('div',{staticClass:"market-filters-mobile__order"},_vm._l((_vm.orderList('markets')),function(order){return _c('menu-button',{key:order.sort,attrs:{"type":order.sort,"name":order.fullName,"selected":_vm.orderSelected(order.sort),"typeThemeEnabled":true},on:{"click":_vm.selectOrderAndClose}})}),1):_vm._e(),_vm._v(" "),(_vm.filtersOpen)?_c('div',{staticClass:"market-filters-mobile__filters"},[_c('a',{staticClass:"market-filters-mobile__clear-all",on:{"click":function($event){$event.preventDefault();return _vm.onClearFilters($event)}}},[_vm._v("Clear Selections")]),_vm._v(" "),_vm._l((_vm.filters),function(category){return _c('div',{staticClass:"market-filters-mobile__filters-group"},[_c('h3',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_vm._l((category.filters),function(filter){return _c('filter-button',{key:_vm.filterKey(filter),attrs:{"id":filter.filterId,"name":filter.name,"selected":_vm.filterSelected(filter.filterId)},on:{"addFilter":_vm.onAddFilter,"removeFilter":_vm.onRemoveFilter}})})],2)})],2):_vm._e(),_vm._v(" "),(_vm.timespansOpen)?_c('div',{staticClass:"market-filters-mobile__order"},_vm._l((_vm.availableTimespanOptions),function(timespan){return _c('menu-button',{key:timespan.parameter,attrs:{"type":timespan.parameter,"name":timespan.name},on:{"click":_vm.selectTimespanAndClose}})}),1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y852":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y8UT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__ = __webpack_require__("GOBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_accountVerify__ = __webpack_require__("yZQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_account_account_social_badge_account_social_badge_vue__ = __webpack_require__("gdGR");

/* eslint-disable no-unused-vars */







__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('en');
__WEBPACK_IMPORTED_MODULE_1_moment___default.a.updateLocale('en', {
  meridiem: function meridiem(hour, minute, isLowerCase) {
    return hour < 12 ? 'a.m.' : 'p.m.';
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_accountVerify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_socialLevel__["a" /* default */]],
  components: {
    accountSocialBadge: __WEBPACK_IMPORTED_MODULE_6__components_account_account_social_badge_account_social_badge_vue__["a" /* default */]
  },
  data: function data() {
    var route = this.$router.currentRoute.name;
    return {
      name: null,
      accountBalance: null,
      portfolioBalance: null,
      currency: null,
      links: [{ icon: 'wallet', name: 'Wallet', pathName: 'wallet', active: route === 'wallet' }, { icon: 'history', name: 'History', pathName: 'account-history', active: route === 'account-history' }, { icon: 'details', name: 'Account Details', pathName: 'account-details', active: route === 'account-details' }, { icon: 'settings', name: 'Settings', pathName: 'account-settings', active: route === 'account-settings' }, {
        icon: 'settings',
        name: 'Help And Support',
        pathName: 'HelpAndSupport',
        active: ['HelpAndSupport', 'WhatIsPredictIt', 'LearnTheBasics', 'ComunityForums', 'Faq', 'Videos'].includes(route)
      }]
    };
  },
  metaInfo: function metaInfo() {
    if (this.isLayoutMobile) {
      return {
        title: 'Account'
      };
    }
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('wallet', ['balance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['hasMaintenanceMessage', 'isLayoutMobile']), {
    cash: function cash() {
      return (Math.floor(this.balance.accountBalanceDecimal * 100) / 100).toFixed(2);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['logout']), {
    profileButtonClass: function profileButtonClass(link) {
      return {
        profile__button: true,
        'profile__button--active': link.active
      };
    },
    logoutButton: function logoutButton() {
      this.loaderAdd(document.body);
      this.logout();
      this.$gtm.trackEvent({ event: 'Logout' });
    },
    isLinkAvailable: function isLinkAvailable(link) {
      if (link.pathName === 'wallet') {
        // return this.isUserVerified && !this.hasMaintenanceMessage;
        return this.isWalletEnabled;
      }
      return true;
    }
  })
});

/***/ }),

/***/ "yG7b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-register"},[_c('form-errors',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row-xy"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.email,"disabled":_vm.isFormDisabled,"name":"username","type":"email","required":true,"validator":"email","autocomplete":"off","gtm":"Registration,Email","placeholder":"Email"},on:{"input":_vm.$v.fields.email.$touch},model:{value:(_vm.fields.email),callback:function ($$v) {_vm.$set(_vm.fields, "email", $$v)},expression:"fields.email"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.emailConfirmation,"disabled":_vm.isFormDisabled,"name":"emailConfirmation","type":"email","required":true,"validator":"equalTo","equalTo":_vm.fields.email,"autocomplete":"off","gtm":"Registration,Email Confirmation","placeholder":"Confirm Email"},on:{"input":_vm.$v.fields.emailConfirmation.$touch},model:{value:(_vm.fields.emailConfirmation),callback:function ($$v) {_vm.$set(_vm.fields, "emailConfirmation", $$v)},expression:"fields.emailConfirmation"}})],1),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"account-register__username-wraper"},[_c('form-input',{attrs:{"disabled":_vm.isFormDisabled,"name":"nickname","type":"text","required":true,"validation":_vm.$v.fields.username,"autocomplete":"off","placeholder":"Username","gtm":"Registration,Username"},on:{"input":_vm.$v.fields.username.$touch},model:{value:(_vm.fields.username),callback:function ($$v) {_vm.$set(_vm.fields, "username", $$v)},expression:"fields.username"}})],1)]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('p',{staticClass:"account-register__disclaimer"},[_vm._v("\r\n          By clicking \"Create Account\",\r\n          you confirm that you are at least 18 years of age and have read the "),_c('router-link',{attrs:{"to":{ name: 'terms-and-conditions' }}},[_vm._v("Terms and Conditions")]),_vm._v(".\r\n        ")],1)]),_vm._v(" "),_c('div',{staticClass:"column small-12"},[_c('form-submit',{attrs:{"label":"Create Account","disabled":_vm.invalidOrDisabled}})],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column small-12"},[_c('h5',{staticClass:"form__title form__title--new"},[_vm._v("Register with your email")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yHvP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"balance-history"},[(!_vm.isComponentReady)?_c('table-rows-loader',{attrs:{"num":_vm.loaderNum}}):_vm._e(),_vm._v(" "),(_vm.isComponentReady)?_c('div',{staticClass:"balance-history__head"},[_c('div',{staticClass:"row"},[_c('div',{class:_vm.typeColumnModifiers},[_vm._v("\n        "+_vm._s(_vm.$txt('balance-history.type'))+"\n      ")]),_vm._v(" "),_c('div',{class:_vm.amountColumnModifiers},[_vm._v("\n        "+_vm._s(_vm.$txt('balance-history.amount'))+"\n      ")]),_vm._v(" "),(_vm.showAdditionalColumns)?[_c('div',{staticClass:"column small-2"},[_c('div',{staticClass:"balance-history__fee"},[_c('div',[_vm._v("\n              "+_vm._s(_vm.$txt('balance-history.fee'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"balance-history__fee-icon",on:{"click":_vm.onFeeInfoClick}})])]),_vm._v(" "),_c('div',{staticClass:"column small-2 text-center"},[_vm._v("\n          "+_vm._s(_vm.$txt('balance-history.net'))+"\n        ")])]:_vm._e(),_vm._v(" "),_c('div',{class:_vm.statusColumnModifiers},[_vm._v("\n        "+_vm._s(_vm.$txt('balance-history.status'))+"\n      ")])],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"balance-history__list"},[_vm._l((_vm.items),function(item){return _c('balance-history-item',{key:item.confirmationNumber + item.date,attrs:{"type":_vm.type,"item":item},on:{"itemCancelled":function($event){return _vm.$emit('itemCancelled')}}})}),_vm._v(" "),(_vm.canLoadMore)?_c('infinite-loading',{on:{"infinite":_vm.goInfinite}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('div',{staticClass:"balance-history__spinner"})]),_vm._v(" "),_c('span',{attrs:{"slot":"no-results"},slot:"no-results"}),_vm._v(" "),_c('span',{attrs:{"slot":"no-more"},slot:"no-more"})]):_vm._e(),_vm._v(" "),(!_vm.canLoadMore)?_c('div',{staticClass:"balance-history__loaded-info"},[_vm._v("\n      "+_vm._s(_vm.loadedInfo)+"\n    ")]):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yLPo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coinbase-withdraw"},[(!_vm.isComponentReady)?_c('account-form-loader',{attrs:{"theme":"withdraw"}}):[(!_vm.showConfirmation)?_c('div',[(_vm.documentUploadInfoVisible)?_c('account-upload-document',{attrs:{"source":_vm.documentUploadSource,"isPending":_vm.documentUploadInfoPending}}):[(!_vm.hasErrorMessage)?[_c('alert-box',{attrs:{"level":"warning"}},[_vm._v("\n          Withdrawing funds may cause some or all of your open offers to be cancelled.\n        ")]),_vm._v(" "),_c('form',{staticClass:"form ach__form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('available-balance',{attrs:{"restricted":_vm.restrictedFunds,"balance":_vm.availableBalance}}),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-input',{attrs:{"validation":_vm.$v.fields.amount,"theme":"amount","name":"amount","disabled":_vm.isAmountFieldDisabled,"autocomplete":"","placeholder":"Withdrawal Amount (Minimum $1 USD)"},on:{"input":_vm.$v.fields.amount.$touch},model:{value:(_vm.fields.amount),callback:function ($$v) {_vm.$set(_vm.fields, "amount", $$v)},expression:"fields.amount"}})],1)]),_vm._v(" "),_c('h4',{staticClass:"coinbase-withdraw__section-title"},[_vm._v("\n            Email\n          ")]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('div',{staticClass:"coinbase-withdraw__address"},[_vm._v("\n                "+_vm._s(_vm.withdrawCoinbase.email)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"row-xy"},[_c('div',{staticClass:"column small-12"},[_c('form-submit',{attrs:{"disabled":_vm.invalidOrDisabled,"label":"Review Request"}})],1)])],1)]:_vm._e(),_vm._v(" "),(_vm.hasErrorMessage)?_c('alert-box',{attrs:{"level":"warning"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]):_vm._e(),_vm._v(" "),(!_vm.hasErrorMessage)?[_c('div',{staticClass:"coinbase-withdraw__disclaimer",domProps:{"innerHTML":_vm._s(_vm.withdrawCoinbase.disclaimer)}})]:_vm._e()]],2):_vm._e(),_vm._v(" "),(_vm.showConfirmation)?_c('withdraw-confirm',{staticClass:"withdraw-confirm--with-margin",attrs:{"kind":"coinbase-withdraw","amendAvailable":true,"amount":Number(_vm.fields.amount),"fee":Number(_vm.fields.amount) * Number(_vm.withdrawCoinbase.feePercent),"recipient":_vm.withdrawCoinbase.email},on:{"edit":_vm.onEdit,"success":_vm.onSuccess}}):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yMNL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yNb/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ySht":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq-search-input",class:_vm.hasValueModifier},[_c('label',{staticClass:"faq-search-input__label",attrs:{"for":_vm.name},on:{"click":_vm.focusInput}},[_vm._v(_vm._s(_vm.placeholder))]),_vm._v(" "),_c('input',{ref:"input",staticClass:"faq-search-input__input",attrs:{"type":"text","name":_vm.name},domProps:{"value":_vm.value},on:{"input":_vm.updateSearch}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yZQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__ = __webpack_require__("E3zi");




var STATUS_PENDING = 2;

var accountVerifyMixin = {
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['isLoggedIn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('user', ['userData', 'status']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('wallet', ['balance']), {
    accountLink: function accountLink() {
      if (this.isLayoutMobile) return '/account';
      if (this.isWalletEnabled) return '/account/wallet';
      return '/account/details';
    },
    hasUserClassicEnabled: function hasUserClassicEnabled() {
      return !this.isLoggedIn || this.isLoggedIn && this.status.isClassicEnabled !== false;
    },
    isUserVerified: function isUserVerified() {
      var idVerified = this.userData.idVerified;
      var verificationStatus = this.userData.verificationStatus;
      if (!this.isLoggedIn) return true;
      return typeof idVerified !== 'undefined' ? idVerified || verificationStatus === STATUS_PENDING : true;
    },
    isUserVerifiedFully: function isUserVerifiedFully() {
      var idVerified = this.userData.idVerified;
      var verificationStatus = this.userData.verificationStatus;
      if (!this.isLoggedIn) return true;
      return typeof idVerified !== 'undefined' ? idVerified && verificationStatus !== STATUS_PENDING : true;
    },
    isWalletEnabled: function isWalletEnabled() {
      var idVerified = this.userData.idVerified;
      if (!this.isLoggedIn) return true;
      return typeof idVerified !== 'undefined' ? idVerified : true;
    },
    isUserBalanceEmpty: function isUserBalanceEmpty() {
      return this.balance && this.balance.accountBalanceDecimal === 0;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('popup', ['setCurrentPopup']), {
    checkDataIfUserIsVerified: function checkDataIfUserIsVerified(data) {
      if (!this.isLoggedIn) return true;
      return data && (data.idVerified === true || data.verificationStatus === STATUS_PENDING);
    },
    showAccountVerifyPopup: function showAccountVerifyPopup() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].ACCOUNT_VERIFY);
    },
    showAddFundsPopup: function showAddFundsPopup() {
      this.setCurrentPopup(__WEBPACK_IMPORTED_MODULE_2__components_app_app_modals_app_modals__["a" /* MODALS */].ADD_FUNDS);
    }
  })
};

/* harmony default export */ __webpack_exports__["a"] = (accountVerifyMixin);

/***/ }),

/***/ "yaVC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ybwC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yeq6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_badges_list_js__ = __webpack_require__("LWRS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a27a5f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_badges_list_vue__ = __webpack_require__("iPAm");
function injectStyle (ssrContext) {
  __webpack_require__("L/Rx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_account_badges_list_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a27a5f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_badges_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yf1d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ygM9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

/* eslint-disable no-useless-escape */


function isValidUrl(input) {
  var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
  return regex.test(input);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      imageLoadError: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), {
    showSubtitle: function showSubtitle() {
      return this.data && this.data.origin && this.data.origin.title;
    },
    shouldShowImage: function shouldShowImage() {
      return !this.imageLoadError;
    },
    containerModifier: function containerModifier() {
      return {
        'news-feed-item--no-image': this.imageLoadError
      };
    },
    contentModifier: function contentModifier() {
      return {
        'small-8': !this.imageLoadError,
        'small-12': this.imageLoadError
      };
    },
    url: function url() {
      return this.data.originId;
    },
    target: function target() {
      return isValidUrl(this.url) && this.isLayoutDesktop ? '_blank' : '_self';
    }
  }),
  methods: {
    getItemImage: function getItemImage(item) {
      if (item.visual && item.visual.url) {
        return item.visual.url;
      }

      this.imageLoadError = true;
      return null;
    },
    onImageLoadError: function onImageLoadError() {
      this.imageLoadError = true;
    }
  }
});

/***/ }),

/***/ "yh8I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yhSh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_toolbar_js__ = __webpack_require__("RJiU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_243e1196_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_toolbar_vue__ = __webpack_require__("zG2V");
function injectStyle (ssrContext) {
  __webpack_require__("BUtN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_election_map_toolbar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_243e1196_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_election_map_toolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ys9T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");





var externalLinksMixin = {
  data: function data() {
    return {
      links: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('user', ['getExternalLogins']), {
    registrationTrack: function registrationTrack(label) {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'submit',
        label: label
      });
    },
    twitterLinkClick: function twitterLinkClick() {
      this.registrationTrack('Twitter');
      window.location = this.twitterLink;
    },
    facebookLinkClick: function facebookLinkClick() {
      this.registrationTrack('Facebook');
      window.location = this.facebookLink;
    }
  }),
  computed: {
    twitterLink: function twitterLink() {
      var data = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(this.links, function (l) {
        return l.name === 'Twitter';
      });
      return data ? '' + "" + data.url : null;
    },
    facebookLink: function facebookLink() {
      var data = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(this.links, function (l) {
        return l.name === 'Facebook';
      });
      return data ? '' + "" + data.url : null;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (externalLinksMixin);

/***/ }),

/***/ "yui2":
/***/ (function(module, exports) {

module.exports = {"test":"test"}

/***/ }),

/***/ "ywdO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yy50":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yyG2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z++8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_contentLoader__ = __webpack_require__("P71F");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_contentLoader__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutDesktop']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('leaderboards', ['selectedLeaderboard']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('leaderboards', ['leaderboards', 'selectedLeaderboardId'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('leaderboards', ['setSelectedLeaderboardId', 'getLeaderboards']), {
    itemClassModifiers: function itemClassModifiers(item) {
      return {
        'leaderboards-levels__item': true,
        'leaderboards-levels__item--active': item.leaderBoardId === this.selectedLeaderboardId
      };
    },
    onItemClick: function onItemClick(item) {
      if (item.leaderBoardId !== this.selectedLeaderboardId) {
        this.setSelectedLeaderboardId(item.leaderBoardId);
      }
    }
  }),
  created: function created() {
    var _this = this;

    this.getLeaderboards().then(function (data) {
      _this.isComponentReady = true;
      var shouldSetFirstLeaderboardAsDefault = !_this.selectedLeaderboardId && (data || []).length > 0 && _this.isLayoutDesktop;

      if (shouldSetFirstLeaderboardAsDefault) {
        _this.setSelectedLeaderboardId(data[0].leaderBoardId);
      }
    });
  }
});

/***/ }),

/***/ "z/nA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_privacy_statement_js__ = __webpack_require__("nHn7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_386b8031_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_privacy_statement_vue__ = __webpack_require__("XXB4");
function injectStyle (ssrContext) {
  __webpack_require__("kafY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_privacy_statement_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_386b8031_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_privacy_statement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z52E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z5zI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z6fO":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MiIgaGVpZ2h0PSI4MiIgdmlld0JveD0iMCAwIDgyIDgyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8cGF0aCBzdHJva2U9IiNkOTUzNGYiIGQ9Ik0xIDQxYzAgMjIuMDkgMTcuOTA1IDQwIDQwIDQwIDIyLjA5IDAgNDAtMTcuOTEgNDAtNDBTNjMuMDkgMSA0MSAxQzE4LjkwNSAxIDEgMTguOTEgMSA0MXoiLz4NCiAgICAgICAgPHBhdGggZmlsbD0iI2Q5NTM0ZiIgZD0iTTQ3LjU0MyA1NC41MjhsLTYuNTMtNi41MjYtNi41NTYgNi41NDZhNC45NSA0Ljk1IDAgMCAxLTcuMDA0IDAgNC45NDIgNC45NDIgMCAwIDEgMC03bDYuNTUtNi41NS02LjU1LTYuNTQ2YTQuOTQyIDQuOTQyIDAgMCAxIDAtNyA0Ljk1IDQuOTUgMCAwIDEgNy4wMDQgMGw2LjU1NSA2LjU0NiA2LjUzLTYuNTI2YTQuOTUxIDQuOTUxIDAgMSAxIDcuMDA0IDdsLTYuNTI5IDYuNTMgNi41MyA2LjUyNmE0Ljk0MiA0Ljk0MiAwIDAgMSAwIDcgNC45NiA0Ljk2IDAgMCAxLTcuMDA0IDB6Ii8+DQogICAgPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "zAJv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__ = __webpack_require__("63Fj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* eslint-disable */



var STATUS_PENDING = 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  checkIfCanRunAfterVerification: function checkIfCanRunAfterVerification() {
    var lastInstantCredit = __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__["a" /* default */].get('lastInstantCredit', null);
    var instantCredit = __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__["a" /* default */].get('instant_credit', null);
    if (instantCredit && lastInstantCredit === instantCredit) {
      return false;
    }

    return instantCredit !== null;
  },
  checkIfCanRunAfterLogin: function checkIfCanRunAfterLogin() {
    var checkIfCanRunAfterVerification = this.checkIfCanRunAfterVerification();
    var userData = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.user.userData;
    var verificationStatus = userData.verificationStatus;
    var idVerified = userData.idVerified;
    var isUserVerified = typeof idVerified !== 'undefined' ? idVerified || verificationStatus === STATUS_PENDING : true;
    return checkIfCanRunAfterVerification && isUserVerified;
  },
  run: function run() {
    var code = __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__["a" /* default */].get('instant_credit', null);

    return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('wallet/submitInstantCredit', code).then(function (data) {
      __WEBPACK_IMPORTED_MODULE_0__helpers_sessionStorage__["a" /* default */].set('lastInstantCredit', code);
      return data;
    });
  }
});

/***/ }),

/***/ "zG2V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"election-map-toolbar"},[_c('div',{staticClass:"election-map-toolbar__legend"},[_c('div',{staticClass:"election-map-toolbar__label",style:(_vm.democratLabelStyleModifiers)},[_vm._v("\r\n      Democratic "+_vm._s(_vm.democraticCounters.total + _vm.democraticCounters.predefinedReal)+"\r\n    ")]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__label",style:(_vm.republicanLabelStyleModifiers)},[_vm._v("\r\n      "+_vm._s(_vm.republicanCounters.total + _vm.republicanCounters.predefinedReal)+" Republican\r\n    ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar",style:(_vm.barStyleModifiers)},[_c('div',{staticClass:"election-map-toolbar__line"},[_c('div',{staticClass:"election-map-toolbar__line-content"},[_c('div',{staticClass:"election-map-toolbar__line-label election-map-toolbar__line-label--center"},[_vm._v("\r\n          "+_vm._s(_vm.majorityText)+"\r\n        ")])])]),_vm._v(" "),(_vm.isSenate)?_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--democratic-stripped",style:(_vm.democraticPredefinedBarSectionStyleModifiers),attrs:{"title":_vm.democraticCounters.predefinedReal}},[(_vm.showDemocraticPredefinedText)?_c('span',[_vm._v("\r\n        34 + 2 "),_c('div',{staticClass:"election-map-toolbar__bar-section-label election-map-toolbar__bar-section-label--right"},[_vm._v("No election")])]):_c('span',[_vm._v(" ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--democratic",style:(_vm.democraticHighBarSectionStyleModifiers),attrs:{"title":_vm.democraticCounters.high}},[(_vm.showDemocraticHighText)?_c('span',[_vm._v("\r\n        "+_vm._s(_vm.democraticCounters.high)+"\r\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--democratic",style:(_vm.democraticMediumBarSectionStyleModifiers),attrs:{"title":_vm.democraticCounters.medium}},[(_vm.showDemocraticMediumText)?_c('span',[_vm._v("\r\n        "+_vm._s(_vm.democraticCounters.medium)+"\r\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--democratic",style:(_vm.democraticLowBarSectionStyleModifiers),attrs:{"title":_vm.democraticCounters.low}},[(_vm.showDemocraticLowText)?_c('span',[_vm._v("\r\n        "+_vm._s(_vm.democraticCounters.low)+"\r\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--republican",style:(_vm.republicanLowBarSectionStyleModifiers),attrs:{"title":_vm.republicanCounters.low}},[(_vm.showRepublicanLowText)?_c('span',[_vm._v("\r\n        "+_vm._s(_vm.republicanCounters.low)+"\r\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--republican",style:(_vm.republicanMediumBarSectionStyleModifiers),attrs:{"title":_vm.republicanCounters.medium}},[(_vm.showRepublicanMediumText)?_c('span',[_vm._v("\r\n        "+_vm._s(_vm.republicanCounters.medium)+"\r\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--republican",style:(_vm.republicanHighBarSectionStyleModifiers),attrs:{"title":_vm.republicanCounters.high}},[(_vm.showRepublicanHighText)?_c('span',[_vm._v("\r\n        "+_vm._s(_vm.republicanCounters.high)+"\r\n      ")]):_c('span',[_vm._v(" ")])]),_vm._v(" "),(_vm.isSenate)?_c('div',{staticClass:"election-map-toolbar__bar-section election-map-toolbar__bar-section--republican-stripped",style:(_vm.republicanPredefinedBarSectionStyleModifiers),attrs:{"title":_vm.republicanCounters.predefinedReal}},[(_vm.showRepublicanPredefinedText)?_c('span',[_c('div',{staticClass:"election-map-toolbar__bar-section-label election-map-toolbar__bar-section-label--left"},[_vm._v("No election")]),_vm._v(" "+_vm._s(_vm.republicanCounters.predefinedReal)+"\r\n      ")]):_c('span',[_vm._v(" ")])]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zJ+0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zJxP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zNKi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    errors: {
      type: Array,
      required: true
    }
  }
});

/***/ }),

/***/ "zREO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_generics_back_button_back_button_vue__ = __webpack_require__("9xGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_generics_close_button_close_button_vue__ = __webpack_require__("mjGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_marketHeader__ = __webpack_require__("rbjD");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_marketHeader__["a" /* default */]],
  components: {
    backButton: __WEBPACK_IMPORTED_MODULE_0__components_generics_back_button_back_button_vue__["a" /* default */],
    closeButton: __WEBPACK_IMPORTED_MODULE_1__components_generics_close_button_close_button_vue__["a" /* default */]
  },
  props: {
    backButton: {
      type: Boolean,
      default: false
    },
    closeButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classModifier: function classModifier() {
      return {
        'market-header-title__header': true,
        'market-header-title__header--left-padding': this.backButton,
        'market-header-title__header--right-padding': this.watchIconVisible || this.closeButton
      };
    }
  },
  methods: {
    onClick: function onClick() {},
    close: function close() {
      this.$emit('close');
    },
    back: function back() {
      this.$emit('back');
    }
  }
});

/***/ }),

/***/ "zV2+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_userAgent__ = __webpack_require__("GZXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nav_browse_nav_browse_vue__ = __webpack_require__("i8vA");






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_userAgent__["a" /* default */]],
  components: {
    navBrowse: __WEBPACK_IMPORTED_MODULE_4__nav_browse_nav_browse_vue__["a" /* default */]
  },
  props: {
    theme: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      rotationIndex: 1
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile']), {
    classModifiers: function classModifiers() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'app-secondary-nav': true
      }, 'app-secondary-nav--' + this.theme, this.theme);
    }
  }),
  methods: {
    handleOrientationChange: function handleOrientationChange() {
      var _this = this;

      setTimeout(function () {
        _this.rotationIndex += 1;
      }, 300);
    }
  },
  created: function created() {
    window.addEventListener('orientationchange', this.handleOrientationChange);
    if (this.isTablet || this.isIos) {
      this.handleOrientationChange();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('orientationchange', this.handleOrientationChange);
  }
});

/***/ }),

/***/ "zX9S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: 'faq-search-input'
    },
    placeholder: {
      type: String,
      default: 'Search FAQs'
    },
    initial: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      value: this.initial
    };
  },

  computed: {
    hasValueModifier: function hasValueModifier() {
      return this.value ? 'faq-search-input--has-value' : '';
    }
  },
  methods: {
    updateSearch: function updateSearch(e) {
      var value = e.target.value;
      this.value = value;
      this.$emit('search', value);
    },
    focusInput: function focusInput() {
      this.$refs.input.focus();
    }
  },
  mounted: function mounted() {
    if (this.initial) {
      this.$emit('init', this.initial);
    }
  }
});

/***/ }),

/***/ "zXob":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zc3X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-daily-markets-details",domProps:{"innerHTML":_vm._s(_vm.content)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zkja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_dashboard_markets_toggle_js__ = __webpack_require__("54E+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a9300c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_markets_toggle_vue__ = __webpack_require__("ue1S");
function injectStyle (ssrContext) {
  __webpack_require__("pTAt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_dashboard_markets_toggle_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a9300c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_markets_toggle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zoV9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-register"},[_c('div',{staticClass:"page-register__content"},[_c('div',{staticClass:"page-register__title"},[_vm._v("\n      "+_vm._s(_vm.$txt('page-register.title'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"page-register__content-wrap"},[_c('account-register',{attrs:{"mode":"page"}}),_vm._v(" "),_c('account-register-footer',{attrs:{"mode":"page"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zxL1":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "zxhS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zyut":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_offers_indicator_popup_js__ = __webpack_require__("VYq2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f226cba8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_offers_indicator_popup_vue__ = __webpack_require__("mGCv");
function injectStyle (ssrContext) {
  __webpack_require__("HX7c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_offers_indicator_popup_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f226cba8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_offers_indicator_popup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f129530003ed00215cd6.js